
// import React, {
//   useEffect,
//   useState,
//   useRef,
//   useMemo,
//   useCallback,
// } from "react";
// import { createPortal } from "react-dom";
// import { forwardRef, useImperativeHandle } from "react";
// import * as THREE from "three";
// import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
// import state from "./index.js";
// import { useSnapshot } from "valtio";
// import {
//   OrbitControls,
//   Decal,
//   Html,
//   TransformControls,
// } from "@react-three/drei";
// import Spinner from "react-bootstrap/Spinner";
// import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
// import clothingConfig from "./clothingConfig";
// import { CanvasTexture } from "three";
// import modelConfig1 from "./modelConfig1.js";
// import { GLTFExporter } from "three/examples/jsm/exporters/GLTFExporter";
// import { TextureLoader } from "three";
// import { useFrame } from "@react-three/fiber";
// import { fabric } from "fabric";
// import { MdArrowOutward } from "react-icons/md";
// import { useThree } from "@react-three/fiber";
// import { useDispatch, useSelector } from "react-redux";
// import { FaArrowRotateLeft } from "react-icons/fa6";
// import { useLocation } from "react-router-dom";

// const DEFAULT_MODEL_URL = "/asset/HalfpoloK5.glb";
// const LEGACY_MODEL_URL = "/LongTeeM1.glb";

// const ShirtModel = forwardRef(
//   (
//     { menuSlug, subcategorySlug, gltfRef, isEditingDraft, currentProduct },
//     ref
//   ) => {
//     console.log("svg <<<<<<<<<>>>>>>>>>>>>>>>>>>..... : ", state.svg);
//     const { glbId } = useSelector((state) => state.cart);
//     const { camera } = useThree();
//     const raycaster = useMemo(() => new THREE.Raycaster(), []);
//     const mouse = useMemo(() => new THREE.Vector2(), []);
//     // const { selectedPattern } = useSnapshot(state);
//     const [isLoading, setIsLoading] = useState(true);
//     const snap = useSnapshot(state);
//     const group = useRef();
//     const shirtRef = useRef();
//     const [bandMesh, setBandMesh] = useState(null);
//     const location = useLocation(); // Add this line
//     const [isMobile, setIsmobile] = useState(window.innerWidth < 667);
//     const [initialDecalRotation, setInitialDecalRotation] = useState(0);
//     console.log("state.newKey : ", state.newKey);
//     console.log("state.frontText : ", state.frontText);
//     console.log("settings.Colors : ", state.partColors);
//     console.log(
//       "state.gradientColors...................... : ",
//       state.gradientColors
//     );

//     const productData = currentProduct || state.currentProduct;

//     console.log("productData///////////////////////// : ",productData)
//     const { selectedPattern } = productData || {};

//     console.log("state.newKey : ", state.newKey);
//     console.log("currentProduct frontText : ", productData?.frontText);
//     console.log("currentProduct partColors : ", productData?.partColors);
//     console.log(
//       "currentProduct gradientColors : ",
//       productData?.gradientColors
//     );

//     const { viewSide } = productData || { viewSide: "front" };

// const previousModelUrlRef = useRef(null);

// // Add this effect to ShirtModel.jsx
// useEffect(() => {
//   // Reset model loading state when product changes
//   if (productData?.id && previousProductIdRef.current !== productData.id) {
//     console.log("Product ID changed, resetting model state");
    
//     // If the model name is the same but product is different (duplicate),
//     // we need to reload the model to get fresh textures
//     if (previousModelUrlRef.current === productData.modelName) {
//       console.log("Same model URL, different product - reloading");
//       loadModelForProduct();
//     }
    
//     previousProductIdRef.current = productData.id;
//   }
// }, [productData?.id, productData?.modelName]);

//   useEffect(() => {
//       if (group.current && productData?.id) {
//         console.log("Product changed, applying images...");
//         applyImagesToMaterials();
//       }
//     }, [productData?.id, productData?.imagesPattern]);
    
//     // Optimize applyImagesToMaterials with useCallback
//     const applyImagesToMaterials = useCallback(async () => {
//       if (!group.current || !productData?.imagesPattern) {
//         console.log("No group or no imagesPattern to apply");
//         return;
//       }
      
//       console.log("Applying images to materials...");
      
//       const imagesPattern = productData.imagesPattern || {};
//       const normalizedImages = Object.fromEntries(
//         Object.entries(imagesPattern).map(([key, val]) => [
//           key.toUpperCase(),
//           val,
//         ])
//       );
      
//       // Process each mesh in the model
//       group.current.traverse(async (child) => {
//         if (!child.isMesh || !child.material) return;
        
//         const materialName = child.material.name?.toUpperCase();
//         if (!materialName) return;
        
//         const materials = Array.isArray(child.material)
//           ? child.material
//           : [child.material];
        
//         for (const mat of materials) {
//           const imageData = normalizedImages[materialName];
          
//           // Dispose of existing texture
//           if (mat.map) {
//             mat.map.dispose();
//             mat.map = null;
//           }
          
//           if (imageData?.image) {
//             try {
//               const texture = await new THREE.TextureLoader().loadAsync(
//                 imageData.image
//               );
              
//               texture.colorSpace = THREE.SRGBColorSpace;
//               texture.flipY = false;
//               texture.wrapS = THREE.RepeatWrapping;
//               texture.wrapT = THREE.RepeatWrapping;
//               texture.center.set(0.5, 0.5);
              
//               // Set texture properties
//               const img = new Image();
//               img.crossOrigin = "anonymous";
              
//               img.onload = () => {
//                 const imageAspect = img.width / img.height;
//                 const shirtAspect = 2220 / 2553;
//                 const SCALE_FACTOR = 2;
                
//                 if (img.width >= 2220 && img.height >= 2553) {
//                   if (imageAspect > shirtAspect) {
//                     texture.repeat.set(
//                       (shirtAspect / imageAspect) * SCALE_FACTOR,
//                       1 * SCALE_FACTOR
//                     );
//                   } else {
//                     texture.repeat.set(
//                       1 * SCALE_FACTOR,
//                       (imageAspect / shirtAspect) * SCALE_FACTOR
//                     );
//                   }
//                 } else if (img.width >= 1000 && img.height >= 1000) {
//                   texture.repeat.set(
//                     (2220 / img.width) * 0.8 * SCALE_FACTOR,
//                     (2553 / img.height) * 0.8 * SCALE_FACTOR
//                   );
//                 } else {
//                   const scaleX = Math.max(1, 2220 / img.width);
//                   const scaleY = Math.max(1, 2553 / img.height);
//                   texture.repeat.set(scaleX * SCALE_FACTOR, scaleY * SCALE_FACTOR);
//                 }
                
//                 texture.needsUpdate = true;
//               };
              
//               img.src = imageData.image;
              
//               mat.map = texture;
//               mat.color.set(0xffffff);
//               mat.needsUpdate = true;
              
//               console.log(`Applied texture to ${materialName}`);
//             } catch (err) {
//               console.error(`Failed to load image for ${materialName}:`, err);
//             }
//           } else {
//             // No image - use default color
//             mat.map = null;
//             mat.color.set("#112F51");
//             mat.needsUpdate = true;
//           }
//         }
//       });
//     }, [productData?.imagesPattern,productData?.id,]);
    
//     // Add a debug effect to log when product changes
//     useEffect(() => {
//       console.log("Product data updated:", {
//         id: productData?.id,
//         imagesPattern: productData?.imagesPattern,
//         hasImages: !!productData?.imagesPattern && Object.keys(productData.imagesPattern).length > 0
//       });
//     }, [productData,productData?.id,]);

//     useEffect(() => {
//       const handleResize = () => {
//         setIsmobile(window.innerWidth < 667);
//       };

//       window.addEventListener("resize", handleResize);
//       return () => window.removeEventListener("resize", handleResize);
//     }, []);
//     function resetState() {
//       state.updateTrigger++;
//       state.intro = false;
//       state.color = "#EFBD48";

//       // Reset current product data
//       const currentProductId = state.currentProductId;
//       if (state.products[currentProductId]) {
//         state.products[currentProductId] = {
//           ...state.products[currentProductId],
//           frontText: "",
//           backText: "",
//           frontNumber: "",
//           backNumber: "",
//           frontLogo: null,
//           backLogo: null,
//           imagesPattern: {},
//           viewSide: "front",
//           patternColors: {},
//           selectedPattern: {},
//           selectedFonts: "Arial",
//           textFonts: { front: "Arial", back: "Arial" },
//           numberFonts: { front: "Arial", back: "Arial" },
//           textColors: { front: "#ffffff", back: "#ffffff" },
//           numberColors: { front: "#ffffff", back: "#ffffff" },
//           partColors: {},
//           gradientColors: {},
//         };
//       }
//     }
//     // Replace your current useEffect with:
//     // Replace your current useEffect with:
//     useEffect(() => {
//       const hasDraftData =
//         location.state?.draftData || location.state?.restoreData;

//       if (!hasDraftData) {
//         console.log("No draft data found, resetting state...");
//         resetState();
//       } else {
//         console.log("Draft data found, skipping state reset...");
//         state.updateTrigger++; // Still trigger a re-render
//       }
//     }, [location.state]);

//     // In ShirtModel.jsx, add this effect to apply colors when product changes
//     useEffect(() => {
//       if (!group.current || !productData?.partColors) return;

//       console.log("Applying colors for product:", productData.id);
//       console.log("Colors to apply:", productData.partColors);

//       group.current.traverse((child) => {
//         if (child.isMesh && child.material) {
//           const partName = child.material.name?.toUpperCase();

//           if (partName && productData.partColors[partName]) {
//             const color = productData.partColors[partName];
//             const materials = Array.isArray(child.material)
//               ? child.material
//               : [child.material];

//             materials.forEach((mat) => {
//               if (mat.name === partName) {
//                 console.log(`Setting color ${color} for ${partName}`);
//                 mat.color.set(color);
//                 mat.needsUpdate = true;
//               }
//             });
//           }
//         }
//       });
//     }, [productData?.id, productData?.partColors]);

//     useEffect(() => {
//       // When product changes, update the model
//       if (productData && group.current) {
//         applyProductColorsToModel();
//       }
//     }, [productData?.id, productData?.partColors]);

//     const applyProductColorsToModel = () => {
//       if (!group.current || !productData?.partColors) return;

//       console.log("Applying colors for product:", productData.id);
//       console.log("Colors:", productData.partColors);

//       group.current.traverse((child) => {
//         if (child.isMesh && child.material) {
//           const partName = child.material.name?.toUpperCase();

//           if (partName && productData.partColors[partName]) {
//             const color = productData.partColors[partName];
//             const materials = Array.isArray(child.material)
//               ? child.material
//               : [child.material];

//             materials.forEach((mat) => {
//               if (mat.name === partName) {
//                 console.log(`Setting color ${color} for ${partName}`);
//                 mat.color.set(color);
//                 mat.needsUpdate = true;
//               }
//             });
//           }
//         }
//       });
//     };

//     const [gltf, setGltf] = useState(null);
//     const latestRequestRef = useRef(0);

//     const loadModel = useCallback(
//       (src) =>
//         new Promise((resolve, reject) => {
//           if (!src) {
//             reject(new Error("Model source is undefined"));
//             return;
//           }

//           const dracoLoader = new DRACOLoader();
//           dracoLoader.setDecoderPath(
//             "https://www.gstatic.com/draco/v1/decoders/"
//           );

//           const loader = new GLTFLoader();
//           loader.setDRACOLoader(dracoLoader);

//           loader.load(
//             src,
//             (model) => {
//               dracoLoader.dispose();
//               resolve(model);
//             },
//             undefined,
//             (error) => {
//               dracoLoader.dispose();
//               reject(error);
//             }
//           );
//         }),
//       []
//     );

//     console.log("gltf : ", gltf);

//     const getModelSettings = (menuSlug, subcategorySlug, selectedDesignId) => {
//       console.log("selectedDesignId <<<<<<<<<<<<<<>>>>>>>>>>>> ; ", glbId);
//       console.log("menuSlug .................. : ", menuSlug);
//       console.log(
//         "subcategorySlug ........................ : ",
//         subcategorySlug
//       );
//       const key = `${menuSlug}${subcategorySlug}`;
//       const newKey = key.replace(/-/g, "");
//       state.newKey = newKey;
//       console.log("newKey : ", newKey);

//       let modelConfig = modelConfig1[newKey];

//       if (newKey === "eventordereventjersey") {
//         const designKey = glbId || 900;
//         modelConfig = modelConfig1[newKey]?.[designKey];
//       }

//       return (
//         modelConfig || {
//           position: [0, 0, 0],
//           rotation: [0, 0, 0],
//           scale: 1,
//         }
//       );
//     };

//     useImperativeHandle(ref, () => ({
//       capturePng: () => {
//         if (!gltf) return null;

//         const scene = new THREE.Scene();
//         const camera = new THREE.PerspectiveCamera(35, 1, 0.1, 1000);
//         const renderer = new THREE.WebGLRenderer({
//           preserveDrawingBuffer: true,
//           alpha: true,
//         });
//         renderer.setSize(512, 512);
//         renderer.setClearColor(0x000000, 0);

//         const model = gltf.scene.clone();

//         model.scale.set(2.5, 2.5, 2.5);

//         const box = new THREE.Box3().setFromObject(model);
//         const center = box.getCenter(new THREE.Vector3());
//         model.position.x -= center.x;
//         model.position.y -= center.y;
//         model.position.z -= center.z;

//         scene.add(model);

//         const directionalLight = new THREE.DirectionalLight(0xffffff, 3.0);
//         directionalLight.position.set(3, 5, 5);
//         scene.add(directionalLight);

//         const ambientLight = new THREE.AmbientLight(0xffffff, 0.7);
//         scene.add(ambientLight);

//         const size = box.getSize(new THREE.Vector3());
//         const maxDim = Math.max(size.x, size.y, size.z);
//         const fov = camera.fov * (Math.PI / 180);
//         let cameraZ = Math.abs(maxDim / Math.sin(fov / 2)) * 0.6;

//         camera.position.set(0, 0.2, cameraZ);
//         camera.lookAt(new THREE.Vector3(0, 0.1, 0));
//         const backLight = new THREE.DirectionalLight(0xffffff, 1.5);
//         backLight.position.set(-5, -3, -5);
//         scene.add(backLight);

//         renderer.render(scene, camera);
//         const pngData = renderer.domElement.toDataURL("image/png");
//         return pngData;
//       },
//     }));

//     const {
//       partMappings,
//       overallScale,
//       position,
//       rotation,
//       scale,
//       fontSize,
//       designposition,
//       designrotation,
//       designscale,
//       patternScalling,
//       logoPosition,
//       logoRotation,
//       logoScale,
//       backNumberPosition,
//       backNumberRotation,
//       backNumberScale,
//       backLogoPosition,
//       backLogoRotation,
//       backLogoScale,
//       frontLogoPosition,
//       frontLogoRotation,
//       frontLogoScale,
//       frontTextPosition,
//       frontTextRotation,
//       frontTextScale,
//       backTextPosition,
//       backTextRotation,
//       backTextScale,
//       frontNumberPosition,
//       frontNumberRotation,
//       frontNumberScale,
//     } = getModelSettings(menuSlug, subcategorySlug);

//     const frontRotation = useMemo(() => {
//       return rotation;
//     }, [rotation]);

//     const backRotation = useMemo(() => {
//       const modelKey = state.newKey;
//       if (
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey"
//       ) {
//         return [rotation[0], rotation[1] + Math.PI, rotation[2]];
//       } else if (
//         modelKey === "menmenshorts" ||
//         modelKey === "menmencricketshorts" ||
//         modelKey === "menmencyclingshorts" ||
//         modelKey === "menmenrunningshorts" ||
//         modelKey === "menmenwovenshorts" ||
//         modelKey === "menmenknittedshorts" ||
//         modelKey === "menmenfootballshorts" ||
//         modelKey === "menmensoccershorts" ||
//         modelKey === "menmenbasketballshorts" ||
//         modelKey === "menmennftfootballshorts" ||
//         modelKey === "menmencyclingjersey" ||
//         modelKey === "menmenwinterjersey" ||
//         modelKey === "menmencitycollection" ||
//         modelKey === "menmencricketjersey" ||
//         modelKey === "menmentrackpants" ||
//         modelKey === "menmencompressionpants" ||
//         modelKey === "menmensinglet" ||
//         modelKey === "menmenarmsleeves" ||
//         modelKey === "menmenbasketballjersey" ||
//         modelKey === "womenwomenbadmintonshorts" ||
//         modelKey === "womenwomencyclingshorts" ||
//         modelKey === "womenwomencricketshorts" ||
//         modelKey === "womenwomenwovenshorts" ||
//         modelKey === "womenwomentightshorts" ||
//         modelKey === "womenwomenfootballshorts" ||
//         modelKey === "womenwomensoccershorts" ||
//         modelKey === "menmencompressionpants" ||
//         modelKey === "womenwomennftfootballshorts" ||
//         modelKey === "menmencompressionpants" ||
//         modelKey === "womenwomenbasketballshorts" ||
//         modelKey === "womenwomenknittedshorts" ||
//         modelKey === "womenwomencompressionpants" ||
//         modelKey === "womenwomencrickettrackpants" ||
//         modelKey === "womenwomentrackpants" ||
//         modelKey === "womenwomencricketjersey" ||
//         modelKey === "womenwomencyclingjersey" ||
//         modelKey === "womenwomenwinterjersey" ||
//         modelKey === "womenwomencitycollection" ||
//         modelKey === "kidskidsjersey" ||
//         modelKey === "kidskidscompressionpants" ||
//         modelKey === "kidskidsshorts" ||
//         modelKey === "kidskidscricketshorts" ||
//         modelKey === "kidskidscyclingshorts" ||
//         modelKey === "kidskidswintershorts" ||
//         modelKey === "kidskidsrunningshorts" ||
//         modelKey === "kidskidswovenshorts" ||
//         modelKey === "kidskidsknittedshorts" ||
//         modelKey === "kidskidsbasketballshorts" ||
//         modelKey === "kidskidssoccershorts" ||
//         modelKey === "kidskidsfootballshorts" ||
//         modelKey === "kidskidsnftfootballshorts" ||
//         modelKey === "kidskidstanktop" ||
//         modelKey === "kidskidscyclingjersey" ||
//         modelKey === "kidskidswinterjersey" ||
//         modelKey === "kidskidscitycollection" ||
//         modelKey === "kidskidscricketjersey" ||
//         modelKey === "kidskidstrackpants" ||
//         modelKey === "kidskidsprotshirt" ||
//         modelKey === "kidskidssinglet" ||
//         modelKey === "kidskidsarmsleeves" ||
//         modelKey === "kidskidsfootballjersey"||
//         modelKey === "kidskidssoccerjersey" 
//       ) {
//         return [rotation[0], rotation[1], rotation[2] + Math.PI];
//       } else {
//         return [rotation[0], rotation[1] + Math.PI, rotation[2]];
//       }
//     }, [rotation]);

//     const currentRotation = useMemo(() => {
//       return viewSide === "front" ? frontRotation : backRotation;
//     }, [viewSide, frontRotation, backRotation]);

//     const [animatedRotation, setAnimatedRotation] = useState(frontRotation);

//     useEffect(() => {
//       const targetRotation =
//         viewSide === "front" ? frontRotation : backRotation;

//       const timer = setTimeout(() => {
//         setAnimatedRotation(targetRotation);
//       }, 50);

//       return () => clearTimeout(timer);
//     }, [viewSide, frontRotation, backRotation]);

//     console.log("position <<<<<<<<<<<<<<>>>>>>>>>>>>>>: ", position);
//     console.log("rotation : ", rotation);
//     console.log("scale : ", scale);

//     const [modelSettings, setModelSettings] = useState(() =>
//       getModelSettings(menuSlug, subcategorySlug)
//     );

//     const [updateTrigger, setUpdateTrigger] = useState(0);

//     useEffect(() => {
//       setModelSettings(getModelSettings(menuSlug, subcategorySlug));
//     }, [snap.updateTrigger, menuSlug, subcategorySlug]);

//     useEffect(() => {
//       console.log("menu slug /////////// : ", menuSlug);
//       console.log("menu slug /////////// : ", subcategorySlug);
//       let isMounted = true;
//       latestRequestRef.current += 1;
//       const requestId = latestRequestRef.current;

//       // Determine which model to load
//       let modelKeyToLoad;

//       // Priority 1: Preserved model from navigation
//       if (location.state?.preserveModel && location.state?.currentModelKey) {
//         modelKeyToLoad = location.state.currentModelKey;
//         console.log(`🎯 Loading PRESERVED model: ${modelKeyToLoad}`);
//       }
//       // Priority 2: Current slugs
//       else if (menuSlug && subcategorySlug) {
//         modelKeyToLoad = `${menuSlug}${subcategorySlug}`.replace(/-/g, "");
//         console.log(`🎯 Loading from slugs: ${modelKeyToLoad}`);
//       }
//       // Priority 3: Previously stored model
//       else {
//         const storedModel = localStorage.getItem("current-3d-model");
//         modelKeyToLoad = storedModel || "menmenjersey";
//         console.log(`🎯 Loading STORED model: ${modelKeyToLoad}`);
//       }

//       // Update state with the actual key we're loading
//       state.newKey = modelKeyToLoad;

//       setIsLoading(true);

//       const loadModelForKey = async () => {
//         const modelConfig = modelConfig1[modelKeyToLoad];
//         let modelUrl;

//         if (modelConfig?.modelUrl) {
//           modelUrl = modelConfig.modelUrl;
//         } else {
//           // Fallback: use model name from state or default
//           modelUrl = snap.modelName || DEFAULT_MODEL_URL;
//         }

//         console.log(`📦 Loading model from: ${modelUrl}`);

//         try {
//           // Add cache busting
//           const cacheBustedUrl = `${modelUrl}?t=${Date.now()}`;
//           const model = await loadModel(cacheBustedUrl);

//           if (!isMounted || latestRequestRef.current !== requestId) return;

//           console.log(`✅ Model loaded: ${modelKeyToLoad}`);
//           setGltf(model);
//         } catch (error) {
//           console.error(`❌ Failed to load ${modelKeyToLoad}:`, error);

//           if (!isMounted || latestRequestRef.current !== requestId) return;

//           // Fallback to default
//           try {
//             console.log(`🔄 Falling back to default model`);
//             const defaultModel = await loadModel(DEFAULT_MODEL_URL);
//             if (isMounted && latestRequestRef.current === requestId) {
//               setGltf(defaultModel);
//               state.newKey = "menmenjersey";
//             }
//           } catch (fallbackError) {
//             console.error("❌ Fallback also failed:", fallbackError);
//             setGltf(null);
//           }
//         } finally {
//           if (isMounted && latestRequestRef.current === requestId) {
//             setIsLoading(false);
//           }
//         }
//       };

//       loadModelForKey();

//       return () => {
//         isMounted = false;
//       };
//     }, [snap.modelName, menuSlug, subcategorySlug, loadModel, location.state]);

//     useEffect(() => {
//       if (gltf && gltfRef) {
//         gltfRef.current = gltf;
//       }
//     }, [gltf]);

//     ////console.log("gltf?.scene : ", gltf?.scene);

//     useEffect(() => {
//       if (gltf?.scene && state.scene) {
//         state.scene = gltf.scene;
//       }

//       if (gltf?.scene) {
//         gltf.scene.traverse((child) => {
//           if (child.isGroup && ["TEE", "DESIGN"].includes(child.name)) {
//             setBandMesh((prev) => [
//               ...(Array.isArray(prev) ? prev : []),
//               ...child.children.filter((c) => c.isMesh),
//             ]);
//           }
//         });
//       }
//     }, [gltf, state.scene, menuSlug, subcategorySlug]);

//     // useEffect(() => {
//     //   updateTexture(snap.frontText, frontTextTexture, "front");
//     //   updateTexture(snap.backText, backTextTexture, "back");
//     //   updateTexture(snap.frontNumber, frontNumberTexture, "frontNumber");
//     //   updateTexture(snap.backNumber, backNumberTexture, "backNumber");
//     // }, [state.updateTrigger]);

//     useEffect(() => {
//       const modelKey = state.newKey;

//       if (modelKey === "eventordereventjersey" && glbId) {
//         console.log(" Updating positions for event order design:", glbId);

//         let modelConfig = modelConfig1[modelKey][glbId];

//         if (!modelConfig) {
//           console.warn(" No config found for design ID:", glbId);
//           return;
//         }

//         setDecalPositions({
//           frontText: modelConfig.frontTextPosition
//             ? [...modelConfig.frontTextPosition]
//             : [0, 0, 0],
//           frontNumber: modelConfig.frontNumberPosition
//             ? [...modelConfig.frontNumberPosition]
//             : [0, 0, 0],
//           frontLogo: modelConfig.frontLogoPosition
//             ? [...modelConfig.frontLogoPosition]
//             : [0, 0, 0],
//           backText: modelConfig.backTextPosition
//             ? [...modelConfig.backTextPosition]
//             : [0, 0, 0],
//           backNumber: modelConfig.backNumberPosition
//             ? [...modelConfig.backNumberPosition]
//             : [0, 0, 0],
//           backLogo: modelConfig.backLogoPosition
//             ? [...modelConfig.backLogoPosition]
//             : [0, 0, 0],
//         });

//         setDecalScales({
//           frontText: modelConfig.frontTextScale
//             ? [...modelConfig.frontTextScale]
//             : [1, 1, 1],
//           frontNumber: modelConfig.frontNumberScale
//             ? [...modelConfig.frontNumberScale]
//             : [1, 1, 1],
//           frontLogo: modelConfig.frontLogoScale
//             ? [...modelConfig.frontLogoScale]
//             : [1, 1, 1],
//           backText: modelConfig.backTextScale
//             ? [...modelConfig.backTextScale]
//             : [1, 1, 1],
//           backNumber: modelConfig.backNumberScale
//             ? [...modelConfig.backNumberScale]
//             : [1, 1, 1],
//           backLogo: modelConfig.backLogoScale
//             ? [...modelConfig.backLogoScale]
//             : [1, 1, 1],
//         });

//         if (modelConfig.fontSize) {
//           setFontSizetext(modelConfig.fontSize);
//         }
//         if (modelConfig.fontSizeNumber) {
//           setFontSizeNumber(modelConfig.fontSizeNumber);
//         }

//         if (modelConfig.frontTextPosition) {
//           frontTextPosition[0] = modelConfig.frontTextPosition[0];
//           frontTextPosition[1] = modelConfig.frontTextPosition[1];
//           frontTextPosition[2] = modelConfig.frontTextPosition[2];
//         }

//         if (modelConfig.frontNumberPosition) {
//           frontNumberPosition[0] = modelConfig.frontNumberPosition[0];
//           frontNumberPosition[1] = modelConfig.frontNumberPosition[1];
//           frontNumberPosition[2] = modelConfig.frontNumberPosition[2];
//         }

//         if (modelConfig.frontLogoPosition) {
//           frontLogoPosition[0] = modelConfig.frontLogoPosition[0];
//           frontLogoPosition[1] = modelConfig.frontLogoPosition[1];
//           frontLogoPosition[2] = modelConfig.frontLogoPosition[2];
//         }

//         if (modelConfig.backTextPosition) {
//           backTextPosition[0] = modelConfig.backTextPosition[0];
//           backTextPosition[1] = modelConfig.backTextPosition[1];
//           backTextPosition[2] = modelConfig.backTextPosition[2];
//         }

//         if (modelConfig.backNumberPosition) {
//           backNumberPosition[0] = modelConfig.backNumberPosition[0];
//           backNumberPosition[1] = modelConfig.backNumberPosition[1];
//           backNumberPosition[2] = modelConfig.backNumberPosition[2];
//         }

//         if (modelConfig.backLogoPosition) {
//           backLogoPosition[0] = modelConfig.backLogoPosition[0];
//           backLogoPosition[1] = modelConfig.backLogoPosition[1];
//           backLogoPosition[2] = modelConfig.backLogoPosition[2];
//         }

//         if (modelConfig.frontTextScale) {
//           frontTextScale[0] = modelConfig.frontTextScale[0];
//           frontTextScale[1] = modelConfig.frontTextScale[1];
//           frontTextScale[2] = modelConfig.frontTextScale[2];
//         }

//         if (modelConfig.frontNumberScale) {
//           frontNumberScale[0] = modelConfig.frontNumberScale[0];
//           frontNumberScale[1] = modelConfig.frontNumberScale[1];
//           frontNumberScale[2] = modelConfig.frontNumberScale[2];
//         }

//         if (modelConfig.frontLogoScale) {
//           frontLogoScale[0] = modelConfig.frontLogoScale[0];
//           frontLogoScale[1] = modelConfig.frontLogoScale[1];
//           frontLogoScale[2] = modelConfig.frontLogoScale[2];
//         }

//         if (modelConfig.backTextScale) {
//           backTextScale[0] = modelConfig.backTextScale[0];
//           backTextScale[1] = modelConfig.backTextScale[1];
//           backTextScale[2] = modelConfig.backTextScale[2];
//         }

//         if (modelConfig.backNumberScale) {
//           backNumberScale[0] = modelConfig.backNumberScale[0];
//           backNumberScale[1] = modelConfig.backNumberScale[1];
//           backNumberScale[2] = modelConfig.backNumberScale[2];
//         }

//         if (modelConfig.backLogoScale) {
//           backLogoScale[0] = modelConfig.backLogoScale[0];
//           backLogoScale[1] = modelConfig.backLogoScale[1];
//           backLogoScale[2] = modelConfig.backLogoScale[2];
//         }

//         console.log(
//           "Updated event order positions and scales for design:",
//           glbId
//         );
//       }
//     }, [glbId]);

//     const [parts, setLocalParts] = useState([]);
//     const [frontParts, setFrontParts] = useState([]);
//     const [backParts, setBackParts] = useState([]);
//     const [leftParts, setLeftParts] = useState([]);
//     const [rightParts, setRightParts] = useState([]);
//     const [designParts, setDesignParts] = useState([]);
//     const [defaultTexture, setDefaultTexture] = useState(null);
//      const previousProductIdRef = useRef(null);
// // Effect 1: Handle model changes (when model URL changes)
// useEffect(() => {
//   if (!productData?.modelName) return;
  
//   // Only reload if model URL actually changed
//   if (productData.modelName !== previousModelUrlRef.current) {
//     console.log("Model URL changed:", productData.modelName);
    
//     previousModelUrlRef.current = productData.modelName;
//     loadModelForProduct();
//   }
// }, [productData?.modelName]);

// // Effect 2: Handle product changes (when product ID changes but model stays same)
// useEffect(() => {
//   if (!productData?.id) return;
  
//   // Product ID changed but model might be the same
//   if (productData.id !== previousProductIdRef.current) {
//     console.log("Product changed:", productData.id);
    
//     const modelChanged = productData.modelName !== previousModelUrlRef.current;
    
//     if (!modelChanged && gltf) {
//       // Same model, different product (duplicate) - just update settings
//       console.log("Same model, applying new product settings");
//       applyProductColorsToModel();
//       applyImagesToMaterials();
//     }
    
//     previousProductIdRef.current = productData.id;
//   }
// }, [productData?.id, gltf]);

// async function loadModelForProduct() {
//   if (!productData?.modelName) return;
  
//   setIsLoading(true);
//   setGltf(null);
  
//   try {
//     const cacheBustedUrl = `${productData.modelName}?t=${Date.now()}`;
//     const model = await loadModel(cacheBustedUrl);
//     setGltf(model);
//     setIsLoading(false);
//     console.log("Model loaded for product:", productData.id);
//   } catch (error) {
//     console.error("Failed to load model:", error);
//     setIsLoading(false);
//   }
// }

//     const texture = useMemo(() => {
//       // Check if we have a valid selected pattern from current product
//       if (!selectedPattern || typeof selectedPattern !== "object") {
//         console.log("No selected pattern or invalid pattern object");
//         return null;
//       }

//       // Check if the pattern has an image property
//       const patternImage = selectedPattern.image;
//       if (!patternImage || typeof patternImage !== "string") {
//         console.log(
//           "Selected pattern has no valid image URL:",
//           selectedPattern
//         );
//         return null;
//       }

//       try {
//         console.log("Loading pattern texture:", patternImage);
//         const texture = new THREE.TextureLoader().load(
//           patternImage,
//           // onLoad callback
//           () => {
//             console.log("Pattern texture loaded successfully");
//             texture.needsUpdate = true;
//           },
//           // onProgress callback (optional)
//           undefined,
//           // onError callback
//           (error) => {
//             console.error("Failed to load pattern texture:", error);
//           }
//         );

//         if (texture) {
//           texture.colorSpace = THREE.SRGBColorSpace;
//           texture.wrapS = THREE.RepeatWrapping;
//           texture.wrapT = THREE.RepeatWrapping;

//           // Use pattern-specific scale if available, otherwise default
//           const scale = selectedPattern.scale || 1;
//           texture.repeat.set(35 * scale, 35 * scale);

//           texture.transparent = true;
//           texture.opacity = selectedPattern.opacity || 0.5;
//         }

//         return texture;
//       } catch (error) {
//         console.error("Error creating texture:", error);
//         return null;
//       }
//     }, [
//         productData?.id,
//       selectedPattern?.image,
//       selectedPattern?.scale,
//       selectedPattern?.opacity,
//     ]);

//     const [patternedMaterials, setPatternedMaterials] = useState({});
//     const [forceRenderKey, setForceRenderKey] = useState(0);

//     ////console.log("state.selectedPattern : ", state.selectedPattern);

//     const baseColorTextureRef = useRef(null);

//     /** ==========================
//      *  OPTIMIZED MESH EXTRACTION
//      *  ========================== */
//     useEffect(() => {
//       if (gltf?.scene) {
//         const extractedParts = [];

//         gltf.scene.traverse((child) => {
//           if (child.isMesh) {
//             child.geometry.computeVertexNormals();

//             if (child.material.side === THREE.BackSide) {
//               child.geometry.scale(-1, 1, 1);
//               child.material.side = THREE.FrontSide;
//             }

//             extractedParts.push({
//               name: child.name,
//               geometry: child.geometry,
//               material: child.material,
//             });
//           }
//         });

//         console.log("extractedParts : ", extractedParts);

//         setLocalParts(extractedParts);
//         state.parts = extractedParts.map((part) => part.material.name);
//       }
//     }, [gltf, state.setParts, menuSlug, subcategorySlug]);

//     console.log("state.parts:", state.parts);

//     const [renderCount, setRenderCount] = useState(0);

//     const svgContainerRef = useRef(null);

//     useEffect(() => {
//       const applyImagesToMaterials = async () => {
//         if (!group.current) return;

//         console.log(
//           "currentProduct imagesPattern : ",
//           productData?.imagesPattern
//         );

//         const imagesPattern = productData?.imagesPattern || {};
//         const normalizedImages = Object.fromEntries(
//           Object.entries(imagesPattern).map(([key, val]) => [
//             key.toUpperCase(),
//             val,
//           ])
//         );

//         group.current.traverse(async (child) => {
//           if (!child.isMesh || !child.material) return;

//           const materialName = child.material.name?.toUpperCase();
//           if (!materialName || !partMappings[materialName]) return;

//           const materials = Array.isArray(child.material)
//             ? child.material
//             : [child.material];

//           for (const mat of materials) {
//             const imageData = normalizedImages[materialName];

//             // Dispose of existing texture to prevent memory leaks
//             if (mat.map) {
//               mat.map.dispose();
//               mat.map = null;
//             }

//             if (imageData?.image) {
//               try {
//                 const texture = await new THREE.TextureLoader().loadAsync(
//                   imageData.image
//                 );

//                 texture.colorSpace = THREE.SRGBColorSpace;
//                 texture.flipY = false;
//                 texture.wrapS = THREE.RepeatWrapping;
//                 texture.wrapT = THREE.RepeatWrapping;
//                 texture.center.set(0.5, 0.5);

//                 const img = new Image();
//                 img.crossOrigin = "anonymous";

//                 img.onload = () => {
//                   const imageAspect = img.width / img.height;
//                   const shirtAspect = 2220 / 2553; // your shirt UV ratio

//                   console.log("imageAspect: ", imageAspect);
//                   console.log("img.width: ", img.width);
//                   console.log("img.height: ", img.height);

//                   // Scale factor to control pattern size (increase = smaller pattern)
//                   const SCALE_FACTOR = 2; // Adjust this: 1 = normal, 2 = half size, 3 = third size

//                   if (img.width >= 2220 && img.height >= 2553) {
//                     // High-res pattern
//                     if (imageAspect > shirtAspect) {
//                       texture.repeat.set(
//                         (shirtAspect / imageAspect) * SCALE_FACTOR,
//                         1 * SCALE_FACTOR
//                       );
//                     } else {
//                       texture.repeat.set(
//                         1 * SCALE_FACTOR,
//                         (imageAspect / shirtAspect) * SCALE_FACTOR
//                       );
//                     }
//                   } else if (img.width >= 1000 && img.height >= 1000) {
//                     // Medium pattern - tile it appropriately
//                     texture.repeat.set(
//                       (2220 / img.width) * 0.8 * SCALE_FACTOR,
//                       (2553 / img.height) * 0.8 * SCALE_FACTOR
//                     );
//                   } else {
//                     // Small pattern - tile more
//                     const scaleX = Math.max(1, 2220 / img.width);
//                     const scaleY = Math.max(1, 2553 / img.height);
//                     texture.repeat.set(
//                       scaleX * SCALE_FACTOR,
//                       scaleY * SCALE_FACTOR
//                     );
//                   }

//                   texture.needsUpdate = true;
//                 };

//                 img.src = imageData.image;

//                 mat.map = texture;
//                 mat.color.set(0xffffff);
//                 mat.needsUpdate = true;
//               } catch (err) {
//                 console.error(`Failed to load image for ${materialName}:`, err);
//               }
//             } else {
//               // No image - reset to default color
//               mat.map = null;
//               mat.color.set("#112F51");
//               mat.needsUpdate = true;
//             }
//           }
//         });
//       };

//       applyImagesToMaterials();
//     }, [productData?.imagesPattern, productData?.id]);

//     function applyGradientToPath(
//       svg,
//       pathElement,
//       baseColor,
//       gradientColor,
//       gradientId
//     ) {
//       ////console.log("Gradient svg : ", svg);
//       ////console.log("Gradient pathElement : ", pathElement);
//       ////console.log("Gradient baseColor : ", baseColor);
//       ////console.log("Gradient gradientColor : ", gradientColor);
//       ////console.log("Gradient gradientId : ", gradientId);

//       const defs =
//         svg.querySelector("defs") ||
//         svg.insertBefore(
//           document.createElementNS("http://www.w3.org/2000/svg", "defs"),
//           svg.firstChild
//         );

//       let gradient = document.getElementById(gradientId);
//       if (!gradient) {
//         gradient = document.createElementNS(
//           "http://www.w3.org/2000/svg",
//           "linearGradient"
//         );
//         gradient.setAttribute("id", gradientId);

//         gradient.setAttribute("x1", "0%");
//         gradient.setAttribute("y1", "0%");
//         gradient.setAttribute("x2", "0%");
//         gradient.setAttribute("y2", "100%");

//         const stop1 = document.createElementNS(
//           "http://www.w3.org/2000/svg",
//           "stop"
//         );
//         stop1.setAttribute("offset", "0%");
//         stop1.setAttribute("stop-color", baseColor);

//         const stop2 = document.createElementNS(
//           "http://www.w3.org/2000/svg",
//           "stop"
//         );
//         stop2.setAttribute("offset", "100%");
//         stop2.setAttribute("stop-color", gradientColor);

//         gradient.appendChild(stop1);
//         gradient.appendChild(stop2);
//         defs.appendChild(gradient);
//       }

//       pathElement.setAttribute("fill", `url(#${gradientId})`);
//     }

//     async function applyPatternToPath(
//       targetSVG,
//       pathElements,
//       patternData,
//       patternName,
//       patternId
//     ) {
//       try {
//         const response = await fetch(patternData.image);
//         const contentType = response.headers.get("Content-Type");
//         const isSVG = contentType && contentType.includes("image/svg+xml");

//         if (!isSVG) {
//           console.error("Pattern is not an SVG.");
//           return;
//         }

//         const rawPatternSVG = await response.text();
//         const parser = new DOMParser();
//         const parsedDoc = parser.parseFromString(
//           rawPatternSVG,
//           "image/svg+xml"
//         );
//         const originalSVG = parsedDoc.querySelector("svg");

//         if (!originalSVG) {
//           console.error("No <svg> found in the pattern file.");
//           return;
//         }

//         // Get or create defs
//         const defs =
//           targetSVG.querySelector("defs") ||
//           targetSVG.insertBefore(
//             document.createElementNS("http://www.w3.org/2000/svg", "defs"),
//             targetSVG.firstChild
//           );

//         // Remove existing patterns with same name
//         const existingPatterns = defs.querySelectorAll("pattern");
//         existingPatterns.forEach((pat) => {
//           if (pat.getAttribute("data-pattern-name") === patternName) {
//             pat.remove();
//           }
//         });

//         const oldInnerSVG = targetSVG.querySelector(`#svg_${patternName}`);
//         if (oldInnerSVG) oldInnerSVG.remove();

//         // Extract viewBox from original SVG
//         const viewBoxAttr = originalSVG.getAttribute("viewBox");
//         let viewBoxWidth, viewBoxHeight;

//         if (viewBoxAttr) {
//           const viewBox = viewBoxAttr.split(/\s+/);
//           viewBoxWidth = parseFloat(viewBox[2]);
//           viewBoxHeight = parseFloat(viewBox[3]);
//         } else {
//           // Fallback to width/height attributes
//           viewBoxWidth = parseFloat(originalSVG.getAttribute("width")) || 28;
//           viewBoxHeight = parseFloat(originalSVG.getAttribute("height")) || 49;
//         }

//         // Use pattern-specific scale if available, otherwise use default 1.2
//         console.log("patternData ........... : ", patternData);

//         const PATTERN_SCALE = patternData.scale || 1.2;

//         // Create pattern element with proper dimensions
//         const patternNode = document.createElementNS(
//           "http://www.w3.org/2000/svg",
//           "pattern"
//         );
//         patternNode.setAttribute("id", patternId);
//         patternNode.setAttribute("x", "0");
//         patternNode.setAttribute("y", "0");
//         patternNode.setAttribute("width", viewBoxWidth.toString());
//         patternNode.setAttribute("height", viewBoxHeight.toString());
//         patternNode.setAttribute("patternUnits", "userSpaceOnUse");
//         patternNode.setAttribute("patternTransform", `scale(${PATTERN_SCALE})`);
//         patternNode.setAttribute("data-pattern-name", patternName);

//         // Create inner SVG with matching dimensions
//         const innerSVG = document.createElementNS(
//           "http://www.w3.org/2000/svg",
//           "svg"
//         );
//         innerSVG.setAttribute("id", `svg_${patternName}`);
//         innerSVG.setAttribute("width", viewBoxWidth.toString());
//         innerSVG.setAttribute("height", viewBoxHeight.toString());
//         innerSVG.setAttribute(
//           "viewBox",
//           `0 0 ${viewBoxWidth} ${viewBoxHeight}`
//         );

//         // Get the color for this pattern from current product
//         const partColor =
//           productData?.patternColors?.[patternName.toUpperCase()] || "#000000";

//         // For your specific hexagon pattern, we need to handle it differently
//         // Clone the entire content but replace the fill color
//         const originalContent = originalSVG.innerHTML;

//         // Create a temporary div to manipulate the SVG content
//         const tempDiv = document.createElement("div");
//         tempDiv.innerHTML = originalContent;

//         // Find and update all path elements
//         const paths = tempDiv.querySelectorAll("path");
//         paths.forEach((path) => {
//           // Remove existing fill and stroke attributes
//           path.removeAttribute("fill");
//           path.removeAttribute("stroke");
//           path.removeAttribute("stroke-width");
//           path.removeAttribute("style");

//           // Apply the new color
//           path.setAttribute("fill", partColor);
//           path.setAttribute("stroke", "none");
//           path.setAttribute("stroke-width", "0");
//         });

//         // If no paths found, try to find any shapes
//         if (paths.length === 0) {
//           const shapes = tempDiv.querySelectorAll(
//             "rect, circle, ellipse, polygon, polyline"
//           );
//           shapes.forEach((shape) => {
//             shape.removeAttribute("fill");
//             shape.removeAttribute("stroke");
//             shape.removeAttribute("stroke-width");
//             shape.removeAttribute("style");
//             shape.setAttribute("fill", partColor);
//             shape.setAttribute("stroke", "none");
//             shape.setAttribute("stroke-width", "0");
//           });
//         }

//         // Set the inner HTML of our innerSVG
//         innerSVG.innerHTML = tempDiv.innerHTML;

//         patternNode.appendChild(innerSVG);
//         defs.appendChild(patternNode);

//         // Get or create the scale group
//         let gElement = targetSVG.querySelector("g#scale");
//         if (!gElement) {
//           gElement = document.createElementNS(
//             "http://www.w3.org/2000/svg",
//             "g"
//           );
//           gElement.setAttribute("id", "scale");
//           targetSVG.appendChild(gElement);
//         }

//         // Apply pattern to all path elements
//         pathElements.forEach((pathElement, index) => {
//           const originalId = pathElement.getAttribute("id");
//           const elementLabel = (
//             pathElement.getAttribute("elementname") || `part${index}`
//           ).replace(/\s+/g, "_");
//           const newId = `${originalId}_copy_${elementLabel}`;

//           // Remove old copy if exists
//           const oldCopy = gElement.querySelector(`path[id="${newId}"]`);
//           if (oldCopy) oldCopy.remove();

//           // Create new path with pattern fill
//           const copyPath = pathElement.cloneNode(true);

//           // Clean up attributes but keep essential ones
//           const keepAttributes = ["d", "id", "transform"];
//           [...copyPath.attributes].forEach((attr) => {
//             if (!keepAttributes.includes(attr.name)) {
//               copyPath.removeAttribute(attr.name);
//             }
//           });

//           copyPath.setAttribute("id", newId);
//           copyPath.setAttribute("fill", `url(#${patternId})`);
//           copyPath.setAttribute("data-pattern-name", patternName);
//           copyPath.setAttribute("data-element-name", elementLabel);

//           gElement.appendChild(copyPath);
//         });

//         console.log(
//           `Pattern '${patternName}' applied with color ${partColor}, scale ${PATTERN_SCALE} and dimensions ${viewBoxWidth}x${viewBoxHeight}`
//         );
//       } catch (err) {
//         console.error("Failed to load or apply pattern:", err);
//       }
//     }
//     async function loadTextureFromSVG(svgElement, size = 2048) {
//       ////console.log("svgElement for pattern and color: ", svgElement);

//       const svgClone = svgElement.cloneNode(true);

//       ////console.log("svgClone : ", svgClone);

//       const originalDefs = svgElement.querySelector("defs");
//       ////console.log("originalDefs : ", originalDefs);
//       if (originalDefs) {
//         let clonedDefs = svgClone.querySelector("defs");

//         if (!clonedDefs) {
//           clonedDefs = originalDefs.cloneNode(true);
//           svgClone.insertBefore(clonedDefs, svgClone.firstChild);
//         }
//       }

//       svgClone.setAttribute("width", size);
//       svgClone.setAttribute("height", size);
//       svgClone.setAttribute("viewBox", `0 0 ${size} ${size}`);
//       svgClone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
//       svgClone.setAttribute("version", "1.1");

//       const svgString = new XMLSerializer().serializeToString(svgClone);
//       ////console.log("svgString: ", svgString);
//       const imageUrl = `data:image/svg+xml;base64,${btoa(
//         unescape(encodeURIComponent(svgString))
//       )}`;

//       ////console.log("imageUrl for pattern: ", imageUrl);

//       const existing = document.getElementById("svg-preview-wrapper");
//       if (existing) existing.remove();

//       // const wrapper = document.createElement("div");
//       // wrapper.id = "svg-preview-wrapper";
//       // wrapper.style.cssText = `
//       //   position: absolute; top: 20px; left: 520px;
//       //   width: 320px; height: 100px;
//       //   overflow: auto; border: 2px solid black;
//       //   z-index: 9999; background: white; padding: 4px;
//       // `;

//       // const preview = document.createElement("img");
//       // preview.src = imageUrl;
//       // preview.style.width = "100%";
//       // preview.style.outline = "3px solid blue";
//       // wrapper.appendChild(preview);
//       // document.body.appendChild(wrapper);

//       return new Promise((resolve) => {
//         const img = new Image();
//         img.crossOrigin = "anonymous";

//         img.onload = () => {
//           const canvas = document.createElement("canvas");
//           canvas.width = size;
//           canvas.height = size;

//           const ctx = canvas.getContext("2d");
//           ctx.clearRect(0, 0, size, size);

//           ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

//           const texture = new THREE.CanvasTexture(canvas);
//           texture.needsUpdate = true;

//           const debugImage = new Image();
//           debugImage.src = texture.image.toDataURL("image/png");
//           // debugImage.style.position = "absolute";
//           // debugImage.style.top = "200px";
//           // debugImage.style.left = "400px";
//           // debugImage.style.width = "200px";
//           // debugImage.style.border = "2px dashed green";
//           // debugImage.alt = "CanvasTexture Preview";

//           // document.body.appendChild(debugImage);

//           resolve(texture);
//         };

//         img.onerror = (err) => {
//           console.error("Image failed to load from SVG:", err);
//           resolve(null);
//         };

//         img.src = imageUrl;
//       });
//     }

//     const svgStateRef = useRef(null);
//     function unwrapProxy(proxyObj) {
//       if (proxyObj === null || typeof proxyObj !== "object") return proxyObj;
//       if (Array.isArray(proxyObj)) return proxyObj.map(unwrapProxy);

//       const plainObj = {};
//       for (const key in proxyObj) {
//         plainObj[key] = unwrapProxy(proxyObj[key]);
//       }
//       return plainObj;
//     }

//     const currentSvgUrlRef = useRef(null);

//     console.log("partcolors : ", state.partColors);
// console.log("productData ::::::::::::::::::::: ",productData)
// console.log("svg new ::::::::::::::::: ", state.svg);
// // Add this effect to force SVG updates when product changes
// useEffect(() => {
//   console.log("Product changed, forcing SVG update for product:", productData?.id);
  
//   // Force a re-render of the SVG effect
//   if (svgStateRef.current && productData?.id) {
//     // Trigger the SVG update by updating the refetch condition
//     currentSvgUrlRef.current = null; // Force refetch
//     svgStateRef.current = null; // Clear cached SVG
    
//     // Manually trigger the SVG update
//     const timer = setTimeout(() => {
//       if (state.svg) {
//         fetch(`${state.svg}?cacheBust=${Date.now()}`)
//           .then((res) => res.text())
//           .then((svgText) => {
//             const parser = new DOMParser();
//             const baseSVG = parser
//               .parseFromString(svgText, "image/svg+xml")
//               .querySelector("svg");

//             if (!baseSVG) {
//               console.warn("SVG not found");
//               return;
//             }

//             svgStateRef.current = baseSVG;
//             currentSvgUrlRef.current = state.svg;
            
//             // Trigger the update function
//             updateAndRenderSVG();
//           });
//       }
//     }, 100);
    
//     return () => clearTimeout(timer);
//   }
// }, [productData?.id]);
// // Move this function outside the useEffect
// const updateAndRenderSVG = useCallback(async () => {
//   console.log("updateAndRenderSVG called for product:", productData?.id);
  
//   if (!svgStateRef.current) {
//     console.log("No SVG state available, skipping");
//     return;
//   }
  
//   const baseSVG = svgStateRef.current.cloneNode(true);
//   const scaleGroup = baseSVG.querySelector("#scale");
  
//   if (!scaleGroup) {
//     console.log("No scale group found in SVG");
//     return;
//   }

//   console.log("scaleGroup found:", scaleGroup);

//   const partColors = productData?.partColors || {};
//   const gradientColors = productData?.gradientColors || {};
//   const unwrappedPattern = unwrapProxy(
//     productData?.selectedPattern || {}
//   );
//   const normalizedPattern = Object.fromEntries(
//     Object.entries(unwrappedPattern).map(([key, val]) => [
//       key.toUpperCase(),
//       val,
//     ])
//   );

//   console.log("Applying from productData:", {
//     partColors,
//     gradientColors,
//     normalizedPattern
//   });

//   const directColorParts = ["DESIGN", "LOGO", "NECK"];

//   directColorParts.forEach((partName) => {
//     const color = partColors?.[partName];
//     if (!color) return;

//     const groupObj = group.current;
//     if (!groupObj) return;

//     groupObj.traverse((child) => {
//       if (!child.isMesh || !child.material) return;

//       const materials = Array.isArray(child.material)
//         ? child.material
//         : [child.material];

//       materials.forEach((mat) => {
//         if (mat.name === partName) {
//           mat.color.set(color);
//           mat.needsUpdate = true;
//         }
//       });
//     });
//   });

//   const patternApplyPromises = [];

//   console.log("partMappings : ", partMappings);

//   Object.entries(partMappings).forEach(
//     ([materialName, targetElements]) => {
//       const baseColor = partColors[materialName];
//       const gradientColor = gradientColors[materialName];
//       const patternData = normalizedPattern?.[materialName.toUpperCase()];

//       console.log(`Processing ${materialName}:`, {
//         baseColor,
//         gradientColor,
//         patternData: patternData?.image ? "Pattern exists" : "No pattern"
//       });

//       if ((!baseColor && !patternData) || !targetElements) return;

//       const matchingPaths = Array.from(
//         scaleGroup.querySelectorAll("path")
//       ).filter((path) => {
//         let nameAttr = null;
//         path.getAttributeNames().forEach((attr) => {
//           if (attr.toLowerCase() === "elementname") {
//             nameAttr = path.getAttribute(attr);
//           }
//         });
//         return (
//           nameAttr && targetElements.includes(nameAttr.toUpperCase())
//         );
//       });

//       console.log(`${materialName} - matching paths:`, matchingPaths.length);

//       matchingPaths.forEach((path) => {
//         if (patternData?.image) {
//           if (materialName === "TEE") {
//             const promise = applyPatternToPath(
//               baseSVG,
//               matchingPaths,
//               patternData,
//               materialName,
//               `${materialName}_${patternData.name}`
//             );
//             patternApplyPromises.push(promise);
//           } else {
//             // apply individually
//             matchingPaths.forEach((path) => {
//               const promise = applyPatternToPath(
//                 baseSVG,
//                 [path], // wrap in array
//                 patternData,
//                 materialName,
//                 `${materialName}_${patternData.name}`
//               );
//               patternApplyPromises.push(promise);
//             });
//           }
//         }

//         if (baseColor && gradientColor) {
//           applyGradientToPath(
//             baseSVG,
//             path,
//             baseColor,
//             gradientColor,
//             `grad-${materialName}`
//           );
//         } else if (baseColor) {
//           path.setAttribute("fill", baseColor);
//         }
//       });
//     }
//   );

//   // Wait for all pattern fills to complete
//   await Promise.all(patternApplyPromises);

//   const texture = await loadTextureFromSVG(baseSVG);
//   baseColorTextureRef.current = texture;

//   group.current?.traverse((child) => {
//     if (!child.isMesh || !child.material) return;

//     const materials = Array.isArray(child.material)
//       ? child.material
//       : [child.material];

//     materials.forEach((mat) => {
//       if (!partMappings[mat.name]) return;

//       mat.map?.dispose();
//       mat.map = texture;
//       mat.map.flipY = false;
//       mat.map.colorSpace = THREE.SRGBColorSpace;
//       mat.color.set("#ffffff");
//       mat.needsUpdate = true;
//     });
//   });
  
//   console.log("SVG update completed for product:", productData?.id);
// }, [productData, partMappings, group.current]);

// // Then update the useEffect to use this function
// useEffect(() => {
//   console.log("SVG Effect Triggered");
  
//   if (!svgContainerRef.current) {
//     return;
//   }

//   const shouldRefetch =
//     !svgStateRef.current || currentSvgUrlRef.current !== state.svg;

//   if (shouldRefetch) {
//     fetch(`${state.svg}?cacheBust=${Date.now()}`)
//       .then((res) => res.text())
//       .then((svgText) => {
//         const parser = new DOMParser();
//         const baseSVG = parser
//           .parseFromString(svgText, "image/svg+xml")
//           .querySelector("svg");

//         if (!baseSVG) {
//           console.warn("SVG not found");
//           return;
//         }

//         svgStateRef.current = baseSVG;
//         currentSvgUrlRef.current = state.svg;
        
//         // Call the external function
//         updateAndRenderSVG();
//       });
//   } else {
//     // Call the external function
//     updateAndRenderSVG();
//   }
// }, [
//   state.svg,
//   updateAndRenderSVG // Add this as dependency
// ]);
//     useEffect(() => {
//       console.log("svg new : ", state.svg);
//       if (!svgContainerRef.current) return;

//       // Check if SVG URL has changed
//       const shouldRefetch =
//         !svgStateRef.current || currentSvgUrlRef.current !== state.svg;

//       if (shouldRefetch) {
//         fetch(`${state.svg}?cacheBust=${Date.now()}`)
//           .then((res) => res.text())
//           .then((svgText) => {
//             console.log("svgText : ", svgText);
//             const parser = new DOMParser();
//             const baseSVG = parser
//               .parseFromString(svgText, "image/svg+xml")
//               .querySelector("svg");

//             console.log("baseSVG : ", baseSVG);

//             if (!baseSVG) {
//               console.warn("SVG not found");
//               return;
//             }

//             svgStateRef.current = baseSVG;
//             currentSvgUrlRef.current = state.svg; // Track current SVG URL
//             updateAndRenderSVG();
//           });
//       } else {
//         updateAndRenderSVG();
//       }

//       async function updateAndRenderSVG() {
//         const baseSVG = svgStateRef.current.cloneNode(true);
//         const scaleGroup = baseSVG.querySelector("#scale");
//         console.log("scaleGroup : ", scaleGroup);
//         if (!scaleGroup) return;

//         // Use productData instead of snap
//         const partColors = productData?.partColors || {};
//         const gradientColors = productData?.gradientColors || {};
//         const unwrappedPattern = unwrapProxy(
//           productData?.selectedPattern || {}
//         );
//         const normalizedPattern = Object.fromEntries(
//           Object.entries(unwrappedPattern).map(([key, val]) => [
//             key.toUpperCase(),
//             val,
//           ])
//         );

//         const directColorParts = ["DESIGN", "LOGO", "NECK"];

//         directColorParts.forEach((partName) => {
//           const color = partColors?.[partName];
//           if (!color) return;

//           const groupObj = group.current;
//           if (!groupObj) return;

//           groupObj.traverse((child) => {
//             if (!child.isMesh || !child.material) return;

//             const materials = Array.isArray(child.material)
//               ? child.material
//               : [child.material];

//             materials.forEach((mat) => {
//               if (mat.name === partName) {
//                 mat.color.set(color);
//                 mat.needsUpdate = true;
//               }
//             });
//           });
//         });

//         const patternApplyPromises = [];

//         console.log("partMappings : ", partMappings);

//         Object.entries(partMappings).forEach(
//           ([materialName, targetElements]) => {
//             const baseColor = partColors[materialName];
//             const gradientColor = gradientColors[materialName];
//             const patternData = normalizedPattern?.[materialName.toUpperCase()];

//             console.log("baseColor : ", baseColor);

//             if ((!baseColor && !patternData) || !targetElements) return;

//             const matchingPaths = Array.from(
//               scaleGroup.querySelectorAll("path")
//             ).filter((path) => {
//               let nameAttr = null;
//               path.getAttributeNames().forEach((attr) => {
//                 if (attr.toLowerCase() === "elementname") {
//                   nameAttr = path.getAttribute(attr);
//                 }
//               });
//               return (
//                 nameAttr && targetElements.includes(nameAttr.toUpperCase())
//               );
//             });

//             matchingPaths.forEach((path) => {
//               if (patternData?.image) {
//                 if (materialName === "TEE") {
//                   const promise = applyPatternToPath(
//                     baseSVG,
//                     matchingPaths,
//                     patternData,
//                     materialName,
//                     `${materialName}_${patternData.name}`
//                   );
//                   patternApplyPromises.push(promise);
//                 } else {
//                   // apply individually
//                   matchingPaths.forEach((path) => {
//                     const promise = applyPatternToPath(
//                       baseSVG,
//                       [path], // wrap in array
//                       patternData,
//                       materialName,
//                       `${materialName}_${patternData.name}`
//                     );
//                     patternApplyPromises.push(promise);
//                   });
//                 }
//               }

//               if (baseColor && gradientColor) {
//                 applyGradientToPath(
//                   baseSVG,
//                   path,
//                   baseColor,
//                   gradientColor,
//                   `grad-${materialName}`
//                 );
//               } else if (baseColor) {
//                 path.setAttribute("fill", baseColor);
//               }
//             });
//           }
//         );

//         // Wait for all pattern fills to complete
//         await Promise.all(patternApplyPromises);

//         const texture = await loadTextureFromSVG(baseSVG);
//         baseColorTextureRef.current = texture;

//         group.current?.traverse((child) => {
//           if (!child.isMesh || !child.material) return;

//           const materials = Array.isArray(child.material)
//             ? child.material
//             : [child.material];

//           materials.forEach((mat) => {
//             if (!partMappings[mat.name]) return;

//             mat.map?.dispose();
//             mat.map = texture;
//             mat.map.flipY = false;
//             mat.map.colorSpace = THREE.SRGBColorSpace;
//             mat.color.set("#ffffff");
//             mat.needsUpdate = true;
//           });
//         });
//       }
//     }, [
//          productData?.id,
//       productData?.partColors,
//       productData?.gradientColors,
//       productData?.selectedPattern,
//       productData?.patternColors,
//       state.svg,
//       currentProduct
//     ]);
//     /** ==========================
//      *  MEMOIZED TEXTURE LOADING
//      *  ========================== */
//     // const logoTexture = useMemo(() => {
//     //   if (!snap.frontLogo) return null;
//     //   // Create a canvas to resize the image to 100x100
//     //   const canvas = document.createElement("canvas");
//     //   canvas.width = 100;
//     //   canvas.height = 100;
//     //   const ctx = canvas.getContext("2d");

//     //   // Create texture from the canvas
//     //   const texture = new THREE.CanvasTexture(canvas);
//     //   texture.colorSpace = THREE.SRGBColorSpace;
//     //   texture.premultiplyAlpha = true;
//     //   texture.generateMipmaps = false;
//     //   texture.minFilter = THREE.LinearFilter;
//     //   texture.magFilter = THREE.LinearFilter;

//     //   // Create an image to load the logo
//     //   const img = new Image();
//     //   img.crossOrigin = "anonymous";
//     //   img.onload = () => {
//     //     // Draw the image resized to 100x100
//     //     ctx.drawImage(img, 0, 0, 100, 100);
//     //     texture.needsUpdate = true;
//     //   };
//     //   img.src = snap.frontLogo;

//     //   return texture;
//     // }, [snap.frontLogo]);
//     const logoTexture = useMemo(() => {
//       if (!productData?.frontLogo) return null;
//       // Create a canvas to resize the image to 100x100
//       const canvas = document.createElement("canvas");
//       canvas.width = 100;
//       canvas.height = 100;
//       const ctx = canvas.getContext("2d");

//       // Create texture from the canvas
//       const texture = new THREE.CanvasTexture(canvas);
//       texture.colorSpace = THREE.SRGBColorSpace;
//       texture.premultiplyAlpha = true;
//       texture.generateMipmaps = false;
//       texture.minFilter = THREE.LinearFilter;
//       texture.magFilter = THREE.LinearFilter;

//       // Create an image to load the logo
//       const img = new Image();
//       img.crossOrigin = "anonymous";
//       img.onload = () => {
//         // Draw the image resized to 100x100
//         ctx.drawImage(img, 0, 0, 100, 100);
//         texture.needsUpdate = true;
//       };
//       img.src = productData.frontLogo;

//       return texture;
//     }, [productData?.frontLogo]);

//     const logoTextureBack = useMemo(() => {
//       if (!productData?.backLogo) return null;
//       // Create a canvas to resize the image to 100x100
//       const canvas = document.createElement("canvas");
//       canvas.width = 100;
//       canvas.height = 100;
//       const ctx = canvas.getContext("2d");

//       // Create texture from the canvas
//       const texture = new THREE.CanvasTexture(canvas);
//       texture.colorSpace = THREE.SRGBColorSpace;
//       texture.premultiplyAlpha = true;
//       texture.generateMipmaps = false;
//       texture.minFilter = THREE.LinearFilter;
//       texture.magFilter = THREE.LinearFilter;

//       // Create an image to load the logo
//       const img = new Image();
//       img.crossOrigin = "anonymous";
//       img.onload = () => {
//         // Draw the image resized to 100x100
//         ctx.drawImage(img, 0, 0, 100, 100);
//         texture.needsUpdate = true;
//       };
//       img.src = productData.backLogo;

//       return texture;
//     }, [productData?.backLogo]);

//     useEffect(() => {
//       if (logoTexture) {
//         logoTexture.needsUpdate = true;
//       }
//     }, [logoTexture]);

//     useEffect(() => {
//       if (logoTextureBack) {
//         logoTextureBack.needsUpdate = true;
//       }
//     }, [logoTextureBack]);

//     const createCanvasTexture = () => {
//       const canvas = document.createElement("canvas");
//       canvas.width = 1024;
//       canvas.height = 512;
//       return new CanvasTexture(canvas);
//     };

//     const frontTextTexture = useRef(createCanvasTexture());
//     const backTextTexture = useRef(createCanvasTexture());
//     const frontNumberTexture = useRef(createCanvasTexture());
//     const backNumberTexture = useRef(createCanvasTexture());

//     // const updateTexture = (
//     //   text,
//     //   textureRef,
//     //   partName,
//     //   fontFamily,
//     //   colorType = "text"
//     // ) => {
//     //   if (!text || !textureRef.current) return;

//     //   const canvas = textureRef.current.image;
//     //   const ctx = canvas.getContext("2d");

//     //   if (!ctx) {
//     //     console.error("Canvas context not found.");
//     //     return;
//     //   }

//     //   ctx.clearRect(0, 0, canvas.width, canvas.height);

//     //   // Use different color properties based on colorType
//     //   let color;
//     //   if (colorType === "text") {
//     //     // For text: use textColors.front or textColors.back from current product
//     //     color = partName.includes("front")
//     //       ? productData?.textColors?.front || "#ffffff"
//     //       : productData?.textColors?.back || "#ffffff";
//     //   } else if (colorType === "number") {
//     //     // For numbers: use numberColors.front or numberColors.back from current product
//     //     color = partName.includes("front")
//     //       ? productData?.numberColors?.front || "#ffffff"
//     //       : productData?.numberColors?.back || "#ffffff";
//     //   } else {
//     //     // Fallback
//     //     color = "#ffffff";
//     //   }

//     //   ctx.fillStyle = color;
//     //   ctx.font = `bold 80px ${fontFamily}`;
//     //   ctx.textAlign = "center";
//     //   ctx.textBaseline = "middle";
//     //   ctx.fillText(text, canvas.width / 2, canvas.height / 2);

//     //   textureRef.current.needsUpdate = true;
//     // };

//     // useEffect(() => {
//     //   // For front text
//     //   updateTexture(
//     //     productData?.frontText || "",
//     //     frontTextTexture,
//     //     "front",
//     //     productData?.textFonts?.front || productData?.selectedFonts || "Arial",
//     //     "text"
//     //   );

//     //   // For back text
//     //   updateTexture(
//     //     productData?.backText || "",
//     //     backTextTexture,
//     //     "back",
//     //     productData?.textFonts?.back || productData?.selectedFonts || "Arial",
//     //     "text"
//     //   );

//     //   // For front number - use number colors
//     //   updateTexture(
//     //     productData?.frontNumber || "",
//     //     frontNumberTexture,
//     //     "frontNumber",
//     //     productData?.numberFonts?.front || productData?.selectedFonts || "Arial",
//     //     "number"
//     //   );

//     //   // For back number - use number colors
//     //   updateTexture(
//     //     productData?.backNumber || "",
//     //     backNumberTexture,
//     //     "backNumber",
//     //     productData?.numberFonts?.back || productData?.selectedFonts || "Arial",
//     //     "number"
//     //   );
//     // }, [
//     //   productData?.frontText,
//     //   productData?.backText,
//     //   productData?.frontNumber,
//     //   productData?.backNumber,
//     //   productData?.textColors?.front,
//     //   productData?.textColors?.back,
//     //   productData?.numberColors?.front,
//     //   productData?.numberColors?.back,
//     //   productData?.textFonts?.front,
//     //   productData?.textFonts?.back,
//     //   productData?.numberFonts?.front,
//     //   productData?.numberFonts?.back,
//     //   productData?.selectedFonts,
//     // ]);

//     // useEffect(() => {
//     //   // For front text
//     //   updateTexture(
//     //     snap.frontText,
//     //     frontTextTexture,
//     //     "front",
//     //     state.textFonts?.front || state.selectedFonts,
//     //     "text" // Specify this is text
//     //   );

//     //   // For back text
//     //   updateTexture(
//     //     snap.backText,
//     //     backTextTexture,
//     //     "back",
//     //     state.textFonts?.back || state.selectedFonts,
//     //     "text" // Specify this is text
//     //   );

//     //   // For front number - use number colors
//     //   updateTexture(
//     //     snap.frontNumber,
//     //     frontNumberTexture,
//     //     "frontNumber",
//     //     state.numberFonts?.front || state.selectedFonts,
//     //     "number" // Specify this is number
//     //   );

//     //   // For back number - use number colors
//     //   updateTexture(
//     //     snap.backNumber,
//     //     backNumberTexture,
//     //     "backNumber",
//     //     state.numberFonts?.back || state.selectedFonts,
//     //     "number" // Specify this is number
//     //   );
//     // }, [
//     //   snap.frontText,
//     //   snap.backText,
//     //   snap.frontNumber,
//     //   snap.backNumber,
//     //   // Watch for text color changes
//     //   snap.textColors?.front,
//     //   snap.textColors?.back,
//     //   // Watch for number color changes
//     //   snap.numberColors?.front,
//     //   snap.numberColors?.back,
//     //   state.textFonts?.front,
//     //   state.textFonts?.back,
//     //   state.numberFonts?.front,
//     //   state.numberFonts?.back,
//     //   state.selectedFonts,
//     // ]);

//     useEffect(() => {
//       console.log("Updating textures for product:", productData?.id);
//       console.log("Front text:", productData?.frontText);
//       console.log("Front number:", productData?.frontNumber);

//       // For front text
//       updateTexture(
//         productData?.frontText || "",
//         frontTextTexture,
//         "front",
//         productData?.textFonts?.front || productData?.selectedFonts || "Arial",
//         "text"
//       );

//       // For back text
//       updateTexture(
//         productData?.backText || "",
//         backTextTexture,
//         "back",
//         productData?.textFonts?.back || productData?.selectedFonts || "Arial",
//         "text"
//       );

//       // For front number - use number colors
//       updateTexture(
//         productData?.frontNumber || "",
//         frontNumberTexture,
//         "frontNumber",
//         productData?.numberFonts?.front ||
//           productData?.selectedFonts ||
//           "Arial",
//         "number"
//       );

//       // For back number - use number colors
//       updateTexture(
//         productData?.backNumber || "",
//         backNumberTexture,
//         "backNumber",
//         productData?.numberFonts?.back || productData?.selectedFonts || "Arial",
//         "number"
//       );
//     }, [
//       productData?.id, // Add this to trigger when product changes
//       productData?.frontText,
//       productData?.backText,
//       productData?.frontNumber,
//       productData?.backNumber,
//       productData?.textColors?.front,
//       productData?.textColors?.back,
//       productData?.numberColors?.front,
//       productData?.numberColors?.back,
//       productData?.textFonts?.front,
//       productData?.textFonts?.back,
//       productData?.numberFonts?.front,
//       productData?.numberFonts?.back,
//       productData?.selectedFonts,
//     ]);

//     const updateTexture = (
//       text,
//       textureRef,
//       partName,
//       fontFamily,
//       colorType = "text"
//     ) => {
//       if (!textureRef.current) return;

//       const canvas = textureRef.current.image;
//       const ctx = canvas.getContext("2d");

//       if (!ctx) {
//         console.error("Canvas context not found.");
//         return;
//       }

//       // Always clear the canvas
//       ctx.clearRect(0, 0, canvas.width, canvas.height);

//       // Only draw if there's text
//       if (text && text.trim() !== "") {
//         // Use different color properties based on colorType
//         let color;
//         if (colorType === "text") {
//           // For text: use textColors.front or textColors.back from current product
//           color = partName.includes("front")
//             ? productData?.textColors?.front || "#ffffff"
//             : productData?.textColors?.back || "#ffffff";
//         } else if (colorType === "number") {
//           // For numbers: use numberColors.front or numberColors.back from current product
//           color = partName.includes("front")
//             ? productData?.numberColors?.front || "#ffffff"
//             : productData?.numberColors?.back || "#ffffff";
//         } else {
//           // Fallback
//           color = "#ffffff";
//         }

//         ctx.fillStyle = color;
//         ctx.font = `bold 80px ${fontFamily || "Arial"}`;
//         ctx.textAlign = "center";
//         ctx.textBaseline = "middle";
//         ctx.fillText(text, canvas.width / 2, canvas.height / 2);
//       }

//       textureRef.current.needsUpdate = true;
//     };

//     // Remove or update this useEffect
//     // useEffect(() => {
//     //   updateTexture(snap.frontText, frontTextTexture, "front");
//     //   updateTexture(snap.backText, backTextTexture, "back");
//     //   updateTexture(snap.frontNumber, frontNumberTexture, "frontNumber");
//     //   updateTexture(snap.backNumber, backNumberTexture, "backNumber");
//     // }, [state.updateTrigger]);

//     // Replace it with this:
//     useEffect(() => {
//       // Trigger texture updates when global updateTrigger changes
//       if (productData) {
//         updateTexture(
//           productData.frontText || "",
//           frontTextTexture,
//           "front",
//           productData.textFonts?.front || productData.selectedFonts || "Arial",
//           "text"
//         );

//         updateTexture(
//           productData.backText || "",
//           backTextTexture,
//           "back",
//           productData.textFonts?.back || productData.selectedFonts || "Arial",
//           "text"
//         );

//         updateTexture(
//           productData.frontNumber || "",
//           frontNumberTexture,
//           "frontNumber",
//           productData.numberFonts?.front ||
//             productData.selectedFonts ||
//             "Arial",
//           "number"
//         );

//         updateTexture(
//           productData.backNumber || "",
//           backNumberTexture,
//           "backNumber",
//           productData.numberFonts?.back || productData.selectedFonts || "Arial",
//           "number"
//         );
//       }
//     }, [state.updateTrigger]);

//     // ==========================================
//     // CLEAN INTERACTION STATE - FROM SCRATCH
//     // ==========================================
//     const [interactionMode, setInteractionMode] = useState("idle"); // idle, dragging, resizing
//     const [selectedDecal, setSelectedDecal] = useState(null); // Which decal is selected
//     const [isDragging, setIsDragging] = useState(false);
//     const [isResizing, setIsResizing] = useState(false);
//     const [activeCorner, setActiveCorner] = useState(null); // tl, tr, bl, br
//     const [dragStartPos, setDragStartPos] = useState({ x: 0, y: 0 });
//     const [initialDecalPos, setInitialDecalPos] = useState([0, 0, 0]);
//     const [initialDecalScale, setInitialDecalScale] = useState([1, 1, 1]);

//     const [decalPositions, setDecalPositions] = useState({
//       frontText: frontTextPosition,
//       backText: backTextPosition,
//       frontNumber: frontNumberPosition,
//       backNumber: backNumberPosition,
//       frontLogo: frontLogoPosition,
//       backLogo: backLogoPosition,
//     });
//     const [decalScales, setDecalScales] = useState({
//       frontText: frontTextScale,
//       backText: backTextScale,
//       frontNumber: frontNumberScale,
//       backNumber: backNumberScale,
//       frontLogo: frontLogoScale,
//       backLogo: backLogoScale,
//     });

//     const [decalRotations, setDecalRotations] = useState({
//       frontText: 0,
//       frontNumber: 0,
//       frontLogo: 0,
//       backText: 0,
//       backNumber: 0,
//       backLogo: 0,
//     });

//     console.log("decalRotations:", decalRotations);

//     const transformTargetsRef = useRef({});
//     const [transformMode, setTransformMode] = useState("translate");
//     const [, setIsTransforming] = useState(false);

//     useEffect(() => {
//       const modelKey = state.newKey;

//       if (modelKey === "eventordereventjersey") {
//         console.log("state.selectedDesignId:", glbId);
//         const designId = String(glbId || "902");

//         console.log("Updating positions for event order design:", designId);

//         let modelConfig = modelConfig1[modelKey]?.[designId];

//         if (!modelConfig) {
//           console.warn(
//             "No config found for design ID:",
//             designId,
//             "falling back to 902"
//           );
//           modelConfig = modelConfig1[modelKey]?.["902"];
//         }

//         if (!modelConfig) {
//           console.error("No valid config found even for fallback 902!");
//           return;
//         }

//         console.log("Found config for design:", designId, modelConfig);

//         setDecalPositions({
//           frontText: modelConfig.frontTextPosition || [0, 0, 0],
//           frontNumber: modelConfig.frontNumberPosition || [0, 0, 0],
//           frontLogo: modelConfig.frontLogoPosition || [0, 0, 0],
//           backText: modelConfig.backTextPosition || [0, 0, 0],
//           backNumber: modelConfig.backNumberPosition || [0, 0, 0],
//           backLogo: modelConfig.backLogoPosition || [0, 0, 0],
//         });

//         setDecalScales({
//           frontText: modelConfig.frontTextScale || [1, 1, 1],
//           frontNumber: modelConfig.frontNumberScale || [1, 1, 1],
//           frontLogo: modelConfig.frontLogoScale || [1, 1, 1],
//           backText: modelConfig.backTextScale || [1, 1, 1],
//           backNumber: modelConfig.backNumberScale || [1, 1, 1],
//           backLogo: modelConfig.backLogoScale || [1, 1, 1],
//         });

//         if (modelConfig.fontSize) setFontSizetext(modelConfig.fontSize);
//         if (modelConfig.fontSizeNumber)
//           setFontSizeNumber(modelConfig.fontSizeNumber);

//         console.log("📍 Updated decal positions for design:", designId);
//       }
//     }, [glbId]);

//     const [tempPosition, setTempPosition] = useState([0, 0, 0]);
//     const [tempScale, setTempScale] = useState([0, 0, 0]);
//     const [mouseStartPos, setMouseStartPos] = useState({ x: 0, y: 0 });
//     const fabricCanvasCache = useRef({});
//     const textureCache = useRef({});
//     const lastOverlayClickTime = useRef(0);
//     const [isFrontVisible, setIsFrontVisible] = useState(true);

//     const rotateIconScreenPosRef = useRef({ x: 0, y: 0 });
//     const rotateClickTimeRef = useRef(0);
//     const [showRotateTooltip, setShowRotateTooltip] = useState(null);

//     const [resizeArrowPosition, setResizeArrowPosition] = useState({
//       x: 0,
//       y: 0,
//     });

//     useEffect(() => {
//       const handleTransformHotkeys = (event) => {
//         if (!selectedDecal || !selectedDecal.toLowerCase().includes("text")) {
//           return;
//         }

//         if (event.key === "t" || event.key === "T") {
//           setTransformMode("translate");
//         }

//         if (event.key === "s" || event.key === "S") {
//           setTransformMode("scale");
//         }
//       };

//       window.addEventListener("keydown", handleTransformHotkeys);
//       return () =>
//         window.removeEventListener("keydown", handleTransformHotkeys);
//     }, [selectedDecal]);

//     const resizeArrowPositionRef = useRef({ x: 0, y: 0 });

//     const getFabricCanvas = useCallback((type) => {
//       if (fabricCanvasCache.current[type]) {
//         return fabricCanvasCache.current[type];
//       }

//       const canvas = document.createElement("canvas");
//       canvas.width = 1024;
//       canvas.height = 512;

//       const fabricCanvas = new fabric.Canvas(canvas, {
//         enableRetinaScaling: false,
//         renderOnAddRemove: false,
//         selection: false,
//         preserveObjectStacking: true,

//         skipTargetFind: false,
//         skipOffscreen: true,
//         imageSmoothingEnabled: true,

//         renderOnSelectionChange: false,

//         allowTouchScrolling: false,
//         fireRightClick: false,
//         stopContextMenu: true,
//       });

//       fabricCanvasCache.current[type] = {
//         canvas,
//         fabricCanvas,
//         texture: new THREE.CanvasTexture(canvas),
//       };

//       return fabricCanvasCache.current[type];
//     }, []);

//     useEffect(() => {
//       return () => {
//         Object.values(textureCache.current).forEach((texture) => {
//           if (texture && texture.dispose) {
//             texture.dispose();
//           }
//         });
//         textureCache.current = {};
//         fabricCanvasCache.current = {};
//       };
//     }, []);

//     useEffect(() => {
//       if (!selectedDecal) return;

//       const handleKeyDown = (e) => {
//         if (!selectedDecal) return;
//         if (
//           !["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)
//         )
//           return;

//         e.preventDefault();
//         const moveAmount = 0.01;
//         const currentPos = [...decalPositions[selectedDecal]];

//         //console.log("currentPos : ", currentPos);
//         switch (e.key) {
//           case "ArrowUp":
//             currentPos[1] += moveAmount;
//             break;
//           case "ArrowDown":
//             currentPos[1] -= moveAmount;
//             break;
//           case "ArrowLeft":
//             currentPos[0] -= moveAmount;
//             break;
//           case "ArrowRight":
//             currentPos[0] += moveAmount;
//             break;
//           default:
//             break;
//         }

//         //console.log("currentPos : ", currentPos);
//         setDecalPositions((prev) => ({
//           ...prev,
//           [selectedDecal]: currentPos,
//         }));
//         setTempPosition(currentPos);
//       };
//       window.addEventListener("keydown", handleKeyDown);
//       return () => {
//         window.removeEventListener("keydown", handleKeyDown);
//       };
//     }, [selectedDecal, decalPositions]);

//     const handleDeselect = () => {
//       setSelectedDecal(null);
//       setResizeMode(false);
//       setResizeCorner(null);
//       setInitialScale(null);
//       setIsDragging(false);
//       setIsResizing(false);
//       setActiveCorner(null);
//       // Always set to rotate-shirt mode when deselecting to enable rotation
//       setInteractionMode("rotate-shirt");

//       Object.keys(fabricCanvasCache.current).forEach((type) => {
//         const { fabricCanvas } = fabricCanvasCache.current[type];
//         fabricCanvas.discardActiveObject();
//         fabricCanvas.renderAll();
//       });
//     };

//     const [fontSizetext, setFontSizetext] = useState(() => {
//       const settings = getModelSettings(menuSlug, subcategorySlug);
//       return settings.fontSize || 50; // Reduced from 80 to 50
//     });

//     const [fontSizeNumber, setFontSizeNumber] = useState(() => {
//       const settings = getModelSettings(menuSlug, subcategorySlug);
//       return settings.fontSizeNumber || 60; // Reduced from 80 to 60
//     });

//     const getTextTexture = useCallback(
//       (type, textContent, color, font, isSelected) => {
//         if (!textContent || textContent.trim() === "") return null;

//         console.log("textContent : ", textContent);

//         try {
//           const { canvas, fabricCanvas, texture } = getFabricCanvas(type);

//           fabricCanvas.clear();

//           // Add padding for outline
//           const padding = isSelected ? 40 : 0;

//           const text = new fabric.Text(textContent, {
//             left: canvas.width / 2,
//             top: canvas.height / 2,
//             originX: "center",
//             originY: "center",
//             fontSize: fontSizetext || 80,
//             fontWeight: "bold",
//             fontFamily: font || "Arial",
//             fill: color || "black",
//             selectable: false,
//             hasControls: false,
//             hasBorders: false,
//             padding: isSelected ? 20 : 0,
//             borderColor: "transparent",
//             cornerSize: 0,
//             transparentCorners: true,
//             lockUniScaling: false,
//             hoverCursor: "default",
//             moveCursor: "default",
//             objectCaching: false,
//             borderScaleFactor: 0,
//             controls: {
//               tr: new fabric.Control({
//                 x: 0.5,
//                 y: -0.5,
//                 actionHandler: fabric.controlsUtils.rotationWithSnapping,
//                 cursorStyleHandler: () => "crosshair",
//                 // render: function (ctx, left, top, styleOverride, fabricObject) {
//                 //   const size = 60;
//                 //   ctx.save();
//                 //   ctx.translate(left, top);
//                 //   ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));

//                 //   ctx.beginPath();

//                 //   ctx.arc(0, 0, size / 2, 0, 2 * Math.PI);
//                 //   ctx.fillStyle = "white";
//                 //   ctx.fill();
//                 //   ctx.strokeStyle = "black";
//                 //   ctx.lineWidth = 3;
//                 //   ctx.stroke();

//                 //   ctx.beginPath();
//                 //   ctx.moveTo(size * 0.25, -size * 0.25);
//                 //   ctx.lineTo(size * 0.5, 0);
//                 //   ctx.lineTo(size * 0.25, size * 0.25);
//                 //   ctx.lineWidth = 7;
//                 //   ctx.stroke();

//                 //   ctx.beginPath();
//                 //   ctx.arc(
//                 //     0,
//                 //     0,
//                 //     size * 0.35,
//                 //     -Math.PI * 0.25,
//                 //     Math.PI * 1.5,
//                 //     false
//                 //   );
//                 //   ctx.lineWidth = 7;
//                 //   ctx.stroke();

//                 //   ctx.restore();
//                 // },
//                 actionName: "rotate",
//               }),
//               br: new fabric.Control({
//                 x: 0.5,
//                 y: 0.5,
//                 actionHandler: fabric.controlsUtils.scalingEqually,
//                 cursorStyleHandler: () => "nwse-resize",
//                 render: function (ctx, left, top, styleOverride, fabricObject) {
//                   const size = 60;
//                   ctx.save();
//                   ctx.translate(left, top);

//                   ctx.beginPath();
//                   ctx.rect(-size / 2, -size / 2, size, size);
//                   ctx.fillStyle = "white";
//                   ctx.fill();
//                   ctx.strokeStyle = "black";
//                   ctx.lineWidth = 3;
//                   ctx.stroke();

//                   ctx.beginPath();
//                   // Main line
//                   ctx.moveTo(-size * 0.35, -size * 0.35);
//                   ctx.lineTo(size * 0.35, size * 0.35);

//                   // Arrowhead
//                   ctx.moveTo(size * 0.35, size * 0.35);
//                   ctx.lineTo(size * 0.2, size * 0.35);
//                   ctx.lineTo(size * 0.35, size * 0.2);
//                   ctx.closePath();

//                   ctx.fillStyle = "black";
//                   ctx.fill();
//                   ctx.strokeStyle = "black";
//                   ctx.lineWidth = 7;
//                   ctx.stroke();

//                   ctx.restore();
//                 },
//                 actionName: "scale",
//               }),
//             },
//           });

//           text.set({
//             stroke: color || "black",
//             strokeWidth: 1,
//             strokeUniform: true,
//           });

//           fabricCanvas.add(text);

//           if (isSelected) {
//             fabricCanvas.setActiveObject(text);
//             text.bringToFront();

//             text.on("rotating", function (e) {
//               const angle = e.target.angle;
//               if (type.includes("front")) {
//                 frontTextRotation[2] = THREE.MathUtils.degToRad(angle);
//               } else {
//                 backTextRotation[2] = THREE.MathUtils.degToRad(angle);
//               }
//             });

//             text.on("scaling", function (e) {
//               const scale = e.target.scaleX;
//               if (type.includes("front")) {
//                 frontTextScale[0] = scale;
//                 frontTextScale[1] = scale;
//               } else {
//                 backTextScale[0] = scale;
//                 backTextScale[1] = scale;
//               }
//             });

//             // Disabled arrow creation for new resize feature
//             // requestAnimationFrame(() => {
//             //   const textBounds = text.getBoundingRect();
//             //   calculateAndStoreArrowPosition(type, textBounds);
//             // });
//           }

//           // Render fabric canvas and update texture
//           fabricCanvas.renderAll();
//           texture.needsUpdate = true;

//           return texture;
//         } catch (error) {
//           console.error("Error creating text texture:", error);

//           // Fallback canvas drawing
//           const fallbackCanvas = document.createElement("canvas");
//           fallbackCanvas.width = 1024;
//           fallbackCanvas.height = 512;
//           const ctx = fallbackCanvas.getContext("2d");

//           ctx.fillStyle = color || "white";
//           ctx.font = `80px ${font || "Arial"}`;
//           ctx.textAlign = "center";
//           ctx.textBaseline = "middle";
//           ctx.fillText(
//             textContent,
//             fallbackCanvas.width / 2,
//             fallbackCanvas.height / 2
//           );

//           return new THREE.CanvasTexture(fallbackCanvas);
//         }
//       },
//       [getFabricCanvas, fontSizetext]
//     );

//     const getNumberTexture = useCallback(
//       (type, textContent, color, font, isSelected) => {
//         if (!textContent || textContent.trim() === "") return null;

//         try {
//           const { canvas, fabricCanvas, texture } = getFabricCanvas(type);

//           fabricCanvas.clear();

//           const text = new fabric.Text(textContent, {
//             left: canvas.width / 2,
//             top: canvas.height / 2,
//             originX: "center",
//             originY: "center",
//             fontSize: fontSizeNumber || 80,
//             fontWeight: "bold",
//             fontFamily: font || "Arial",
//             fill: color || "black",
//             selectable: false,
//             hasControls: false,
//             hasBorders: false,
//             borderColor: "transparent",
//             cornerSize: 0,
//             transparentCorners: true,
//             lockUniScaling: false,
//             hoverCursor: "default",
//             moveCursor: "default",
//             objectCaching: false,
//             borderScaleFactor: 0,
//             controls: {
//               tr: new fabric.Control({
//                 x: 0.5,
//                 y: -0.5,
//                 actionHandler: fabric.controlsUtils.rotationWithSnapping,
//                 cursorStyleHandler: () => "crosshair",
//                 // render: function (ctx, left, top, styleOverride, fabricObject) {
//                 //   const size = 60;
//                 //   ctx.save();
//                 //   ctx.translate(left, top);
//                 //   ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
//                 //   ctx.beginPath();
//                 //   ctx.arc(0, 0, size / 2, 0, 2 * Math.PI);
//                 //   ctx.fillStyle = "white";
//                 //   ctx.fill();
//                 //   ctx.strokeStyle = "black";
//                 //   ctx.lineWidth = 3;
//                 //   ctx.stroke();

//                 //   ctx.beginPath();
//                 //   ctx.moveTo(size * 0.25, -size * 0.25);
//                 //   ctx.lineTo(size * 0.5, 0);
//                 //   ctx.lineTo(size * 0.25, size * 0.25);
//                 //   ctx.lineWidth = 7;
//                 //   ctx.stroke();

//                 //   ctx.beginPath();
//                 //   ctx.arc(
//                 //     0,
//                 //     0,
//                 //     size * 0.35,
//                 //     -Math.PI * 0.25,
//                 //     Math.PI * 1.5,
//                 //     false
//                 //   );
//                 //   ctx.lineWidth = 7;
//                 //   ctx.stroke();

//                 //   ctx.restore();
//                 // },
//                 actionName: "rotate",
//               }),
//               br: new fabric.Control({
//                 x: 0.5,
//                 y: 0.5,
//                 actionHandler: fabric.controlsUtils.scalingEqually,
//                 cursorStyleHandler: () => "nwse-resize",
//                 render: function (ctx, left, top, styleOverride, fabricObject) {
//                   const size = 60;
//                   ctx.save();
//                   ctx.translate(left, top);

//                   ctx.beginPath();
//                   ctx.rect(-size / 2, -size / 2, size, size);
//                   ctx.fillStyle = "white";
//                   ctx.fill();
//                   ctx.strokeStyle = "black";
//                   ctx.lineWidth = 3;
//                   ctx.stroke();

//                   ctx.beginPath();

//                   ctx.moveTo(-size * 0.35, -size * 0.35);
//                   ctx.lineTo(size * 0.35, size * 0.35);

//                   ctx.moveTo(size * 0.35, size * 0.35);
//                   ctx.lineTo(size * 0.2, size * 0.35);
//                   ctx.lineTo(size * 0.35, size * 0.2);
//                   ctx.closePath();

//                   ctx.fillStyle = "black";
//                   ctx.fill();
//                   ctx.strokeStyle = "black";
//                   ctx.lineWidth = 7;
//                   ctx.stroke();

//                   ctx.restore();
//                 },
//                 actionName: "scale",
//               }),
//             },
//           });

//           // Slight stroke to harden number edges
//           text.set({
//             stroke: color || "black",
//             strokeWidth: 1,
//             strokeUniform: true,
//           });

//           // Add to canvas
//           fabricCanvas.add(text);

//           if (isSelected) {
//             fabricCanvas.setActiveObject(text);
//             text.bringToFront();

//             // Rotation tracking
//             text.on("rotating", function (e) {
//               const angle = e.target.angle;
//               if (type.includes("front")) {
//                 frontNumberRotation[2] = THREE.MathUtils.degToRad(angle);
//               } else {
//                 backNumberRotation[2] = THREE.MathUtils.degToRad(angle);
//               }
//             });

//             // Scaling tracking
//             text.on("scaling", function (e) {
//               const scale = e.target.scaleX;
//               if (type.includes("front")) {
//                 frontNumberScale[0] = frontNumberScale[1] = scale;
//               } else {
//                 backNumberScale[0] = backNumberScale[1] = scale;
//               }
//             });

//             // Disabled arrow creation for new resize feature
//             // requestAnimationFrame(() => {
//             //   const textBounds = text.getBoundingRect();
//             //   calculateAndStoreArrowPosition(type, textBounds);
//             // });
//           }

//           fabricCanvas.renderAll();
//           texture.needsUpdate = true;

//           return texture;
//         } catch (error) {
//           console.error("Error creating number texture:", error);

//           // Fallback 2D canvas version
//           const fallbackCanvas = document.createElement("canvas");
//           fallbackCanvas.width = 1024;
//           fallbackCanvas.height = 512;
//           const ctx = fallbackCanvas.getContext("2d");

//           ctx.fillStyle = color || "white";
//           ctx.font = `80px ${font || "Arial"}`;
//           ctx.textAlign = "center";
//           ctx.textBaseline = "middle";
//           ctx.fillText(
//             textContent,
//             fallbackCanvas.width / 2,
//             fallbackCanvas.height / 2
//           );

//           return new THREE.CanvasTexture(fallbackCanvas);
//         }
//       },
//       [getFabricCanvas, fontSizeNumber]
//     );

//     // Maintain decal aspect ratio to prevent squishing when multiple overlays overlap
//     const getAspectAwareScale = useCallback((type, baseScale, texture) => {
//       const scaleArray = Array.isArray(baseScale)
//         ? baseScale
//         : [baseScale, baseScale, baseScale];
//       const base = scaleArray[0] || 1;

//       // Default aspect is square
//       let aspect = 1;

//       // Text and number canvases use 1024x512 => height/width = 0.5
//       if (type.includes("Text") || type.includes("Number")) {
//         aspect = 512 / 1024;
//       }

//       // Logos: use the actual texture dimensions when available
//       if (
//         type.includes("Logo") &&
//         texture &&
//         texture.image &&
//         texture.image.width &&
//         texture.image.height
//       ) {
//         aspect = texture.image.height / texture.image.width;
//       }

//       // Keep Z as original if provided
//       const z = scaleArray[2] !== undefined ? scaleArray[2] : base;
//       return [base, base * aspect, z];
//     }, []);

    

//     const [resizeMode, setResizeMode] = useState(false);
//     const [resizeStartPos, setResizeStartPos] = useState({ x: 0, y: 0 });
//     const [initialScale, setInitialScale] = useState(null);
//     const [resizeCorner, setResizeCorner] = useState(null);
//     const [resizeBorderVisible, setResizeBorderVisible] = useState(false);
//     const selectedDecalRef = useRef(null);
//     const [pendingResizeEvent, setPendingResizeEvent] = useState(null);

//     // NEW RESIZE FEATURE - Completely separate from existing functions
//     const [newResizeActive, setNewResizeActive] = useState(false);
//     const [newResizeStartPos, setNewResizeStartPos] = useState({ x: 0, y: 0 });
//     const [newResizeInitialScale, setNewResizeInitialScale] = useState(null);
//     const [newResizeSelectedDecal, setNewResizeSelectedDecal] = useState(null);
//     const [newResizeTempScale, setNewResizeTempScale] = useState([0, 0, 0]);
//     const [newResizeCorner, setNewResizeCorner] = useState(null);

//     // REPLACE your detectCornerClick function with this updated version:
//     const detectCornerClick = (e, decalType, camera) => {
//       console.log("Corner Detection start");
//       console.log(`selectedDecal: ${selectedDecal}, decalType: ${decalType}`);

//       if (!selectedDecal && !decalType) {
//         console.log("No selected decal or decal type");
//         return false;
//       }

//       const position = decalPositions[decalType];
//       const currentScale = decalScales[decalType];

//       if (!camera || !position || !currentScale) {
//         console.error("Camera, position, or scale missing");
//         return false;
//       }

//       console.log(`Position: ${position}, Scale: ${currentScale}`);

//       // Get model-specific configuration
//       const modelKey = state.newKey;
//       let modelConfig = modelConfig1[modelKey];

//       // SPECIAL HANDLING for eventordereventjersey - it has subcategories
//       if (modelKey === "eventordereventjersey" && state.selectedDesignId) {
//         modelConfig =
//           modelConfig1[modelKey][state.selectedDesignId] ||
//           modelConfig1[modelKey];
//         console.log(
//           `Using eventorder category: ${state.selectedDesignId}`,
//           modelConfig
//         );
//       }

//       console.log(`Model: ${modelKey}`, modelConfig);

//       // MODEL-SPECIFIC CORNER DETECTION CALCULATION
//       let threshold = 50;
//       let widthDivisor = 10;
//       let heightDivisor = 10;

//       if (modelConfig && currentScale) {
//         const overallScale = modelConfig.overallScale || 1;
//         const modelScale = Array.isArray(modelConfig.scale)
//           ? modelConfig.scale[0]
//           : modelConfig.scale || 1;
//         const currentScaleX = currentScale[0] || 1;
//         const currentScaleY = currentScale[1] || 1;

//         console.log(
//           `Model: ${modelKey}, DesignID: ${state.selectedDesignId}, Scale analysis:`,
//           {
//             overallScale,
//             modelScale,
//             currentScaleX,
//             currentScaleY,
//           }
//         );

//         if (modelKey === "menmenjersey") {
//           widthDivisor = 8;
//           heightDivisor = 8;
//           threshold = 60;
//         } else if (modelKey === "eventordereventjersey") {
//           const designId = state.selectedDesignId;
//           if (designId === "900" || designId === 900) {
//             widthDivisor = 3;
//             heightDivisor = 4;
//             threshold = 70;
//           } else if (designId === "901" || designId === 901) {
//             widthDivisor = 2.5;
//             heightDivisor = 3;
//             threshold = 80;
//           } else if (designId === "902" || designId === 902) {
//             widthDivisor = 8;
//             heightDivisor = 8;
//             threshold = 60;
//           } else if (designId === "903" || designId === 903) {
//             widthDivisor = 2;
//             heightDivisor = 2.5;
//             threshold = 75;
//           } else if (designId === "904" || designId === 904) {
//             widthDivisor = 3;
//             heightDivisor = 3.5;
//             threshold = 70;
//           } else {
//             widthDivisor = 3;
//             heightDivisor = 4;
//             threshold = 70;
//           }
//         } else if (modelKey === "womenwomenfootballjersey") {
//           widthDivisor = 6;
//           heightDivisor = 6;
//           threshold = 65;
//         } else if (
//           modelKey === "menmencricketshorts" ||
//           modelKey === "menmenshorts"
//         ) {
//           widthDivisor = 4;
//           heightDivisor = 5;
//           threshold = 70;
//         } else if (modelKey === "womenwomenbadmintonshorts") {
//           widthDivisor = 3.5;
//           heightDivisor = 4;
//           threshold = 65;
//         } else if (modelKey === "womenwomentrackpants") {
//           widthDivisor = 4;
//           heightDivisor = 5;
//           threshold = 60;
//         } else if (modelKey === "womenwomencyclingjersey") {
//           widthDivisor = 15;
//           heightDivisor = 15;
//           threshold = 45;
//         } else if (modelKey === "menmentanktop") {
//           widthDivisor = 3;
//           heightDivisor = 3.5;
//           threshold = 70;
//         } else if (modelKey === "menmencyclingjersey") {
//           widthDivisor = 2.5;
//           heightDivisor = 3;
//           threshold = 80;
//         } else if (modelKey === "menmentrackpants") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//           threshold = 65;
//         } else if (modelKey === "menmencricketjersey") {
//           widthDivisor = 8;
//           heightDivisor = 8;
//           threshold = 60;
//         } else if (modelKey === "menmenarmsleeves") {
//           widthDivisor = 2.5;
//           heightDivisor = 3;
//           threshold = 75;
//         } else if (modelKey === "menmenbasketballshorts") {
//           widthDivisor = 4.5;
//           heightDivisor = 5;
//           threshold = 65;
//         } else if (modelKey === "womenwomenbadmintonjersey") {
//           widthDivisor = 2;
//           heightDivisor = 2.5;
//           threshold = 75;
//         } else if (modelKey === "menmensoccerjersey") {
//           widthDivisor = 2;
//           heightDivisor = 2.5;
//           threshold = 80;
//         } else if (modelKey === "womenwomenjersey") {
//           widthDivisor = 3;
//           heightDivisor = 3.5;
//           threshold = 70;
//         } else if (modelKey === "menmenbasketballjersey") {
//           widthDivisor = 3;
//           heightDivisor = 3.5;
//           threshold = 70;
//         } else if (modelKey === "kidskidsbasketballjersey") {
//           widthDivisor = 3;
//           heightDivisor = 3.5;
//           threshold = 70;
//         } else if (modelKey === "menmencitycollection") {
//           widthDivisor = 2;
//           heightDivisor = 2.5;
//           threshold = 75;
//         } else if (modelKey === "menmenxjersey") {
//           widthDivisor = 2;
//           heightDivisor = 2.5;
//           threshold = 75;
//         } else if (modelKey === "kidskidscricketshorts") {
//           widthDivisor = 4.5;
//           heightDivisor = 5;
//           threshold = 65;
//         } else if (modelKey === "kidskidsshorts") {
//           widthDivisor = 4.5;
//           heightDivisor = 5;
//           threshold = 65;
//         } else if (modelKey === "menmenfootballjersey") {
//           widthDivisor = 2.5;
//           heightDivisor = 3;
//           threshold = 75;
//         } else if (modelKey === "womenwomencricketjersey") {
//           widthDivisor = 3.5;
//           heightDivisor = 4;
//           threshold = 65;
//         } else if (modelKey === "womenwomenbadmintontanktop") {
//           widthDivisor = 7;
//           heightDivisor = 7;
//           threshold = 55;
//         } else if (modelKey === "womenwomenxjersey") {
//           widthDivisor = 5;
//           heightDivisor = 5;
//           threshold = 60;
//         } else if (modelKey === "kidskidscricketjersey") {
//           widthDivisor = 3;
//           heightDivisor = 4;
//           threshold = 70;
//         } else if (modelKey === "kidskidscyclingjersey") {
//           widthDivisor = 4;
//           heightDivisor = 5;
//           threshold = 65;
//         } else if (modelKey === "kidskidsjersey") {
//           widthDivisor = 4;
//           heightDivisor = 5;
//           threshold = 65;
//         } else if (modelKey === "kidskidstanktop") {
//           widthDivisor = 3;
//           heightDivisor = 3.5;
//           threshold = 70;
//         } else if (modelKey === "kidskidsbasictshirt") {
//           widthDivisor = 4;
//           heightDivisor = 4.5;
//           threshold = 65;
//         } else if (modelKey === "womenwomencompressionpants") {
//           widthDivisor = 3.5;
//           heightDivisor = 4;
//           threshold = 65;
//         } else {
//           widthDivisor = 5;
//           heightDivisor = 6;
//           threshold = 60;
//         }

//         console.log(`Corner detection config:`, {
//           widthDivisor: widthDivisor.toFixed(2),
//           heightDivisor: heightDivisor.toFixed(2),
//           threshold: threshold.toFixed(2),
//         });
//       }

//       const getEventCoords = (event) => {
//         if (event.touches && event.touches.length > 0) {
//           return { x: event.touches[0].clientX, y: event.touches[0].clientY };
//         }
//         return { x: event.clientX, y: event.clientY };
//       };

//       const coords = getEventCoords(e);
//       const clickX = coords.x;
//       const clickY = coords.y;

//       console.log(`Click coordinates: [${clickX}, ${clickY}]`);

//       const center3D = new THREE.Vector3(...position);
//       console.log("3D Center Position: ", center3D);

//       let adjustedPosition = center3D.clone();

//       console.log("Adjusted 3D Position: ", adjustedPosition);

//       const projectedCenter = adjustedPosition.clone().project(camera);
//       console.log("Projected Center: ", projectedCenter);

//       // FIXED: Better validation for projected coordinates
//       if (
//         Math.abs(projectedCenter.x) > 3 ||
//         Math.abs(projectedCenter.y) > 3 ||
//         projectedCenter.z <= 0 ||
//         projectedCenter.z > 1
//       ) {
//         console.error("❌ Projected coordinates are invalid");
//         console.log(
//           `Raw projected: [${projectedCenter.x}, ${projectedCenter.y}, ${projectedCenter.z}]`
//         );
//         return false;
//       }

//       const screenCenterX = (projectedCenter.x * 0.5 + 0.5) * window.innerWidth;
//       const screenCenterY =
//         (1 - (projectedCenter.y * 0.5 + 0.5)) * window.innerHeight;

//       console.log(
//         `📺 Screen center: [${screenCenterX.toFixed(
//           2
//         )}, ${screenCenterY.toFixed(2)}]`
//       );

//       let normalizedScaleX = Math.min(currentScale[0] / 50, 1);
//       let normalizedScaleY = Math.min(currentScale[1] / 50, 1);

//       if (modelKey === "womenwomencyclingjersey") {
//         normalizedScaleX = Math.min(currentScale[0] / 80, 0.8);
//         normalizedScaleY = Math.min(currentScale[1] / 80, 0.8);
//       }

//       const screenHalfWidth =
//         (normalizedScaleX * window.innerWidth) / widthDivisor;
//       const screenHalfHeight =
//         (normalizedScaleY * window.innerHeight) / heightDivisor;

//       console.log(
//         `Screen half dimensions: W=${screenHalfWidth.toFixed(
//           2
//         )}, H=${screenHalfHeight.toFixed(2)}`
//       );

//       const maxDimension = Math.min(window.innerWidth, window.innerHeight) / 4;
//       const cappedWidth = Math.min(screenHalfWidth, maxDimension);
//       const cappedHeight = Math.min(screenHalfHeight, maxDimension);

//       if (
//         cappedWidth !== screenHalfWidth ||
//         cappedHeight !== screenHalfHeight
//       ) {
//         console.log(
//           `Dimensions capped: W=${screenHalfWidth.toFixed(
//             2
//           )}->${cappedWidth.toFixed(2)}, H=${screenHalfHeight.toFixed(
//             2
//           )}->${cappedHeight.toFixed(2)}`
//         );
//       }

//       console.log(
//         `Capped dimensions: W=${cappedWidth.toFixed(
//           2
//         )}, H=${cappedHeight.toFixed(2)}`
//       );

//       const corners = {
//         tl: {
//           x: screenCenterX - cappedWidth,
//           y: screenCenterY - cappedHeight,
//           type: "tl",
//         },
//         tr: {
//           x: screenCenterX + cappedWidth,
//           y: screenCenterY - cappedHeight,
//           type: "tr",
//         },
//         bl: {
//           x: screenCenterX - cappedWidth,
//           y: screenCenterY + cappedHeight,
//           type: "bl",
//         },
//         br: {
//           x: screenCenterX + cappedWidth,
//           y: screenCenterY + cappedHeight,
//           type: "br",
//         },
//       };

//       console.log(`Corners:`, corners);

//       let closestCorner = null;
//       let minDistance = Infinity;

//       for (let key in corners) {
//         const dx = clickX - corners[key].x;
//         const dy = clickY - corners[key].y;
//         const dist = Math.hypot(dx, dy);

//         console.log(
//           `📍 Corner ${key}: [${corners[key].x.toFixed(2)}, ${corners[
//             key
//           ].y.toFixed(2)}] distance=${dist.toFixed(2)}`
//         );

//         if (dist < minDistance) {
//           minDistance = dist;
//           closestCorner = corners[key];
//         }
//       }

//       console.log(
//         `Closest corner: ${
//           closestCorner?.type
//         }, distance: ${minDistance.toFixed(2)}, threshold: ${threshold}`
//       );

//       if (minDistance < threshold) {
//         console.log("Corner detected!");
//         setPendingResizeEvent(e);
//         return closestCorner.type;
//       }

//       console.log("No corner detected");
//       return false;
//     };

//     useEffect(() => {
//       const modelKey = state.newKey;
//       let modelConfig = modelConfig1[modelKey];

//       if (modelKey === "eventordereventjersey" && state.selectedDesignId) {
//         modelConfig = modelConfig1[modelKey][state.selectedDesignId];
//         console.log(
//           `Event Order Category: ${state.selectedDesignId}`,
//           modelConfig
//         );
//       }

//       console.log(`Active Model Config: ${modelKey}`, {
//         overallScale: modelConfig?.overallScale,
//         scale: modelConfig?.scale,
//         rotation: modelConfig?.rotation,
//       });
//     }, [state.newKey, state.selectedDesignId]);

//     const detectNewResizeCorner = (e, decalType, camera) => {
//       console.log("NEW Corner Detection start");
//       if (!newResizeSelectedDecal || newResizeSelectedDecal !== decalType)
//         return false;

//       const position = decalPositions[decalType];
//       const currentScale = decalScales[decalType];
//       console.log("position:", position, "currentScale:", currentScale);

//       if (!camera) {
//         console.error("Camera not found");
//         return false;
//       }

//       // Get model-specific configuration
//       const modelKey = state.newKey;
//       const modelConfig = modelConfig1[modelKey];

//       // Use a dynamic threshold based on model scale
//       let threshold = 40; // Base threshold for new resize
//       let widthDivisor = 8;
//       let heightDivisor = 8;

//       // Adjust threshold and divisors based on model's overall scale
//       if (modelConfig) {
//         const scaleFactor = modelConfig.overallScale || 1;
//         threshold = Math.max(25, Math.min(60, threshold * (10 / scaleFactor)));

//         // MODEL-SPECIFIC DIVISOR CALCULATION FOR NEW RESIZE
//         if (modelKey === "menmenjersey") {
//           widthDivisor = 12;
//           heightDivisor = 12;
//         } else if (modelKey === "eventordereventjersey") {
//           const designId = state.selectedDesignId;
//           if (designId === "900" || designId === 900) {
//             widthDivisor = 5;
//             heightDivisor = 6;
//           } else if (designId === "901" || designId === 901) {
//             widthDivisor = 4;
//             heightDivisor = 5;
//           } else if (designId === "902" || designId === 902) {
//             widthDivisor = 12;
//             heightDivisor = 12;
//           } else if (designId === "903" || designId === 903) {
//             widthDivisor = 3;
//             heightDivisor = 4;
//           } else if (designId === "904" || designId === 904) {
//             widthDivisor = 5;
//             heightDivisor = 6;
//           } else {
//             widthDivisor = 5;
//             heightDivisor = 6;
//           }
//         } else if (modelKey === "womenwomenfootballjersey") {
//           widthDivisor = 9;
//           heightDivisor = 9;
//         } else if (
//           modelKey === "menmencricketshorts" ||
//           modelKey === "menmenshorts"
//         ) {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "womenwomenbadmintonshorts") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else if (modelKey === "womenwomentrackpants") {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "womenwomencyclingjersey") {
//           widthDivisor = 20;
//           heightDivisor = 20;
//         } else if (modelKey === "menmentanktop") {
//           widthDivisor = 4;
//           heightDivisor = 5;
//         } else if (modelKey === "menmencyclingjersey") {
//           widthDivisor = 4;
//           heightDivisor = 5;
//         } else if (modelKey === "menmentrackpants") {
//           widthDivisor = 7;
//           heightDivisor = 8;
//         } else if (modelKey === "menmencricketjersey") {
//           widthDivisor = 12;
//           heightDivisor = 12;
//         } else if (modelKey === "menmenarmsleeves") {
//           widthDivisor = 4;
//           heightDivisor = 5;
//         } else if (modelKey === "menmenbasketballshorts") {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "womenwomenbadmintonjersey") {
//           widthDivisor = 3;
//           heightDivisor = 4;
//         } else if (modelKey === "menmensoccerjersey") {
//           widthDivisor = 3;
//           heightDivisor = 4;
//         } else if (modelKey === "womenwomenjersey") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else if (modelKey === "menmenbasketballjersey") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else if (modelKey === "kidskidsbasketballjersey") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else if (modelKey === "menmencitycollection") {
//           widthDivisor = 3;
//           heightDivisor = 4;
//         } else if (modelKey === "menmenxjersey") {
//           widthDivisor = 3;
//           heightDivisor = 4;
//         } else if (modelKey === "kidskidscricketshorts") {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "kidskidsshorts") {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "menmenfootballjersey") {
//           widthDivisor = 4;
//           heightDivisor = 5;
//         } else if (modelKey === "womenwomencricketjersey") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else if (modelKey === "womenwomenbadmintontanktop") {
//           widthDivisor = 10;
//           heightDivisor = 10;
//         } else if (modelKey === "womenwomenxjersey") {
//           widthDivisor = 7;
//           heightDivisor = 7;
//         } else if (modelKey === "kidskidscricketjersey") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else if (modelKey === "kidskidscyclingjersey") {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "kidskidsjersey") {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "kidskidstanktop") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else if (modelKey === "kidskidsbasictshirt") {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "womenwomencompressionpants") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else {
//           widthDivisor = 7;
//           heightDivisor = 8;
//         }

//         console.log(
//           `Model: ${modelKey}, Overall Scale: ${scaleFactor}, Threshold: ${threshold}, Divisors: W=${widthDivisor}, H=${heightDivisor}`
//         );
//       }

//       // Get coordinates from either mouse or touch event
//       const getEventCoords = (event) => {
//         if (event.touches && event.touches.length > 0) {
//           return { x: event.touches[0].clientX, y: event.touches[0].clientY };
//         }
//         return { x: event.clientX, y: event.clientY };
//       };

//       const coords = getEventCoords(e);
//       const clickX = coords.x;
//       const clickY = coords.y;
//       console.log(`Click coordinates: [${clickX}, ${clickY}]`);

//       // Get the 3D position and project to screen
//       const center3D = new THREE.Vector3(...position);
//       console.log("3D Center Position: ", center3D);

//       // FIXED: Apply position adjustment for womenwomencyclingjersey to fix extreme Y values
//       let adjustedPosition = center3D.clone();

//       // SPECIAL FIX for womenwomencyclingjersey - adjust problematic Y positions
//       if (modelKey === "womenwomencyclingjersey") {
//         console.log(`🔧 Applying cycling jersey position fix for ${decalType}`);

//         // Reduce the extreme Y values that are causing projection issues
//         if (
//           decalType.includes("frontText") ||
//           decalType.includes("frontNumber") ||
//           decalType.includes("backText") ||
//           decalType.includes("backNumber")
//         ) {
//           // Scale down the extreme Y values while maintaining relative positioning
//           adjustedPosition.y = adjustedPosition.y * 0.3; // Reduce Y by 70%
//           console.log(
//             `🔧 Adjusted Y position: ${center3D.y} -> ${adjustedPosition.y}`
//           );
//         }
//       }

//       // Project center to screen coordinates
//       const projectedCenter = adjustedPosition.clone().project(camera);

//       // FIXED: More lenient validation for projected coordinates
//       let projectedX = projectedCenter.x;
//       let projectedY = projectedCenter.y;

//       // Clamp projected coordinates to reasonable range if they're extreme
//       if (Math.abs(projectedX) > 10 || Math.abs(projectedY) > 10) {
//         console.log("🔄 Clamping extreme projected coordinates");
//         projectedX = Math.max(-5, Math.min(5, projectedX));
//         projectedY = Math.max(-5, Math.min(5, projectedY));
//       }

//       const screenCenterX = (projectedX * 0.5 + 0.5) * window.innerWidth;
//       const screenCenterY = (1 - (projectedY * 0.5 + 0.5)) * window.innerHeight;

//       console.log(
//         `Screen center: [${screenCenterX.toFixed(2)}, ${screenCenterY.toFixed(
//           2
//         )}]`
//       );

//       // FIXED: Improved scale calculation with better normalization
//       let normalizedScaleX = Math.min(currentScale[0] / 80, 0.7);
//       let normalizedScaleY = Math.min(currentScale[1] / 80, 0.7);

//       // Special adjustment for womenwomencyclingjersey to make corner area smaller
//       if (modelKey === "womenwomencyclingjersey") {
//         normalizedScaleX = Math.min(currentScale[0] / 120, 0.5);
//         normalizedScaleY = Math.min(currentScale[1] / 120, 0.5);
//       }

//       const screenHalfWidth =
//         (normalizedScaleX * window.innerWidth) / widthDivisor;
//       const screenHalfHeight =
//         (normalizedScaleY * window.innerHeight) / heightDivisor;

//       console.log(
//         `Screen half dimensions: W=${screenHalfWidth.toFixed(
//           2
//         )}, H=${screenHalfHeight.toFixed(2)}`
//       );

//       // Safety check: Cap dimensions to reasonable screen bounds
//       const maxDimension = Math.min(window.innerWidth, window.innerHeight) / 5;
//       const cappedWidth = Math.min(screenHalfWidth, maxDimension);
//       const cappedHeight = Math.min(screenHalfHeight, maxDimension);

//       if (
//         cappedWidth !== screenHalfWidth ||
//         cappedHeight !== screenHalfHeight
//       ) {
//         console.log(
//           `Dimensions capped: W=${screenHalfWidth.toFixed(
//             2
//           )}->${cappedWidth.toFixed(2)}, H=${screenHalfHeight.toFixed(
//             2
//           )}->${cappedHeight.toFixed(2)}`
//         );
//       }

//       // Define corners in screen space
//       const corners = {
//         tl: {
//           x: screenCenterX - cappedWidth,
//           y: screenCenterY - cappedHeight,
//           type: "tl",
//         },
//         tr: {
//           x: screenCenterX + cappedWidth,
//           y: screenCenterY - cappedHeight,
//           type: "tr",
//         },
//         bl: {
//           x: screenCenterX - cappedWidth,
//           y: screenCenterY + cappedHeight,
//           type: "bl",
//         },
//         br: {
//           x: screenCenterX + cappedWidth,
//           y: screenCenterY + cappedHeight,
//           type: "br",
//         },
//       };

//       console.log("Corners:", corners);

//       // Find closest corner
//       let closestCorner = null;
//       let minDistance = Infinity;

//       for (let key in corners) {
//         const dx = clickX - corners[key].x;
//         const dy = clickY - corners[key].y;
//         const dist = Math.hypot(dx, dy);

//         console.log(
//           `Corner ${key}: [${corners[key].x.toFixed(2)}, ${corners[
//             key
//           ].y.toFixed(2)}] distance=${dist.toFixed(2)}`
//         );

//         if (dist < minDistance) {
//           minDistance = dist;
//           closestCorner = corners[key];
//           console.log(
//             `New closest corner: ${key} with distance ${dist.toFixed(2)}`
//           );
//         }
//       }

//       console.log(
//         `NEW Closest corner distance: ${minDistance.toFixed(
//           2
//         )}, threshold: ${threshold}`
//       );

//       if (minDistance < threshold) {
//         console.log("✅ NEW Corner detected!");
//         return closestCorner.type;
//       }

//       console.log("❌ NEW No corner detected");
//       return false;
//     };

//     const handleNewResizeFunction = (e) => {
//       if (
//         !newResizeActive ||
//         !newResizeSelectedDecal ||
//         !newResizeInitialScale ||
//         !newResizeCorner
//       )
//         return;

//       const getEventCoords = (event) => {
//         if (event.touches && event.touches.length > 0) {
//           return { x: event.touches[0].clientX, y: event.touches[0].clientY };
//         }
//         return { x: event.clientX, y: event.clientY };
//       };

//       const modelKey = state.newKey;
//       const coords = getEventCoords(e);
//       let deltaX = coords.x - newResizeStartPos.x;
//       let deltaY = coords.y - newResizeStartPos.y;

//       if (modelKey === "womenwomenbadmintonjersey") {
//         deltaX = -deltaX;
//         deltaY = -deltaY;
//       }

//       if (
//         modelKey === "menmenjersey" ||
//         modelKey === "menmencricketjersey" ||
//         modelKey === "womenwomenfootballjersey" ||
//         modelKey === "womenwomenxjersey" ||
//         modelKey === "womenwomenbadmintontanktop" ||
//         (!modelKey === "eventordereventjersey" &&
//           (glbId === "900" || glbId === "904"))
//       ) {
//         const sensitivity = newResizeSelectedDecal.includes("Logo")
//           ? 0.005
//           : 0.003;
//         let newScale = [...newResizeInitialScale];

//         requestAnimationFrame(() => {
//           switch (newResizeCorner) {
//             case "tl":
//               newScale[0] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[0] - deltaX * sensitivity)
//               );
//               newScale[1] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[1] - deltaY * sensitivity)
//               );
//               break;
//             case "tr":
//               newScale[0] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[0] + deltaX * sensitivity)
//               );
//               newScale[1] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[1] - deltaY * sensitivity)
//               );
//               break;
//             case "bl":
//               newScale[0] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[0] - deltaX * sensitivity)
//               );
//               newScale[1] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[1] + deltaY * sensitivity)
//               );
//               break;
//             case "br":
//               newScale[0] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[0] + deltaX * sensitivity)
//               );
//               newScale[1] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[1] + deltaY * sensitivity)
//               );
//               break;
//             default:
//               break;
//           }

//           setNewResizeTempScale(newScale);
//           setDecalScales((prev) => ({
//             ...prev,
//             [newResizeSelectedDecal]: newScale,
//           }));

//           if (newResizeSelectedDecal.includes("front")) {
//             frontLogoScale[0] = newScale[0];
//             frontLogoScale[1] = newScale[1];
//           } else if (newResizeSelectedDecal.includes("back")) {
//             backLogoScale[0] = newScale[0];
//             backLogoScale[1] = newScale[1];
//           }
//         });
//       } else {
//         console.log(
//           "------------------------------------------------------------------"
//         );
//         const sensitivity = newResizeSelectedDecal.includes("Logo")
//           ? 0.005
//           : 0.003;
//         const diagonalDelta = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

//         let scaleFactor = 1;
//         switch (newResizeCorner) {
//           case "tl":
//             scaleFactor =
//               1 +
//               (deltaX < 0 && deltaY < 0 ? -diagonalDelta : diagonalDelta) *
//                 sensitivity;
//             break;
//           case "tr":
//             scaleFactor =
//               1 +
//               (deltaX > 0 && deltaY < 0 ? -diagonalDelta : diagonalDelta) *
//                 sensitivity;
//             break;
//           case "bl":
//             scaleFactor =
//               1 +
//               (deltaX < 0 && deltaY > 0 ? -diagonalDelta : diagonalDelta) *
//                 sensitivity;
//             break;
//           case "br":
//             scaleFactor =
//               1 +
//               (deltaX > 0 && deltaY > 0 ? diagonalDelta : -diagonalDelta) *
//                 sensitivity;
//             break;
//         }

//         const newScale = newResizeInitialScale.map((s) =>
//           Math.max(5, Math.min(300, s * scaleFactor))
//         );

//         requestAnimationFrame(() => {
//           setNewResizeTempScale(newScale);
//           setDecalScales((prev) => ({
//             ...prev,
//             [newResizeSelectedDecal]: newScale,
//           }));

//           if (newResizeSelectedDecal.includes("front")) {
//             frontLogoScale[0] = newScale[0];
//             frontLogoScale[1] = newScale[1];
//           } else if (newResizeSelectedDecal.includes("back")) {
//             backLogoScale[0] = newScale[0];
//             backLogoScale[1] = newScale[1];
//           }
//         });
//       }
//     };

//     // NEW RESIZE END FUNCTION
//     const endNewResize = () => {
//       console.log("Ending NEW resize function");

//       setNewResizeActive(false);
//       setNewResizeSelectedDecal(null);
//       setNewResizeInitialScale(null);
//       setNewResizeTempScale([0, 0, 0]);
//       setNewResizeCorner(null);
//       setInteractionMode("rotate-shirt");
//     };
//     useFrame(() => {
//       if (!group.current) return;

//       // Update which side is visible based on rotation (only when it changes)
//       const normalizedRotation =
//         ((group.current.rotation.y % (Math.PI * 2)) + Math.PI * 2) %
//         (Math.PI * 2);
//       const isFront =
//         normalizedRotation < Math.PI / 2 ||
//         normalizedRotation > (3 * Math.PI) / 2;

//       // Only update state if visibility changed to avoid unnecessary re-renders
//       if (isFront !== isFrontVisible) {
//         setIsFrontVisible(isFront);
//       }

//       // Don't rotate if a decal is selected or if not in rotate-shirt mode
//       if (selectedDecal || interactionMode !== "rotate-shirt") return;

//       const targetYRotation = snap.viewSide === "front" ? 0 : Math.PI;
//       group.current.rotation.y +=
//         (targetYRotation - group.current.rotation.y) * 0.1;
//     });
//     useEffect(() => {
//       if (resizeMode && selectedDecal && pendingResizeEvent) {
//         handleResizeMove(pendingResizeEvent);
//         setPendingResizeEvent(null);
//       }
//     }, [resizeMode, selectedDecal, pendingResizeEvent]);
//     useEffect(() => {
//       if (resizeMode && selectedDecal && pendingResizeEvent) {
//         handlePointerMove(pendingResizeEvent);
//         setPendingResizeEvent(null);
//       }
//     }, [resizeMode, selectedDecal, pendingResizeEvent]);

//     // NEW RESIZE FEATURE - Ensure full screen event capture
//     useEffect(() => {
//       if (interactionMode === "new-resize-mode") {
//         // Add global event listeners for better event capture
//         const handleGlobalPointerMove = (e) => {
//           if (newResizeActive) {
//             handleNewResizeFunction(e);
//           }
//         };

//         const handleGlobalPointerUp = (e) => {
//           if (newResizeActive) {
//             handlePointerUp(e);
//           }
//         };

//         document.addEventListener("pointermove", handleGlobalPointerMove);
//         document.addEventListener("pointerup", handleGlobalPointerUp);
//         document.addEventListener("mousemove", handleGlobalPointerMove);
//         document.addEventListener("mouseup", handleGlobalPointerUp);
//         document.addEventListener("touchmove", handleGlobalPointerMove);
//         document.addEventListener("touchend", handleGlobalPointerUp);

//         return () => {
//           document.removeEventListener("pointermove", handleGlobalPointerMove);
//           document.removeEventListener("pointerup", handleGlobalPointerUp);
//           document.removeEventListener("mousemove", handleGlobalPointerMove);
//           document.removeEventListener("mouseup", handleGlobalPointerUp);
//           document.removeEventListener("touchmove", handleGlobalPointerMove);
//           document.removeEventListener("touchend", handleGlobalPointerUp);
//         };
//       }
//     }, [interactionMode, newResizeActive]);

//     // ==========================================
//     // START DRAGGING DECAL
//     // ==========================================
//     const handleDecalDragStart = (e, decalType) => {
//       e.stopPropagation();

//       // Access native event for preventDefault
//       const nativeEvent = e.nativeEvent || e;
//       if (nativeEvent && typeof nativeEvent.preventDefault === "function") {
//         nativeEvent.preventDefault();
//       }

//       const getCoords = (event) => {
//         const evt = event.nativeEvent || event;
//         if (evt.touches && evt.touches.length > 0) {
//           return { x: evt.touches[0].clientX, y: evt.touches[0].clientY };
//         }
//         return { x: evt.clientX, y: evt.clientY };
//       };

//       const coords = getCoords(e);
//       const currentPos = decalPositions[decalType] || [0, 0, 0];

//       console.log("🚀 Drag start:", decalType, coords);

//       // Capture pointer to ensure we get all subsequent events
//       const target = e.target || (nativeEvent && nativeEvent.target);
//       const pointerId = e.pointerId || (nativeEvent && nativeEvent.pointerId);
//       if (target && pointerId !== undefined) {
//         try {
//           target.setPointerCapture(pointerId);
//         } catch (err) {
//           console.log("Pointer capture not available");
//         }
//       }

//       setSelectedDecal(decalType);
//       setIsDragging(true);
//       setInteractionMode("dragging");
//       setDragStartPos(coords);
//       setInitialDecalPos([...currentPos]);
//     };

//     const [isRotating, setIsRotating] = useState(false);
//     const [rotationStartAngle, setRotationStartAngle] = useState(0);
//     const [rotationCenter, setRotationCenter] = useState({ x: 0, y: 0 });

//     // Update cursor during rotation
//     useEffect(() => {
//       if (isRotating) {
//         document.body.style.cursor = "grabbing";
//       }
//       return () => {
//         if (isRotating) {
//           document.body.style.cursor = "auto";
//         }
//       };
//     }, [isRotating]);

//     // const handleDecalRotate = (e, decalType) => {
//     //   // Stop all event propagation FIRST to prevent background click
//     //   if (e?.stopPropagation) e.stopPropagation();
//     //   if (e?.nativeEvent?.stopPropagation) e.nativeEvent.stopPropagation();
//     //   if (e?.nativeEvent?.stopImmediatePropagation)
//     //     e.nativeEvent.stopImmediatePropagation();

//     //   // Prevent default behavior
//     //   const nativeEvent = e.nativeEvent || e;
//     //   if (nativeEvent && typeof nativeEvent.preventDefault === "function") {
//     //     nativeEvent.preventDefault();
//     //   }

//     //   // Record timestamp to prevent background click from deselecting
//     //   const now = Date.now();
//     //   lastOverlayClickTime.current = now;

//     //   const getCoords = (event) => {
//     //     const evt = event.nativeEvent || event;
//     //     if (evt.touches && evt.touches.length > 0) {
//     //       return { x: evt.touches[0].clientX, y: evt.touches[0].clientY };
//     //     }
//     //     return { x: evt.clientX, y: evt.clientY };
//     //   };

//     //   const coords = getCoords(e);

//     //   // Get the decal center position in screen coordinates
//     //   const decalPosition = decalPositions[decalType] || [0, 0, 0];
//     //   const modelKey = state.newKey;
//     //   let modelConfig = modelConfig1[modelKey];

//     //   if (modelKey === "eventordereventjersey" && glbId) {
//     //     modelConfig = modelConfig1[modelKey][glbId] || modelConfig1[modelKey];
//     //   }

//     //   const center3D = new THREE.Vector3(...decalPosition);
//     //   const centerScreen = center3D.clone().project(camera);
//     //   const centerX = (centerScreen.x * 0.5 + 0.5) * window.innerWidth;
//     //   const centerY = (-(centerScreen.y * 0.5) + 0.5) * window.innerHeight;

//     //   // Calculate initial angle from center to mouse
//     //   const initialAngle = Math.atan2(
//     //     coords.y - centerY,
//     //     coords.x - centerX
//     //   );

//     //   // Capture pointer
//     //   const target = e.target || (nativeEvent && nativeEvent.target);
//     //   const pointerId = e.pointerId || (nativeEvent && nativeEvent.pointerId);
//     //   if (target && pointerId !== undefined) {
//     //     try {
//     //       target.setPointerCapture(pointerId);
//     //     } catch (err) {
//     //       console.log("Pointer capture not available");
//     //     }
//     //   }

//     //   setSelectedDecal(decalType);
//     //   setIsRotating(true);
//     //   setInteractionMode("rotating");
//     //   setRotationStartAngle(initialAngle);
//     //   setRotationCenter({ x: centerX, y: centerY });
//     //   setInitialDecalRotation(decalRotations[decalType] || 0);
//     // };

//     // ==========================================
//     // START RESIZING DECAL (CORNER CLICKED)
//     // ==========================================

//     const handleDecalRotate = (e, decalType) => {
//       e.stopPropagation?.();
//       e.nativeEvent?.stopPropagation?.();
//       e.nativeEvent?.stopImmediatePropagation?.();
//       e.preventDefault?.();

//       lastOverlayClickTime.current = Date.now();

//       const getCoords = (event) => {
//         const evt = event.nativeEvent || event;
//         if (evt.touches?.length > 0) {
//           return { x: evt.touches[0].clientX, y: evt.touches[0].clientY };
//         }
//         return { x: evt.clientX, y: evt.clientY };
//       };

//       const startCoords = getCoords(e);

//       const decalPos = decalPositions[decalType] || [0, 0, 0];
//       const center3D = new THREE.Vector3(...decalPos);
//       const centerScreen = center3D.clone().project(camera);
//       const centerX = (centerScreen.x * 0.5 + 0.5) * window.innerWidth;
//       const centerY = (-centerScreen.y * 0.5 + 0.5) * window.innerHeight;

//       const startAngle = Math.atan2(
//         startCoords.y - centerY,
//         startCoords.x - centerX
//       );

//       const startRotation = decalRotations[decalType] || 0;

//       const handleMove = (moveEvent) => {
//         moveEvent.preventDefault();
//         moveEvent.stopPropagation();

//         const currentCoords = getCoords(moveEvent);

//         const currentAngle = Math.atan2(
//           currentCoords.y - centerY,
//           currentCoords.x - centerX
//         );

//         let angleDelta = currentAngle - startAngle;
//         angleDelta = -angleDelta;

//         const newRotation = startRotation + angleDelta;

//         setDecalRotations((prev) => ({
//           ...prev,
//           [decalType]: newRotation,
//         }));
//       };

//       const handleEnd = () => {
//         document.removeEventListener("mousemove", handleMove);
//         document.removeEventListener("mouseup", handleEnd);
//         document.removeEventListener("touchmove", handleMove);
//         document.removeEventListener("touchend", handleEnd);

//         setIsRotating(false);
//         setInteractionMode("idle");
//       };

//       // Set state
//       setSelectedDecal(decalType);
//       setIsRotating(true);
//       setInteractionMode("rotating");

//       // Add event listeners
//       document.addEventListener("mousemove", handleMove);
//       document.addEventListener("mouseup", handleEnd);
//       document.addEventListener("touchmove", handleMove, { passive: false });
//       document.addEventListener("touchend", handleEnd);
//     };
//     const handleCornerDragStart = (e, decalType, corner) => {
//       e.stopPropagation();

//       // Access native event for preventDefault
//       const nativeEvent = e.nativeEvent || e;
//       if (nativeEvent && typeof nativeEvent.preventDefault === "function") {
//         nativeEvent.preventDefault();
//       }

//       const getCoords = (event) => {
//         const evt = event.nativeEvent || event;
//         if (evt.touches && evt.touches.length > 0) {
//           return { x: evt.touches[0].clientX, y: evt.touches[0].clientY };
//         }
//         return { x: evt.clientX, y: evt.clientY };
//       };

//       const coords = getCoords(e);
//       const currentScale = decalScales[decalType] || [1, 1, 1];

//       // Capture pointer to ensure we get all subsequent events
//       const target = e.target || (nativeEvent && nativeEvent.target);
//       const pointerId = e.pointerId || (nativeEvent && nativeEvent.pointerId);
//       if (target && pointerId !== undefined) {
//         try {
//           target.setPointerCapture(pointerId);
//         } catch (err) {
//           console.log("Pointer capture not available");
//         }
//       }

//       setSelectedDecal(decalType);
//       setIsResizing(true);
//       setActiveCorner(corner);
//       setInteractionMode("resizing");
//       setDragStartPos(coords);
//       setInitialDecalScale(
//         Array.isArray(currentScale)
//           ? [...currentScale]
//           : [currentScale, currentScale, currentScale]
//       );
//     };

//     // ==========================================
//     // BOUNDARY CONSTRAINT HELPER FUNCTION
//     // ==========================================
//     const getBoundariesForModel = useCallback(() => {
//       const modelKey = state.newKey;

//       // Model-specific boundaries based on actual position ranges from modelConfig1
//       // Z-axis (bottom): increased by 20%, Y-axis: increased by 15% at bottom only (minY for front, maxY for back), top unchanged
//       const modelBoundaries = {
//         eventordereventjersey: {
//           900: {
//             frontText: {
//               minX: -8,
//               maxX: 8,
//               minY: -17.25,
//               maxY: -5,
//               minZ: -15,
//               maxZ: -4,
//             },
//             backText: {
//               minX: -8,
//               maxX: 8,
//               minY: 5,
//               maxY: 17.25,
//               minZ: -15,
//               maxZ: -4,
//             },
//             frontNumber: {
//               minX: -8,
//               maxX: 8,
//               minY: -17.25,
//               maxY: -5,
//               minZ: -5,
//               maxZ: 6,
//             },
//             backNumber: {
//               minX: -8,
//               maxX: 8,
//               minY: 5,
//               maxY: 17.25,
//               minZ: -5,
//               maxZ: 6,
//             },
//             frontLogo: {
//               minX: -2,
//               maxX: 10,
//               minY: -17.25,
//               maxY: -5,
//               minZ: 8,
//               maxZ: 21.6,
//             },
//             backLogo: {
//               minX: -10,
//               maxX: 2,
//               minY: 5,
//               maxY: 17.25,
//               minZ: 8,
//               maxZ: 21.6,
//             },
//           },
//           902: {
//             frontText: {
//               minX: -80,
//               maxX: 80,
//               minY: 68,
//               maxY: 180,
//               minZ: 80,
//               maxZ: 216,
//             },
//             backText: {
//               minX: -80,
//               maxX: 80,
//               minY: -180,
//               maxY: -68,
//               minZ: 80,
//               maxZ: 216,
//             },
//             frontNumber: {
//               minX: -80,
//               maxX: 80,
//               minY: 68,
//               maxY: 180,
//               minZ: -20,
//               maxZ: 96,
//             },
//             backNumber: {
//               minX: -80,
//               maxX: 80,
//               minY: -180,
//               maxY: -68,
//               minZ: -20,
//               maxZ: 96,
//             },
//             frontLogo: {
//               minX: 20,
//               maxX: 100,
//               minY: 51,
//               maxY: 140,
//               minZ: -180,
//               maxZ: -84,
//             },
//             backLogo: {
//               minX: -100,
//               maxX: -20,
//               minY: -180,
//               maxY: -68,
//               minZ: -180,
//               maxZ: -84,
//             },
//           },
//           903: {
//             frontText: {
//               minX: -0.08,
//               maxX: 0.08,
//               minY: 0.017,
//               maxY: 0.08,
//               minZ: 0.05,
//               maxZ: 0.18,
//             },
//             backText: {
//               minX: -0.08,
//               maxX: 0.08,
//               minY: 0.02,
//               maxY: 0.092,
//               minZ: -0.15,
//               maxZ: -0.04,
//             },
//             frontNumber: {
//               minX: -0.08,
//               maxX: 0.08,
//               minY: -0.115,
//               maxY: -0.02,
//               minZ: 0.05,
//               maxZ: 0.18,
//             },
//             backNumber: {
//               minX: -0.08,
//               maxX: 0.08,
//               minY: -0.1,
//               maxY: -0.017,
//               minZ: -0.15,
//               maxZ: -0.04,
//             },
//             frontLogo: {
//               minX: 0.02,
//               maxX: 0.08,
//               minY: 0.068,
//               maxY: 0.16,
//               minZ: 0.05,
//               maxZ: 0.18,
//             },
//             backLogo: {
//               minX: -0.08,
//               maxX: -0.02,
//               minY: 0.08,
//               maxY: 0.1955,
//               minZ: -0.12,
//               maxZ: -0.016,
//             },
//           },
//           904: {
//             frontText: {
//               minX: -80,
//               maxX: 80,
//               minY: 42.5,
//               maxY: 150,
//               minZ: -1250,
//               maxZ: -1010,
//             },
//             backText: {
//               minX: -80,
//               maxX: 80,
//               minY: -150,
//               maxY: -42.5,
//               minZ: -1250,
//               maxZ: -1010,
//             },
//             frontNumber: {
//               minX: -80,
//               maxX: 80,
//               minY: 42.5,
//               maxY: 150,
//               minZ: -1450,
//               maxZ: -1210,
//             },
//             backNumber: {
//               minX: -80,
//               maxX: 80,
//               minY: -150,
//               maxY: -42.5,
//               minZ: -1450,
//               maxZ: -1210,
//             },
//             frontLogo: {
//               minX: 20,
//               maxX: 100,
//               minY: 34,
//               maxY: 120,
//               minZ: -1550,
//               maxZ: -1310,
//             },
//             backLogo: {
//               minX: 20,
//               maxX: 100,
//               minY: -200,
//               maxY: -85,
//               minZ: -1550,
//               maxZ: -1310,
//             },
//           },
//         },
//         menmenjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         menmenxjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         menmenprotshirt: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         menmentanktop: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 18.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 18.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 18.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 18.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 18.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 18.8,
//           },
//         },
//         menmenarmsleeves: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//         },
//         menmensinglet: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//         },
//         menmencyclingjersey: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//         },
//         menmenwinterjersey: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//         },
//         menmenbasketballjersey: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//         },
//         womenwomencyclingjersey: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//         },
//         womenwomenwinterjersey: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//         },
//         menmenshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmencricketshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmencyclingshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmenrunningshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmenwovenshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmenknittedshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmenfootballshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmensoccershorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmenbasketballshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmennftfootballshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmencitycollection: {
//           frontText: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           backText: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           frontNumber: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           backNumber: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           frontLogo: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           backLogo: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//         },
//         menmencricketjersey: {
//           frontText: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -150,
//             maxZ: 200,
//           },
//           backText: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -150,
//             maxZ: 200,
//           },
//           frontNumber: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -150,
//             maxZ: 200,
//           },
//           backNumber: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -150,
//             maxZ: 200,
//           },
//           frontLogo: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -150,
//             maxZ: 200,
//           },
//           backLogo: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -150,
//             maxZ: 200,
//           },
//         },
//         womenwomencitycollection: {
//           frontText: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           backText: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           frontNumber: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           backNumber: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           frontLogo: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           backLogo: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//         },
//         menmentrackpants: {
//           frontText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           backText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           frontNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           frontLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//         },
//         menmencompressionpants: {
//           frontText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           backText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           frontNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           frontLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//         },
//         womenwomenbadmintonjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomencricketjersey: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           frontNumber: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           backNumber: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//         },
//         womenwomentrackpants: {
//           frontText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           backText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           frontNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           frontLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//         },
//         womenwomencrickettrackpants: {
//           frontText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           backText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           frontNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           frontLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//         },
//         womenwomenxjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.05,
//             maxY: 0.1725,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.05,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.15,
//             maxY: 0.0575,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.12,
//             maxX: 0.12,
//             minY: -0.115,
//             maxY: 0.2,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.12,
//             maxX: 0.12,
//             minY: -0.1,
//             maxY: 0.23,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomenjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.05,
//             maxY: 0.1725,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.05,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.15,
//             maxY: 0.0575,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.12,
//             maxX: 0.12,
//             minY: -0.115,
//             maxY: 0.2,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.12,
//             maxX: 0.12,
//             minY: -0.1,
//             maxY: 0.23,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomenprotshirt: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomenfootballjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomensoccerjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomencompressionpants: {
//           frontText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 45.8,
//           },
//           backText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 45.8,
//           },
//           frontNumber: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 45.8,
//           },
//           backNumber: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 45.8,
//           },
//           frontLogo: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 45.8,
//           },
//           backLogo: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 45.8,
//           },
//         },
//         womenwomenbadmintontanktop: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomensinglet: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomenarmsleeves: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomenbadmintonshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomencyclingshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomencricketshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomenwovenshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomentightshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomenfootballshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomensoccershorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomennftfootballshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomenbasketballshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomenknittedshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         kidskidsjersey: {
//           frontText: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backText: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//           frontNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backLogo: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//         },
//         kidskidstanktop: {
//           frontText: {
//             minX: -19,
//             maxX: 19,
//             minY: -10,
//             maxY: 10,
//             minZ: -20,
//             maxZ: 25,
//           },
//           backText: {
//             minX: -19,
//             maxX: 19,
//             minY: -10,
//             maxY: 10,
//             minZ: -20,
//             maxZ: 25,
//           },
//           frontNumber: {
//             minX: -19,
//             maxX: 19,
//             minY: -10,
//             maxY: 10,
//             minZ: -20,
//             maxZ: 25,
//           },
//           backNumber: {
//             minX: -19,
//             maxX: 19,
//             minY: -10,
//             maxY: 10,
//             minZ: -20,
//             maxZ: 25,
//           },
//           frontLogo: {
//             minX: -19,
//             maxX: 19,
//             minY: -10,
//             maxY: 10,
//             minZ: -20,
//             maxZ: 25,
//           },
//           backLogo: {
//             minX: -19,
//             maxX: 19,
//             minY: -10,
//             maxY: 10,
//             minZ: -20,
//             maxZ: 25,
//           },
//         },
//         kidskidscyclingjersey: {
//           frontText: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 5,
//             minZ: -8,
//             maxZ: 6,
//           },
//           backText: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
//           frontNumber: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           backNumber: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           frontLogo: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           backLogo: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
//         },
//         kidskidswinterjersey: {
//           frontText: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 5,
//             minZ: -8,
//             maxZ: 6,
//           },
//           backText: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
//           frontNumber: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           backNumber: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           frontLogo: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           backLogo: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
//         },
//         kidskidscitycollection: {
//           frontText: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 5,
//             minZ: -8,
//             maxZ: 6,
//           },
//           backText: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
//           frontNumber: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           backNumber: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           frontLogo: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           backLogo: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
//         },
//         kidskidscricketjersey: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -18,
//             maxY: 18,
//             minZ: -18,
//             maxZ: 18,
//           },
//           backText: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//           frontNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backLogo: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//         },
//         kidskidstrackpants: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//         },
//         kidskidsxjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         kidskidsprotshirt: {
//           frontText: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backText: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//           frontNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backLogo: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//         },
//         kidskidscompressionpants: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//         },
//         kidskidssinglet: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -23,
//             maxY: 25,
//             minZ: -18,
//             maxZ: 25.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -10,
//             maxX: 10,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         kidskidsarmsleeves: {
//           frontText: {
//             minX: -6,
//             maxX: 6,
//             minY: -23,
//             maxY: 25,
//             minZ: 30,
//             maxZ: 45.8,
//           },
//           backText: {
//             minX: -6,
//             maxX: 6,
//             minY: -23,
//             maxY: 25,
//             minZ: 30,
//             maxZ: 45.8,
//           },
//           frontNumber: {
//             minX: -6,
//             maxX: 6,
//             minY: -23,
//             maxY: 25,
//             minZ: 30,
//             maxZ: 45.8,
//           },
//           backNumber: {
//             minX: -6,
//             maxX: 6,
//             minY: -23,
//             maxY: 25,
//             minZ: 30,
//             maxZ: 45.8,
//           },
//           frontLogo: {
//             minX: -6,
//             maxX: 6,
//             minY: -23,
//             maxY: 25,
//             minZ: 30,
//             maxZ: 45.8,
//           },
//           backLogo: {
//             minX: -6,
//             maxX: 6,
//             minY: -23,
//             maxY: 25,
//             minZ: 30,
//             maxZ: 45.8,
//           },
//         },
//         kidskidsbasketballjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         kidskidsfootballjersey: {
//           frontText: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backText: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//           frontNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backLogo: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//         },
//         kidskidssoccerjersey: {
//           frontText: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backText: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//           frontNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backLogo: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//         },
//         kidskidsshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidscricketshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidscyclingshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidswintershorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidsrunningshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidswovenshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidsknittedshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidsbasketballshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidssoccershorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidsfootballshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidsnftfootballshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         default: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.05,
//             maxY: 0.1725,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.05,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.15,
//             maxY: 0.0575,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.12,
//             maxX: 0.12,
//             minY: -0.115,
//             maxY: 0.2,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.12,
//             maxX: 0.12,
//             minY: -0.1,
//             maxY: 0.23,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//       };

//       // Check if it's an event order with specific glbId
//       if (
//         modelKey === "eventordereventjersey" &&
//         glbId &&
//         modelBoundaries[modelKey][glbId]
//       ) {
//         return modelBoundaries[modelKey][glbId];
//       }

//       // Check if model has specific boundaries
//       if (modelBoundaries[modelKey]) {
//         return modelBoundaries[modelKey];
//       }

//       // Return default boundaries
//       return modelBoundaries.default;
//     }, [glbId]);

//     const applyBoundaryConstraints = useCallback(
//       (position, decalType) => {
//         const boundaries = getBoundariesForModel();
//         const boundary = boundaries[decalType];

//         if (!boundary) {
//           return position; // No boundary defined, return original position
//         }

//         const constrainedPosition = [...position];
//         constrainedPosition[0] = Math.max(
//           boundary.minX,
//           Math.min(boundary.maxX, position[0])
//         );
//         constrainedPosition[1] = Math.max(
//           boundary.minY,
//           Math.min(boundary.maxY, position[1])
//         );
//         constrainedPosition[2] = Math.max(
//           boundary.minZ,
//           Math.min(boundary.maxZ, position[2])
//         );

//         return constrainedPosition;
//       },
//       [getBoundariesForModel]
//     );

//     // HANDLE MOUSE/TOUCH MOVE - OPTIMIZED
//     // ==========================================
//     const rafRef = useRef(null);

//     const handleGlobalMove = useCallback(
//       (e) => {
//         if (interactionMode === "idle") return;

//         const getCoords = (event) => {
//           if (event.touches && event.touches.length > 0) {
//             return { x: event.touches[0].clientX, y: event.touches[0].clientY };
//           }
//           return { x: event.clientX, y: event.clientY };
//         };

//         const coords = getCoords(e);
//         const modelKey = state.newKey;

//         const allowedMovementModels = [
//           "menmenjersey",
//           "menmenxjersey",
//           "kidskidsxjersey",
//           "kidskidsbasketballjersey",
//           "womenwomenbadmintonjersey",
//           "womenwomenprotshirt",
//           "womenwomensinglet",
//           "womenwomenarmsleeves",
//           "womenwomenjersey",
//           "womenwomensoccerjersey",
//           "menmensoccerjersey",
//           "menmenprotshirt",
//           "menmenfootballjersey",
//           "menmencricketjersey",
//           "womenwomenfootballjersey",
//           "womenwomenxjersey",
//           "womenwomenbadmintontanktop",
//         ];

//         const isEventOrderSpecial =
//           modelKey === "eventordereventjersey" &&
//           (glbId === "900" || glbId === "904");

//         const useSpecialMovement =
//           allowedMovementModels.includes(modelKey) || isEventOrderSpecial;
//         const useFirstResizeMethod =
//           allowedMovementModels.includes(modelKey) || isEventOrderSpecial; // ⭐ FIXED: Use same condition

//         if (interactionMode === "dragging" && isDragging && selectedDecal) {
//           const deltaX = coords.x - dragStartPos.x;
//           const deltaY = coords.y - dragStartPos.y;

//           if (modelKey === "menmencricketjersey") {
//             const normalSensitivityX = 2.4;
//             const normalSensitivityZ = 2.8;
//             const isBackSide = selectedDecal.includes("back");
//             const finalDeltaX = isBackSide ? -deltaX : deltaX;
//             const newX = initialDecalPos[0] + finalDeltaX * normalSensitivityX;
//             const newZ = initialDecalPos[1] + deltaY * normalSensitivityZ;
//             let newPosition = [newX, initialDecalPos[1], newZ];

//             // Apply boundary constraints
//             newPosition = applyBoundaryConstraints(newPosition, selectedDecal);

//             console.log(
//               "Cricket Jersey Movement - Delta:",
//               deltaX,
//               deltaY,
//               "New Position:",
//               newPosition
//             );
//             setTempPosition(newPosition);
//             setDecalPositions((prev) => ({
//               ...prev,
//               [selectedDecal]: newPosition,
//             }));
//           } else if (useSpecialMovement) {
//             const sensitivity = 0.0015;
//             const isBackSide = selectedDecal.includes("back");
//             const newX =
//               initialDecalPos[0] +
//               (isBackSide ? -deltaX : deltaX) * sensitivity;
//             const newY = initialDecalPos[1] - deltaY * sensitivity;
//             let newPosition = [newX, newY, initialDecalPos[2]];

//             // Apply boundary constraints
//             newPosition = applyBoundaryConstraints(newPosition, selectedDecal);

//             setTempPosition(newPosition);
//             setDecalPositions((prev) => ({
//               ...prev,
//               [selectedDecal]: newPosition,
//             }));
//           } else if (
//             modelKey === "menmencitycollection" ||
//             modelKey === "womenwomencitycollection"
//           ) {
//             const normalSensitivityX = 1.4;
//             const normalSensitivityZ = 1.8;
//             const isBackSide = selectedDecal.includes("back");
//             const finalDeltaX = isBackSide ? -deltaX : deltaX;
//             const newX = initialDecalPos[0] + finalDeltaX * normalSensitivityX;
//             const newZ = initialDecalPos[2] + deltaY * normalSensitivityZ;
//             let newPosition = [newX, initialDecalPos[1], newZ];

//             // Apply boundary constraints
//             newPosition = applyBoundaryConstraints(newPosition, selectedDecal);

//             setTempPosition(newPosition);
//             setDecalPositions((prev) => ({
//               ...prev,
//               [selectedDecal]: newPosition,
//             }));
//           } else {
//             const normalSensitivityX = 0.09;
//             const normalSensitivityZ = 0.2;
//             const isBackSide = selectedDecal.includes("back");
//             const finalDeltaX = isBackSide ? -deltaX : deltaX;
//             const newX = initialDecalPos[0] + finalDeltaX * normalSensitivityX;
//             const newZ = initialDecalPos[2] - deltaY * normalSensitivityZ;
//             let newPosition = [newX, initialDecalPos[1], newZ];

//             // Apply boundary constraints
//             newPosition = applyBoundaryConstraints(newPosition, selectedDecal);

//             setTempPosition(newPosition);
//             setDecalPositions((prev) => ({
//               ...prev,
//               [selectedDecal]: newPosition,
//             }));
//           }
//         }

//         if (
//           interactionMode === "resizing" &&
//           isResizing &&
//           selectedDecal &&
//           activeCorner
//         ) {
//           requestAnimationFrame(() => {
//             const deltaX = coords.x - dragStartPos.x;
//             const deltaY = coords.y - dragStartPos.y;
//             let adjustedDeltaX = deltaX;
//             let adjustedDeltaY = deltaY;

//             const sensitivity = selectedDecal.includes("Logo") ? 0.005 : 0.003;

//             let newScale;

//             if (modelKey === "menmencricketjersey") {
//               const cricketSensitivity = selectedDecal.includes("Logo") ? 5 : 4;
//               newScale = [...initialDecalScale];

//               switch (activeCorner) {
//                 case "tl":
//                   newScale[0] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[0] - adjustedDeltaX * cricketSensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[1] - adjustedDeltaY * cricketSensitivity
//                     )
//                   );
//                   break;
//                 case "tr":
//                   newScale[0] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[0] + adjustedDeltaX * cricketSensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[1] - adjustedDeltaY * cricketSensitivity
//                     )
//                   );
//                   break;
//                 case "bl":
//                   newScale[0] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[0] - adjustedDeltaX * cricketSensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[1] + adjustedDeltaY * cricketSensitivity
//                     )
//                   );
//                   break;
//                 case "br":
//                   newScale[0] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[0] + adjustedDeltaX * cricketSensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[1] + adjustedDeltaY * cricketSensitivity
//                     )
//                   );
//                   break;
//                 default:
//                   newScale = initialDecalScale;
//                   break;
//               }
//               console.log("Cricket Jersey Resize - New Scale:", newScale);
//             } else if (useFirstResizeMethod) {
//               // ⭐ NOW THIS USES THE SAME MODELS LIST
//               newScale = [...initialDecalScale];
//               switch (activeCorner) {
//                 case "tl":
//                   newScale[0] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[0] - adjustedDeltaX * sensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[1] - adjustedDeltaY * sensitivity
//                     )
//                   );
//                   break;
//                 case "tr":
//                   newScale[0] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[0] + adjustedDeltaX * sensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[1] - adjustedDeltaY * sensitivity
//                     )
//                   );
//                   break;
//                 case "bl":
//                   newScale[0] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[0] - adjustedDeltaX * sensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[1] + adjustedDeltaY * sensitivity
//                     )
//                   );
//                   break;
//                 case "br":
//                   newScale[0] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[0] + adjustedDeltaX * sensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[1] + adjustedDeltaY * sensitivity
//                     )
//                   );
//                   break;
//                 default:
//                   newScale = initialDecalScale;
//                   break;
//               }
//             } else if (
//               modelKey === "menmencitycollection" ||
//               modelKey === "womenwomencitycollection"
//             ) {
//               const diagonalDelta = Math.sqrt(
//                 adjustedDeltaX * adjustedDeltaX +
//                   adjustedDeltaY * adjustedDeltaY
//               );

//               // Double the sensitivity for faster scaling
//               const fasterSensitivity = sensitivity * 3;

//               let scaleFactor = 1;
//               switch (activeCorner) {
//                 case "tl":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX < 0 && adjustedDeltaY < 0
//                       ? -diagonalDelta
//                       : diagonalDelta) *
//                       fasterSensitivity;
//                   break;
//                 case "tr":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX > 0 && adjustedDeltaY < 0
//                       ? -diagonalDelta
//                       : diagonalDelta) *
//                       fasterSensitivity;
//                   break;
//                 case "bl":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX < 0 && adjustedDeltaY > 0
//                       ? -diagonalDelta
//                       : diagonalDelta) *
//                       fasterSensitivity;
//                   break;
//                 case "br":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX > 0 && adjustedDeltaY > 0
//                       ? diagonalDelta
//                       : -diagonalDelta) *
//                       fasterSensitivity;
//                   break;
//               }
//               newScale = initialDecalScale.map((s) =>
//                 Math.max(265, Math.min(1200, s * scaleFactor))
//               );
//             } else {
//               const diagonalDelta = Math.sqrt(
//                 adjustedDeltaX * adjustedDeltaX +
//                   adjustedDeltaY * adjustedDeltaY
//               );
//               let scaleFactor = 1;
//               switch (activeCorner) {
//                 case "tl":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX < 0 && adjustedDeltaY < 0
//                       ? -diagonalDelta
//                       : diagonalDelta) *
//                       sensitivity;
//                   break;
//                 case "tr":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX > 0 && adjustedDeltaY < 0
//                       ? -diagonalDelta
//                       : diagonalDelta) *
//                       sensitivity;
//                   break;
//                 case "bl":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX < 0 && adjustedDeltaY > 0
//                       ? -diagonalDelta
//                       : diagonalDelta) *
//                       sensitivity;
//                   break;
//                 case "br":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX > 0 && adjustedDeltaY > 0
//                       ? diagonalDelta
//                       : -diagonalDelta) *
//                       sensitivity;
//                   break;
//               }
//               newScale = initialDecalScale.map((s) =>
//                 Math.max(5, Math.min(300, s * scaleFactor))
//               );
//             }

//             setTempScale(newScale);
//             setDecalScales((prev) => ({
//               ...prev,
//               [selectedDecal]: newScale,
//             }));

//             if (selectedDecal.includes("front")) {
//               frontLogoScale[0] = newScale[0];
//               frontLogoScale[1] = newScale[1];
//             } else if (selectedDecal.includes("back")) {
//               backLogoScale[0] = newScale[0];
//               backLogoScale[1] = newScale[1];
//             }
//           });
//         }
//       },
//       [
//         interactionMode,
//         isDragging,
//         isResizing,
//         selectedDecal,
//         activeCorner,
//         dragStartPos,
//         initialDecalPos,
//         initialDecalScale,
//         state.newKey,
//         glbId,
//       ]
//     );

//     // ==========================================
//     // HANDLE MOUSE/TOUCH UP
//     // ==========================================
//     const handleGlobalUp = () => {
//       // Clean up dragging state
//       if (isDragging) {
//         setIsDragging(false);
//       }

//       // Clean up resizing state
//       if (isResizing) {
//         setIsResizing(false);
//         setActiveCorner(null);
//       }

//       // Reset interaction mode
//       setInteractionMode("idle");
//     };

//     // ==========================================
//     // ATTACH GLOBAL EVENT LISTENERS
//     // ==========================================
//     useEffect(() => {
//       if (interactionMode === "dragging" || interactionMode === "resizing") {
//         const handleMove = (e) => {
//           e.preventDefault();
//           handleGlobalMove(e);
//         };

//         const handleUp = (e) => {
//           handleGlobalUp(e);
//         };

//         document.addEventListener("mousemove", handleMove);
//         document.addEventListener("mouseup", handleUp);
//         document.addEventListener("touchmove", handleMove, { passive: false });
//         document.addEventListener("touchend", handleUp);

//         return () => {
//           document.removeEventListener("mousemove", handleMove);
//           document.removeEventListener("mouseup", handleUp);
//           document.removeEventListener("touchmove", handleMove);
//           document.removeEventListener("touchend", handleUp);
//         };
//       }
//     }, [
//       interactionMode,
//       isDragging,
//       isResizing,
//       selectedDecal,
//       dragStartPos,
//       initialDecalPos,
//       initialDecalScale,
//       activeCorner,
//     ]);

//     const handleResizeMove = (e) => {
//       if (!resizeMode || !selectedDecal || !initialScale) return;

//       // Get coordinates from either mouse or touch event
//       const getEventCoords = (event) => {
//         if (event.touches && event.touches.length > 0) {
//           return { x: event.touches[0].clientX, y: event.touches[0].clientY };
//         }
//         return { x: event.clientX, y: event.clientY };
//       };

//       const coords = getEventCoords(e);
//       const deltaX = coords.x - resizeStartPos.x;
//       const deltaY = coords.y - resizeStartPos.y;

//       // Calculate scale change based on diagonal movement for corner resize
//       const delta =
//         Math.sqrt(deltaX * deltaX + deltaY * deltaY) *
//         (deltaX + deltaY > 0 ? 1 : -1);
//       const scaleFactor = 1 + delta * 0.003;

//       const newScale = [
//         Math.max(0.1, Math.min(3, initialScale[0] * scaleFactor)),
//         Math.max(0.1, Math.min(3, initialScale[1] * scaleFactor)),
//         initialScale[2],
//       ];

//       setDecalScales((prev) => ({
//         ...prev,
//         [selectedDecal]: newScale,
//       }));

//       setTempScale(newScale);
//     };

//     const handleResizeUp = () => {
//       if (resizeMode && selectedDecal && tempScale) {
//         // Save the final scale
//         setDecalScales((prev) => ({
//           ...prev,
//           [selectedDecal]: tempScale,
//         }));
//       }

//       setResizeMode(false);
//       setResizeCorner(null);
//       setInitialScale(null);
//       setTempScale([0, 0, 0]);
//       setInteractionMode("rotate-shirt");
//       setSelectedDecal(null);
//     };

//     // Mobile detection helper function
//     const isMobileDevice = () => {
//       return (
//         window.innerWidth <= 768 ||
//         /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
//           navigator.userAgent
//         )
//       );
//     };

//     const handlePointerMove = (e) => {
//       // Prevent default touch behavior to avoid page scrolling during drag
//       if (e.type === "touchmove") {
//         e.preventDefault();
//       }

//       // Only block pointer move when TransformControls is actively being used
//       if (interactionMode === "transform-controls") {
//         return;
//       }

//       // Better detection for active dragging
//       const isMouseDown = e.buttons === 1;
//       const isTouchMove =
//         e.type === "touchmove" && e.touches && e.touches.length > 0;
//       const isPointerMove = e.type === "pointermove" && e.pressure > 0;

//       if (!isMouseDown && !isTouchMove && !isPointerMove) return;

//       const getEventCoords = (event) => {
//         // Touch events
//         if (event.touches && event.touches.length > 0) {
//           return { x: event.touches[0].clientX, y: event.touches[0].clientY };
//         }
//         // Pointer events (including touch on some devices)
//         if (event.clientX !== undefined && event.clientY !== undefined) {
//           return { x: event.clientX, y: event.clientY };
//         }
//         return { x: 0, y: 0 };
//       };

//       const coords = getEventCoords(e);

//       // NEW RESIZE FEATURE - Handle new resize mode
//       if (interactionMode === "new-resize-mode") {
//         handleNewResizeFunction(e);
//         return;
//       }

//       if (interactionMode === "resize-decal") {
//         handleResizeMove(e);
//         return;
//       }

//       // Handle rotation mode
//       if (interactionMode === "rotating" && isRotating && selectedDecal) {
//         const currentAngle = Math.atan2(
//           coords.y - rotationCenter.y,
//           coords.x - rotationCenter.x
//         );

//         // Calculate rotation delta
//         const angleDelta = currentAngle - rotationStartAngle;

//         // Apply rotation (adding the delta to initial rotation)
//         let newRotation = initialDecalRotation + angleDelta;

//         // Normalize to 0-2π range
//         while (newRotation < 0) newRotation += Math.PI * 2;
//         while (newRotation >= Math.PI * 2) newRotation -= Math.PI * 2;

//         setDecalRotations((prev) => ({
//           ...prev,
//           [selectedDecal]: newRotation,
//         }));
//         return;
//       }

//       if (interactionMode === "move-decal" && selectedDecal) {
//         // Get model-specific movement sensitivity
//         const modelKey = state.newKey;
//         let modelConfig = modelConfig1[modelKey];

//         // SPECIAL HANDLING for eventordereventjersey
//         if (modelKey === "eventordereventjersey" && glbId) {
//           modelConfig = modelConfig1[modelKey][glbId] || modelConfig1[modelKey];
//         }

//         // Base sensitivity values
//         let sensitivityX = selectedDecal.includes("Logo") ? 0.001 : 0.0008;
//         let sensitivityY = selectedDecal.includes("Logo") ? 0.001 : 0.0008;

//         // INCREASED sensitivity for touch devices (mobile)
//         if (e.type === "touchmove" || e.pointerType === "touch") {
//           sensitivityX *= 2.5; // Increased from 1.5 to 2.5
//           sensitivityY *= 2.5;
//         }

//         // Additional mobile-specific boost for better responsiveness
//         if (isMobileDevice()) {
//           sensitivityX *= 1.5;
//           sensitivityY *= 1.5;
//         }

//         if (modelConfig) {
//           const scale = modelConfig.scale;
//           const overallScale = modelConfig.overallScale || 1;
//           const scaleFactor = Array.isArray(scale) ? scale[0] || 1 : scale || 1;

//           let adjustedFactor = 1;

//           if (
//             modelKey === "menmenjersey" ||
//             (modelKey === "eventordereventjersey" && glbId === "902")
//           ) {
//             adjustedFactor = Math.min(
//               3,
//               Math.max(0.5, scaleFactor / overallScale)
//             );
//           } else if (
//             modelKey === "eventordereventjersey" &&
//             (glbId === "900" || glbId === "904")
//           ) {
//             if (scaleFactor < 0.01) {
//               adjustedFactor = Math.min(20, Math.max(5, 1 / scaleFactor));
//             } else if (scaleFactor < 1) {
//               adjustedFactor = Math.min(10, Math.max(2, 1 / scaleFactor));
//             } else {
//               adjustedFactor = Math.min(
//                 5,
//                 Math.max(0.2, scaleFactor / overallScale)
//               );
//             }
//           } else if (modelKey === "womenwomenfootballjersey") {
//             adjustedFactor = Math.min(
//               3,
//               Math.max(0.5, scaleFactor / overallScale)
//             );
//           } else if (
//             modelKey === "menmenxjersey" ||
//             (modelKey === "eventordereventjersey" && glbId === "903")
//           ) {
//             adjustedFactor = Math.min(
//               3,
//               Math.max(0.5, scaleFactor / overallScale)
//             );
//           } else if (modelKey === "womenwomenbadmintontanktop") {
//             adjustedFactor = Math.min(
//               4,
//               Math.max(0.8, scaleFactor / overallScale)
//             );
//           } else if (scaleFactor < 0.01) {
//             adjustedFactor = Math.min(15, Math.max(3, 1 / scaleFactor));
//           } else if (scaleFactor < 0.1) {
//             adjustedFactor = Math.min(10, Math.max(2, 1 / scaleFactor));
//           } else {
//             adjustedFactor = Math.min(
//               5,
//               Math.max(0.2, scaleFactor / overallScale)
//             );
//           }

//           sensitivityX *= adjustedFactor;
//           sensitivityY *= adjustedFactor;
//         }

//         let deltaX = (coords.x - mouseStartPos.x) * sensitivityX;
//         let deltaY = -(coords.y - mouseStartPos.y) * sensitivityY;

//         let maxDelta = 0.1;
//         if (
//           modelKey === "eventordereventjersey" &&
//           (glbId === "900" || glbId === "902" || glbId === "904")
//         ) {
//           maxDelta = 0.5;
//         } else if (
//           modelKey === "menmenjersey" ||
//           modelKey === "womenwomenfootballjersey" ||
//           modelKey === "menmenxjersey"
//         ) {
//           maxDelta = 0.2;
//         } else if (modelKey === "womenwomenbadmintontanktop") {
//           maxDelta = 0.15;
//         }

//         deltaX = Math.max(-maxDelta, Math.min(maxDelta, deltaX));
//         deltaY = Math.max(-maxDelta, Math.min(maxDelta, deltaY));

//         const isBackSide = ["backText", "backNumber", "backLogo"].includes(
//           selectedDecal
//         );
//         if (isBackSide) {
//           deltaX *= -1;
//         }

//         let positionArray;
//         switch (selectedDecal) {
//           case "frontText":
//             positionArray = frontTextPosition;
//             break;
//           case "backText":
//             positionArray = backTextPosition;
//             break;
//           case "frontNumber":
//             positionArray = frontNumberPosition;
//             break;
//           case "backNumber":
//             positionArray = backNumberPosition;
//             break;
//           case "frontLogo":
//             positionArray = frontLogoPosition;
//             break;
//           case "backLogo":
//             positionArray = backLogoPosition;
//             break;
//           default:
//             return;
//         }

//         const modelRotation = modelConfig?.rotation || [0, 0, 0];

//         if (Math.abs(modelRotation[0]) > 1) {
//           positionArray[0] += deltaX;
//           positionArray[2] += deltaY;
//         } else {
//           positionArray[0] += deltaX;
//           positionArray[1] += deltaY;
//         }

//         // Apply boundary constraints using shared helper function
//         const constrainedPosition = applyBoundaryConstraints(
//           [...positionArray],
//           selectedDecal
//         );
//         positionArray[0] = constrainedPosition[0];
//         positionArray[1] = constrainedPosition[1];
//         positionArray[2] = constrainedPosition[2];

//         setTempPosition([...positionArray]);
//         setMouseStartPos(coords);
//         setWasMoved(true); // Track that movement occurred
//       }
//     };
//     const [wasMoved, setWasMoved] = useState(false);

//     const handlePointerUp = () => {
//       if (interactionMode === "transform-controls") {
//         // Don't deselect - keep the decal selected for transform controls
//         setInteractionMode("rotate-shirt");
//         setIsTransforming(false);
//         return;
//       }

//       if (interactionMode === "new-resize-mode") {
//         endNewResize();
//         return;
//       }

//       if (resizeMode && selectedDecal) {
//         setResizeMode(false);
//         setResizeCorner(null);
//         setInitialScale(null);
//         setInteractionMode("rotate-shirt");
//         // Keep decal selected after resize
//         return;
//       }

//       // Handle rotation end
//       if (interactionMode === "rotating" && isRotating && selectedDecal) {
//         setIsRotating(false);
//         setInteractionMode("idle");
//         // Keep decal selected after rotation
//         return;
//       }

//       if (interactionMode === "move-decal" && selectedDecal) {
//         setDecalPositions((prev) => ({
//           ...prev,
//           [selectedDecal]: tempPosition,
//         }));

//         setInteractionMode("rotate-shirt");
//         setWasMoved(false);
//         // Keep decal selected after move (don't deselect)
//       }
//     };

//     const renderResizeArrow = () => {
//       return null;
//     };

//     const getTransformTarget = useCallback(
//       (type, position, rotation, scale) => {
//         const existing = transformTargetsRef.current[type];
//         const target = existing || new THREE.Object3D();

//         target.position.set(position[0], position[1], position[2]);
//         target.rotation.set(rotation[0], rotation[1], rotation[2]);

//         const targetScale = Array.isArray(scale)
//           ? scale
//           : [scale || 1, scale || 1, scale || 1];

//         target.scale.set(
//           targetScale[0] || 1,
//           targetScale[1] || 1,
//           targetScale[2] || 1
//         );

//         transformTargetsRef.current[type] = target;
//         return target;
//       },
//       []
//     );
//     const mobileScaleFactor = isMobile ? 0.75 : 1.0;
//     const mobilePositionOffset = isMobile ? [0, 0.06, 0] : [0, 0, 0];

//     const renderDecal = (
//       type,
//       defaultTexture,
//       defaultPosition,
//       rotation,
//       defaultScale
//     ) => {
//       console.log(`🔍 renderDecal called for ${type}`);
//       console.log(`   productData:`, productData);
//       console.log(`   ${type} value:`, productData?.[type]);
//       console.log(`   should display:`, !!productData?.[type]);
//       const isSelected = selectedDecal === type;
//       const isTextDecal = type.toLowerCase().includes("text");
//       const isNumberDecal = type.toLowerCase().includes("number");

//       // Check if currently dragging this specific decal
//       const isCurrentlyDragging =
//         isSelected && interactionMode === "dragging" && isDragging;

//       // Fix: Use tempPosition when selected and dragging for smooth real-time updates
//       let position =
//         isCurrentlyDragging && tempPosition && tempPosition.length === 3
//           ? tempPosition
//           : decalPositions[type] || defaultPosition;

//       let scale;
//       // Check if currently resizing this specific decal
//       const isCurrentlyResizing =
//         isSelected && interactionMode === "resizing" && isResizing;

//       if (
//         isCurrentlyResizing &&
//         tempScale &&
//         tempScale.length === 3 &&
//         tempScale[0] !== 0
//       ) {
//         // Use tempScale for real-time resize feedback for all decal types including text
//         scale = tempScale;
//       } else if (isTextDecal || isNumberDecal) {
//         scale = decalScales[type] || defaultScale;
//       } else if (
//         interactionMode === "new-resize-mode" &&
//         newResizeSelectedDecal === type &&
//         newResizeTempScale &&
//         newResizeTempScale.length === 3 &&
//         newResizeTempScale[0] !== 0
//       ) {
//         scale = newResizeTempScale;
//       } else if (
//         isSelected &&
//         resizeMode &&
//         tempScale &&
//         tempScale.length === 3 &&
//         tempScale[0] !== 0
//       ) {
//         scale = tempScale;
//       } else {
//         scale = decalScales[type] || defaultScale;
//       }

//       let shouldDisplay = false;
//       let texture = null;

//       // Use productData instead of snap!
//       if (type.includes("Text")) {
//         const textValue = productData?.[type] || ""; // e.g., productData.frontText
//         shouldDisplay = !!textValue && textValue.trim() !== "";

//         if (shouldDisplay) {
//           texture = getTextTexture(
//             type,
//             textValue,
//             // Use productData.textColors instead of snap.textColors
//             productData?.textColors?.[
//               type.includes("front") ? "front" : "back"
//             ] || "#ffffff",
//             // Use productData.textFonts instead of state.textFonts
//             productData?.textFonts?.[
//               type.includes("front") ? "front" : "back"
//             ] ||
//               productData?.selectedFonts ||
//               "Arial",
//             isSelected
//           );
//         }
//       } else if (type.includes("Number")) {
//         const numberValue = productData?.[type] || ""; // e.g., productData.frontNumber
//         shouldDisplay = !!numberValue && numberValue.trim() !== "";

//         if (shouldDisplay) {
//           texture = getNumberTexture(
//             type,
//             numberValue,
//             // Use productData.numberColors instead of snap.numberColors
//             productData?.numberColors?.[
//               type.includes("front") ? "front" : "back"
//             ] || "#ffffff",
//             // Use productData.numberFonts instead of state.numberFonts
//             productData?.numberFonts?.[
//               type.includes("front") ? "front" : "back"
//             ] ||
//               productData?.selectedFonts ||
//               "Arial",
//             isSelected
//           );
//         }
//       } else if (type.includes("Logo")) {
//         const logoTex = type === "frontLogo" ? logoTexture : logoTextureBack;
//         shouldDisplay = !!logoTex;
//         texture = logoTex;
//       }

//       if (!shouldDisplay || !texture) return null;

//       // CRITICAL FIX: Show selection UI for ALL models, not just menmenjersey
//       const shouldShowDots = isSelected;

//       let adjustedScale = getAspectAwareScale(type, scale, texture);

//       // Get model-specific configuration
//       const modelKey = state.newKey;
//       const modelConfig = getModelSettings(menuSlug, subcategorySlug);

//       let selectionScaleMultiplier = 1;
//       let frameWidthMultiplier = 1;
//       let frameHeightMultiplier = 1;
//       let cornerSizeMultiplier = 1;
//       let showFullBorder = false;

//       if (modelKey === "menmenjersey") {
//         selectionScaleMultiplier = 1;
//         frameWidthMultiplier = 1;
//         frameHeightMultiplier = 1;
//         showFullBorder = true;
//       } else if (
//         modelKey === "menmentrackpants" ||
//         modelKey === "womenwomentrackpants"
//       ) {
//         selectionScaleMultiplier = 20;
//         frameWidthMultiplier = 0.8;
//         frameHeightMultiplier = 0.8;
//       } else if (
//         modelKey === "kidskidscricketshorts" ||
//         modelKey === "kidskidsshorts" ||
//         modelKey === "kidskidscyclingshorts" ||
//         modelKey === "kidskidswintershorts" ||
//         modelKey === "kidskidsrunningshorts" ||
//         modelKey === "kidskidswovenshorts" ||
//         modelKey === "kidskidsknittedshorts" ||
//         modelKey === "kidskidsbasketballshorts" ||
//         modelKey === "kidskidssoccershorts" ||
//         modelKey === "kidskidsfootballshorts" ||
//         modelKey === "kidskidsnftfootballshorts"
//       ) {
//         selectionScaleMultiplier = 1;
//         frameWidthMultiplier = 1;
//         frameHeightMultiplier = 1;
//         showFullBorder = true;
//       } else if (modelKey.includes("shorts")) {
//         selectionScaleMultiplier = 1;
//         frameWidthMultiplier = 1;
//         frameHeightMultiplier = 1;
//         showFullBorder = true;
//       } else if (
//         modelKey === "menmentanktop" ||
//         modelKey === "menmenarmsleeves" ||
//         modelKey === "menmensinglet"
//       ) {
//         selectionScaleMultiplier = 1; // Fixed from 20 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (
//         modelKey === "menmencyclingjersey" ||
//         modelKey === "menmenwinterjersey" ||
//         modelKey === "menmenbasketballjersey" ||
//         modelKey === "womenwomencyclingjersey" ||
//         modelKey === "womenwomenwinterjersey"
//       ) {
//         selectionScaleMultiplier = 1; // Fixed from 20 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (
//         modelKey === "menmencitycollection" ||
//         modelKey === "womenwomencitycollection"
//       ) {
//         selectionScaleMultiplier = 1; // Fixed from 150 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (modelKey === "womenwomencricketjersey") {
//         selectionScaleMultiplier = 1; // Fixed from 15 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (
//         modelKey === "kidskidsjersey" ||
//         modelKey === "kidskidsprotshirt" ||
//         modelKey === "kidskidsfootballjersey" ||
//         modelKey === "kidskidssoccerjersey"
//       ) {
//         selectionScaleMultiplier = 1; // Fixed from 3 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (
//         modelKey === "kidskidstanktop" ||
//         modelKey === "kidskidssinglet"
//       ) {
//         selectionScaleMultiplier = 1; // Fixed from 15 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (
//         modelKey === "kidskidscyclingjersey" ||
//         modelKey === "kidskidswinterjersey" ||
//         modelKey === "kidskidscitycollection"
//       ) {
//         selectionScaleMultiplier = 1; // Fixed from 5 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (modelKey === "kidskidscricketjersey") {
//         selectionScaleMultiplier = 1; // Fixed from 15 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (modelKey === "kidskidsxjersey") {
//         selectionScaleMultiplier = 1; // Fixed from 0.2 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (modelKey === "kidskidsarmsleeves") {
//         selectionScaleMultiplier = 1; // Fixed from 5 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (
//         modelKey === "menmencompressionpants" ||
//         modelKey === "womenwomencompressionpants" ||
//         modelKey === "kidskidstrackpants" ||
//         modelKey === "kidskidscompressionpants"
//       ) {
//         selectionScaleMultiplier = 20;
//         frameWidthMultiplier = 0.8;
//         frameHeightMultiplier = 0.8;
//         showFullBorder = true;
//       } else {
//         selectionScaleMultiplier = 1;
//         frameWidthMultiplier = 1;
//         frameHeightMultiplier = 1;
//         showFullBorder = true;
//       }

//       let baseSelectionWidth, baseSelectionHeight;
//       if (modelKey === "menmenjersey") {
//         const minSelectionSize = 0.05;
//         const maxSelectionSize = 1.5;

//         baseSelectionWidth = Math.min(
//           Math.max(adjustedScale?.[0] || 0.2, minSelectionSize),
//           maxSelectionSize
//         );

//         baseSelectionHeight = Math.min(
//           Math.max(adjustedScale?.[1] || 0.2, minSelectionSize),
//           maxSelectionSize
//         );
//       } else {
//         // For all other models - use simplified logic without clamping
//         baseSelectionWidth = (adjustedScale?.[0] || 0.2) * frameWidthMultiplier;
//         baseSelectionHeight =
//           (adjustedScale?.[1] || 0.2) * frameHeightMultiplier;
//       }

//       console.log("Base Selection Width:", baseSelectionWidth);
//       console.log("Base Selection Height:", baseSelectionHeight);

//       // Tighter selection for text to fit closer to actual text bounds
//       // Tighter selection for text to fit closer to actual text bounds
//       let selectionTightness;

//       if (
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenxjersey" ||
//         modelKey === "menmenprotshirt" ||
//         modelKey === "menmenfootballjersey" ||
//         modelKey === "menmensoccerjersey"
//       ) {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.73
//           : type.includes("Text")
//           ? 0.58
//           : 0.48;
//       } else if (
//         modelKey === "menmencyclingjersey" ||
//         modelKey === "menmenwinterjersey"
//       ) {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.5
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "menmencitycollection" ||
//         modelKey === "menmencricketjersey"
//       ) {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.3
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "menmentrackpants" ||
//         modelKey === "menmenshorts" ||
//         modelKey === "menmencricketshorts" ||
//         modelKey === "menmencyclingshorts" ||
//         modelKey === "menmenrunningshorts" ||
//         modelKey === "menmenwovenshorts" ||
//         modelKey === "menmenknittedshorts" ||
//         modelKey === "menmenfootballshorts" ||
//         modelKey === "menmensoccershorts" ||
//         modelKey === "menmenbasketballshorts" ||
//         modelKey === "menmennftfootballshorts"
//       ) {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.3
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (modelKey === "menmenarmsleeves") {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.5
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (modelKey === "menmenbasketballjersey") {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.5
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (modelKey === "menmencompressionpants") {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.15
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "womenwomenbadmintonjersey" ||
//         modelKey === "womenwomenprotshirt" ||
//         modelKey === "womenwomenfootballjersey" ||
//         modelKey === "womenwomensoccerjersey"
//       ) {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.12
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (modelKey === "womenwomencricketjersey") {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.12
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "womenwomencyclingjersey" ||
//         modelKey === "womenwomenwinterjersey"
//       ) {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.5
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "womenwomenxjersey" ||
//         modelKey === "womenwomenjersey"
//       ) {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.12
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "womenwomenbadmintonshorts" ||
//         modelKey === "womenwomencyclingshorts" ||
//         modelKey === "womenwomencricketshorts" ||
//         modelKey === "womenwomenwovenshorts" ||
//         modelKey === "womenwomentightshorts" ||
//         modelKey === "womenwomenfootballshorts" ||
//         modelKey === "womenwomensoccershorts" ||
//         modelKey === "womenwomennftfootballshorts" ||
//         modelKey === "womenwomenbasketballshorts" ||
//         modelKey === "womenwomenknittedshorts"
//       ) {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.2
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "womenwomencompressionpants" ||
//         modelKey === "womenwomentrackpants" ||
//         modelKey === "womenwomencrickettrackpants"
//       ) {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.2
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "kidskidsjersey" ||
//         modelKey === "kidskidstanktop" ||
//         modelKey === "kidskidsprotshirt" ||
//         modelKey === "kidskidsfootballjersey" ||
//         modelKey === "kidskidssoccerjersey"
//       ) {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.15
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "kidskidscricketjersey" ||
//         modelKey === "kidskidsxjersey" ||
//         modelKey === "kidskidssinglet" ||
//         modelKey === "kidskidsarmsleeves"
//       ) {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.12
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (modelKey === "kidskidsbasketballjersey") {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.45
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "kidskidsshorts" ||
//         modelKey === "kidskidscricketshorts" ||
//         modelKey === "kidskidscyclingshorts" ||
//         modelKey === "kidskidswintershorts" ||
//         modelKey === "kidskidsrunningshorts" ||
//         modelKey === "kidskidswovenshorts" ||
//         modelKey === "kidskidsknittedshorts" ||
//         modelKey === "kidskidsbasketballshorts" ||
//         modelKey === "kidskidssoccershorts" ||
//         modelKey === "kidskidsfootballshorts" ||
//         modelKey === "kidskidsnftfootballshorts"
//       ) {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.4
//           : type.includes("Text")
//           ? 0.38
//           : 0.48;
//       } else if (
//         modelKey === "kidskidstrackpants" ||
//         modelKey === "kidskidscompressionpants"
//       ) {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.5
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.2
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       }

//       const frameWidth = baseSelectionWidth * selectionTightness;
//       const frameHeight = baseSelectionHeight * selectionTightness;

//       console.log("Frame Width:", frameWidth);
//       console.log("Frame Height:", frameHeight);

//       const layerOrder = type.includes("Number")
//         ? 2
//         : type.includes("Text")
//         ? 1
//         : 0;
//       const polygonOffsetFactor = -1 - layerOrder;
//       const additionalRotation = decalRotations[type] || 0;
//       const finalRotation = [
//         rotation[0],
//         rotation[1],
//         rotation[2] + additionalRotation,
//       ];

//       if (type.includes("Text")) {
//         console.log(
//           `📝 Rendering ${type}: baseRot=${(
//             (rotation[2] * 180) /
//             Math.PI
//           ).toFixed(1)}°, addRot=${(
//             (additionalRotation * 180) /
//             Math.PI
//           ).toFixed(1)}°, finalRot=${(
//             (finalRotation[2] * 180) /
//             Math.PI
//           ).toFixed(1)}°`
//         );
//       }

//       return (
//         <>
//           <Decal
//             key={`${type}-decal-${(additionalRotation * 10000).toFixed(0)}`}
//             mesh={shirtRef.current}
//             position={position}
//             rotation={finalRotation}
//             scale={adjustedScale}
//             map={texture}
//             transparent={true}
//             alphaTest={0.1}
//             depthTest={true}
//             depthWrite={false}
//             polygonOffset={true}
//             polygonOffsetFactor={polygonOffsetFactor}
//             alphaToCoverage={true}
//             renderOrder={
//               type.includes("Number")
//                 ? 1002
//                 : type.includes("Text")
//                 ? 1001
//                 : type.includes("back")
//                 ? 1003
//                 : 1000
//             }
//             //  debug
//           />

//           {/* Invisible clickable area for text selection */}
//           {!isSelected && (
//             <group position={position} rotation={finalRotation}>
//               <mesh
//                 position={[0, 0, 0.1]}
//                 onClick={(e) => {
//                   lastOverlayClickTime.current = Date.now();

//                   if (e?.stopPropagation) e.stopPropagation();
//                   if (e?.nativeEvent?.stopImmediatePropagation)
//                     e.nativeEvent.stopImmediatePropagation();
//                   if (e?.nativeEvent?.stopPropagation)
//                     e.nativeEvent.stopPropagation();

//                   console.log(
//                     `🎯 Selecting ${type} decal (isBack: ${type.includes(
//                       "back"
//                     )})`
//                   );
//                   setSelectedDecal(type);
//                   setInteractionMode("idle");
//                 }}
//                 onPointerDown={(e) => {
//                   lastOverlayClickTime.current = Date.now();
//                   if (e?.stopPropagation) e.stopPropagation();
//                   if (e?.nativeEvent?.stopImmediatePropagation)
//                     e.nativeEvent.stopImmediatePropagation();
//                   if (e?.nativeEvent?.stopPropagation)
//                     e.nativeEvent.stopPropagation();

//                   console.log(
//                     `🎯 Pointer down on ${type} decal (isBack: ${type.includes(
//                       "back"
//                     )})`
//                   );
//                   setSelectedDecal(type);
//                   setInteractionMode("idle");
//                 }}
//               >
//                 <planeGeometry args={[frameWidth * 1.1, frameHeight * 1.1]} />
//                 <meshBasicMaterial
//                   transparent
//                   opacity={0}
//                   side={THREE.DoubleSide}
//                   depthTest={false}
//                   depthWrite={false}
//                 />
//               </mesh>
//             </group>
//           )}

//           {/* Mobile-only invisible drag area overlay for easier touch interaction */}
//           {shouldShowDots && isMobileDevice() && (
//             <group position={position} rotation={finalRotation}>
//               <mesh
//                 position={[0, 0, 0.003]}
//                 scale={[2.5, 2.5, 1]}
//                 onPointerDown={(e) => {
//                   e.stopPropagation();
//                   handleDecalDragStart(e, type);
//                 }}
//               >
//                 <planeGeometry args={[adjustedScale[0], adjustedScale[1]]} />
//                 <meshBasicMaterial transparent opacity={0} depthTest={false} />
//               </mesh>
//             </group>
//           )}

//           {/* Selection outline and corner handles for ALL decal types */}
//           {shouldShowDots && (
//             <group position={position} rotation={finalRotation}>
//               {(() => {
//                 const outlineWidth = frameWidth * 1.05;
//                 const outlineHeight = frameHeight * 1.05;

//                 // Dynamic corner size based on model
//                 const cornerSize = Math.max(
//                   Math.min(frameWidth, frameHeight) *
//                     0.07 *
//                     cornerSizeMultiplier,
//                   0.01
//                 );
//                 let lineThickness;
//                 // Dynamic line thickness based on frame size and model
//                 if (modelKey === "menmenjersey") {
//                   const baseLineThickness =
//                     Math.min(frameWidth, frameHeight) * 0.001;
//                   lineThickness = Math.max(baseLineThickness, 0.001);
//                 } else {
//                   const baseLineThickness =
//                     Math.min(frameWidth, frameHeight) * 0.008;
//                   lineThickness = Math.max(baseLineThickness, 0.002);
//                 }
//                 const hw = frameWidth / 2;
//                 const hh = frameHeight / 2;
//                 const depth = 0.002;

//                 // Define corners
//                 const topLeft = [-hw, hh, depth];
//                 const topRight = [hw, hh, depth];
//                 const bottomLeft = [-hw, -hh, depth];
//                 const bottomRight = [hw, -hh, depth];

//                 return (
//                   <>
//                     <mesh
//                       position={[0, 0, depth - 0.001]}
//                       rotation={[0, 0, 0]}
//                       onPointerDown={(e) => {
//                         if (e?.stopPropagation) e.stopPropagation();
//                         console.log(`🎯 DRAG STARTED for ${type}`);
//                         handleDecalDragStart(e, type);
//                       }}
//                       onPointerOver={(e) => {
//                         if (e?.stopPropagation) e.stopPropagation();
//                         document.body.style.cursor = "move";
//                       }}
//                       onPointerOut={(e) => {
//                         if (e?.stopPropagation) e.stopPropagation();
//                         document.body.style.cursor = "auto";
//                       }}
//                     >
//                       <planeGeometry args={[frameWidth, frameHeight]} />
//                       <meshBasicMaterial
//                         transparent
//                         opacity={0}
//                         depthTest={false}
//                         depthWrite={false}
//                       />
//                     </mesh>

//                     {showFullBorder && (
//                       <group>
//                         <mesh position={[0, hh, depth]}>
//                           <planeGeometry args={[frameWidth, lineThickness]} />
//                           <meshBasicMaterial
//                             color="#ffffff"
//                             transparent
//                             opacity={1}
//                             depthTest={false}
//                             depthWrite={false}
//                           />
//                         </mesh>

//                         <mesh position={[hw, 0, depth]}>
//                           <planeGeometry args={[lineThickness, frameHeight]} />
//                           <meshBasicMaterial
//                             color="#ffffff"
//                             transparent
//                             opacity={1}
//                             depthTest={false}
//                             depthWrite={false}
//                           />
//                         </mesh>

//                         <mesh position={[0, -hh, depth]}>
//                           <planeGeometry args={[frameWidth, lineThickness]} />
//                           <meshBasicMaterial
//                             color="#ffffff"
//                             transparent
//                             opacity={1}
//                             depthTest={false}
//                             depthWrite={false}
//                           />
//                         </mesh>

//                         <mesh position={[-hw, 0, depth]}>
//                           <planeGeometry args={[lineThickness, frameHeight]} />
//                           <meshBasicMaterial
//                             color="#ffffff"
//                             transparent
//                             opacity={1}
//                             depthTest={false}
//                             depthWrite={false}
//                           />
//                         </mesh>
//                       </group>
//                     )}
//                   </>
//                 );
//               })()}

//               {/* Professional corner handles with black outline - SHOWN FOR ALL MODELS */}
//               {["tl", "tr", "bl", "br"].map((corner) => {
//                 const sx = frameWidth / 2;
//                 const sy = frameHeight / 2;
//                 const offset =
//                   corner === "tl"
//                     ? [-sx, sy, 0.003]
//                     : corner === "tr"
//                     ? [sx, sy, 0.003]
//                     : corner === "bl"
//                     ? [-sx, -sy, 0.003]
//                     : [sx, -sy, 0.003];
//                 const cursor =
//                   corner === "tl" || corner === "br"
//                     ? "nwse-resize"
//                     : "nesw-resize";
//                 let cornerSize;
//                 if (modelKey === "menmenjersey") {
//                   cornerSize = Math.max(
//                     Math.min(frameWidth, frameHeight) *
//                       0.035 *
//                       cornerSizeMultiplier,
//                     0.004
//                   );
//                 } else {
//                   cornerSize = Math.max(
//                     Math.min(frameWidth, frameHeight) *
//                       0.055 *
//                       cornerSizeMultiplier,
//                     0.008
//                   );
//                 }

//                 return (
//                   <group key={corner} position={offset}>
//                     {/* Outer white border circle */}
//                     <mesh renderOrder={10000}>
//                       <circleGeometry args={[cornerSize * 1.3, 16]} />
//                       <meshBasicMaterial
//                         color="#ffffffff"
//                         transparent
//                         opacity={0.9}
//                         depthTest={false}
//                         depthWrite={false}
//                       />
//                     </mesh>

//                     {/* Inner gray circle */}
//                     <mesh
//                       position={[0, 0, 0.0001]}
//                       renderOrder={10001}
//                       onPointerDown={(e) => {
//                         if (e?.stopPropagation) e.stopPropagation();
//                         console.log(`📏 RESIZE CORNER ${corner} for ${type}`);
//                         handleCornerDragStart(e, type, corner);
//                         document.body.style.cursor = cursor;
//                       }}
//                       onPointerOver={(e) => {
//                         if (e?.stopPropagation) e.stopPropagation();
//                         document.body.style.cursor = cursor;
//                       }}
//                       onPointerOut={(e) => {
//                         if (e?.stopPropagation) e.stopPropagation();
//                         document.body.style.cursor = "auto";
//                       }}
//                     >
//                       <circleGeometry args={[cornerSize, 16]} />
//                       <meshBasicMaterial
//                         color="#c9c2c2ff"
//                         depthTest={false}
//                         depthWrite={false}
//                       />
//                     </mesh>

//                     {/* Larger hit area for easier clicking */}
//                     <mesh
//                       position={[0, 0, 0.0002]}
//                       onPointerDown={(e) => {
//                         if (e?.stopPropagation) e.stopPropagation();
//                         console.log(`📏 RESIZE HIT AREA ${corner} for ${type}`);
//                         handleCornerDragStart(e, type, corner);
//                         document.body.style.cursor = cursor;
//                       }}
//                       onPointerOver={(e) => {
//                         if (e?.stopPropagation) e.stopPropagation();
//                         document.body.style.cursor = cursor;
//                       }}
//                       onPointerOut={(e) => {
//                         e.stopPropagation();
//                         document.body.style.cursor = "auto";
//                       }}
//                     >
//                       <circleGeometry args={[cornerSize * 2, 16]} />
//                       <meshBasicMaterial
//                         transparent
//                         opacity={0}
//                         depthTest={false}
//                       />
//                     </mesh>
//                   </group>
//                 );
//               })}

//               {/* Rotation handles at corners - positioned outside resize points */}
//               {["tl", "tr", "bl", "br"].map((corner) => {
//                 const sx = frameWidth / 2;
//                 const sy = frameHeight / 2;
//                 const cornerSize = Math.max(
//                   Math.min(frameWidth, frameHeight) *
//                     0.055 *
//                     cornerSizeMultiplier,
//                   0.008
//                 );

//                 // Position rotation handle outside the corner with more flexible distance
//                 const offsetDistance = cornerSize * 2.8; // Reduced distance for easier access
//                 const baseOffset =
//                   corner === "tl"
//                     ? [-sx, sy, 0.003]
//                     : corner === "tr"
//                     ? [sx, sy, 0.003]
//                     : corner === "bl"
//                     ? [-sx, -sy, 0.003]
//                     : [sx, -sy, 0.003];

//                 // Add offset to position rotation handle diagonally outside the corner
//                 const rotationHandleOffset = [
//                   baseOffset[0] +
//                     (corner.includes("l") ? -offsetDistance : offsetDistance),
//                   baseOffset[1] +
//                     (corner.includes("t") ? offsetDistance : -offsetDistance),
//                   baseOffset[2] + 0.001,
//                 ];

//                 return (
//                   <group
//                     key={`rotate-${corner}`}
//                     position={rotationHandleOffset}
//                   >
//                     {/* Outer white circle background */}
//                     <mesh renderOrder={10000}>
//                       <circleGeometry args={[cornerSize * 1.3, 16]} />
//                       <meshBasicMaterial
//                         color="#ffffff"
//                         transparent
//                         opacity={0.95}
//                         depthTest={false}
//                         depthWrite={false}
//                       />
//                     </mesh>

//                     {/* Blue rotation ring */}
//                     <mesh position={[0, 0, 0.0001]} renderOrder={10001}>
//                       <ringGeometry
//                         args={[cornerSize * 0.5, cornerSize * 0.9, 16]}
//                       />
//                       <meshBasicMaterial
//                         color="#4A90E2"
//                         transparent
//                         opacity={0.9}
//                         depthTest={false}
//                         depthWrite={false}
//                       />
//                     </mesh>

//                     {/* Rotation arrow indicator */}
//                     <group
//                       position={[0, cornerSize * 0.7, 0.0002]}
//                       renderOrder={10002}
//                     >
//                       <mesh rotation={[0, 0, -Math.PI / 2]}>
//                         <coneGeometry
//                           args={[cornerSize * 0.2, cornerSize * 0.35, 3]}
//                         />
//                         <meshBasicMaterial
//                           color="#4A90E2"
//                           depthTest={false}
//                           depthWrite={false}
//                         />
//                       </mesh>
//                     </group>

//                     {/* Larger invisible hit area for easier clicking */}
//                     <mesh
//                       position={[0, 0, 0.0003]}
//                       renderOrder={10003}
//                       onPointerDown={(e) => {
//                         e.stopPropagation();
//                         if (e.nativeEvent) {
//                           e.nativeEvent.stopPropagation();
//                           e.nativeEvent.stopImmediatePropagation();
//                         }
//                         handleDecalRotate(e, type);
//                       }}
//                       onPointerOver={(e) => {
//                         if (e?.stopPropagation) e.stopPropagation();
//                         document.body.style.cursor = "grab";
//                         setShowRotateTooltip(type);
//                       }}
//                       onPointerOut={(e) => {
//                         if (e?.stopPropagation) e.stopPropagation();
//                         document.body.style.cursor = "auto";
//                         setShowRotateTooltip(null);
//                       }}
//                     >
//                       <circleGeometry args={[cornerSize * 2, 16]} />
//                       <meshBasicMaterial
//                         transparent
//                         opacity={0}
//                         depthTest={false}
//                         depthWrite={false}
//                       />
//                     </mesh>
//                   </group>
//                 );
//               })}
//             </group>
//           )}
//         </>
//       );
//     };

//     return (
//       <>
//         {/* NEW RESIZE FEATURE - HTML overlay for smooth resize */}

//         {interactionMode === "new-resize-mode" && (
//           <Html>
//             <div
//               style={{
//                 position: "fixed",
//                 top: 0,
//                 left: 0,
//                 width: "100vw",
//                 height: "100vh",
//                 pointerEvents: "auto",
//                 cursor:
//                   newResizeCorner === "tl" || newResizeCorner === "br"
//                     ? "nwse-resize"
//                     : "nesw-resize",
//                 backgroundColor: "transparent",
//                 zIndex: 9999,
//               }}
//               onPointerMove={handleNewResizeFunction}
//               onPointerUp={handlePointerUp}
//               onMouseMove={handleNewResizeFunction}
//               onMouseUp={handlePointerUp}
//               onTouchMove={handleNewResizeFunction}
//               onTouchEnd={handlePointerUp}
//             />
//           </Html>
//         )}

//         <Html
//           style={{
//             position: "absolute",
//             top: "-1000px",
//             left: "-800px",
//             zIndex: "999999999999999999999",
//           }}
//         >
//           <div id="svg-hidden-container" ref={svgContainerRef}></div>
//         </Html>

//         {interactionMode === "resize-decal" && (
//           <Html>
//             <div
//               style={{
//                 position: "fixed",
//                 top: 0,
//                 left: 0,
//                 width: "100vw",
//                 height: "100vh",
//                 pointerEvents: "auto",
//                 cursor: "nwse-resize",
//               }}
//               onPointerMove={handleResizeMove}
//               onPointerUp={handleResizeUp}
//               onMouseMove={handleResizeMove}
//               onMouseUp={handleResizeUp}
//               onTouchMove={handleResizeMove}
//               onTouchEnd={handleResizeUp}
//             />
//           </Html>
//         )}

//         {interactionMode === "move-decal" && (
//           <Html>
//             <div
//               style={{
//                 position: "fixed",
//                 top: "-188px",
//                 left: "-179px",
//                 width: "34vw",
//                 height: "65vh",
//                 pointerEvents: "auto",
//                 cursor: "move",
//               }}
//               onPointerMove={handlePointerMove}
//               onPointerUp={handlePointerUp}
//               onMouseMove={handlePointerMove}
//               onMouseUp={handlePointerUp}
//               onTouchMove={handlePointerMove}
//               onTouchEnd={handlePointerUp}
//             />
//           </Html>
//         )}

//         {interactionMode === "rotating" && (
//           <Html>
//             <div
//               style={{
//                 position: "fixed",
//                 top: "-188px",
//                 left: "-179px",
//                 width: "34vw",
//                 height: "65vh",
//                 pointerEvents: "auto",
//                 cursor: "grabbing",
//               }}
//               onPointerMove={handlePointerMove}
//               onPointerUp={handlePointerUp}
//               onMouseMove={handlePointerMove}
//               onMouseUp={handlePointerUp}
//               onTouchMove={handlePointerMove}
//               onTouchEnd={handlePointerUp}
//             />
//           </Html>
//         )}

//         <OrbitControls
//           enableZoom={true}
//           enablePan={false}
//           enabled={interactionMode === "rotate-shirt"}
//           target={[0, 0, 0]}
//           enableRotate
//           rotateSpeed={2.0}
//           minDistance={4.5}
//           maxDistance={5.5}
//         />

//         {selectedDecal && renderResizeArrow()}

//         {isLoading && (
//           <Html center>
//             <div style={loadingStyles}>
//               <Spinner animation="border" variant="dark" />
//               <p style={loadingTextStyles}>Loading...</p>
//             </div>
//           </Html>
//         )}

//         {!isLoading && (
//           <group
//             ref={group}
//             dispose={null}
//             // scale={overallScale}
//             scale={overallScale * mobileScaleFactor}
//             onPointerDown={() => {
//               handleDeselect();
//             }}
//           >
//             {/* <group position={position} rotation={rotation} scale={scale}> */}
//             <group
//               position={[
//                 position[0] + mobilePositionOffset[0],
//                 position[1] + mobilePositionOffset[1],
//                 position[2] + mobilePositionOffset[2],
//               ]}
//               // rotation={rotation}
//               rotation={animatedRotation}
//               scale={scale}
//             >
//               {parts
//                 .filter((part) => part.material.name !== "LOGO")
//                 .map((part, index) => (
//                   <mesh
//                     key={`non-logo-${index}`}
//                     geometry={part.geometry}
//                     material={part.material}
//                     name={part.name}
//                     ref={shirtRef}
//                   >
//                     <>
//                       {/* Front decals - always render */}
//                       {renderDecal(
//                         "frontText",
//                         frontTextTexture.current,
//                         frontTextPosition,
//                         frontTextRotation,
//                         frontTextScale
//                       )}
//                       {renderDecal(
//                         "frontNumber",
//                         frontNumberTexture.current,
//                         frontNumberPosition,
//                         frontNumberRotation,
//                         frontNumberScale
//                       )}
//                       {renderDecal(
//                         "frontLogo",
//                         logoTexture,
//                         frontLogoPosition,
//                         frontLogoRotation,
//                         frontLogoScale
//                       )}

//                       {/* Back decals - always render */}
//                       {renderDecal(
//                         "backText",
//                         backTextTexture.current,
//                         backTextPosition,
//                         backTextRotation,
//                         backTextScale
//                       )}
//                       {renderDecal(
//                         "backNumber",
//                         backNumberTexture.current,
//                         backNumberPosition,
//                         backNumberRotation,
//                         backNumberScale
//                       )}
//                       {renderDecal(
//                         "backLogo",
//                         logoTextureBack,
//                         backLogoPosition,
//                         backLogoRotation,
//                         backLogoScale
//                       )}
//                     </>
//                   </mesh>
//                 ))}
//             </group>

//             {parts
//               .filter((part) => part.material.name === "LOGO")
//               .map((part, index) => {
//                 return (
//                   <mesh
//                     geometry={part.geometry}
//                     material={part.material}
//                     position={logoPosition}
//                     rotation={logoRotation}
//                     scale={logoScale}
//                   />
//                 );
//               })}
//           </group>
//         )}
//       </>
//     );
//   }
// );
// const loadingStyles = {
//   display: "flex",
//   flexDirection: "row",
//   alignItems: "center",
//   justifyContent: "center",
//   backgroundColor: "rgba(197, 197, 197, 0.8)",
//   padding: "5px 15px",
//   borderRadius: "8px",
//   gap: "20px",
// };

// const loadingTextStyles = {
//   fontSize: "20px",
//   fontWeight: "bold",
//   color: "black",
//   marginTop: "10px",
// };

// const instructionsStyle = {
//   background: "rgba(0,0,0,0.7)",
//   padding: "10px",
//   borderRadius: "8px",
//   color: "white",
// };

// export default ShirtModel;

// import React, {
//   useEffect,
//   useState,
//   useRef,
//   useMemo,
//   useCallback,
// } from "react";
// import { createPortal } from "react-dom";
// import { forwardRef, useImperativeHandle } from "react";
// import * as THREE from "three";
// import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
// import state from "./index.js";
// import { useSnapshot } from "valtio";
// import {
//   OrbitControls,
//   Decal,
//   Html,
//   TransformControls,
// } from "@react-three/drei";
// import Spinner from "react-bootstrap/Spinner";
// import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
// import clothingConfig from "./clothingConfig";
// import { CanvasTexture } from "three";
// import modelConfig1 from "./modelConfig1.js";
// import { GLTFExporter } from "three/examples/jsm/exporters/GLTFExporter";
// import { TextureLoader } from "three";
// import { useFrame } from "@react-three/fiber";
// import { fabric } from "fabric";
// import { MdArrowOutward } from "react-icons/md";
// import { useThree } from "@react-three/fiber";
// import { useDispatch, useSelector } from "react-redux";
// import { FaArrowRotateLeft } from "react-icons/fa6";
// import { useLocation } from "react-router-dom";

// const DEFAULT_MODEL_URL = "/asset/HalfpoloK5.glb";
// const LEGACY_MODEL_URL = "/LongTeeM1.glb";

// const ShirtModel = forwardRef(
//   (
//     { menuSlug, subcategorySlug, gltfRef, isEditingDraft, currentProduct },
//     ref
//   ) => {
//     console.log("svg <<<<<<<<<>>>>>>>>>>>>>>>>>>..... : ", state.svg);
//     const { glbId } = useSelector((state) => state.cart);
//     const { camera } = useThree();
//     const raycaster = useMemo(() => new THREE.Raycaster(), []);
//     const mouse = useMemo(() => new THREE.Vector2(), []);
//     // const { selectedPattern } = useSnapshot(state);
//     const [isLoading, setIsLoading] = useState(true);
//     const snap = useSnapshot(state);
//     const group = useRef();
//     const shirtRef = useRef();
//     const [bandMesh, setBandMesh] = useState(null);
//     const location = useLocation(); // Add this line
//     const [isMobile, setIsmobile] = useState(window.innerWidth < 667);
//     const [initialDecalRotation, setInitialDecalRotation] = useState(0);
//     console.log("state.newKey : ", state.newKey);
//     console.log("state.frontText : ", state.frontText);
//     console.log("settings.Colors : ", state.partColors);
//     console.log(
//       "state.gradientColors...................... : ",
//       state.gradientColors
//     );

//     const productData = currentProduct || state.currentProduct;

//     console.log("productData///////////////////////// : ",productData)
//     const { selectedPattern } = productData || {};

//     console.log("state.newKey : ", state.newKey);
//     console.log("currentProduct frontText : ", productData?.frontText);
//     console.log("currentProduct partColors : ", productData?.partColors);
//     console.log(
//       "currentProduct gradientColors : ",
//       productData?.gradientColors
//     );

//     const { viewSide } = productData || { viewSide: "front" };

// const previousModelUrlRef = useRef(null);

// // Add this effect to ShirtModel.jsx
// useEffect(() => {
//   // Reset model loading state when product changes
//   if (productData?.id && previousProductIdRef.current !== productData.id) {
//     console.log("Product ID changed, resetting model state");
    
//     // If the model name is the same but product is different (duplicate),
//     // we need to reload the model to get fresh textures
//     if (previousModelUrlRef.current === productData.modelName) {
//       console.log("Same model URL, different product - reloading");
//       loadModelForProduct();
//     }
    
//     previousProductIdRef.current = productData.id;
//   }
// }, [productData?.id, productData?.modelName]);

//   useEffect(() => {
//       if (group.current && productData?.id) {
//         console.log("Product changed, applying images...");
//         applyImagesToMaterials();
//       }
//     }, [productData?.id, productData?.imagesPattern]);
    
//     // Optimize applyImagesToMaterials with useCallback
//     const applyImagesToMaterials = useCallback(async () => {
//       if (!group.current || !productData?.imagesPattern) {
//         console.log("No group or no imagesPattern to apply");
//         return;
//       }
      
//       console.log("Applying images to materials...");
      
//       const imagesPattern = productData.imagesPattern || {};
//       const normalizedImages = Object.fromEntries(
//         Object.entries(imagesPattern).map(([key, val]) => [
//           key.toUpperCase(),
//           val,
//         ])
//       );
      
//       // Process each mesh in the model
//       group.current.traverse(async (child) => {
//         if (!child.isMesh || !child.material) return;
        
//         const materialName = child.material.name?.toUpperCase();
//         if (!materialName) return;
        
//         const materials = Array.isArray(child.material)
//           ? child.material
//           : [child.material];
        
//         for (const mat of materials) {
//           const imageData = normalizedImages[materialName];
          
//           // Dispose of existing texture
//           if (mat.map) {
//             mat.map.dispose();
//             mat.map = null;
//           }
          
//           if (imageData?.image) {
//             try {
//               const texture = await new THREE.TextureLoader().loadAsync(
//                 imageData.image
//               );
              
//               texture.colorSpace = THREE.SRGBColorSpace;
//               texture.flipY = false;
//               texture.wrapS = THREE.RepeatWrapping;
//               texture.wrapT = THREE.RepeatWrapping;
//               texture.center.set(0.5, 0.5);
              
//               // Set texture properties
//               const img = new Image();
//               img.crossOrigin = "anonymous";
              
//               img.onload = () => {
//                 const imageAspect = img.width / img.height;
//                 const shirtAspect = 2220 / 2553;
//                 const SCALE_FACTOR = 2;
                
//                 if (img.width >= 2220 && img.height >= 2553) {
//                   if (imageAspect > shirtAspect) {
//                     texture.repeat.set(
//                       (shirtAspect / imageAspect) * SCALE_FACTOR,
//                       1 * SCALE_FACTOR
//                     );
//                   } else {
//                     texture.repeat.set(
//                       1 * SCALE_FACTOR,
//                       (imageAspect / shirtAspect) * SCALE_FACTOR
//                     );
//                   }
//                 } else if (img.width >= 1000 && img.height >= 1000) {
//                   texture.repeat.set(
//                     (2220 / img.width) * 0.8 * SCALE_FACTOR,
//                     (2553 / img.height) * 0.8 * SCALE_FACTOR
//                   );
//                 } else {
//                   const scaleX = Math.max(1, 2220 / img.width);
//                   const scaleY = Math.max(1, 2553 / img.height);
//                   texture.repeat.set(scaleX * SCALE_FACTOR, scaleY * SCALE_FACTOR);
//                 }
                
//                 texture.needsUpdate = true;
//               };
              
//               img.src = imageData.image;
              
//               mat.map = texture;
//               mat.color.set(0xffffff);
//               mat.needsUpdate = true;
              
//               console.log(`Applied texture to ${materialName}`);
//             } catch (err) {
//               console.error(`Failed to load image for ${materialName}:`, err);
//             }
//           } else {
//             // No image - use default color
//             mat.map = null;
//             mat.color.set("#112F51");
//             mat.needsUpdate = true;
//           }
//         }
//       });
//     }, [productData?.imagesPattern,productData?.id,]);
    
//     // Add a debug effect to log when product changes
//     useEffect(() => {
//       console.log("Product data updated:", {
//         id: productData?.id,
//         imagesPattern: productData?.imagesPattern,
//         hasImages: !!productData?.imagesPattern && Object.keys(productData.imagesPattern).length > 0
//       });
//     }, [productData,productData?.id,]);

//     useEffect(() => {
//       const handleResize = () => {
//         setIsmobile(window.innerWidth < 667);
//       };

//       window.addEventListener("resize", handleResize);
//       return () => window.removeEventListener("resize", handleResize);
//     }, []);
//     function resetState() {
//       state.updateTrigger++;
//       state.intro = false;
//       state.color = "#EFBD48";

//       // Reset current product data
//       const currentProductId = state.currentProductId;
//       if (state.products[currentProductId]) {
//         state.products[currentProductId] = {
//           ...state.products[currentProductId],
//           frontText: "",
//           backText: "",
//           frontNumber: "",
//           backNumber: "",
//           frontLogo: null,
//           backLogo: null,
//           imagesPattern: {},
//           viewSide: "front",
//           patternColors: {},
//           selectedPattern: {},
//           selectedFonts: "Arial",
//           textFonts: { front: "Arial", back: "Arial" },
//           numberFonts: { front: "Arial", back: "Arial" },
//           textColors: { front: "#ffffff", back: "#ffffff" },
//           numberColors: { front: "#ffffff", back: "#ffffff" },
//           partColors: {},
//           gradientColors: {},
//         };
//       }
//     }
//     // Replace your current useEffect with:
//     // Replace your current useEffect with:
//     useEffect(() => {
//       const hasDraftData =
//         location.state?.draftData || location.state?.restoreData;

//       if (!hasDraftData) {
//         console.log("No draft data found, resetting state...");
//         resetState();
//       } else {
//         console.log("Draft data found, skipping state reset...");
//         state.updateTrigger++; // Still trigger a re-render
//       }
//     }, [location.state]);

//     // In ShirtModel.jsx, add this effect to apply colors when product changes
//     useEffect(() => {
//       if (!group.current || !productData?.partColors) return;

//       console.log("Applying colors for product:", productData.id);
//       console.log("Colors to apply:", productData.partColors);

//       group.current.traverse((child) => {
//         if (child.isMesh && child.material) {
//           const partName = child.material.name?.toUpperCase();

//           if (partName && productData.partColors[partName]) {
//             const color = productData.partColors[partName];
//             const materials = Array.isArray(child.material)
//               ? child.material
//               : [child.material];

//             materials.forEach((mat) => {
//               if (mat.name === partName) {
//                 console.log(`Setting color ${color} for ${partName}`);
//                 mat.color.set(color);
//                 mat.needsUpdate = true;
//               }
//             });
//           }
//         }
//       });
//     }, [productData?.id, productData?.partColors]);

//     useEffect(() => {
//       // When product changes, update the model
//       if (productData && group.current) {
//         applyProductColorsToModel();
//       }
//     }, [productData?.id, productData?.partColors]);

//     const applyProductColorsToModel = () => {
//       if (!group.current || !productData?.partColors) return;

//       console.log("Applying colors for product:", productData.id);
//       console.log("Colors:", productData.partColors);

//       group.current.traverse((child) => {
//         if (child.isMesh && child.material) {
//           const partName = child.material.name?.toUpperCase();

//           if (partName && productData.partColors[partName]) {
//             const color = productData.partColors[partName];
//             const materials = Array.isArray(child.material)
//               ? child.material
//               : [child.material];

//             materials.forEach((mat) => {
//               if (mat.name === partName) {
//                 console.log(`Setting color ${color} for ${partName}`);
//                 mat.color.set(color);
//                 mat.needsUpdate = true;
//               }
//             });
//           }
//         }
//       });
//     };

//     const [gltf, setGltf] = useState(null);
//     const latestRequestRef = useRef(0);

//     const loadModel = useCallback(
//       (src) =>
//         new Promise((resolve, reject) => {
//           if (!src) {
//             reject(new Error("Model source is undefined"));
//             return;
//           }

//           const dracoLoader = new DRACOLoader();
//           dracoLoader.setDecoderPath(
//             "https://www.gstatic.com/draco/v1/decoders/"
//           );

//           const loader = new GLTFLoader();
//           loader.setDRACOLoader(dracoLoader);

//           loader.load(
//             src,
//             (model) => {
//               dracoLoader.dispose();
//               resolve(model);
//             },
//             undefined,
//             (error) => {
//               dracoLoader.dispose();
//               reject(error);
//             }
//           );
//         }),
//       []
//     );

//     console.log("gltf : ", gltf);

//     const getModelSettings = (menuSlug, subcategorySlug, selectedDesignId) => {
//       console.log("selectedDesignId <<<<<<<<<<<<<<>>>>>>>>>>>> ; ", glbId);
//       console.log("menuSlug .................. : ", menuSlug);
//       console.log(
//         "subcategorySlug ........................ : ",
//         subcategorySlug
//       );
//       const key = `${menuSlug}${subcategorySlug}`;
//       const newKey = key.replace(/-/g, "");
//       state.newKey = newKey;
//       console.log("newKey : ", newKey);

//       let modelConfig = modelConfig1[newKey];

//       if (newKey === "eventordereventjersey") {
//         const designKey = glbId || 900;
//         modelConfig = modelConfig1[newKey]?.[designKey];
//       }

//       return (
//         modelConfig || {
//           position: [0, 0, 0],
//           rotation: [0, 0, 0],
//           scale: 1,
//         }
//       );
//     };

//     useImperativeHandle(ref, () => ({
//       capturePng: () => {
//         if (!gltf) return null;

//         const scene = new THREE.Scene();
//         const camera = new THREE.PerspectiveCamera(35, 1, 0.1, 1000);
//         const renderer = new THREE.WebGLRenderer({
//           preserveDrawingBuffer: true,
//           alpha: true,
//         });
//         renderer.setSize(512, 512);
//         renderer.setClearColor(0x000000, 0);

//         const model = gltf.scene.clone();

//         model.scale.set(2.5, 2.5, 2.5);

//         const box = new THREE.Box3().setFromObject(model);
//         const center = box.getCenter(new THREE.Vector3());
//         model.position.x -= center.x;
//         model.position.y -= center.y;
//         model.position.z -= center.z;

//         scene.add(model);

//         const directionalLight = new THREE.DirectionalLight(0xffffff, 3.0);
//         directionalLight.position.set(3, 5, 5);
//         scene.add(directionalLight);

//         const ambientLight = new THREE.AmbientLight(0xffffff, 0.7);
//         scene.add(ambientLight);

//         const size = box.getSize(new THREE.Vector3());
//         const maxDim = Math.max(size.x, size.y, size.z);
//         const fov = camera.fov * (Math.PI / 180);
//         let cameraZ = Math.abs(maxDim / Math.sin(fov / 2)) * 0.6;

//         camera.position.set(0, 0.2, cameraZ);
//         camera.lookAt(new THREE.Vector3(0, 0.1, 0));
//         const backLight = new THREE.DirectionalLight(0xffffff, 1.5);
//         backLight.position.set(-5, -3, -5);
//         scene.add(backLight);

//         renderer.render(scene, camera);
//         const pngData = renderer.domElement.toDataURL("image/png");
//         return pngData;
//       },
//     }));

//     const {
//       partMappings,
//       overallScale,
//       position,
//       rotation,
//       scale,
//       fontSize,
//       designposition,
//       designrotation,
//       designscale,
//       patternScalling,
//       logoPosition,
//       logoRotation,
//       logoScale,
//       backNumberPosition,
//       backNumberRotation,
//       backNumberScale,
//       backLogoPosition,
//       backLogoRotation,
//       backLogoScale,
//       frontLogoPosition,
//       frontLogoRotation,
//       frontLogoScale,
//       frontTextPosition,
//       frontTextRotation,
//       frontTextScale,
//       backTextPosition,
//       backTextRotation,
//       backTextScale,
//       frontNumberPosition,
//       frontNumberRotation,
//       frontNumberScale,
//     } = getModelSettings(menuSlug, subcategorySlug);

//     const frontRotation = useMemo(() => {
//       return rotation;
//     }, [rotation]);

//     const backRotation = useMemo(() => {
//       const modelKey = state.newKey;
//       if (
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey"
//       ) {
//         return [rotation[0], rotation[1] + Math.PI, rotation[2]];
//       } else if (
//         modelKey === "menmenshorts" ||
//         modelKey === "menmencricketshorts" ||
//         modelKey === "menmencyclingshorts" ||
//         modelKey === "menmenrunningshorts" ||
//         modelKey === "menmenwovenshorts" ||
//         modelKey === "menmenknittedshorts" ||
//         modelKey === "menmenfootballshorts" ||
//         modelKey === "menmensoccershorts" ||
//         modelKey === "menmenbasketballshorts" ||
//         modelKey === "menmennftfootballshorts" ||
//         modelKey === "menmencyclingjersey" ||
//         modelKey === "menmenwinterjersey" ||
//         modelKey === "menmencitycollection" ||
//         modelKey === "menmencricketjersey" ||
//         modelKey === "menmentrackpants" ||
//         modelKey === "menmencompressionpants" ||
//         modelKey === "menmensinglet" ||
//         modelKey === "menmenarmsleeves" ||
//         modelKey === "menmenbasketballjersey" ||
//         modelKey === "womenwomenbadmintonshorts" ||
//         modelKey === "womenwomencyclingshorts" ||
//         modelKey === "womenwomencricketshorts" ||
//         modelKey === "womenwomenwovenshorts" ||
//         modelKey === "womenwomentightshorts" ||
//         modelKey === "womenwomenfootballshorts" ||
//         modelKey === "womenwomensoccershorts" ||
//         modelKey === "menmencompressionpants" ||
//         modelKey === "womenwomennftfootballshorts" ||
//         modelKey === "menmencompressionpants" ||
//         modelKey === "womenwomenbasketballshorts" ||
//         modelKey === "womenwomenknittedshorts" ||
//         modelKey === "womenwomencompressionpants" ||
//         modelKey === "womenwomencrickettrackpants" ||
//         modelKey === "womenwomentrackpants" ||
//         modelKey === "womenwomencricketjersey" ||
//         modelKey === "womenwomencyclingjersey" ||
//         modelKey === "womenwomenwinterjersey" ||
//         modelKey === "womenwomencitycollection" ||
//         modelKey === "kidskidsjersey" ||
//         modelKey === "kidskidscompressionpants" ||
//         modelKey === "kidskidsshorts" ||
//         modelKey === "kidskidscricketshorts" ||
//         modelKey === "kidskidscyclingshorts" ||
//         modelKey === "kidskidswintershorts" ||
//         modelKey === "kidskidsrunningshorts" ||
//         modelKey === "kidskidswovenshorts" ||
//         modelKey === "kidskidsknittedshorts" ||
//         modelKey === "kidskidsbasketballshorts" ||
//         modelKey === "kidskidssoccershorts" ||
//         modelKey === "kidskidsfootballshorts" ||
//         modelKey === "kidskidsnftfootballshorts" ||
//         modelKey === "kidskidstanktop" ||
//         modelKey === "kidskidscyclingjersey" ||
//         modelKey === "kidskidswinterjersey" ||
//         modelKey === "kidskidscitycollection" ||
//         modelKey === "kidskidscricketjersey" ||
//         modelKey === "kidskidstrackpants" ||
//         modelKey === "kidskidsprotshirt" ||
//         modelKey === "kidskidssinglet" ||
//         modelKey === "kidskidsarmsleeves" ||
//         modelKey === "kidskidsfootballjersey"||
//         modelKey === "kidskidssoccerjersey" 
//       ) {
//         return [rotation[0], rotation[1], rotation[2] + Math.PI];
//       } else {
//         return [rotation[0], rotation[1] + Math.PI, rotation[2]];
//       }
//     }, [rotation]);

//     const currentRotation = useMemo(() => {
//       return viewSide === "front" ? frontRotation : backRotation;
//     }, [viewSide, frontRotation, backRotation]);

//     const [animatedRotation, setAnimatedRotation] = useState(frontRotation);

//     useEffect(() => {
//       const targetRotation =
//         viewSide === "front" ? frontRotation : backRotation;

//       const timer = setTimeout(() => {
//         setAnimatedRotation(targetRotation);
//       }, 50);

//       return () => clearTimeout(timer);
//     }, [viewSide, frontRotation, backRotation]);

//     console.log("position <<<<<<<<<<<<<<>>>>>>>>>>>>>>: ", position);
//     console.log("rotation : ", rotation);
//     console.log("scale : ", scale);

//     const [modelSettings, setModelSettings] = useState(() =>
//       getModelSettings(menuSlug, subcategorySlug)
//     );

//     const [updateTrigger, setUpdateTrigger] = useState(0);

//     useEffect(() => {
//       setModelSettings(getModelSettings(menuSlug, subcategorySlug));
//     }, [snap.updateTrigger, menuSlug, subcategorySlug]);

//     useEffect(() => {
//       console.log("menu slug /////////// : ", menuSlug);
//       console.log("menu slug /////////// : ", subcategorySlug);
//       let isMounted = true;
//       latestRequestRef.current += 1;
//       const requestId = latestRequestRef.current;

//       // Determine which model to load
//       let modelKeyToLoad;

//       // Priority 1: Preserved model from navigation
//       if (location.state?.preserveModel && location.state?.currentModelKey) {
//         modelKeyToLoad = location.state.currentModelKey;
//         console.log(`🎯 Loading PRESERVED model: ${modelKeyToLoad}`);
//       }
//       // Priority 2: Current slugs
//       else if (menuSlug && subcategorySlug) {
//         modelKeyToLoad = `${menuSlug}${subcategorySlug}`.replace(/-/g, "");
//         console.log(`🎯 Loading from slugs: ${modelKeyToLoad}`);
//       }
//       // Priority 3: Previously stored model
//       else {
//         const storedModel = localStorage.getItem("current-3d-model");
//         modelKeyToLoad = storedModel || "menmenjersey";
//         console.log(`🎯 Loading STORED model: ${modelKeyToLoad}`);
//       }

//       // Update state with the actual key we're loading
//       state.newKey = modelKeyToLoad;

//       setIsLoading(true);

//       const loadModelForKey = async () => {
//         const modelConfig = modelConfig1[modelKeyToLoad];
//         let modelUrl;

//         if (modelConfig?.modelUrl) {
//           modelUrl = modelConfig.modelUrl;
//         } else {
//           // Fallback: use model name from state or default
//           modelUrl = snap.modelName || DEFAULT_MODEL_URL;
//         }

//         console.log(`📦 Loading model from: ${modelUrl}`);

//         try {
//           // Add cache busting
//           const cacheBustedUrl = `${modelUrl}?t=${Date.now()}`;
//           const model = await loadModel(cacheBustedUrl);

//           if (!isMounted || latestRequestRef.current !== requestId) return;

//           console.log(`✅ Model loaded: ${modelKeyToLoad}`);
//           setGltf(model);
//         } catch (error) {
//           console.error(`❌ Failed to load ${modelKeyToLoad}:`, error);

//           if (!isMounted || latestRequestRef.current !== requestId) return;

//           // Fallback to default
//           try {
//             console.log(`🔄 Falling back to default model`);
//             const defaultModel = await loadModel(DEFAULT_MODEL_URL);
//             if (isMounted && latestRequestRef.current === requestId) {
//               setGltf(defaultModel);
//               state.newKey = "menmenjersey";
//             }
//           } catch (fallbackError) {
//             console.error("❌ Fallback also failed:", fallbackError);
//             setGltf(null);
//           }
//         } finally {
//           if (isMounted && latestRequestRef.current === requestId) {
//             setIsLoading(false);
//           }
//         }
//       };

//       loadModelForKey();

//       return () => {
//         isMounted = false;
//       };
//     }, [snap.modelName, menuSlug, subcategorySlug, loadModel, location.state]);

//     useEffect(() => {
//       if (gltf && gltfRef) {
//         gltfRef.current = gltf;
//       }
//     }, [gltf]);

//     ////console.log("gltf?.scene : ", gltf?.scene);

//     useEffect(() => {
//       if (gltf?.scene && state.scene) {
//         state.scene = gltf.scene;
//       }

//       if (gltf?.scene) {
//         gltf.scene.traverse((child) => {
//           if (child.isGroup && ["TEE", "DESIGN"].includes(child.name)) {
//             setBandMesh((prev) => [
//               ...(Array.isArray(prev) ? prev : []),
//               ...child.children.filter((c) => c.isMesh),
//             ]);
//           }
//         });
//       }
//     }, [gltf, state.scene, menuSlug, subcategorySlug]);

//     // useEffect(() => {
//     //   updateTexture(snap.frontText, frontTextTexture, "front");
//     //   updateTexture(snap.backText, backTextTexture, "back");
//     //   updateTexture(snap.frontNumber, frontNumberTexture, "frontNumber");
//     //   updateTexture(snap.backNumber, backNumberTexture, "backNumber");
//     // }, [state.updateTrigger]);

//     useEffect(() => {
//       const modelKey = state.newKey;

//       if (modelKey === "eventordereventjersey" && glbId) {
//         console.log(" Updating positions for event order design:", glbId);

//         let modelConfig = modelConfig1[modelKey][glbId];

//         if (!modelConfig) {
//           console.warn(" No config found for design ID:", glbId);
//           return;
//         }

//         setDecalPositions({
//           frontText: modelConfig.frontTextPosition
//             ? [...modelConfig.frontTextPosition]
//             : [0, 0, 0],
//           frontNumber: modelConfig.frontNumberPosition
//             ? [...modelConfig.frontNumberPosition]
//             : [0, 0, 0],
//           frontLogo: modelConfig.frontLogoPosition
//             ? [...modelConfig.frontLogoPosition]
//             : [0, 0, 0],
//           backText: modelConfig.backTextPosition
//             ? [...modelConfig.backTextPosition]
//             : [0, 0, 0],
//           backNumber: modelConfig.backNumberPosition
//             ? [...modelConfig.backNumberPosition]
//             : [0, 0, 0],
//           backLogo: modelConfig.backLogoPosition
//             ? [...modelConfig.backLogoPosition]
//             : [0, 0, 0],
//         });

//         setDecalScales({
//           frontText: modelConfig.frontTextScale
//             ? [...modelConfig.frontTextScale]
//             : [1, 1, 1],
//           frontNumber: modelConfig.frontNumberScale
//             ? [...modelConfig.frontNumberScale]
//             : [1, 1, 1],
//           frontLogo: modelConfig.frontLogoScale
//             ? [...modelConfig.frontLogoScale]
//             : [1, 1, 1],
//           backText: modelConfig.backTextScale
//             ? [...modelConfig.backTextScale]
//             : [1, 1, 1],
//           backNumber: modelConfig.backNumberScale
//             ? [...modelConfig.backNumberScale]
//             : [1, 1, 1],
//           backLogo: modelConfig.backLogoScale
//             ? [...modelConfig.backLogoScale]
//             : [1, 1, 1],
//         });

//         if (modelConfig.fontSize) {
//           setFontSizetext(modelConfig.fontSize);
//         }
//         if (modelConfig.fontSizeNumber) {
//           setFontSizeNumber(modelConfig.fontSizeNumber);
//         }

//         if (modelConfig.frontTextPosition) {
//           frontTextPosition[0] = modelConfig.frontTextPosition[0];
//           frontTextPosition[1] = modelConfig.frontTextPosition[1];
//           frontTextPosition[2] = modelConfig.frontTextPosition[2];
//         }

//         if (modelConfig.frontNumberPosition) {
//           frontNumberPosition[0] = modelConfig.frontNumberPosition[0];
//           frontNumberPosition[1] = modelConfig.frontNumberPosition[1];
//           frontNumberPosition[2] = modelConfig.frontNumberPosition[2];
//         }

//         if (modelConfig.frontLogoPosition) {
//           frontLogoPosition[0] = modelConfig.frontLogoPosition[0];
//           frontLogoPosition[1] = modelConfig.frontLogoPosition[1];
//           frontLogoPosition[2] = modelConfig.frontLogoPosition[2];
//         }

//         if (modelConfig.backTextPosition) {
//           backTextPosition[0] = modelConfig.backTextPosition[0];
//           backTextPosition[1] = modelConfig.backTextPosition[1];
//           backTextPosition[2] = modelConfig.backTextPosition[2];
//         }

//         if (modelConfig.backNumberPosition) {
//           backNumberPosition[0] = modelConfig.backNumberPosition[0];
//           backNumberPosition[1] = modelConfig.backNumberPosition[1];
//           backNumberPosition[2] = modelConfig.backNumberPosition[2];
//         }

//         if (modelConfig.backLogoPosition) {
//           backLogoPosition[0] = modelConfig.backLogoPosition[0];
//           backLogoPosition[1] = modelConfig.backLogoPosition[1];
//           backLogoPosition[2] = modelConfig.backLogoPosition[2];
//         }

//         if (modelConfig.frontTextScale) {
//           frontTextScale[0] = modelConfig.frontTextScale[0];
//           frontTextScale[1] = modelConfig.frontTextScale[1];
//           frontTextScale[2] = modelConfig.frontTextScale[2];
//         }

//         if (modelConfig.frontNumberScale) {
//           frontNumberScale[0] = modelConfig.frontNumberScale[0];
//           frontNumberScale[1] = modelConfig.frontNumberScale[1];
//           frontNumberScale[2] = modelConfig.frontNumberScale[2];
//         }

//         if (modelConfig.frontLogoScale) {
//           frontLogoScale[0] = modelConfig.frontLogoScale[0];
//           frontLogoScale[1] = modelConfig.frontLogoScale[1];
//           frontLogoScale[2] = modelConfig.frontLogoScale[2];
//         }

//         if (modelConfig.backTextScale) {
//           backTextScale[0] = modelConfig.backTextScale[0];
//           backTextScale[1] = modelConfig.backTextScale[1];
//           backTextScale[2] = modelConfig.backTextScale[2];
//         }

//         if (modelConfig.backNumberScale) {
//           backNumberScale[0] = modelConfig.backNumberScale[0];
//           backNumberScale[1] = modelConfig.backNumberScale[1];
//           backNumberScale[2] = modelConfig.backNumberScale[2];
//         }

//         if (modelConfig.backLogoScale) {
//           backLogoScale[0] = modelConfig.backLogoScale[0];
//           backLogoScale[1] = modelConfig.backLogoScale[1];
//           backLogoScale[2] = modelConfig.backLogoScale[2];
//         }

//         console.log(
//           "Updated event order positions and scales for design:",
//           glbId
//         );
//       }
//     }, [glbId]);

//     const [parts, setLocalParts] = useState([]);
//     const [frontParts, setFrontParts] = useState([]);
//     const [backParts, setBackParts] = useState([]);
//     const [leftParts, setLeftParts] = useState([]);
//     const [rightParts, setRightParts] = useState([]);
//     const [designParts, setDesignParts] = useState([]);
//     const [defaultTexture, setDefaultTexture] = useState(null);
//      const previousProductIdRef = useRef(null);
// // Effect 1: Handle model changes (when model URL changes)
// useEffect(() => {
//   if (!productData?.modelName) return;
  
//   // Only reload if model URL actually changed
//   if (productData.modelName !== previousModelUrlRef.current) {
//     console.log("Model URL changed:", productData.modelName);
    
//     previousModelUrlRef.current = productData.modelName;
//     loadModelForProduct();
//   }
// }, [productData?.modelName]);

// // Effect 2: Handle product changes (when product ID changes but model stays same)
// useEffect(() => {
//   if (!productData?.id) return;
  
//   // Product ID changed but model might be the same
//   if (productData.id !== previousProductIdRef.current) {
//     console.log("Product changed:", productData.id);
    
//     const modelChanged = productData.modelName !== previousModelUrlRef.current;
    
//     if (!modelChanged && gltf) {
//       // Same model, different product (duplicate) - just update settings
//       console.log("Same model, applying new product settings");
//       applyProductColorsToModel();
//       applyImagesToMaterials();
//     }
    
//     previousProductIdRef.current = productData.id;
//   }
// }, [productData?.id, gltf]);

// async function loadModelForProduct() {
//   if (!productData?.modelName) return;
  
//   setIsLoading(true);
//   setGltf(null);
  
//   try {
//     const cacheBustedUrl = `${productData.modelName}?t=${Date.now()}`;
//     const model = await loadModel(cacheBustedUrl);
//     setGltf(model);
//     setIsLoading(false);
//     console.log("Model loaded for product:", productData.id);
//   } catch (error) {
//     console.error("Failed to load model:", error);
//     setIsLoading(false);
//   }
// }

//     const texture = useMemo(() => {
//       // Check if we have a valid selected pattern from current product
//       if (!selectedPattern || typeof selectedPattern !== "object") {
//         console.log("No selected pattern or invalid pattern object");
//         return null;
//       }

//       // Check if the pattern has an image property
//       const patternImage = selectedPattern.image;
//       if (!patternImage || typeof patternImage !== "string") {
//         console.log(
//           "Selected pattern has no valid image URL:",
//           selectedPattern
//         );
//         return null;
//       }

//       try {
//         console.log("Loading pattern texture:", patternImage);
//         const texture = new THREE.TextureLoader().load(
//           patternImage,
//           // onLoad callback
//           () => {
//             console.log("Pattern texture loaded successfully");
//             texture.needsUpdate = true;
//           },
//           // onProgress callback (optional)
//           undefined,
//           // onError callback
//           (error) => {
//             console.error("Failed to load pattern texture:", error);
//           }
//         );

//         if (texture) {
//           texture.colorSpace = THREE.SRGBColorSpace;
//           texture.wrapS = THREE.RepeatWrapping;
//           texture.wrapT = THREE.RepeatWrapping;

//           // Use pattern-specific scale if available, otherwise default
//           const scale = selectedPattern.scale || 1;
//           texture.repeat.set(35 * scale, 35 * scale);

//           texture.transparent = true;
//           texture.opacity = selectedPattern.opacity || 0.5;
//         }

//         return texture;
//       } catch (error) {
//         console.error("Error creating texture:", error);
//         return null;
//       }
//     }, [
//         productData?.id,
//       selectedPattern?.image,
//       selectedPattern?.scale,
//       selectedPattern?.opacity,
//     ]);

//     const [patternedMaterials, setPatternedMaterials] = useState({});
//     const [forceRenderKey, setForceRenderKey] = useState(0);

//     ////console.log("state.selectedPattern : ", state.selectedPattern);

//     const baseColorTextureRef = useRef(null);

//     /** ==========================
//      *  OPTIMIZED MESH EXTRACTION
//      *  ========================== */
//     useEffect(() => {
//       if (gltf?.scene) {
//         const extractedParts = [];

//         gltf.scene.traverse((child) => {
//           if (child.isMesh) {
//             child.geometry.computeVertexNormals();

//             if (child.material.side === THREE.BackSide) {
//               child.geometry.scale(-1, 1, 1);
//               child.material.side = THREE.FrontSide;
//             }

//             extractedParts.push({
//               name: child.name,
//               geometry: child.geometry,
//               material: child.material,
//             });
//           }
//         });

//         console.log("extractedParts : ", extractedParts);

//         setLocalParts(extractedParts);
//         state.parts = extractedParts.map((part) => part.material.name);
//       }
//     }, [gltf, state.setParts, menuSlug, subcategorySlug]);

//     console.log("state.parts:", state.parts);

//     const [renderCount, setRenderCount] = useState(0);

//     const svgContainerRef = useRef(null);

//     useEffect(() => {
//       const applyImagesToMaterials = async () => {
//         if (!group.current) return;

//         console.log(
//           "currentProduct imagesPattern : ",
//           productData?.imagesPattern
//         );

//         const imagesPattern = productData?.imagesPattern || {};
//         const normalizedImages = Object.fromEntries(
//           Object.entries(imagesPattern).map(([key, val]) => [
//             key.toUpperCase(),
//             val,
//           ])
//         );

//         group.current.traverse(async (child) => {
//           if (!child.isMesh || !child.material) return;

//           const materialName = child.material.name?.toUpperCase();
//           if (!materialName || !partMappings[materialName]) return;

//           const materials = Array.isArray(child.material)
//             ? child.material
//             : [child.material];

//           for (const mat of materials) {
//             const imageData = normalizedImages[materialName];

//             // Dispose of existing texture to prevent memory leaks
//             if (mat.map) {
//               mat.map.dispose();
//               mat.map = null;
//             }

//             if (imageData?.image) {
//               try {
//                 const texture = await new THREE.TextureLoader().loadAsync(
//                   imageData.image
//                 );

//                 texture.colorSpace = THREE.SRGBColorSpace;
//                 texture.flipY = false;
//                 texture.wrapS = THREE.RepeatWrapping;
//                 texture.wrapT = THREE.RepeatWrapping;
//                 texture.center.set(0.5, 0.5);

//                 const img = new Image();
//                 img.crossOrigin = "anonymous";

//                 img.onload = () => {
//                   const imageAspect = img.width / img.height;
//                   const shirtAspect = 2220 / 2553; // your shirt UV ratio

//                   console.log("imageAspect: ", imageAspect);
//                   console.log("img.width: ", img.width);
//                   console.log("img.height: ", img.height);

//                   // Scale factor to control pattern size (increase = smaller pattern)
//                   const SCALE_FACTOR = 2; // Adjust this: 1 = normal, 2 = half size, 3 = third size

//                   if (img.width >= 2220 && img.height >= 2553) {
//                     // High-res pattern
//                     if (imageAspect > shirtAspect) {
//                       texture.repeat.set(
//                         (shirtAspect / imageAspect) * SCALE_FACTOR,
//                         1 * SCALE_FACTOR
//                       );
//                     } else {
//                       texture.repeat.set(
//                         1 * SCALE_FACTOR,
//                         (imageAspect / shirtAspect) * SCALE_FACTOR
//                       );
//                     }
//                   } else if (img.width >= 1000 && img.height >= 1000) {
//                     // Medium pattern - tile it appropriately
//                     texture.repeat.set(
//                       (2220 / img.width) * 0.8 * SCALE_FACTOR,
//                       (2553 / img.height) * 0.8 * SCALE_FACTOR
//                     );
//                   } else {
//                     // Small pattern - tile more
//                     const scaleX = Math.max(1, 2220 / img.width);
//                     const scaleY = Math.max(1, 2553 / img.height);
//                     texture.repeat.set(
//                       scaleX * SCALE_FACTOR,
//                       scaleY * SCALE_FACTOR
//                     );
//                   }

//                   texture.needsUpdate = true;
//                 };

//                 img.src = imageData.image;

//                 mat.map = texture;
//                 mat.color.set(0xffffff);
//                 mat.needsUpdate = true;
//               } catch (err) {
//                 console.error(`Failed to load image for ${materialName}:`, err);
//               }
//             } else {
//               // No image - reset to default color
//               mat.map = null;
//               mat.color.set("#112F51");
//               mat.needsUpdate = true;
//             }
//           }
//         });
//       };

//       applyImagesToMaterials();
//     }, [productData?.imagesPattern, productData?.id]);

//     function applyGradientToPath(
//       svg,
//       pathElement,
//       baseColor,
//       gradientColor,
//       gradientId
//     ) {
//       ////console.log("Gradient svg : ", svg);
//       ////console.log("Gradient pathElement : ", pathElement);
//       ////console.log("Gradient baseColor : ", baseColor);
//       ////console.log("Gradient gradientColor : ", gradientColor);
//       ////console.log("Gradient gradientId : ", gradientId);

//       const defs =
//         svg.querySelector("defs") ||
//         svg.insertBefore(
//           document.createElementNS("http://www.w3.org/2000/svg", "defs"),
//           svg.firstChild
//         );

//       let gradient = document.getElementById(gradientId);
//       if (!gradient) {
//         gradient = document.createElementNS(
//           "http://www.w3.org/2000/svg",
//           "linearGradient"
//         );
//         gradient.setAttribute("id", gradientId);

//         gradient.setAttribute("x1", "0%");
//         gradient.setAttribute("y1", "0%");
//         gradient.setAttribute("x2", "0%");
//         gradient.setAttribute("y2", "100%");

//         const stop1 = document.createElementNS(
//           "http://www.w3.org/2000/svg",
//           "stop"
//         );
//         stop1.setAttribute("offset", "0%");
//         stop1.setAttribute("stop-color", baseColor);

//         const stop2 = document.createElementNS(
//           "http://www.w3.org/2000/svg",
//           "stop"
//         );
//         stop2.setAttribute("offset", "100%");
//         stop2.setAttribute("stop-color", gradientColor);

//         gradient.appendChild(stop1);
//         gradient.appendChild(stop2);
//         defs.appendChild(gradient);
//       }

//       pathElement.setAttribute("fill", `url(#${gradientId})`);
//     }

//     async function applyPatternToPath(
//       targetSVG,
//       pathElements,
//       patternData,
//       patternName,
//       patternId
//     ) {
//       try {
//         const response = await fetch(patternData.image);
//         const contentType = response.headers.get("Content-Type");
//         const isSVG = contentType && contentType.includes("image/svg+xml");

//         if (!isSVG) {
//           console.error("Pattern is not an SVG.");
//           return;
//         }

//         const rawPatternSVG = await response.text();
//         const parser = new DOMParser();
//         const parsedDoc = parser.parseFromString(
//           rawPatternSVG,
//           "image/svg+xml"
//         );
//         const originalSVG = parsedDoc.querySelector("svg");

//         if (!originalSVG) {
//           console.error("No <svg> found in the pattern file.");
//           return;
//         }

//         // Get or create defs
//         const defs =
//           targetSVG.querySelector("defs") ||
//           targetSVG.insertBefore(
//             document.createElementNS("http://www.w3.org/2000/svg", "defs"),
//             targetSVG.firstChild
//           );

//         // Remove existing patterns with same name
//         const existingPatterns = defs.querySelectorAll("pattern");
//         existingPatterns.forEach((pat) => {
//           if (pat.getAttribute("data-pattern-name") === patternName) {
//             pat.remove();
//           }
//         });

//         const oldInnerSVG = targetSVG.querySelector(`#svg_${patternName}`);
//         if (oldInnerSVG) oldInnerSVG.remove();

//         // Extract viewBox from original SVG
//         const viewBoxAttr = originalSVG.getAttribute("viewBox");
//         let viewBoxWidth, viewBoxHeight;

//         if (viewBoxAttr) {
//           const viewBox = viewBoxAttr.split(/\s+/);
//           viewBoxWidth = parseFloat(viewBox[2]);
//           viewBoxHeight = parseFloat(viewBox[3]);
//         } else {
//           // Fallback to width/height attributes
//           viewBoxWidth = parseFloat(originalSVG.getAttribute("width")) || 28;
//           viewBoxHeight = parseFloat(originalSVG.getAttribute("height")) || 49;
//         }

//         // Use pattern-specific scale if available, otherwise use default 1.2
//         console.log("patternData ........... : ", patternData);

//         const PATTERN_SCALE = patternData.scale || 1.2;

//         // Create pattern element with proper dimensions
//         const patternNode = document.createElementNS(
//           "http://www.w3.org/2000/svg",
//           "pattern"
//         );
//         patternNode.setAttribute("id", patternId);
//         patternNode.setAttribute("x", "0");
//         patternNode.setAttribute("y", "0");
//         patternNode.setAttribute("width", viewBoxWidth.toString());
//         patternNode.setAttribute("height", viewBoxHeight.toString());
//         patternNode.setAttribute("patternUnits", "userSpaceOnUse");
//         patternNode.setAttribute("patternTransform", `scale(${PATTERN_SCALE})`);
//         patternNode.setAttribute("data-pattern-name", patternName);

//         // Create inner SVG with matching dimensions
//         const innerSVG = document.createElementNS(
//           "http://www.w3.org/2000/svg",
//           "svg"
//         );
//         innerSVG.setAttribute("id", `svg_${patternName}`);
//         innerSVG.setAttribute("width", viewBoxWidth.toString());
//         innerSVG.setAttribute("height", viewBoxHeight.toString());
//         innerSVG.setAttribute(
//           "viewBox",
//           `0 0 ${viewBoxWidth} ${viewBoxHeight}`
//         );

//         // Get the color for this pattern from current product
//         const partColor =
//           productData?.patternColors?.[patternName.toUpperCase()] || "#000000";

//         // For your specific hexagon pattern, we need to handle it differently
//         // Clone the entire content but replace the fill color
//         const originalContent = originalSVG.innerHTML;

//         // Create a temporary div to manipulate the SVG content
//         const tempDiv = document.createElement("div");
//         tempDiv.innerHTML = originalContent;

//         // Find and update all path elements
//         const paths = tempDiv.querySelectorAll("path");
//         paths.forEach((path) => {
//           // Remove existing fill and stroke attributes
//           path.removeAttribute("fill");
//           path.removeAttribute("stroke");
//           path.removeAttribute("stroke-width");
//           path.removeAttribute("style");

//           // Apply the new color
//           path.setAttribute("fill", partColor);
//           path.setAttribute("stroke", "none");
//           path.setAttribute("stroke-width", "0");
//         });

//         // If no paths found, try to find any shapes
//         if (paths.length === 0) {
//           const shapes = tempDiv.querySelectorAll(
//             "rect, circle, ellipse, polygon, polyline"
//           );
//           shapes.forEach((shape) => {
//             shape.removeAttribute("fill");
//             shape.removeAttribute("stroke");
//             shape.removeAttribute("stroke-width");
//             shape.removeAttribute("style");
//             shape.setAttribute("fill", partColor);
//             shape.setAttribute("stroke", "none");
//             shape.setAttribute("stroke-width", "0");
//           });
//         }

//         // Set the inner HTML of our innerSVG
//         innerSVG.innerHTML = tempDiv.innerHTML;

//         patternNode.appendChild(innerSVG);
//         defs.appendChild(patternNode);

//         // Get or create the scale group
//         let gElement = targetSVG.querySelector("g#scale");
//         if (!gElement) {
//           gElement = document.createElementNS(
//             "http://www.w3.org/2000/svg",
//             "g"
//           );
//           gElement.setAttribute("id", "scale");
//           targetSVG.appendChild(gElement);
//         }

//         // Apply pattern to all path elements
//         pathElements.forEach((pathElement, index) => {
//           const originalId = pathElement.getAttribute("id");
//           const elementLabel = (
//             pathElement.getAttribute("elementname") || `part${index}`
//           ).replace(/\s+/g, "_");
//           const newId = `${originalId}_copy_${elementLabel}`;

//           // Remove old copy if exists
//           const oldCopy = gElement.querySelector(`path[id="${newId}"]`);
//           if (oldCopy) oldCopy.remove();

//           // Create new path with pattern fill
//           const copyPath = pathElement.cloneNode(true);

//           // Clean up attributes but keep essential ones
//           const keepAttributes = ["d", "id", "transform"];
//           [...copyPath.attributes].forEach((attr) => {
//             if (!keepAttributes.includes(attr.name)) {
//               copyPath.removeAttribute(attr.name);
//             }
//           });

//           copyPath.setAttribute("id", newId);
//           copyPath.setAttribute("fill", `url(#${patternId})`);
//           copyPath.setAttribute("data-pattern-name", patternName);
//           copyPath.setAttribute("data-element-name", elementLabel);

//           gElement.appendChild(copyPath);
//         });

//         console.log(
//           `Pattern '${patternName}' applied with color ${partColor}, scale ${PATTERN_SCALE} and dimensions ${viewBoxWidth}x${viewBoxHeight}`
//         );
//       } catch (err) {
//         console.error("Failed to load or apply pattern:", err);
//       }
//     }
//     async function loadTextureFromSVG(svgElement, size = 2048) {
//       ////console.log("svgElement for pattern and color: ", svgElement);

//       const svgClone = svgElement.cloneNode(true);

//       ////console.log("svgClone : ", svgClone);

//       const originalDefs = svgElement.querySelector("defs");
//       ////console.log("originalDefs : ", originalDefs);
//       if (originalDefs) {
//         let clonedDefs = svgClone.querySelector("defs");

//         if (!clonedDefs) {
//           clonedDefs = originalDefs.cloneNode(true);
//           svgClone.insertBefore(clonedDefs, svgClone.firstChild);
//         }
//       }

//       svgClone.setAttribute("width", size);
//       svgClone.setAttribute("height", size);
//       svgClone.setAttribute("viewBox", `0 0 ${size} ${size}`);
//       svgClone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
//       svgClone.setAttribute("version", "1.1");

//       const svgString = new XMLSerializer().serializeToString(svgClone);
//       ////console.log("svgString: ", svgString);
//       const imageUrl = `data:image/svg+xml;base64,${btoa(
//         unescape(encodeURIComponent(svgString))
//       )}`;

//       ////console.log("imageUrl for pattern: ", imageUrl);

//       const existing = document.getElementById("svg-preview-wrapper");
//       if (existing) existing.remove();

//       // const wrapper = document.createElement("div");
//       // wrapper.id = "svg-preview-wrapper";
//       // wrapper.style.cssText = `
//       //   position: absolute; top: 20px; left: 520px;
//       //   width: 320px; height: 100px;
//       //   overflow: auto; border: 2px solid black;
//       //   z-index: 9999; background: white; padding: 4px;
//       // `;

//       // const preview = document.createElement("img");
//       // preview.src = imageUrl;
//       // preview.style.width = "100%";
//       // preview.style.outline = "3px solid blue";
//       // wrapper.appendChild(preview);
//       // document.body.appendChild(wrapper);

//       return new Promise((resolve) => {
//         const img = new Image();
//         img.crossOrigin = "anonymous";

//         img.onload = () => {
//           const canvas = document.createElement("canvas");
//           canvas.width = size;
//           canvas.height = size;

//           const ctx = canvas.getContext("2d");
//           ctx.clearRect(0, 0, size, size);

//           ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

//           const texture = new THREE.CanvasTexture(canvas);
//           texture.needsUpdate = true;

//           const debugImage = new Image();
//           debugImage.src = texture.image.toDataURL("image/png");
//           // debugImage.style.position = "absolute";
//           // debugImage.style.top = "200px";
//           // debugImage.style.left = "400px";
//           // debugImage.style.width = "200px";
//           // debugImage.style.border = "2px dashed green";
//           // debugImage.alt = "CanvasTexture Preview";

//           // document.body.appendChild(debugImage);

//           resolve(texture);
//         };

//         img.onerror = (err) => {
//           console.error("Image failed to load from SVG:", err);
//           resolve(null);
//         };

//         img.src = imageUrl;
//       });
//     }

//     const svgStateRef = useRef(null);
//     function unwrapProxy(proxyObj) {
//       if (proxyObj === null || typeof proxyObj !== "object") return proxyObj;
//       if (Array.isArray(proxyObj)) return proxyObj.map(unwrapProxy);

//       const plainObj = {};
//       for (const key in proxyObj) {
//         plainObj[key] = unwrapProxy(proxyObj[key]);
//       }
//       return plainObj;
//     }

//     const currentSvgUrlRef = useRef(null);

//     console.log("partcolors : ", state.partColors);
// console.log("productData ::::::::::::::::::::: ",productData)
// console.log("svg new ::::::::::::::::: ", state.svg);
// // Add this effect to force SVG updates when product changes
// useEffect(() => {
//   console.log("Product changed, forcing SVG update for product:", productData?.id);
  
//   // Force a re-render of the SVG effect
//   if (svgStateRef.current && productData?.id) {
//     // Trigger the SVG update by updating the refetch condition
//     currentSvgUrlRef.current = null; // Force refetch
//     svgStateRef.current = null; // Clear cached SVG
    
//     // Manually trigger the SVG update
//     const timer = setTimeout(() => {
//       if (state.svg) {
//         fetch(`${state.svg}?cacheBust=${Date.now()}`)
//           .then((res) => res.text())
//           .then((svgText) => {
//             const parser = new DOMParser();
//             const baseSVG = parser
//               .parseFromString(svgText, "image/svg+xml")
//               .querySelector("svg");

//             if (!baseSVG) {
//               console.warn("SVG not found");
//               return;
//             }

//             svgStateRef.current = baseSVG;
//             currentSvgUrlRef.current = state.svg;
            
//             // Trigger the update function
//             updateAndRenderSVG();
//           });
//       }
//     }, 100);
    
//     return () => clearTimeout(timer);
//   }
// }, [productData?.id]);
// // Move this function outside the useEffect
// const updateAndRenderSVG = useCallback(async () => {
//   console.log("updateAndRenderSVG called for product:", productData?.id);
  
//   if (!svgStateRef.current) {
//     console.log("No SVG state available, skipping");
//     return;
//   }
  
//   const baseSVG = svgStateRef.current.cloneNode(true);
//   const scaleGroup = baseSVG.querySelector("#scale");
  
//   if (!scaleGroup) {
//     console.log("No scale group found in SVG");
//     return;
//   }

//   console.log("scaleGroup found:", scaleGroup);

//   const partColors = productData?.partColors || {};
//   const gradientColors = productData?.gradientColors || {};
//   const unwrappedPattern = unwrapProxy(
//     productData?.selectedPattern || {}
//   );
//   const normalizedPattern = Object.fromEntries(
//     Object.entries(unwrappedPattern).map(([key, val]) => [
//       key.toUpperCase(),
//       val,
//     ])
//   );

//   console.log("Applying from productData:", {
//     partColors,
//     gradientColors,
//     normalizedPattern
//   });

//   const directColorParts = ["DESIGN", "LOGO", "NECK"];

//   directColorParts.forEach((partName) => {
//     const color = partColors?.[partName];
//     if (!color) return;

//     const groupObj = group.current;
//     if (!groupObj) return;

//     groupObj.traverse((child) => {
//       if (!child.isMesh || !child.material) return;

//       const materials = Array.isArray(child.material)
//         ? child.material
//         : [child.material];

//       materials.forEach((mat) => {
//         if (mat.name === partName) {
//           mat.color.set(color);
//           mat.needsUpdate = true;
//         }
//       });
//     });
//   });

//   const patternApplyPromises = [];

//   console.log("partMappings : ", partMappings);

//   Object.entries(partMappings).forEach(
//     ([materialName, targetElements]) => {
//       const baseColor = partColors[materialName];
//       const gradientColor = gradientColors[materialName];
//       const patternData = normalizedPattern?.[materialName.toUpperCase()];

//       console.log(`Processing ${materialName}:`, {
//         baseColor,
//         gradientColor,
//         patternData: patternData?.image ? "Pattern exists" : "No pattern"
//       });

//       if ((!baseColor && !patternData) || !targetElements) return;

//       const matchingPaths = Array.from(
//         scaleGroup.querySelectorAll("path")
//       ).filter((path) => {
//         let nameAttr = null;
//         path.getAttributeNames().forEach((attr) => {
//           if (attr.toLowerCase() === "elementname") {
//             nameAttr = path.getAttribute(attr);
//           }
//         });
//         return (
//           nameAttr && targetElements.includes(nameAttr.toUpperCase())
//         );
//       });

//       console.log(`${materialName} - matching paths:`, matchingPaths.length);

//       matchingPaths.forEach((path) => {
//         if (patternData?.image) {
//           if (materialName === "TEE") {
//             const promise = applyPatternToPath(
//               baseSVG,
//               matchingPaths,
//               patternData,
//               materialName,
//               `${materialName}_${patternData.name}`
//             );
//             patternApplyPromises.push(promise);
//           } else {
//             // apply individually
//             matchingPaths.forEach((path) => {
//               const promise = applyPatternToPath(
//                 baseSVG,
//                 [path], // wrap in array
//                 patternData,
//                 materialName,
//                 `${materialName}_${patternData.name}`
//               );
//               patternApplyPromises.push(promise);
//             });
//           }
//         }

//         if (baseColor && gradientColor) {
//           applyGradientToPath(
//             baseSVG,
//             path,
//             baseColor,
//             gradientColor,
//             `grad-${materialName}`
//           );
//         } else if (baseColor) {
//           path.setAttribute("fill", baseColor);
//         }
//       });
//     }
//   );

//   // Wait for all pattern fills to complete
//   await Promise.all(patternApplyPromises);

//   const texture = await loadTextureFromSVG(baseSVG);
//   baseColorTextureRef.current = texture;

//   group.current?.traverse((child) => {
//     if (!child.isMesh || !child.material) return;

//     const materials = Array.isArray(child.material)
//       ? child.material
//       : [child.material];

//     materials.forEach((mat) => {
//       if (!partMappings[mat.name]) return;

//       mat.map?.dispose();
//       mat.map = texture;
//       mat.map.flipY = false;
//       mat.map.colorSpace = THREE.SRGBColorSpace;
//       mat.color.set("#ffffff");
//       mat.needsUpdate = true;
//     });
//   });
  
//   console.log("SVG update completed for product:", productData?.id);
// }, [productData, partMappings, group.current]);

// // Then update the useEffect to use this function
// useEffect(() => {
//   console.log("SVG Effect Triggered");
  
//   if (!svgContainerRef.current) {
//     return;
//   }

//   const shouldRefetch =
//     !svgStateRef.current || currentSvgUrlRef.current !== state.svg;

//   if (shouldRefetch) {
//     fetch(`${state.svg}?cacheBust=${Date.now()}`)
//       .then((res) => res.text())
//       .then((svgText) => {
//         const parser = new DOMParser();
//         const baseSVG = parser
//           .parseFromString(svgText, "image/svg+xml")
//           .querySelector("svg");

//         if (!baseSVG) {
//           console.warn("SVG not found");
//           return;
//         }

//         svgStateRef.current = baseSVG;
//         currentSvgUrlRef.current = state.svg;
        
//         // Call the external function
//         updateAndRenderSVG();
//       });
//   } else {
//     // Call the external function
//     updateAndRenderSVG();
//   }
// }, [
//   state.svg,
//   updateAndRenderSVG // Add this as dependency
// ]);
//     useEffect(() => {
//       console.log("svg new : ", state.svg);
//       if (!svgContainerRef.current) return;

//       // Check if SVG URL has changed
//       const shouldRefetch =
//         !svgStateRef.current || currentSvgUrlRef.current !== state.svg;

//       if (shouldRefetch) {
//         fetch(`${state.svg}?cacheBust=${Date.now()}`)
//           .then((res) => res.text())
//           .then((svgText) => {
//             console.log("svgText : ", svgText);
//             const parser = new DOMParser();
//             const baseSVG = parser
//               .parseFromString(svgText, "image/svg+xml")
//               .querySelector("svg");

//             console.log("baseSVG : ", baseSVG);

//             if (!baseSVG) {
//               console.warn("SVG not found");
//               return;
//             }

//             svgStateRef.current = baseSVG;
//             currentSvgUrlRef.current = state.svg; // Track current SVG URL
//             updateAndRenderSVG();
//           });
//       } else {
//         updateAndRenderSVG();
//       }

//       async function updateAndRenderSVG() {
//         const baseSVG = svgStateRef.current.cloneNode(true);
//         const scaleGroup = baseSVG.querySelector("#scale");
//         console.log("scaleGroup : ", scaleGroup);
//         if (!scaleGroup) return;

//         // Use productData instead of snap
//         const partColors = productData?.partColors || {};
//         const gradientColors = productData?.gradientColors || {};
//         const unwrappedPattern = unwrapProxy(
//           productData?.selectedPattern || {}
//         );
//         const normalizedPattern = Object.fromEntries(
//           Object.entries(unwrappedPattern).map(([key, val]) => [
//             key.toUpperCase(),
//             val,
//           ])
//         );

//         const directColorParts = ["DESIGN", "LOGO", "NECK"];

//         directColorParts.forEach((partName) => {
//           const color = partColors?.[partName];
//           if (!color) return;

//           const groupObj = group.current;
//           if (!groupObj) return;

//           groupObj.traverse((child) => {
//             if (!child.isMesh || !child.material) return;

//             const materials = Array.isArray(child.material)
//               ? child.material
//               : [child.material];

//             materials.forEach((mat) => {
//               if (mat.name === partName) {
//                 mat.color.set(color);
//                 mat.needsUpdate = true;
//               }
//             });
//           });
//         });

//         const patternApplyPromises = [];

//         console.log("partMappings : ", partMappings);

//         Object.entries(partMappings).forEach(
//           ([materialName, targetElements]) => {
//             const baseColor = partColors[materialName];
//             const gradientColor = gradientColors[materialName];
//             const patternData = normalizedPattern?.[materialName.toUpperCase()];

//             console.log("baseColor : ", baseColor);

//             if ((!baseColor && !patternData) || !targetElements) return;

//             const matchingPaths = Array.from(
//               scaleGroup.querySelectorAll("path")
//             ).filter((path) => {
//               let nameAttr = null;
//               path.getAttributeNames().forEach((attr) => {
//                 if (attr.toLowerCase() === "elementname") {
//                   nameAttr = path.getAttribute(attr);
//                 }
//               });
//               return (
//                 nameAttr && targetElements.includes(nameAttr.toUpperCase())
//               );
//             });

//             matchingPaths.forEach((path) => {
//               if (patternData?.image) {
//                 if (materialName === "TEE") {
//                   const promise = applyPatternToPath(
//                     baseSVG,
//                     matchingPaths,
//                     patternData,
//                     materialName,
//                     `${materialName}_${patternData.name}`
//                   );
//                   patternApplyPromises.push(promise);
//                 } else {
//                   // apply individually
//                   matchingPaths.forEach((path) => {
//                     const promise = applyPatternToPath(
//                       baseSVG,
//                       [path], // wrap in array
//                       patternData,
//                       materialName,
//                       `${materialName}_${patternData.name}`
//                     );
//                     patternApplyPromises.push(promise);
//                   });
//                 }
//               }

//               if (baseColor && gradientColor) {
//                 applyGradientToPath(
//                   baseSVG,
//                   path,
//                   baseColor,
//                   gradientColor,
//                   `grad-${materialName}`
//                 );
//               } else if (baseColor) {
//                 path.setAttribute("fill", baseColor);
//               }
//             });
//           }
//         );

//         // Wait for all pattern fills to complete
//         await Promise.all(patternApplyPromises);

//         const texture = await loadTextureFromSVG(baseSVG);
//         baseColorTextureRef.current = texture;

//         group.current?.traverse((child) => {
//           if (!child.isMesh || !child.material) return;

//           const materials = Array.isArray(child.material)
//             ? child.material
//             : [child.material];

//           materials.forEach((mat) => {
//             if (!partMappings[mat.name]) return;

//             mat.map?.dispose();
//             mat.map = texture;
//             mat.map.flipY = false;
//             mat.map.colorSpace = THREE.SRGBColorSpace;
//             mat.color.set("#ffffff");
//             mat.needsUpdate = true;
//           });
//         });
//       }
//     }, [
//          productData?.id,
//       productData?.partColors,
//       productData?.gradientColors,
//       productData?.selectedPattern,
//       productData?.patternColors,
//       state.svg,
//       currentProduct
//     ]);

//     const logoTexture = useMemo(() => {
//       if (!productData?.frontLogo) return null;
//       // Create a larger canvas with logo centered and smaller
//       const canvas = document.createElement("canvas");
//       canvas.width = 2048;  // Increased canvas size for better quality
//       canvas.height = 2048; // Increased canvas size for better quality
//       const ctx = canvas.getContext("2d", { alpha: true });
      
//       // Enable image smoothing for better quality
//       ctx.imageSmoothingEnabled = true;
//       ctx.imageSmoothingQuality = 'high';
      
//       // Clear canvas with transparent background
//       ctx.clearRect(0, 0, canvas.width, canvas.height);

//       // Create texture from the canvas
//       const texture = new THREE.CanvasTexture(canvas);
//       texture.colorSpace = THREE.SRGBColorSpace;
//       texture.premultiplyAlpha = false; // Changed to false for better transparency
//       texture.generateMipmaps = true; // Enable mipmaps for better quality
//       texture.minFilter = THREE.LinearMipmapLinearFilter;
//       texture.magFilter = THREE.LinearFilter;

//       // Create an image to load the logo
//       const img = new Image();
//       img.crossOrigin = "anonymous";
//       img.onload = () => {
//         try {
//           // Clear canvas again before drawing
//           ctx.clearRect(0, 0, canvas.width, canvas.height);
          
//           // Set logo width to 800px while preserving aspect ratio (increased for better visibility)
//           const targetWidth = 800; // Fixed width of 800px
//           const imgWidth = img.naturalWidth || img.width;
//           const imgHeight = img.naturalHeight || img.height;
          
//           // Calculate height to maintain aspect ratio
//           const aspectRatio = imgHeight / imgWidth;
//           const drawWidth = targetWidth;
//           const drawHeight = targetWidth * aspectRatio;
          
//           // Center the logo on the canvas
//           const x = (canvas.width - drawWidth) / 2;
//           const y = (canvas.height - drawHeight) / 2;
          
//           // Draw the image centered and smaller
//           ctx.drawImage(img, 0, 0, img.naturalWidth || img.width, img.naturalHeight || img.height, x, y, drawWidth, drawHeight);
          
//           // Force texture update
//           texture.needsUpdate = true;
//         } catch (error) {
//           console.error("Error drawing logo to canvas:", error);
//         }
//       };
//       img.onerror = (error) => {
//         console.error("Error loading logo image:", error);
//       };
//       img.src = productData.frontLogo;

//       return texture;
//     }, [productData?.frontLogo]);

//     const logoTextureBack = useMemo(() => {
//       if (!productData?.backLogo) return null;
//       // Create a larger canvas with logo centered and smaller
//       const canvas = document.createElement("canvas");
//       canvas.width = 2048;  // Increased canvas size for better quality
//       canvas.height = 2048; // Increased canvas size for better quality
//       const ctx = canvas.getContext("2d", { alpha: true });
      
//       // Enable image smoothing for better quality
//       ctx.imageSmoothingEnabled = true;
//       ctx.imageSmoothingQuality = 'high';
      
//       // Clear canvas with transparent background
//       ctx.clearRect(0, 0, canvas.width, canvas.height);

//       // Create texture from the canvas
//       const texture = new THREE.CanvasTexture(canvas);
//       texture.colorSpace = THREE.SRGBColorSpace;
//       texture.premultiplyAlpha = false; // Changed to false for better transparency
//       texture.generateMipmaps = true; // Enable mipmaps for better quality
//       texture.minFilter = THREE.LinearMipmapLinearFilter;
//       texture.magFilter = THREE.LinearFilter;

//       // Create an image to load the logo
//       const img = new Image();
//       img.crossOrigin = "anonymous";
//       img.onload = () => {
//         try {
//           // Clear canvas again before drawing
//           ctx.clearRect(0, 0, canvas.width, canvas.height);
          
//           // Set logo width to 800px while preserving aspect ratio (increased for better visibility)
//           const targetWidth = 800; // Fixed width of 800px
//           const imgWidth = img.naturalWidth || img.width;
//           const imgHeight = img.naturalHeight || img.height;
          
//           // Calculate height to maintain aspect ratio
//           const aspectRatio = imgHeight / imgWidth;
//           const drawWidth = targetWidth;
//           const drawHeight = targetWidth * aspectRatio;
          
//           // Center the logo on the canvas
//           const x = (canvas.width - drawWidth) / 2;
//           const y = (canvas.height - drawHeight) / 2;
          
//           // Draw the image centered and smaller
//           ctx.drawImage(img, 0, 0, img.naturalWidth || img.width, img.naturalHeight || img.height, x, y, drawWidth, drawHeight);
          
//           // Force texture update
//           texture.needsUpdate = true;
//         } catch (error) {
//           console.error("Error drawing logo to canvas:", error);
//         }
//       };
//       img.onerror = (error) => {
//         console.error("Error loading logo image:", error);
//       };
//       img.src = productData.backLogo;

//       return texture;
//     }, [productData?.backLogo]);

//     useEffect(() => {
//       if (logoTexture) {
//         logoTexture.needsUpdate = true;
//       }
//     }, [logoTexture]);

//     useEffect(() => {
//       if (logoTextureBack) {
//         logoTextureBack.needsUpdate = true;
//       }
//     }, [logoTextureBack]);

//     const createCanvasTexture = () => {
//       const canvas = document.createElement("canvas");
//       canvas.width = 1024;
//       canvas.height = 512;
//       return new CanvasTexture(canvas);
//     };

//     const frontTextTexture = useRef(createCanvasTexture());
//     const backTextTexture = useRef(createCanvasTexture());
//     const frontNumberTexture = useRef(createCanvasTexture());
//     const backNumberTexture = useRef(createCanvasTexture());

//     // const updateTexture = (
//     //   text,
//     //   textureRef,
//     //   partName,
//     //   fontFamily,
//     //   colorType = "text"
//     // ) => {
//     //   if (!text || !textureRef.current) return;

//     //   const canvas = textureRef.current.image;
//     //   const ctx = canvas.getContext("2d");

//     //   if (!ctx) {
//     //     console.error("Canvas context not found.");
//     //     return;
//     //   }

//     //   ctx.clearRect(0, 0, canvas.width, canvas.height);

//     //   // Use different color properties based on colorType
//     //   let color;
//     //   if (colorType === "text") {
//     //     // For text: use textColors.front or textColors.back from current product
//     //     color = partName.includes("front")
//     //       ? productData?.textColors?.front || "#ffffff"
//     //       : productData?.textColors?.back || "#ffffff";
//     //   } else if (colorType === "number") {
//     //     // For numbers: use numberColors.front or numberColors.back from current product
//     //     color = partName.includes("front")
//     //       ? productData?.numberColors?.front || "#ffffff"
//     //       : productData?.numberColors?.back || "#ffffff";
//     //   } else {
//     //     // Fallback
//     //     color = "#ffffff";
//     //   }

//     //   ctx.fillStyle = color;
//     //   ctx.font = `bold 80px ${fontFamily}`;
//     //   ctx.textAlign = "center";
//     //   ctx.textBaseline = "middle";
//     //   ctx.fillText(text, canvas.width / 2, canvas.height / 2);

//     //   textureRef.current.needsUpdate = true;
//     // };

//     // useEffect(() => {
//     //   // For front text
//     //   updateTexture(
//     //     productData?.frontText || "",
//     //     frontTextTexture,
//     //     "front",
//     //     productData?.textFonts?.front || productData?.selectedFonts || "Arial",
//     //     "text"
//     //   );

//     //   // For back text
//     //   updateTexture(
//     //     productData?.backText || "",
//     //     backTextTexture,
//     //     "back",
//     //     productData?.textFonts?.back || productData?.selectedFonts || "Arial",
//     //     "text"
//     //   );

//     //   // For front number - use number colors
//     //   updateTexture(
//     //     productData?.frontNumber || "",
//     //     frontNumberTexture,
//     //     "frontNumber",
//     //     productData?.numberFonts?.front || productData?.selectedFonts || "Arial",
//     //     "number"
//     //   );

//     //   // For back number - use number colors
//     //   updateTexture(
//     //     productData?.backNumber || "",
//     //     backNumberTexture,
//     //     "backNumber",
//     //     productData?.numberFonts?.back || productData?.selectedFonts || "Arial",
//     //     "number"
//     //   );
//     // }, [
//     //   productData?.frontText,
//     //   productData?.backText,
//     //   productData?.frontNumber,
//     //   productData?.backNumber,
//     //   productData?.textColors?.front,
//     //   productData?.textColors?.back,
//     //   productData?.numberColors?.front,
//     //   productData?.numberColors?.back,
//     //   productData?.textFonts?.front,
//     //   productData?.textFonts?.back,
//     //   productData?.numberFonts?.front,
//     //   productData?.numberFonts?.back,
//     //   productData?.selectedFonts,
//     // ]);

//     // useEffect(() => {
//     //   // For front text
//     //   updateTexture(
//     //     snap.frontText,
//     //     frontTextTexture,
//     //     "front",
//     //     state.textFonts?.front || state.selectedFonts,
//     //     "text" // Specify this is text
//     //   );

//     //   // For back text
//     //   updateTexture(
//     //     snap.backText,
//     //     backTextTexture,
//     //     "back",
//     //     state.textFonts?.back || state.selectedFonts,
//     //     "text" // Specify this is text
//     //   );

//     //   // For front number - use number colors
//     //   updateTexture(
//     //     snap.frontNumber,
//     //     frontNumberTexture,
//     //     "frontNumber",
//     //     state.numberFonts?.front || state.selectedFonts,
//     //     "number" // Specify this is number
//     //   );

//     //   // For back number - use number colors
//     //   updateTexture(
//     //     snap.backNumber,
//     //     backNumberTexture,
//     //     "backNumber",
//     //     state.numberFonts?.back || state.selectedFonts,
//     //     "number" // Specify this is number
//     //   );
//     // }, [
//     //   snap.frontText,
//     //   snap.backText,
//     //   snap.frontNumber,
//     //   snap.backNumber,
//     //   // Watch for text color changes
//     //   snap.textColors?.front,
//     //   snap.textColors?.back,
//     //   // Watch for number color changes
//     //   snap.numberColors?.front,
//     //   snap.numberColors?.back,
//     //   state.textFonts?.front,
//     //   state.textFonts?.back,
//     //   state.numberFonts?.front,
//     //   state.numberFonts?.back,
//     //   state.selectedFonts,
//     // ]);

//     useEffect(() => {
//       console.log("Updating textures for product:", productData?.id);
//       console.log("Front text:", productData?.frontText);
//       console.log("Front number:", productData?.frontNumber);

//       // For front text
//       updateTexture(
//         productData?.frontText || "",
//         frontTextTexture,
//         "front",
//         productData?.textFonts?.front || productData?.selectedFonts || "Arial",
//         "text"
//       );

//       // For back text
//       updateTexture(
//         productData?.backText || "",
//         backTextTexture,
//         "back",
//         productData?.textFonts?.back || productData?.selectedFonts || "Arial",
//         "text"
//       );

//       // For front number - use number colors
//       updateTexture(
//         productData?.frontNumber || "",
//         frontNumberTexture,
//         "frontNumber",
//         productData?.numberFonts?.front ||
//           productData?.selectedFonts ||
//           "Arial",
//         "number"
//       );

//       // For back number - use number colors
//       updateTexture(
//         productData?.backNumber || "",
//         backNumberTexture,
//         "backNumber",
//         productData?.numberFonts?.back || productData?.selectedFonts || "Arial",
//         "number"
//       );
//     }, [
//       productData?.id, // Add this to trigger when product changes
//       productData?.frontText,
//       productData?.backText,
//       productData?.frontNumber,
//       productData?.backNumber,
//       productData?.textColors?.front,
//       productData?.textColors?.back,
//       productData?.numberColors?.front,
//       productData?.numberColors?.back,
//       productData?.textFonts?.front,
//       productData?.textFonts?.back,
//       productData?.numberFonts?.front,
//       productData?.numberFonts?.back,
//       productData?.selectedFonts,
//     ]);

//     const updateTexture = (
//       text,
//       textureRef,
//       partName,
//       fontFamily,
//       colorType = "text"
//     ) => {
//       if (!textureRef.current) return;

//       const canvas = textureRef.current.image;
//       const ctx = canvas.getContext("2d");

//       if (!ctx) {
//         console.error("Canvas context not found.");
//         return;
//       }

//       // Always clear the canvas
//       ctx.clearRect(0, 0, canvas.width, canvas.height);

//       // Only draw if there's text
//       if (text && text.trim() !== "") {
//         // Use different color properties based on colorType
//         let color;
//         if (colorType === "text") {
//           // For text: use textColors.front or textColors.back from current product
//           color = partName.includes("front")
//             ? productData?.textColors?.front || "#ffffff"
//             : productData?.textColors?.back || "#ffffff";
//         } else if (colorType === "number") {
//           // For numbers: use numberColors.front or numberColors.back from current product
//           color = partName.includes("front")
//             ? productData?.numberColors?.front || "#ffffff"
//             : productData?.numberColors?.back || "#ffffff";
//         } else {
//           // Fallback
//           color = "#ffffff";
//         }

//         ctx.fillStyle = color;
//         ctx.font = `bold 80px ${fontFamily || "Arial"}`;
//         ctx.textAlign = "center";
//         ctx.textBaseline = "middle";
//         ctx.fillText(text, canvas.width / 2, canvas.height / 2);
//       }

//       textureRef.current.needsUpdate = true;
//     };

//     // Remove or update this useEffect
//     // useEffect(() => {
//     //   updateTexture(snap.frontText, frontTextTexture, "front");
//     //   updateTexture(snap.backText, backTextTexture, "back");
//     //   updateTexture(snap.frontNumber, frontNumberTexture, "frontNumber");
//     //   updateTexture(snap.backNumber, backNumberTexture, "backNumber");
//     // }, [state.updateTrigger]);

//     // Replace it with this:
//     useEffect(() => {
//       // Trigger texture updates when global updateTrigger changes
//       if (productData) {
//         updateTexture(
//           productData.frontText || "",
//           frontTextTexture,
//           "front",
//           productData.textFonts?.front || productData.selectedFonts || "Arial",
//           "text"
//         );

//         updateTexture(
//           productData.backText || "",
//           backTextTexture,
//           "back",
//           productData.textFonts?.back || productData.selectedFonts || "Arial",
//           "text"
//         );

//         updateTexture(
//           productData.frontNumber || "",
//           frontNumberTexture,
//           "frontNumber",
//           productData.numberFonts?.front ||
//             productData.selectedFonts ||
//             "Arial",
//           "number"
//         );

//         updateTexture(
//           productData.backNumber || "",
//           backNumberTexture,
//           "backNumber",
//           productData.numberFonts?.back || productData.selectedFonts || "Arial",
//           "number"
//         );
//       }
//     }, [state.updateTrigger]);

//     // ==========================================
//     // CLEAN INTERACTION STATE - FROM SCRATCH
//     // ==========================================
//     const [interactionMode, setInteractionMode] = useState("idle"); // idle, dragging, resizing
//     const [selectedDecal, setSelectedDecal] = useState(null); // Which decal is selected
//     const [isDragging, setIsDragging] = useState(false);
//     const [isResizing, setIsResizing] = useState(false);
//     const [activeCorner, setActiveCorner] = useState(null); // tl, tr, bl, br
//     const [dragStartPos, setDragStartPos] = useState({ x: 0, y: 0 });
//     const [initialDecalPos, setInitialDecalPos] = useState([0, 0, 0]);
//     const [initialDecalScale, setInitialDecalScale] = useState([1, 1, 1]);
//     const hasDraggedRef = useRef(false); // Track if we actually moved during drag
//     const dragStartPosRef = useRef({ x: 0, y: 0 });
//     const initialDecalPosRef = useRef([0, 0, 0]);
//     const lastDragPositionRef = useRef([0, 0, 0]);
//     const selectedDecalDragRef = useRef(null);
//     const rotationIntervalRef = useRef(null); // Legacy – unused when using rAF
//     const rotationRAFRef = useRef(null); // For requestAnimationFrame-based continuous rotation
//     const rotationDirectionRef = useRef(null); // Track rotation direction (clockwise/anticlockwise)
//     const rotationLastTimeRef = useRef(0);

//     const [decalPositions, setDecalPositions] = useState({
//       frontText: frontTextPosition,
//       backText: backTextPosition,
//       frontNumber: frontNumberPosition,
//       backNumber: backNumberPosition,
//       frontLogo: frontLogoPosition,
//       backLogo: backLogoPosition,
//     });
//     const [decalScales, setDecalScales] = useState({
//       frontText: frontTextScale,
//       backText: backTextScale,
//       frontNumber: frontNumberScale,
//       backNumber: backNumberScale,
//       frontLogo: frontLogoScale,
//       backLogo: backLogoScale,
//     });

//     const [decalRotations, setDecalRotations] = useState({
//       frontText: 0,
//       frontNumber: 0,
//       frontLogo: 0,
//       backText: 0,
//       backNumber: 0,
//       backLogo: 0,
//     });

//     console.log("decalRotations:", decalRotations);

//     const transformTargetsRef = useRef({});
//     const [transformMode, setTransformMode] = useState("translate");
//     const [, setIsTransforming] = useState(false);

//     useEffect(() => {
//       const modelKey = state.newKey;

//       if (modelKey === "eventordereventjersey") {
//         console.log("state.selectedDesignId:", glbId);
//         const designId = String(glbId || "902");

//         console.log("Updating positions for event order design:", designId);

//         let modelConfig = modelConfig1[modelKey]?.[designId];

//         if (!modelConfig) {
//           console.warn(
//             "No config found for design ID:",
//             designId,
//             "falling back to 902"
//           );
//           modelConfig = modelConfig1[modelKey]?.["902"];
//         }

//         if (!modelConfig) {
//           console.error("No valid config found even for fallback 902!");
//           return;
//         }

//         console.log("Found config for design:", designId, modelConfig);

//         setDecalPositions({
//           frontText: modelConfig.frontTextPosition || [0, 0, 0],
//           frontNumber: modelConfig.frontNumberPosition || [0, 0, 0],
//           frontLogo: modelConfig.frontLogoPosition || [0, 0, 0],
//           backText: modelConfig.backTextPosition || [0, 0, 0],
//           backNumber: modelConfig.backNumberPosition || [0, 0, 0],
//           backLogo: modelConfig.backLogoPosition || [0, 0, 0],
//         });

//         setDecalScales({
//           frontText: modelConfig.frontTextScale || [1, 1, 1],
//           frontNumber: modelConfig.frontNumberScale || [1, 1, 1],
//           frontLogo: modelConfig.frontLogoScale || [1, 1, 1],
//           backText: modelConfig.backTextScale || [1, 1, 1],
//           backNumber: modelConfig.backNumberScale || [1, 1, 1],
//           backLogo: modelConfig.backLogoScale || [1, 1, 1],
//         });

//         if (modelConfig.fontSize) setFontSizetext(modelConfig.fontSize);
//         if (modelConfig.fontSizeNumber)
//           setFontSizeNumber(modelConfig.fontSizeNumber);

//         console.log("📍 Updated decal positions for design:", designId);
//       }
//     }, [glbId]);

//     const [tempPosition, setTempPosition] = useState([0, 0, 0]);
//     const [tempScale, setTempScale] = useState([0, 0, 0]);
//     const [mouseStartPos, setMouseStartPos] = useState({ x: 0, y: 0 });
//     const fabricCanvasCache = useRef({});
//     const textureCache = useRef({});
//     const lastOverlayClickTime = useRef(0);
//     const [isFrontVisible, setIsFrontVisible] = useState(true);

//     const rotateIconScreenPosRef = useRef({ x: 0, y: 0 });
//     const rotateClickTimeRef = useRef(0);
//     const [showRotateTooltip, setShowRotateTooltip] = useState(null);

//     const [resizeArrowPosition, setResizeArrowPosition] = useState({
//       x: 0,
//       y: 0,
//     });

//     useEffect(() => {
//       const handleTransformHotkeys = (event) => {
//         if (!selectedDecal || !selectedDecal.toLowerCase().includes("text")) {
//           return;
//         }

//         if (event.key === "t" || event.key === "T") {
//           setTransformMode("translate");
//         }

//         if (event.key === "s" || event.key === "S") {
//           setTransformMode("scale");
//         }
//       };

//       window.addEventListener("keydown", handleTransformHotkeys);
//       return () =>
//         window.removeEventListener("keydown", handleTransformHotkeys);
//     }, [selectedDecal]);

//     const resizeArrowPositionRef = useRef({ x: 0, y: 0 });

//     const getFabricCanvas = useCallback((type) => {
//       if (fabricCanvasCache.current[type]) {
//         return fabricCanvasCache.current[type];
//       }

//       const canvas = document.createElement("canvas");
//       // Use smaller canvas for numbers to prevent head cutting off
//       if (type.includes("Number")) {
//         canvas.width = 400;  // Smaller canvas for numbers
//         canvas.height = 200; // Smaller canvas for numbers
//       } else {
//         canvas.width = 512;  // Reduced from 1024 - smaller canvas for tighter text bounds
//         canvas.height = 256; // Reduced from 512 - smaller canvas for tighter text bounds
//       }

//       const fabricCanvas = new fabric.Canvas(canvas, {
//         enableRetinaScaling: false,
//         renderOnAddRemove: false,
//         selection: false,
//         preserveObjectStacking: true,

//         skipTargetFind: false,
//         skipOffscreen: true,
//         imageSmoothingEnabled: true,

//         renderOnSelectionChange: false,

//         allowTouchScrolling: false,
//         fireRightClick: false,
//         stopContextMenu: true,
//       });

//       fabricCanvasCache.current[type] = {
//         canvas,
//         fabricCanvas,
//         texture: new THREE.CanvasTexture(canvas),
//       };

//       return fabricCanvasCache.current[type];
//     }, []);

//     useEffect(() => {
//       return () => {
//         Object.values(textureCache.current).forEach((texture) => {
//           if (texture && texture.dispose) {
//             texture.dispose();
//           }
//         });
//         textureCache.current = {};
//         fabricCanvasCache.current = {};
//       };
//     }, []);

//         useEffect(() => {
//       return () => {
//         stopContinuousRotation();
//       };
//     }, [selectedDecal]);

//     useEffect(() => {
//       if (!selectedDecal) return;

//       const handleKeyDown = (e) => {
//         if (!selectedDecal) return;
//         if (
//           !["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)
//         )
//           return;

//         e.preventDefault();
//         const moveAmount = 0.01;
//         const currentPos = [...decalPositions[selectedDecal]];

//         //console.log("currentPos : ", currentPos);
//         switch (e.key) {
//           case "ArrowUp":
//             currentPos[1] += moveAmount;
//             break;
//           case "ArrowDown":
//             currentPos[1] -= moveAmount;
//             break;
//           case "ArrowLeft":
//             currentPos[0] -= moveAmount;
//             break;
//           case "ArrowRight":
//             currentPos[0] += moveAmount;
//             break;
//           default:
//             break;
//         }

//         //console.log("currentPos : ", currentPos);
//         setDecalPositions((prev) => ({
//           ...prev,
//           [selectedDecal]: currentPos,
//         }));
//         setTempPosition(currentPos);
//       };
//       window.addEventListener("keydown", handleKeyDown);
//       return () => {
//         window.removeEventListener("keydown", handleKeyDown);
//       };
//     }, [selectedDecal, decalPositions]);

//     const handleDeselect = () => {
//       setSelectedDecal(null);
//       setResizeMode(false);
//       setResizeCorner(null);
//       setInitialScale(null);
//       setIsDragging(false);
//       setIsResizing(false);
//       setActiveCorner(null);
//       // Always set to rotate-shirt mode when deselecting to enable rotation
//       setInteractionMode("rotate-shirt");

//       Object.keys(fabricCanvasCache.current).forEach((type) => {
//         const { fabricCanvas } = fabricCanvasCache.current[type];
//         fabricCanvas.discardActiveObject();
//         fabricCanvas.renderAll();
//       });
//     };

//     const [fontSizetext, setFontSizetext] = useState(() => {
//       const settings = getModelSettings(menuSlug, subcategorySlug);
//       return settings.fontSize || 50; // Reduced from 80 to 50
//     });

//     const [fontSizeNumber, setFontSizeNumber] = useState(() => {
//       const settings = getModelSettings(menuSlug, subcategorySlug);
//       return settings.fontSizeNumber || 60; // Reduced from 80 to 60
//     });


//     const getTextTexture = useCallback(
//       (type, textContent, color, font, isSelected) => {
//         if (!textContent || textContent.trim() === "") return null;

//         console.log("textContent : ", textContent);

//         try {
//           const { canvas, fabricCanvas, texture } = getFabricCanvas(type);

//           fabricCanvas.clear();

//           // No padding: keep text tight to texture for minimal gap from t-shirt
//           const text = new fabric.Text(textContent, {
//             left: canvas.width / 2,
//             top: canvas.height / 2,
//             originX: "center",
//             originY: "center",
//             fontSize: (fontSizetext || 80) * 1.35,  // Reduced by 20px from previous (1.6 * 80 = 128px, now 1.35 * 80 = 108px)
//             fontWeight: "bold",
//             fontFamily: font || "Arial",
//             fill: color || "black",
//             selectable: false,
//             hasControls: false,
//             hasBorders: false,
//             padding: 0,
//             borderColor: "transparent",
//             cornerSize: 0,
//             transparentCorners: true,
//             lockUniScaling: false,
//             hoverCursor: "default",
//             moveCursor: "default",
//             objectCaching: false,
//             borderScaleFactor: 0,
//             controls: {
//               tr: new fabric.Control({
//                 x: 0.5,
//                 y: -0.5,
//                 actionHandler: fabric.controlsUtils.rotationWithSnapping,
//                 cursorStyleHandler: () => "crosshair",
//                 // render: function (ctx, left, top, styleOverride, fabricObject) {
//                 //   const size = 60;
//                 //   ctx.save();
//                 //   ctx.translate(left, top);
//                 //   ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));

//                 //   ctx.beginPath();

//                 //   ctx.arc(0, 0, size / 2, 0, 2 * Math.PI);
//                 //   ctx.fillStyle = "white";
//                 //   ctx.fill();
//                 //   ctx.strokeStyle = "black";
//                 //   ctx.lineWidth = 3;
//                 //   ctx.stroke();

//                 //   ctx.beginPath();
//                 //   ctx.moveTo(size * 0.25, -size * 0.25);
//                 //   ctx.lineTo(size * 0.5, 0);
//                 //   ctx.lineTo(size * 0.25, size * 0.25);
//                 //   ctx.lineWidth = 7;
//                 //   ctx.stroke();

//                 //   ctx.beginPath();
//                 //   ctx.arc(
//                 //     0,
//                 //     0,
//                 //     size * 0.35,
//                 //     -Math.PI * 0.25,
//                 //     Math.PI * 1.5,
//                 //     false
//                 //   );
//                 //   ctx.lineWidth = 7;
//                 //   ctx.stroke();

//                 //   ctx.restore();
//                 // },
//                 actionName: "rotate",
//               }),
//               br: new fabric.Control({
//                 x: 0.5,
//                 y: 0.5,
//                 actionHandler: fabric.controlsUtils.scalingEqually,
//                 cursorStyleHandler: () => "nwse-resize",
//                 render: function (ctx, left, top, styleOverride, fabricObject) {
//                   const size = 60;
//                   ctx.save();
//                   ctx.translate(left, top);

//                   ctx.beginPath();
//                   ctx.rect(-size / 2, -size / 2, size, size);
//                   ctx.fillStyle = "white";
//                   ctx.fill();
//                   ctx.strokeStyle = "black";
//                   ctx.lineWidth = 3;
//                   ctx.stroke();

//                   ctx.beginPath();
//                   // Main line
//                   ctx.moveTo(-size * 0.35, -size * 0.35);
//                   ctx.lineTo(size * 0.35, size * 0.35);

//                   // Arrowhead
//                   ctx.moveTo(size * 0.35, size * 0.35);
//                   ctx.lineTo(size * 0.2, size * 0.35);
//                   ctx.lineTo(size * 0.35, size * 0.2);
//                   ctx.closePath();

//                   ctx.fillStyle = "black";
//                   ctx.fill();
//                   ctx.strokeStyle = "black";
//                   ctx.lineWidth = 7;
//                   ctx.stroke();

//                   ctx.restore();
//                 },
//                 actionName: "scale",
//               }),
//             },
//           });

//           text.set({
//             stroke: color || "black",
//             strokeWidth: 1,
//             strokeUniform: true,
//           });

//           fabricCanvas.add(text);

//           if (isSelected) {
//             fabricCanvas.setActiveObject(text);
//             text.bringToFront();

//             text.on("rotating", function (e) {
//               const angle = e.target.angle;
//               if (type.includes("front")) {
//                 frontTextRotation[2] = THREE.MathUtils.degToRad(angle);
//               } else {
//                 backTextRotation[2] = THREE.MathUtils.degToRad(angle);
//               }
//             });

//             text.on("scaling", function (e) {
//               const scale = e.target.scaleX;
//               if (type.includes("front")) {
//                 frontTextScale[0] = scale;
//                 frontTextScale[1] = scale;
//               } else {
//                 backTextScale[0] = scale;
//                 backTextScale[1] = scale;
//               }
//             });

//             // Disabled arrow creation for new resize feature
//             // requestAnimationFrame(() => {
//             //   const textBounds = text.getBoundingRect();
//             //   calculateAndStoreArrowPosition(type, textBounds);
//             // });
//           }

//           // Render fabric canvas and update texture
//           fabricCanvas.renderAll();
//           texture.needsUpdate = true;

//           return texture;
//         } catch (error) {
//           console.error("Error creating text texture:", error);

//           // Fallback canvas drawing
//           const fallbackCanvas = document.createElement("canvas");
//           fallbackCanvas.width = 512;  // Reduced canvas size
//           fallbackCanvas.height = 256; // Reduced canvas size
//           const ctx = fallbackCanvas.getContext("2d");

//           ctx.fillStyle = color || "white";
//           ctx.font = `108px ${font || "Arial"}`;  // Reduced by 20px (1.35 * 80 = 108px)
//           ctx.textAlign = "center";
//           ctx.textBaseline = "middle";
//           ctx.fillText(
//             textContent,
//             fallbackCanvas.width / 2,
//             fallbackCanvas.height / 2
//           );

//           return new THREE.CanvasTexture(fallbackCanvas);
//         }
//       },
//       [getFabricCanvas, fontSizetext]
//     );

//     const getNumberTexture = useCallback(
//       (type, textContent, color, font, isSelected) => {
//         if (!textContent || textContent.trim() === "") return null;

//         try {
//           const { canvas, fabricCanvas, texture } = getFabricCanvas(type);

//           fabricCanvas.clear();

//           const text = new fabric.Text(textContent, {
//             left: canvas.width / 2,
//             top: canvas.height / 2,
//             originX: "center",
//             originY: "center",
//             fontSize: (fontSizeNumber || 80) * 0.55,  // Reduced by 40px for numbers (was 84px, now 0.55 * 80 = 44px)
//             fontWeight: "bold",
//             fontFamily: font || "Arial",
//             fill: color || "black",
//             selectable: false,
//             hasControls: false,
//             hasBorders: false,
//             borderColor: "transparent",
//             cornerSize: 0,
//             transparentCorners: true,
//             lockUniScaling: false,
//             hoverCursor: "default",
//             moveCursor: "default",
//             objectCaching: false,
//             borderScaleFactor: 0,
//             controls: {
//               tr: new fabric.Control({
//                 x: 0.5,
//                 y: -0.5,
//                 actionHandler: fabric.controlsUtils.rotationWithSnapping,
//                 cursorStyleHandler: () => "crosshair",
//                 // render: function (ctx, left, top, styleOverride, fabricObject) {
//                 //   const size = 60;
//                 //   ctx.save();
//                 //   ctx.translate(left, top);
//                 //   ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
//                 //   ctx.beginPath();
//                 //   ctx.arc(0, 0, size / 2, 0, 2 * Math.PI);
//                 //   ctx.fillStyle = "white";
//                 //   ctx.fill();
//                 //   ctx.strokeStyle = "black";
//                 //   ctx.lineWidth = 3;
//                 //   ctx.stroke();

//                 //   ctx.beginPath();
//                 //   ctx.moveTo(size * 0.25, -size * 0.25);
//                 //   ctx.lineTo(size * 0.5, 0);
//                 //   ctx.lineTo(size * 0.25, size * 0.25);
//                 //   ctx.lineWidth = 7;
//                 //   ctx.stroke();

//                 //   ctx.beginPath();
//                 //   ctx.arc(
//                 //     0,
//                 //     0,
//                 //     size * 0.35,
//                 //     -Math.PI * 0.25,
//                 //     Math.PI * 1.5,
//                 //     false
//                 //   );
//                 //   ctx.lineWidth = 7;
//                 //   ctx.stroke();

//                 //   ctx.restore();
//                 // },
//                 actionName: "rotate",
//               }),
//               br: new fabric.Control({
//                 x: 0.5,
//                 y: 0.5,
//                 actionHandler: fabric.controlsUtils.scalingEqually,
//                 cursorStyleHandler: () => "nwse-resize",
//                 render: function (ctx, left, top, styleOverride, fabricObject) {
//                   const size = 60;
//                   ctx.save();
//                   ctx.translate(left, top);

//                   ctx.beginPath();
//                   ctx.rect(-size / 2, -size / 2, size, size);
//                   ctx.fillStyle = "white";
//                   ctx.fill();
//                   ctx.strokeStyle = "black";
//                   ctx.lineWidth = 3;
//                   ctx.stroke();

//                   ctx.beginPath();

//                   ctx.moveTo(-size * 0.35, -size * 0.35);
//                   ctx.lineTo(size * 0.35, size * 0.35);

//                   ctx.moveTo(size * 0.35, size * 0.35);
//                   ctx.lineTo(size * 0.2, size * 0.35);
//                   ctx.lineTo(size * 0.35, size * 0.2);
//                   ctx.closePath();

//                   ctx.fillStyle = "black";
//                   ctx.fill();
//                   ctx.strokeStyle = "black";
//                   ctx.lineWidth = 7;
//                   ctx.stroke();

//                   ctx.restore();
//                 },
//                 actionName: "scale",
//               }),
//             },
//           });

//           // Slight stroke to harden number edges
//           text.set({
//             stroke: color || "black",
//             strokeWidth: 1,
//             strokeUniform: true,
//           });

//           // Add to canvas
//           fabricCanvas.add(text);

//           if (isSelected) {
//             fabricCanvas.setActiveObject(text);
//             text.bringToFront();

//             // Rotation tracking
//             text.on("rotating", function (e) {
//               const angle = e.target.angle;
//               if (type.includes("front")) {
//                 frontNumberRotation[2] = THREE.MathUtils.degToRad(angle);
//               } else {
//                 backNumberRotation[2] = THREE.MathUtils.degToRad(angle);
//               }
//             });

//             // Scaling tracking
//             text.on("scaling", function (e) {
//               const scale = e.target.scaleX;
//               if (type.includes("front")) {
//                 frontNumberScale[0] = frontNumberScale[1] = scale;
//               } else {
//                 backNumberScale[0] = backNumberScale[1] = scale;
//               }
//             });

//             // Disabled arrow creation for new resize feature
//             // requestAnimationFrame(() => {
//             //   const textBounds = text.getBoundingRect();
//             //   calculateAndStoreArrowPosition(type, textBounds);
//             // });
//           }

//           fabricCanvas.renderAll();
//           texture.needsUpdate = true;

//           return texture;
//         } catch (error) {
//           console.error("Error creating number texture:", error);

//           // Fallback 2D canvas version
//           const fallbackCanvas = document.createElement("canvas");
//           fallbackCanvas.width = 400;  // Smaller canvas for numbers
//           fallbackCanvas.height = 200; // Smaller canvas for numbers
//           const ctx = fallbackCanvas.getContext("2d");

//           ctx.fillStyle = color || "white";
//           ctx.font = `44px ${font || "Arial"}`;  // Reduced by 40px for numbers (was 84px, now 44px)
//           ctx.textAlign = "center";
//           ctx.textBaseline = "middle";
//           ctx.fillText(
//             textContent,
//             fallbackCanvas.width / 2,
//             fallbackCanvas.height / 2
//           );

//           return new THREE.CanvasTexture(fallbackCanvas);
//         }
//       },
//       [getFabricCanvas, fontSizeNumber]
//     );

//     // Maintain decal aspect ratio to prevent squishing when multiple overlays overlap
//     const getAspectAwareScale = useCallback((type, baseScale, texture) => {
//       const scaleArray = Array.isArray(baseScale)
//         ? baseScale
//         : [baseScale, baseScale, baseScale];
//       const base = scaleArray[0] || 1;

//       // Default aspect is square
//       let aspect = 1;

//       // Text and number canvases use 1024x512 => height/width = 0.5
//       if (type.includes("Text") || type.includes("Number")) {
//         aspect = 512 / 1024;
//       }

//       // Logos: use the actual texture dimensions when available
//       if (
//         type.includes("Logo") &&
//         texture &&
//         texture.image &&
//         texture.image.width &&
//         texture.image.height
//       ) {
//         aspect = texture.image.height / texture.image.width;
//       }

//       // Keep Z as original if provided
//       const z = scaleArray[2] !== undefined ? scaleArray[2] : base;
//       return [base, base * aspect, z];
//     }, []);

    

//     const [resizeMode, setResizeMode] = useState(false);
//     const [resizeStartPos, setResizeStartPos] = useState({ x: 0, y: 0 });
//     const [initialScale, setInitialScale] = useState(null);
//     const [resizeCorner, setResizeCorner] = useState(null);
//     const [resizeBorderVisible, setResizeBorderVisible] = useState(false);
//     const selectedDecalRef = useRef(null);
//     const [pendingResizeEvent, setPendingResizeEvent] = useState(null);

//     // NEW RESIZE FEATURE - Completely separate from existing functions
//     const [newResizeActive, setNewResizeActive] = useState(false);
//     const [newResizeStartPos, setNewResizeStartPos] = useState({ x: 0, y: 0 });
//     const [newResizeInitialScale, setNewResizeInitialScale] = useState(null);
//     const [newResizeSelectedDecal, setNewResizeSelectedDecal] = useState(null);
//     const [newResizeTempScale, setNewResizeTempScale] = useState([0, 0, 0]);
//     const [newResizeCorner, setNewResizeCorner] = useState(null);

//      // REPLACE your detectCornerClick function with this updated version:
//     const detectCornerClick = (e, decalType, camera) => {
//       console.log("Corner Detection start");
//       console.log(`selectedDecal: ${selectedDecal}, decalType: ${decalType}`);

//       if (!selectedDecal && !decalType) {
//         console.log("No selected decal or decal type");
//         return false;
//       }

//       const position = decalPositions[decalType];
//       const currentScale = decalScales[decalType];

//       if (!camera || !position || !currentScale) {
//         console.error("Camera, position, or scale missing");
//         return false;
//       }

//       console.log(`Position: ${position}, Scale: ${currentScale}`);

//       // Get model-specific configuration
//       const modelKey = state.newKey;
//       let modelConfig = modelConfig1[modelKey];

//       // SPECIAL HANDLING for eventordereventjersey - it has subcategories
//       if (modelKey === "eventordereventjersey" && state.selectedDesignId) {
//         modelConfig =
//           modelConfig1[modelKey][state.selectedDesignId] ||
//           modelConfig1[modelKey];
//         console.log(
//           `Using eventorder category: ${state.selectedDesignId}`,
//           modelConfig
//         );
//       }

//       console.log(`Model: ${modelKey}`, modelConfig);

//       // MODEL-SPECIFIC CORNER DETECTION CALCULATION
//       let threshold = 50;
//       let widthDivisor = 10;
//       let heightDivisor = 10;

//       if (modelConfig && currentScale) {
//         const overallScale = modelConfig.overallScale || 1;
//         const modelScale = Array.isArray(modelConfig.scale)
//           ? modelConfig.scale[0]
//           : modelConfig.scale || 1;
//         const currentScaleX = currentScale[0] || 1;
//         const currentScaleY = currentScale[1] || 1;

//         console.log(
//           `Model: ${modelKey}, DesignID: ${state.selectedDesignId}, Scale analysis:`,
//           {
//             overallScale,
//             modelScale,
//             currentScaleX,
//             currentScaleY,
//           }
//         );

//         if (modelKey === "menmenjersey") {
//           widthDivisor = 8;
//           heightDivisor = 8;
//           threshold = 60;
//         } else if (modelKey === "eventordereventjersey") {
//           const designId = state.selectedDesignId;
//           if (designId === "900" || designId === 900) {
//             widthDivisor = 3;
//             heightDivisor = 4;
//             threshold = 70;
//           } else if (designId === "901" || designId === 901) {
//             widthDivisor = 2.5;
//             heightDivisor = 3;
//             threshold = 80;
//           } else if (designId === "902" || designId === 902) {
//             widthDivisor = 8;
//             heightDivisor = 8;
//             threshold = 60;
//           } else if (designId === "903" || designId === 903) {
//             widthDivisor = 2;
//             heightDivisor = 2.5;
//             threshold = 75;
//           } else if (designId === "904" || designId === 904) {
//             widthDivisor = 3;
//             heightDivisor = 3.5;
//             threshold = 70;
//           } else {
//             widthDivisor = 3;
//             heightDivisor = 4;
//             threshold = 70;
//           }
//         } else if (modelKey === "womenwomenfootballjersey") {
//           widthDivisor = 6;
//           heightDivisor = 6;
//           threshold = 65;
//         } else if (
//           modelKey === "menmencricketshorts" ||
//           modelKey === "menmenshorts"
//         ) {
//           widthDivisor = 4;
//           heightDivisor = 5;
//           threshold = 70;
//         } else if (modelKey === "womenwomenbadmintonshorts") {
//           widthDivisor = 3.5;
//           heightDivisor = 4;
//           threshold = 65;
//         } else if (modelKey === "womenwomentrackpants") {
//           widthDivisor = 4;
//           heightDivisor = 5;
//           threshold = 60;
//         } else if (modelKey === "womenwomencyclingjersey") {
//           widthDivisor = 15;
//           heightDivisor = 15;
//           threshold = 45;
//         } else if (modelKey === "menmentanktop") {
//           widthDivisor = 3;
//           heightDivisor = 3.5;
//           threshold = 70;
//         } else if (modelKey === "menmencyclingjersey") {
//           widthDivisor = 2.5;
//           heightDivisor = 3;
//           threshold = 80;
//         } else if (modelKey === "menmentrackpants") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//           threshold = 65;
//         } else if (modelKey === "menmencricketjersey") {
//           widthDivisor = 8;
//           heightDivisor = 8;
//           threshold = 60;
//         } else if (modelKey === "menmenarmsleeves") {
//           widthDivisor = 2.5;
//           heightDivisor = 3;
//           threshold = 75;
//         } else if (modelKey === "menmenbasketballshorts") {
//           widthDivisor = 4.5;
//           heightDivisor = 5;
//           threshold = 65;
//         } else if (modelKey === "womenwomenbadmintonjersey") {
//           widthDivisor = 2;
//           heightDivisor = 2.5;
//           threshold = 75;
//         } else if (modelKey === "menmensoccerjersey") {
//           widthDivisor = 2;
//           heightDivisor = 2.5;
//           threshold = 80;
//         } else if (modelKey === "womenwomenjersey") {
//           widthDivisor = 3;
//           heightDivisor = 3.5;
//           threshold = 70;
//         } else if (modelKey === "menmenbasketballjersey") {
//           widthDivisor = 3;
//           heightDivisor = 3.5;
//           threshold = 70;
//         } else if (modelKey === "kidskidsbasketballjersey") {
//           widthDivisor = 3;
//           heightDivisor = 3.5;
//           threshold = 70;
//         } else if (modelKey === "menmencitycollection") {
//           widthDivisor = 2;
//           heightDivisor = 2.5;
//           threshold = 75;
//         } else if (modelKey === "menmenxjersey") {
//           widthDivisor = 2;
//           heightDivisor = 2.5;
//           threshold = 75;
//         } else if (modelKey === "kidskidscricketshorts") {
//           widthDivisor = 4.5;
//           heightDivisor = 5;
//           threshold = 65;
//         } else if (modelKey === "kidskidsshorts") {
//           widthDivisor = 4.5;
//           heightDivisor = 5;
//           threshold = 65;
//         } else if (modelKey === "menmenfootballjersey") {
//           widthDivisor = 2.5;
//           heightDivisor = 3;
//           threshold = 75;
//         } else if (modelKey === "womenwomencricketjersey") {
//           widthDivisor = 3.5;
//           heightDivisor = 4;
//           threshold = 65;
//         } else if (modelKey === "womenwomenbadmintontanktop") {
//           widthDivisor = 7;
//           heightDivisor = 7;
//           threshold = 55;
//         } else if (modelKey === "womenwomenxjersey") {
//           widthDivisor = 5;
//           heightDivisor = 5;
//           threshold = 60;
//         } else if (modelKey === "kidskidscricketjersey") {
//           widthDivisor = 3;
//           heightDivisor = 4;
//           threshold = 70;
//         } else if (modelKey === "kidskidscyclingjersey") {
//           widthDivisor = 4;
//           heightDivisor = 5;
//           threshold = 65;
//         } else if (modelKey === "kidskidsjersey") {
//           widthDivisor = 4;
//           heightDivisor = 5;
//           threshold = 65;
//         } else if (modelKey === "kidskidstanktop") {
//           widthDivisor = 3;
//           heightDivisor = 3.5;
//           threshold = 70;
//         } else if (modelKey === "kidskidsbasictshirt") {
//           widthDivisor = 4;
//           heightDivisor = 4.5;
//           threshold = 65;
//         } else if (modelKey === "womenwomencompressionpants") {
//           widthDivisor = 3.5;
//           heightDivisor = 4;
//           threshold = 65;
//         } else {
//           widthDivisor = 5;
//           heightDivisor = 6;
//           threshold = 60;
//         }

//         console.log(`Corner detection config:`, {
//           widthDivisor: widthDivisor.toFixed(2),
//           heightDivisor: heightDivisor.toFixed(2),
//           threshold: threshold.toFixed(2),
//         });
//       }

//       const getEventCoords = (event) => {
//         if (event.touches && event.touches.length > 0) {
//           return { x: event.touches[0].clientX, y: event.touches[0].clientY };
//         }
//         return { x: event.clientX, y: event.clientY };
//       };

//       const coords = getEventCoords(e);
//       const clickX = coords.x;
//       const clickY = coords.y;

//       console.log(`Click coordinates: [${clickX}, ${clickY}]`);

//       const center3D = new THREE.Vector3(...position);
//       console.log("3D Center Position: ", center3D);

//       let adjustedPosition = center3D.clone();

//       console.log("Adjusted 3D Position: ", adjustedPosition);

//       const projectedCenter = adjustedPosition.clone().project(camera);
//       console.log("Projected Center: ", projectedCenter);

//       // FIXED: Better validation for projected coordinates
//       if (
//         Math.abs(projectedCenter.x) > 3 ||
//         Math.abs(projectedCenter.y) > 3 ||
//         projectedCenter.z <= 0 ||
//         projectedCenter.z > 1
//       ) {
//         console.error("❌ Projected coordinates are invalid");
//         console.log(
//           `Raw projected: [${projectedCenter.x}, ${projectedCenter.y}, ${projectedCenter.z}]`
//         );
//         return false;
//       }

//       const screenCenterX = (projectedCenter.x * 0.5 + 0.5) * window.innerWidth;
//       const screenCenterY =
//         (1 - (projectedCenter.y * 0.5 + 0.5)) * window.innerHeight;

//       console.log(
//         `📺 Screen center: [${screenCenterX.toFixed(
//           2
//         )}, ${screenCenterY.toFixed(2)}]`
//       );

//       let normalizedScaleX = Math.min(currentScale[0] / 50, 1);
//       let normalizedScaleY = Math.min(currentScale[1] / 50, 1);

//       if (modelKey === "womenwomencyclingjersey") {
//         normalizedScaleX = Math.min(currentScale[0] / 80, 0.8);
//         normalizedScaleY = Math.min(currentScale[1] / 80, 0.8);
//       }

//       const screenHalfWidth =
//         (normalizedScaleX * window.innerWidth) / widthDivisor;
//       const screenHalfHeight =
//         (normalizedScaleY * window.innerHeight) / heightDivisor;

//       console.log(
//         `Screen half dimensions: W=${screenHalfWidth.toFixed(
//           2
//         )}, H=${screenHalfHeight.toFixed(2)}`
//       );

//       const maxDimension = Math.min(window.innerWidth, window.innerHeight) / 4;
//       const cappedWidth = Math.min(screenHalfWidth, maxDimension);
//       const cappedHeight = Math.min(screenHalfHeight, maxDimension);

//       if (
//         cappedWidth !== screenHalfWidth ||
//         cappedHeight !== screenHalfHeight
//       ) {
//         console.log(
//           `Dimensions capped: W=${screenHalfWidth.toFixed(
//             2
//           )}->${cappedWidth.toFixed(2)}, H=${screenHalfHeight.toFixed(
//             2
//           )}->${cappedHeight.toFixed(2)}`
//         );
//       }

//       console.log(
//         `Capped dimensions: W=${cappedWidth.toFixed(
//           2
//         )}, H=${cappedHeight.toFixed(2)}`
//       );

//       const corners = {
//         tl: {
//           x: screenCenterX - cappedWidth,
//           y: screenCenterY - cappedHeight,
//           type: "tl",
//         },
//         tr: {
//           x: screenCenterX + cappedWidth,
//           y: screenCenterY - cappedHeight,
//           type: "tr",
//         },
//         bl: {
//           x: screenCenterX - cappedWidth,
//           y: screenCenterY + cappedHeight,
//           type: "bl",
//         },
//         br: {
//           x: screenCenterX + cappedWidth,
//           y: screenCenterY + cappedHeight,
//           type: "br",
//         },
//       };

//       console.log(`Corners:`, corners);

//       let closestCorner = null;
//       let minDistance = Infinity;

//       for (let key in corners) {
//         const dx = clickX - corners[key].x;
//         const dy = clickY - corners[key].y;
//         const dist = Math.hypot(dx, dy);

//         console.log(
//           `📍 Corner ${key}: [${corners[key].x.toFixed(2)}, ${corners[
//             key
//           ].y.toFixed(2)}] distance=${dist.toFixed(2)}`
//         );

//         if (dist < minDistance) {
//           minDistance = dist;
//           closestCorner = corners[key];
//         }
//       }

//       console.log(
//         `Closest corner: ${
//           closestCorner?.type
//         }, distance: ${minDistance.toFixed(2)}, threshold: ${threshold}`
//       );

//       if (minDistance < threshold) {
//         console.log("Corner detected!");
//         setPendingResizeEvent(e);
//         return closestCorner.type;
//       }

//       console.log("No corner detected");
//       return false;
//     };

//     useEffect(() => {
//       const modelKey = state.newKey;
//       let modelConfig = modelConfig1[modelKey];

//       if (modelKey === "eventordereventjersey" && state.selectedDesignId) {
//         modelConfig = modelConfig1[modelKey][state.selectedDesignId];
//         console.log(
//           `Event Order Category: ${state.selectedDesignId}`,
//           modelConfig
//         );
//       }

//       console.log(`Active Model Config: ${modelKey}`, {
//         overallScale: modelConfig?.overallScale,
//         scale: modelConfig?.scale,
//         rotation: modelConfig?.rotation,
//       });
//     }, [state.newKey, state.selectedDesignId]);

//     const detectNewResizeCorner = (e, decalType, camera) => {
//       console.log("NEW Corner Detection start");
//       if (!newResizeSelectedDecal || newResizeSelectedDecal !== decalType)
//         return false;

//       const position = decalPositions[decalType];
//       const currentScale = decalScales[decalType];
//       console.log("position:", position, "currentScale:", currentScale);

//       if (!camera) {
//         console.error("Camera not found");
//         return false;
//       }

//       // Get model-specific configuration
//       const modelKey = state.newKey;
//       const modelConfig = modelConfig1[modelKey];

//       // Use a dynamic threshold based on model scale
//       let threshold = 40; // Base threshold for new resize
//       let widthDivisor = 8;
//       let heightDivisor = 8;

//       // Adjust threshold and divisors based on model's overall scale
//       if (modelConfig) {
//         const scaleFactor = modelConfig.overallScale || 1;
//         threshold = Math.max(25, Math.min(60, threshold * (10 / scaleFactor)));

//         // MODEL-SPECIFIC DIVISOR CALCULATION FOR NEW RESIZE
//         if (modelKey === "menmenjersey") {
//           widthDivisor = 12;
//           heightDivisor = 12;
//         } else if (modelKey === "eventordereventjersey") {
//           const designId = state.selectedDesignId;
//           if (designId === "900" || designId === 900) {
//             widthDivisor = 5;
//             heightDivisor = 6;
//           } else if (designId === "901" || designId === 901) {
//             widthDivisor = 4;
//             heightDivisor = 5;
//           } else if (designId === "902" || designId === 902) {
//             widthDivisor = 12;
//             heightDivisor = 12;
//           } else if (designId === "903" || designId === 903) {
//             widthDivisor = 3;
//             heightDivisor = 4;
//           } else if (designId === "904" || designId === 904) {
//             widthDivisor = 5;
//             heightDivisor = 6;
//           } else {
//             widthDivisor = 5;
//             heightDivisor = 6;
//           }
//         } else if (modelKey === "womenwomenfootballjersey") {
//           widthDivisor = 9;
//           heightDivisor = 9;
//         } else if (
//           modelKey === "menmencricketshorts" ||
//           modelKey === "menmenshorts"
//         ) {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "womenwomenbadmintonshorts") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else if (modelKey === "womenwomentrackpants") {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "womenwomencyclingjersey") {
//           widthDivisor = 20;
//           heightDivisor = 20;
//         } else if (modelKey === "menmentanktop") {
//           widthDivisor = 4;
//           heightDivisor = 5;
//         } else if (modelKey === "menmencyclingjersey") {
//           widthDivisor = 4;
//           heightDivisor = 5;
//         } else if (modelKey === "menmentrackpants") {
//           widthDivisor = 7;
//           heightDivisor = 8;
//         } else if (modelKey === "menmencricketjersey") {
//           widthDivisor = 12;
//           heightDivisor = 12;
//         } else if (modelKey === "menmenarmsleeves") {
//           widthDivisor = 4;
//           heightDivisor = 5;
//         } else if (modelKey === "menmenbasketballshorts") {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "womenwomenbadmintonjersey") {
//           widthDivisor = 3;
//           heightDivisor = 4;
//         } else if (modelKey === "menmensoccerjersey") {
//           widthDivisor = 3;
//           heightDivisor = 4;
//         } else if (modelKey === "womenwomenjersey") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else if (modelKey === "menmenbasketballjersey") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else if (modelKey === "kidskidsbasketballjersey") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else if (modelKey === "menmencitycollection") {
//           widthDivisor = 3;
//           heightDivisor = 4;
//         } else if (modelKey === "menmenxjersey") {
//           widthDivisor = 3;
//           heightDivisor = 4;
//         } else if (modelKey === "kidskidscricketshorts") {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "kidskidsshorts") {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "menmenfootballjersey") {
//           widthDivisor = 4;
//           heightDivisor = 5;
//         } else if (modelKey === "womenwomencricketjersey") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else if (modelKey === "womenwomenbadmintontanktop") {
//           widthDivisor = 10;
//           heightDivisor = 10;
//         } else if (modelKey === "womenwomenxjersey") {
//           widthDivisor = 7;
//           heightDivisor = 7;
//         } else if (modelKey === "kidskidscricketjersey") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else if (modelKey === "kidskidscyclingjersey") {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "kidskidsjersey") {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "kidskidstanktop") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else if (modelKey === "kidskidsbasictshirt") {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "womenwomencompressionpants") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else {
//           widthDivisor = 7;
//           heightDivisor = 8;
//         }

//         console.log(
//           `Model: ${modelKey}, Overall Scale: ${scaleFactor}, Threshold: ${threshold}, Divisors: W=${widthDivisor}, H=${heightDivisor}`
//         );
//       }

//       // Get coordinates from either mouse or touch event
//       const getEventCoords = (event) => {
//         if (event.touches && event.touches.length > 0) {
//           return { x: event.touches[0].clientX, y: event.touches[0].clientY };
//         }
//         return { x: event.clientX, y: event.clientY };
//       };

//       const coords = getEventCoords(e);
//       const clickX = coords.x;
//       const clickY = coords.y;
//       console.log(`Click coordinates: [${clickX}, ${clickY}]`);

//       // Get the 3D position and project to screen
//       const center3D = new THREE.Vector3(...position);
//       console.log("3D Center Position: ", center3D);

//       // FIXED: Apply position adjustment for womenwomencyclingjersey to fix extreme Y values
//       let adjustedPosition = center3D.clone();

//       // SPECIAL FIX for womenwomencyclingjersey - adjust problematic Y positions
//       if (modelKey === "womenwomencyclingjersey") {
//         console.log(`🔧 Applying cycling jersey position fix for ${decalType}`);

//         // Reduce the extreme Y values that are causing projection issues
//         if (
//           decalType.includes("frontText") ||
//           decalType.includes("frontNumber") ||
//           decalType.includes("backText") ||
//           decalType.includes("backNumber")
//         ) {
//           // Scale down the extreme Y values while maintaining relative positioning
//           adjustedPosition.y = adjustedPosition.y * 0.3; // Reduce Y by 70%
//           console.log(
//             `🔧 Adjusted Y position: ${center3D.y} -> ${adjustedPosition.y}`
//           );
//         }
//       }

//       // Project center to screen coordinates
//       const projectedCenter = adjustedPosition.clone().project(camera);

//       // FIXED: More lenient validation for projected coordinates
//       let projectedX = projectedCenter.x;
//       let projectedY = projectedCenter.y;

//       // Clamp projected coordinates to reasonable range if they're extreme
//       if (Math.abs(projectedX) > 10 || Math.abs(projectedY) > 10) {
//         console.log("🔄 Clamping extreme projected coordinates");
//         projectedX = Math.max(-5, Math.min(5, projectedX));
//         projectedY = Math.max(-5, Math.min(5, projectedY));
//       }

//       const screenCenterX = (projectedX * 0.5 + 0.5) * window.innerWidth;
//       const screenCenterY = (1 - (projectedY * 0.5 + 0.5)) * window.innerHeight;

//       console.log(
//         `Screen center: [${screenCenterX.toFixed(2)}, ${screenCenterY.toFixed(
//           2
//         )}]`
//       );

//       // FIXED: Improved scale calculation with better normalization
//       let normalizedScaleX = Math.min(currentScale[0] / 80, 0.7);
//       let normalizedScaleY = Math.min(currentScale[1] / 80, 0.7);

//       // Special adjustment for womenwomencyclingjersey to make corner area smaller
//       if (modelKey === "womenwomencyclingjersey") {
//         normalizedScaleX = Math.min(currentScale[0] / 120, 0.5);
//         normalizedScaleY = Math.min(currentScale[1] / 120, 0.5);
//       }

//       const screenHalfWidth =
//         (normalizedScaleX * window.innerWidth) / widthDivisor;
//       const screenHalfHeight =
//         (normalizedScaleY * window.innerHeight) / heightDivisor;

//       console.log(
//         `Screen half dimensions: W=${screenHalfWidth.toFixed(
//           2
//         )}, H=${screenHalfHeight.toFixed(2)}`
//       );

//       // Safety check: Cap dimensions to reasonable screen bounds
//       const maxDimension = Math.min(window.innerWidth, window.innerHeight) / 5;
//       const cappedWidth = Math.min(screenHalfWidth, maxDimension);
//       const cappedHeight = Math.min(screenHalfHeight, maxDimension);

//       if (
//         cappedWidth !== screenHalfWidth ||
//         cappedHeight !== screenHalfHeight
//       ) {
//         console.log(
//           `Dimensions capped: W=${screenHalfWidth.toFixed(
//             2
//           )}->${cappedWidth.toFixed(2)}, H=${screenHalfHeight.toFixed(
//             2
//           )}->${cappedHeight.toFixed(2)}`
//         );
//       }

//       // Define corners in screen space
//       const corners = {
//         tl: {
//           x: screenCenterX - cappedWidth,
//           y: screenCenterY - cappedHeight,
//           type: "tl",
//         },
//         tr: {
//           x: screenCenterX + cappedWidth,
//           y: screenCenterY - cappedHeight,
//           type: "tr",
//         },
//         bl: {
//           x: screenCenterX - cappedWidth,
//           y: screenCenterY + cappedHeight,
//           type: "bl",
//         },
//         br: {
//           x: screenCenterX + cappedWidth,
//           y: screenCenterY + cappedHeight,
//           type: "br",
//         },
//       };

//       console.log("Corners:", corners);

//       // Find closest corner
//       let closestCorner = null;
//       let minDistance = Infinity;

//       for (let key in corners) {
//         const dx = clickX - corners[key].x;
//         const dy = clickY - corners[key].y;
//         const dist = Math.hypot(dx, dy);

//         console.log(
//           `Corner ${key}: [${corners[key].x.toFixed(2)}, ${corners[
//             key
//           ].y.toFixed(2)}] distance=${dist.toFixed(2)}`
//         );

//         if (dist < minDistance) {
//           minDistance = dist;
//           closestCorner = corners[key];
//           console.log(
//             `New closest corner: ${key} with distance ${dist.toFixed(2)}`
//           );
//         }
//       }

//       console.log(
//         `NEW Closest corner distance: ${minDistance.toFixed(
//           2
//         )}, threshold: ${threshold}`
//       );

//       if (minDistance < threshold) {
//         console.log("✅ NEW Corner detected!");
//         return closestCorner.type;
//       }

//       console.log("❌ NEW No corner detected");
//       return false;
//     };

//     const handleNewResizeFunction = (e) => {
//       if (
//         !newResizeActive ||
//         !newResizeSelectedDecal ||
//         !newResizeInitialScale ||
//         !newResizeCorner
//       )
//         return;

//       const getEventCoords = (event) => {
//         if (event.touches && event.touches.length > 0) {
//           return { x: event.touches[0].clientX, y: event.touches[0].clientY };
//         }
//         return { x: event.clientX, y: event.clientY };
//       };

//       const modelKey = state.newKey;
//       const coords = getEventCoords(e);
//       let deltaX = coords.x - newResizeStartPos.x;
//       let deltaY = coords.y - newResizeStartPos.y;

//       if (modelKey === "womenwomenbadmintonjersey") {
//         deltaX = -deltaX;
//         deltaY = -deltaY;
//       }

//       if (
//         modelKey === "menmenjersey" ||
//         modelKey === "menmencricketjersey" ||
//         modelKey === "womenwomenfootballjersey" ||
//         modelKey === "womenwomenxjersey" ||
//         modelKey === "womenwomenbadmintontanktop" ||
//         (!modelKey === "eventordereventjersey" &&
//           (glbId === "900" || glbId === "904"))
//       ) {
//         const sensitivity = newResizeSelectedDecal.includes("Logo")
//           ? 0.005
//           : 0.003;
//         let newScale = [...newResizeInitialScale];

//         requestAnimationFrame(() => {
//           switch (newResizeCorner) {
//             case "tl":
//               newScale[0] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[0] - deltaX * sensitivity)
//               );
//               newScale[1] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[1] - deltaY * sensitivity)
//               );
//               break;
//             case "tr":
//               newScale[0] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[0] + deltaX * sensitivity)
//               );
//               newScale[1] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[1] - deltaY * sensitivity)
//               );
//               break;
//             case "bl":
//               newScale[0] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[0] - deltaX * sensitivity)
//               );
//               newScale[1] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[1] + deltaY * sensitivity)
//               );
//               break;
//             case "br":
//               newScale[0] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[0] + deltaX * sensitivity)
//               );
//               newScale[1] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[1] + deltaY * sensitivity)
//               );
//               break;
//             default:
//               break;
//           }

//           setNewResizeTempScale(newScale);
//           setDecalScales((prev) => ({
//             ...prev,
//             [newResizeSelectedDecal]: newScale,
//           }));

//           if (newResizeSelectedDecal.includes("front")) {
//             frontLogoScale[0] = newScale[0];
//             frontLogoScale[1] = newScale[1];
//           } else if (newResizeSelectedDecal.includes("back")) {
//             backLogoScale[0] = newScale[0];
//             backLogoScale[1] = newScale[1];
//           }
//         });
//       } else {
//         console.log(
//           "------------------------------------------------------------------"
//         );
//         const sensitivity = newResizeSelectedDecal.includes("Logo")
//           ? 0.005
//           : 0.003;
//         const diagonalDelta = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

//         let scaleFactor = 1;
//         switch (newResizeCorner) {
//           case "tl":
//             scaleFactor =
//               1 +
//               (deltaX < 0 && deltaY < 0 ? -diagonalDelta : diagonalDelta) *
//                 sensitivity;
//             break;
//           case "tr":
//             scaleFactor =
//               1 +
//               (deltaX > 0 && deltaY < 0 ? -diagonalDelta : diagonalDelta) *
//                 sensitivity;
//             break;
//           case "bl":
//             scaleFactor =
//               1 +
//               (deltaX < 0 && deltaY > 0 ? -diagonalDelta : diagonalDelta) *
//                 sensitivity;
//             break;
//           case "br":
//             scaleFactor =
//               1 +
//               (deltaX > 0 && deltaY > 0 ? diagonalDelta : -diagonalDelta) *
//                 sensitivity;
//             break;
//         }

//         const newScale = newResizeInitialScale.map((s) =>
//           Math.max(5, Math.min(300, s * scaleFactor))
//         );

//         requestAnimationFrame(() => {
//           setNewResizeTempScale(newScale);
//           setDecalScales((prev) => ({
//             ...prev,
//             [newResizeSelectedDecal]: newScale,
//           }));

//           if (newResizeSelectedDecal.includes("front")) {
//             frontLogoScale[0] = newScale[0];
//             frontLogoScale[1] = newScale[1];
//           } else if (newResizeSelectedDecal.includes("back")) {
//             backLogoScale[0] = newScale[0];
//             backLogoScale[1] = newScale[1];
//           }
//         });
//       }
//     };

//     // NEW RESIZE END FUNCTION
//     const endNewResize = () => {
//       console.log("Ending NEW resize function");

//       setNewResizeActive(false);
//       setNewResizeSelectedDecal(null);
//       setNewResizeInitialScale(null);
//       setNewResizeTempScale([0, 0, 0]);
//       setNewResizeCorner(null);
//       setInteractionMode("rotate-shirt");
//     };
//     useFrame(() => {
//       if (!group.current) return;

//       // Update which side is visible based on rotation (only when it changes)
//       const normalizedRotation =
//         ((group.current.rotation.y % (Math.PI * 2)) + Math.PI * 2) %
//         (Math.PI * 2);
//       const isFront =
//         normalizedRotation < Math.PI / 2 ||
//         normalizedRotation > (3 * Math.PI) / 2;

//       // Only update state if visibility changed to avoid unnecessary re-renders
//       if (isFront !== isFrontVisible) {
//         setIsFrontVisible(isFront);
//       }

//       // Don't rotate if a decal is selected or if not in rotate-shirt mode
//       if (selectedDecal || interactionMode !== "rotate-shirt") return;

//       const targetYRotation = snap.viewSide === "front" ? 0 : Math.PI;
//       group.current.rotation.y +=
//         (targetYRotation - group.current.rotation.y) * 0.1;
//     });
//     useEffect(() => {
//       if (resizeMode && selectedDecal && pendingResizeEvent) {
//         handleResizeMove(pendingResizeEvent);
//         setPendingResizeEvent(null);
//       }
//     }, [resizeMode, selectedDecal, pendingResizeEvent]);
//     useEffect(() => {
//       if (resizeMode && selectedDecal && pendingResizeEvent) {
//         handlePointerMove(pendingResizeEvent);
//         setPendingResizeEvent(null);
//       }
//     }, [resizeMode, selectedDecal, pendingResizeEvent]);

//     // NEW RESIZE FEATURE - Ensure full screen event capture
//     useEffect(() => {
//       if (interactionMode === "new-resize-mode") {
//         // Add global event listeners for better event capture
//         const handleGlobalPointerMove = (e) => {
//           if (newResizeActive) {
//             handleNewResizeFunction(e);
//           }
//         };

//         const handleGlobalPointerUp = (e) => {
//           if (newResizeActive) {
//             handlePointerUp(e);
//           }
//         };

//         document.addEventListener("pointermove", handleGlobalPointerMove);
//         document.addEventListener("pointerup", handleGlobalPointerUp);
//         document.addEventListener("mousemove", handleGlobalPointerMove);
//         document.addEventListener("mouseup", handleGlobalPointerUp);
//         document.addEventListener("touchmove", handleGlobalPointerMove);
//         document.addEventListener("touchend", handleGlobalPointerUp);

//         return () => {
//           document.removeEventListener("pointermove", handleGlobalPointerMove);
//           document.removeEventListener("pointerup", handleGlobalPointerUp);
//           document.removeEventListener("mousemove", handleGlobalPointerMove);
//           document.removeEventListener("mouseup", handleGlobalPointerUp);
//           document.removeEventListener("touchmove", handleGlobalPointerMove);
//           document.removeEventListener("touchend", handleGlobalPointerUp);
//         };
//       }
//     }, [interactionMode, newResizeActive]);

//     // ==========================================
//     // START DRAGGING DECAL
//     // ==========================================
//     const handleDecalDragStart = (e, decalType) => {
//       e.stopPropagation();

//       if (rotationRAFRef.current || rotationDirectionRef.current) return;

//       // Access native event for preventDefault
//       const nativeEvent = e.nativeEvent || e;
//       if (nativeEvent && typeof nativeEvent.preventDefault === "function") {
//         nativeEvent.preventDefault();
//       }

//       const getCoords = (event) => {
//         const evt = event.nativeEvent || event;
//         if (evt.touches && evt.touches.length > 0) {
//           return { x: evt.touches[0].clientX, y: evt.touches[0].clientY };
//         }
//         return { x: evt.clientX, y: evt.clientY };
//       };

//       const coords = getCoords(e);
//       const currentPos = decalPositions[decalType] || [0, 0, 0];

//       console.log("🚀 Drag start:", decalType, coords);

//       // Capture pointer to ensure we get all subsequent events
//       const target = e.target || (nativeEvent && nativeEvent.target);
//       const pointerId = e.pointerId || (nativeEvent && nativeEvent.pointerId);
//       if (target && pointerId !== undefined) {
//         try {
//           target.setPointerCapture(pointerId);
//         } catch (err) {
//           console.log("Pointer capture not available");
//         }
//       }

//       setSelectedDecal(decalType);
//       setIsDragging(true);
//       setInteractionMode("dragging");
//       setDragStartPos(coords);
//       setInitialDecalPos([...currentPos]);
//       hasDraggedRef.current = false;
//       dragStartPosRef.current = { ...coords };
//       initialDecalPosRef.current = [...currentPos];
//       lastDragPositionRef.current = [...currentPos];
//       selectedDecalDragRef.current = decalType;
//     };

//     const [isRotating, setIsRotating] = useState(false);
//     const [rotationStartAngle, setRotationStartAngle] = useState(0);
//     const [rotationCenter, setRotationCenter] = useState({ x: 0, y: 0 });

//     // Update cursor during rotation
//     useEffect(() => {
//       if (isRotating) {
//         document.body.style.cursor = "grabbing";
//       }
//       return () => {
//         if (isRotating) {
//           document.body.style.cursor = "auto";
//         }
//       };
//     }, [isRotating]);

//     // const handleDecalRotate = (e, decalType) => {
//     //   // Stop all event propagation FIRST to prevent background click
//     //   if (e?.stopPropagation) e.stopPropagation();
//     //   if (e?.nativeEvent?.stopPropagation) e.nativeEvent.stopPropagation();
//     //   if (e?.nativeEvent?.stopImmediatePropagation)
//     //     e.nativeEvent.stopImmediatePropagation();

//     //   // Prevent default behavior
//     //   const nativeEvent = e.nativeEvent || e;
//     //   if (nativeEvent && typeof nativeEvent.preventDefault === "function") {
//     //     nativeEvent.preventDefault();
//     //   }

//     //   // Record timestamp to prevent background click from deselecting
//     //   const now = Date.now();
//     //   lastOverlayClickTime.current = now;

//     //   const getCoords = (event) => {
//     //     const evt = event.nativeEvent || event;
//     //     if (evt.touches && evt.touches.length > 0) {
//     //       return { x: evt.touches[0].clientX, y: evt.touches[0].clientY };
//     //     }
//     //     return { x: evt.clientX, y: evt.clientY };
//     //   };

//     //   const coords = getCoords(e);

//     //   // Get the decal center position in screen coordinates
//     //   const decalPosition = decalPositions[decalType] || [0, 0, 0];
//     //   const modelKey = state.newKey;
//     //   let modelConfig = modelConfig1[modelKey];

//     //   if (modelKey === "eventordereventjersey" && glbId) {
//     //     modelConfig = modelConfig1[modelKey][glbId] || modelConfig1[modelKey];
//     //   }

//     //   const center3D = new THREE.Vector3(...decalPosition);
//     //   const centerScreen = center3D.clone().project(camera);
//     //   const centerX = (centerScreen.x * 0.5 + 0.5) * window.innerWidth;
//     //   const centerY = (-(centerScreen.y * 0.5) + 0.5) * window.innerHeight;

//     //   // Calculate initial angle from center to mouse
//     //   const initialAngle = Math.atan2(
//     //     coords.y - centerY,
//     //     coords.x - centerX
//     //   );

//     //   // Capture pointer
//     //   const target = e.target || (nativeEvent && nativeEvent.target);
//     //   const pointerId = e.pointerId || (nativeEvent && nativeEvent.pointerId);
//     //   if (target && pointerId !== undefined) {
//     //     try {
//     //       target.setPointerCapture(pointerId);
//     //     } catch (err) {
//     //       console.log("Pointer capture not available");
//     //     }
//     //   }

//     //   setSelectedDecal(decalType);
//     //   setIsRotating(true);
//     //   setInteractionMode("rotating");
//     //   setRotationStartAngle(initialAngle);
//     //   setRotationCenter({ x: centerX, y: centerY });
//     //   setInitialDecalRotation(decalRotations[decalType] || 0);
//     // };

//     // ==========================================
//     // START RESIZING DECAL (CORNER CLICKED)
//     // ==========================================

//     const handleDecalRotate = (e, decalType) => {
//       e.stopPropagation?.();
//       e.nativeEvent?.stopPropagation?.();
//       e.nativeEvent?.stopImmediatePropagation?.();
//       e.preventDefault?.();

//       lastOverlayClickTime.current = Date.now();

//       const getCoords = (event) => {
//         const evt = event.nativeEvent || event;
//         if (evt.touches?.length > 0) {
//           return { x: evt.touches[0].clientX, y: evt.touches[0].clientY };
//         }
//         return { x: evt.clientX, y: evt.clientY };
//       };

//       const startCoords = getCoords(e);
//       const decalPos = decalPositions[decalType] || [0, 0, 0];
//       const center3D = new THREE.Vector3(...decalPos);
//       const centerScreen = center3D.clone().project(camera);
//       const centerX = (centerScreen.x * 0.5 + 0.5) * window.innerWidth;
//       const centerY = (-centerScreen.y * 0.5 + 0.5) * window.innerHeight;
//       const startAngle = Math.atan2(
//         startCoords.y - centerY,
//         startCoords.x - centerX
//       );
//       const startRotation = decalRotations[decalType] || 0;

//       const handleMove = (moveEvent) => {
//         moveEvent.preventDefault();
//         moveEvent.stopPropagation();
//         document.body.style.cursor = "grabbing";

//         const currentCoords = getCoords(moveEvent);
//         const currentAngle = Math.atan2(
//           currentCoords.y - centerY,
//           currentCoords.x - centerX
//         );
//         let angleDelta = currentAngle - startAngle;
//         angleDelta = -angleDelta;
//         const newRotation = startRotation + angleDelta;

//         setDecalRotations((prev) => ({
//           ...prev,
//           [decalType]: newRotation,
//         }));
//       };

//       const handleEnd = () => {
//         document.removeEventListener("mousemove", handleMove);
//         document.removeEventListener("mouseup", handleEnd);
//         document.removeEventListener("touchmove", handleMove);
//         document.removeEventListener("touchend", handleEnd);
//         document.body.style.cursor = "auto";
//         setIsRotating(false);
//         setInteractionMode("idle");
//       };

//       setSelectedDecal(decalType);
//       setIsRotating(true);
//       setInteractionMode("rotating");
//       document.addEventListener("mousemove", handleMove);
//       document.addEventListener("mouseup", handleEnd);
//       document.addEventListener("touchmove", handleMove, { passive: false });
//       document.addEventListener("touchend", handleEnd);
//     };
//     // ==========================================
//     // SMOOTH ROTATION FUNCTIONS (CLOCKWISE/ANTICLOCKWISE)
//     // ==========================================
//     // const rotateTextClockwise = (decalType) => {
//     //   const currentRotation = decalRotations[decalType] || 0;
//     //   const rotationIncrement = (5 * Math.PI) / 180; // 5 degrees in radians
//     //   const newRotation = currentRotation + rotationIncrement;
//     //   setDecalRotations((prev) => ({ ...prev, [decalType]: newRotation }));
//     // };

//     // const rotateTextAnticlockwise = (decalType) => {
//     //   const currentRotation = decalRotations[decalType] || 0;
//     //   const rotationIncrement = (5 * Math.PI) / 180; // 5 degrees in radians
//     //   const newRotation = currentRotation - rotationIncrement;
//     //   setDecalRotations((prev) => ({ ...prev, [decalType]: newRotation }));
//     // };

//     // Angular speed for hold-to-rotate: rad/s (~170 deg/s) – smooth and responsive
//     const ROTATION_SPEED_RAD_PER_SEC = 2.8;

//     const continuousRotationLoop = () => {
//       const info = rotationDirectionRef.current;
//       if (!info) return;
//       const now = performance.now();
//       let dt = (now - rotationLastTimeRef.current) / 1000;
//       rotationLastTimeRef.current = now;
//       if (dt > 0.1) dt = 0.1;
//       const step = ROTATION_SPEED_RAD_PER_SEC * dt * (info.direction === "clockwise" ? 1 : -1);
//       setDecalRotations((prev) => ({
//         ...prev,
//         [info.decalType]: (prev[info.decalType] || 0) + step,
//       }));
//       rotationRAFRef.current = requestAnimationFrame(continuousRotationLoop);
//     };

//     // const startContinuousRotation = (decalType, direction) => {
//     //   stopContinuousRotation();
//     //   rotationDirectionRef.current = { decalType, direction };
//     //   rotationLastTimeRef.current = performance.now();
//     //   if (direction === "clockwise") rotateTextClockwise(decalType);
//     //   else rotateTextAnticlockwise(decalType);
//     //   rotationRAFRef.current = requestAnimationFrame(continuousRotationLoop);
//     // };

//     const stopContinuousRotation = () => {
//       if (rotationRAFRef.current) {
//         cancelAnimationFrame(rotationRAFRef.current);
//         rotationRAFRef.current = null;
//       }
//       if (rotationIntervalRef.current) {
//         clearInterval(rotationIntervalRef.current);
//         rotationIntervalRef.current = null;
//       }
//       rotationDirectionRef.current = null;
//     };

//     const handleCornerDragStart = (e, decalType, corner) => {
//       e.stopPropagation();

//       // Access native event for preventDefault
//       const nativeEvent = e.nativeEvent || e;
//       if (nativeEvent && typeof nativeEvent.preventDefault === "function") {
//         nativeEvent.preventDefault();
//       }

//       const getCoords = (event) => {
//         const evt = event.nativeEvent || event;
//         if (evt.touches && evt.touches.length > 0) {
//           return { x: evt.touches[0].clientX, y: evt.touches[0].clientY };
//         }
//         return { x: evt.clientX, y: evt.clientY };
//       };

//       const coords = getCoords(e);
//       const currentScale = decalScales[decalType] || [1, 1, 1];

//       // Capture pointer to ensure we get all subsequent events
//       const target = e.target || (nativeEvent && nativeEvent.target);
//       const pointerId = e.pointerId || (nativeEvent && nativeEvent.pointerId);
//       if (target && pointerId !== undefined) {
//         try {
//           target.setPointerCapture(pointerId);
//         } catch (err) {
//           console.log("Pointer capture not available");
//         }
//       }

//       setSelectedDecal(decalType);
//       setIsResizing(true);
//       setActiveCorner(corner);
//       setInteractionMode("resizing");
//       setDragStartPos(coords);
//       setInitialDecalScale(
//         Array.isArray(currentScale)
//           ? [...currentScale]
//           : [currentScale, currentScale, currentScale]
//       );
      
//       // Set resize cursor
//       document.body.style.cursor = 'nwse-resize';
//     };

//     // ==========================================
//     // BOUNDARY CONSTRAINT HELPER FUNCTION
//     // ==========================================
//     const getBoundariesForModel = useCallback(() => {
//       const modelKey = state.newKey;

//       // Model-specific boundaries based on actual position ranges from modelConfig1
//       // Z-axis (bottom): increased by 20%, Y-axis: increased by 15% at bottom only (minY for front, maxY for back), top unchanged
//       const modelBoundaries = {
//         eventordereventjersey: {
//           900: {
//             frontText: {
//               minX: -8,
//               maxX: 8,
//               minY: -17.25,
//               maxY: -5,
//               minZ: -15,
//               maxZ: -4,
//             },
//             backText: {
//               minX: -8,
//               maxX: 8,
//               minY: 5,
//               maxY: 17.25,
//               minZ: -15,
//               maxZ: -4,
//             },
//             frontNumber: {
//               minX: -8,
//               maxX: 8,
//               minY: -17.25,
//               maxY: -5,
//               minZ: -5,
//               maxZ: 6,
//             },
//             backNumber: {
//               minX: -8,
//               maxX: 8,
//               minY: 5,
//               maxY: 17.25,
//               minZ: -5,
//               maxZ: 6,
//             },
//             frontLogo: {
//               minX: -2,
//               maxX: 10,
//               minY: -17.25,
//               maxY: -5,
//               minZ: 8,
//               maxZ: 21.6,
//             },
//             backLogo: {
//               minX: -10,
//               maxX: 2,
//               minY: 5,
//               maxY: 17.25,
//               minZ: 8,
//               maxZ: 21.6,
//             },
//           },
//           902: {
//             frontText: {
//               minX: -80,
//               maxX: 80,
//               minY: 68,
//               maxY: 180,
//               minZ: 80,
//               maxZ: 216,
//             },
//             backText: {
//               minX: -80,
//               maxX: 80,
//               minY: -180,
//               maxY: -68,
//               minZ: 80,
//               maxZ: 216,
//             },
//             frontNumber: {
//               minX: -80,
//               maxX: 80,
//               minY: 68,
//               maxY: 180,
//               minZ: -20,
//               maxZ: 96,
//             },
//             backNumber: {
//               minX: -80,
//               maxX: 80,
//               minY: -180,
//               maxY: -68,
//               minZ: -20,
//               maxZ: 96,
//             },
//             frontLogo: {
//               minX: 20,
//               maxX: 100,
//               minY: 51,
//               maxY: 140,
//               minZ: -180,
//               maxZ: -84,
//             },
//             backLogo: {
//               minX: -100,
//               maxX: -20,
//               minY: -180,
//               maxY: -68,
//               minZ: -180,
//               maxZ: -84,
//             },
//           },
//           903: {
//             frontText: {
//               minX: -0.08,
//               maxX: 0.08,
//               minY: 0.017,
//               maxY: 0.08,
//               minZ: 0.05,
//               maxZ: 0.18,
//             },
//             backText: {
//               minX: -0.08,
//               maxX: 0.08,
//               minY: 0.02,
//               maxY: 0.092,
//               minZ: -0.15,
//               maxZ: -0.04,
//             },
//             frontNumber: {
//               minX: -0.08,
//               maxX: 0.08,
//               minY: -0.115,
//               maxY: -0.02,
//               minZ: 0.05,
//               maxZ: 0.18,
//             },
//             backNumber: {
//               minX: -0.08,
//               maxX: 0.08,
//               minY: -0.1,
//               maxY: -0.017,
//               minZ: -0.15,
//               maxZ: -0.04,
//             },
//             frontLogo: {
//               minX: 0.02,
//               maxX: 0.08,
//               minY: 0.068,
//               maxY: 0.16,
//               minZ: 0.05,
//               maxZ: 0.18,
//             },
//             backLogo: {
//               minX: -0.08,
//               maxX: -0.02,
//               minY: 0.08,
//               maxY: 0.1955,
//               minZ: -0.12,
//               maxZ: -0.016,
//             },
//           },
//           904: {
//             frontText: {
//               minX: -80,
//               maxX: 80,
//               minY: 42.5,
//               maxY: 150,
//               minZ: -1250,
//               maxZ: -1010,
//             },
//             backText: {
//               minX: -80,
//               maxX: 80,
//               minY: -150,
//               maxY: -42.5,
//               minZ: -1250,
//               maxZ: -1010,
//             },
//             frontNumber: {
//               minX: -80,
//               maxX: 80,
//               minY: 42.5,
//               maxY: 150,
//               minZ: -1450,
//               maxZ: -1210,
//             },
//             backNumber: {
//               minX: -80,
//               maxX: 80,
//               minY: -150,
//               maxY: -42.5,
//               minZ: -1450,
//               maxZ: -1210,
//             },
//             frontLogo: {
//               minX: 20,
//               maxX: 100,
//               minY: 34,
//               maxY: 120,
//               minZ: -1550,
//               maxZ: -1310,
//             },
//             backLogo: {
//               minX: 20,
//               maxX: 100,
//               minY: -200,
//               maxY: -85,
//               minZ: -1550,
//               maxZ: -1310,
//             },
//           },
//         },
//         menmenjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         menmenxjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         menmenprotshirt: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         menmentanktop: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 18.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 18.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 18.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 18.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 18.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 18.8,
//           },
//         },
//         menmenarmsleeves: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//         },
//         menmensinglet: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//         },
//         menmencyclingjersey: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//         },
//         menmenwinterjersey: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//         },
//         menmenbasketballjersey: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//         },
//         womenwomencyclingjersey: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//         },
//         womenwomenwinterjersey: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//         },
//         menmenshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmencricketshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmencyclingshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmenrunningshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmenwovenshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmenknittedshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmenfootballshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmensoccershorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmenbasketballshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmennftfootballshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmencitycollection: {
//           frontText: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           backText: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           frontNumber: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           backNumber: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           frontLogo: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           backLogo: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//         },
//         menmencricketjersey: {
//           frontText: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -150,
//             maxZ: 200,
//           },
//           backText: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -150,
//             maxZ: 200,
//           },
//           frontNumber: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -150,
//             maxZ: 200,
//           },
//           backNumber: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -150,
//             maxZ: 200,
//           },
//           frontLogo: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -150,
//             maxZ: 200,
//           },
//           backLogo: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -150,
//             maxZ: 200,
//           },
//         },
//         womenwomencitycollection: {
//           frontText: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           backText: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           frontNumber: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           backNumber: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           frontLogo: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           backLogo: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//         },
//         menmentrackpants: {
//           frontText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           backText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           frontNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           frontLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//         },
//         menmencompressionpants: {
//           frontText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           backText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           frontNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           frontLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//         },
//         womenwomenbadmintonjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomencricketjersey: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           frontNumber: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           backNumber: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//         },
//         womenwomentrackpants: {
//           frontText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           backText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           frontNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           frontLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//         },
//         womenwomencrickettrackpants: {
//           frontText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           backText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           frontNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           frontLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//         },
//         womenwomenxjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.05,
//             maxY: 0.1725,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.05,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.15,
//             maxY: 0.0575,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.12,
//             maxX: 0.12,
//             minY: -0.115,
//             maxY: 0.2,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.12,
//             maxX: 0.12,
//             minY: -0.1,
//             maxY: 0.23,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomenjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.05,
//             maxY: 0.1725,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.05,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.15,
//             maxY: 0.0575,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.12,
//             maxX: 0.12,
//             minY: -0.115,
//             maxY: 0.2,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.12,
//             maxX: 0.12,
//             minY: -0.1,
//             maxY: 0.23,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomenprotshirt: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomenfootballjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomensoccerjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomencompressionpants: {
//           frontText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 45.8,
//           },
//           backText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 45.8,
//           },
//           frontNumber: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 45.8,
//           },
//           backNumber: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 45.8,
//           },
//           frontLogo: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 45.8,
//           },
//           backLogo: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 45.8,
//           },
//         },
//         womenwomenbadmintontanktop: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomensinglet: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomenarmsleeves: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomenbadmintonshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomencyclingshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomencricketshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomenwovenshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomentightshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomenfootballshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomensoccershorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomennftfootballshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomenbasketballshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomenknittedshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         kidskidsjersey: {
//           frontText: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backText: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//           frontNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backLogo: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//         },
//         kidskidstanktop: {
//           frontText: {
//             minX: -19,
//             maxX: 19,
//             minY: -10,
//             maxY: 10,
//             minZ: -20,
//             maxZ: 25,
//           },
//           backText: {
//             minX: -19,
//             maxX: 19,
//             minY: -10,
//             maxY: 10,
//             minZ: -20,
//             maxZ: 25,
//           },
//           frontNumber: {
//             minX: -19,
//             maxX: 19,
//             minY: -10,
//             maxY: 10,
//             minZ: -20,
//             maxZ: 25,
//           },
//           backNumber: {
//             minX: -19,
//             maxX: 19,
//             minY: -10,
//             maxY: 10,
//             minZ: -20,
//             maxZ: 25,
//           },
//           frontLogo: {
//             minX: -19,
//             maxX: 19,
//             minY: -10,
//             maxY: 10,
//             minZ: -20,
//             maxZ: 25,
//           },
//           backLogo: {
//             minX: -19,
//             maxX: 19,
//             minY: -10,
//             maxY: 10,
//             minZ: -20,
//             maxZ: 25,
//           },
//         },
//         kidskidscyclingjersey: {
//           frontText: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 5,
//             minZ: -8,
//             maxZ: 6,
//           },
//           backText: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
//           frontNumber: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           backNumber: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           frontLogo: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           backLogo: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
//         },
//         kidskidswinterjersey: {
//           frontText: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 5,
//             minZ: -8,
//             maxZ: 6,
//           },
//           backText: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
//           frontNumber: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           backNumber: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           frontLogo: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           backLogo: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
//         },
//         kidskidscitycollection: {
//           frontText: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 5,
//             minZ: -8,
//             maxZ: 6,
//           },
//           backText: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
//           frontNumber: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           backNumber: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           frontLogo: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           backLogo: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
//         },
//         kidskidscricketjersey: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -18,
//             maxY: 18,
//             minZ: -18,
//             maxZ: 18,
//           },
//           backText: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//           frontNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backLogo: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//         },
//         kidskidstrackpants: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//         },
//         kidskidsxjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         kidskidsprotshirt: {
//           frontText: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backText: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//           frontNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backLogo: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//         },
//         kidskidscompressionpants: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//         },
//         kidskidssinglet: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -23,
//             maxY: 25,
//             minZ: -18,
//             maxZ: 25.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -10,
//             maxX: 10,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         kidskidsarmsleeves: {
//           frontText: {
//             minX: -6,
//             maxX: 6,
//             minY: -23,
//             maxY: 25,
//             minZ: 30,
//             maxZ: 45.8,
//           },
//           backText: {
//             minX: -6,
//             maxX: 6,
//             minY: -23,
//             maxY: 25,
//             minZ: 30,
//             maxZ: 45.8,
//           },
//           frontNumber: {
//             minX: -6,
//             maxX: 6,
//             minY: -23,
//             maxY: 25,
//             minZ: 30,
//             maxZ: 45.8,
//           },
//           backNumber: {
//             minX: -6,
//             maxX: 6,
//             minY: -23,
//             maxY: 25,
//             minZ: 30,
//             maxZ: 45.8,
//           },
//           frontLogo: {
//             minX: -6,
//             maxX: 6,
//             minY: -23,
//             maxY: 25,
//             minZ: 30,
//             maxZ: 45.8,
//           },
//           backLogo: {
//             minX: -6,
//             maxX: 6,
//             minY: -23,
//             maxY: 25,
//             minZ: 30,
//             maxZ: 45.8,
//           },
//         },
//         kidskidsbasketballjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         kidskidsfootballjersey: {
//           frontText: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backText: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//           frontNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backLogo: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//         },
//         kidskidssoccerjersey: {
//           frontText: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backText: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//           frontNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backLogo: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//         },
//         kidskidsshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidscricketshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidscyclingshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidswintershorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidsrunningshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidswovenshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidsknittedshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidsbasketballshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidssoccershorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidsfootballshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidsnftfootballshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         default: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.05,
//             maxY: 0.1725,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.05,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.15,
//             maxY: 0.0575,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.12,
//             maxX: 0.12,
//             minY: -0.115,
//             maxY: 0.2,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.12,
//             maxX: 0.12,
//             minY: -0.1,
//             maxY: 0.23,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//       };

//       // Check if it's an event order with specific glbId
//       if (
//         modelKey === "eventordereventjersey" &&
//         glbId &&
//         modelBoundaries[modelKey][glbId]
//       ) {
//         return modelBoundaries[modelKey][glbId];
//       }

//       // Check if model has specific boundaries
//       if (modelBoundaries[modelKey]) {
//         return modelBoundaries[modelKey];
//       }

//       // Return default boundaries
//       return modelBoundaries.default;
//     }, [glbId]);

//     const applyBoundaryConstraints = useCallback(
//       (position, decalType) => {
//         const boundaries = getBoundariesForModel();
//         const boundary = boundaries[decalType];

//         if (!boundary) {
//           return position; // No boundary defined, return original position
//         }

//         const constrainedPosition = [...position];
//         constrainedPosition[0] = Math.max(
//           boundary.minX,
//           Math.min(boundary.maxX, position[0])
//         );
//         constrainedPosition[1] = Math.max(
//           boundary.minY,
//           Math.min(boundary.maxY, position[1])
//         );
//         constrainedPosition[2] = Math.max(
//           boundary.minZ,
//           Math.min(boundary.maxZ, position[2])
//         );

//         return constrainedPosition;
//       },
//       [getBoundariesForModel]
//     );

//     // HANDLE MOUSE/TOUCH MOVE - OPTIMIZED
//     // ==========================================
//     const rafRef = useRef(null);

//     const handleGlobalMove = useCallback(
//       (e) => {
//         if (interactionMode === "idle") return;

//         const getCoords = (event) => {
//           if (event.touches && event.touches.length > 0) {
//             return { x: event.touches[0].clientX, y: event.touches[0].clientY };
//           }
//           return { x: event.clientX, y: event.clientY };
//         };

//         const coords = getCoords(e);
//         const modelKey = state.newKey;

//         const allowedMovementModels = [
//           "menmenjersey",
//           "menmenxjersey",
//           "kidskidsxjersey",
//           "kidskidsbasketballjersey",
//           "womenwomenbadmintonjersey",
//           "womenwomenprotshirt",
//           "womenwomensinglet",
//           "womenwomenarmsleeves",
//           "womenwomenjersey",
//           "womenwomensoccerjersey",
//           "menmensoccerjersey",
//           "menmenprotshirt",
//           "menmenfootballjersey",
//           "menmencricketjersey",
//           "womenwomenfootballjersey",
//           "womenwomenxjersey",
//           "womenwomenbadmintontanktop",
//         ];

//         const isEventOrderSpecial =
//           modelKey === "eventordereventjersey" &&
//           (glbId === "900" || glbId === "904");

//         const useSpecialMovement =
//           allowedMovementModels.includes(modelKey) || isEventOrderSpecial;
//         const useFirstResizeMethod =
//           allowedMovementModels.includes(modelKey) || isEventOrderSpecial; // ⭐ FIXED: Use same condition

//         if (interactionMode === "dragging" && isDragging && selectedDecal) {
//           const start = dragStartPosRef.current;
//           const initial = initialDecalPosRef.current;
//           const deltaX = coords.x - start.x;
//           const deltaY = coords.y - start.y;

//           const movement = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//           if (movement > 3) hasDraggedRef.current = true;

//           let newPosition;

//           if (modelKey === "menmencricketjersey") {
//             const normalSensitivityX = 2.4;
//             const normalSensitivityZ = 2.8;
//             const isBackSide = selectedDecal.includes("back");
//             const finalDeltaX = isBackSide ? -deltaX : deltaX;
//             const newX = initial[0] + finalDeltaX * normalSensitivityX;
//             const newZ = initial[1] + deltaY * normalSensitivityZ;
//             newPosition = [newX, initial[1], newZ];
//           } else if (useSpecialMovement) {
//             const sensitivity = 0.0015;
//             const isBackSide = selectedDecal.includes("back");
//             const newX = initial[0] + (isBackSide ? -deltaX : deltaX) * sensitivity;
//             const newY = initial[1] - deltaY * sensitivity;
//             newPosition = [newX, newY, initial[2]];
//           } else if (
//             modelKey === "menmencitycollection" ||
//             modelKey === "womenwomencitycollection"
//           ) {
//             const normalSensitivityX = 1.4;
//             const normalSensitivityZ = 1.8;
//             const isBackSide = selectedDecal.includes("back");
//             const finalDeltaX = isBackSide ? -deltaX : deltaX;
//             const newX = initial[0] + finalDeltaX * normalSensitivityX;
//             const newZ = initial[2] + deltaY * normalSensitivityZ;
//             newPosition = [newX, initial[1], newZ];
//           } else {
//             const normalSensitivityX = 0.09;
//             const normalSensitivityZ = 0.2;
//             const isBackSide = selectedDecal.includes("back");
//             const finalDeltaX = isBackSide ? -deltaX : deltaX;
//             const newX = initial[0] + finalDeltaX * normalSensitivityX;
//             const newZ = initial[2] - deltaY * normalSensitivityZ;
//             newPosition = [newX, initial[1], newZ];
//           }

//           newPosition = applyBoundaryConstraints(newPosition, selectedDecal);
//           lastDragPositionRef.current = newPosition;
//           selectedDecalDragRef.current = selectedDecal;
//           setTempPosition(newPosition);
//           setDecalPositions((prev) => ({ ...prev, [selectedDecal]: newPosition }));
//         }

//         if (
//           interactionMode === "resizing" &&
//           isResizing &&
//           selectedDecal &&
//           activeCorner
//         ) {
//           requestAnimationFrame(() => {
//             const deltaX = coords.x - dragStartPos.x;
//             const deltaY = coords.y - dragStartPos.y;
//             let adjustedDeltaX = deltaX;
//             let adjustedDeltaY = deltaY;

//             const sensitivity = selectedDecal.includes("Logo") ? 0.005 : 0.003;

//             let newScale;

//             if (modelKey === "menmencricketjersey") {
//               const cricketSensitivity = selectedDecal.includes("Logo") ? 5 : 4;
//               newScale = [...initialDecalScale];

//               switch (activeCorner) {
//                 case "tl":
//                   newScale[0] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[0] - adjustedDeltaX * cricketSensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[1] - adjustedDeltaY * cricketSensitivity
//                     )
//                   );
//                   break;
//                 case "tr":
//                   newScale[0] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[0] + adjustedDeltaX * cricketSensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[1] - adjustedDeltaY * cricketSensitivity
//                     )
//                   );
//                   break;
//                 case "bl":
//                   newScale[0] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[0] - adjustedDeltaX * cricketSensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[1] + adjustedDeltaY * cricketSensitivity
//                     )
//                   );
//                   break;
//                 case "br":
//                   newScale[0] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[0] + adjustedDeltaX * cricketSensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[1] + adjustedDeltaY * cricketSensitivity
//                     )
//                   );
//                   break;
//                 default:
//                   newScale = initialDecalScale;
//                   break;
//               }
//               console.log("Cricket Jersey Resize - New Scale:", newScale);
//             } else if (useFirstResizeMethod) {
//               // ⭐ NOW THIS USES THE SAME MODELS LIST
//               newScale = [...initialDecalScale];
//               switch (activeCorner) {
//                 case "tl":
//                   newScale[0] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[0] - adjustedDeltaX * sensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[1] - adjustedDeltaY * sensitivity
//                     )
//                   );
//                   break;
//                 case "tr":
//                   newScale[0] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[0] + adjustedDeltaX * sensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[1] - adjustedDeltaY * sensitivity
//                     )
//                   );
//                   break;
//                 case "bl":
//                   newScale[0] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[0] - adjustedDeltaX * sensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[1] + adjustedDeltaY * sensitivity
//                     )
//                   );
//                   break;
//                 case "br":
//                   newScale[0] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[0] + adjustedDeltaX * sensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[1] + adjustedDeltaY * sensitivity
//                     )
//                   );
//                   break;
//                 default:
//                   newScale = initialDecalScale;
//                   break;
//               }
//             } else if (
//               modelKey === "menmencitycollection" ||
//               modelKey === "womenwomencitycollection"
//             ) {
//               const diagonalDelta = Math.sqrt(
//                 adjustedDeltaX * adjustedDeltaX +
//                   adjustedDeltaY * adjustedDeltaY
//               );

//               // Double the sensitivity for faster scaling
//               const fasterSensitivity = sensitivity * 3;

//               let scaleFactor = 1;
//               switch (activeCorner) {
//                 case "tl":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX < 0 && adjustedDeltaY < 0
//                       ? -diagonalDelta
//                       : diagonalDelta) *
//                       fasterSensitivity;
//                   break;
//                 case "tr":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX > 0 && adjustedDeltaY < 0
//                       ? -diagonalDelta
//                       : diagonalDelta) *
//                       fasterSensitivity;
//                   break;
//                 case "bl":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX < 0 && adjustedDeltaY > 0
//                       ? -diagonalDelta
//                       : diagonalDelta) *
//                       fasterSensitivity;
//                   break;
//                 case "br":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX > 0 && adjustedDeltaY > 0
//                       ? diagonalDelta
//                       : -diagonalDelta) *
//                       fasterSensitivity;
//                   break;
//               }
//               newScale = initialDecalScale.map((s) =>
//                 Math.max(265, Math.min(1200, s * scaleFactor))
//               );
//             } else {
//               const diagonalDelta = Math.sqrt(
//                 adjustedDeltaX * adjustedDeltaX +
//                   adjustedDeltaY * adjustedDeltaY
//               );
//               let scaleFactor = 1;
//               switch (activeCorner) {
//                 case "tl":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX < 0 && adjustedDeltaY < 0
//                       ? -diagonalDelta
//                       : diagonalDelta) *
//                       sensitivity;
//                   break;
//                 case "tr":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX > 0 && adjustedDeltaY < 0
//                       ? -diagonalDelta
//                       : diagonalDelta) *
//                       sensitivity;
//                   break;
//                 case "bl":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX < 0 && adjustedDeltaY > 0
//                       ? -diagonalDelta
//                       : diagonalDelta) *
//                       sensitivity;
//                   break;
//                 case "br":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX > 0 && adjustedDeltaY > 0
//                       ? diagonalDelta
//                       : -diagonalDelta) *
//                       sensitivity;
//                   break;
//               }
//               newScale = initialDecalScale.map((s) =>
//                 Math.max(5, Math.min(300, s * scaleFactor))
//               );
//             }

//             setTempScale(newScale);
//             setDecalScales((prev) => ({
//               ...prev,
//               [selectedDecal]: newScale,
//             }));

//             if (selectedDecal.includes("front")) {
//               frontLogoScale[0] = newScale[0];
//               frontLogoScale[1] = newScale[1];
//             } else if (selectedDecal.includes("back")) {
//               backLogoScale[0] = newScale[0];
//               backLogoScale[1] = newScale[1];
//             }
//           });
//         }
//       },
//       [
//         interactionMode,
//         isDragging,
//         isResizing,
//         selectedDecal,
//         activeCorner,
//         dragStartPos,
//         initialDecalPos,
//         initialDecalScale,
//         state.newKey,
//         glbId,
//       ]
//     );

//     // ==========================================
//     // HANDLE MOUSE/TOUCH UP
//     // ==========================================
//     const handleGlobalUp = () => {
//       if (isDragging) {
//         const decal = selectedDecalDragRef.current;
//         const last = lastDragPositionRef.current;
//         if (decal && last && last.length === 3) {
//           const pos = [...last];
//           setDecalPositions((prev) => ({ ...prev, [decal]: pos }));
//           setTempPosition(pos);
//         }
//         selectedDecalDragRef.current = null;
//         setIsDragging(false);
//         hasDraggedRef.current = false;
//       }

//       if (isResizing) {
//         setIsResizing(false);
//         setActiveCorner(null);
//         document.body.style.cursor = "auto";
//       }

//       stopContinuousRotation();
//       setInteractionMode("idle");
//     };

//     // ==========================================
//     // ATTACH GLOBAL EVENT LISTENERS
//     // ==========================================
//     useEffect(() => {
//       if (interactionMode === "dragging" || interactionMode === "resizing") {
//         const handleMove = (e) => {
//           e.preventDefault();
//           handleGlobalMove(e);
//         };

//         const handleUp = (e) => {
//           handleGlobalUp(e);
//         };

//         document.addEventListener("mousemove", handleMove);
//         document.addEventListener("mouseup", handleUp);
//         document.addEventListener("touchmove", handleMove, { passive: false });
//         document.addEventListener("touchend", handleUp);

//         return () => {
//           document.removeEventListener("mousemove", handleMove);
//           document.removeEventListener("mouseup", handleUp);
//           document.removeEventListener("touchmove", handleMove);
//           document.removeEventListener("touchend", handleUp);
//         };
//       }
//     }, [
//       interactionMode,
//       isDragging,
//       isResizing,
//       selectedDecal,
//       dragStartPos,
//       initialDecalPos,
//       initialDecalScale,
//       activeCorner,
//     ]);

//     const handleResizeMove = (e) => {
//       if (!resizeMode || !selectedDecal || !initialScale) return;

//       // Get coordinates from either mouse or touch event
//       const getEventCoords = (event) => {
//         if (event.touches && event.touches.length > 0) {
//           return { x: event.touches[0].clientX, y: event.touches[0].clientY };
//         }
//         return { x: event.clientX, y: event.clientY };
//       };

//       const coords = getEventCoords(e);
//       const deltaX = coords.x - resizeStartPos.x;
//       const deltaY = coords.y - resizeStartPos.y;

//       // Calculate scale change based on diagonal movement for corner resize
//       const delta =
//         Math.sqrt(deltaX * deltaX + deltaY * deltaY) *
//         (deltaX + deltaY > 0 ? 1 : -1);
//       const scaleFactor = 1 + delta * 0.003;

//       const newScale = [
//         Math.max(0.1, Math.min(3, initialScale[0] * scaleFactor)),
//         Math.max(0.1, Math.min(3, initialScale[1] * scaleFactor)),
//         initialScale[2],
//       ];

//       setDecalScales((prev) => ({
//         ...prev,
//         [selectedDecal]: newScale,
//       }));

//       setTempScale(newScale);
//     };

//     const handleResizeUp = () => {
//       if (resizeMode && selectedDecal && tempScale) {
//         // Save the final scale
//         setDecalScales((prev) => ({
//           ...prev,
//           [selectedDecal]: tempScale,
//         }));
//       }

//       setResizeMode(false);
//       setResizeCorner(null);
//       setInitialScale(null);
//       setTempScale([0, 0, 0]);
//       setInteractionMode("rotate-shirt");
//       setSelectedDecal(null);
//     };

//     // Mobile detection helper function
//     const isMobileDevice = () => {
//       return (
//         window.innerWidth <= 768 ||
//         /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
//           navigator.userAgent
//         )
//       );
//     };

//     const handlePointerMove = (e) => {
//       // Prevent default touch behavior to avoid page scrolling during drag
//       if (e.type === "touchmove") {
//         e.preventDefault();
//       }

//       // Only block pointer move when TransformControls is actively being used
//       if (interactionMode === "transform-controls") {
//         return;
//       }

//       // Better detection for active dragging
//       const isMouseDown = e.buttons === 1;
//       const isTouchMove =
//         e.type === "touchmove" && e.touches && e.touches.length > 0;
//       const isPointerMove = e.type === "pointermove" && e.pressure > 0;

//       if (!isMouseDown && !isTouchMove && !isPointerMove) return;

//       const getEventCoords = (event) => {
//         // Touch events
//         if (event.touches && event.touches.length > 0) {
//           return { x: event.touches[0].clientX, y: event.touches[0].clientY };
//         }
//         // Pointer events (including touch on some devices)
//         if (event.clientX !== undefined && event.clientY !== undefined) {
//           return { x: event.clientX, y: event.clientY };
//         }
//         return { x: 0, y: 0 };
//       };

//       const coords = getEventCoords(e);

//       // NEW RESIZE FEATURE - Handle new resize mode
//       if (interactionMode === "new-resize-mode") {
//         handleNewResizeFunction(e);
//         return;
//       }

//       if (interactionMode === "resize-decal") {
//         handleResizeMove(e);
//         return;
//       }

//       // Handle rotation mode
//       if (interactionMode === "rotating" && isRotating && selectedDecal) {
//         const currentAngle = Math.atan2(
//           coords.y - rotationCenter.y,
//           coords.x - rotationCenter.x
//         );

//         // Calculate rotation delta
//         const angleDelta = currentAngle - rotationStartAngle;

//         // Apply rotation (adding the delta to initial rotation)
//         let newRotation = initialDecalRotation + angleDelta;

//         // Normalize to 0-2π range
//         while (newRotation < 0) newRotation += Math.PI * 2;
//         while (newRotation >= Math.PI * 2) newRotation -= Math.PI * 2;

//         setDecalRotations((prev) => ({
//           ...prev,
//           [selectedDecal]: newRotation,
//         }));
//         return;
//       }

//       if (interactionMode === "move-decal" && selectedDecal) {
//         // Get model-specific movement sensitivity
//         const modelKey = state.newKey;
//         let modelConfig = modelConfig1[modelKey];

//         // SPECIAL HANDLING for eventordereventjersey
//         if (modelKey === "eventordereventjersey" && glbId) {
//           modelConfig = modelConfig1[modelKey][glbId] || modelConfig1[modelKey];
//         }

//         // Base sensitivity values
//         let sensitivityX = selectedDecal.includes("Logo") ? 0.001 : 0.0008;
//         let sensitivityY = selectedDecal.includes("Logo") ? 0.001 : 0.0008;

//         // INCREASED sensitivity for touch devices (mobile)
//         if (e.type === "touchmove" || e.pointerType === "touch") {
//           sensitivityX *= 2.5; // Increased from 1.5 to 2.5
//           sensitivityY *= 2.5;
//         }

//         // Additional mobile-specific boost for better responsiveness
//         if (isMobileDevice()) {
//           sensitivityX *= 1.5;
//           sensitivityY *= 1.5;
//         }

//         if (modelConfig) {
//           const scale = modelConfig.scale;
//           const overallScale = modelConfig.overallScale || 1;
//           const scaleFactor = Array.isArray(scale) ? scale[0] || 1 : scale || 1;

//           let adjustedFactor = 1;

//           if (
//             modelKey === "menmenjersey" ||
//             (modelKey === "eventordereventjersey" && glbId === "902")
//           ) {
//             adjustedFactor = Math.min(
//               3,
//               Math.max(0.5, scaleFactor / overallScale)
//             );
//           } else if (
//             modelKey === "eventordereventjersey" &&
//             (glbId === "900" || glbId === "904")
//           ) {
//             if (scaleFactor < 0.01) {
//               adjustedFactor = Math.min(20, Math.max(5, 1 / scaleFactor));
//             } else if (scaleFactor < 1) {
//               adjustedFactor = Math.min(10, Math.max(2, 1 / scaleFactor));
//             } else {
//               adjustedFactor = Math.min(
//                 5,
//                 Math.max(0.2, scaleFactor / overallScale)
//               );
//             }
//           } else if (modelKey === "womenwomenfootballjersey") {
//             adjustedFactor = Math.min(
//               3,
//               Math.max(0.5, scaleFactor / overallScale)
//             );
//           } else if (
//             modelKey === "menmenxjersey" ||
//             (modelKey === "eventordereventjersey" && glbId === "903")
//           ) {
//             adjustedFactor = Math.min(
//               3,
//               Math.max(0.5, scaleFactor / overallScale)
//             );
//           } else if (modelKey === "womenwomenbadmintontanktop") {
//             adjustedFactor = Math.min(
//               4,
//               Math.max(0.8, scaleFactor / overallScale)
//             );
//           } else if (scaleFactor < 0.01) {
//             adjustedFactor = Math.min(15, Math.max(3, 1 / scaleFactor));
//           } else if (scaleFactor < 0.1) {
//             adjustedFactor = Math.min(10, Math.max(2, 1 / scaleFactor));
//           } else {
//             adjustedFactor = Math.min(
//               5,
//               Math.max(0.2, scaleFactor / overallScale)
//             );
//           }

//           sensitivityX *= adjustedFactor;
//           sensitivityY *= adjustedFactor;
//         }

//         let deltaX = (coords.x - mouseStartPos.x) * sensitivityX;
//         let deltaY = -(coords.y - mouseStartPos.y) * sensitivityY;

//         let maxDelta = 0.1;
//         if (
//           modelKey === "eventordereventjersey" &&
//           (glbId === "900" || glbId === "902" || glbId === "904")
//         ) {
//           maxDelta = 0.5;
//         } else if (
//           modelKey === "menmenjersey" ||
//           modelKey === "womenwomenfootballjersey" ||
//           modelKey === "menmenxjersey"
//         ) {
//           maxDelta = 0.2;
//         } else if (modelKey === "womenwomenbadmintontanktop") {
//           maxDelta = 0.15;
//         }

//         deltaX = Math.max(-maxDelta, Math.min(maxDelta, deltaX));
//         deltaY = Math.max(-maxDelta, Math.min(maxDelta, deltaY));

//         const isBackSide = ["backText", "backNumber", "backLogo"].includes(
//           selectedDecal
//         );
//         if (isBackSide) {
//           deltaX *= -1;
//         }

//         let positionArray;
//         switch (selectedDecal) {
//           case "frontText":
//             positionArray = frontTextPosition;
//             break;
//           case "backText":
//             positionArray = backTextPosition;
//             break;
//           case "frontNumber":
//             positionArray = frontNumberPosition;
//             break;
//           case "backNumber":
//             positionArray = backNumberPosition;
//             break;
//           case "frontLogo":
//             positionArray = frontLogoPosition;
//             break;
//           case "backLogo":
//             positionArray = backLogoPosition;
//             break;
//           default:
//             return;
//         }

//         const modelRotation = modelConfig?.rotation || [0, 0, 0];

//         if (Math.abs(modelRotation[0]) > 1) {
//           positionArray[0] += deltaX;
//           positionArray[2] += deltaY;
//         } else {
//           positionArray[0] += deltaX;
//           positionArray[1] += deltaY;
//         }

//         // Apply boundary constraints using shared helper function
//         const constrainedPosition = applyBoundaryConstraints(
//           [...positionArray],
//           selectedDecal
//         );
//         positionArray[0] = constrainedPosition[0];
//         positionArray[1] = constrainedPosition[1];
//         positionArray[2] = constrainedPosition[2];

//         setTempPosition([...positionArray]);
//         setMouseStartPos(coords);
//         setWasMoved(true); // Track that movement occurred
//       }
//     };
//     const [wasMoved, setWasMoved] = useState(false);

//     const handlePointerUp = () => {
//       if (interactionMode === "transform-controls") {
//         // Don't deselect - keep the decal selected for transform controls
//         setInteractionMode("rotate-shirt");
//         setIsTransforming(false);
//         return;
//       }

//       if (interactionMode === "new-resize-mode") {
//         endNewResize();
//         return;
//       }

//       if (resizeMode && selectedDecal) {
//         setResizeMode(false);
//         setResizeCorner(null);
//         setInitialScale(null);
//         setInteractionMode("rotate-shirt");
//         // Keep decal selected after resize
//         return;
//       }

//       // Handle rotation end
//       if (interactionMode === "rotating" && isRotating && selectedDecal) {
//         setIsRotating(false);
//         setInteractionMode("idle");
//         // Keep decal selected after rotation
//         return;
//       }

//       if (interactionMode === "move-decal" && selectedDecal) {
//         setDecalPositions((prev) => ({
//           ...prev,
//           [selectedDecal]: tempPosition,
//         }));

//         setInteractionMode("rotate-shirt");
//         setWasMoved(false);
//         // Keep decal selected after move (don't deselect)
//       }
//     };

//     const renderResizeArrow = () => {
//       return null;
//     };

//     const getTransformTarget = useCallback(
//       (type, position, rotation, scale) => {
//         const existing = transformTargetsRef.current[type];
//         const target = existing || new THREE.Object3D();

//         target.position.set(position[0], position[1], position[2]);
//         target.rotation.set(rotation[0], rotation[1], rotation[2]);

//         const targetScale = Array.isArray(scale)
//           ? scale
//           : [scale || 1, scale || 1, scale || 1];

//         target.scale.set(
//           targetScale[0] || 1,
//           targetScale[1] || 1,
//           targetScale[2] || 1
//         );

//         transformTargetsRef.current[type] = target;
//         return target;
//       },
//       []
//     );

//     const isDecalFacingCamera = useCallback(
//       (e) => {
//         if (!e?.point || !e?.face || !e?.object || !camera) return true;
//         const normal = new THREE.Vector3();
//         normal.copy(e.face.normal).transformDirection(e.object.matrixWorld);
//         const toCamera = new THREE.Vector3()
//           .subVectors(camera.position, e.point)
//           .normalize();
//         return normal.dot(toCamera) > 0.1;
//       },
//       [camera]
//     );

//     const mobileScaleFactor = isMobile ? 0.75 : 1.0;
//     const mobilePositionOffset = isMobile ? [0, 0.06, 0] : [0, 0, 0];

//     const renderDecal = (
//       type,
//       defaultTexture,
//       defaultPosition,
//       rotation,
//       defaultScale
//     ) => {
//       console.log(`🔍 renderDecal called for ${type}`);
//       console.log(`   productData:`, productData);
//       console.log(`   ${type} value:`, productData?.[type]);
//       console.log(`   should display:`, !!productData?.[type]);
//       const isSelected = selectedDecal === type;
//       const isTextDecal = type.toLowerCase().includes("text");
//       const isNumberDecal = type.toLowerCase().includes("number");

//       // Check if currently dragging this specific decal
//       const isCurrentlyDragging =
//         isSelected && interactionMode === "dragging" && isDragging;

//       // Fix: Use tempPosition when selected and dragging for smooth real-time updates
//       let position =
//         isCurrentlyDragging && tempPosition && tempPosition.length === 3
//           ? tempPosition
//           : decalPositions[type] || defaultPosition;

//       // Pull text/number decals slightly toward t-shirt surface to reduce gap (fabric.js)
//       const displayPosition =
//         isTextDecal || isNumberDecal
//           ? [position[0], position[1], position[2] - 0.0004]
//           : position;

//       let scale;
//       // Check if currently resizing this specific decal
//       const isCurrentlyResizing =
//         isSelected && interactionMode === "resizing" && isResizing;

//       if (
//         isCurrentlyResizing &&
//         tempScale &&
//         tempScale.length === 3 &&
//         tempScale[0] !== 0
//       ) {
//         // Use tempScale for real-time resize feedback for all decal types including text
//         scale = tempScale;
//       } else if (isTextDecal || isNumberDecal) {
//         scale = decalScales[type] || defaultScale;
//       } else if (
//         interactionMode === "new-resize-mode" &&
//         newResizeSelectedDecal === type &&
//         newResizeTempScale &&
//         newResizeTempScale.length === 3 &&
//         newResizeTempScale[0] !== 0
//       ) {
//         scale = newResizeTempScale;
//       } else if (
//         isSelected &&
//         resizeMode &&
//         tempScale &&
//         tempScale.length === 3 &&
//         tempScale[0] !== 0
//       ) {
//         scale = tempScale;
//       } else {
//         scale = decalScales[type] || defaultScale;
//       }

//       let shouldDisplay = false;
//       let texture = null;

//       // Use productData instead of snap!
//       if (type.includes("Text")) {
//         const textValue = productData?.[type] || ""; // e.g., productData.frontText
//         shouldDisplay = !!textValue && textValue.trim() !== "";

//         if (shouldDisplay) {
//           texture = getTextTexture(
//             type,
//             textValue,
//             // Use productData.textColors instead of snap.textColors
//             productData?.textColors?.[
//               type.includes("front") ? "front" : "back"
//             ] || "#ffffff",
//             // Use productData.textFonts instead of state.textFonts
//             productData?.textFonts?.[
//               type.includes("front") ? "front" : "back"
//             ] ||
//               productData?.selectedFonts ||
//               "Arial",
//             isSelected
//           );
//         }
//       } else if (type.includes("Number")) {
//         const numberValue = productData?.[type] || ""; // e.g., productData.frontNumber
//         shouldDisplay = !!numberValue && numberValue.trim() !== "";

//         if (shouldDisplay) {
//           texture = getNumberTexture(
//             type,
//             numberValue,
//             // Use productData.numberColors instead of snap.numberColors
//             productData?.numberColors?.[
//               type.includes("front") ? "front" : "back"
//             ] || "#ffffff",
//             // Use productData.numberFonts instead of state.numberFonts
//             productData?.numberFonts?.[
//               type.includes("front") ? "front" : "back"
//             ] ||
//               productData?.selectedFonts ||
//               "Arial",
//             isSelected
//           );
//         }
//       } else if (type.includes("Logo")) {
//         const logoTex = type === "frontLogo" ? logoTexture : logoTextureBack;
//         shouldDisplay = !!logoTex;
//         texture = logoTex;
//       }

//       if (!shouldDisplay || !texture) return null;

//       // CRITICAL FIX: Show selection UI for ALL models, not just menmenjersey
//       const shouldShowDots = isSelected;

//       let adjustedScale = getAspectAwareScale(type, scale, texture);

//       // Get model-specific configuration
//       const modelKey = state.newKey;
//       const modelConfig = getModelSettings(menuSlug, subcategorySlug);

//       let selectionScaleMultiplier = 1;
//       let frameWidthMultiplier = 1;
//       let frameHeightMultiplier = 1;
//       let cornerSizeMultiplier = 1;
//       let showFullBorder = false;

//       if (modelKey === "menmenjersey") {
//         selectionScaleMultiplier = 1;
//         frameWidthMultiplier = 1;
//         frameHeightMultiplier = 1;
//         showFullBorder = true;
//       } else if (
//         modelKey === "menmentrackpants" ||
//         modelKey === "womenwomentrackpants"
//       ) {
//         selectionScaleMultiplier = 20;
//         frameWidthMultiplier = 0.8;
//         frameHeightMultiplier = 0.8;
//       } else if (
//         modelKey === "kidskidscricketshorts" ||
//         modelKey === "kidskidsshorts" ||
//         modelKey === "kidskidscyclingshorts" ||
//         modelKey === "kidskidswintershorts" ||
//         modelKey === "kidskidsrunningshorts" ||
//         modelKey === "kidskidswovenshorts" ||
//         modelKey === "kidskidsknittedshorts" ||
//         modelKey === "kidskidsbasketballshorts" ||
//         modelKey === "kidskidssoccershorts" ||
//         modelKey === "kidskidsfootballshorts" ||
//         modelKey === "kidskidsnftfootballshorts"
//       ) {
//         selectionScaleMultiplier = 1;
//         frameWidthMultiplier = 1;
//         frameHeightMultiplier = 1;
//         showFullBorder = true;
//       } else if (modelKey.includes("shorts")) {
//         selectionScaleMultiplier = 1;
//         frameWidthMultiplier = 1;
//         frameHeightMultiplier = 1;
//         showFullBorder = true;
//       } else if (
//         modelKey === "menmentanktop" ||
//         modelKey === "menmenarmsleeves" ||
//         modelKey === "menmensinglet"
//       ) {
//         selectionScaleMultiplier = 1; // Fixed from 20 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (
//         modelKey === "menmencyclingjersey" ||
//         modelKey === "menmenwinterjersey" ||
//         modelKey === "menmenbasketballjersey" ||
//         modelKey === "womenwomencyclingjersey" ||
//         modelKey === "womenwomenwinterjersey"
//       ) {
//         selectionScaleMultiplier = 1; // Fixed from 20 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (
//         modelKey === "menmencitycollection" ||
//         modelKey === "womenwomencitycollection"
//       ) {
//         selectionScaleMultiplier = 1; // Fixed from 150 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (modelKey === "womenwomencricketjersey") {
//         selectionScaleMultiplier = 1; // Fixed from 15 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (
//         modelKey === "kidskidsjersey" ||
//         modelKey === "kidskidsprotshirt" ||
//         modelKey === "kidskidsfootballjersey" ||
//         modelKey === "kidskidssoccerjersey"
//       ) {
//         selectionScaleMultiplier = 1; // Fixed from 3 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (
//         modelKey === "kidskidstanktop" ||
//         modelKey === "kidskidssinglet"
//       ) {
//         selectionScaleMultiplier = 1; // Fixed from 15 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (
//         modelKey === "kidskidscyclingjersey" ||
//         modelKey === "kidskidswinterjersey" ||
//         modelKey === "kidskidscitycollection"
//       ) {
//         selectionScaleMultiplier = 1; // Fixed from 5 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (modelKey === "kidskidscricketjersey") {
//         selectionScaleMultiplier = 1; // Fixed from 15 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (modelKey === "kidskidsxjersey") {
//         selectionScaleMultiplier = 1; // Fixed from 0.2 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (modelKey === "kidskidsarmsleeves") {
//         selectionScaleMultiplier = 1; // Fixed from 5 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (
//         modelKey === "menmencompressionpants" ||
//         modelKey === "womenwomencompressionpants" ||
//         modelKey === "kidskidstrackpants" ||
//         modelKey === "kidskidscompressionpants"
//       ) {
//         selectionScaleMultiplier = 20;
//         frameWidthMultiplier = 0.8;
//         frameHeightMultiplier = 0.8;
//         showFullBorder = true;
//       } else {
//         selectionScaleMultiplier = 1;
//         frameWidthMultiplier = 1;
//         frameHeightMultiplier = 1;
//         showFullBorder = true;
//       }

//       let baseSelectionWidth, baseSelectionHeight;
//       if (modelKey === "menmenjersey") {
//         const minSelectionSize = 0.05;
//         const maxSelectionSize = 1.5;

//         baseSelectionWidth = Math.min(
//           Math.max(adjustedScale?.[0] || 0.2, minSelectionSize),
//           maxSelectionSize
//         );

//         baseSelectionHeight = Math.min(
//           Math.max(adjustedScale?.[1] || 0.2, minSelectionSize),
//           maxSelectionSize
//         );
//       } else {
//         // For all other models - use simplified logic without clamping
//         baseSelectionWidth = (adjustedScale?.[0] || 0.2) * frameWidthMultiplier;
//         baseSelectionHeight =
//           (adjustedScale?.[1] || 0.2) * frameHeightMultiplier;
//       }

//       console.log("Base Selection Width:", baseSelectionWidth);
//       console.log("Base Selection Height:", baseSelectionHeight);

//       // Tighter selection for text to fit closer to actual text bounds
//       // Tighter selection for text to fit closer to actual text bounds
//       let selectionTightness;

//       if (
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenxjersey" ||
//         modelKey === "menmenprotshirt" ||
//         modelKey === "menmenfootballjersey" ||
//         modelKey === "menmensoccerjersey"
//       ) {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.73
//           : type.includes("Text")
//           ? 0.58
//           : 0.48;
//       } else if (
//         modelKey === "menmencyclingjersey" ||
//         modelKey === "menmenwinterjersey"
//       ) {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.5
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "menmencitycollection" ||
//         modelKey === "menmencricketjersey"
//       ) {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.3
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "menmentrackpants" ||
//         modelKey === "menmenshorts" ||
//         modelKey === "menmencricketshorts" ||
//         modelKey === "menmencyclingshorts" ||
//         modelKey === "menmenrunningshorts" ||
//         modelKey === "menmenwovenshorts" ||
//         modelKey === "menmenknittedshorts" ||
//         modelKey === "menmenfootballshorts" ||
//         modelKey === "menmensoccershorts" ||
//         modelKey === "menmenbasketballshorts" ||
//         modelKey === "menmennftfootballshorts"
//       ) {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.3
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (modelKey === "menmenarmsleeves") {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.5
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (modelKey === "menmenbasketballjersey") {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.5
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (modelKey === "menmencompressionpants") {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.15
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "womenwomenbadmintonjersey" ||
//         modelKey === "womenwomenprotshirt" ||
//         modelKey === "womenwomenfootballjersey" ||
//         modelKey === "womenwomensoccerjersey"
//       ) {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.12
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (modelKey === "womenwomencricketjersey") {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.12
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "womenwomencyclingjersey" ||
//         modelKey === "womenwomenwinterjersey"
//       ) {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.5
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "womenwomenxjersey" ||
//         modelKey === "womenwomenjersey"
//       ) {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.12
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "womenwomenbadmintonshorts" ||
//         modelKey === "womenwomencyclingshorts" ||
//         modelKey === "womenwomencricketshorts" ||
//         modelKey === "womenwomenwovenshorts" ||
//         modelKey === "womenwomentightshorts" ||
//         modelKey === "womenwomenfootballshorts" ||
//         modelKey === "womenwomensoccershorts" ||
//         modelKey === "womenwomennftfootballshorts" ||
//         modelKey === "womenwomenbasketballshorts" ||
//         modelKey === "womenwomenknittedshorts"
//       ) {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.2
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "womenwomencompressionpants" ||
//         modelKey === "womenwomentrackpants" ||
//         modelKey === "womenwomencrickettrackpants"
//       ) {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.2
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "kidskidsjersey" ||
//         modelKey === "kidskidstanktop" ||
//         modelKey === "kidskidsprotshirt" ||
//         modelKey === "kidskidsfootballjersey" ||
//         modelKey === "kidskidssoccerjersey"
//       ) {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.15
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "kidskidscricketjersey" ||
//         modelKey === "kidskidsxjersey" ||
//         modelKey === "kidskidssinglet" ||
//         modelKey === "kidskidsarmsleeves"
//       ) {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.12
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (modelKey === "kidskidsbasketballjersey") {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.45
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "kidskidsshorts" ||
//         modelKey === "kidskidscricketshorts" ||
//         modelKey === "kidskidscyclingshorts" ||
//         modelKey === "kidskidswintershorts" ||
//         modelKey === "kidskidsrunningshorts" ||
//         modelKey === "kidskidswovenshorts" ||
//         modelKey === "kidskidsknittedshorts" ||
//         modelKey === "kidskidsbasketballshorts" ||
//         modelKey === "kidskidssoccershorts" ||
//         modelKey === "kidskidsfootballshorts" ||
//         modelKey === "kidskidsnftfootballshorts"
//       ) {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.4
//           : type.includes("Text")
//           ? 0.38
//           : 0.48;
//       } else if (
//         modelKey === "kidskidstrackpants" ||
//         modelKey === "kidskidscompressionpants"
//       ) {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.5
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.2
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       }

//       const frameWidth = baseSelectionWidth * selectionTightness;
//       const frameHeight = baseSelectionHeight * selectionTightness;

//       console.log("Frame Width:", frameWidth);
//       console.log("Frame Height:", frameHeight);

//       const layerOrder = type.includes("Number")
//         ? 2
//         : type.includes("Text")
//         ? 1
//         : 0;
//       const polygonOffsetFactor = -1 - layerOrder;
//       const additionalRotation = decalRotations[type] || 0;
//       const finalRotation = [
//         rotation[0],
//         rotation[1],
//         rotation[2] + additionalRotation,
//       ];

//       if (type.includes("Text")) {
//         console.log(
//           `📝 Rendering ${type}: baseRot=${(
//             (rotation[2] * 180) /
//             Math.PI
//           ).toFixed(1)}°, addRot=${(
//             (additionalRotation * 180) /
//             Math.PI
//           ).toFixed(1)}°, finalRot=${(
//             (finalRotation[2] * 180) /
//             Math.PI
//           ).toFixed(1)}°`
//         );
//       }

//       // Render using mesh with CanvasTexture - simplified, no decal UI
//       const renderOrder = type.includes("Number")
//         ? 1002
//         : type.includes("Text")
//         ? 1001
//         : type.includes("back")
//         ? 1003
//         : 1000;

//       // Calculate tight scale based on actual texture dimensions to keep lines close to text
//       let tightScale = adjustedScale;
//       if (isTextDecal || isNumberDecal) {
//         // Use tighter scale - close to actual text bounds (0.98) to minimise gap from t-shirt
//         tightScale = [
//           adjustedScale[0] * 0.98,
//           adjustedScale[1] * 0.98,
//           adjustedScale[2]
//         ];
//       } else if (type.includes("Logo")) {
//         // For logos, use adjustedScale as-is (already maintains aspect ratio from texture dimensions)
//         // Don't apply any tightness multiplier to preserve aspect ratio
//         tightScale = adjustedScale;
//       }

//       // Calculate dot positions for selection indicators - close to text
//       const dotSize = Math.min(tightScale[0], tightScale[1]) * 0.045; // Increased dot size
//       const dotDepth = type.includes("Logo") ? 0.05 : 0.001; // Much higher z-depth for logos to appear above
//       // Bring dots very close to text by using 70% of the tightScale
//       const dotOffset = 0.70; // Very close to text bounds
//       const hw = (tightScale[0] / 2) * dotOffset;
//       const hh = (tightScale[1] / 2) * dotOffset;
//       const corners = [
//         { pos: [-hw, hh, dotDepth], label: 'tl' },   // top-left
//         { pos: [hw, hh, dotDepth], label: 'tr' },    // top-right
//         { pos: [0, hh, dotDepth], label: 'tm' },     // top-middle
//         { pos: [-hw, -hh, dotDepth], label: 'bl' },  // bottom-left
//         { pos: [hw, -hh, dotDepth], label: 'br' },   // bottom-right
//         { pos: [0, -hh, dotDepth], label: 'bm' }     // bottom-middle
//       ];

//       const useDecal = isTextDecal || isNumberDecal || type.includes("Logo");
//       const textureVisual = useDecal ? (
//         <Decal
//           key={`${type}-decal-${(additionalRotation * 10000).toFixed(0)}`}
//           position={position}
//           rotation={finalRotation}
//           scale={tightScale}
//           map={texture}
//           polygonOffsetFactor={polygonOffsetFactor}
//           depthTest={true}
//           {...{ "material-alphaTest": 0.1, "material-depthWrite": false }}
//         />
//       ) : (
//         <mesh
//           key={`${type}-texture-mesh-${(additionalRotation * 10000).toFixed(0)}`}
//           position={displayPosition}
//           rotation={finalRotation}
//           scale={tightScale}
//           renderOrder={renderOrder}
//         >
//           <planeGeometry args={[1, 1]} />
//           <meshStandardMaterial
//             map={texture}
//             transparent={true}
//             alphaTest={0.1}
//             depthTest={true}
//             depthWrite={false}
//             polygonOffset={true}
//             polygonOffsetFactor={polygonOffsetFactor}
//             alphaToCoverage={true}
//             side={THREE.DoubleSide}
//           />
//         </mesh>
//       );

//       return (
//         <>
//           {textureVisual}
//           <group>
//             {/* Invisible clickable/draggable area - depthTest: true; ignore when decal faces away */}
//             <mesh
//             position={displayPosition}
//             rotation={finalRotation}
//             scale={tightScale}
//             renderOrder={renderOrder + 0.1}
//             onPointerDown={(e) => {
//               e.stopPropagation();
//               if (!isDecalFacingCamera(e)) return;
//               const isDot = e.object?.userData?.isDot;
//               const isRotationButton = e.object?.userData?.isRotationButton;
//               if ((e.object === e.target || (!isDot && !isRotationButton))) {
//                 handleDecalDragStart(e, type);
//               }
//             }}
//             onClick={(e) => {
//               if (!isDecalFacingCamera(e)) return;
//               if (!hasDraggedRef.current && interactionMode !== "resizing") {
//                 e.stopPropagation();
//                 setSelectedDecal(type);
//               }
//             }}
//           >
//             <planeGeometry args={[1, 1]} />
//             <meshBasicMaterial
//               transparent
//               opacity={0}
//               depthTest={true}
//               depthWrite={false}
//               side={THREE.DoubleSide}
//             />
//           </mesh>

//           {/* Small selection dots at corners */}
//           {isSelected && (
//             <group position={displayPosition} rotation={finalRotation}>
//               {corners.map((corner, idx) => (
//                 <mesh
//                   key={`dot-${corner.label}-${idx}`}
//                   position={corner.pos}
//                   renderOrder={renderOrder + 100}
//                   userData={{ isDot: true }}
//                   onPointerDown={(e) => {
//                     e.stopPropagation();
//                     handleCornerDragStart(e, type, corner.label);
//                   }}
//                   onPointerOver={(e) => {
//                     e.stopPropagation();
//                     document.body.style.cursor = 'nwse-resize';
//                   }}
//                   onPointerOut={(e) => {
//                     e.stopPropagation();
//                     if (!isResizing) {
//                       document.body.style.cursor = 'auto';
//                     }
//                   }}
//                 >
//                   <sphereGeometry args={[dotSize, 8, 8]} />
//                   <meshBasicMaterial
//                     color="#4A90E2"
//                     transparent={false}
//                     depthTest={false}
//                     depthWrite={false}
//                   />
//                 </mesh>
//               ))}
//             </group>
//           )}

//           {/* Rotation buttons at vertical center (for text/numbers/logos) */}
//           {isSelected && (isTextDecal || isNumberDecal || type.includes("Logo")) && (
//             <group position={displayPosition} rotation={finalRotation}>
//               {/* Left rotation button (at vertical center, anticlockwise) */}
//               {/* <group position={[-hw - dotSize * 2.5, 0, dotDepth + (type.includes("Logo") ? 0.01 : 0.0005)]}>
//                 <mesh
//                   renderOrder={renderOrder + 100}
//                   userData={{ isRotationButton: true, direction: 'anticlockwise' }}
//                   onPointerDown={(e) => {
//                     e.stopPropagation();
//                     e.nativeEvent?.stopPropagation?.();
//                     e.nativeEvent?.stopImmediatePropagation?.();
//                     // startContinuousRotation(type, 'anticlockwise');
//                   }}
//                   onPointerUp={(e) => {
//                     e.stopPropagation();
//                     stopContinuousRotation();
//                   }}
//                   onPointerLeave={(e) => {
//                     e.stopPropagation();
//                     stopContinuousRotation();
//                   }}
//                   onPointerOver={(e) => {
//                     e.stopPropagation();
//                     document.body.style.cursor = 'pointer';
//                   }}
//                   onPointerOut={(e) => {
//                     e.stopPropagation();
//                     document.body.style.cursor = 'auto';
//                   }}
//                 >
//                   <sphereGeometry args={[dotSize * 1.35, 12, 12]} />
//                   <meshBasicMaterial
//                     color="#FF6B6B"
//                     transparent={false}
//                     depthTest={false}
//                     depthWrite={false}
//                   />
//                 </mesh>
//                 <Html
//                   center
//                   distanceFactor={10}
//                   style={{ pointerEvents: 'none' }}
//                 >
//                   <div style={{
//                     fontSize: `${dotSize * 1.35 * 60}px`,
//                     color: 'white',
//                     fontWeight: 'bold',
//                     userSelect: 'none',
//                     pointerEvents: 'none',
//                     lineHeight: '1'
//                   }}>↺</div>
//                 </Html>
//               </group> */}
              
//               {/* Right rotation button (at vertical center, clockwise) */}
//               {/* <group position={[hw + dotSize * 2.5, 0, dotDepth + (type.includes("Logo") ? 0.01 : 0.0005)]}>
//                 <mesh
//                   renderOrder={renderOrder + 100}
//                   userData={{ isRotationButton: true, direction: 'clockwise' }}
//                   onPointerDown={(e) => {
//                     e.stopPropagation();
//                     e.nativeEvent?.stopPropagation?.();
//                     e.nativeEvent?.stopImmediatePropagation?.();
//                     // startContinuousRotation(type, 'clockwise');
//                   }}
//                   onPointerUp={(e) => {
//                     e.stopPropagation();
//                     stopContinuousRotation();
//                   }}
//                   onPointerLeave={(e) => {
//                     e.stopPropagation();
//                     stopContinuousRotation();
//                   }}
//                   onPointerOver={(e) => {
//                     e.stopPropagation();
//                     document.body.style.cursor = 'pointer';
//                   }}
//                   onPointerOut={(e) => {
//                     e.stopPropagation();
//                     document.body.style.cursor = 'auto';
//                   }}
//                 >
//                   <sphereGeometry args={[dotSize * 1.35, 12, 12]} />
//                   <meshBasicMaterial
//                     color="#4ECDC4"
//                     transparent={false}
//                     depthTest={false}
//                     depthWrite={false}
//                   />
//                 </mesh>
//                 <Html
//                   center
//                   distanceFactor={10}
//                   style={{ pointerEvents: 'none' }}
//                 >
//                   <div style={{
//                     fontSize: `${dotSize * 1.35 * 60}px`,
//                     color: 'white',
//                     fontWeight: 'bold',
//                     userSelect: 'none',
//                     pointerEvents: 'none',
//                     lineHeight: '1'
//                   }}>↻</div>
//                 </Html>
//               </group> */}

//               {/* Rotation icon above decal (for smooth mouse drag rotation - text, number, logo) */}
//               {(isTextDecal || isNumberDecal || type.includes("Logo")) && (
//                 <group position={[0, hh + dotSize * 3, dotDepth + (type.includes("Logo") ? 0.01 : 0.0005)]}>
//                   <mesh
//                     renderOrder={renderOrder + 101}
//                     userData={{ isRotationButton: true, isRotationHandle: true }}
//                     onPointerDown={(e) => {
//                       e.stopPropagation();
//                       e.nativeEvent?.stopPropagation?.();
//                       e.nativeEvent?.stopImmediatePropagation?.();
//                       handleDecalRotate(e, type);
//                     }}
//                     onPointerUp={(e) => {
//                       e.stopPropagation();
//                       stopContinuousRotation();
//                     }}
//                     onPointerLeave={(e) => {
//                       e.stopPropagation();
//                       stopContinuousRotation();
//                     }}
//                     onPointerOver={(e) => {
//                       e.stopPropagation();
//                       document.body.style.cursor = 'grab';
//                     }}
//                     onPointerOut={(e) => {
//                       e.stopPropagation();
//                       if (interactionMode !== "rotating") {
//                         document.body.style.cursor = 'auto';
//                       }
//                     }}
//                   >
//                     <sphereGeometry args={[dotSize * 1.5, 16, 16]} />
//                     <meshBasicMaterial
//                       color="#9B59B6"
//                       transparent={false}
//                       depthTest={false}
//                       depthWrite={false}
//                     />
//                   </mesh>
//                   <Html
//                     center
//                     distanceFactor={10}
//                     style={{ pointerEvents: 'none' }}
//                   >
//                     <div style={{
//                       fontSize: `${dotSize * 1.5 * 70}px`,
//                       color: 'white',
//                       fontWeight: 'bold',
//                       userSelect: 'none',
//                       pointerEvents: 'none',
//                       lineHeight: '1',
//                       transform: 'rotate(-45deg)',
//                       display: 'inline-block'
//                     }}>↻</div>
//                   </Html>
//                 </group>
//               )}
//             </group>
//           )}
//           </group>
//         </>
//       );
//     };

//     return (
//       <>
//         {/* NEW RESIZE FEATURE - HTML overlay for smooth resize */}

//         {interactionMode === "new-resize-mode" && (
//           <Html>
//             <div
//               style={{
//                 position: "fixed",
//                 top: 0,
//                 left: 0,
//                 width: "100vw",
//                 height: "100vh",
//                 pointerEvents: "auto",
//                 cursor:
//                   newResizeCorner === "tl" || newResizeCorner === "br"
//                     ? "nwse-resize"
//                     : "nesw-resize",
//                 backgroundColor: "transparent",
//                 zIndex: 9999,
//               }}
//               onPointerMove={handleNewResizeFunction}
//               onPointerUp={handlePointerUp}
//               onMouseMove={handleNewResizeFunction}
//               onMouseUp={handlePointerUp}
//               onTouchMove={handleNewResizeFunction}
//               onTouchEnd={handlePointerUp}
//             />
//           </Html>
//         )}

//         <Html
//           style={{
//             position: "absolute",
//             top: "-1000px",
//             left: "-800px",
//             zIndex: "999999999999999999999",
//           }}
//         >
//           <div id="svg-hidden-container" ref={svgContainerRef}></div>
//         </Html>

//         {interactionMode === "resize-decal" && (
//           <Html>
//             <div
//               style={{
//                 position: "fixed",
//                 top: 0,
//                 left: 0,
//                 width: "100vw",
//                 height: "100vh",
//                 pointerEvents: "auto",
//                 cursor: "nwse-resize",
//               }}
//               onPointerMove={handleResizeMove}
//               onPointerUp={handleResizeUp}
//               onMouseMove={handleResizeMove}
//               onMouseUp={handleResizeUp}
//               onTouchMove={handleResizeMove}
//               onTouchEnd={handleResizeUp}
//             />
//           </Html>
//         )}

//         {interactionMode === "move-decal" && (
//           <Html>
//             <div
//               style={{
//                 position: "fixed",
//                 top: "-188px",
//                 left: "-179px",
//                 width: "34vw",
//                 height: "65vh",
//                 pointerEvents: "auto",
//                 cursor: "move",
//               }}
//               onPointerMove={handlePointerMove}
//               onPointerUp={handlePointerUp}
//               onMouseMove={handlePointerMove}
//               onMouseUp={handlePointerUp}
//               onTouchMove={handlePointerMove}
//               onTouchEnd={handlePointerUp}
//             />
//           </Html>
//         )}

//         {interactionMode === "rotating" && (
//           <Html>
//             <div
//               style={{
//                 position: "fixed",
//                 top: "-188px",
//                 left: "-179px",
//                 width: "34vw",
//                 height: "65vh",
//                 pointerEvents: "auto",
//                 cursor: "grabbing",
//               }}
//               onPointerMove={handlePointerMove}
//               onPointerUp={handlePointerUp}
//               onMouseMove={handlePointerMove}
//               onMouseUp={handlePointerUp}
//               onTouchMove={handlePointerMove}
//               onTouchEnd={handlePointerUp}
//             />
//           </Html>
//         )}

//         <OrbitControls
//           enableZoom={true}
//           enablePan={false}
//           enabled={interactionMode === "rotate-shirt"}
//           target={[0, 0, 0]}
//           enableRotate
//           rotateSpeed={2.0}
//           minDistance={4.5}
//           maxDistance={5.5}
//         />

//         {selectedDecal && renderResizeArrow()}

//         {isLoading && (
//           <Html center>
//             <div style={loadingStyles}>
//               <Spinner animation="border" variant="dark" />
//               <p style={loadingTextStyles}>Loading...</p>
//             </div>
//           </Html>
//         )}

//         {!isLoading && (
//           <group
//             ref={group}
//             dispose={null}
//             // scale={overallScale}
//             scale={overallScale * mobileScaleFactor}
//             onPointerDown={() => {
//               handleDeselect();
//             }}
//           >
//             {/* <group position={position} rotation={rotation} scale={scale}> */}
//             <group
//               position={[
//                 position[0] + mobilePositionOffset[0],
//                 position[1] + mobilePositionOffset[1],
//                 position[2] + mobilePositionOffset[2],
//               ]}
//               // rotation={rotation}
//               rotation={animatedRotation}
//               scale={scale}
//             >
//               {parts
//                 .filter((part) => part.material.name !== "LOGO")
//                 .map((part, index) => {
//                   const partName = (part.name || "").toUpperCase();
//                   const matName = (part.material?.name || "").toUpperCase();
//                   const isFrontPart = partName.includes("FRONT") || matName.includes("FRONT");
//                   const isBackPart = partName.includes("BACK") || matName.includes("BACK");
//                   const showFrontDecals = isFrontPart || (!isFrontPart && !isBackPart);
//                   const showBackDecals = isBackPart || (!isFrontPart && !isBackPart);
//                   return (
//                     <mesh
//                       key={`non-logo-${index}`}
//                       geometry={part.geometry}
//                       material={part.material}
//                       name={part.name}
//                       ref={shirtRef}
//                     >
//                       <>
//                         {/* Front decals - only on front (or neutral) parts */}
//                         {showFrontDecals && renderDecal(
//                           "frontText",
//                           frontTextTexture.current,
//                           frontTextPosition,
//                           frontTextRotation,
//                           frontTextScale
//                         )}
//                         {showFrontDecals && renderDecal(
//                           "frontNumber",
//                           frontNumberTexture.current,
//                           frontNumberPosition,
//                           frontNumberRotation,
//                           frontNumberScale
//                         )}
//                         {showFrontDecals && renderDecal(
//                           "frontLogo",
//                           logoTexture,
//                           frontLogoPosition,
//                           frontLogoRotation,
//                           frontLogoScale
//                         )}

//                         {/* Back decals - only on back (or neutral) parts */}
//                         {showBackDecals && renderDecal(
//                           "backText",
//                           backTextTexture.current,
//                           backTextPosition,
//                           backTextRotation,
//                           backTextScale
//                         )}
//                         {showBackDecals && renderDecal(
//                           "backNumber",
//                           backNumberTexture.current,
//                           backNumberPosition,
//                           backNumberRotation,
//                           backNumberScale
//                         )}
//                         {showBackDecals && renderDecal(
//                           "backLogo",
//                           logoTextureBack,
//                           backLogoPosition,
//                           backLogoRotation,
//                           backLogoScale
//                         )}
//                       </>
//                     </mesh>
//                   );
//                 })}
//             </group>

//             {parts
//               .filter((part) => part.material.name === "LOGO")
//               .map((part, index) => {
//                 return (
//                   <mesh
//                     geometry={part.geometry}
//                     material={part.material}
//                     position={logoPosition}
//                     rotation={logoRotation}
//                     scale={logoScale}
//                   />
//                 );
//               })}
//           </group>
//         )}
//       </>
//     );
//   }
// );
// const loadingStyles = {
//   display: "flex",
//   flexDirection: "row",
//   alignItems: "center",
//   justifyContent: "center",
//   backgroundColor: "rgba(197, 197, 197, 0.8)",
//   padding: "5px 15px",
//   borderRadius: "8px",
//   gap: "20px",
// };

// const loadingTextStyles = {
//   fontSize: "20px",
//   fontWeight: "bold",
//   color: "black",
//   marginTop: "10px",
// };

// const instructionsStyle = {
//   background: "rgba(0,0,0,0.7)",
//   padding: "10px",
//   borderRadius: "8px",
//   color: "white",
// };

// export default ShirtModel;



// import React, {
//   useEffect,
//   useState,
//   useRef,
//   useMemo,
//   useCallback,
// } from "react";
// import { createPortal } from "react-dom";
// import { forwardRef, useImperativeHandle } from "react";
// import * as THREE from "three";
// import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
// import state from "./index.js";
// import { useSnapshot } from "valtio";
// import {
//   OrbitControls,
//   Decal,
//   Html,
//   TransformControls,
// } from "@react-three/drei";
// import Spinner from "react-bootstrap/Spinner";
// import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
// import clothingConfig from "./clothingConfig";
// import { CanvasTexture } from "three";
// import modelConfig1 from "./modelConfig1.js";
// import { GLTFExporter } from "three/examples/jsm/exporters/GLTFExporter";
// import { TextureLoader } from "three";
// import { useFrame } from "@react-three/fiber";
// import { fabric } from "fabric";
// import { useThree } from "@react-three/fiber";
// import { useDispatch, useSelector } from "react-redux";
// import { FaArrowRotateLeft, FaArrowsRotate } from "react-icons/fa6";
// import { useLocation } from "react-router-dom";

// const DEFAULT_MODEL_URL = "/asset/HalfpoloK5.glb";
// const LEGACY_MODEL_URL = "/LongTeeM1.glb";

// const ShirtModel = forwardRef(
//   (
//     { menuSlug, subcategorySlug, gltfRef, isEditingDraft, currentProduct },
//     ref
//   ) => {
//     console.log("svg <<<<<<<<<>>>>>>>>>>>>>>>>>>..... : ", state.svg);
//     const { glbId } = useSelector((state) => state.cart);
//     const { camera } = useThree();
//     const raycaster = useMemo(() => new THREE.Raycaster(), []);
//     const mouse = useMemo(() => new THREE.Vector2(), []);
//     // const { selectedPattern } = useSnapshot(state);
//     const [isLoading, setIsLoading] = useState(true);
//     const snap = useSnapshot(state);
//     const group = useRef();
//     const shirtRef = useRef();
//     const [bandMesh, setBandMesh] = useState(null);
//     const location = useLocation(); // Add this line
//     const [isMobile, setIsmobile] = useState(window.innerWidth < 667);
//     const [initialDecalRotation, setInitialDecalRotation] = useState(0);
//     console.log("state.newKey : ", state.newKey);
//     console.log("state.frontText : ", state.frontText);
//     console.log("settings.Colors : ", state.partColors);
//     console.log(
//       "state.gradientColors...................... : ",
//       state.gradientColors
//     );

//     const productData = currentProduct || state.currentProduct;

//     console.log("productData///////////////////////// : ",productData)
//     const { selectedPattern } = productData || {};

//     console.log("state.newKey : ", state.newKey);
//     console.log("currentProduct frontText : ", productData?.frontText);
//     console.log("currentProduct partColors : ", productData?.partColors);
//     console.log(
//       "currentProduct gradientColors : ",
//       productData?.gradientColors
//     );

//     const { viewSide } = productData || { viewSide: "front" };

// const previousModelUrlRef = useRef(null);

// // Add this effect to ShirtModel.jsx
// useEffect(() => {
//   // Reset model loading state when product changes
//   if (productData?.id && previousProductIdRef.current !== productData.id) {
//     console.log("Product ID changed, resetting model state");
    
//     // If the model name is the same but product is different (duplicate),
//     // we need to reload the model to get fresh textures
//     if (previousModelUrlRef.current === productData.modelName) {
//       console.log("Same model URL, different product - reloading");
//       loadModelForProduct();
//     }
    
//     previousProductIdRef.current = productData.id;
//   }
// }, [productData?.id, productData?.modelName]);

//   useEffect(() => {
//       if (group.current && productData?.id) {
//         console.log("Product changed, applying images...");
//         applyImagesToMaterials();
//       }
//     }, [productData?.id, productData?.imagesPattern]);
    
//     // Optimize applyImagesToMaterials with useCallback
//     const applyImagesToMaterials = useCallback(async () => {
//       if (!group.current || !productData?.imagesPattern) {
//         console.log("No group or no imagesPattern to apply");
//         return;
//       }
      
//       console.log("Applying images to materials...");
      
//       const imagesPattern = productData.imagesPattern || {};
//       const normalizedImages = Object.fromEntries(
//         Object.entries(imagesPattern).map(([key, val]) => [
//           key.toUpperCase(),
//           val,
//         ])
//       );
      
//       // Process each mesh in the model
//       group.current.traverse(async (child) => {
//         if (!child.isMesh || !child.material) return;
        
//         const materialName = child.material.name?.toUpperCase();
//         if (!materialName) return;
        
//         const materials = Array.isArray(child.material)
//           ? child.material
//           : [child.material];
        
//         for (const mat of materials) {
//           const imageData = normalizedImages[materialName];
          
//           // Dispose of existing texture
//           if (mat.map) {
//             mat.map.dispose();
//             mat.map = null;
//           }
          
//           if (imageData?.image) {
//             try {
//               const texture = await new THREE.TextureLoader().loadAsync(
//                 imageData.image
//               );
              
//               texture.colorSpace = THREE.SRGBColorSpace;
//               texture.flipY = false;
//               texture.wrapS = THREE.RepeatWrapping;
//               texture.wrapT = THREE.RepeatWrapping;
//               texture.center.set(0.5, 0.5);
              
//               // Set texture properties
//               const img = new Image();
//               img.crossOrigin = "anonymous";
              
//               img.onload = () => {
//                 const imageAspect = img.width / img.height;
//                 const shirtAspect = 2220 / 2553;
//                 const SCALE_FACTOR = 2;
                
//                 if (img.width >= 2220 && img.height >= 2553) {
//                   if (imageAspect > shirtAspect) {
//                     texture.repeat.set(
//                       (shirtAspect / imageAspect) * SCALE_FACTOR,
//                       1 * SCALE_FACTOR
//                     );
//                   } else {
//                     texture.repeat.set(
//                       1 * SCALE_FACTOR,
//                       (imageAspect / shirtAspect) * SCALE_FACTOR
//                     );
//                   }
//                 } else if (img.width >= 1000 && img.height >= 1000) {
//                   texture.repeat.set(
//                     (2220 / img.width) * 0.8 * SCALE_FACTOR,
//                     (2553 / img.height) * 0.8 * SCALE_FACTOR
//                   );
//                 } else {
//                   const scaleX = Math.max(1, 2220 / img.width);
//                   const scaleY = Math.max(1, 2553 / img.height);
//                   texture.repeat.set(scaleX * SCALE_FACTOR, scaleY * SCALE_FACTOR);
//                 }
                
//                 texture.needsUpdate = true;
//               };
              
//               img.src = imageData.image;
              
//               mat.map = texture;
//               mat.color.set(0xffffff);
//               mat.needsUpdate = true;
              
//               console.log(`Applied texture to ${materialName}`);
//             } catch (err) {
//               console.error(`Failed to load image for ${materialName}:`, err);
//             }
//           } else {
//             // No image - use default color
//             mat.map = null;
//             mat.color.set("#112F51");
//             mat.needsUpdate = true;
//           }
//         }
//       });
//     }, [productData?.imagesPattern,productData?.id,]);
    
//     // Add a debug effect to log when product changes
//     useEffect(() => {
//       console.log("Product data updated:", {
//         id: productData?.id,
//         imagesPattern: productData?.imagesPattern,
//         hasImages: !!productData?.imagesPattern && Object.keys(productData.imagesPattern).length > 0
//       });
//     }, [productData,productData?.id,]);

//     useEffect(() => {
//       const handleResize = () => {
//         setIsmobile(window.innerWidth < 667);
//       };

//       window.addEventListener("resize", handleResize);
//       return () => window.removeEventListener("resize", handleResize);
//     }, []);
//     function resetState() {
//       state.updateTrigger++;
//       state.intro = false;
//       state.color = "#EFBD48";

//       // Reset current product data
//       const currentProductId = state.currentProductId;
//       if (state.products[currentProductId]) {
//         state.products[currentProductId] = {
//           ...state.products[currentProductId],
//           frontText: "",
//           backText: "",
//           frontNumber: "",
//           backNumber: "",
//           frontLogo: null,
//           backLogo: null,
//           imagesPattern: {},
//           viewSide: "front",
//           patternColors: {},
//           selectedPattern: {},
//           selectedFonts: "Arial",
//           textFonts: { front: "Arial", back: "Arial" },
//           numberFonts: { front: "Arial", back: "Arial" },
//           textColors: { front: "#ffffff", back: "#ffffff" },
//           numberColors: { front: "#ffffff", back: "#ffffff" },
//           partColors: {},
//           gradientColors: {},
//         };
//       }
//     }
//     // Replace your current useEffect with:
//     // Replace your current useEffect with:
//     useEffect(() => {
//       const hasDraftData =
//         location.state?.draftData || location.state?.restoreData;

//       if (!hasDraftData) {
//         console.log("No draft data found, resetting state...");
//         resetState();
//       } else {
//         console.log("Draft data found, skipping state reset...");
//         state.updateTrigger++; // Still trigger a re-render
//       }
//     }, [location.state]);

//     // In ShirtModel.jsx, add this effect to apply colors when product changes
//     useEffect(() => {
//       if (!group.current || !productData?.partColors) return;

//       console.log("Applying colors for product:", productData.id);
//       console.log("Colors to apply:", productData.partColors);

//       group.current.traverse((child) => {
//         if (child.isMesh && child.material) {
//           const partName = child.material.name?.toUpperCase();

//           if (partName && productData.partColors[partName]) {
//             const color = productData.partColors[partName];
//             const materials = Array.isArray(child.material)
//               ? child.material
//               : [child.material];

//             materials.forEach((mat) => {
//               if (mat.name === partName) {
//                 console.log(`Setting color ${color} for ${partName}`);
//                 mat.color.set(color);
//                 mat.needsUpdate = true;
//               }
//             });
//           }
//         }
//       });
//     }, [productData?.id, productData?.partColors]);

//     useEffect(() => {
//       // When product changes, update the model
//       if (productData && group.current) {
//         applyProductColorsToModel();
//       }
//     }, [productData?.id, productData?.partColors]);

//     const applyProductColorsToModel = () => {
//       if (!group.current || !productData?.partColors) return;

//       console.log("Applying colors for product:", productData.id);
//       console.log("Colors:", productData.partColors);

//       group.current.traverse((child) => {
//         if (child.isMesh && child.material) {
//           const partName = child.material.name?.toUpperCase();

//           if (partName && productData.partColors[partName]) {
//             const color = productData.partColors[partName];
//             const materials = Array.isArray(child.material)
//               ? child.material
//               : [child.material];

//             materials.forEach((mat) => {
//               if (mat.name === partName) {
//                 console.log(`Setting color ${color} for ${partName}`);
//                 mat.color.set(color);
//                 mat.needsUpdate = true;
//               }
//             });
//           }
//         }
//       });
//     };

//     const [gltf, setGltf] = useState(null);
//     const latestRequestRef = useRef(0);

//     const loadModel = useCallback(
//       (src) =>
//         new Promise((resolve, reject) => {
//           if (!src) {
//             reject(new Error("Model source is undefined"));
//             return;
//           }

//           const dracoLoader = new DRACOLoader();
//           dracoLoader.setDecoderPath(
//             "https://www.gstatic.com/draco/v1/decoders/"
//           );

//           const loader = new GLTFLoader();
//           loader.setDRACOLoader(dracoLoader);

//           loader.load(
//             src,
//             (model) => {
//               dracoLoader.dispose();
//               resolve(model);
//             },
//             undefined,
//             (error) => {
//               dracoLoader.dispose();
//               reject(error);
//             }
//           );
//         }),
//       []
//     );

//     console.log("gltf : ", gltf);

//     const getModelSettings = (menuSlug, subcategorySlug, selectedDesignId) => {
//       console.log("selectedDesignId <<<<<<<<<<<<<<>>>>>>>>>>>> ; ", glbId);
//       console.log("menuSlug .................. : ", menuSlug);
//       console.log(
//         "subcategorySlug ........................ : ",
//         subcategorySlug
//       );
//       const key = `${menuSlug}${subcategorySlug}`;
//       const newKey = key.replace(/-/g, "");
//       state.newKey = newKey;
//       console.log("newKey : ", newKey);

//       let modelConfig = modelConfig1[newKey];

//       if (newKey === "eventordereventjersey") {
//         const designKey = glbId || 900;
//         modelConfig = modelConfig1[newKey]?.[designKey];
//       }

//       return (
//         modelConfig || {
//           position: [0, 0, 0],
//           rotation: [0, 0, 0],
//           scale: 1,
//         }
//       );
//     };

//     useImperativeHandle(ref, () => ({
//       capturePng: () => {
//         if (!gltf) return null;

//         const scene = new THREE.Scene();
//         const camera = new THREE.PerspectiveCamera(35, 1, 0.1, 1000);
//         const renderer = new THREE.WebGLRenderer({
//           preserveDrawingBuffer: true,
//           alpha: true,
//         });
//         renderer.setSize(512, 512);
//         renderer.setClearColor(0x000000, 0);

//         const model = gltf.scene.clone();

//         model.scale.set(2.5, 2.5, 2.5);

//         const box = new THREE.Box3().setFromObject(model);
//         const center = box.getCenter(new THREE.Vector3());
//         model.position.x -= center.x;
//         model.position.y -= center.y;
//         model.position.z -= center.z;

//         scene.add(model);

//         const directionalLight = new THREE.DirectionalLight(0xffffff, 3.0);
//         directionalLight.position.set(3, 5, 5);
//         scene.add(directionalLight);

//         const ambientLight = new THREE.AmbientLight(0xffffff, 0.7);
//         scene.add(ambientLight);

//         const size = box.getSize(new THREE.Vector3());
//         const maxDim = Math.max(size.x, size.y, size.z);
//         const fov = camera.fov * (Math.PI / 180);
//         let cameraZ = Math.abs(maxDim / Math.sin(fov / 2)) * 0.6;

//         camera.position.set(0, 0.2, cameraZ);
//         camera.lookAt(new THREE.Vector3(0, 0.1, 0));
//         const backLight = new THREE.DirectionalLight(0xffffff, 1.5);
//         backLight.position.set(-5, -3, -5);
//         scene.add(backLight);

//         renderer.render(scene, camera);
//         const pngData = renderer.domElement.toDataURL("image/png");
//         return pngData;
//       },
//     }));

//     const {
//       partMappings,
//       overallScale,
//       position,
//       rotation,
//       scale,
//       fontSize,
//       designposition,
//       designrotation,
//       designscale,
//       patternScalling,
//       logoPosition,
//       logoRotation,
//       logoScale,
//       backNumberPosition,
//       backNumberRotation,
//       backNumberScale,
//       backLogoPosition,
//       backLogoRotation,
//       backLogoScale,
//       frontLogoPosition,
//       frontLogoRotation,
//       frontLogoScale,
//       frontTextPosition,
//       frontTextRotation,
//       frontTextScale,
//       backTextPosition,
//       backTextRotation,
//       backTextScale,
//       frontNumberPosition,
//       frontNumberRotation,
//       frontNumberScale,
//     } = getModelSettings(menuSlug, subcategorySlug);

//     const frontRotation = useMemo(() => {
//       return rotation;
//     }, [rotation]);

//     const backRotation = useMemo(() => {
//       const modelKey = state.newKey;
//       if (
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenjersey"
//       ) {
//         return [rotation[0], rotation[1] + Math.PI, rotation[2]];
//       } else if (
//         modelKey === "menmenshorts" ||
//         modelKey === "menmencricketshorts" ||
//         modelKey === "menmencyclingshorts" ||
//         modelKey === "menmenrunningshorts" ||
//         modelKey === "menmenwovenshorts" ||
//         modelKey === "menmenknittedshorts" ||
//         modelKey === "menmenfootballshorts" ||
//         modelKey === "menmensoccershorts" ||
//         modelKey === "menmenbasketballshorts" ||
//         modelKey === "menmennftfootballshorts" ||
//         modelKey === "menmencyclingjersey" ||
//         modelKey === "menmenwinterjersey" ||
//         modelKey === "menmencitycollection" ||
//         modelKey === "menmencricketjersey" ||
//         modelKey === "menmentrackpants" ||
//         modelKey === "menmencompressionpants" ||
//         modelKey === "menmensinglet" ||
//         modelKey === "menmenarmsleeves" ||
//         modelKey === "menmenbasketballjersey" ||
//         modelKey === "womenwomenbadmintonshorts" ||
//         modelKey === "womenwomencyclingshorts" ||
//         modelKey === "womenwomencricketshorts" ||
//         modelKey === "womenwomenwovenshorts" ||
//         modelKey === "womenwomentightshorts" ||
//         modelKey === "womenwomenfootballshorts" ||
//         modelKey === "womenwomensoccershorts" ||
//         modelKey === "menmencompressionpants" ||
//         modelKey === "womenwomennftfootballshorts" ||
//         modelKey === "menmencompressionpants" ||
//         modelKey === "womenwomenbasketballshorts" ||
//         modelKey === "womenwomenknittedshorts" ||
//         modelKey === "womenwomencompressionpants" ||
//         modelKey === "womenwomencrickettrackpants" ||
//         modelKey === "womenwomentrackpants" ||
//         modelKey === "womenwomencricketjersey" ||
//         modelKey === "womenwomencyclingjersey" ||
//         modelKey === "womenwomenwinterjersey" ||
//         modelKey === "womenwomencitycollection" ||
//         modelKey === "kidskidsjersey" ||
//         modelKey === "kidskidscompressionpants" ||
//         modelKey === "kidskidsshorts" ||
//         modelKey === "kidskidscricketshorts" ||
//         modelKey === "kidskidscyclingshorts" ||
//         modelKey === "kidskidswintershorts" ||
//         modelKey === "kidskidsrunningshorts" ||
//         modelKey === "kidskidswovenshorts" ||
//         modelKey === "kidskidsknittedshorts" ||
//         modelKey === "kidskidsbasketballshorts" ||
//         modelKey === "kidskidssoccershorts" ||
//         modelKey === "kidskidsfootballshorts" ||
//         modelKey === "kidskidsnftfootballshorts" ||
//         modelKey === "kidskidstanktop" ||
//         modelKey === "kidskidscyclingjersey" ||
//         modelKey === "kidskidswinterjersey" ||
//         modelKey === "kidskidscitycollection" ||
//         modelKey === "kidskidscricketjersey" ||
//         modelKey === "kidskidstrackpants" ||
//         modelKey === "kidskidsprotshirt" ||
//         modelKey === "kidskidssinglet" ||
//         modelKey === "kidskidsarmsleeves" ||
//         modelKey === "kidskidsfootballjersey"||
//         modelKey === "kidskidssoccerjersey" 
//       ) {
//         return [rotation[0], rotation[1], rotation[2] + Math.PI];
//       } else {
//         return [rotation[0], rotation[1] + Math.PI, rotation[2]];
//       }
//     }, [rotation]);

//     const currentRotation = useMemo(() => {
//       return viewSide === "front" ? frontRotation : backRotation;
//     }, [viewSide, frontRotation, backRotation]);

//     const [animatedRotation, setAnimatedRotation] = useState(frontRotation);

//     useEffect(() => {
//       const targetRotation =
//         viewSide === "front" ? frontRotation : backRotation;

//       const timer = setTimeout(() => {
//         setAnimatedRotation(targetRotation);
//       }, 50);

//       return () => clearTimeout(timer);
//     }, [viewSide, frontRotation, backRotation]);

//     console.log("position <<<<<<<<<<<<<<>>>>>>>>>>>>>>: ", position);
//     console.log("rotation : ", rotation);
//     console.log("scale : ", scale);

//     const [modelSettings, setModelSettings] = useState(() =>
//       getModelSettings(menuSlug, subcategorySlug)
//     );

//     const [updateTrigger, setUpdateTrigger] = useState(0);

//     useEffect(() => {
//       setModelSettings(getModelSettings(menuSlug, subcategorySlug));
//     }, [snap.updateTrigger, menuSlug, subcategorySlug]);

//     useEffect(() => {
//       console.log("menu slug /////////// : ", menuSlug);
//       console.log("menu slug /////////// : ", subcategorySlug);
//       let isMounted = true;
//       latestRequestRef.current += 1;
//       const requestId = latestRequestRef.current;

//       // Determine which model to load
//       let modelKeyToLoad;

//       // Priority 1: Preserved model from navigation
//       if (location.state?.preserveModel && location.state?.currentModelKey) {
//         modelKeyToLoad = location.state.currentModelKey;
//         console.log(`🎯 Loading PRESERVED model: ${modelKeyToLoad}`);
//       }
//       // Priority 2: Current slugs
//       else if (menuSlug && subcategorySlug) {
//         modelKeyToLoad = `${menuSlug}${subcategorySlug}`.replace(/-/g, "");
//         console.log(`🎯 Loading from slugs: ${modelKeyToLoad}`);
//       }
//       // Priority 3: Previously stored model
//       else {
//         const storedModel = localStorage.getItem("current-3d-model");
//         modelKeyToLoad = storedModel || "menmenjersey";
//         console.log(`🎯 Loading STORED model: ${modelKeyToLoad}`);
//       }

//       // Update state with the actual key we're loading
//       state.newKey = modelKeyToLoad;

//       setIsLoading(true);

//       const loadModelForKey = async () => {
//         const modelConfig = modelConfig1[modelKeyToLoad];
//         let modelUrl;

//         if (modelConfig?.modelUrl) {
//           modelUrl = modelConfig.modelUrl;
//         } else {
//           // Fallback: use model name from state or default
//           modelUrl = snap.modelName || DEFAULT_MODEL_URL;
//         }

//         console.log(`📦 Loading model from: ${modelUrl}`);

//         try {
//           // Add cache busting
//           const cacheBustedUrl = `${modelUrl}?t=${Date.now()}`;
//           const model = await loadModel(cacheBustedUrl);

//           if (!isMounted || latestRequestRef.current !== requestId) return;

//           console.log(`✅ Model loaded: ${modelKeyToLoad}`);
//           setGltf(model);
//         } catch (error) {
//           console.error(`❌ Failed to load ${modelKeyToLoad}:`, error);

//           if (!isMounted || latestRequestRef.current !== requestId) return;

//           // Fallback to default
//           try {
//             console.log(`🔄 Falling back to default model`);
//             const defaultModel = await loadModel(DEFAULT_MODEL_URL);
//             if (isMounted && latestRequestRef.current === requestId) {
//               setGltf(defaultModel);
//               state.newKey = "menmenjersey";
//             }
//           } catch (fallbackError) {
//             console.error("❌ Fallback also failed:", fallbackError);
//             setGltf(null);
//           }
//         } finally {
//           if (isMounted && latestRequestRef.current === requestId) {
//             setIsLoading(false);
//           }
//         }
//       };

//       loadModelForKey();

//       return () => {
//         isMounted = false;
//       };
//     }, [snap.modelName, menuSlug, subcategorySlug, loadModel, location.state]);

//     useEffect(() => {
//       if (gltf && gltfRef) {
//         gltfRef.current = gltf;
//       }
//     }, [gltf]);

//     ////console.log("gltf?.scene : ", gltf?.scene);

//     useEffect(() => {
//       if (gltf?.scene && state.scene) {
//         state.scene = gltf.scene;
//       }

//       if (gltf?.scene) {
//         gltf.scene.traverse((child) => {
//           if (child.isGroup && ["TEE", "DESIGN"].includes(child.name)) {
//             setBandMesh((prev) => [
//               ...(Array.isArray(prev) ? prev : []),
//               ...child.children.filter((c) => c.isMesh),
//             ]);
//           }
//         });
//       }
//     }, [gltf, state.scene, menuSlug, subcategorySlug]);

//     // useEffect(() => {
//     //   updateTexture(snap.frontText, frontTextTexture, "front");
//     //   updateTexture(snap.backText, backTextTexture, "back");
//     //   updateTexture(snap.frontNumber, frontNumberTexture, "frontNumber");
//     //   updateTexture(snap.backNumber, backNumberTexture, "backNumber");
//     // }, [state.updateTrigger]);

//     useEffect(() => {
//       const modelKey = state.newKey;

//       if (modelKey === "eventordereventjersey" && glbId) {
//         console.log(" Updating positions for event order design:", glbId);

//         let modelConfig = modelConfig1[modelKey][glbId];

//         if (!modelConfig) {
//           console.warn(" No config found for design ID:", glbId);
//           return;
//         }

//         setDecalPositions({
//           frontText: modelConfig.frontTextPosition
//             ? [...modelConfig.frontTextPosition]
//             : [0, 0, 0],
//           frontNumber: modelConfig.frontNumberPosition
//             ? [...modelConfig.frontNumberPosition]
//             : [0, 0, 0],
//           frontLogo: modelConfig.frontLogoPosition
//             ? [...modelConfig.frontLogoPosition]
//             : [0, 0, 0],
//           backText: modelConfig.backTextPosition
//             ? [...modelConfig.backTextPosition]
//             : [0, 0, 0],
//           backNumber: modelConfig.backNumberPosition
//             ? [...modelConfig.backNumberPosition]
//             : [0, 0, 0],
//           backLogo: modelConfig.backLogoPosition
//             ? [...modelConfig.backLogoPosition]
//             : [0, 0, 0],
//         });

//         setDecalScales({
//           frontText: modelConfig.frontTextScale
//             ? [...modelConfig.frontTextScale]
//             : [1, 1, 1],
//           frontNumber: modelConfig.frontNumberScale
//             ? [...modelConfig.frontNumberScale]
//             : [1, 1, 1],
//           frontLogo: modelConfig.frontLogoScale
//             ? [...modelConfig.frontLogoScale]
//             : [1, 1, 1],
//           backText: modelConfig.backTextScale
//             ? [...modelConfig.backTextScale]
//             : [1, 1, 1],
//           backNumber: modelConfig.backNumberScale
//             ? [...modelConfig.backNumberScale]
//             : [1, 1, 1],
//           backLogo: modelConfig.backLogoScale
//             ? [...modelConfig.backLogoScale]
//             : [1, 1, 1],
//         });

//         if (modelConfig.fontSize) {
//           setFontSizetext(modelConfig.fontSize);
//         }
//         if (modelConfig.fontSizeNumber) {
//           setFontSizeNumber(modelConfig.fontSizeNumber);
//         }

//         if (modelConfig.frontTextPosition) {
//           frontTextPosition[0] = modelConfig.frontTextPosition[0];
//           frontTextPosition[1] = modelConfig.frontTextPosition[1];
//           frontTextPosition[2] = modelConfig.frontTextPosition[2];
//         }

//         if (modelConfig.frontNumberPosition) {
//           frontNumberPosition[0] = modelConfig.frontNumberPosition[0];
//           frontNumberPosition[1] = modelConfig.frontNumberPosition[1];
//           frontNumberPosition[2] = modelConfig.frontNumberPosition[2];
//         }

//         if (modelConfig.frontLogoPosition) {
//           frontLogoPosition[0] = modelConfig.frontLogoPosition[0];
//           frontLogoPosition[1] = modelConfig.frontLogoPosition[1];
//           frontLogoPosition[2] = modelConfig.frontLogoPosition[2];
//         }

//         if (modelConfig.backTextPosition) {
//           backTextPosition[0] = modelConfig.backTextPosition[0];
//           backTextPosition[1] = modelConfig.backTextPosition[1];
//           backTextPosition[2] = modelConfig.backTextPosition[2];
//         }

//         if (modelConfig.backNumberPosition) {
//           backNumberPosition[0] = modelConfig.backNumberPosition[0];
//           backNumberPosition[1] = modelConfig.backNumberPosition[1];
//           backNumberPosition[2] = modelConfig.backNumberPosition[2];
//         }

//         if (modelConfig.backLogoPosition) {
//           backLogoPosition[0] = modelConfig.backLogoPosition[0];
//           backLogoPosition[1] = modelConfig.backLogoPosition[1];
//           backLogoPosition[2] = modelConfig.backLogoPosition[2];
//         }

//         if (modelConfig.frontTextScale) {
//           frontTextScale[0] = modelConfig.frontTextScale[0];
//           frontTextScale[1] = modelConfig.frontTextScale[1];
//           frontTextScale[2] = modelConfig.frontTextScale[2];
//         }

//         if (modelConfig.frontNumberScale) {
//           frontNumberScale[0] = modelConfig.frontNumberScale[0];
//           frontNumberScale[1] = modelConfig.frontNumberScale[1];
//           frontNumberScale[2] = modelConfig.frontNumberScale[2];
//         }

//         if (modelConfig.frontLogoScale) {
//           frontLogoScale[0] = modelConfig.frontLogoScale[0];
//           frontLogoScale[1] = modelConfig.frontLogoScale[1];
//           frontLogoScale[2] = modelConfig.frontLogoScale[2];
//         }

//         if (modelConfig.backTextScale) {
//           backTextScale[0] = modelConfig.backTextScale[0];
//           backTextScale[1] = modelConfig.backTextScale[1];
//           backTextScale[2] = modelConfig.backTextScale[2];
//         }

//         if (modelConfig.backNumberScale) {
//           backNumberScale[0] = modelConfig.backNumberScale[0];
//           backNumberScale[1] = modelConfig.backNumberScale[1];
//           backNumberScale[2] = modelConfig.backNumberScale[2];
//         }

//         if (modelConfig.backLogoScale) {
//           backLogoScale[0] = modelConfig.backLogoScale[0];
//           backLogoScale[1] = modelConfig.backLogoScale[1];
//           backLogoScale[2] = modelConfig.backLogoScale[2];
//         }

//         console.log(
//           "Updated event order positions and scales for design:",
//           glbId
//         );
//       }
//     }, [glbId]);

//     const [parts, setLocalParts] = useState([]);
//     const [frontParts, setFrontParts] = useState([]);
//     const [backParts, setBackParts] = useState([]);
//     const [leftParts, setLeftParts] = useState([]);
//     const [rightParts, setRightParts] = useState([]);
//     const [designParts, setDesignParts] = useState([]);
//     const [defaultTexture, setDefaultTexture] = useState(null);
//      const previousProductIdRef = useRef(null);
// // Effect 1: Handle model changes (when model URL changes)
// useEffect(() => {
//   if (!productData?.modelName) return;
  
//   // Only reload if model URL actually changed
//   if (productData.modelName !== previousModelUrlRef.current) {
//     console.log("Model URL changed:", productData.modelName);
    
//     previousModelUrlRef.current = productData.modelName;
//     loadModelForProduct();
//   }
// }, [productData?.modelName]);

// // Effect 2: Handle product changes (when product ID changes but model stays same)
// useEffect(() => {
//   if (!productData?.id) return;
  
//   // Product ID changed but model might be the same
//   if (productData.id !== previousProductIdRef.current) {
//     console.log("Product changed:", productData.id);
    
//     const modelChanged = productData.modelName !== previousModelUrlRef.current;
    
//     if (!modelChanged && gltf) {
//       // Same model, different product (duplicate) - just update settings
//       console.log("Same model, applying new product settings");
//       applyProductColorsToModel();
//       applyImagesToMaterials();
//     }
    
//     previousProductIdRef.current = productData.id;
//   }
// }, [productData?.id, gltf]);

// async function loadModelForProduct() {
//   if (!productData?.modelName) return;
  
//   setIsLoading(true);
//   setGltf(null);
  
//   try {
//     const cacheBustedUrl = `${productData.modelName}?t=${Date.now()}`;
//     const model = await loadModel(cacheBustedUrl);
//     setGltf(model);
//     setIsLoading(false);
//     console.log("Model loaded for product:", productData.id);
//   } catch (error) {
//     console.error("Failed to load model:", error);
//     setIsLoading(false);
//   }
// }

//     const texture = useMemo(() => {
//       // Check if we have a valid selected pattern from current product
//       if (!selectedPattern || typeof selectedPattern !== "object") {
//         console.log("No selected pattern or invalid pattern object");
//         return null;
//       }

//       // Check if the pattern has an image property
//       const patternImage = selectedPattern.image;
//       if (!patternImage || typeof patternImage !== "string") {
//         console.log(
//           "Selected pattern has no valid image URL:",
//           selectedPattern
//         );
//         return null;
//       }

//       try {
//         console.log("Loading pattern texture:", patternImage);
//         const texture = new THREE.TextureLoader().load(
//           patternImage,
//           // onLoad callback
//           () => {
//             console.log("Pattern texture loaded successfully");
//             texture.needsUpdate = true;
//           },
//           // onProgress callback (optional)
//           undefined,
//           // onError callback
//           (error) => {
//             console.error("Failed to load pattern texture:", error);
//           }
//         );

//         if (texture) {
//           texture.colorSpace = THREE.SRGBColorSpace;
//           texture.wrapS = THREE.RepeatWrapping;
//           texture.wrapT = THREE.RepeatWrapping;

//           // Use pattern-specific scale if available, otherwise default
//           const scale = selectedPattern.scale || 1;
//           texture.repeat.set(35 * scale, 35 * scale);

//           texture.transparent = true;
//           texture.opacity = selectedPattern.opacity || 0.5;
//         }

//         return texture;
//       } catch (error) {
//         console.error("Error creating texture:", error);
//         return null;
//       }
//     }, [
//         productData?.id,
//       selectedPattern?.image,
//       selectedPattern?.scale,
//       selectedPattern?.opacity,
//     ]);

//     const [patternedMaterials, setPatternedMaterials] = useState({});
//     const [forceRenderKey, setForceRenderKey] = useState(0);

//     ////console.log("state.selectedPattern : ", state.selectedPattern);

//     const baseColorTextureRef = useRef(null);

//     /** ==========================
//      *  OPTIMIZED MESH EXTRACTION
//      *  ========================== */
//     useEffect(() => {
//       if (gltf?.scene) {
//         const extractedParts = [];

//         gltf.scene.traverse((child) => {
//           if (child.isMesh) {
//             child.geometry.computeVertexNormals();

//             if (child.material.side === THREE.BackSide) {
//               child.geometry.scale(-1, 1, 1);
//               child.material.side = THREE.FrontSide;
//             }

//             extractedParts.push({
//               name: child.name,
//               geometry: child.geometry,
//               material: child.material,
//             });
//           }
//         });

//         console.log("extractedParts : ", extractedParts);

//         setLocalParts(extractedParts);
//         state.parts = extractedParts.map((part) => part.material.name);
//       }
//     }, [gltf, state.setParts, menuSlug, subcategorySlug]);

//     console.log("state.parts:", state.parts);

//     const [renderCount, setRenderCount] = useState(0);

//     const svgContainerRef = useRef(null);

//     useEffect(() => {
//       const applyImagesToMaterials = async () => {
//         if (!group.current) return;

//         console.log(
//           "currentProduct imagesPattern : ",
//           productData?.imagesPattern
//         );

//         const imagesPattern = productData?.imagesPattern || {};
//         const normalizedImages = Object.fromEntries(
//           Object.entries(imagesPattern).map(([key, val]) => [
//             key.toUpperCase(),
//             val,
//           ])
//         );

//         group.current.traverse(async (child) => {
//           if (!child.isMesh || !child.material) return;

//           const materialName = child.material.name?.toUpperCase();
//           if (!materialName || !partMappings[materialName]) return;

//           const materials = Array.isArray(child.material)
//             ? child.material
//             : [child.material];

//           for (const mat of materials) {
//             const imageData = normalizedImages[materialName];

//             // Dispose of existing texture to prevent memory leaks
//             if (mat.map) {
//               mat.map.dispose();
//               mat.map = null;
//             }

//             if (imageData?.image) {
//               try {
//                 const texture = await new THREE.TextureLoader().loadAsync(
//                   imageData.image
//                 );

//                 texture.colorSpace = THREE.SRGBColorSpace;
//                 texture.flipY = false;
//                 texture.wrapS = THREE.RepeatWrapping;
//                 texture.wrapT = THREE.RepeatWrapping;
//                 texture.center.set(0.5, 0.5);

//                 const img = new Image();
//                 img.crossOrigin = "anonymous";

//                 img.onload = () => {
//                   const imageAspect = img.width / img.height;
//                   const shirtAspect = 2220 / 2553; // your shirt UV ratio

//                   console.log("imageAspect: ", imageAspect);
//                   console.log("img.width: ", img.width);
//                   console.log("img.height: ", img.height);

//                   // Scale factor to control pattern size (increase = smaller pattern)
//                   const SCALE_FACTOR = 2; // Adjust this: 1 = normal, 2 = half size, 3 = third size

//                   if (img.width >= 2220 && img.height >= 2553) {
//                     // High-res pattern
//                     if (imageAspect > shirtAspect) {
//                       texture.repeat.set(
//                         (shirtAspect / imageAspect) * SCALE_FACTOR,
//                         1 * SCALE_FACTOR
//                       );
//                     } else {
//                       texture.repeat.set(
//                         1 * SCALE_FACTOR,
//                         (imageAspect / shirtAspect) * SCALE_FACTOR
//                       );
//                     }
//                   } else if (img.width >= 1000 && img.height >= 1000) {
//                     // Medium pattern - tile it appropriately
//                     texture.repeat.set(
//                       (2220 / img.width) * 0.8 * SCALE_FACTOR,
//                       (2553 / img.height) * 0.8 * SCALE_FACTOR
//                     );
//                   } else {
//                     // Small pattern - tile more
//                     const scaleX = Math.max(1, 2220 / img.width);
//                     const scaleY = Math.max(1, 2553 / img.height);
//                     texture.repeat.set(
//                       scaleX * SCALE_FACTOR,
//                       scaleY * SCALE_FACTOR
//                     );
//                   }

//                   texture.needsUpdate = true;
//                 };

//                 img.src = imageData.image;

//                 mat.map = texture;
//                 mat.color.set(0xffffff);
//                 mat.needsUpdate = true;
//               } catch (err) {
//                 console.error(`Failed to load image for ${materialName}:`, err);
//               }
//             } else {
//               // No image - reset to default color
//               mat.map = null;
//               mat.color.set("#112F51");
//               mat.needsUpdate = true;
//             }
//           }
//         });
//       };

//       applyImagesToMaterials();
//     }, [productData?.imagesPattern, productData?.id]);

//     function applyGradientToPath(
//       svg,
//       pathElement,
//       baseColor,
//       gradientColor,
//       gradientId
//     ) {
//       ////console.log("Gradient svg : ", svg);
//       ////console.log("Gradient pathElement : ", pathElement);
//       ////console.log("Gradient baseColor : ", baseColor);
//       ////console.log("Gradient gradientColor : ", gradientColor);
//       ////console.log("Gradient gradientId : ", gradientId);

//       const defs =
//         svg.querySelector("defs") ||
//         svg.insertBefore(
//           document.createElementNS("http://www.w3.org/2000/svg", "defs"),
//           svg.firstChild
//         );

//       let gradient = document.getElementById(gradientId);
//       if (!gradient) {
//         gradient = document.createElementNS(
//           "http://www.w3.org/2000/svg",
//           "linearGradient"
//         );
//         gradient.setAttribute("id", gradientId);

//         gradient.setAttribute("x1", "0%");
//         gradient.setAttribute("y1", "0%");
//         gradient.setAttribute("x2", "0%");
//         gradient.setAttribute("y2", "100%");

//         const stop1 = document.createElementNS(
//           "http://www.w3.org/2000/svg",
//           "stop"
//         );
//         stop1.setAttribute("offset", "0%");
//         stop1.setAttribute("stop-color", baseColor);

//         const stop2 = document.createElementNS(
//           "http://www.w3.org/2000/svg",
//           "stop"
//         );
//         stop2.setAttribute("offset", "100%");
//         stop2.setAttribute("stop-color", gradientColor);

//         gradient.appendChild(stop1);
//         gradient.appendChild(stop2);
//         defs.appendChild(gradient);
//       }

//       pathElement.setAttribute("fill", `url(#${gradientId})`);
//     }

//     async function applyPatternToPath(
//       targetSVG,
//       pathElements,
//       patternData,
//       patternName,
//       patternId
//     ) {
//       try {
//         const response = await fetch(patternData.image);
//         const contentType = response.headers.get("Content-Type");
//         const isSVG = contentType && contentType.includes("image/svg+xml");

//         if (!isSVG) {
//           console.error("Pattern is not an SVG.");
//           return;
//         }

//         const rawPatternSVG = await response.text();
//         const parser = new DOMParser();
//         const parsedDoc = parser.parseFromString(
//           rawPatternSVG,
//           "image/svg+xml"
//         );
//         const originalSVG = parsedDoc.querySelector("svg");

//         if (!originalSVG) {
//           console.error("No <svg> found in the pattern file.");
//           return;
//         }

//         // Get or create defs
//         const defs =
//           targetSVG.querySelector("defs") ||
//           targetSVG.insertBefore(
//             document.createElementNS("http://www.w3.org/2000/svg", "defs"),
//             targetSVG.firstChild
//           );

//         // Remove existing patterns with same name
//         const existingPatterns = defs.querySelectorAll("pattern");
//         existingPatterns.forEach((pat) => {
//           if (pat.getAttribute("data-pattern-name") === patternName) {
//             pat.remove();
//           }
//         });

//         const oldInnerSVG = targetSVG.querySelector(`#svg_${patternName}`);
//         if (oldInnerSVG) oldInnerSVG.remove();

//         // Extract viewBox from original SVG
//         const viewBoxAttr = originalSVG.getAttribute("viewBox");
//         let viewBoxWidth, viewBoxHeight;

//         if (viewBoxAttr) {
//           const viewBox = viewBoxAttr.split(/\s+/);
//           viewBoxWidth = parseFloat(viewBox[2]);
//           viewBoxHeight = parseFloat(viewBox[3]);
//         } else {
//           // Fallback to width/height attributes
//           viewBoxWidth = parseFloat(originalSVG.getAttribute("width")) || 28;
//           viewBoxHeight = parseFloat(originalSVG.getAttribute("height")) || 49;
//         }

//         // Use pattern-specific scale if available, otherwise use default 1.2
//         console.log("patternData ........... : ", patternData);

//         const PATTERN_SCALE = patternData.scale || 1.2;

//         // Create pattern element with proper dimensions
//         const patternNode = document.createElementNS(
//           "http://www.w3.org/2000/svg",
//           "pattern"
//         );
//         patternNode.setAttribute("id", patternId);
//         patternNode.setAttribute("x", "0");
//         patternNode.setAttribute("y", "0");
//         patternNode.setAttribute("width", viewBoxWidth.toString());
//         patternNode.setAttribute("height", viewBoxHeight.toString());
//         patternNode.setAttribute("patternUnits", "userSpaceOnUse");
//         patternNode.setAttribute("patternTransform", `scale(${PATTERN_SCALE})`);
//         patternNode.setAttribute("data-pattern-name", patternName);

//         // Create inner SVG with matching dimensions
//         const innerSVG = document.createElementNS(
//           "http://www.w3.org/2000/svg",
//           "svg"
//         );
//         innerSVG.setAttribute("id", `svg_${patternName}`);
//         innerSVG.setAttribute("width", viewBoxWidth.toString());
//         innerSVG.setAttribute("height", viewBoxHeight.toString());
//         innerSVG.setAttribute(
//           "viewBox",
//           `0 0 ${viewBoxWidth} ${viewBoxHeight}`
//         );

//         // Get the color for this pattern from current product
//         const partColor =
//           productData?.patternColors?.[patternName.toUpperCase()] || "#000000";

//         // For your specific hexagon pattern, we need to handle it differently
//         // Clone the entire content but replace the fill color
//         const originalContent = originalSVG.innerHTML;

//         // Create a temporary div to manipulate the SVG content
//         const tempDiv = document.createElement("div");
//         tempDiv.innerHTML = originalContent;

//         // Find and update all path elements
//         const paths = tempDiv.querySelectorAll("path");
//         paths.forEach((path) => {
//           // Remove existing fill and stroke attributes
//           path.removeAttribute("fill");
//           path.removeAttribute("stroke");
//           path.removeAttribute("stroke-width");
//           path.removeAttribute("style");

//           // Apply the new color
//           path.setAttribute("fill", partColor);
//           path.setAttribute("stroke", "none");
//           path.setAttribute("stroke-width", "0");
//         });

//         // If no paths found, try to find any shapes
//         if (paths.length === 0) {
//           const shapes = tempDiv.querySelectorAll(
//             "rect, circle, ellipse, polygon, polyline"
//           );
//           shapes.forEach((shape) => {
//             shape.removeAttribute("fill");
//             shape.removeAttribute("stroke");
//             shape.removeAttribute("stroke-width");
//             shape.removeAttribute("style");
//             shape.setAttribute("fill", partColor);
//             shape.setAttribute("stroke", "none");
//             shape.setAttribute("stroke-width", "0");
//           });
//         }

//         // Set the inner HTML of our innerSVG
//         innerSVG.innerHTML = tempDiv.innerHTML;

//         patternNode.appendChild(innerSVG);
//         defs.appendChild(patternNode);

//         // Get or create the scale group
//         let gElement = targetSVG.querySelector("g#scale");
//         if (!gElement) {
//           gElement = document.createElementNS(
//             "http://www.w3.org/2000/svg",
//             "g"
//           );
//           gElement.setAttribute("id", "scale");
//           targetSVG.appendChild(gElement);
//         }

//         // Apply pattern to all path elements
//         pathElements.forEach((pathElement, index) => {
//           const originalId = pathElement.getAttribute("id");
//           const elementLabel = (
//             pathElement.getAttribute("elementname") || `part${index}`
//           ).replace(/\s+/g, "_");
//           const newId = `${originalId}_copy_${elementLabel}`;

//           // Remove old copy if exists
//           const oldCopy = gElement.querySelector(`path[id="${newId}"]`);
//           if (oldCopy) oldCopy.remove();

//           // Create new path with pattern fill
//           const copyPath = pathElement.cloneNode(true);

//           // Clean up attributes but keep essential ones
//           const keepAttributes = ["d", "id", "transform"];
//           [...copyPath.attributes].forEach((attr) => {
//             if (!keepAttributes.includes(attr.name)) {
//               copyPath.removeAttribute(attr.name);
//             }
//           });

//           copyPath.setAttribute("id", newId);
//           copyPath.setAttribute("fill", `url(#${patternId})`);
//           copyPath.setAttribute("data-pattern-name", patternName);
//           copyPath.setAttribute("data-element-name", elementLabel);

//           gElement.appendChild(copyPath);
//         });

//         console.log(
//           `Pattern '${patternName}' applied with color ${partColor}, scale ${PATTERN_SCALE} and dimensions ${viewBoxWidth}x${viewBoxHeight}`
//         );
//       } catch (err) {
//         console.error("Failed to load or apply pattern:", err);
//       }
//     }
//     async function loadTextureFromSVG(svgElement, size = 2048) {
//       ////console.log("svgElement for pattern and color: ", svgElement);

//       const svgClone = svgElement.cloneNode(true);

//       ////console.log("svgClone : ", svgClone);

//       const originalDefs = svgElement.querySelector("defs");
//       ////console.log("originalDefs : ", originalDefs);
//       if (originalDefs) {
//         let clonedDefs = svgClone.querySelector("defs");

//         if (!clonedDefs) {
//           clonedDefs = originalDefs.cloneNode(true);
//           svgClone.insertBefore(clonedDefs, svgClone.firstChild);
//         }
//       }

//       svgClone.setAttribute("width", size);
//       svgClone.setAttribute("height", size);
//       svgClone.setAttribute("viewBox", `0 0 ${size} ${size}`);
//       svgClone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
//       svgClone.setAttribute("version", "1.1");

//       const svgString = new XMLSerializer().serializeToString(svgClone);
//       ////console.log("svgString: ", svgString);
//       const imageUrl = `data:image/svg+xml;base64,${btoa(
//         unescape(encodeURIComponent(svgString))
//       )}`;

//       ////console.log("imageUrl for pattern: ", imageUrl);

//       const existing = document.getElementById("svg-preview-wrapper");
//       if (existing) existing.remove();

//       // const wrapper = document.createElement("div");
//       // wrapper.id = "svg-preview-wrapper";
//       // wrapper.style.cssText = `
//       //   position: absolute; top: 20px; left: 520px;
//       //   width: 320px; height: 100px;
//       //   overflow: auto; border: 2px solid black;
//       //   z-index: 9999; background: white; padding: 4px;
//       // `;

//       // const preview = document.createElement("img");
//       // preview.src = imageUrl;
//       // preview.style.width = "100%";
//       // preview.style.outline = "3px solid blue";
//       // wrapper.appendChild(preview);
//       // document.body.appendChild(wrapper);

//       return new Promise((resolve) => {
//         const img = new Image();
//         img.crossOrigin = "anonymous";

//         img.onload = () => {
//           const canvas = document.createElement("canvas");
//           canvas.width = size;
//           canvas.height = size;

//           const ctx = canvas.getContext("2d");
//           ctx.clearRect(0, 0, size, size);

//           ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

//           const texture = new THREE.CanvasTexture(canvas);
//           texture.needsUpdate = true;

//           const debugImage = new Image();
//           debugImage.src = texture.image.toDataURL("image/png");
//           // debugImage.style.position = "absolute";
//           // debugImage.style.top = "200px";
//           // debugImage.style.left = "400px";
//           // debugImage.style.width = "200px";
//           // debugImage.style.border = "2px dashed green";
//           // debugImage.alt = "CanvasTexture Preview";

//           // document.body.appendChild(debugImage);

//           resolve(texture);
//         };

//         img.onerror = (err) => {
//           console.error("Image failed to load from SVG:", err);
//           resolve(null);
//         };

//         img.src = imageUrl;
//       });
//     }

//     const svgStateRef = useRef(null);
//     function unwrapProxy(proxyObj) {
//       if (proxyObj === null || typeof proxyObj !== "object") return proxyObj;
//       if (Array.isArray(proxyObj)) return proxyObj.map(unwrapProxy);

//       const plainObj = {};
//       for (const key in proxyObj) {
//         plainObj[key] = unwrapProxy(proxyObj[key]);
//       }
//       return plainObj;
//     }

//     const currentSvgUrlRef = useRef(null);

//     console.log("partcolors : ", state.partColors);
// console.log("productData ::::::::::::::::::::: ",productData)
// console.log("svg new ::::::::::::::::: ", state.svg);
// // Add this effect to force SVG updates when product changes
// useEffect(() => {
//   console.log("Product changed, forcing SVG update for product:", productData?.id);
  
//   // Force a re-render of the SVG effect
//   if (svgStateRef.current && productData?.id) {
//     // Trigger the SVG update by updating the refetch condition
//     currentSvgUrlRef.current = null; // Force refetch
//     svgStateRef.current = null; // Clear cached SVG
    
//     // Manually trigger the SVG update
//     const timer = setTimeout(() => {
//       if (state.svg) {
//         fetch(`${state.svg}?cacheBust=${Date.now()}`)
//           .then((res) => res.text())
//           .then((svgText) => {
//             const parser = new DOMParser();
//             const baseSVG = parser
//               .parseFromString(svgText, "image/svg+xml")
//               .querySelector("svg");

//             if (!baseSVG) {
//               console.warn("SVG not found");
//               return;
//             }

//             svgStateRef.current = baseSVG;
//             currentSvgUrlRef.current = state.svg;
            
//             // Trigger the update function
//             updateAndRenderSVG();
//           });
//       }
//     }, 100);
    
//     return () => clearTimeout(timer);
//   }
// }, [productData?.id]);
// // Move this function outside the useEffect
// const updateAndRenderSVG = useCallback(async () => {
//   console.log("updateAndRenderSVG called for product:", productData?.id);
  
//   if (!svgStateRef.current) {
//     console.log("No SVG state available, skipping");
//     return;
//   }
  
//   const baseSVG = svgStateRef.current.cloneNode(true);
//   const scaleGroup = baseSVG.querySelector("#scale");
  
//   if (!scaleGroup) {
//     console.log("No scale group found in SVG");
//     return;
//   }

//   console.log("scaleGroup found:", scaleGroup);

//   const partColors = productData?.partColors || {};
//   const gradientColors = productData?.gradientColors || {};
//   const unwrappedPattern = unwrapProxy(
//     productData?.selectedPattern || {}
//   );
//   const normalizedPattern = Object.fromEntries(
//     Object.entries(unwrappedPattern).map(([key, val]) => [
//       key.toUpperCase(),
//       val,
//     ])
//   );

//   console.log("Applying from productData:", {
//     partColors,
//     gradientColors,
//     normalizedPattern
//   });

//   const directColorParts = ["DESIGN", "LOGO", "NECK"];

//   directColorParts.forEach((partName) => {
//     const color = partColors?.[partName];
//     if (!color) return;

//     const groupObj = group.current;
//     if (!groupObj) return;

//     groupObj.traverse((child) => {
//       if (!child.isMesh || !child.material) return;

//       const materials = Array.isArray(child.material)
//         ? child.material
//         : [child.material];

//       materials.forEach((mat) => {
//         if (mat.name === partName) {
//           mat.color.set(color);
//           mat.needsUpdate = true;
//         }
//       });
//     });
//   });

//   const patternApplyPromises = [];

//   console.log("partMappings : ", partMappings);

//   Object.entries(partMappings).forEach(
//     ([materialName, targetElements]) => {
//       const baseColor = partColors[materialName];
//       const gradientColor = gradientColors[materialName];
//       const patternData = normalizedPattern?.[materialName.toUpperCase()];

//       console.log(`Processing ${materialName}:`, {
//         baseColor,
//         gradientColor,
//         patternData: patternData?.image ? "Pattern exists" : "No pattern"
//       });

//       if ((!baseColor && !patternData) || !targetElements) return;

//       const matchingPaths = Array.from(
//         scaleGroup.querySelectorAll("path")
//       ).filter((path) => {
//         let nameAttr = null;
//         path.getAttributeNames().forEach((attr) => {
//           if (attr.toLowerCase() === "elementname") {
//             nameAttr = path.getAttribute(attr);
//           }
//         });
//         return (
//           nameAttr && targetElements.includes(nameAttr.toUpperCase())
//         );
//       });

//       console.log(`${materialName} - matching paths:`, matchingPaths.length);

//       matchingPaths.forEach((path) => {
//         if (patternData?.image) {
//           if (materialName === "TEE") {
//             const promise = applyPatternToPath(
//               baseSVG,
//               matchingPaths,
//               patternData,
//               materialName,
//               `${materialName}_${patternData.name}`
//             );
//             patternApplyPromises.push(promise);
//           } else {
//             // apply individually
//             matchingPaths.forEach((path) => {
//               const promise = applyPatternToPath(
//                 baseSVG,
//                 [path], // wrap in array
//                 patternData,
//                 materialName,
//                 `${materialName}_${patternData.name}`
//               );
//               patternApplyPromises.push(promise);
//             });
//           }
//         }

//         if (baseColor && gradientColor) {
//           applyGradientToPath(
//             baseSVG,
//             path,
//             baseColor,
//             gradientColor,
//             `grad-${materialName}`
//           );
//         } else if (baseColor) {
//           path.setAttribute("fill", baseColor);
//         }
//       });
//     }
//   );

//   // Wait for all pattern fills to complete
//   await Promise.all(patternApplyPromises);

//   const texture = await loadTextureFromSVG(baseSVG);
//   baseColorTextureRef.current = texture;

//   group.current?.traverse((child) => {
//     if (!child.isMesh || !child.material) return;

//     const materials = Array.isArray(child.material)
//       ? child.material
//       : [child.material];

//     materials.forEach((mat) => {
//       if (!partMappings[mat.name]) return;

//       mat.map?.dispose();
//       mat.map = texture;
//       mat.map.flipY = false;
//       mat.map.colorSpace = THREE.SRGBColorSpace;
//       mat.color.set("#ffffff");
//       mat.needsUpdate = true;
//     });
//   });
  
//   console.log("SVG update completed for product:", productData?.id);
// }, [productData, partMappings, group.current]);

// // Then update the useEffect to use this function
// useEffect(() => {
//   console.log("SVG Effect Triggered");
  
//   if (!svgContainerRef.current) {
//     return;
//   }

//   const shouldRefetch =
//     !svgStateRef.current || currentSvgUrlRef.current !== state.svg;

//   if (shouldRefetch) {
//     fetch(`${state.svg}?cacheBust=${Date.now()}`)
//       .then((res) => res.text())
//       .then((svgText) => {
//         const parser = new DOMParser();
//         const baseSVG = parser
//           .parseFromString(svgText, "image/svg+xml")
//           .querySelector("svg");

//         if (!baseSVG) {
//           console.warn("SVG not found");
//           return;
//         }

//         svgStateRef.current = baseSVG;
//         currentSvgUrlRef.current = state.svg;
        
//         // Call the external function
//         updateAndRenderSVG();
//       });
//   } else {
//     // Call the external function
//     updateAndRenderSVG();
//   }
// }, [
//   state.svg,
//   updateAndRenderSVG // Add this as dependency
// ]);
//     useEffect(() => {
//       console.log("svg new : ", state.svg);
//       if (!svgContainerRef.current) return;

//       // Check if SVG URL has changed
//       const shouldRefetch =
//         !svgStateRef.current || currentSvgUrlRef.current !== state.svg;

//       if (shouldRefetch) {
//         fetch(`${state.svg}?cacheBust=${Date.now()}`)
//           .then((res) => res.text())
//           .then((svgText) => {
//             console.log("svgText : ", svgText);
//             const parser = new DOMParser();
//             const baseSVG = parser
//               .parseFromString(svgText, "image/svg+xml")
//               .querySelector("svg");

//             console.log("baseSVG : ", baseSVG);

//             if (!baseSVG) {
//               console.warn("SVG not found");
//               return;
//             }

//             svgStateRef.current = baseSVG;
//             currentSvgUrlRef.current = state.svg; // Track current SVG URL
//             updateAndRenderSVG();
//           });
//       } else {
//         updateAndRenderSVG();
//       }

//       async function updateAndRenderSVG() {
//         const baseSVG = svgStateRef.current.cloneNode(true);
//         const scaleGroup = baseSVG.querySelector("#scale");
//         console.log("scaleGroup : ", scaleGroup);
//         if (!scaleGroup) return;

//         // Use productData instead of snap
//         const partColors = productData?.partColors || {};
//         const gradientColors = productData?.gradientColors || {};
//         const unwrappedPattern = unwrapProxy(
//           productData?.selectedPattern || {}
//         );
//         const normalizedPattern = Object.fromEntries(
//           Object.entries(unwrappedPattern).map(([key, val]) => [
//             key.toUpperCase(),
//             val,
//           ])
//         );

//         const directColorParts = ["DESIGN", "LOGO", "NECK"];

//         directColorParts.forEach((partName) => {
//           const color = partColors?.[partName];
//           if (!color) return;

//           const groupObj = group.current;
//           if (!groupObj) return;

//           groupObj.traverse((child) => {
//             if (!child.isMesh || !child.material) return;

//             const materials = Array.isArray(child.material)
//               ? child.material
//               : [child.material];

//             materials.forEach((mat) => {
//               if (mat.name === partName) {
//                 mat.color.set(color);
//                 mat.needsUpdate = true;
//               }
//             });
//           });
//         });

//         const patternApplyPromises = [];

//         console.log("partMappings : ", partMappings);

//         Object.entries(partMappings).forEach(
//           ([materialName, targetElements]) => {
//             const baseColor = partColors[materialName];
//             const gradientColor = gradientColors[materialName];
//             const patternData = normalizedPattern?.[materialName.toUpperCase()];

//             console.log("baseColor : ", baseColor);

//             if ((!baseColor && !patternData) || !targetElements) return;

//             const matchingPaths = Array.from(
//               scaleGroup.querySelectorAll("path")
//             ).filter((path) => {
//               let nameAttr = null;
//               path.getAttributeNames().forEach((attr) => {
//                 if (attr.toLowerCase() === "elementname") {
//                   nameAttr = path.getAttribute(attr);
//                 }
//               });
//               return (
//                 nameAttr && targetElements.includes(nameAttr.toUpperCase())
//               );
//             });

//             matchingPaths.forEach((path) => {
//               if (patternData?.image) {
//                 if (materialName === "TEE") {
//                   const promise = applyPatternToPath(
//                     baseSVG,
//                     matchingPaths,
//                     patternData,
//                     materialName,
//                     `${materialName}_${patternData.name}`
//                   );
//                   patternApplyPromises.push(promise);
//                 } else {
//                   // apply individually
//                   matchingPaths.forEach((path) => {
//                     const promise = applyPatternToPath(
//                       baseSVG,
//                       [path], // wrap in array
//                       patternData,
//                       materialName,
//                       `${materialName}_${patternData.name}`
//                     );
//                     patternApplyPromises.push(promise);
//                   });
//                 }
//               }

//               if (baseColor && gradientColor) {
//                 applyGradientToPath(
//                   baseSVG,
//                   path,
//                   baseColor,
//                   gradientColor,
//                   `grad-${materialName}`
//                 );
//               } else if (baseColor) {
//                 path.setAttribute("fill", baseColor);
//               }
//             });
//           }
//         );

//         // Wait for all pattern fills to complete
//         await Promise.all(patternApplyPromises);

//         const texture = await loadTextureFromSVG(baseSVG);
//         baseColorTextureRef.current = texture;

//         group.current?.traverse((child) => {
//           if (!child.isMesh || !child.material) return;

//           const materials = Array.isArray(child.material)
//             ? child.material
//             : [child.material];

//           materials.forEach((mat) => {
//             if (!partMappings[mat.name]) return;

//             mat.map?.dispose();
//             mat.map = texture;
//             mat.map.flipY = false;
//             mat.map.colorSpace = THREE.SRGBColorSpace;
//             mat.color.set("#ffffff");
//             mat.needsUpdate = true;
//           });
//         });
//       }
//     }, [
//          productData?.id,
//       productData?.partColors,
//       productData?.gradientColors,
//       productData?.selectedPattern,
//       productData?.patternColors,
//       state.svg,
//       currentProduct
//     ]);

//     const logoTexture = useMemo(() => {
//       if (!productData?.frontLogo) return null;
//       // Create a larger canvas with logo centered and smaller
//       const canvas = document.createElement("canvas");
//       canvas.width = 2048;  // Increased canvas size for better quality
//       canvas.height = 2048; // Increased canvas size for better quality
//       const ctx = canvas.getContext("2d", { alpha: true });
      
//       // Enable image smoothing for better quality
//       ctx.imageSmoothingEnabled = true;
//       ctx.imageSmoothingQuality = 'high';
      
//       // Clear canvas with transparent background
//       ctx.clearRect(0, 0, canvas.width, canvas.height);

//       // Create texture from the canvas
//       const texture = new THREE.CanvasTexture(canvas);
//       texture.colorSpace = THREE.SRGBColorSpace;
//       texture.premultiplyAlpha = false; // Changed to false for better transparency
//       texture.generateMipmaps = true; // Enable mipmaps for better quality
//       texture.minFilter = THREE.LinearMipmapLinearFilter;
//       texture.magFilter = THREE.LinearFilter;

//       // Create an image to load the logo
//       const img = new Image();
//       img.crossOrigin = "anonymous";
//       img.onload = () => {
//         try {
//           // Clear canvas again before drawing
//           ctx.clearRect(0, 0, canvas.width, canvas.height);
          
//           // Set logo width to 800px while preserving aspect ratio (increased for better visibility)
//           const targetWidth = 800; // Fixed width of 800px
//           const imgWidth = img.naturalWidth || img.width;
//           const imgHeight = img.naturalHeight || img.height;
          
//           // Calculate height to maintain aspect ratio
//           const aspectRatio = imgHeight / imgWidth;
//           const drawWidth = targetWidth;
//           const drawHeight = targetWidth * aspectRatio;
          
//           // Center the logo on the canvas
//           const x = (canvas.width - drawWidth) / 2;
//           const y = (canvas.height - drawHeight) / 2;
          
//           // Draw the image centered and smaller
//           ctx.drawImage(img, 0, 0, img.naturalWidth || img.width, img.naturalHeight || img.height, x, y, drawWidth, drawHeight);
          
//           // Force texture update
//           texture.needsUpdate = true;
//         } catch (error) {
//           console.error("Error drawing logo to canvas:", error);
//         }
//       };
//       img.onerror = (error) => {
//         console.error("Error loading logo image:", error);
//       };
//       img.src = productData.frontLogo;

//       return texture;
//     }, [productData?.frontLogo]);

//     const logoTextureBack = useMemo(() => {
//       if (!productData?.backLogo) return null;
//       // Create a larger canvas with logo centered and smaller
//       const canvas = document.createElement("canvas");
//       canvas.width = 2048;  // Increased canvas size for better quality
//       canvas.height = 2048; // Increased canvas size for better quality
//       const ctx = canvas.getContext("2d", { alpha: true });
      
//       // Enable image smoothing for better quality
//       ctx.imageSmoothingEnabled = true;
//       ctx.imageSmoothingQuality = 'high';
      
//       // Clear canvas with transparent background
//       ctx.clearRect(0, 0, canvas.width, canvas.height);

//       // Create texture from the canvas
//       const texture = new THREE.CanvasTexture(canvas);
//       texture.colorSpace = THREE.SRGBColorSpace;
//       texture.premultiplyAlpha = false; // Changed to false for better transparency
//       texture.generateMipmaps = true; // Enable mipmaps for better quality
//       texture.minFilter = THREE.LinearMipmapLinearFilter;
//       texture.magFilter = THREE.LinearFilter;

//       // Create an image to load the logo
//       const img = new Image();
//       img.crossOrigin = "anonymous";
//       img.onload = () => {
//         try {
//           // Clear canvas again before drawing
//           ctx.clearRect(0, 0, canvas.width, canvas.height);
          
//           // Set logo width to 800px while preserving aspect ratio (increased for better visibility)
//           const targetWidth = 800; // Fixed width of 800px
//           const imgWidth = img.naturalWidth || img.width;
//           const imgHeight = img.naturalHeight || img.height;
          
//           // Calculate height to maintain aspect ratio
//           const aspectRatio = imgHeight / imgWidth;
//           const drawWidth = targetWidth;
//           const drawHeight = targetWidth * aspectRatio;
          
//           // Center the logo on the canvas
//           const x = (canvas.width - drawWidth) / 2;
//           const y = (canvas.height - drawHeight) / 2;
          
//           // Draw the image centered and smaller
//           ctx.drawImage(img, 0, 0, img.naturalWidth || img.width, img.naturalHeight || img.height, x, y, drawWidth, drawHeight);
          
//           // Force texture update
//           texture.needsUpdate = true;
//         } catch (error) {
//           console.error("Error drawing logo to canvas:", error);
//         }
//       };
//       img.onerror = (error) => {
//         console.error("Error loading logo image:", error);
//       };
//       img.src = productData.backLogo;

//       return texture;
//     }, [productData?.backLogo]);

//     useEffect(() => {
//       if (logoTexture) {
//         logoTexture.needsUpdate = true;
//       }
//     }, [logoTexture]);

//     useEffect(() => {
//       if (logoTextureBack) {
//         logoTextureBack.needsUpdate = true;
//       }
//     }, [logoTextureBack]);

//     const createCanvasTexture = () => {
//       const canvas = document.createElement("canvas");
//       canvas.width = 1024;
//       canvas.height = 512;
//       return new CanvasTexture(canvas);
//     };

//     const frontTextTexture = useRef(createCanvasTexture());
//     const backTextTexture = useRef(createCanvasTexture());
//     const frontNumberTexture = useRef(createCanvasTexture());
//     const backNumberTexture = useRef(createCanvasTexture());

//     // const updateTexture = (
//     //   text,
//     //   textureRef,
//     //   partName,
//     //   fontFamily,
//     //   colorType = "text"
//     // ) => {
//     //   if (!text || !textureRef.current) return;

//     //   const canvas = textureRef.current.image;
//     //   const ctx = canvas.getContext("2d");

//     //   if (!ctx) {
//     //     console.error("Canvas context not found.");
//     //     return;
//     //   }

//     //   ctx.clearRect(0, 0, canvas.width, canvas.height);

//     //   // Use different color properties based on colorType
//     //   let color;
//     //   if (colorType === "text") {
//     //     // For text: use textColors.front or textColors.back from current product
//     //     color = partName.includes("front")
//     //       ? productData?.textColors?.front || "#ffffff"
//     //       : productData?.textColors?.back || "#ffffff";
//     //   } else if (colorType === "number") {
//     //     // For numbers: use numberColors.front or numberColors.back from current product
//     //     color = partName.includes("front")
//     //       ? productData?.numberColors?.front || "#ffffff"
//     //       : productData?.numberColors?.back || "#ffffff";
//     //   } else {
//     //     // Fallback
//     //     color = "#ffffff";
//     //   }

//     //   ctx.fillStyle = color;
//     //   ctx.font = `bold 80px ${fontFamily}`;
//     //   ctx.textAlign = "center";
//     //   ctx.textBaseline = "middle";
//     //   ctx.fillText(text, canvas.width / 2, canvas.height / 2);

//     //   textureRef.current.needsUpdate = true;
//     // };

//     // useEffect(() => {
//     //   // For front text
//     //   updateTexture(
//     //     productData?.frontText || "",
//     //     frontTextTexture,
//     //     "front",
//     //     productData?.textFonts?.front || productData?.selectedFonts || "Arial",
//     //     "text"
//     //   );

//     //   // For back text
//     //   updateTexture(
//     //     productData?.backText || "",
//     //     backTextTexture,
//     //     "back",
//     //     productData?.textFonts?.back || productData?.selectedFonts || "Arial",
//     //     "text"
//     //   );

//     //   // For front number - use number colors
//     //   updateTexture(
//     //     productData?.frontNumber || "",
//     //     frontNumberTexture,
//     //     "frontNumber",
//     //     productData?.numberFonts?.front || productData?.selectedFonts || "Arial",
//     //     "number"
//     //   );

//     //   // For back number - use number colors
//     //   updateTexture(
//     //     productData?.backNumber || "",
//     //     backNumberTexture,
//     //     "backNumber",
//     //     productData?.numberFonts?.back || productData?.selectedFonts || "Arial",
//     //     "number"
//     //   );
//     // }, [
//     //   productData?.frontText,
//     //   productData?.backText,
//     //   productData?.frontNumber,
//     //   productData?.backNumber,
//     //   productData?.textColors?.front,
//     //   productData?.textColors?.back,
//     //   productData?.numberColors?.front,
//     //   productData?.numberColors?.back,
//     //   productData?.textFonts?.front,
//     //   productData?.textFonts?.back,
//     //   productData?.numberFonts?.front,
//     //   productData?.numberFonts?.back,
//     //   productData?.selectedFonts,
//     // ]);

//     // useEffect(() => {
//     //   // For front text
//     //   updateTexture(
//     //     snap.frontText,
//     //     frontTextTexture,
//     //     "front",
//     //     state.textFonts?.front || state.selectedFonts,
//     //     "text" // Specify this is text
//     //   );

//     //   // For back text
//     //   updateTexture(
//     //     snap.backText,
//     //     backTextTexture,
//     //     "back",
//     //     state.textFonts?.back || state.selectedFonts,
//     //     "text" // Specify this is text
//     //   );

//     //   // For front number - use number colors
//     //   updateTexture(
//     //     snap.frontNumber,
//     //     frontNumberTexture,
//     //     "frontNumber",
//     //     state.numberFonts?.front || state.selectedFonts,
//     //     "number" // Specify this is number
//     //   );

//     //   // For back number - use number colors
//     //   updateTexture(
//     //     snap.backNumber,
//     //     backNumberTexture,
//     //     "backNumber",
//     //     state.numberFonts?.back || state.selectedFonts,
//     //     "number" // Specify this is number
//     //   );
//     // }, [
//     //   snap.frontText,
//     //   snap.backText,
//     //   snap.frontNumber,
//     //   snap.backNumber,
//     //   // Watch for text color changes
//     //   snap.textColors?.front,
//     //   snap.textColors?.back,
//     //   // Watch for number color changes
//     //   snap.numberColors?.front,
//     //   snap.numberColors?.back,
//     //   state.textFonts?.front,
//     //   state.textFonts?.back,
//     //   state.numberFonts?.front,
//     //   state.numberFonts?.back,
//     //   state.selectedFonts,
//     // ]);

//     useEffect(() => {
//       console.log("Updating textures for product:", productData?.id);
//       console.log("Front text:", productData?.frontText);
//       console.log("Front number:", productData?.frontNumber);

//       // For front text
//       updateTexture(
//         productData?.frontText || "",
//         frontTextTexture,
//         "front",
//         productData?.textFonts?.front || productData?.selectedFonts || "Arial",
//         "text"
//       );

//       // For back text
//       updateTexture(
//         productData?.backText || "",
//         backTextTexture,
//         "back",
//         productData?.textFonts?.back || productData?.selectedFonts || "Arial",
//         "text"
//       );

//       // For front number - use number colors
//       updateTexture(
//         productData?.frontNumber || "",
//         frontNumberTexture,
//         "frontNumber",
//         productData?.numberFonts?.front ||
//           productData?.selectedFonts ||
//           "Arial",
//         "number"
//       );

//       // For back number - use number colors
//       updateTexture(
//         productData?.backNumber || "",
//         backNumberTexture,
//         "backNumber",
//         productData?.numberFonts?.back || productData?.selectedFonts || "Arial",
//         "number"
//       );
//     }, [
//       productData?.id, // Add this to trigger when product changes
//       productData?.frontText,
//       productData?.backText,
//       productData?.frontNumber,
//       productData?.backNumber,
//       productData?.textColors?.front,
//       productData?.textColors?.back,
//       productData?.numberColors?.front,
//       productData?.numberColors?.back,
//       productData?.textFonts?.front,
//       productData?.textFonts?.back,
//       productData?.numberFonts?.front,
//       productData?.numberFonts?.back,
//       productData?.selectedFonts,
//     ]);

//     const updateTexture = (
//       text,
//       textureRef,
//       partName,
//       fontFamily,
//       colorType = "text"
//     ) => {
//       if (!textureRef.current) return;

//       const canvas = textureRef.current.image;
//       const ctx = canvas.getContext("2d");

//       if (!ctx) {
//         console.error("Canvas context not found.");
//         return;
//       }

//       // Always clear the canvas
//       ctx.clearRect(0, 0, canvas.width, canvas.height);

//       // Only draw if there's text
//       if (text && text.trim() !== "") {
//         // Use different color properties based on colorType
//         let color;
//         if (colorType === "text") {
//           // For text: use textColors.front or textColors.back from current product
//           color = partName.includes("front")
//             ? productData?.textColors?.front || "#ffffff"
//             : productData?.textColors?.back || "#ffffff";
//         } else if (colorType === "number") {
//           // For numbers: use numberColors.front or numberColors.back from current product
//           color = partName.includes("front")
//             ? productData?.numberColors?.front || "#ffffff"
//             : productData?.numberColors?.back || "#ffffff";
//         } else {
//           // Fallback
//           color = "#ffffff";
//         }

//         ctx.fillStyle = color;
//         ctx.font = `bold 80px ${fontFamily || "Arial"}`;
//         ctx.textAlign = "center";
//         ctx.textBaseline = "middle";
//         ctx.fillText(text, canvas.width / 2, canvas.height / 2);
//       }

//       textureRef.current.needsUpdate = true;
//     };

//     // Remove or update this useEffect
//     // useEffect(() => {
//     //   updateTexture(snap.frontText, frontTextTexture, "front");
//     //   updateTexture(snap.backText, backTextTexture, "back");
//     //   updateTexture(snap.frontNumber, frontNumberTexture, "frontNumber");
//     //   updateTexture(snap.backNumber, backNumberTexture, "backNumber");
//     // }, [state.updateTrigger]);

//     // Replace it with this:
//     useEffect(() => {
//       // Trigger texture updates when global updateTrigger changes
//       if (productData) {
//         updateTexture(
//           productData.frontText || "",
//           frontTextTexture,
//           "front",
//           productData.textFonts?.front || productData.selectedFonts || "Arial",
//           "text"
//         );

//         updateTexture(
//           productData.backText || "",
//           backTextTexture,
//           "back",
//           productData.textFonts?.back || productData.selectedFonts || "Arial",
//           "text"
//         );

//         updateTexture(
//           productData.frontNumber || "",
//           frontNumberTexture,
//           "frontNumber",
//           productData.numberFonts?.front ||
//             productData.selectedFonts ||
//             "Arial",
//           "number"
//         );

//         updateTexture(
//           productData.backNumber || "",
//           backNumberTexture,
//           "backNumber",
//           productData.numberFonts?.back || productData.selectedFonts || "Arial",
//           "number"
//         );
//       }
//     }, [state.updateTrigger]);

//     // ==========================================
//     // CLEAN INTERACTION STATE - FROM SCRATCH
//     // ==========================================
//     const [interactionMode, setInteractionMode] = useState("idle"); // idle, dragging, resizing
//     const [selectedDecal, setSelectedDecal] = useState(null); // Which decal is selected
//     const [isDragging, setIsDragging] = useState(false);
//     const [isResizing, setIsResizing] = useState(false);
//     const [activeCorner, setActiveCorner] = useState(null); // tl, tr, bl, br
//     const [dragStartPos, setDragStartPos] = useState({ x: 0, y: 0 });
//     const [initialDecalPos, setInitialDecalPos] = useState([0, 0, 0]);
//     const [initialDecalScale, setInitialDecalScale] = useState([1, 1, 1]);
//     const hasDraggedRef = useRef(false); // Track if we actually moved during drag
//     const dragStartPosRef = useRef({ x: 0, y: 0 });
//     const initialDecalPosRef = useRef([0, 0, 0]);
//     const lastDragPositionRef = useRef([0, 0, 0]);
//     const selectedDecalDragRef = useRef(null);
//     const rotationIntervalRef = useRef(null); // Legacy – unused when using rAF
//     const rotationRAFRef = useRef(null); // For requestAnimationFrame-based continuous rotation
//     const rotationDirectionRef = useRef(null); // Track rotation direction (clockwise/anticlockwise)
//     const rotationLastTimeRef = useRef(0);

//     const [decalPositions, setDecalPositions] = useState({
//       frontText: frontTextPosition,
//       backText: backTextPosition,
//       frontNumber: frontNumberPosition,
//       backNumber: backNumberPosition,
//       frontLogo: frontLogoPosition,
//       backLogo: backLogoPosition,
//     });
//     const [decalScales, setDecalScales] = useState({
//       frontText: frontTextScale,
//       backText: backTextScale,
//       frontNumber: frontNumberScale,
//       backNumber: backNumberScale,
//       frontLogo: frontLogoScale,
//       backLogo: backLogoScale,
//     });

//     const [decalRotations, setDecalRotations] = useState({
//       frontText: 0,
//       frontNumber: 0,
//       frontLogo: 0,
//       backText: 0,
//       backNumber: 0,
//       backLogo: 0,
//     });

//     console.log("decalRotations:", decalRotations);

//     const transformTargetsRef = useRef({});
//     const [transformMode, setTransformMode] = useState("translate");
//     const [, setIsTransforming] = useState(false);

//     useEffect(() => {
//       const modelKey = state.newKey;

//       if (modelKey === "eventordereventjersey") {
//         console.log("state.selectedDesignId:", glbId);
//         const designId = String(glbId || "902");

//         console.log("Updating positions for event order design:", designId);

//         let modelConfig = modelConfig1[modelKey]?.[designId];

//         if (!modelConfig) {
//           console.warn(
//             "No config found for design ID:",
//             designId,
//             "falling back to 902"
//           );
//           modelConfig = modelConfig1[modelKey]?.["902"];
//         }

//         if (!modelConfig) {
//           console.error("No valid config found even for fallback 902!");
//           return;
//         }

//         console.log("Found config for design:", designId, modelConfig);

//         setDecalPositions({
//           frontText: modelConfig.frontTextPosition || [0, 0, 0],
//           frontNumber: modelConfig.frontNumberPosition || [0, 0, 0],
//           frontLogo: modelConfig.frontLogoPosition || [0, 0, 0],
//           backText: modelConfig.backTextPosition || [0, 0, 0],
//           backNumber: modelConfig.backNumberPosition || [0, 0, 0],
//           backLogo: modelConfig.backLogoPosition || [0, 0, 0],
//         });

//         setDecalScales({
//           frontText: modelConfig.frontTextScale || [1, 1, 1],
//           frontNumber: modelConfig.frontNumberScale || [1, 1, 1],
//           frontLogo: modelConfig.frontLogoScale || [1, 1, 1],
//           backText: modelConfig.backTextScale || [1, 1, 1],
//           backNumber: modelConfig.backNumberScale || [1, 1, 1],
//           backLogo: modelConfig.backLogoScale || [1, 1, 1],
//         });

//         if (modelConfig.fontSize) setFontSizetext(modelConfig.fontSize);
//         if (modelConfig.fontSizeNumber)
//           setFontSizeNumber(modelConfig.fontSizeNumber);

//         console.log("📍 Updated decal positions for design:", designId);
//       }
//     }, [glbId]);

//     const [tempPosition, setTempPosition] = useState([0, 0, 0]);
//     const [tempScale, setTempScale] = useState([0, 0, 0]);
//     const [mouseStartPos, setMouseStartPos] = useState({ x: 0, y: 0 });
//     const fabricCanvasCache = useRef({});
//     const textureCache = useRef({});
//     const lastOverlayClickTime = useRef(0);
//     const [isFrontVisible, setIsFrontVisible] = useState(true);

//     const rotateIconScreenPosRef = useRef({ x: 0, y: 0 });
//     const rotateClickTimeRef = useRef(0);
//     const [showRotateTooltip, setShowRotateTooltip] = useState(null);

//     const [resizeArrowPosition, setResizeArrowPosition] = useState({
//       x: 0,
//       y: 0,
//     });

//     useEffect(() => {
//       const handleTransformHotkeys = (event) => {
//         if (!selectedDecal || !selectedDecal.toLowerCase().includes("text")) {
//           return;
//         }

//         if (event.key === "t" || event.key === "T") {
//           setTransformMode("translate");
//         }

//         if (event.key === "s" || event.key === "S") {
//           setTransformMode("scale");
//         }
//       };

//       window.addEventListener("keydown", handleTransformHotkeys);
//       return () =>
//         window.removeEventListener("keydown", handleTransformHotkeys);
//     }, [selectedDecal]);

//     const resizeArrowPositionRef = useRef({ x: 0, y: 0 });

//     const getFabricCanvas = useCallback((type) => {
//       if (fabricCanvasCache.current[type]) {
//         return fabricCanvasCache.current[type];
//       }

//       const canvas = document.createElement("canvas");
//       // Use smaller canvas for numbers to prevent head cutting off
//       if (type.includes("Number")) {
//         canvas.width = 400;  // Smaller canvas for numbers
//         canvas.height = 200; // Smaller canvas for numbers
//       } else {
//         canvas.width = 512;  // Reduced from 1024 - smaller canvas for tighter text bounds
//         canvas.height = 256; // Reduced from 512 - smaller canvas for tighter text bounds
//       }

//       const fabricCanvas = new fabric.Canvas(canvas, {
//         enableRetinaScaling: false,
//         renderOnAddRemove: false,
//         selection: false,
//         preserveObjectStacking: true,

//         skipTargetFind: false,
//         skipOffscreen: true,
//         imageSmoothingEnabled: true,

//         renderOnSelectionChange: false,

//         allowTouchScrolling: false,
//         fireRightClick: false,
//         stopContextMenu: true,
//       });

//       fabricCanvasCache.current[type] = {
//         canvas,
//         fabricCanvas,
//         texture: new THREE.CanvasTexture(canvas),
//       };

//       return fabricCanvasCache.current[type];
//     }, []);

//     useEffect(() => {
//       return () => {
//         Object.values(textureCache.current).forEach((texture) => {
//           if (texture && texture.dispose) {
//             texture.dispose();
//           }
//         });
//         textureCache.current = {};
//         fabricCanvasCache.current = {};
//       };
//     }, []);

//         useEffect(() => {
//       return () => {
//         stopContinuousRotation();
//       };
//     }, [selectedDecal]);

//     useEffect(() => {
//       if (!selectedDecal) return;

//       const handleKeyDown = (e) => {
//         if (!selectedDecal) return;
//         if (
//           !["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)
//         )
//           return;

//         e.preventDefault();
//         const moveAmount = 0.01;
//         const currentPos = [...decalPositions[selectedDecal]];

//         //console.log("currentPos : ", currentPos);
//         switch (e.key) {
//           case "ArrowUp":
//             currentPos[1] += moveAmount;
//             break;
//           case "ArrowDown":
//             currentPos[1] -= moveAmount;
//             break;
//           case "ArrowLeft":
//             currentPos[0] -= moveAmount;
//             break;
//           case "ArrowRight":
//             currentPos[0] += moveAmount;
//             break;
//           default:
//             break;
//         }

//         //console.log("currentPos : ", currentPos);
//         setDecalPositions((prev) => ({
//           ...prev,
//           [selectedDecal]: currentPos,
//         }));
//         setTempPosition(currentPos);
//       };
//       window.addEventListener("keydown", handleKeyDown);
//       return () => {
//         window.removeEventListener("keydown", handleKeyDown);
//       };
//     }, [selectedDecal, decalPositions]);

//     const handleDeselect = () => {
//       setSelectedDecal(null);
//       setResizeMode(false);
//       setResizeCorner(null);
//       setInitialScale(null);
//       setIsDragging(false);
//       setIsResizing(false);
//       setActiveCorner(null);
//       // Always set to rotate-shirt mode when deselecting to enable rotation
//       setInteractionMode("rotate-shirt");

//       Object.keys(fabricCanvasCache.current).forEach((type) => {
//         const { fabricCanvas } = fabricCanvasCache.current[type];
//         fabricCanvas.discardActiveObject();
//         fabricCanvas.renderAll();
//       });
//     };

//     const [fontSizetext, setFontSizetext] = useState(() => {
//       const settings = getModelSettings(menuSlug, subcategorySlug);
//       return settings.fontSize || 50; // Reduced from 80 to 50
//     });

//     const [fontSizeNumber, setFontSizeNumber] = useState(() => {
//       const settings = getModelSettings(menuSlug, subcategorySlug);
//       return settings.fontSizeNumber || 60; // Reduced from 80 to 60
//     });


//     const getTextTexture = useCallback(
//       (type, textContent, color, font, isSelected) => {
//         if (!textContent || textContent.trim() === "") return null;

//         console.log("textContent : ", textContent);

//         try {
//           const { canvas, fabricCanvas, texture } = getFabricCanvas(type);

//           fabricCanvas.clear();

//           // No padding: keep text tight to texture for minimal gap from t-shirt
//           const text = new fabric.Text(textContent, {
//             left: canvas.width / 2,
//             top: canvas.height / 2,
//             originX: "center",
//             originY: "center",
//             fontSize: (fontSizetext || 80) * 1.35,  // Reduced by 20px from previous (1.6 * 80 = 128px, now 1.35 * 80 = 108px)
//             fontWeight: "bold",
//             fontFamily: font || "Arial",
//             fill: color || "black",
//             selectable: false,
//             hasControls: false,
//             hasBorders: false,
//             padding: 0,
//             borderColor: "transparent",
//             cornerSize: 0,
//             transparentCorners: true,
//             lockUniScaling: false,
//             hoverCursor: "default",
//             moveCursor: "default",
//             objectCaching: false,
//             borderScaleFactor: 0,
//             controls: {
//               tr: new fabric.Control({
//                 x: 0.5,
//                 y: -0.5,
//                 actionHandler: fabric.controlsUtils.rotationWithSnapping,
//                 cursorStyleHandler: () => "crosshair",
//                 // render: function (ctx, left, top, styleOverride, fabricObject) {
//                 //   const size = 60;
//                 //   ctx.save();
//                 //   ctx.translate(left, top);
//                 //   ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));

//                 //   ctx.beginPath();

//                 //   ctx.arc(0, 0, size / 2, 0, 2 * Math.PI);
//                 //   ctx.fillStyle = "white";
//                 //   ctx.fill();
//                 //   ctx.strokeStyle = "black";
//                 //   ctx.lineWidth = 3;
//                 //   ctx.stroke();

//                 //   ctx.beginPath();
//                 //   ctx.moveTo(size * 0.25, -size * 0.25);
//                 //   ctx.lineTo(size * 0.5, 0);
//                 //   ctx.lineTo(size * 0.25, size * 0.25);
//                 //   ctx.lineWidth = 7;
//                 //   ctx.stroke();

//                 //   ctx.beginPath();
//                 //   ctx.arc(
//                 //     0,
//                 //     0,
//                 //     size * 0.35,
//                 //     -Math.PI * 0.25,
//                 //     Math.PI * 1.5,
//                 //     false
//                 //   );
//                 //   ctx.lineWidth = 7;
//                 //   ctx.stroke();

//                 //   ctx.restore();
//                 // },
//                 actionName: "rotate",
//               }),
//               br: new fabric.Control({
//                 x: 0.5,
//                 y: 0.5,
//                 actionHandler: fabric.controlsUtils.scalingEqually,
//                 cursorStyleHandler: () => "nwse-resize",
//                 render: function (ctx, left, top, styleOverride, fabricObject) {
//                   const size = 60;
//                   ctx.save();
//                   ctx.translate(left, top);

//                   ctx.beginPath();
//                   ctx.rect(-size / 2, -size / 2, size, size);
//                   ctx.fillStyle = "white";
//                   ctx.fill();
//                   ctx.strokeStyle = "black";
//                   ctx.lineWidth = 3;
//                   ctx.stroke();

//                   ctx.beginPath();
//                   // Main line
//                   ctx.moveTo(-size * 0.35, -size * 0.35);
//                   ctx.lineTo(size * 0.35, size * 0.35);

//                   // Arrowhead
//                   ctx.moveTo(size * 0.35, size * 0.35);
//                   ctx.lineTo(size * 0.2, size * 0.35);
//                   ctx.lineTo(size * 0.35, size * 0.2);
//                   ctx.closePath();

//                   ctx.fillStyle = "black";
//                   ctx.fill();
//                   ctx.strokeStyle = "black";
//                   ctx.lineWidth = 7;
//                   ctx.stroke();

//                   ctx.restore();
//                 },
//                 actionName: "scale",
//               }),
//             },
//           });

//           text.set({
//             stroke: color || "black",
//             strokeWidth: 1,
//             strokeUniform: true,
//           });

//           fabricCanvas.add(text);

//           if (isSelected) {
//             fabricCanvas.setActiveObject(text);
//             text.bringToFront();

//             text.on("rotating", function (e) {
//               const angle = e.target.angle;
//               if (type.includes("front")) {
//                 frontTextRotation[2] = THREE.MathUtils.degToRad(angle);
//               } else {
//                 backTextRotation[2] = THREE.MathUtils.degToRad(angle);
//               }
//             });

//             text.on("scaling", function (e) {
//               const scale = e.target.scaleX;
//               if (type.includes("front")) {
//                 frontTextScale[0] = scale;
//                 frontTextScale[1] = scale;
//               } else {
//                 backTextScale[0] = scale;
//                 backTextScale[1] = scale;
//               }
//             });

//             // Disabled arrow creation for new resize feature
//             // requestAnimationFrame(() => {
//             //   const textBounds = text.getBoundingRect();
//             //   calculateAndStoreArrowPosition(type, textBounds);
//             // });
//           }

//           // Render fabric canvas and update texture
//           fabricCanvas.renderAll();
//           texture.needsUpdate = true;

//           return texture;
//         } catch (error) {
//           console.error("Error creating text texture:", error);

//           // Fallback canvas drawing
//           const fallbackCanvas = document.createElement("canvas");
//           fallbackCanvas.width = 512;  // Reduced canvas size
//           fallbackCanvas.height = 256; // Reduced canvas size
//           const ctx = fallbackCanvas.getContext("2d");

//           ctx.fillStyle = color || "white";
//           ctx.font = `108px ${font || "Arial"}`;  // Reduced by 20px (1.35 * 80 = 108px)
//           ctx.textAlign = "center";
//           ctx.textBaseline = "middle";
//           ctx.fillText(
//             textContent,
//             fallbackCanvas.width / 2,
//             fallbackCanvas.height / 2
//           );

//           return new THREE.CanvasTexture(fallbackCanvas);
//         }
//       },
//       [getFabricCanvas, fontSizetext]
//     );

//     const getNumberTexture = useCallback(
//       (type, textContent, color, font, isSelected) => {
//         if (!textContent || textContent.trim() === "") return null;

//         try {
//           const { canvas, fabricCanvas, texture } = getFabricCanvas(type);

//           fabricCanvas.clear();

//           const text = new fabric.Text(textContent, {
//             left: canvas.width / 2,
//             top: canvas.height / 2,
//             originX: "center",
//             originY: "center",
//             fontSize: (fontSizeNumber || 80) * 0.55,  // Reduced by 40px for numbers (was 84px, now 0.55 * 80 = 44px)
//             fontWeight: "bold",
//             fontFamily: font || "Arial",
//             fill: color || "black",
//             selectable: false,
//             hasControls: false,
//             hasBorders: false,
//             borderColor: "transparent",
//             cornerSize: 0,
//             transparentCorners: true,
//             lockUniScaling: false,
//             hoverCursor: "default",
//             moveCursor: "default",
//             objectCaching: false,
//             borderScaleFactor: 0,
//             controls: {
//               tr: new fabric.Control({
//                 x: 0.5,
//                 y: -0.5,
//                 actionHandler: fabric.controlsUtils.rotationWithSnapping,
//                 cursorStyleHandler: () => "crosshair",
//                 // render: function (ctx, left, top, styleOverride, fabricObject) {
//                 //   const size = 60;
//                 //   ctx.save();
//                 //   ctx.translate(left, top);
//                 //   ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
//                 //   ctx.beginPath();
//                 //   ctx.arc(0, 0, size / 2, 0, 2 * Math.PI);
//                 //   ctx.fillStyle = "white";
//                 //   ctx.fill();
//                 //   ctx.strokeStyle = "black";
//                 //   ctx.lineWidth = 3;
//                 //   ctx.stroke();

//                 //   ctx.beginPath();
//                 //   ctx.moveTo(size * 0.25, -size * 0.25);
//                 //   ctx.lineTo(size * 0.5, 0);
//                 //   ctx.lineTo(size * 0.25, size * 0.25);
//                 //   ctx.lineWidth = 7;
//                 //   ctx.stroke();

//                 //   ctx.beginPath();
//                 //   ctx.arc(
//                 //     0,
//                 //     0,
//                 //     size * 0.35,
//                 //     -Math.PI * 0.25,
//                 //     Math.PI * 1.5,
//                 //     false
//                 //   );
//                 //   ctx.lineWidth = 7;
//                 //   ctx.stroke();

//                 //   ctx.restore();
//                 // },
//                 actionName: "rotate",
//               }),
//               br: new fabric.Control({
//                 x: 0.5,
//                 y: 0.5,
//                 actionHandler: fabric.controlsUtils.scalingEqually,
//                 cursorStyleHandler: () => "nwse-resize",
//                 render: function (ctx, left, top, styleOverride, fabricObject) {
//                   const size = 60;
//                   ctx.save();
//                   ctx.translate(left, top);

//                   ctx.beginPath();
//                   ctx.rect(-size / 2, -size / 2, size, size);
//                   ctx.fillStyle = "white";
//                   ctx.fill();
//                   ctx.strokeStyle = "black";
//                   ctx.lineWidth = 3;
//                   ctx.stroke();

//                   ctx.beginPath();

//                   ctx.moveTo(-size * 0.35, -size * 0.35);
//                   ctx.lineTo(size * 0.35, size * 0.35);

//                   ctx.moveTo(size * 0.35, size * 0.35);
//                   ctx.lineTo(size * 0.2, size * 0.35);
//                   ctx.lineTo(size * 0.35, size * 0.2);
//                   ctx.closePath();

//                   ctx.fillStyle = "black";
//                   ctx.fill();
//                   ctx.strokeStyle = "black";
//                   ctx.lineWidth = 7;
//                   ctx.stroke();

//                   ctx.restore();
//                 },
//                 actionName: "scale",
//               }),
//             },
//           });

//           // Slight stroke to harden number edges
//           text.set({
//             stroke: color || "black",
//             strokeWidth: 1,
//             strokeUniform: true,
//           });

//           // Add to canvas
//           fabricCanvas.add(text);

//           if (isSelected) {
//             fabricCanvas.setActiveObject(text);
//             text.bringToFront();

//             // Rotation tracking
//             text.on("rotating", function (e) {
//               const angle = e.target.angle;
//               if (type.includes("front")) {
//                 frontNumberRotation[2] = THREE.MathUtils.degToRad(angle);
//               } else {
//                 backNumberRotation[2] = THREE.MathUtils.degToRad(angle);
//               }
//             });

//             // Scaling tracking
//             text.on("scaling", function (e) {
//               const scale = e.target.scaleX;
//               if (type.includes("front")) {
//                 frontNumberScale[0] = frontNumberScale[1] = scale;
//               } else {
//                 backNumberScale[0] = backNumberScale[1] = scale;
//               }
//             });

//             // Disabled arrow creation for new resize feature
//             // requestAnimationFrame(() => {
//             //   const textBounds = text.getBoundingRect();
//             //   calculateAndStoreArrowPosition(type, textBounds);
//             // });
//           }

//           fabricCanvas.renderAll();
//           texture.needsUpdate = true;

//           return texture;
//         } catch (error) {
//           console.error("Error creating number texture:", error);

//           // Fallback 2D canvas version
//           const fallbackCanvas = document.createElement("canvas");
//           fallbackCanvas.width = 400;  // Smaller canvas for numbers
//           fallbackCanvas.height = 200; // Smaller canvas for numbers
//           const ctx = fallbackCanvas.getContext("2d");

//           ctx.fillStyle = color || "white";
//           ctx.font = `44px ${font || "Arial"}`;  // Reduced by 40px for numbers (was 84px, now 44px)
//           ctx.textAlign = "center";
//           ctx.textBaseline = "middle";
//           ctx.fillText(
//             textContent,
//             fallbackCanvas.width / 2,
//             fallbackCanvas.height / 2
//           );

//           return new THREE.CanvasTexture(fallbackCanvas);
//         }
//       },
//       [getFabricCanvas, fontSizeNumber]
//     );

//     // Maintain decal aspect ratio to prevent squishing when multiple overlays overlap
//     const getAspectAwareScale = useCallback((type, baseScale, texture) => {
//       const scaleArray = Array.isArray(baseScale)
//         ? baseScale
//         : [baseScale, baseScale, baseScale];
//       const base = scaleArray[0] || 1;

//       // Default aspect is square
//       let aspect = 1;

//       // Text and number canvases use 1024x512 => height/width = 0.5
//       if (type.includes("Text") || type.includes("Number")) {
//         aspect = 512 / 1024;
//       }

//       // Logos: use the actual texture dimensions when available
//       if (
//         type.includes("Logo") &&
//         texture &&
//         texture.image &&
//         texture.image.width &&
//         texture.image.height
//       ) {
//         aspect = texture.image.height / texture.image.width;
//       }

//       // Keep Z as original if provided
//       const z = scaleArray[2] !== undefined ? scaleArray[2] : base;
//       return [base, base * aspect, z];
//     }, []);

    

//     const [resizeMode, setResizeMode] = useState(false);
//     const [resizeStartPos, setResizeStartPos] = useState({ x: 0, y: 0 });
//     const [initialScale, setInitialScale] = useState(null);
//     const [resizeCorner, setResizeCorner] = useState(null);
//     const [resizeBorderVisible, setResizeBorderVisible] = useState(false);
//     const selectedDecalRef = useRef(null);
//     const [pendingResizeEvent, setPendingResizeEvent] = useState(null);

//     // NEW RESIZE FEATURE - Completely separate from existing functions
//     const [newResizeActive, setNewResizeActive] = useState(false);
//     const [newResizeStartPos, setNewResizeStartPos] = useState({ x: 0, y: 0 });
//     const [newResizeInitialScale, setNewResizeInitialScale] = useState(null);
//     const [newResizeSelectedDecal, setNewResizeSelectedDecal] = useState(null);
//     const [newResizeTempScale, setNewResizeTempScale] = useState([0, 0, 0]);
//     const [newResizeCorner, setNewResizeCorner] = useState(null);

//      // REPLACE your detectCornerClick function with this updated version:
//     const detectCornerClick = (e, decalType, camera) => {
//       console.log("Corner Detection start");
//       console.log(`selectedDecal: ${selectedDecal}, decalType: ${decalType}`);

//       if (!selectedDecal && !decalType) {
//         console.log("No selected decal or decal type");
//         return false;
//       }

//       const position = decalPositions[decalType];
//       const currentScale = decalScales[decalType];

//       if (!camera || !position || !currentScale) {
//         console.error("Camera, position, or scale missing");
//         return false;
//       }

//       console.log(`Position: ${position}, Scale: ${currentScale}`);

//       // Get model-specific configuration
//       const modelKey = state.newKey;
//       let modelConfig = modelConfig1[modelKey];

//       // SPECIAL HANDLING for eventordereventjersey - it has subcategories
//       if (modelKey === "eventordereventjersey" && state.selectedDesignId) {
//         modelConfig =
//           modelConfig1[modelKey][state.selectedDesignId] ||
//           modelConfig1[modelKey];
//         console.log(
//           `Using eventorder category: ${state.selectedDesignId}`,
//           modelConfig
//         );
//       }

//       console.log(`Model: ${modelKey}`, modelConfig);

//       // MODEL-SPECIFIC CORNER DETECTION CALCULATION
//       let threshold = 50;
//       let widthDivisor = 10;
//       let heightDivisor = 10;

//       if (modelConfig && currentScale) {
//         const overallScale = modelConfig.overallScale || 1;
//         const modelScale = Array.isArray(modelConfig.scale)
//           ? modelConfig.scale[0]
//           : modelConfig.scale || 1;
//         const currentScaleX = currentScale[0] || 1;
//         const currentScaleY = currentScale[1] || 1;

//         console.log(
//           `Model: ${modelKey}, DesignID: ${state.selectedDesignId}, Scale analysis:`,
//           {
//             overallScale,
//             modelScale,
//             currentScaleX,
//             currentScaleY,
//           }
//         );

//         if (modelKey === "menmenjersey") {
//           widthDivisor = 8;
//           heightDivisor = 8;
//           threshold = 60;
//         } else if (modelKey === "eventordereventjersey") {
//           const designId = state.selectedDesignId;
//           if (designId === "900" || designId === 900) {
//             widthDivisor = 3;
//             heightDivisor = 4;
//             threshold = 70;
//           } else if (designId === "901" || designId === 901) {
//             widthDivisor = 2.5;
//             heightDivisor = 3;
//             threshold = 80;
//           } else if (designId === "902" || designId === 902) {
//             widthDivisor = 8;
//             heightDivisor = 8;
//             threshold = 60;
//           } else if (designId === "903" || designId === 903) {
//             widthDivisor = 2;
//             heightDivisor = 2.5;
//             threshold = 75;
//           } else if (designId === "904" || designId === 904) {
//             widthDivisor = 3;
//             heightDivisor = 3.5;
//             threshold = 70;
//           } else {
//             widthDivisor = 3;
//             heightDivisor = 4;
//             threshold = 70;
//           }
//         } else if (modelKey === "womenwomenfootballjersey") {
//           widthDivisor = 6;
//           heightDivisor = 6;
//           threshold = 65;
//         } else if (
//           modelKey === "menmencricketshorts" ||
//           modelKey === "menmenshorts"
//         ) {
//           widthDivisor = 4;
//           heightDivisor = 5;
//           threshold = 70;
//         } else if (modelKey === "womenwomenbadmintonshorts") {
//           widthDivisor = 3.5;
//           heightDivisor = 4;
//           threshold = 65;
//         } else if (modelKey === "womenwomentrackpants") {
//           widthDivisor = 4;
//           heightDivisor = 5;
//           threshold = 60;
//         } else if (modelKey === "womenwomencyclingjersey") {
//           widthDivisor = 15;
//           heightDivisor = 15;
//           threshold = 45;
//         } else if (modelKey === "menmentanktop") {
//           widthDivisor = 3;
//           heightDivisor = 3.5;
//           threshold = 70;
//         } else if (modelKey === "menmencyclingjersey") {
//           widthDivisor = 2.5;
//           heightDivisor = 3;
//           threshold = 80;
//         } else if (modelKey === "menmentrackpants") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//           threshold = 65;
//         } else if (modelKey === "menmencricketjersey") {
//           widthDivisor = 8;
//           heightDivisor = 8;
//           threshold = 60;
//         } else if (modelKey === "menmenarmsleeves") {
//           widthDivisor = 2.5;
//           heightDivisor = 3;
//           threshold = 75;
//         } else if (modelKey === "menmenbasketballshorts") {
//           widthDivisor = 4.5;
//           heightDivisor = 5;
//           threshold = 65;
//         } else if (modelKey === "womenwomenbadmintonjersey") {
//           widthDivisor = 2;
//           heightDivisor = 2.5;
//           threshold = 75;
//         } else if (modelKey === "menmensoccerjersey") {
//           widthDivisor = 2;
//           heightDivisor = 2.5;
//           threshold = 80;
//         } else if (modelKey === "womenwomenjersey") {
//           widthDivisor = 3;
//           heightDivisor = 3.5;
//           threshold = 70;
//         } else if (modelKey === "menmenbasketballjersey") {
//           widthDivisor = 3;
//           heightDivisor = 3.5;
//           threshold = 70;
//         } else if (modelKey === "kidskidsbasketballjersey") {
//           widthDivisor = 3;
//           heightDivisor = 3.5;
//           threshold = 70;
//         } else if (modelKey === "menmencitycollection") {
//           widthDivisor = 2;
//           heightDivisor = 2.5;
//           threshold = 75;
//         } else if (modelKey === "menmenxjersey") {
//           widthDivisor = 2;
//           heightDivisor = 2.5;
//           threshold = 75;
//         } else if (modelKey === "kidskidscricketshorts") {
//           widthDivisor = 4.5;
//           heightDivisor = 5;
//           threshold = 65;
//         } else if (modelKey === "kidskidsshorts") {
//           widthDivisor = 4.5;
//           heightDivisor = 5;
//           threshold = 65;
//         } else if (modelKey === "menmenfootballjersey") {
//           widthDivisor = 2.5;
//           heightDivisor = 3;
//           threshold = 75;
//         } else if (modelKey === "womenwomencricketjersey") {
//           widthDivisor = 3.5;
//           heightDivisor = 4;
//           threshold = 65;
//         } else if (modelKey === "womenwomenbadmintontanktop") {
//           widthDivisor = 7;
//           heightDivisor = 7;
//           threshold = 55;
//         } else if (modelKey === "womenwomenxjersey") {
//           widthDivisor = 5;
//           heightDivisor = 5;
//           threshold = 60;
//         } else if (modelKey === "kidskidscricketjersey") {
//           widthDivisor = 3;
//           heightDivisor = 4;
//           threshold = 70;
//         } else if (modelKey === "kidskidscyclingjersey") {
//           widthDivisor = 4;
//           heightDivisor = 5;
//           threshold = 65;
//         } else if (modelKey === "kidskidsjersey") {
//           widthDivisor = 4;
//           heightDivisor = 5;
//           threshold = 65;
//         } else if (modelKey === "kidskidstanktop") {
//           widthDivisor = 3;
//           heightDivisor = 3.5;
//           threshold = 70;
//         } else if (modelKey === "kidskidsbasictshirt") {
//           widthDivisor = 4;
//           heightDivisor = 4.5;
//           threshold = 65;
//         } else if (modelKey === "womenwomencompressionpants") {
//           widthDivisor = 3.5;
//           heightDivisor = 4;
//           threshold = 65;
//         } else {
//           widthDivisor = 5;
//           heightDivisor = 6;
//           threshold = 60;
//         }

//         console.log(`Corner detection config:`, {
//           widthDivisor: widthDivisor.toFixed(2),
//           heightDivisor: heightDivisor.toFixed(2),
//           threshold: threshold.toFixed(2),
//         });
//       }

//       const getEventCoords = (event) => {
//         if (event.touches && event.touches.length > 0) {
//           return { x: event.touches[0].clientX, y: event.touches[0].clientY };
//         }
//         return { x: event.clientX, y: event.clientY };
//       };

//       const coords = getEventCoords(e);
//       const clickX = coords.x;
//       const clickY = coords.y;

//       console.log(`Click coordinates: [${clickX}, ${clickY}]`);

//       const center3D = new THREE.Vector3(...position);
//       console.log("3D Center Position: ", center3D);

//       let adjustedPosition = center3D.clone();

//       console.log("Adjusted 3D Position: ", adjustedPosition);

//       const projectedCenter = adjustedPosition.clone().project(camera);
//       console.log("Projected Center: ", projectedCenter);

//       // FIXED: Better validation for projected coordinates
//       if (
//         Math.abs(projectedCenter.x) > 3 ||
//         Math.abs(projectedCenter.y) > 3 ||
//         projectedCenter.z <= 0 ||
//         projectedCenter.z > 1
//       ) {
//         console.error("❌ Projected coordinates are invalid");
//         console.log(
//           `Raw projected: [${projectedCenter.x}, ${projectedCenter.y}, ${projectedCenter.z}]`
//         );
//         return false;
//       }

//       const screenCenterX = (projectedCenter.x * 0.5 + 0.5) * window.innerWidth;
//       const screenCenterY =
//         (1 - (projectedCenter.y * 0.5 + 0.5)) * window.innerHeight;

//       console.log(
//         `📺 Screen center: [${screenCenterX.toFixed(
//           2
//         )}, ${screenCenterY.toFixed(2)}]`
//       );

//       let normalizedScaleX = Math.min(currentScale[0] / 50, 1);
//       let normalizedScaleY = Math.min(currentScale[1] / 50, 1);

//       if (modelKey === "womenwomencyclingjersey") {
//         normalizedScaleX = Math.min(currentScale[0] / 80, 0.8);
//         normalizedScaleY = Math.min(currentScale[1] / 80, 0.8);
//       }

//       const screenHalfWidth =
//         (normalizedScaleX * window.innerWidth) / widthDivisor;
//       const screenHalfHeight =
//         (normalizedScaleY * window.innerHeight) / heightDivisor;

//       console.log(
//         `Screen half dimensions: W=${screenHalfWidth.toFixed(
//           2
//         )}, H=${screenHalfHeight.toFixed(2)}`
//       );

//       const maxDimension = Math.min(window.innerWidth, window.innerHeight) / 4;
//       const cappedWidth = Math.min(screenHalfWidth, maxDimension);
//       const cappedHeight = Math.min(screenHalfHeight, maxDimension);

//       if (
//         cappedWidth !== screenHalfWidth ||
//         cappedHeight !== screenHalfHeight
//       ) {
//         console.log(
//           `Dimensions capped: W=${screenHalfWidth.toFixed(
//             2
//           )}->${cappedWidth.toFixed(2)}, H=${screenHalfHeight.toFixed(
//             2
//           )}->${cappedHeight.toFixed(2)}`
//         );
//       }

//       console.log(
//         `Capped dimensions: W=${cappedWidth.toFixed(
//           2
//         )}, H=${cappedHeight.toFixed(2)}`
//       );

//       const corners = {
//         tl: {
//           x: screenCenterX - cappedWidth,
//           y: screenCenterY - cappedHeight,
//           type: "tl",
//         },
//         tr: {
//           x: screenCenterX + cappedWidth,
//           y: screenCenterY - cappedHeight,
//           type: "tr",
//         },
//         bl: {
//           x: screenCenterX - cappedWidth,
//           y: screenCenterY + cappedHeight,
//           type: "bl",
//         },
//         br: {
//           x: screenCenterX + cappedWidth,
//           y: screenCenterY + cappedHeight,
//           type: "br",
//         },
//       };

//       console.log(`Corners:`, corners);

//       let closestCorner = null;
//       let minDistance = Infinity;

//       for (let key in corners) {
//         const dx = clickX - corners[key].x;
//         const dy = clickY - corners[key].y;
//         const dist = Math.hypot(dx, dy);

//         console.log(
//           `📍 Corner ${key}: [${corners[key].x.toFixed(2)}, ${corners[
//             key
//           ].y.toFixed(2)}] distance=${dist.toFixed(2)}`
//         );

//         if (dist < minDistance) {
//           minDistance = dist;
//           closestCorner = corners[key];
//         }
//       }

//       console.log(
//         `Closest corner: ${
//           closestCorner?.type
//         }, distance: ${minDistance.toFixed(2)}, threshold: ${threshold}`
//       );

//       if (minDistance < threshold) {
//         console.log("Corner detected!");
//         setPendingResizeEvent(e);
//         return closestCorner.type;
//       }

//       console.log("No corner detected");
//       return false;
//     };

//     useEffect(() => {
//       const modelKey = state.newKey;
//       let modelConfig = modelConfig1[modelKey];

//       if (modelKey === "eventordereventjersey" && state.selectedDesignId) {
//         modelConfig = modelConfig1[modelKey][state.selectedDesignId];
//         console.log(
//           `Event Order Category: ${state.selectedDesignId}`,
//           modelConfig
//         );
//       }

//       console.log(`Active Model Config: ${modelKey}`, {
//         overallScale: modelConfig?.overallScale,
//         scale: modelConfig?.scale,
//         rotation: modelConfig?.rotation,
//       });
//     }, [state.newKey, state.selectedDesignId]);

//     const detectNewResizeCorner = (e, decalType, camera) => {
//       console.log("NEW Corner Detection start");
//       if (!newResizeSelectedDecal || newResizeSelectedDecal !== decalType)
//         return false;

//       const position = decalPositions[decalType];
//       const currentScale = decalScales[decalType];
//       console.log("position:", position, "currentScale:", currentScale);

//       if (!camera) {
//         console.error("Camera not found");
//         return false;
//       }

//       // Get model-specific configuration
//       const modelKey = state.newKey;
//       const modelConfig = modelConfig1[modelKey];

//       // Use a dynamic threshold based on model scale
//       let threshold = 40; // Base threshold for new resize
//       let widthDivisor = 8;
//       let heightDivisor = 8;

//       // Adjust threshold and divisors based on model's overall scale
//       if (modelConfig) {
//         const scaleFactor = modelConfig.overallScale || 1;
//         threshold = Math.max(25, Math.min(60, threshold * (10 / scaleFactor)));

//         // MODEL-SPECIFIC DIVISOR CALCULATION FOR NEW RESIZE
//         if (modelKey === "menmenjersey") {
//           widthDivisor = 12;
//           heightDivisor = 12;
//         } else if (modelKey === "eventordereventjersey") {
//           const designId = state.selectedDesignId;
//           if (designId === "900" || designId === 900) {
//             widthDivisor = 5;
//             heightDivisor = 6;
//           } else if (designId === "901" || designId === 901) {
//             widthDivisor = 4;
//             heightDivisor = 5;
//           } else if (designId === "902" || designId === 902) {
//             widthDivisor = 12;
//             heightDivisor = 12;
//           } else if (designId === "903" || designId === 903) {
//             widthDivisor = 3;
//             heightDivisor = 4;
//           } else if (designId === "904" || designId === 904) {
//             widthDivisor = 5;
//             heightDivisor = 6;
//           } else {
//             widthDivisor = 5;
//             heightDivisor = 6;
//           }
//         } else if (modelKey === "womenwomenfootballjersey") {
//           widthDivisor = 9;
//           heightDivisor = 9;
//         } else if (
//           modelKey === "menmencricketshorts" ||
//           modelKey === "menmenshorts"
//         ) {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "womenwomenbadmintonshorts") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else if (modelKey === "womenwomentrackpants") {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "womenwomencyclingjersey") {
//           widthDivisor = 20;
//           heightDivisor = 20;
//         } else if (modelKey === "menmentanktop") {
//           widthDivisor = 4;
//           heightDivisor = 5;
//         } else if (modelKey === "menmencyclingjersey") {
//           widthDivisor = 4;
//           heightDivisor = 5;
//         } else if (modelKey === "menmentrackpants") {
//           widthDivisor = 7;
//           heightDivisor = 8;
//         } else if (modelKey === "menmencricketjersey") {
//           widthDivisor = 12;
//           heightDivisor = 12;
//         } else if (modelKey === "menmenarmsleeves") {
//           widthDivisor = 4;
//           heightDivisor = 5;
//         } else if (modelKey === "menmenbasketballshorts") {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "womenwomenbadmintonjersey") {
//           widthDivisor = 3;
//           heightDivisor = 4;
//         } else if (modelKey === "menmensoccerjersey") {
//           widthDivisor = 3;
//           heightDivisor = 4;
//         } else if (modelKey === "womenwomenjersey") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else if (modelKey === "menmenbasketballjersey") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else if (modelKey === "kidskidsbasketballjersey") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else if (modelKey === "menmencitycollection") {
//           widthDivisor = 3;
//           heightDivisor = 4;
//         } else if (modelKey === "menmenxjersey") {
//           widthDivisor = 3;
//           heightDivisor = 4;
//         } else if (modelKey === "kidskidscricketshorts") {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "kidskidsshorts") {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "menmenfootballjersey") {
//           widthDivisor = 4;
//           heightDivisor = 5;
//         } else if (modelKey === "womenwomencricketjersey") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else if (modelKey === "womenwomenbadmintontanktop") {
//           widthDivisor = 10;
//           heightDivisor = 10;
//         } else if (modelKey === "womenwomenxjersey") {
//           widthDivisor = 7;
//           heightDivisor = 7;
//         } else if (modelKey === "kidskidscricketjersey") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else if (modelKey === "kidskidscyclingjersey") {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "kidskidsjersey") {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "kidskidstanktop") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else if (modelKey === "kidskidsbasictshirt") {
//           widthDivisor = 6;
//           heightDivisor = 7;
//         } else if (modelKey === "womenwomencompressionpants") {
//           widthDivisor = 5;
//           heightDivisor = 6;
//         } else {
//           widthDivisor = 7;
//           heightDivisor = 8;
//         }

//         console.log(
//           `Model: ${modelKey}, Overall Scale: ${scaleFactor}, Threshold: ${threshold}, Divisors: W=${widthDivisor}, H=${heightDivisor}`
//         );
//       }

//       // Get coordinates from either mouse or touch event
//       const getEventCoords = (event) => {
//         if (event.touches && event.touches.length > 0) {
//           return { x: event.touches[0].clientX, y: event.touches[0].clientY };
//         }
//         return { x: event.clientX, y: event.clientY };
//       };

//       const coords = getEventCoords(e);
//       const clickX = coords.x;
//       const clickY = coords.y;
//       console.log(`Click coordinates: [${clickX}, ${clickY}]`);

//       // Get the 3D position and project to screen
//       const center3D = new THREE.Vector3(...position);
//       console.log("3D Center Position: ", center3D);

//       // FIXED: Apply position adjustment for womenwomencyclingjersey to fix extreme Y values
//       let adjustedPosition = center3D.clone();

//       // SPECIAL FIX for womenwomencyclingjersey - adjust problematic Y positions
//       if (modelKey === "womenwomencyclingjersey") {
//         console.log(`🔧 Applying cycling jersey position fix for ${decalType}`);

//         // Reduce the extreme Y values that are causing projection issues
//         if (
//           decalType.includes("frontText") ||
//           decalType.includes("frontNumber") ||
//           decalType.includes("backText") ||
//           decalType.includes("backNumber")
//         ) {
//           // Scale down the extreme Y values while maintaining relative positioning
//           adjustedPosition.y = adjustedPosition.y * 0.3; // Reduce Y by 70%
//           console.log(
//             `🔧 Adjusted Y position: ${center3D.y} -> ${adjustedPosition.y}`
//           );
//         }
//       }

//       // Project center to screen coordinates
//       const projectedCenter = adjustedPosition.clone().project(camera);

//       // FIXED: More lenient validation for projected coordinates
//       let projectedX = projectedCenter.x;
//       let projectedY = projectedCenter.y;

//       // Clamp projected coordinates to reasonable range if they're extreme
//       if (Math.abs(projectedX) > 10 || Math.abs(projectedY) > 10) {
//         console.log("🔄 Clamping extreme projected coordinates");
//         projectedX = Math.max(-5, Math.min(5, projectedX));
//         projectedY = Math.max(-5, Math.min(5, projectedY));
//       }

//       const screenCenterX = (projectedX * 0.5 + 0.5) * window.innerWidth;
//       const screenCenterY = (1 - (projectedY * 0.5 + 0.5)) * window.innerHeight;

//       console.log(
//         `Screen center: [${screenCenterX.toFixed(2)}, ${screenCenterY.toFixed(
//           2
//         )}]`
//       );

//       // FIXED: Improved scale calculation with better normalization
//       let normalizedScaleX = Math.min(currentScale[0] / 80, 0.7);
//       let normalizedScaleY = Math.min(currentScale[1] / 80, 0.7);

//       // Special adjustment for womenwomencyclingjersey to make corner area smaller
//       if (modelKey === "womenwomencyclingjersey") {
//         normalizedScaleX = Math.min(currentScale[0] / 120, 0.5);
//         normalizedScaleY = Math.min(currentScale[1] / 120, 0.5);
//       }

//       const screenHalfWidth =
//         (normalizedScaleX * window.innerWidth) / widthDivisor;
//       const screenHalfHeight =
//         (normalizedScaleY * window.innerHeight) / heightDivisor;

//       console.log(
//         `Screen half dimensions: W=${screenHalfWidth.toFixed(
//           2
//         )}, H=${screenHalfHeight.toFixed(2)}`
//       );

//       // Safety check: Cap dimensions to reasonable screen bounds
//       const maxDimension = Math.min(window.innerWidth, window.innerHeight) / 5;
//       const cappedWidth = Math.min(screenHalfWidth, maxDimension);
//       const cappedHeight = Math.min(screenHalfHeight, maxDimension);

//       if (
//         cappedWidth !== screenHalfWidth ||
//         cappedHeight !== screenHalfHeight
//       ) {
//         console.log(
//           `Dimensions capped: W=${screenHalfWidth.toFixed(
//             2
//           )}->${cappedWidth.toFixed(2)}, H=${screenHalfHeight.toFixed(
//             2
//           )}->${cappedHeight.toFixed(2)}`
//         );
//       }

//       // Define corners in screen space
//       const corners = {
//         tl: {
//           x: screenCenterX - cappedWidth,
//           y: screenCenterY - cappedHeight,
//           type: "tl",
//         },
//         tr: {
//           x: screenCenterX + cappedWidth,
//           y: screenCenterY - cappedHeight,
//           type: "tr",
//         },
//         bl: {
//           x: screenCenterX - cappedWidth,
//           y: screenCenterY + cappedHeight,
//           type: "bl",
//         },
//         br: {
//           x: screenCenterX + cappedWidth,
//           y: screenCenterY + cappedHeight,
//           type: "br",
//         },
//       };

//       console.log("Corners:", corners);

//       // Find closest corner
//       let closestCorner = null;
//       let minDistance = Infinity;

//       for (let key in corners) {
//         const dx = clickX - corners[key].x;
//         const dy = clickY - corners[key].y;
//         const dist = Math.hypot(dx, dy);

//         console.log(
//           `Corner ${key}: [${corners[key].x.toFixed(2)}, ${corners[
//             key
//           ].y.toFixed(2)}] distance=${dist.toFixed(2)}`
//         );

//         if (dist < minDistance) {
//           minDistance = dist;
//           closestCorner = corners[key];
//           console.log(
//             `New closest corner: ${key} with distance ${dist.toFixed(2)}`
//           );
//         }
//       }

//       console.log(
//         `NEW Closest corner distance: ${minDistance.toFixed(
//           2
//         )}, threshold: ${threshold}`
//       );

//       if (minDistance < threshold) {
//         console.log("✅ NEW Corner detected!");
//         return closestCorner.type;
//       }

//       console.log("❌ NEW No corner detected");
//       return false;
//     };

//     const handleNewResizeFunction = (e) => {
//       if (
//         !newResizeActive ||
//         !newResizeSelectedDecal ||
//         !newResizeInitialScale ||
//         !newResizeCorner
//       )
//         return;

//       const getEventCoords = (event) => {
//         if (event.touches && event.touches.length > 0) {
//           return { x: event.touches[0].clientX, y: event.touches[0].clientY };
//         }
//         return { x: event.clientX, y: event.clientY };
//       };

//       const modelKey = state.newKey;
//       const coords = getEventCoords(e);
//       let deltaX = coords.x - newResizeStartPos.x;
//       let deltaY = coords.y - newResizeStartPos.y;

//       if (modelKey === "womenwomenbadmintonjersey") {
//         deltaX = -deltaX;
//         deltaY = -deltaY;
//       }

//       if (
//         modelKey === "menmenjersey" ||
//         modelKey === "menmencricketjersey" ||
//         modelKey === "womenwomenfootballjersey" ||
//         modelKey === "womenwomenxjersey" ||
//         modelKey === "womenwomenbadmintontanktop" ||
//         (!modelKey === "eventordereventjersey" &&
//           (glbId === "900" || glbId === "904"))
//       ) {
//         const sensitivity = newResizeSelectedDecal.includes("Logo")
//           ? 0.005
//           : 0.003;
//         let newScale = [...newResizeInitialScale];

//         requestAnimationFrame(() => {
//           switch (newResizeCorner) {
//             case "tl":
//               newScale[0] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[0] - deltaX * sensitivity)
//               );
//               newScale[1] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[1] - deltaY * sensitivity)
//               );
//               break;
//             case "tr":
//               newScale[0] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[0] + deltaX * sensitivity)
//               );
//               newScale[1] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[1] - deltaY * sensitivity)
//               );
//               break;
//             case "bl":
//               newScale[0] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[0] - deltaX * sensitivity)
//               );
//               newScale[1] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[1] + deltaY * sensitivity)
//               );
//               break;
//             case "br":
//               newScale[0] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[0] + deltaX * sensitivity)
//               );
//               newScale[1] = Math.max(
//                 0.05,
//                 Math.min(8, newResizeInitialScale[1] + deltaY * sensitivity)
//               );
//               break;
//             default:
//               break;
//           }

//           setNewResizeTempScale(newScale);
//           setDecalScales((prev) => ({
//             ...prev,
//             [newResizeSelectedDecal]: newScale,
//           }));

//           if (newResizeSelectedDecal.includes("front")) {
//             frontLogoScale[0] = newScale[0];
//             frontLogoScale[1] = newScale[1];
//           } else if (newResizeSelectedDecal.includes("back")) {
//             backLogoScale[0] = newScale[0];
//             backLogoScale[1] = newScale[1];
//           }
//         });
//       } else {
//         console.log(
//           "------------------------------------------------------------------"
//         );
//         const sensitivity = newResizeSelectedDecal.includes("Logo")
//           ? 0.005
//           : 0.003;
//         const diagonalDelta = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

//         let scaleFactor = 1;
//         switch (newResizeCorner) {
//           case "tl":
//             scaleFactor =
//               1 +
//               (deltaX < 0 && deltaY < 0 ? -diagonalDelta : diagonalDelta) *
//                 sensitivity;
//             break;
//           case "tr":
//             scaleFactor =
//               1 +
//               (deltaX > 0 && deltaY < 0 ? -diagonalDelta : diagonalDelta) *
//                 sensitivity;
//             break;
//           case "bl":
//             scaleFactor =
//               1 +
//               (deltaX < 0 && deltaY > 0 ? -diagonalDelta : diagonalDelta) *
//                 sensitivity;
//             break;
//           case "br":
//             scaleFactor =
//               1 +
//               (deltaX > 0 && deltaY > 0 ? diagonalDelta : -diagonalDelta) *
//                 sensitivity;
//             break;
//         }

//         const newScale = newResizeInitialScale.map((s) =>
//           Math.max(5, Math.min(300, s * scaleFactor))
//         );

//         requestAnimationFrame(() => {
//           setNewResizeTempScale(newScale);
//           setDecalScales((prev) => ({
//             ...prev,
//             [newResizeSelectedDecal]: newScale,
//           }));

//           if (newResizeSelectedDecal.includes("front")) {
//             frontLogoScale[0] = newScale[0];
//             frontLogoScale[1] = newScale[1];
//           } else if (newResizeSelectedDecal.includes("back")) {
//             backLogoScale[0] = newScale[0];
//             backLogoScale[1] = newScale[1];
//           }
//         });
//       }
//     };

//     // NEW RESIZE END FUNCTION
//     const endNewResize = () => {
//       console.log("Ending NEW resize function");

//       setNewResizeActive(false);
//       setNewResizeSelectedDecal(null);
//       setNewResizeInitialScale(null);
//       setNewResizeTempScale([0, 0, 0]);
//       setNewResizeCorner(null);
//       setInteractionMode("rotate-shirt");
//     };
//     useFrame(() => {
//       if (!group.current) return;

//       // Update which side is visible based on rotation (only when it changes)
//       const normalizedRotation =
//         ((group.current.rotation.y % (Math.PI * 2)) + Math.PI * 2) %
//         (Math.PI * 2);
//       const isFront =
//         normalizedRotation < Math.PI / 2 ||
//         normalizedRotation > (3 * Math.PI) / 2;

//       // Only update state if visibility changed to avoid unnecessary re-renders
//       if (isFront !== isFrontVisible) {
//         setIsFrontVisible(isFront);
//       }

//       // Don't rotate if a decal is selected or if not in rotate-shirt mode
//       if (selectedDecal || interactionMode !== "rotate-shirt") return;

//       const targetYRotation = snap.viewSide === "front" ? 0 : Math.PI;
//       group.current.rotation.y +=
//         (targetYRotation - group.current.rotation.y) * 0.1;
//     });
//     useEffect(() => {
//       if (resizeMode && selectedDecal && pendingResizeEvent) {
//         handleResizeMove(pendingResizeEvent);
//         setPendingResizeEvent(null);
//       }
//     }, [resizeMode, selectedDecal, pendingResizeEvent]);
//     useEffect(() => {
//       if (resizeMode && selectedDecal && pendingResizeEvent) {
//         handlePointerMove(pendingResizeEvent);
//         setPendingResizeEvent(null);
//       }
//     }, [resizeMode, selectedDecal, pendingResizeEvent]);

//     // NEW RESIZE FEATURE - Ensure full screen event capture
//     useEffect(() => {
//       if (interactionMode === "new-resize-mode") {
//         // Add global event listeners for better event capture
//         const handleGlobalPointerMove = (e) => {
//           if (newResizeActive) {
//             handleNewResizeFunction(e);
//           }
//         };

//         const handleGlobalPointerUp = (e) => {
//           if (newResizeActive) {
//             handlePointerUp(e);
//           }
//         };

//         document.addEventListener("pointermove", handleGlobalPointerMove);
//         document.addEventListener("pointerup", handleGlobalPointerUp);
//         document.addEventListener("mousemove", handleGlobalPointerMove);
//         document.addEventListener("mouseup", handleGlobalPointerUp);
//         document.addEventListener("touchmove", handleGlobalPointerMove);
//         document.addEventListener("touchend", handleGlobalPointerUp);

//         return () => {
//           document.removeEventListener("pointermove", handleGlobalPointerMove);
//           document.removeEventListener("pointerup", handleGlobalPointerUp);
//           document.removeEventListener("mousemove", handleGlobalPointerMove);
//           document.removeEventListener("mouseup", handleGlobalPointerUp);
//           document.removeEventListener("touchmove", handleGlobalPointerMove);
//           document.removeEventListener("touchend", handleGlobalPointerUp);
//         };
//       }
//     }, [interactionMode, newResizeActive]);

//     // ==========================================
//     // START DRAGGING DECAL
//     // ==========================================
//     const handleDecalDragStart = (e, decalType) => {
//       e.stopPropagation();

//       if (rotationRAFRef.current || rotationDirectionRef.current) return;

//       // Access native event for preventDefault
//       const nativeEvent = e.nativeEvent || e;
//       if (nativeEvent && typeof nativeEvent.preventDefault === "function") {
//         nativeEvent.preventDefault();
//       }

//       const getCoords = (event) => {
//         const evt = event.nativeEvent || event;
//         if (evt.touches && evt.touches.length > 0) {
//           return { x: evt.touches[0].clientX, y: evt.touches[0].clientY };
//         }
//         return { x: evt.clientX, y: evt.clientY };
//       };

//       const coords = getCoords(e);
//       const currentPos = decalPositions[decalType] || [0, 0, 0];

//       console.log("🚀 Drag start:", decalType, coords);

//       // Capture pointer to ensure we get all subsequent events
//       const target = e.target || (nativeEvent && nativeEvent.target);
//       const pointerId = e.pointerId || (nativeEvent && nativeEvent.pointerId);
//       if (target && pointerId !== undefined) {
//         try {
//           target.setPointerCapture(pointerId);
//         } catch (err) {
//           console.log("Pointer capture not available");
//         }
//       }

//       setSelectedDecal(decalType);
//       setIsDragging(true);
//       setInteractionMode("dragging");
//       setDragStartPos(coords);
//       setInitialDecalPos([...currentPos]);
//       hasDraggedRef.current = false;
//       dragStartPosRef.current = { ...coords };
//       initialDecalPosRef.current = [...currentPos];
//       lastDragPositionRef.current = [...currentPos];
//       selectedDecalDragRef.current = decalType;
//     };

//     const [isRotating, setIsRotating] = useState(false);
//     const [rotationStartAngle, setRotationStartAngle] = useState(0);
//     const [rotationCenter, setRotationCenter] = useState({ x: 0, y: 0 });

//     // Update cursor during rotation
//     useEffect(() => {
//       if (isRotating) {
//         document.body.style.cursor = "grabbing";
//       }
//       return () => {
//         if (isRotating) {
//           document.body.style.cursor = "auto";
//         }
//       };
//     }, [isRotating]);

//     // const handleDecalRotate = (e, decalType) => {
//     //   // Stop all event propagation FIRST to prevent background click
//     //   if (e?.stopPropagation) e.stopPropagation();
//     //   if (e?.nativeEvent?.stopPropagation) e.nativeEvent.stopPropagation();
//     //   if (e?.nativeEvent?.stopImmediatePropagation)
//     //     e.nativeEvent.stopImmediatePropagation();

//     //   // Prevent default behavior
//     //   const nativeEvent = e.nativeEvent || e;
//     //   if (nativeEvent && typeof nativeEvent.preventDefault === "function") {
//     //     nativeEvent.preventDefault();
//     //   }

//     //   // Record timestamp to prevent background click from deselecting
//     //   const now = Date.now();
//     //   lastOverlayClickTime.current = now;

//     //   const getCoords = (event) => {
//     //     const evt = event.nativeEvent || event;
//     //     if (evt.touches && evt.touches.length > 0) {
//     //       return { x: evt.touches[0].clientX, y: evt.touches[0].clientY };
//     //     }
//     //     return { x: evt.clientX, y: evt.clientY };
//     //   };

//     //   const coords = getCoords(e);

//     //   // Get the decal center position in screen coordinates
//     //   const decalPosition = decalPositions[decalType] || [0, 0, 0];
//     //   const modelKey = state.newKey;
//     //   let modelConfig = modelConfig1[modelKey];

//     //   if (modelKey === "eventordereventjersey" && glbId) {
//     //     modelConfig = modelConfig1[modelKey][glbId] || modelConfig1[modelKey];
//     //   }

//     //   const center3D = new THREE.Vector3(...decalPosition);
//     //   const centerScreen = center3D.clone().project(camera);
//     //   const centerX = (centerScreen.x * 0.5 + 0.5) * window.innerWidth;
//     //   const centerY = (-(centerScreen.y * 0.5) + 0.5) * window.innerHeight;

//     //   // Calculate initial angle from center to mouse
//     //   const initialAngle = Math.atan2(
//     //     coords.y - centerY,
//     //     coords.x - centerX
//     //   );

//     //   // Capture pointer
//     //   const target = e.target || (nativeEvent && nativeEvent.target);
//     //   const pointerId = e.pointerId || (nativeEvent && nativeEvent.pointerId);
//     //   if (target && pointerId !== undefined) {
//     //     try {
//     //       target.setPointerCapture(pointerId);
//     //     } catch (err) {
//     //       console.log("Pointer capture not available");
//     //     }
//     //   }

//     //   setSelectedDecal(decalType);
//     //   setIsRotating(true);
//     //   setInteractionMode("rotating");
//     //   setRotationStartAngle(initialAngle);
//     //   setRotationCenter({ x: centerX, y: centerY });
//     //   setInitialDecalRotation(decalRotations[decalType] || 0);
//     // };

//     // ==========================================
//     // START RESIZING DECAL (CORNER CLICKED)
//     // ==========================================

//     const handleDecalRotate = (e, decalType) => {
//       e.stopPropagation?.();
//       e.nativeEvent?.stopPropagation?.();
//       e.nativeEvent?.stopImmediatePropagation?.();
//       e.preventDefault?.();

//       lastOverlayClickTime.current = Date.now();

//       const getCoords = (event) => {
//         const evt = event.nativeEvent || event;
//         if (evt.touches?.length > 0) {
//           return { x: evt.touches[0].clientX, y: evt.touches[0].clientY };
//         }
//         return { x: evt.clientX, y: evt.clientY };
//       };

//       const startCoords = getCoords(e);
//       const decalPos = decalPositions[decalType] || [0, 0, 0];
//       const center3D = new THREE.Vector3(...decalPos);
//       const centerScreen = center3D.clone().project(camera);
//       const centerX = (centerScreen.x * 0.5 + 0.5) * window.innerWidth;
//       const centerY = (-centerScreen.y * 0.5 + 0.5) * window.innerHeight;
//       const startAngle = Math.atan2(
//         startCoords.y - centerY,
//         startCoords.x - centerX
//       );
//       const startRotation = decalRotations[decalType] || 0;

//       const handleMove = (moveEvent) => {
//         moveEvent.preventDefault();
//         moveEvent.stopPropagation();
//         document.body.style.cursor = "grabbing";

//         const currentCoords = getCoords(moveEvent);
//         const currentAngle = Math.atan2(
//           currentCoords.y - centerY,
//           currentCoords.x - centerX
//         );
//         let angleDelta = currentAngle - startAngle;
//         angleDelta = -angleDelta;
//         const newRotation = startRotation + angleDelta;

//         setDecalRotations((prev) => ({
//           ...prev,
//           [decalType]: newRotation,
//         }));
//       };

//       const handleEnd = () => {
//         document.removeEventListener("mousemove", handleMove);
//         document.removeEventListener("mouseup", handleEnd);
//         document.removeEventListener("touchmove", handleMove);
//         document.removeEventListener("touchend", handleEnd);
//         document.body.style.cursor = "auto";
//         setIsRotating(false);
//         setInteractionMode("idle");
//       };

//       setSelectedDecal(decalType);
//       setIsRotating(true);
//       setInteractionMode("rotating");
//       document.addEventListener("mousemove", handleMove);
//       document.addEventListener("mouseup", handleEnd);
//       document.addEventListener("touchmove", handleMove, { passive: false });
//       document.addEventListener("touchend", handleEnd);
//     };
//     // ==========================================
//     // SMOOTH ROTATION FUNCTIONS (CLOCKWISE/ANTICLOCKWISE)
//     // ==========================================
//     // const rotateTextClockwise = (decalType) => {
//     //   const currentRotation = decalRotations[decalType] || 0;
//     //   const rotationIncrement = (5 * Math.PI) / 180; // 5 degrees in radians
//     //   const newRotation = currentRotation + rotationIncrement;
//     //   setDecalRotations((prev) => ({ ...prev, [decalType]: newRotation }));
//     // };

//     // const rotateTextAnticlockwise = (decalType) => {
//     //   const currentRotation = decalRotations[decalType] || 0;
//     //   const rotationIncrement = (5 * Math.PI) / 180; // 5 degrees in radians
//     //   const newRotation = currentRotation - rotationIncrement;
//     //   setDecalRotations((prev) => ({ ...prev, [decalType]: newRotation }));
//     // };

//     // Angular speed for hold-to-rotate: rad/s (~170 deg/s) – smooth and responsive
//     const ROTATION_SPEED_RAD_PER_SEC = 2.8;

//     const continuousRotationLoop = () => {
//       const info = rotationDirectionRef.current;
//       if (!info) return;
//       const now = performance.now();
//       let dt = (now - rotationLastTimeRef.current) / 1000;
//       rotationLastTimeRef.current = now;
//       if (dt > 0.1) dt = 0.1;
//       const step = ROTATION_SPEED_RAD_PER_SEC * dt * (info.direction === "clockwise" ? 1 : -1);
//       setDecalRotations((prev) => ({
//         ...prev,
//         [info.decalType]: (prev[info.decalType] || 0) + step,
//       }));
//       rotationRAFRef.current = requestAnimationFrame(continuousRotationLoop);
//     };

//     // const startContinuousRotation = (decalType, direction) => {
//     //   stopContinuousRotation();
//     //   rotationDirectionRef.current = { decalType, direction };
//     //   rotationLastTimeRef.current = performance.now();
//     //   if (direction === "clockwise") rotateTextClockwise(decalType);
//     //   else rotateTextAnticlockwise(decalType);
//     //   rotationRAFRef.current = requestAnimationFrame(continuousRotationLoop);
//     // };

//     const stopContinuousRotation = () => {
//       if (rotationRAFRef.current) {
//         cancelAnimationFrame(rotationRAFRef.current);
//         rotationRAFRef.current = null;
//       }
//       if (rotationIntervalRef.current) {
//         clearInterval(rotationIntervalRef.current);
//         rotationIntervalRef.current = null;
//       }
//       rotationDirectionRef.current = null;
//     };

//     const handleCornerDragStart = (e, decalType, corner) => {
//       e.stopPropagation();

//       // Access native event for preventDefault
//       const nativeEvent = e.nativeEvent || e;
//       if (nativeEvent && typeof nativeEvent.preventDefault === "function") {
//         nativeEvent.preventDefault();
//       }

//       const getCoords = (event) => {
//         const evt = event.nativeEvent || event;
//         if (evt.touches && evt.touches.length > 0) {
//           return { x: evt.touches[0].clientX, y: evt.touches[0].clientY };
//         }
//         return { x: evt.clientX, y: evt.clientY };
//       };

//       const coords = getCoords(e);
//       const currentScale = decalScales[decalType] || [1, 1, 1];

//       // Capture pointer to ensure we get all subsequent events
//       const target = e.target || (nativeEvent && nativeEvent.target);
//       const pointerId = e.pointerId || (nativeEvent && nativeEvent.pointerId);
//       if (target && pointerId !== undefined) {
//         try {
//           target.setPointerCapture(pointerId);
//         } catch (err) {
//           console.log("Pointer capture not available");
//         }
//       }

//       setSelectedDecal(decalType);
//       setIsResizing(true);
//       setActiveCorner(corner);
//       setInteractionMode("resizing");
//       setDragStartPos(coords);
//       setInitialDecalScale(
//         Array.isArray(currentScale)
//           ? [...currentScale]
//           : [currentScale, currentScale, currentScale]
//       );
      
//       // Set resize cursor
//       document.body.style.cursor = 'nwse-resize';
//     };

//     // ==========================================
//     // BOUNDARY CONSTRAINT HELPER FUNCTION
//     // ==========================================
//     const getBoundariesForModel = useCallback(() => {
//       const modelKey = state.newKey;

//       // Model-specific boundaries based on actual position ranges from modelConfig1
//       // Z-axis (bottom): increased by 20%, Y-axis: increased by 15% at bottom only (minY for front, maxY for back), top unchanged
//       const modelBoundaries = {
//         eventordereventjersey: {
//           900: {
//             frontText: {
//               minX: -8,
//               maxX: 8,
//               minY: -17.25,
//               maxY: -5,
//               minZ: -15,
//               maxZ: -4,
//             },
//             backText: {
//               minX: -8,
//               maxX: 8,
//               minY: 5,
//               maxY: 17.25,
//               minZ: -15,
//               maxZ: -4,
//             },
//             frontNumber: {
//               minX: -8,
//               maxX: 8,
//               minY: -17.25,
//               maxY: -5,
//               minZ: -5,
//               maxZ: 6,
//             },
//             backNumber: {
//               minX: -8,
//               maxX: 8,
//               minY: 5,
//               maxY: 17.25,
//               minZ: -5,
//               maxZ: 6,
//             },
//             frontLogo: {
//               minX: -2,
//               maxX: 10,
//               minY: -17.25,
//               maxY: -5,
//               minZ: 8,
//               maxZ: 21.6,
//             },
//             backLogo: {
//               minX: -10,
//               maxX: 2,
//               minY: 5,
//               maxY: 17.25,
//               minZ: 8,
//               maxZ: 21.6,
//             },
//           },
//           902: {
//             frontText: {
//               minX: -80,
//               maxX: 80,
//               minY: 68,
//               maxY: 180,
//               minZ: 80,
//               maxZ: 216,
//             },
//             backText: {
//               minX: -80,
//               maxX: 80,
//               minY: -180,
//               maxY: -68,
//               minZ: 80,
//               maxZ: 216,
//             },
//             frontNumber: {
//               minX: -80,
//               maxX: 80,
//               minY: 68,
//               maxY: 180,
//               minZ: -20,
//               maxZ: 96,
//             },
//             backNumber: {
//               minX: -80,
//               maxX: 80,
//               minY: -180,
//               maxY: -68,
//               minZ: -20,
//               maxZ: 96,
//             },
//             frontLogo: {
//               minX: 20,
//               maxX: 100,
//               minY: 51,
//               maxY: 140,
//               minZ: -180,
//               maxZ: -84,
//             },
//             backLogo: {
//               minX: -100,
//               maxX: -20,
//               minY: -180,
//               maxY: -68,
//               minZ: -180,
//               maxZ: -84,
//             },
//           },
//           903: {
//             frontText: {
//               minX: -0.08,
//               maxX: 0.08,
//               minY: 0.017,
//               maxY: 0.08,
//               minZ: 0.05,
//               maxZ: 0.18,
//             },
//             backText: {
//               minX: -0.08,
//               maxX: 0.08,
//               minY: 0.02,
//               maxY: 0.092,
//               minZ: -0.15,
//               maxZ: -0.04,
//             },
//             frontNumber: {
//               minX: -0.08,
//               maxX: 0.08,
//               minY: -0.115,
//               maxY: -0.02,
//               minZ: 0.05,
//               maxZ: 0.18,
//             },
//             backNumber: {
//               minX: -0.08,
//               maxX: 0.08,
//               minY: -0.1,
//               maxY: -0.017,
//               minZ: -0.15,
//               maxZ: -0.04,
//             },
//             frontLogo: {
//               minX: 0.02,
//               maxX: 0.08,
//               minY: 0.068,
//               maxY: 0.16,
//               minZ: 0.05,
//               maxZ: 0.18,
//             },
//             backLogo: {
//               minX: -0.08,
//               maxX: -0.02,
//               minY: 0.08,
//               maxY: 0.1955,
//               minZ: -0.12,
//               maxZ: -0.016,
//             },
//           },
//           904: {
//             frontText: {
//               minX: -80,
//               maxX: 80,
//               minY: 42.5,
//               maxY: 150,
//               minZ: -1250,
//               maxZ: -1010,
//             },
//             backText: {
//               minX: -80,
//               maxX: 80,
//               minY: -150,
//               maxY: -42.5,
//               minZ: -1250,
//               maxZ: -1010,
//             },
//             frontNumber: {
//               minX: -80,
//               maxX: 80,
//               minY: 42.5,
//               maxY: 150,
//               minZ: -1450,
//               maxZ: -1210,
//             },
//             backNumber: {
//               minX: -80,
//               maxX: 80,
//               minY: -150,
//               maxY: -42.5,
//               minZ: -1450,
//               maxZ: -1210,
//             },
//             frontLogo: {
//               minX: 20,
//               maxX: 100,
//               minY: 34,
//               maxY: 120,
//               minZ: -1550,
//               maxZ: -1310,
//             },
//             backLogo: {
//               minX: 20,
//               maxX: 100,
//               minY: -200,
//               maxY: -85,
//               minZ: -1550,
//               maxZ: -1310,
//             },
//           },
//         },
//         menmenjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         menmenxjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         menmenprotshirt: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         menmentanktop: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 18.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 18.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 18.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 18.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 18.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 18.8,
//           },
//         },
//         menmenarmsleeves: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//         },
//         menmensinglet: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//         },
//         menmencyclingjersey: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//         },
//         menmenwinterjersey: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//         },
//         menmenbasketballjersey: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//         },
//         womenwomencyclingjersey: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//         },
//         womenwomenwinterjersey: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backNumber: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 16.8,
//           },
//         },
//         menmenshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmencricketshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmencyclingshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmenrunningshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmenwovenshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmenknittedshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmenfootballshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmensoccershorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmenbasketballshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmennftfootballshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         menmencitycollection: {
//           frontText: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           backText: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           frontNumber: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           backNumber: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           frontLogo: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           backLogo: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//         },
//         menmencricketjersey: {
//           frontText: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -150,
//             maxZ: 200,
//           },
//           backText: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -150,
//             maxZ: 200,
//           },
//           frontNumber: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -150,
//             maxZ: 200,
//           },
//           backNumber: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -150,
//             maxZ: 200,
//           },
//           frontLogo: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -150,
//             maxZ: 200,
//           },
//           backLogo: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -150,
//             maxZ: 200,
//           },
//         },
//         womenwomencitycollection: {
//           frontText: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           backText: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           frontNumber: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           backNumber: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           frontLogo: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//           backLogo: {
//             minX: -150,
//             maxX: 150,
//             minY: -1500,
//             maxY: 200,
//             minZ: -1500,
//             maxZ: -1000,
//           },
//         },
//         menmentrackpants: {
//           frontText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           backText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           frontNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           frontLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//         },
//         menmencompressionpants: {
//           frontText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           backText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           frontNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           frontLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//         },
//         womenwomenbadmintonjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomencricketjersey: {
//           frontText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           backText: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           frontNumber: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           backNumber: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           frontLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//           backLogo: {
//             minX: -15,
//             maxX: 15,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 10.8,
//           },
//         },
//         womenwomentrackpants: {
//           frontText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           backText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           frontNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           frontLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//         },
//         womenwomencrickettrackpants: {
//           frontText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           backText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 25.8,
//           },
//           frontNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backNumber: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           frontLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//           backLogo: {
//             minX: -11,
//             maxX: 11,
//             minY: -23,
//             maxY: 20,
//             minZ: -19,
//             maxZ: 20.8,
//           },
//         },
//         womenwomenxjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.05,
//             maxY: 0.1725,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.05,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.15,
//             maxY: 0.0575,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.12,
//             maxX: 0.12,
//             minY: -0.115,
//             maxY: 0.2,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.12,
//             maxX: 0.12,
//             minY: -0.1,
//             maxY: 0.23,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomenjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.05,
//             maxY: 0.1725,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.05,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.15,
//             maxY: 0.0575,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.12,
//             maxX: 0.12,
//             minY: -0.115,
//             maxY: 0.2,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.12,
//             maxX: 0.12,
//             minY: -0.1,
//             maxY: 0.23,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomenprotshirt: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomenfootballjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomensoccerjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomencompressionpants: {
//           frontText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 45.8,
//           },
//           backText: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 45.8,
//           },
//           frontNumber: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 45.8,
//           },
//           backNumber: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 45.8,
//           },
//           frontLogo: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 45.8,
//           },
//           backLogo: {
//             minX: -12,
//             maxX: 12,
//             minY: -23,
//             maxY: 20,
//             minZ: 10.8,
//             maxZ: 45.8,
//           },
//         },
//         womenwomenbadmintontanktop: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomensinglet: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomenarmsleeves: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.11,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         womenwomenbadmintonshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomencyclingshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomencricketshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomenwovenshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomentightshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomenfootballshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomensoccershorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomennftfootballshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomenbasketballshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         womenwomenknittedshorts: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -8,
//             maxY: 8,
//             minZ: -8,
//             maxZ: 8.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         kidskidsjersey: {
//           frontText: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backText: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//           frontNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backLogo: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//         },
//         kidskidstanktop: {
//           frontText: {
//             minX: -19,
//             maxX: 19,
//             minY: -10,
//             maxY: 10,
//             minZ: -20,
//             maxZ: 25,
//           },
//           backText: {
//             minX: -19,
//             maxX: 19,
//             minY: -10,
//             maxY: 10,
//             minZ: -20,
//             maxZ: 25,
//           },
//           frontNumber: {
//             minX: -19,
//             maxX: 19,
//             minY: -10,
//             maxY: 10,
//             minZ: -20,
//             maxZ: 25,
//           },
//           backNumber: {
//             minX: -19,
//             maxX: 19,
//             minY: -10,
//             maxY: 10,
//             minZ: -20,
//             maxZ: 25,
//           },
//           frontLogo: {
//             minX: -19,
//             maxX: 19,
//             minY: -10,
//             maxY: 10,
//             minZ: -20,
//             maxZ: 25,
//           },
//           backLogo: {
//             minX: -19,
//             maxX: 19,
//             minY: -10,
//             maxY: 10,
//             minZ: -20,
//             maxZ: 25,
//           },
//         },
//         kidskidscyclingjersey: {
//           frontText: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 5,
//             minZ: -8,
//             maxZ: 6,
//           },
//           backText: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
//           frontNumber: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           backNumber: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           frontLogo: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           backLogo: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
//         },
//         kidskidswinterjersey: {
//           frontText: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 5,
//             minZ: -8,
//             maxZ: 6,
//           },
//           backText: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
//           frontNumber: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           backNumber: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           frontLogo: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           backLogo: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
//         },
//         kidskidscitycollection: {
//           frontText: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 5,
//             minZ: -8,
//             maxZ: 6,
//           },
//           backText: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
//           frontNumber: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           backNumber: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           frontLogo: {
//             minX: -4,
//             maxX: 4,
//             minY: -8,
//             maxY: 6,
//             minZ: -8,
//             maxZ: 7,
//           },
//           backLogo: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
//         },
//         kidskidscricketjersey: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -18,
//             maxY: 18,
//             minZ: -18,
//             maxZ: 18,
//           },
//           backText: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//           frontNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backLogo: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//         },
//         kidskidstrackpants: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//         },
//         kidskidsxjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         kidskidsprotshirt: {
//           frontText: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backText: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//           frontNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backLogo: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//         },
//         kidskidscompressionpants: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -8,
//             maxY: 15,
//             minZ: -8,
//             maxZ: 15,
//           },
//         },
//         kidskidssinglet: {
//           frontText: {
//             minX: -10,
//             maxX: 10,
//             minY: -23,
//             maxY: 25,
//             minZ: -18,
//             maxZ: 25.8,
//           },
//           backText: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -18,
//             maxZ: -8.8,
//           },
//           frontNumber: {
//             minX: -10,
//             maxX: 10,
//             minY: -23,
//             maxY: -8,
//             minZ: -5,
//             maxZ: 6,
//           },
//           backNumber: {
//             minX: -10,
//             maxX: 10,
//             minY: 8,
//             maxY: 23,
//             minZ: -5,
//             maxZ: 6,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -23,
//             maxY: -8,
//             minZ: 10,
//             maxZ: 24,
//           },
//           backLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: 8,
//             maxY: 23,
//             minZ: 10,
//             maxZ: 24,
//           },
//         },
//         kidskidsarmsleeves: {
//           frontText: {
//             minX: -6,
//             maxX: 6,
//             minY: -23,
//             maxY: 25,
//             minZ: 30,
//             maxZ: 45.8,
//           },
//           backText: {
//             minX: -6,
//             maxX: 6,
//             minY: -23,
//             maxY: 25,
//             minZ: 30,
//             maxZ: 45.8,
//           },
//           frontNumber: {
//             minX: -6,
//             maxX: 6,
//             minY: -23,
//             maxY: 25,
//             minZ: 30,
//             maxZ: 45.8,
//           },
//           backNumber: {
//             minX: -6,
//             maxX: 6,
//             minY: -23,
//             maxY: 25,
//             minZ: 30,
//             maxZ: 45.8,
//           },
//           frontLogo: {
//             minX: -6,
//             maxX: 6,
//             minY: -23,
//             maxY: 25,
//             minZ: 30,
//             maxZ: 45.8,
//           },
//           backLogo: {
//             minX: -6,
//             maxX: 6,
//             minY: -23,
//             maxY: 25,
//             minZ: 30,
//             maxZ: 45.8,
//           },
//         },
//         kidskidsbasketballjersey: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//         kidskidsfootballjersey: {
//           frontText: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backText: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//           frontNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backLogo: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//         },
//         kidskidssoccerjersey: {
//           frontText: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backText: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//           frontNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backNumber: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           frontLogo: {
//             minX: -5,
//             maxX: 5,
//             minY: -8,
//             maxY: 7,
//             minZ: -8,
//             maxZ: 8,
//           },
//           backLogo: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
//         },
//         kidskidsshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidscricketshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidscyclingshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidswintershorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidsrunningshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidswovenshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidsknittedshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidsbasketballshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidssoccershorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidsfootballshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         kidskidsnftfootballshorts: {
//           frontText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backText: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backNumber: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           frontLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//           backLogo: {
//             minX: -8,
//             maxX: 8,
//             minY: -6,
//             maxY: 5.5,
//             minZ: -6,
//             maxZ: 5.5,
//           },
//         },
//         default: {
//           frontText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.0575,
//             maxY: 0.15,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backText: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.05,
//             maxY: 0.1725,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.1725,
//             maxY: 0.05,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backNumber: {
//             minX: -0.1,
//             maxX: 0.1,
//             minY: -0.15,
//             maxY: 0.0575,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           frontLogo: {
//             minX: -0.12,
//             maxX: 0.12,
//             minY: -0.115,
//             maxY: 0.2,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//           backLogo: {
//             minX: -0.12,
//             maxX: 0.12,
//             minY: -0.1,
//             maxY: 0.23,
//             minZ: -0.15,
//             maxZ: 0.18,
//           },
//         },
//       };

//       // Check if it's an event order with specific glbId
//       if (
//         modelKey === "eventordereventjersey" &&
//         glbId &&
//         modelBoundaries[modelKey][glbId]
//       ) {
//         return modelBoundaries[modelKey][glbId];
//       }

//       // Check if model has specific boundaries
//       if (modelBoundaries[modelKey]) {
//         return modelBoundaries[modelKey];
//       }

//       // Return default boundaries
//       return modelBoundaries.default;
//     }, [glbId]);

//     const applyBoundaryConstraints = useCallback(
//       (position, decalType) => {
//         const boundaries = getBoundariesForModel();
//         const boundary = boundaries[decalType];

//         if (!boundary) {
//           return position; // No boundary defined, return original position
//         }

//         const constrainedPosition = [...position];
//         constrainedPosition[0] = Math.max(
//           boundary.minX,
//           Math.min(boundary.maxX, position[0])
//         );
//         constrainedPosition[1] = Math.max(
//           boundary.minY,
//           Math.min(boundary.maxY, position[1])
//         );
//         constrainedPosition[2] = Math.max(
//           boundary.minZ,
//           Math.min(boundary.maxZ, position[2])
//         );

//         return constrainedPosition;
//       },
//       [getBoundariesForModel]
//     );

//     // HANDLE MOUSE/TOUCH MOVE - OPTIMIZED
//     // ==========================================
//     const rafRef = useRef(null);

//     const handleGlobalMove = useCallback(
//       (e) => {
//         if (interactionMode === "idle") return;

//         const getCoords = (event) => {
//           if (event.touches && event.touches.length > 0) {
//             return { x: event.touches[0].clientX, y: event.touches[0].clientY };
//           }
//           return { x: event.clientX, y: event.clientY };
//         };

//         const coords = getCoords(e);
//         const modelKey = state.newKey;

//         const allowedMovementModels = [
//           "menmenjersey",
//           "menmenxjersey",
//           "kidskidsxjersey",
//           "kidskidsbasketballjersey",
//           "womenwomenbadmintonjersey",
//           "womenwomenprotshirt",
//           "womenwomensinglet",
//           "womenwomenarmsleeves",
//           "womenwomenjersey",
//           "womenwomensoccerjersey",
//           "menmensoccerjersey",
//           "menmenprotshirt",
//           "menmenfootballjersey",
//           "menmencricketjersey",
//           "womenwomenfootballjersey",
//           "womenwomenxjersey",
//           "womenwomenbadmintontanktop",
//         ];

//         const isEventOrderSpecial =
//           modelKey === "eventordereventjersey" &&
//           (glbId === "900" || glbId === "904");

//         const useSpecialMovement =
//           allowedMovementModels.includes(modelKey) || isEventOrderSpecial;
//         const useFirstResizeMethod =
//           allowedMovementModels.includes(modelKey) || isEventOrderSpecial; // ⭐ FIXED: Use same condition

//         if (interactionMode === "dragging" && isDragging && selectedDecal) {
//           const start = dragStartPosRef.current;
//           const initial = initialDecalPosRef.current;
//           const deltaX = coords.x - start.x;
//           const deltaY = coords.y - start.y;

//           const movement = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
//           if (movement > 3) hasDraggedRef.current = true;

//           let newPosition;

//           if (modelKey === "menmencricketjersey") {
//             const normalSensitivityX = 2.4;
//             const normalSensitivityZ = 2.8;
//             const isBackSide = selectedDecal.includes("back");
//             const finalDeltaX = isBackSide ? -deltaX : deltaX;
//             const newX = initial[0] + finalDeltaX * normalSensitivityX;
//             const newZ = initial[1] + deltaY * normalSensitivityZ;
//             newPosition = [newX, initial[1], newZ];
//           } else if (useSpecialMovement) {
//             const sensitivity = 0.0015;
//             const isBackSide = selectedDecal.includes("back");
//             const newX = initial[0] + (isBackSide ? -deltaX : deltaX) * sensitivity;
//             const newY = initial[1] - deltaY * sensitivity;
//             newPosition = [newX, newY, initial[2]];
//           } else if (
//             modelKey === "menmencitycollection" ||
//             modelKey === "womenwomencitycollection"
//           ) {
//             const normalSensitivityX = 1.4;
//             const normalSensitivityZ = 1.8;
//             const isBackSide = selectedDecal.includes("back");
//             const finalDeltaX = isBackSide ? -deltaX : deltaX;
//             const newX = initial[0] + finalDeltaX * normalSensitivityX;
//             const newZ = initial[2] + deltaY * normalSensitivityZ;
//             newPosition = [newX, initial[1], newZ];
//           } else {
//             const normalSensitivityX = 0.09;
//             const normalSensitivityZ = 0.2;
//             const isBackSide = selectedDecal.includes("back");
//             const finalDeltaX = isBackSide ? -deltaX : deltaX;
//             const newX = initial[0] + finalDeltaX * normalSensitivityX;
//             const newZ = initial[2] - deltaY * normalSensitivityZ;
//             newPosition = [newX, initial[1], newZ];
//           }

//           newPosition = applyBoundaryConstraints(newPosition, selectedDecal);
//           lastDragPositionRef.current = newPosition;
//           selectedDecalDragRef.current = selectedDecal;
//           setTempPosition(newPosition);
//           setDecalPositions((prev) => ({ ...prev, [selectedDecal]: newPosition }));
//         }

//         if (
//           interactionMode === "resizing" &&
//           isResizing &&
//           selectedDecal &&
//           activeCorner
//         ) {
//           requestAnimationFrame(() => {
//             const deltaX = coords.x - dragStartPos.x;
//             const deltaY = coords.y - dragStartPos.y;
//             let adjustedDeltaX = deltaX;
//             let adjustedDeltaY = deltaY;

//             const sensitivity = selectedDecal.includes("Logo") ? 0.005 : 0.003;

//             let newScale;

//             if (modelKey === "menmencricketjersey") {
//               const cricketSensitivity = selectedDecal.includes("Logo") ? 5 : 4;
//               newScale = [...initialDecalScale];

//               switch (activeCorner) {
//                 case "tl":
//                   newScale[0] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[0] - adjustedDeltaX * cricketSensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[1] - adjustedDeltaY * cricketSensitivity
//                     )
//                   );
//                   break;
//                 case "tr":
//                   newScale[0] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[0] + adjustedDeltaX * cricketSensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[1] - adjustedDeltaY * cricketSensitivity
//                     )
//                   );
//                   break;
//                 case "bl":
//                   newScale[0] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[0] - adjustedDeltaX * cricketSensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[1] + adjustedDeltaY * cricketSensitivity
//                     )
//                   );
//                   break;
//                 case "br":
//                   newScale[0] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[0] + adjustedDeltaX * cricketSensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     100,
//                     Math.min(
//                       2000,
//                       initialDecalScale[1] + adjustedDeltaY * cricketSensitivity
//                     )
//                   );
//                   break;
//                 default:
//                   newScale = initialDecalScale;
//                   break;
//               }
//               console.log("Cricket Jersey Resize - New Scale:", newScale);
//             } else if (useFirstResizeMethod) {
//               // ⭐ NOW THIS USES THE SAME MODELS LIST
//               newScale = [...initialDecalScale];
//               switch (activeCorner) {
//                 case "tl":
//                   newScale[0] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[0] - adjustedDeltaX * sensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[1] - adjustedDeltaY * sensitivity
//                     )
//                   );
//                   break;
//                 case "tr":
//                   newScale[0] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[0] + adjustedDeltaX * sensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[1] - adjustedDeltaY * sensitivity
//                     )
//                   );
//                   break;
//                 case "bl":
//                   newScale[0] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[0] - adjustedDeltaX * sensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[1] + adjustedDeltaY * sensitivity
//                     )
//                   );
//                   break;
//                 case "br":
//                   newScale[0] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[0] + adjustedDeltaX * sensitivity
//                     )
//                   );
//                   newScale[1] = Math.max(
//                     0.05,
//                     Math.min(
//                       8,
//                       initialDecalScale[1] + adjustedDeltaY * sensitivity
//                     )
//                   );
//                   break;
//                 default:
//                   newScale = initialDecalScale;
//                   break;
//               }
//             } else if (
//               modelKey === "menmencitycollection" ||
//               modelKey === "womenwomencitycollection"
//             ) {
//               const diagonalDelta = Math.sqrt(
//                 adjustedDeltaX * adjustedDeltaX +
//                   adjustedDeltaY * adjustedDeltaY
//               );

//               // Double the sensitivity for faster scaling
//               const fasterSensitivity = sensitivity * 3;

//               let scaleFactor = 1;
//               switch (activeCorner) {
//                 case "tl":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX < 0 && adjustedDeltaY < 0
//                       ? -diagonalDelta
//                       : diagonalDelta) *
//                       fasterSensitivity;
//                   break;
//                 case "tr":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX > 0 && adjustedDeltaY < 0
//                       ? -diagonalDelta
//                       : diagonalDelta) *
//                       fasterSensitivity;
//                   break;
//                 case "bl":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX < 0 && adjustedDeltaY > 0
//                       ? -diagonalDelta
//                       : diagonalDelta) *
//                       fasterSensitivity;
//                   break;
//                 case "br":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX > 0 && adjustedDeltaY > 0
//                       ? diagonalDelta
//                       : -diagonalDelta) *
//                       fasterSensitivity;
//                   break;
//               }
//               newScale = initialDecalScale.map((s) =>
//                 Math.max(265, Math.min(1200, s * scaleFactor))
//               );
//             } else {
//               const diagonalDelta = Math.sqrt(
//                 adjustedDeltaX * adjustedDeltaX +
//                   adjustedDeltaY * adjustedDeltaY
//               );
//               let scaleFactor = 1;
//               switch (activeCorner) {
//                 case "tl":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX < 0 && adjustedDeltaY < 0
//                       ? -diagonalDelta
//                       : diagonalDelta) *
//                       sensitivity;
//                   break;
//                 case "tr":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX > 0 && adjustedDeltaY < 0
//                       ? -diagonalDelta
//                       : diagonalDelta) *
//                       sensitivity;
//                   break;
//                 case "bl":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX < 0 && adjustedDeltaY > 0
//                       ? -diagonalDelta
//                       : diagonalDelta) *
//                       sensitivity;
//                   break;
//                 case "br":
//                   scaleFactor =
//                     1 +
//                     (adjustedDeltaX > 0 && adjustedDeltaY > 0
//                       ? diagonalDelta
//                       : -diagonalDelta) *
//                       sensitivity;
//                   break;
//               }
//               newScale = initialDecalScale.map((s) =>
//                 Math.max(5, Math.min(300, s * scaleFactor))
//               );
//             }

//             setTempScale(newScale);
//             setDecalScales((prev) => ({
//               ...prev,
//               [selectedDecal]: newScale,
//             }));

//             if (selectedDecal.includes("front")) {
//               frontLogoScale[0] = newScale[0];
//               frontLogoScale[1] = newScale[1];
//             } else if (selectedDecal.includes("back")) {
//               backLogoScale[0] = newScale[0];
//               backLogoScale[1] = newScale[1];
//             }
//           });
//         }
//       },
//       [
//         interactionMode,
//         isDragging,
//         isResizing,
//         selectedDecal,
//         activeCorner,
//         dragStartPos,
//         initialDecalPos,
//         initialDecalScale,
//         state.newKey,
//         glbId,
//       ]
//     );

//     // ==========================================
//     // HANDLE MOUSE/TOUCH UP
//     // ==========================================
//     const handleGlobalUp = () => {
//       if (isDragging) {
//         const decal = selectedDecalDragRef.current;
//         const last = lastDragPositionRef.current;
//         if (decal && last && last.length === 3) {
//           const pos = [...last];
//           setDecalPositions((prev) => ({ ...prev, [decal]: pos }));
//           setTempPosition(pos);
//         }
//         selectedDecalDragRef.current = null;
//         setIsDragging(false);
//         hasDraggedRef.current = false;
//       }

//       if (isResizing) {
//         setIsResizing(false);
//         setActiveCorner(null);
//         document.body.style.cursor = "auto";
//       }

//       stopContinuousRotation();
//       setInteractionMode("idle");
//     };

//     // ==========================================
//     // ATTACH GLOBAL EVENT LISTENERS
//     // ==========================================
//     useEffect(() => {
//       if (interactionMode === "dragging" || interactionMode === "resizing") {
//         const handleMove = (e) => {
//           e.preventDefault();
//           handleGlobalMove(e);
//         };

//         const handleUp = (e) => {
//           handleGlobalUp(e);
//         };

//         document.addEventListener("mousemove", handleMove);
//         document.addEventListener("mouseup", handleUp);
//         document.addEventListener("touchmove", handleMove, { passive: false });
//         document.addEventListener("touchend", handleUp);

//         return () => {
//           document.removeEventListener("mousemove", handleMove);
//           document.removeEventListener("mouseup", handleUp);
//           document.removeEventListener("touchmove", handleMove);
//           document.removeEventListener("touchend", handleUp);
//         };
//       }
//     }, [
//       interactionMode,
//       isDragging,
//       isResizing,
//       selectedDecal,
//       dragStartPos,
//       initialDecalPos,
//       initialDecalScale,
//       activeCorner,
//     ]);

//     const handleResizeMove = (e) => {
//       if (!resizeMode || !selectedDecal || !initialScale) return;

//       // Get coordinates from either mouse or touch event
//       const getEventCoords = (event) => {
//         if (event.touches && event.touches.length > 0) {
//           return { x: event.touches[0].clientX, y: event.touches[0].clientY };
//         }
//         return { x: event.clientX, y: event.clientY };
//       };

//       const coords = getEventCoords(e);
//       const deltaX = coords.x - resizeStartPos.x;
//       const deltaY = coords.y - resizeStartPos.y;

//       // Calculate scale change based on diagonal movement for corner resize
//       const delta =
//         Math.sqrt(deltaX * deltaX + deltaY * deltaY) *
//         (deltaX + deltaY > 0 ? 1 : -1);
//       const scaleFactor = 1 + delta * 0.003;

//       const newScale = [
//         Math.max(0.1, Math.min(3, initialScale[0] * scaleFactor)),
//         Math.max(0.1, Math.min(3, initialScale[1] * scaleFactor)),
//         initialScale[2],
//       ];

//       setDecalScales((prev) => ({
//         ...prev,
//         [selectedDecal]: newScale,
//       }));

//       setTempScale(newScale);
//     };

//     const handleResizeUp = () => {
//       if (resizeMode && selectedDecal && tempScale) {
//         // Save the final scale
//         setDecalScales((prev) => ({
//           ...prev,
//           [selectedDecal]: tempScale,
//         }));
//       }

//       setResizeMode(false);
//       setResizeCorner(null);
//       setInitialScale(null);
//       setTempScale([0, 0, 0]);
//       setInteractionMode("rotate-shirt");
//       setSelectedDecal(null);
//     };

//     // Mobile detection helper function
//     const isMobileDevice = () => {
//       return (
//         window.innerWidth <= 768 ||
//         /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
//           navigator.userAgent
//         )
//       );
//     };

//     const handlePointerMove = (e) => {
//       // Prevent default touch behavior to avoid page scrolling during drag
//       if (e.type === "touchmove") {
//         e.preventDefault();
//       }

//       // Only block pointer move when TransformControls is actively being used
//       if (interactionMode === "transform-controls") {
//         return;
//       }

//       // Better detection for active dragging
//       const isMouseDown = e.buttons === 1;
//       const isTouchMove =
//         e.type === "touchmove" && e.touches && e.touches.length > 0;
//       const isPointerMove = e.type === "pointermove" && e.pressure > 0;

//       if (!isMouseDown && !isTouchMove && !isPointerMove) return;

//       const getEventCoords = (event) => {
//         // Touch events
//         if (event.touches && event.touches.length > 0) {
//           return { x: event.touches[0].clientX, y: event.touches[0].clientY };
//         }
//         // Pointer events (including touch on some devices)
//         if (event.clientX !== undefined && event.clientY !== undefined) {
//           return { x: event.clientX, y: event.clientY };
//         }
//         return { x: 0, y: 0 };
//       };

//       const coords = getEventCoords(e);

//       // NEW RESIZE FEATURE - Handle new resize mode
//       if (interactionMode === "new-resize-mode") {
//         handleNewResizeFunction(e);
//         return;
//       }

//       if (interactionMode === "resize-decal") {
//         handleResizeMove(e);
//         return;
//       }

//       // Handle rotation mode
//       if (interactionMode === "rotating" && isRotating && selectedDecal) {
//         const currentAngle = Math.atan2(
//           coords.y - rotationCenter.y,
//           coords.x - rotationCenter.x
//         );

//         // Calculate rotation delta
//         const angleDelta = currentAngle - rotationStartAngle;

//         // Apply rotation (adding the delta to initial rotation)
//         let newRotation = initialDecalRotation + angleDelta;

//         // Normalize to 0-2π range
//         while (newRotation < 0) newRotation += Math.PI * 2;
//         while (newRotation >= Math.PI * 2) newRotation -= Math.PI * 2;

//         setDecalRotations((prev) => ({
//           ...prev,
//           [selectedDecal]: newRotation,
//         }));
//         return;
//       }

//       if (interactionMode === "move-decal" && selectedDecal) {
//         // Get model-specific movement sensitivity
//         const modelKey = state.newKey;
//         let modelConfig = modelConfig1[modelKey];

//         // SPECIAL HANDLING for eventordereventjersey
//         if (modelKey === "eventordereventjersey" && glbId) {
//           modelConfig = modelConfig1[modelKey][glbId] || modelConfig1[modelKey];
//         }

//         // Base sensitivity values
//         let sensitivityX = selectedDecal.includes("Logo") ? 0.001 : 0.0008;
//         let sensitivityY = selectedDecal.includes("Logo") ? 0.001 : 0.0008;

//         // INCREASED sensitivity for touch devices (mobile)
//         if (e.type === "touchmove" || e.pointerType === "touch") {
//           sensitivityX *= 2.5; // Increased from 1.5 to 2.5
//           sensitivityY *= 2.5;
//         }

//         // Additional mobile-specific boost for better responsiveness
//         if (isMobileDevice()) {
//           sensitivityX *= 1.5;
//           sensitivityY *= 1.5;
//         }

//         if (modelConfig) {
//           const scale = modelConfig.scale;
//           const overallScale = modelConfig.overallScale || 1;
//           const scaleFactor = Array.isArray(scale) ? scale[0] || 1 : scale || 1;

//           let adjustedFactor = 1;

//           if (
//             modelKey === "menmenjersey" ||
//             (modelKey === "eventordereventjersey" && glbId === "902")
//           ) {
//             adjustedFactor = Math.min(
//               3,
//               Math.max(0.5, scaleFactor / overallScale)
//             );
//           } else if (
//             modelKey === "eventordereventjersey" &&
//             (glbId === "900" || glbId === "904")
//           ) {
//             if (scaleFactor < 0.01) {
//               adjustedFactor = Math.min(20, Math.max(5, 1 / scaleFactor));
//             } else if (scaleFactor < 1) {
//               adjustedFactor = Math.min(10, Math.max(2, 1 / scaleFactor));
//             } else {
//               adjustedFactor = Math.min(
//                 5,
//                 Math.max(0.2, scaleFactor / overallScale)
//               );
//             }
//           } else if (modelKey === "womenwomenfootballjersey") {
//             adjustedFactor = Math.min(
//               3,
//               Math.max(0.5, scaleFactor / overallScale)
//             );
//           } else if (
//             modelKey === "menmenxjersey" ||
//             (modelKey === "eventordereventjersey" && glbId === "903")
//           ) {
//             adjustedFactor = Math.min(
//               3,
//               Math.max(0.5, scaleFactor / overallScale)
//             );
//           } else if (modelKey === "womenwomenbadmintontanktop") {
//             adjustedFactor = Math.min(
//               4,
//               Math.max(0.8, scaleFactor / overallScale)
//             );
//           } else if (scaleFactor < 0.01) {
//             adjustedFactor = Math.min(15, Math.max(3, 1 / scaleFactor));
//           } else if (scaleFactor < 0.1) {
//             adjustedFactor = Math.min(10, Math.max(2, 1 / scaleFactor));
//           } else {
//             adjustedFactor = Math.min(
//               5,
//               Math.max(0.2, scaleFactor / overallScale)
//             );
//           }

//           sensitivityX *= adjustedFactor;
//           sensitivityY *= adjustedFactor;
//         }

//         let deltaX = (coords.x - mouseStartPos.x) * sensitivityX;
//         let deltaY = -(coords.y - mouseStartPos.y) * sensitivityY;

//         let maxDelta = 0.1;
//         if (
//           modelKey === "eventordereventjersey" &&
//           (glbId === "900" || glbId === "902" || glbId === "904")
//         ) {
//           maxDelta = 0.5;
//         } else if (
//           modelKey === "menmenjersey" ||
//           modelKey === "womenwomenfootballjersey" ||
//           modelKey === "menmenxjersey"
//         ) {
//           maxDelta = 0.2;
//         } else if (modelKey === "womenwomenbadmintontanktop") {
//           maxDelta = 0.15;
//         }

//         deltaX = Math.max(-maxDelta, Math.min(maxDelta, deltaX));
//         deltaY = Math.max(-maxDelta, Math.min(maxDelta, deltaY));

//         const isBackSide = ["backText", "backNumber", "backLogo"].includes(
//           selectedDecal
//         );
//         if (isBackSide) {
//           deltaX *= -1;
//         }

//         let positionArray;
//         switch (selectedDecal) {
//           case "frontText":
//             positionArray = frontTextPosition;
//             break;
//           case "backText":
//             positionArray = backTextPosition;
//             break;
//           case "frontNumber":
//             positionArray = frontNumberPosition;
//             break;
//           case "backNumber":
//             positionArray = backNumberPosition;
//             break;
//           case "frontLogo":
//             positionArray = frontLogoPosition;
//             break;
//           case "backLogo":
//             positionArray = backLogoPosition;
//             break;
//           default:
//             return;
//         }

//         const modelRotation = modelConfig?.rotation || [0, 0, 0];

//         if (Math.abs(modelRotation[0]) > 1) {
//           positionArray[0] += deltaX;
//           positionArray[2] += deltaY;
//         } else {
//           positionArray[0] += deltaX;
//           positionArray[1] += deltaY;
//         }

//         // Apply boundary constraints using shared helper function
//         const constrainedPosition = applyBoundaryConstraints(
//           [...positionArray],
//           selectedDecal
//         );
//         positionArray[0] = constrainedPosition[0];
//         positionArray[1] = constrainedPosition[1];
//         positionArray[2] = constrainedPosition[2];

//         setTempPosition([...positionArray]);
//         setMouseStartPos(coords);
//         setWasMoved(true); // Track that movement occurred
//       }
//     };
//     const [wasMoved, setWasMoved] = useState(false);

//     const handlePointerUp = () => {
//       if (interactionMode === "transform-controls") {
//         // Don't deselect - keep the decal selected for transform controls
//         setInteractionMode("rotate-shirt");
//         setIsTransforming(false);
//         return;
//       }

//       if (interactionMode === "new-resize-mode") {
//         endNewResize();
//         return;
//       }

//       if (resizeMode && selectedDecal) {
//         setResizeMode(false);
//         setResizeCorner(null);
//         setInitialScale(null);
//         setInteractionMode("rotate-shirt");
//         // Keep decal selected after resize
//         return;
//       }

//       // Handle rotation end
//       if (interactionMode === "rotating" && isRotating && selectedDecal) {
//         setIsRotating(false);
//         setInteractionMode("idle");
//         // Keep decal selected after rotation
//         return;
//       }

//       if (interactionMode === "move-decal" && selectedDecal) {
//         setDecalPositions((prev) => ({
//           ...prev,
//           [selectedDecal]: tempPosition,
//         }));

//         setInteractionMode("rotate-shirt");
//         setWasMoved(false);
//         // Keep decal selected after move (don't deselect)
//       }
//     };

//     const renderResizeArrow = () => {
//       return null;
//     };

//     const getTransformTarget = useCallback(
//       (type, position, rotation, scale) => {
//         const existing = transformTargetsRef.current[type];
//         const target = existing || new THREE.Object3D();

//         target.position.set(position[0], position[1], position[2]);
//         target.rotation.set(rotation[0], rotation[1], rotation[2]);

//         const targetScale = Array.isArray(scale)
//           ? scale
//           : [scale || 1, scale || 1, scale || 1];

//         target.scale.set(
//           targetScale[0] || 1,
//           targetScale[1] || 1,
//           targetScale[2] || 1
//         );

//         transformTargetsRef.current[type] = target;
//         return target;
//       },
//       []
//     );

//     const isDecalFacingCamera = useCallback(
//       (e) => {
//         if (!e?.point || !e?.face || !e?.object || !camera) return true;
//         const normal = new THREE.Vector3();
//         normal.copy(e.face.normal).transformDirection(e.object.matrixWorld);
//         const toCamera = new THREE.Vector3()
//           .subVectors(camera.position, e.point)
//           .normalize();
//         return normal.dot(toCamera) > 0.1;
//       },
//       [camera]
//     );

//     const mobileScaleFactor = isMobile ? 0.75 : 1.0;
//     const mobilePositionOffset = isMobile ? [0, 0.06, 0] : [0, 0, 0];

//     const renderDecal = (
//       type,
//       defaultTexture,
//       defaultPosition,
//       rotation,
//       defaultScale
//     ) => {
//       console.log(`🔍 renderDecal called for ${type}`);
//       console.log(`   productData:`, productData);
//       console.log(`   ${type} value:`, productData?.[type]);
//       console.log(`   should display:`, !!productData?.[type]);
//       const isSelected = selectedDecal === type;
//       const isTextDecal = type.toLowerCase().includes("text");
//       const isNumberDecal = type.toLowerCase().includes("number");

//       // Check if currently dragging this specific decal
//       const isCurrentlyDragging =
//         isSelected && interactionMode === "dragging" && isDragging;

//       // Fix: Use tempPosition when selected and dragging for smooth real-time updates
//       let position =
//         isCurrentlyDragging && tempPosition && tempPosition.length === 3
//           ? tempPosition
//           : decalPositions[type] || defaultPosition;

//       // Pull text/number decals slightly toward t-shirt surface to reduce gap (fabric.js)
//       const displayPosition =
//         isTextDecal || isNumberDecal
//           ? [position[0], position[1], position[2] - 0.0004]
//           : position;

//       let scale;
//       // Check if currently resizing this specific decal
//       const isCurrentlyResizing =
//         isSelected && interactionMode === "resizing" && isResizing;

//       if (
//         isCurrentlyResizing &&
//         tempScale &&
//         tempScale.length === 3 &&
//         tempScale[0] !== 0
//       ) {
//         // Use tempScale for real-time resize feedback for all decal types including text
//         scale = tempScale;
//       } else if (isTextDecal || isNumberDecal) {
//         scale = decalScales[type] || defaultScale;
//       } else if (
//         interactionMode === "new-resize-mode" &&
//         newResizeSelectedDecal === type &&
//         newResizeTempScale &&
//         newResizeTempScale.length === 3 &&
//         newResizeTempScale[0] !== 0
//       ) {
//         scale = newResizeTempScale;
//       } else if (
//         isSelected &&
//         resizeMode &&
//         tempScale &&
//         tempScale.length === 3 &&
//         tempScale[0] !== 0
//       ) {
//         scale = tempScale;
//       } else {
//         scale = decalScales[type] || defaultScale;
//       }

//       let shouldDisplay = false;
//       let texture = null;

//       // Use productData instead of snap!
//       if (type.includes("Text")) {
//         const textValue = productData?.[type] || ""; // e.g., productData.frontText
//         shouldDisplay = !!textValue && textValue.trim() !== "";

//         if (shouldDisplay) {
//           texture = getTextTexture(
//             type,
//             textValue,
//             // Use productData.textColors instead of snap.textColors
//             productData?.textColors?.[
//               type.includes("front") ? "front" : "back"
//             ] || "#ffffff",
//             // Use productData.textFonts instead of state.textFonts
//             productData?.textFonts?.[
//               type.includes("front") ? "front" : "back"
//             ] ||
//               productData?.selectedFonts ||
//               "Arial",
//             isSelected
//           );
//         }
//       } else if (type.includes("Number")) {
//         const numberValue = productData?.[type] || ""; // e.g., productData.frontNumber
//         shouldDisplay = !!numberValue && numberValue.trim() !== "";

//         if (shouldDisplay) {
//           texture = getNumberTexture(
//             type,
//             numberValue,
//             // Use productData.numberColors instead of snap.numberColors
//             productData?.numberColors?.[
//               type.includes("front") ? "front" : "back"
//             ] || "#ffffff",
//             // Use productData.numberFonts instead of state.numberFonts
//             productData?.numberFonts?.[
//               type.includes("front") ? "front" : "back"
//             ] ||
//               productData?.selectedFonts ||
//               "Arial",
//             isSelected
//           );
//         }
//       } else if (type.includes("Logo")) {
//         const logoTex = type === "frontLogo" ? logoTexture : logoTextureBack;
//         shouldDisplay = !!logoTex;
//         texture = logoTex;
//       }

//       if (!shouldDisplay || !texture) return null;

//       // CRITICAL FIX: Show selection UI for ALL models, not just menmenjersey
//       const shouldShowDots = isSelected;

//       let adjustedScale = getAspectAwareScale(type, scale, texture);

//       // Get model-specific configuration
//       const modelKey = state.newKey;
//       const modelConfig = getModelSettings(menuSlug, subcategorySlug);

//       let selectionScaleMultiplier = 1;
//       let frameWidthMultiplier = 1;
//       let frameHeightMultiplier = 1;
//       let cornerSizeMultiplier = 1;
//       let showFullBorder = false;

//       if (modelKey === "menmenjersey") {
//         selectionScaleMultiplier = 1;
//         frameWidthMultiplier = 1;
//         frameHeightMultiplier = 1;
//         showFullBorder = true;
//       } else if (
//         modelKey === "menmentrackpants" ||
//         modelKey === "womenwomentrackpants"
//       ) {
//         selectionScaleMultiplier = 20;
//         frameWidthMultiplier = 0.8;
//         frameHeightMultiplier = 0.8;
//       } else if (
//         modelKey === "kidskidscricketshorts" ||
//         modelKey === "kidskidsshorts" ||
//         modelKey === "kidskidscyclingshorts" ||
//         modelKey === "kidskidswintershorts" ||
//         modelKey === "kidskidsrunningshorts" ||
//         modelKey === "kidskidswovenshorts" ||
//         modelKey === "kidskidsknittedshorts" ||
//         modelKey === "kidskidsbasketballshorts" ||
//         modelKey === "kidskidssoccershorts" ||
//         modelKey === "kidskidsfootballshorts" ||
//         modelKey === "kidskidsnftfootballshorts"
//       ) {
//         selectionScaleMultiplier = 1;
//         frameWidthMultiplier = 1;
//         frameHeightMultiplier = 1;
//         showFullBorder = true;
//       } else if (modelKey.includes("shorts")) {
//         selectionScaleMultiplier = 1;
//         frameWidthMultiplier = 1;
//         frameHeightMultiplier = 1;
//         showFullBorder = true;
//       } else if (
//         modelKey === "menmentanktop" ||
//         modelKey === "menmenarmsleeves" ||
//         modelKey === "menmensinglet"
//       ) {
//         selectionScaleMultiplier = 1; // Fixed from 20 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (
//         modelKey === "menmencyclingjersey" ||
//         modelKey === "menmenwinterjersey" ||
//         modelKey === "menmenbasketballjersey" ||
//         modelKey === "womenwomencyclingjersey" ||
//         modelKey === "womenwomenwinterjersey"
//       ) {
//         selectionScaleMultiplier = 1; // Fixed from 20 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (
//         modelKey === "menmencitycollection" ||
//         modelKey === "womenwomencitycollection"
//       ) {
//         selectionScaleMultiplier = 1; // Fixed from 150 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (modelKey === "womenwomencricketjersey") {
//         selectionScaleMultiplier = 1; // Fixed from 15 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (
//         modelKey === "kidskidsjersey" ||
//         modelKey === "kidskidsprotshirt" ||
//         modelKey === "kidskidsfootballjersey" ||
//         modelKey === "kidskidssoccerjersey"
//       ) {
//         selectionScaleMultiplier = 1; // Fixed from 3 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (
//         modelKey === "kidskidstanktop" ||
//         modelKey === "kidskidssinglet"
//       ) {
//         selectionScaleMultiplier = 1; // Fixed from 15 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (
//         modelKey === "kidskidscyclingjersey" ||
//         modelKey === "kidskidswinterjersey" ||
//         modelKey === "kidskidscitycollection"
//       ) {
//         selectionScaleMultiplier = 1; // Fixed from 5 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (modelKey === "kidskidscricketjersey") {
//         selectionScaleMultiplier = 1; // Fixed from 15 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (modelKey === "kidskidsxjersey") {
//         selectionScaleMultiplier = 1; // Fixed from 0.2 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (modelKey === "kidskidsarmsleeves") {
//         selectionScaleMultiplier = 1; // Fixed from 5 to 1
//         frameWidthMultiplier = 1; // Fixed from 24 to 1
//         frameHeightMultiplier = 1; // Fixed from 25 to 1
//         showFullBorder = true;
//       } else if (
//         modelKey === "menmencompressionpants" ||
//         modelKey === "womenwomencompressionpants" ||
//         modelKey === "kidskidstrackpants" ||
//         modelKey === "kidskidscompressionpants"
//       ) {
//         selectionScaleMultiplier = 20;
//         frameWidthMultiplier = 0.8;
//         frameHeightMultiplier = 0.8;
//         showFullBorder = true;
//       } else {
//         selectionScaleMultiplier = 1;
//         frameWidthMultiplier = 1;
//         frameHeightMultiplier = 1;
//         showFullBorder = true;
//       }

//       let baseSelectionWidth, baseSelectionHeight;
//       if (modelKey === "menmenjersey") {
//         const minSelectionSize = 0.05;
//         const maxSelectionSize = 1.5;

//         baseSelectionWidth = Math.min(
//           Math.max(adjustedScale?.[0] || 0.2, minSelectionSize),
//           maxSelectionSize
//         );

//         baseSelectionHeight = Math.min(
//           Math.max(adjustedScale?.[1] || 0.2, minSelectionSize),
//           maxSelectionSize
//         );
//       } else {
//         // For all other models - use simplified logic without clamping
//         baseSelectionWidth = (adjustedScale?.[0] || 0.2) * frameWidthMultiplier;
//         baseSelectionHeight =
//           (adjustedScale?.[1] || 0.2) * frameHeightMultiplier;
//       }

//       console.log("Base Selection Width:", baseSelectionWidth);
//       console.log("Base Selection Height:", baseSelectionHeight);

//       // Tighter selection for text to fit closer to actual text bounds
//       // Tighter selection for text to fit closer to actual text bounds
//       let selectionTightness;

//       if (
//         modelKey === "menmenjersey" ||
//         modelKey === "menmenxjersey" ||
//         modelKey === "menmenprotshirt" ||
//         modelKey === "menmenfootballjersey" ||
//         modelKey === "menmensoccerjersey"
//       ) {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.73
//           : type.includes("Text")
//           ? 0.58
//           : 0.48;
//       } else if (
//         modelKey === "menmencyclingjersey" ||
//         modelKey === "menmenwinterjersey"
//       ) {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.5
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "menmencitycollection" ||
//         modelKey === "menmencricketjersey"
//       ) {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.3
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "menmentrackpants" ||
//         modelKey === "menmenshorts" ||
//         modelKey === "menmencricketshorts" ||
//         modelKey === "menmencyclingshorts" ||
//         modelKey === "menmenrunningshorts" ||
//         modelKey === "menmenwovenshorts" ||
//         modelKey === "menmenknittedshorts" ||
//         modelKey === "menmenfootballshorts" ||
//         modelKey === "menmensoccershorts" ||
//         modelKey === "menmenbasketballshorts" ||
//         modelKey === "menmennftfootballshorts"
//       ) {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.3
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (modelKey === "menmenarmsleeves") {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.5
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (modelKey === "menmenbasketballjersey") {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.5
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (modelKey === "menmencompressionpants") {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.15
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "womenwomenbadmintonjersey" ||
//         modelKey === "womenwomenprotshirt" ||
//         modelKey === "womenwomenfootballjersey" ||
//         modelKey === "womenwomensoccerjersey"
//       ) {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.12
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (modelKey === "womenwomencricketjersey") {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.12
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "womenwomencyclingjersey" ||
//         modelKey === "womenwomenwinterjersey"
//       ) {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.5
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "womenwomenxjersey" ||
//         modelKey === "womenwomenjersey"
//       ) {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.12
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "womenwomenbadmintonshorts" ||
//         modelKey === "womenwomencyclingshorts" ||
//         modelKey === "womenwomencricketshorts" ||
//         modelKey === "womenwomenwovenshorts" ||
//         modelKey === "womenwomentightshorts" ||
//         modelKey === "womenwomenfootballshorts" ||
//         modelKey === "womenwomensoccershorts" ||
//         modelKey === "womenwomennftfootballshorts" ||
//         modelKey === "womenwomenbasketballshorts" ||
//         modelKey === "womenwomenknittedshorts"
//       ) {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.2
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "womenwomencompressionpants" ||
//         modelKey === "womenwomentrackpants" ||
//         modelKey === "womenwomencrickettrackpants"
//       ) {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.2
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "kidskidsjersey" ||
//         modelKey === "kidskidstanktop" ||
//         modelKey === "kidskidsprotshirt" ||
//         modelKey === "kidskidsfootballjersey" ||
//         modelKey === "kidskidssoccerjersey"
//       ) {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.15
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "kidskidscricketjersey" ||
//         modelKey === "kidskidsxjersey" ||
//         modelKey === "kidskidssinglet" ||
//         modelKey === "kidskidsarmsleeves"
//       ) {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.12
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (modelKey === "kidskidsbasketballjersey") {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.45
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else if (
//         modelKey === "kidskidsshorts" ||
//         modelKey === "kidskidscricketshorts" ||
//         modelKey === "kidskidscyclingshorts" ||
//         modelKey === "kidskidswintershorts" ||
//         modelKey === "kidskidsrunningshorts" ||
//         modelKey === "kidskidswovenshorts" ||
//         modelKey === "kidskidsknittedshorts" ||
//         modelKey === "kidskidsbasketballshorts" ||
//         modelKey === "kidskidssoccershorts" ||
//         modelKey === "kidskidsfootballshorts" ||
//         modelKey === "kidskidsnftfootballshorts"
//       ) {
//         // Use original tightness for menmenjersey
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.4
//           : type.includes("Text")
//           ? 0.38
//           : 0.48;
//       } else if (
//         modelKey === "kidskidstrackpants" ||
//         modelKey === "kidskidscompressionpants"
//       ) {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.5
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       } else {
//         selectionTightness = type.includes("Logo")
//           ? 0.92
//           : type.includes("Number")
//           ? 0.2
//           : type.includes("Text")
//           ? 0.45
//           : 0.48;
//       }

//       const frameWidth = baseSelectionWidth * selectionTightness;
//       const frameHeight = baseSelectionHeight * selectionTightness;

//       console.log("Frame Width:", frameWidth);
//       console.log("Frame Height:", frameHeight);

//       const layerOrder = type.includes("Number")
//         ? 2
//         : type.includes("Text")
//         ? 1
//         : 0;
//       const polygonOffsetFactor = -1 - layerOrder;
//       const additionalRotation = decalRotations[type] || 0;
//       const finalRotation = [
//         rotation[0],
//         rotation[1],
//         rotation[2] + additionalRotation,
//       ];

//       if (type.includes("Text")) {
//         console.log(
//           `📝 Rendering ${type}: baseRot=${(
//             (rotation[2] * 180) /
//             Math.PI
//           ).toFixed(1)}°, addRot=${(
//             (additionalRotation * 180) /
//             Math.PI
//           ).toFixed(1)}°, finalRot=${(
//             (finalRotation[2] * 180) /
//             Math.PI
//           ).toFixed(1)}°`
//         );
//       }

//       // Render using mesh with CanvasTexture - simplified, no decal UI
//       const renderOrder = type.includes("Number")
//         ? 1002
//         : type.includes("Text")
//         ? 1001
//         : type.includes("back")
//         ? 1003
//         : 1000;

//       // Calculate tight scale based on actual texture dimensions to keep lines close to text
//       let tightScale = adjustedScale;
//       if (isTextDecal || isNumberDecal) {
//         // Use tighter scale - close to actual text bounds (0.98) to minimise gap from t-shirt
//         tightScale = [
//           adjustedScale[0] * 0.98,
//           adjustedScale[1] * 0.98,
//           adjustedScale[2]
//         ];
//       } else if (type.includes("Logo")) {
//         // For logos, use adjustedScale as-is (already maintains aspect ratio from texture dimensions)
//         // Don't apply any tightness multiplier to preserve aspect ratio
//         tightScale = adjustedScale;
//       }

//       // Dot size scales with decal (text/logo) size - smaller text = smaller circles & icons
//       const baseDotMultiplier = isMobile ? 0.078 : 0.058;
//       const dotSize = Math.min(tightScale[0], tightScale[1]) * baseDotMultiplier;
//       const dotDepth = type.includes("Logo") ? 0.05 : 0.001; // Much higher z-depth for logos to appear above
//       // Bring dots very close to text by using 70% of the tightScale
//       const dotOffset = 0.70; // Very close to text bounds
//       const hw = (tightScale[0] / 2) * dotOffset;
//       const hh = (tightScale[1] / 2) * dotOffset;
//       const corners = [
//         { pos: [-hw, hh, dotDepth], label: 'tl' },   // top-left
//         { pos: [hw, hh, dotDepth], label: 'tr' },    // top-right
//         { pos: [0, hh, dotDepth], label: 'tm' },     // top-middle
//         { pos: [-hw, -hh, dotDepth], label: 'bl' },  // bottom-left
//         { pos: [hw, -hh, dotDepth], label: 'br' },   // bottom-right
//         { pos: [0, -hh, dotDepth], label: 'bm' }     // bottom-middle
//       ];

//       const useDecal = isTextDecal || isNumberDecal || type.includes("Logo");
//       const textureVisual = useDecal ? (
//         <Decal
//           key={`${type}-decal-${(additionalRotation * 10000).toFixed(0)}`}
//           position={position}
//           rotation={finalRotation}
//           scale={tightScale}
//           map={texture}
//           polygonOffsetFactor={polygonOffsetFactor}
//           depthTest={true}
//           {...{ "material-alphaTest": 0.1, "material-depthWrite": false }}
//         />
//       ) : (
//         <mesh
//           key={`${type}-texture-mesh-${(additionalRotation * 10000).toFixed(0)}`}
//           position={displayPosition}
//           rotation={finalRotation}
//           scale={tightScale}
//           renderOrder={renderOrder}
//         >
//           <planeGeometry args={[1, 1]} />
//           <meshStandardMaterial
//             map={texture}
//             transparent={true}
//             alphaTest={0.1}
//             depthTest={true}
//             depthWrite={false}
//             polygonOffset={true}
//             polygonOffsetFactor={polygonOffsetFactor}
//             alphaToCoverage={true}
//             side={THREE.DoubleSide}
//           />
//         </mesh>
//       );

//       return (
//         <>
//           {textureVisual}
//           <group>
//             {/* Invisible clickable/draggable area - depthTest: true; ignore when decal faces away */}
//             <mesh
//             position={displayPosition}
//             rotation={finalRotation}
//             scale={tightScale}
//             renderOrder={renderOrder + 0.1}
//             onPointerDown={(e) => {
//               e.stopPropagation();
//               if (!isDecalFacingCamera(e)) return;
//               const isDot = e.object?.userData?.isDot;
//               const isRotationButton = e.object?.userData?.isRotationButton;
//               if ((e.object === e.target || (!isDot && !isRotationButton))) {
//                 handleDecalDragStart(e, type);
//               }
//             }}
//             onClick={(e) => {
//               if (!isDecalFacingCamera(e)) return;
//               if (!hasDraggedRef.current && interactionMode !== "resizing") {
//                 e.stopPropagation();
//                 setSelectedDecal(type);
//               }
//             }}
//           >
//             <planeGeometry args={[1, 1]} />
//             <meshBasicMaterial
//               transparent
//               opacity={0}
//               depthTest={true}
//               depthWrite={false}
//               side={THREE.DoubleSide}
//             />
//           </mesh>

//           {/* Outline connecting 4 corners + resize handles - same position/rotation as decal so it moves with text */}
//           {isSelected && (
//             <group position={position} rotation={finalRotation}>
//               {/* Professional outline connecting the dots - key forces geometry update when text moves/resizes */}
//               <line key={`outline-${type}-${position[0]}-${position[1]}-${position[2]}-${hw}-${hh}`} renderOrder={renderOrder + 99}>
//                 <bufferGeometry attach="geometry">
//                   <bufferAttribute
//                     attach="attributes-position"
//                     count={5}
//                     array={new Float32Array([
//                       -hw, hh, dotDepth,
//                       hw, hh, dotDepth,
//                       hw, -hh, dotDepth,
//                       -hw, -hh, dotDepth,
//                       -hw, hh, dotDepth
//                     ])}
//                     itemSize={3}
//                   />
//                 </bufferGeometry>
//                 <lineBasicMaterial
//                   color="#2563EB"
//                   depthTest={false}
//                   depthWrite={false}
//                 />
//               </line>
//               {corners
//                 .filter((c) => ['tl', 'tr', 'bl', 'br'].includes(c.label))
//                 .map((corner, idx) => (
//                   <group key={`dot-${corner.label}-${idx}`} position={corner.pos}>
//                     <mesh
//                       renderOrder={renderOrder + 100}
//                       userData={{ isDot: true }}
//                       onPointerDown={(e) => {
//                         e.stopPropagation();
//                         handleCornerDragStart(e, type, corner.label);
//                       }}
//                       onPointerOver={(e) => {
//                         e.stopPropagation();
//                         document.body.style.cursor = 'nwse-resize';
//                       }}
//                       onPointerOut={(e) => {
//                         e.stopPropagation();
//                         if (!isResizing) {
//                           document.body.style.cursor = 'auto';
//                         }
//                       }}
//                     >
//                       <sphereGeometry args={[dotSize * 1.85, 20, 20]} />
//                       <meshBasicMaterial
//                         color="#2563EB"
//                         transparent={false}
//                         depthTest={false}
//                         depthWrite={false}
//                       />
//                     </mesh>
//                     <Html center distanceFactor={10} style={{ pointerEvents: 'none' }}>
//                       <div style={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         width: `${Math.max(6, Math.round(dotSize * 1.85 * 10))}px`,
//                         height: `${Math.max(6, Math.round(dotSize * 1.85 * 10))}px`,
//                         padding: '10%',
//                         boxSizing: 'border-box',
//                         userSelect: 'none',
//                         pointerEvents: 'none',
//                         filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.4))'
//                       }}>
//                         <img
//                           src="/Images/resize-icon.jpeg"
//                           alt="Resize"
//                           style={{
//                             width: '100%',
//                             height: '100%',
//                             objectFit: 'contain'
//                           }}
//                         />
//                       </div>
//                     </Html>
//                   </group>
//                 ))}
//             </group>
//           )}

//           {/* Rotation buttons at vertical center (for text/numbers/logos) */}
//           {isSelected && (isTextDecal || isNumberDecal || type.includes("Logo")) && (
//             <group position={position} rotation={finalRotation}>
             
//               {/* Rotation icon above decal - larger on mobile for easier touch */}
//               {(isTextDecal || isNumberDecal || type.includes("Logo")) && (
//                 <group position={[0, hh + dotSize * 3.2, dotDepth + (type.includes("Logo") ? 0.01 : 0.0005)]}>
//                   <mesh
//                     renderOrder={renderOrder + 101}
//                     userData={{ isRotationButton: true, isRotationHandle: true }}
//                     onPointerDown={(e) => {
//                       e.stopPropagation();
//                       e.nativeEvent?.stopPropagation?.();
//                       e.nativeEvent?.stopImmediatePropagation?.();
//                       handleDecalRotate(e, type);
//                     }}
//                     onPointerUp={(e) => {
//                       e.stopPropagation();
//                       stopContinuousRotation();
//                     }}
//                     onPointerLeave={(e) => {
//                       e.stopPropagation();
//                       stopContinuousRotation();
//                     }}
//                     onPointerOver={(e) => {
//                       e.stopPropagation();
//                       document.body.style.cursor = 'grab';
//                     }}
//                     onPointerOut={(e) => {
//                       e.stopPropagation();
//                       if (interactionMode !== "rotating") {
//                         document.body.style.cursor = 'auto';
//                       }
//                     }}
//                   >
//                     <sphereGeometry args={[dotSize * (isMobile ? 2.25 : 1.95), 20, 20]} />
//                     <meshBasicMaterial
//                       color="#7C3AED"
//                       transparent={false}
//                       depthTest={false}
//                       depthWrite={false}
//                     />
//                   </mesh>
//                   <Html
//                     center
//                     distanceFactor={10}
//                     style={{ pointerEvents: 'none' }}
//                   >
//                     <div style={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       userSelect: 'none',
//                       pointerEvents: 'none',
//                       fontWeight: 300,
//                       filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.45))',
//                       transform: 'rotate(-45deg)'
//                     }}>
//                       <FaArrowsRotate
//                         size={Math.max(18, Math.round(dotSize * (isMobile ? 2.25 : 1.95) * 52))}
//                         color="#ffffff"
//                         style={{ flexShrink: 0 }}
//                       />
//                     </div>
//                   </Html>
//                 </group>
//               )}
//             </group>
//           )}
//           </group>
//         </>
//       );
//     };

//     return (
//       <>
//         {/* NEW RESIZE FEATURE - HTML overlay for smooth resize */}

//         {interactionMode === "new-resize-mode" && (
//           <Html>
//             <div
//               style={{
//                 position: "fixed",
//                 top: 0,
//                 left: 0,
//                 width: "100vw",
//                 height: "100vh",
//                 pointerEvents: "auto",
//                 cursor:
//                   newResizeCorner === "tl" || newResizeCorner === "br"
//                     ? "nwse-resize"
//                     : "nesw-resize",
//                 backgroundColor: "transparent",
//                 zIndex: 9999,
//               }}
//               onPointerMove={handleNewResizeFunction}
//               onPointerUp={handlePointerUp}
//               onMouseMove={handleNewResizeFunction}
//               onMouseUp={handlePointerUp}
//               onTouchMove={handleNewResizeFunction}
//               onTouchEnd={handlePointerUp}
//             />
//           </Html>
//         )}

//         <Html
//           style={{
//             position: "absolute",
//             top: "-1000px",
//             left: "-800px",
//             zIndex: "999999999999999999999",
//           }}
//         >
//           <div id="svg-hidden-container" ref={svgContainerRef}></div>
//         </Html>

//         {interactionMode === "resize-decal" && (
//           <Html>
//             <div
//               style={{
//                 position: "fixed",
//                 top: 0,
//                 left: 0,
//                 width: "100vw",
//                 height: "100vh",
//                 pointerEvents: "auto",
//                 cursor: "nwse-resize",
//               }}
//               onPointerMove={handleResizeMove}
//               onPointerUp={handleResizeUp}
//               onMouseMove={handleResizeMove}
//               onMouseUp={handleResizeUp}
//               onTouchMove={handleResizeMove}
//               onTouchEnd={handleResizeUp}
//             />
//           </Html>
//         )}

//         {interactionMode === "move-decal" && (
//           <Html>
//             <div
//               style={{
//                 position: "fixed",
//                 top: "-188px",
//                 left: "-179px",
//                 width: "34vw",
//                 height: "65vh",
//                 pointerEvents: "auto",
//                 cursor: "move",
//               }}
//               onPointerMove={handlePointerMove}
//               onPointerUp={handlePointerUp}
//               onMouseMove={handlePointerMove}
//               onMouseUp={handlePointerUp}
//               onTouchMove={handlePointerMove}
//               onTouchEnd={handlePointerUp}
//             />
//           </Html>
//         )}

//         {interactionMode === "rotating" && (
//           <Html>
//             <div
//               style={{
//                 position: "fixed",
//                 top: "-188px",
//                 left: "-179px",
//                 width: "34vw",
//                 height: "65vh",
//                 pointerEvents: "auto",
//                 cursor: "grabbing",
//               }}
//               onPointerMove={handlePointerMove}
//               onPointerUp={handlePointerUp}
//               onMouseMove={handlePointerMove}
//               onMouseUp={handlePointerUp}
//               onTouchMove={handlePointerMove}
//               onTouchEnd={handlePointerUp}
//             />
//           </Html>
//         )}

//         <OrbitControls
//           enableZoom={true}
//           enablePan={false}
//           enabled={interactionMode === "rotate-shirt"}
//           target={[0, 0, 0]}
//           enableRotate
//           rotateSpeed={2.0}
//           minDistance={4.5}
//           maxDistance={5.5}
//         />

//         {selectedDecal && renderResizeArrow()}

//         {isLoading && (
//           <Html center>
//             <div style={loadingStyles}>
//               <Spinner animation="border" variant="dark" />
//               <p style={loadingTextStyles}>Loading...</p>
//             </div>
//           </Html>
//         )}

//         {!isLoading && (
//           <group
//             ref={group}
//             dispose={null}
//             // scale={overallScale}
//             scale={overallScale * mobileScaleFactor}
//             onPointerDown={() => {
//               handleDeselect();
//             }}
//           >
//             {/* <group position={position} rotation={rotation} scale={scale}> */}
//             <group
//               position={[
//                 position[0] + mobilePositionOffset[0],
//                 position[1] + mobilePositionOffset[1],
//                 position[2] + mobilePositionOffset[2],
//               ]}
//               // rotation={rotation}
//               rotation={animatedRotation}
//               scale={scale}
//             >
//               {parts
//                 .filter((part) => part.material.name !== "LOGO")
//                 .map((part, index) => {
//                   const partName = (part.name || "").toUpperCase();
//                   const matName = (part.material?.name || "").toUpperCase();
//                   const isFrontPart = partName.includes("FRONT") || matName.includes("FRONT");
//                   const isBackPart = partName.includes("BACK") || matName.includes("BACK");
//                   const showFrontDecals = isFrontPart || (!isFrontPart && !isBackPart);
//                   const showBackDecals = isBackPart || (!isFrontPart && !isBackPart);
//                   return (
//                     <mesh
//                       key={`non-logo-${index}`}
//                       geometry={part.geometry}
//                       material={part.material}
//                       name={part.name}
//                       ref={shirtRef}
//                     >
//                       <>
//                         {/* Front decals - only on front (or neutral) parts */}
//                         {showFrontDecals && renderDecal(
//                           "frontText",
//                           frontTextTexture.current,
//                           frontTextPosition,
//                           frontTextRotation,
//                           frontTextScale
//                         )}
//                         {showFrontDecals && renderDecal(
//                           "frontNumber",
//                           frontNumberTexture.current,
//                           frontNumberPosition,
//                           frontNumberRotation,
//                           frontNumberScale
//                         )}
//                         {showFrontDecals && renderDecal(
//                           "frontLogo",
//                           logoTexture,
//                           frontLogoPosition,
//                           frontLogoRotation,
//                           frontLogoScale
//                         )}

//                         {/* Back decals - only on back (or neutral) parts */}
//                         {showBackDecals && renderDecal(
//                           "backText",
//                           backTextTexture.current,
//                           backTextPosition,
//                           backTextRotation,
//                           backTextScale
//                         )}
//                         {showBackDecals && renderDecal(
//                           "backNumber",
//                           backNumberTexture.current,
//                           backNumberPosition,
//                           backNumberRotation,
//                           backNumberScale
//                         )}
//                         {showBackDecals && renderDecal(
//                           "backLogo",
//                           logoTextureBack,
//                           backLogoPosition,
//                           backLogoRotation,
//                           backLogoScale
//                         )}
//                       </>
//                     </mesh>
//                   );
//                 })}
//             </group>

//             {parts
//               .filter((part) => part.material.name === "LOGO")
//               .map((part, index) => {
//                 return (
//                   <mesh
//                     geometry={part.geometry}
//                     material={part.material}
//                     position={logoPosition}
//                     rotation={logoRotation}
//                     scale={logoScale}
//                   />
//                 );
//               })}
//           </group>
//         )}
//       </>
//     );
//   }
// );
// const loadingStyles = {
//   display: "flex",
//   flexDirection: "row",
//   alignItems: "center",
//   justifyContent: "center",
//   backgroundColor: "rgba(197, 197, 197, 0.8)",
//   padding: "5px 15px",
//   borderRadius: "8px",
//   gap: "20px",
// };

// const loadingTextStyles = {
//   fontSize: "20px",
//   fontWeight: "bold",
//   color: "black",
//   marginTop: "10px",
// };

// const instructionsStyle = {
//   background: "rgba(0,0,0,0.7)",
//   padding: "10px",
//   borderRadius: "8px",
//   color: "white",
// };

// export default ShirtModel;



import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { createPortal } from "react-dom";
import { forwardRef, useImperativeHandle } from "react";
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import state from "./index.js";
import { useSnapshot } from "valtio";
import {
  OrbitControls,
  Decal,
  Html,
  TransformControls,
} from "@react-three/drei";
import Spinner from "react-bootstrap/Spinner";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import clothingConfig from "./clothingConfig";
import { CanvasTexture } from "three";
import modelConfig1 from "./modelConfig1.js";
import { GLTFExporter } from "three/examples/jsm/exporters/GLTFExporter";
import { TextureLoader } from "three";
import { useFrame } from "@react-three/fiber";
import { fabric } from "fabric";
import { useThree } from "@react-three/fiber";
import { useDispatch, useSelector } from "react-redux";
import { FaArrowRotateLeft, FaArrowsRotate } from "react-icons/fa6";
import { useLocation } from "react-router-dom";

const DEFAULT_MODEL_URL = "/asset/HalfpoloK5.glb";
const LEGACY_MODEL_URL = "/LongTeeM1.glb";

const ShirtModel = forwardRef(
  (
    { menuSlug, subcategorySlug, gltfRef, isEditingDraft, currentProduct },
    ref
  ) => {
    console.log("svg <<<<<<<<<>>>>>>>>>>>>>>>>>>..... : ", state.svg);
    const { glbId } = useSelector((state) => state.cart);
    const { camera } = useThree();
    const raycaster = useMemo(() => new THREE.Raycaster(), []);
    const mouse = useMemo(() => new THREE.Vector2(), []);
    // const { selectedPattern } = useSnapshot(state);
    const [isLoading, setIsLoading] = useState(true);
    const snap = useSnapshot(state);
    const group = useRef();
    const shirtRef = useRef();
    const [bandMesh, setBandMesh] = useState(null);
    const location = useLocation(); // Add this line
    const [isMobile, setIsmobile] = useState(window.innerWidth < 667);
    const [initialDecalRotation, setInitialDecalRotation] = useState(0);
    console.log("state.newKey : ", state.newKey);
    console.log("state.frontText : ", state.frontText);
    console.log("settings.Colors : ", state.partColors);
    console.log(
      "state.gradientColors...................... : ",
      state.gradientColors
    );

    const productData = currentProduct || state.currentProduct;

    console.log("productData///////////////////////// : ",productData)
    const { selectedPattern } = productData || {};

    console.log("state.newKey : ", state.newKey);
    console.log("currentProduct frontText : ", productData?.frontText);
    console.log("currentProduct partColors : ", productData?.partColors);
    console.log(
      "currentProduct gradientColors : ",
      productData?.gradientColors
    );

    const { viewSide } = productData || { viewSide: "front" };

const previousModelUrlRef = useRef(null);

// Add this effect to ShirtModel.jsx
useEffect(() => {
  // Reset model loading state when product changes
  if (productData?.id && previousProductIdRef.current !== productData.id) {
    console.log("Product ID changed, resetting model state");
    
    // If the model name is the same but product is different (duplicate),
    // we need to reload the model to get fresh textures
    if (previousModelUrlRef.current === productData.modelName) {
      console.log("Same model URL, different product - reloading");
      loadModelForProduct();
    }
    
    previousProductIdRef.current = productData.id;
  }
}, [productData?.id, productData?.modelName]);

  useEffect(() => {
      if (group.current && productData?.id) {
        console.log("Product changed, applying images...");
        applyImagesToMaterials();
      }
    }, [productData?.id, productData?.imagesPattern]);
    
    // Optimize applyImagesToMaterials with useCallback
    const applyImagesToMaterials = useCallback(async () => {
      if (!group.current || !productData?.imagesPattern) {
        console.log("No group or no imagesPattern to apply");
        return;
      }
      
      console.log("Applying images to materials...");
      
      const imagesPattern = productData.imagesPattern || {};
      const normalizedImages = Object.fromEntries(
        Object.entries(imagesPattern).map(([key, val]) => [
          key.toUpperCase(),
          val,
        ])
      );
      
      // Process each mesh in the model
      group.current.traverse(async (child) => {
        if (!child.isMesh || !child.material) return;
        
        const materialName = child.material.name?.toUpperCase();
        if (!materialName) return;
        
        const materials = Array.isArray(child.material)
          ? child.material
          : [child.material];
        
        for (const mat of materials) {
          const imageData = normalizedImages[materialName];
          
          // Dispose of existing texture
          if (mat.map) {
            mat.map.dispose();
            mat.map = null;
          }
          
          if (imageData?.image) {
            try {
              const texture = await new THREE.TextureLoader().loadAsync(
                imageData.image
              );
              
              texture.colorSpace = THREE.SRGBColorSpace;
              texture.flipY = false;
              texture.wrapS = THREE.RepeatWrapping;
              texture.wrapT = THREE.RepeatWrapping;
              texture.center.set(0.5, 0.5);
              
              // Set texture properties
              const img = new Image();
              img.crossOrigin = "anonymous";
              
              img.onload = () => {
                const imageAspect = img.width / img.height;
                const shirtAspect = 2220 / 2553;
                const SCALE_FACTOR = 2;
                
                if (img.width >= 2220 && img.height >= 2553) {
                  if (imageAspect > shirtAspect) {
                    texture.repeat.set(
                      (shirtAspect / imageAspect) * SCALE_FACTOR,
                      1 * SCALE_FACTOR
                    );
                  } else {
                    texture.repeat.set(
                      1 * SCALE_FACTOR,
                      (imageAspect / shirtAspect) * SCALE_FACTOR
                    );
                  }
                } else if (img.width >= 1000 && img.height >= 1000) {
                  texture.repeat.set(
                    (2220 / img.width) * 0.8 * SCALE_FACTOR,
                    (2553 / img.height) * 0.8 * SCALE_FACTOR
                  );
                } else {
                  const scaleX = Math.max(1, 2220 / img.width);
                  const scaleY = Math.max(1, 2553 / img.height);
                  texture.repeat.set(scaleX * SCALE_FACTOR, scaleY * SCALE_FACTOR);
                }
                
                texture.needsUpdate = true;
              };
              
              img.src = imageData.image;
              
              mat.map = texture;
              mat.color.set(0xffffff);
              mat.needsUpdate = true;
              
              console.log(`Applied texture to ${materialName}`);
            } catch (err) {
              console.error(`Failed to load image for ${materialName}:`, err);
            }
          } else {
            // No image - use default color
            mat.map = null;
            mat.color.set("#112F51");
            mat.needsUpdate = true;
          }
        }
      });
    }, [productData?.imagesPattern,productData?.id,]);
    
    // Add a debug effect to log when product changes
    useEffect(() => {
      console.log("Product data updated:", {
        id: productData?.id,
        imagesPattern: productData?.imagesPattern,
        hasImages: !!productData?.imagesPattern && Object.keys(productData.imagesPattern).length > 0
      });
    }, [productData,productData?.id,]);

    useEffect(() => {
      const handleResize = () => {
        setIsmobile(window.innerWidth < 667);
      };

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
    function resetState() {
      state.updateTrigger++;
      state.intro = false;
      state.color = "#EFBD48";

      // Reset current product data
      const currentProductId = state.currentProductId;
      if (state.products[currentProductId]) {
        state.products[currentProductId] = {
          ...state.products[currentProductId],
          frontText: "",
          backText: "",
          frontNumber: "",
          backNumber: "",
          frontLogo: null,
          backLogo: null,
          imagesPattern: {},
          viewSide: "front",
          patternColors: {},
          selectedPattern: {},
          selectedFonts: "Arial",
          textFonts: { front: "Arial", back: "Arial" },
          numberFonts: { front: "Arial", back: "Arial" },
          textColors: { front: "#ffffff", back: "#ffffff" },
          numberColors: { front: "#ffffff", back: "#ffffff" },
          partColors: {},
          gradientColors: {},
        };
      }
    }
    // Replace your current useEffect with:
    // Replace your current useEffect with:
    useEffect(() => {
      const hasDraftData =
        location.state?.draftData || location.state?.restoreData;

      if (!hasDraftData) {
        console.log("No draft data found, resetting state...");
        resetState();
      } else {
        console.log("Draft data found, skipping state reset...");
        state.updateTrigger++; // Still trigger a re-render
      }
    }, [location.state]);

    // In ShirtModel.jsx, add this effect to apply colors when product changes
    useEffect(() => {
      if (!group.current || !productData?.partColors) return;

      console.log("Applying colors for product:", productData.id);
      console.log("Colors to apply:", productData.partColors);

      group.current.traverse((child) => {
        if (child.isMesh && child.material) {
          const partName = child.material.name?.toUpperCase();

          if (partName && productData.partColors[partName]) {
            const color = productData.partColors[partName];
            const materials = Array.isArray(child.material)
              ? child.material
              : [child.material];

            materials.forEach((mat) => {
              if (mat.name === partName) {
                console.log(`Setting color ${color} for ${partName}`);
                mat.color.set(color);
                mat.needsUpdate = true;
              }
            });
          }
        }
      });
    }, [productData?.id, productData?.partColors]);

    useEffect(() => {
      // When product changes, update the model
      if (productData && group.current) {
        applyProductColorsToModel();
      }
    }, [productData?.id, productData?.partColors]);

    const applyProductColorsToModel = () => {
      if (!group.current || !productData?.partColors) return;

      console.log("Applying colors for product:", productData.id);
      console.log("Colors:", productData.partColors);

      group.current.traverse((child) => {
        if (child.isMesh && child.material) {
          const partName = child.material.name?.toUpperCase();

          if (partName && productData.partColors[partName]) {
            const color = productData.partColors[partName];
            const materials = Array.isArray(child.material)
              ? child.material
              : [child.material];

            materials.forEach((mat) => {
              if (mat.name === partName) {
                console.log(`Setting color ${color} for ${partName}`);
                mat.color.set(color);
                mat.needsUpdate = true;
              }
            });
          }
        }
      });
    };

    const [gltf, setGltf] = useState(null);
    const latestRequestRef = useRef(0);

    const loadModel = useCallback(
      (src) =>
        new Promise((resolve, reject) => {
          if (!src) {
            reject(new Error("Model source is undefined"));
            return;
          }

          const dracoLoader = new DRACOLoader();
          dracoLoader.setDecoderPath(
            "https://www.gstatic.com/draco/v1/decoders/"
          );

          const loader = new GLTFLoader();
          loader.setDRACOLoader(dracoLoader);

          loader.load(
            src,
            (model) => {
              dracoLoader.dispose();
              resolve(model);
            },
            undefined,
            (error) => {
              dracoLoader.dispose();
              reject(error);
            }
          );
        }),
      []
    );

    console.log("gltf : ", gltf);

    const getModelSettings = (menuSlug, subcategorySlug, selectedDesignId) => {
      console.log("selectedDesignId <<<<<<<<<<<<<<>>>>>>>>>>>> ; ", glbId);
      console.log("menuSlug .................. : ", menuSlug);
      console.log(
        "subcategorySlug ........................ : ",
        subcategorySlug
      );
      const key = `${menuSlug}${subcategorySlug}`;
      const newKey = key.replace(/-/g, "");
      state.newKey = newKey;
      console.log("newKey : ", newKey);

      let modelConfig = modelConfig1[newKey];

      if (newKey === "eventordereventjersey") {
        const designKey = glbId || 900;
        modelConfig = modelConfig1[newKey]?.[designKey];
      }

      return (
        modelConfig || {
          position: [0, 0, 0],
          rotation: [0, 0, 0],
          scale: 1,
        }
      );
    };

    useImperativeHandle(ref, () => ({
      capturePng: () => {
        if (!gltf) return null;

        const scene = new THREE.Scene();
        const camera = new THREE.PerspectiveCamera(35, 1, 0.1, 1000);
        const renderer = new THREE.WebGLRenderer({
          preserveDrawingBuffer: true,
          alpha: true,
        });
        renderer.setSize(512, 512);
        renderer.setClearColor(0x000000, 0);

        const model = gltf.scene.clone();

        model.scale.set(2.5, 2.5, 2.5);

        const box = new THREE.Box3().setFromObject(model);
        const center = box.getCenter(new THREE.Vector3());
        model.position.x -= center.x;
        model.position.y -= center.y;
        model.position.z -= center.z;

        scene.add(model);

        const directionalLight = new THREE.DirectionalLight(0xffffff, 3.0);
        directionalLight.position.set(3, 5, 5);
        scene.add(directionalLight);

        const ambientLight = new THREE.AmbientLight(0xffffff, 0.7);
        scene.add(ambientLight);

        const size = box.getSize(new THREE.Vector3());
        const maxDim = Math.max(size.x, size.y, size.z);
        const fov = camera.fov * (Math.PI / 180);
        let cameraZ = Math.abs(maxDim / Math.sin(fov / 2)) * 0.6;

        camera.position.set(0, 0.2, cameraZ);
        camera.lookAt(new THREE.Vector3(0, 0.1, 0));
        const backLight = new THREE.DirectionalLight(0xffffff, 1.5);
        backLight.position.set(-5, -3, -5);
        scene.add(backLight);

        renderer.render(scene, camera);
        const pngData = renderer.domElement.toDataURL("image/png");
        return pngData;
      },
    }));

    const {
      partMappings,
      overallScale,
      position,
      rotation,
      scale,
      fontSize,
      designposition,
      designrotation,
      designscale,
      patternScalling,
      logoPosition,
      logoRotation,
      logoScale,
      backNumberPosition,
      backNumberRotation,
      backNumberScale,
      backLogoPosition,
      backLogoRotation,
      backLogoScale,
      frontLogoPosition,
      frontLogoRotation,
      frontLogoScale,
      frontTextPosition,
      frontTextRotation,
      frontTextScale,
      backTextPosition,
      backTextRotation,
      backTextScale,
      frontNumberPosition,
      frontNumberRotation,
      frontNumberScale,
    } = getModelSettings(menuSlug, subcategorySlug);

    const frontRotation = useMemo(() => {
      return rotation;
    }, [rotation]);

    const backRotation = useMemo(() => {
      const modelKey = state.newKey;
      if (
        modelKey === "menmenjersey" ||
        modelKey === "menmenjersey" ||
        modelKey === "menmenjersey" ||
        modelKey === "menmenjersey" ||
        modelKey === "menmenjersey" ||
        modelKey === "menmenjersey" ||
        modelKey === "menmenjersey" ||
        modelKey === "menmenjersey" ||
        modelKey === "menmenjersey" ||
        modelKey === "menmenjersey" ||
        modelKey === "menmenjersey" ||
        modelKey === "menmenjersey" ||
        modelKey === "menmenjersey" ||
        modelKey === "menmenjersey"
      ) {
        return [rotation[0], rotation[1] + Math.PI, rotation[2]];
      } else if (
        modelKey === "menmenshorts" ||
        modelKey === "menmencricketshorts" ||
        modelKey === "menmencyclingshorts" ||
        modelKey === "menmenrunningshorts" ||
        modelKey === "menmenwovenshorts" ||
        modelKey === "menmenknittedshorts" ||
        modelKey === "menmenfootballshorts" ||
        modelKey === "menmensoccershorts" ||
        modelKey === "menmenbasketballshorts" ||
        modelKey === "menmennftfootballshorts" ||
        modelKey === "menmencyclingjersey" ||
        modelKey === "menmenwinterjersey" ||
        modelKey === "menmencitycollection" ||
        modelKey === "menmencricketjersey" ||
        modelKey === "menmentrackpants" ||
        modelKey === "menmencompressionpants" ||
        modelKey === "menmensinglet" ||
        modelKey === "menmenarmsleeves" ||
        modelKey === "menmenbasketballjersey" ||
        modelKey === "womenwomenbadmintonshorts" ||
        modelKey === "womenwomencyclingshorts" ||
        modelKey === "womenwomencricketshorts" ||
        modelKey === "womenwomenwovenshorts" ||
        modelKey === "womenwomentightshorts" ||
        modelKey === "womenwomenfootballshorts" ||
        modelKey === "womenwomensoccershorts" ||
        modelKey === "menmencompressionpants" ||
        modelKey === "womenwomennftfootballshorts" ||
        modelKey === "menmencompressionpants" ||
        modelKey === "womenwomenbasketballshorts" ||
        modelKey === "womenwomenknittedshorts" ||
        modelKey === "womenwomencompressionpants" ||
        modelKey === "womenwomencrickettrackpants" ||
        modelKey === "womenwomentrackpants" ||
        modelKey === "womenwomencricketjersey" ||
        modelKey === "womenwomencyclingjersey" ||
        modelKey === "womenwomenwinterjersey" ||
        modelKey === "womenwomencitycollection" ||
        modelKey === "kidskidsjersey" ||
        modelKey === "kidskidscompressionpants" ||
        modelKey === "kidskidsshorts" ||
        modelKey === "kidskidscricketshorts" ||
        modelKey === "kidskidscyclingshorts" ||
        modelKey === "kidskidswintershorts" ||
        modelKey === "kidskidsrunningshorts" ||
        modelKey === "kidskidswovenshorts" ||
        modelKey === "kidskidsknittedshorts" ||
        modelKey === "kidskidsbasketballshorts" ||
        modelKey === "kidskidssoccershorts" ||
        modelKey === "kidskidsfootballshorts" ||
        modelKey === "kidskidsnftfootballshorts" ||
        modelKey === "kidskidstanktop" ||
        modelKey === "kidskidscyclingjersey" ||
        modelKey === "kidskidswinterjersey" ||
        modelKey === "kidskidscitycollection" ||
        modelKey === "kidskidscricketjersey" ||
        modelKey === "kidskidstrackpants" ||
        modelKey === "kidskidsprotshirt" ||
        modelKey === "kidskidssinglet" ||
        modelKey === "kidskidsarmsleeves" ||
        modelKey === "kidskidsfootballjersey"||
        modelKey === "kidskidssoccerjersey" 
      ) {
        return [rotation[0], rotation[1], rotation[2] + Math.PI];
      } else {
        return [rotation[0], rotation[1] + Math.PI, rotation[2]];
      }
    }, [rotation]);

    const currentRotation = useMemo(() => {
      return viewSide === "front" ? frontRotation : backRotation;
    }, [viewSide, frontRotation, backRotation]);

    const [animatedRotation, setAnimatedRotation] = useState(frontRotation);

    useEffect(() => {
      const targetRotation =
        viewSide === "front" ? frontRotation : backRotation;

      const timer = setTimeout(() => {
        setAnimatedRotation(targetRotation);
      }, 50);

      return () => clearTimeout(timer);
    }, [viewSide, frontRotation, backRotation]);

    console.log("position <<<<<<<<<<<<<<>>>>>>>>>>>>>>: ", position);
    console.log("rotation : ", rotation);
    console.log("scale : ", scale);

    const [modelSettings, setModelSettings] = useState(() =>
      getModelSettings(menuSlug, subcategorySlug)
    );

    const [updateTrigger, setUpdateTrigger] = useState(0);

    useEffect(() => {
      setModelSettings(getModelSettings(menuSlug, subcategorySlug));
    }, [snap.updateTrigger, menuSlug, subcategorySlug]);

    useEffect(() => {
      console.log("menu slug /////////// : ", menuSlug);
      console.log("menu slug /////////// : ", subcategorySlug);
      let isMounted = true;
      latestRequestRef.current += 1;
      const requestId = latestRequestRef.current;

      // Determine which model to load
      let modelKeyToLoad;

      // Priority 1: Preserved model from navigation
      if (location.state?.preserveModel && location.state?.currentModelKey) {
        modelKeyToLoad = location.state.currentModelKey;
        console.log(`🎯 Loading PRESERVED model: ${modelKeyToLoad}`);
      }
      // Priority 2: Current slugs
      else if (menuSlug && subcategorySlug) {
        modelKeyToLoad = `${menuSlug}${subcategorySlug}`.replace(/-/g, "");
        console.log(`🎯 Loading from slugs: ${modelKeyToLoad}`);
      }
      // Priority 3: Previously stored model
      else {
        const storedModel = localStorage.getItem("current-3d-model");
        modelKeyToLoad = storedModel || "menmenjersey";
        console.log(`🎯 Loading STORED model: ${modelKeyToLoad}`);
      }

      // Update state with the actual key we're loading
      state.newKey = modelKeyToLoad;

      setIsLoading(true);

      const loadModelForKey = async () => {
        const modelConfig = modelConfig1[modelKeyToLoad];
        let modelUrl;

        if (modelConfig?.modelUrl) {
          modelUrl = modelConfig.modelUrl;
        } else {
          // Fallback: use model name from state or default
          modelUrl = snap.modelName || DEFAULT_MODEL_URL;
        }

        console.log(`📦 Loading model from: ${modelUrl}`);

        try {
          // Add cache busting
          const cacheBustedUrl = `${modelUrl}?t=${Date.now()}`;
          const model = await loadModel(cacheBustedUrl);

          if (!isMounted || latestRequestRef.current !== requestId) return;

          console.log(`✅ Model loaded: ${modelKeyToLoad}`);
          setGltf(model);
        } catch (error) {
          console.error(`❌ Failed to load ${modelKeyToLoad}:`, error);

          if (!isMounted || latestRequestRef.current !== requestId) return;

          // Fallback to default
          try {
            console.log(`🔄 Falling back to default model`);
            const defaultModel = await loadModel(DEFAULT_MODEL_URL);
            if (isMounted && latestRequestRef.current === requestId) {
              setGltf(defaultModel);
              state.newKey = "menmenjersey";
            }
          } catch (fallbackError) {
            console.error("❌ Fallback also failed:", fallbackError);
            setGltf(null);
          }
        } finally {
          if (isMounted && latestRequestRef.current === requestId) {
            setIsLoading(false);
          }
        }
      };

      loadModelForKey();

      return () => {
        isMounted = false;
      };
    }, [snap.modelName, menuSlug, subcategorySlug, loadModel, location.state]);

    useEffect(() => {
      if (gltf && gltfRef) {
        gltfRef.current = gltf;
      }
    }, [gltf]);

    ////console.log("gltf?.scene : ", gltf?.scene);

    useEffect(() => {
      if (gltf?.scene && state.scene) {
        state.scene = gltf.scene;
      }

      if (gltf?.scene) {
        gltf.scene.traverse((child) => {
          if (child.isGroup && ["TEE", "DESIGN"].includes(child.name)) {
            setBandMesh((prev) => [
              ...(Array.isArray(prev) ? prev : []),
              ...child.children.filter((c) => c.isMesh),
            ]);
          }
        });
      }
    }, [gltf, state.scene, menuSlug, subcategorySlug]);

    // useEffect(() => {
    //   updateTexture(snap.frontText, frontTextTexture, "front");
    //   updateTexture(snap.backText, backTextTexture, "back");
    //   updateTexture(snap.frontNumber, frontNumberTexture, "frontNumber");
    //   updateTexture(snap.backNumber, backNumberTexture, "backNumber");
    // }, [state.updateTrigger]);

    useEffect(() => {
      const modelKey = state.newKey;

      if (modelKey === "eventordereventjersey" && glbId) {
        console.log(" Updating positions for event order design:", glbId);

        let modelConfig = modelConfig1[modelKey][glbId];

        if (!modelConfig) {
          console.warn(" No config found for design ID:", glbId);
          return;
        }

        setDecalPositions({
          frontText: modelConfig.frontTextPosition
            ? [...modelConfig.frontTextPosition]
            : [0, 0, 0],
          frontNumber: modelConfig.frontNumberPosition
            ? [...modelConfig.frontNumberPosition]
            : [0, 0, 0],
          frontLogo: modelConfig.frontLogoPosition
            ? [...modelConfig.frontLogoPosition]
            : [0, 0, 0],
          backText: modelConfig.backTextPosition
            ? [...modelConfig.backTextPosition]
            : [0, 0, 0],
          backNumber: modelConfig.backNumberPosition
            ? [...modelConfig.backNumberPosition]
            : [0, 0, 0],
          backLogo: modelConfig.backLogoPosition
            ? [...modelConfig.backLogoPosition]
            : [0, 0, 0],
        });

        setDecalScales({
          frontText: modelConfig.frontTextScale
            ? [...modelConfig.frontTextScale]
            : [1, 1, 1],
          frontNumber: modelConfig.frontNumberScale
            ? [...modelConfig.frontNumberScale]
            : [1, 1, 1],
          frontLogo: modelConfig.frontLogoScale
            ? [...modelConfig.frontLogoScale]
            : [1, 1, 1],
          backText: modelConfig.backTextScale
            ? [...modelConfig.backTextScale]
            : [1, 1, 1],
          backNumber: modelConfig.backNumberScale
            ? [...modelConfig.backNumberScale]
            : [1, 1, 1],
          backLogo: modelConfig.backLogoScale
            ? [...modelConfig.backLogoScale]
            : [1, 1, 1],
        });

        if (modelConfig.fontSize) {
          setFontSizetext(modelConfig.fontSize);
        }
        if (modelConfig.fontSizeNumber) {
          setFontSizeNumber(modelConfig.fontSizeNumber);
        }

        if (modelConfig.frontTextPosition) {
          frontTextPosition[0] = modelConfig.frontTextPosition[0];
          frontTextPosition[1] = modelConfig.frontTextPosition[1];
          frontTextPosition[2] = modelConfig.frontTextPosition[2];
        }

        if (modelConfig.frontNumberPosition) {
          frontNumberPosition[0] = modelConfig.frontNumberPosition[0];
          frontNumberPosition[1] = modelConfig.frontNumberPosition[1];
          frontNumberPosition[2] = modelConfig.frontNumberPosition[2];
        }

        if (modelConfig.frontLogoPosition) {
          frontLogoPosition[0] = modelConfig.frontLogoPosition[0];
          frontLogoPosition[1] = modelConfig.frontLogoPosition[1];
          frontLogoPosition[2] = modelConfig.frontLogoPosition[2];
        }

        if (modelConfig.backTextPosition) {
          backTextPosition[0] = modelConfig.backTextPosition[0];
          backTextPosition[1] = modelConfig.backTextPosition[1];
          backTextPosition[2] = modelConfig.backTextPosition[2];
        }

        if (modelConfig.backNumberPosition) {
          backNumberPosition[0] = modelConfig.backNumberPosition[0];
          backNumberPosition[1] = modelConfig.backNumberPosition[1];
          backNumberPosition[2] = modelConfig.backNumberPosition[2];
        }

        if (modelConfig.backLogoPosition) {
          backLogoPosition[0] = modelConfig.backLogoPosition[0];
          backLogoPosition[1] = modelConfig.backLogoPosition[1];
          backLogoPosition[2] = modelConfig.backLogoPosition[2];
        }

        if (modelConfig.frontTextScale) {
          frontTextScale[0] = modelConfig.frontTextScale[0];
          frontTextScale[1] = modelConfig.frontTextScale[1];
          frontTextScale[2] = modelConfig.frontTextScale[2];
        }

        if (modelConfig.frontNumberScale) {
          frontNumberScale[0] = modelConfig.frontNumberScale[0];
          frontNumberScale[1] = modelConfig.frontNumberScale[1];
          frontNumberScale[2] = modelConfig.frontNumberScale[2];
        }

        if (modelConfig.frontLogoScale) {
          frontLogoScale[0] = modelConfig.frontLogoScale[0];
          frontLogoScale[1] = modelConfig.frontLogoScale[1];
          frontLogoScale[2] = modelConfig.frontLogoScale[2];
        }

        if (modelConfig.backTextScale) {
          backTextScale[0] = modelConfig.backTextScale[0];
          backTextScale[1] = modelConfig.backTextScale[1];
          backTextScale[2] = modelConfig.backTextScale[2];
        }

        if (modelConfig.backNumberScale) {
          backNumberScale[0] = modelConfig.backNumberScale[0];
          backNumberScale[1] = modelConfig.backNumberScale[1];
          backNumberScale[2] = modelConfig.backNumberScale[2];
        }

        if (modelConfig.backLogoScale) {
          backLogoScale[0] = modelConfig.backLogoScale[0];
          backLogoScale[1] = modelConfig.backLogoScale[1];
          backLogoScale[2] = modelConfig.backLogoScale[2];
        }

        console.log(
          "Updated event order positions and scales for design:",
          glbId
        );
      }
    }, [glbId]);

    const [parts, setLocalParts] = useState([]);
    const [frontParts, setFrontParts] = useState([]);
    const [backParts, setBackParts] = useState([]);
    const [leftParts, setLeftParts] = useState([]);
    const [rightParts, setRightParts] = useState([]);
    const [designParts, setDesignParts] = useState([]);
    const [defaultTexture, setDefaultTexture] = useState(null);
     const previousProductIdRef = useRef(null);
// Effect 1: Handle model changes (when model URL changes)
useEffect(() => {
  if (!productData?.modelName) return;
  
  // Only reload if model URL actually changed
  if (productData.modelName !== previousModelUrlRef.current) {
    console.log("Model URL changed:", productData.modelName);
    
    previousModelUrlRef.current = productData.modelName;
    loadModelForProduct();
  }
}, [productData?.modelName]);

// Effect 2: Handle product changes (when product ID changes but model stays same)
useEffect(() => {
  if (!productData?.id) return;
  
  // Product ID changed but model might be the same
  if (productData.id !== previousProductIdRef.current) {
    console.log("Product changed:", productData.id);
    
    const modelChanged = productData.modelName !== previousModelUrlRef.current;
    
    if (!modelChanged && gltf) {
      // Same model, different product (duplicate) - just update settings
      console.log("Same model, applying new product settings");
      applyProductColorsToModel();
      applyImagesToMaterials();
    }
    
    previousProductIdRef.current = productData.id;
  }
}, [productData?.id, gltf]);

async function loadModelForProduct() {
  if (!productData?.modelName) return;
  
  setIsLoading(true);
  setGltf(null);
  
  try {
    const cacheBustedUrl = `${productData.modelName}?t=${Date.now()}`;
    const model = await loadModel(cacheBustedUrl);
    setGltf(model);
    setIsLoading(false);
    console.log("Model loaded for product:", productData.id);
  } catch (error) {
    console.error("Failed to load model:", error);
    setIsLoading(false);
  }
}

    const texture = useMemo(() => {
      // Check if we have a valid selected pattern from current product
      if (!selectedPattern || typeof selectedPattern !== "object") {
        console.log("No selected pattern or invalid pattern object");
        return null;
      }

      // Check if the pattern has an image property
      const patternImage = selectedPattern.image;
      if (!patternImage || typeof patternImage !== "string") {
        console.log(
          "Selected pattern has no valid image URL:",
          selectedPattern
        );
        return null;
      }

      try {
        console.log("Loading pattern texture:", patternImage);
        const texture = new THREE.TextureLoader().load(
          patternImage,
          // onLoad callback
          () => {
            console.log("Pattern texture loaded successfully");
            texture.needsUpdate = true;
          },
          // onProgress callback (optional)
          undefined,
          // onError callback
          (error) => {
            console.error("Failed to load pattern texture:", error);
          }
        );

        if (texture) {
          texture.colorSpace = THREE.SRGBColorSpace;
          texture.wrapS = THREE.RepeatWrapping;
          texture.wrapT = THREE.RepeatWrapping;

          // Use pattern-specific scale if available, otherwise default
          const scale = selectedPattern.scale || 1;
          texture.repeat.set(35 * scale, 35 * scale);

          texture.transparent = true;
          texture.opacity = selectedPattern.opacity || 0.5;
        }

        return texture;
      } catch (error) {
        console.error("Error creating texture:", error);
        return null;
      }
    }, [
        productData?.id,
      selectedPattern?.image,
      selectedPattern?.scale,
      selectedPattern?.opacity,
    ]);

    const [patternedMaterials, setPatternedMaterials] = useState({});
    const [forceRenderKey, setForceRenderKey] = useState(0);

    ////console.log("state.selectedPattern : ", state.selectedPattern);

    const baseColorTextureRef = useRef(null);

    /** ==========================
     *  OPTIMIZED MESH EXTRACTION
     *  ========================== */
    useEffect(() => {
      if (gltf?.scene) {
        const extractedParts = [];

        gltf.scene.traverse((child) => {
          if (child.isMesh) {
            child.geometry.computeVertexNormals();

            if (child.material.side === THREE.BackSide) {
              child.geometry.scale(-1, 1, 1);
              child.material.side = THREE.FrontSide;
            }

            extractedParts.push({
              name: child.name,
              geometry: child.geometry,
              material: child.material,
            });
          }
        });

        console.log("extractedParts : ", extractedParts);

        setLocalParts(extractedParts);
        state.parts = extractedParts.map((part) => part.material.name);
      }
    }, [gltf, state.setParts, menuSlug, subcategorySlug]);

    console.log("state.parts:", state.parts);

    const [renderCount, setRenderCount] = useState(0);

    const svgContainerRef = useRef(null);

    useEffect(() => {
      const applyImagesToMaterials = async () => {
        if (!group.current) return;

        console.log(
          "currentProduct imagesPattern : ",
          productData?.imagesPattern
        );

        const imagesPattern = productData?.imagesPattern || {};
        const normalizedImages = Object.fromEntries(
          Object.entries(imagesPattern).map(([key, val]) => [
            key.toUpperCase(),
            val,
          ])
        );

        group.current.traverse(async (child) => {
          if (!child.isMesh || !child.material) return;

          const materialName = child.material.name?.toUpperCase();
          if (!materialName || !partMappings[materialName]) return;

          const materials = Array.isArray(child.material)
            ? child.material
            : [child.material];

          for (const mat of materials) {
            const imageData = normalizedImages[materialName];

            // Dispose of existing texture to prevent memory leaks
            if (mat.map) {
              mat.map.dispose();
              mat.map = null;
            }

            if (imageData?.image) {
              try {
                const texture = await new THREE.TextureLoader().loadAsync(
                  imageData.image
                );

                texture.colorSpace = THREE.SRGBColorSpace;
                texture.flipY = false;
                texture.wrapS = THREE.RepeatWrapping;
                texture.wrapT = THREE.RepeatWrapping;
                texture.center.set(0.5, 0.5);

                const img = new Image();
                img.crossOrigin = "anonymous";

                img.onload = () => {
                  const imageAspect = img.width / img.height;
                  const shirtAspect = 2220 / 2553; // your shirt UV ratio

                  console.log("imageAspect: ", imageAspect);
                  console.log("img.width: ", img.width);
                  console.log("img.height: ", img.height);

                  // Scale factor to control pattern size (increase = smaller pattern)
                  const SCALE_FACTOR = 2; // Adjust this: 1 = normal, 2 = half size, 3 = third size

                  if (img.width >= 2220 && img.height >= 2553) {
                    // High-res pattern
                    if (imageAspect > shirtAspect) {
                      texture.repeat.set(
                        (shirtAspect / imageAspect) * SCALE_FACTOR,
                        1 * SCALE_FACTOR
                      );
                    } else {
                      texture.repeat.set(
                        1 * SCALE_FACTOR,
                        (imageAspect / shirtAspect) * SCALE_FACTOR
                      );
                    }
                  } else if (img.width >= 1000 && img.height >= 1000) {
                    // Medium pattern - tile it appropriately
                    texture.repeat.set(
                      (2220 / img.width) * 0.8 * SCALE_FACTOR,
                      (2553 / img.height) * 0.8 * SCALE_FACTOR
                    );
                  } else {
                    // Small pattern - tile more
                    const scaleX = Math.max(1, 2220 / img.width);
                    const scaleY = Math.max(1, 2553 / img.height);
                    texture.repeat.set(
                      scaleX * SCALE_FACTOR,
                      scaleY * SCALE_FACTOR
                    );
                  }

                  texture.needsUpdate = true;
                };

                img.src = imageData.image;

                mat.map = texture;
                mat.color.set(0xffffff);
                mat.needsUpdate = true;
              } catch (err) {
                console.error(`Failed to load image for ${materialName}:`, err);
              }
            } else {
              // No image - reset to default color
              mat.map = null;
              mat.color.set("#112F51");
              mat.needsUpdate = true;
            }
          }
        });
      };

      applyImagesToMaterials();
    }, [productData?.imagesPattern, productData?.id]);

    function applyGradientToPath(
      svg,
      pathElement,
      baseColor,
      gradientColor,
      gradientId
    ) {
      ////console.log("Gradient svg : ", svg);
      ////console.log("Gradient pathElement : ", pathElement);
      ////console.log("Gradient baseColor : ", baseColor);
      ////console.log("Gradient gradientColor : ", gradientColor);
      ////console.log("Gradient gradientId : ", gradientId);

      const defs =
        svg.querySelector("defs") ||
        svg.insertBefore(
          document.createElementNS("http://www.w3.org/2000/svg", "defs"),
          svg.firstChild
        );

      let gradient = document.getElementById(gradientId);
      if (!gradient) {
        gradient = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "linearGradient"
        );
        gradient.setAttribute("id", gradientId);

        gradient.setAttribute("x1", "0%");
        gradient.setAttribute("y1", "0%");
        gradient.setAttribute("x2", "0%");
        gradient.setAttribute("y2", "100%");

        const stop1 = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "stop"
        );
        stop1.setAttribute("offset", "0%");
        stop1.setAttribute("stop-color", baseColor);

        const stop2 = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "stop"
        );
        stop2.setAttribute("offset", "100%");
        stop2.setAttribute("stop-color", gradientColor);

        gradient.appendChild(stop1);
        gradient.appendChild(stop2);
        defs.appendChild(gradient);
      }

      pathElement.setAttribute("fill", `url(#${gradientId})`);
    }

    async function applyPatternToPath(
      targetSVG,
      pathElements,
      patternData,
      patternName,
      patternId
    ) {
      try {
        const response = await fetch(patternData.image);
        const contentType = response.headers.get("Content-Type");
        const isSVG = contentType && contentType.includes("image/svg+xml");

        if (!isSVG) {
          console.error("Pattern is not an SVG.");
          return;
        }

        const rawPatternSVG = await response.text();
        const parser = new DOMParser();
        const parsedDoc = parser.parseFromString(
          rawPatternSVG,
          "image/svg+xml"
        );
        const originalSVG = parsedDoc.querySelector("svg");

        if (!originalSVG) {
          console.error("No <svg> found in the pattern file.");
          return;
        }

        // Get or create defs
        const defs =
          targetSVG.querySelector("defs") ||
          targetSVG.insertBefore(
            document.createElementNS("http://www.w3.org/2000/svg", "defs"),
            targetSVG.firstChild
          );

        // Remove existing patterns with same name
        const existingPatterns = defs.querySelectorAll("pattern");
        existingPatterns.forEach((pat) => {
          if (pat.getAttribute("data-pattern-name") === patternName) {
            pat.remove();
          }
        });

        const oldInnerSVG = targetSVG.querySelector(`#svg_${patternName}`);
        if (oldInnerSVG) oldInnerSVG.remove();

        // Extract viewBox from original SVG
        const viewBoxAttr = originalSVG.getAttribute("viewBox");
        let viewBoxWidth, viewBoxHeight;

        if (viewBoxAttr) {
          const viewBox = viewBoxAttr.split(/\s+/);
          viewBoxWidth = parseFloat(viewBox[2]);
          viewBoxHeight = parseFloat(viewBox[3]);
        } else {
          // Fallback to width/height attributes
          viewBoxWidth = parseFloat(originalSVG.getAttribute("width")) || 28;
          viewBoxHeight = parseFloat(originalSVG.getAttribute("height")) || 49;
        }

        // Use pattern-specific scale if available, otherwise use default 1.2
        console.log("patternData ........... : ", patternData);

        const PATTERN_SCALE = patternData.scale || 1.2;

        // Create pattern element with proper dimensions
        const patternNode = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "pattern"
        );
        patternNode.setAttribute("id", patternId);
        patternNode.setAttribute("x", "0");
        patternNode.setAttribute("y", "0");
        patternNode.setAttribute("width", viewBoxWidth.toString());
        patternNode.setAttribute("height", viewBoxHeight.toString());
        patternNode.setAttribute("patternUnits", "userSpaceOnUse");
        patternNode.setAttribute("patternTransform", `scale(${PATTERN_SCALE})`);
        patternNode.setAttribute("data-pattern-name", patternName);

        // Create inner SVG with matching dimensions
        const innerSVG = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "svg"
        );
        innerSVG.setAttribute("id", `svg_${patternName}`);
        innerSVG.setAttribute("width", viewBoxWidth.toString());
        innerSVG.setAttribute("height", viewBoxHeight.toString());
        innerSVG.setAttribute(
          "viewBox",
          `0 0 ${viewBoxWidth} ${viewBoxHeight}`
        );

        // Get the color for this pattern from current product
        const partColor =
          productData?.patternColors?.[patternName.toUpperCase()] || "#000000";

        // For your specific hexagon pattern, we need to handle it differently
        // Clone the entire content but replace the fill color
        const originalContent = originalSVG.innerHTML;

        // Create a temporary div to manipulate the SVG content
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = originalContent;

        // Find and update all path elements
        const paths = tempDiv.querySelectorAll("path");
        paths.forEach((path) => {
          // Remove existing fill and stroke attributes
          path.removeAttribute("fill");
          path.removeAttribute("stroke");
          path.removeAttribute("stroke-width");
          path.removeAttribute("style");

          // Apply the new color
          path.setAttribute("fill", partColor);
          path.setAttribute("stroke", "none");
          path.setAttribute("stroke-width", "0");
        });

        // If no paths found, try to find any shapes
        if (paths.length === 0) {
          const shapes = tempDiv.querySelectorAll(
            "rect, circle, ellipse, polygon, polyline"
          );
          shapes.forEach((shape) => {
            shape.removeAttribute("fill");
            shape.removeAttribute("stroke");
            shape.removeAttribute("stroke-width");
            shape.removeAttribute("style");
            shape.setAttribute("fill", partColor);
            shape.setAttribute("stroke", "none");
            shape.setAttribute("stroke-width", "0");
          });
        }

        // Set the inner HTML of our innerSVG
        innerSVG.innerHTML = tempDiv.innerHTML;

        patternNode.appendChild(innerSVG);
        defs.appendChild(patternNode);

        // Get or create the scale group
        let gElement = targetSVG.querySelector("g#scale");
        if (!gElement) {
          gElement = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "g"
          );
          gElement.setAttribute("id", "scale");
          targetSVG.appendChild(gElement);
        }

        // Apply pattern to all path elements
        pathElements.forEach((pathElement, index) => {
          const originalId = pathElement.getAttribute("id");
          const elementLabel = (
            pathElement.getAttribute("elementname") || `part${index}`
          ).replace(/\s+/g, "_");
          const newId = `${originalId}_copy_${elementLabel}`;

          // Remove old copy if exists
          const oldCopy = gElement.querySelector(`path[id="${newId}"]`);
          if (oldCopy) oldCopy.remove();

          // Create new path with pattern fill
          const copyPath = pathElement.cloneNode(true);

          // Clean up attributes but keep essential ones
          const keepAttributes = ["d", "id", "transform"];
          [...copyPath.attributes].forEach((attr) => {
            if (!keepAttributes.includes(attr.name)) {
              copyPath.removeAttribute(attr.name);
            }
          });

          copyPath.setAttribute("id", newId);
          copyPath.setAttribute("fill", `url(#${patternId})`);
          copyPath.setAttribute("data-pattern-name", patternName);
          copyPath.setAttribute("data-element-name", elementLabel);

          gElement.appendChild(copyPath);
        });

        console.log(
          `Pattern '${patternName}' applied with color ${partColor}, scale ${PATTERN_SCALE} and dimensions ${viewBoxWidth}x${viewBoxHeight}`
        );
      } catch (err) {
        console.error("Failed to load or apply pattern:", err);
      }
    }
    async function loadTextureFromSVG(svgElement, size = 2048) {
      ////console.log("svgElement for pattern and color: ", svgElement);

      const svgClone = svgElement.cloneNode(true);

      ////console.log("svgClone : ", svgClone);

      const originalDefs = svgElement.querySelector("defs");
      ////console.log("originalDefs : ", originalDefs);
      if (originalDefs) {
        let clonedDefs = svgClone.querySelector("defs");

        if (!clonedDefs) {
          clonedDefs = originalDefs.cloneNode(true);
          svgClone.insertBefore(clonedDefs, svgClone.firstChild);
        }
      }

      svgClone.setAttribute("width", size);
      svgClone.setAttribute("height", size);
      svgClone.setAttribute("viewBox", `0 0 ${size} ${size}`);
      svgClone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
      svgClone.setAttribute("version", "1.1");

      const svgString = new XMLSerializer().serializeToString(svgClone);
      ////console.log("svgString: ", svgString);
      const imageUrl = `data:image/svg+xml;base64,${btoa(
        unescape(encodeURIComponent(svgString))
      )}`;

      ////console.log("imageUrl for pattern: ", imageUrl);

      const existing = document.getElementById("svg-preview-wrapper");
      if (existing) existing.remove();

      // const wrapper = document.createElement("div");
      // wrapper.id = "svg-preview-wrapper";
      // wrapper.style.cssText = `
      //   position: absolute; top: 20px; left: 520px;
      //   width: 320px; height: 100px;
      //   overflow: auto; border: 2px solid black;
      //   z-index: 9999; background: white; padding: 4px;
      // `;

      // const preview = document.createElement("img");
      // preview.src = imageUrl;
      // preview.style.width = "100%";
      // preview.style.outline = "3px solid blue";
      // wrapper.appendChild(preview);
      // document.body.appendChild(wrapper);

      return new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = "anonymous";

        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = size;
          canvas.height = size;

          const ctx = canvas.getContext("2d");
          ctx.clearRect(0, 0, size, size);

          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          const texture = new THREE.CanvasTexture(canvas);
          texture.needsUpdate = true;

          const debugImage = new Image();
          debugImage.src = texture.image.toDataURL("image/png");
          // debugImage.style.position = "absolute";
          // debugImage.style.top = "200px";
          // debugImage.style.left = "400px";
          // debugImage.style.width = "200px";
          // debugImage.style.border = "2px dashed green";
          // debugImage.alt = "CanvasTexture Preview";

          // document.body.appendChild(debugImage);

          resolve(texture);
        };

        img.onerror = (err) => {
          console.error("Image failed to load from SVG:", err);
          resolve(null);
        };

        img.src = imageUrl;
      });
    }

    const svgStateRef = useRef(null);
    function unwrapProxy(proxyObj) {
      if (proxyObj === null || typeof proxyObj !== "object") return proxyObj;
      if (Array.isArray(proxyObj)) return proxyObj.map(unwrapProxy);

      const plainObj = {};
      for (const key in proxyObj) {
        plainObj[key] = unwrapProxy(proxyObj[key]);
      }
      return plainObj;
    }

    const currentSvgUrlRef = useRef(null);

    console.log("partcolors : ", state.partColors);
console.log("productData ::::::::::::::::::::: ",productData)
console.log("svg new ::::::::::::::::: ", state.svg);
// Add this effect to force SVG updates when product changes
useEffect(() => {
  console.log("Product changed, forcing SVG update for product:", productData?.id);
  
  // Force a re-render of the SVG effect
  if (svgStateRef.current && productData?.id) {
    // Trigger the SVG update by updating the refetch condition
    currentSvgUrlRef.current = null; // Force refetch
    svgStateRef.current = null; // Clear cached SVG
    
    // Manually trigger the SVG update
    const timer = setTimeout(() => {
      if (state.svg) {
        fetch(`${state.svg}?cacheBust=${Date.now()}`)
          .then((res) => res.text())
          .then((svgText) => {
            const parser = new DOMParser();
            const baseSVG = parser
              .parseFromString(svgText, "image/svg+xml")
              .querySelector("svg");

            if (!baseSVG) {
              console.warn("SVG not found");
              return;
            }

            svgStateRef.current = baseSVG;
            currentSvgUrlRef.current = state.svg;
            
            // Trigger the update function
            updateAndRenderSVG();
          });
      }
    }, 100);
    
    return () => clearTimeout(timer);
  }
}, [productData?.id]);
// Move this function outside the useEffect
const updateAndRenderSVG = useCallback(async () => {
  console.log("updateAndRenderSVG called for product:", productData?.id);
  
  if (!svgStateRef.current) {
    console.log("No SVG state available, skipping");
    return;
  }
  
  const baseSVG = svgStateRef.current.cloneNode(true);
  const scaleGroup = baseSVG.querySelector("#scale");
  
  if (!scaleGroup) {
    console.log("No scale group found in SVG");
    return;
  }

  console.log("scaleGroup found:", scaleGroup);

  const partColors = productData?.partColors || {};
  const gradientColors = productData?.gradientColors || {};
  const unwrappedPattern = unwrapProxy(
    productData?.selectedPattern || {}
  );
  const normalizedPattern = Object.fromEntries(
    Object.entries(unwrappedPattern).map(([key, val]) => [
      key.toUpperCase(),
      val,
    ])
  );

  console.log("Applying from productData:", {
    partColors,
    gradientColors,
    normalizedPattern
  });

  const directColorParts = ["DESIGN", "LOGO", "NECK"];

  directColorParts.forEach((partName) => {
    const color = partColors?.[partName];
    if (!color) return;

    const groupObj = group.current;
    if (!groupObj) return;

    groupObj.traverse((child) => {
      if (!child.isMesh || !child.material) return;

      const materials = Array.isArray(child.material)
        ? child.material
        : [child.material];

      materials.forEach((mat) => {
        if (mat.name === partName) {
          mat.color.set(color);
          mat.needsUpdate = true;
        }
      });
    });
  });

  const patternApplyPromises = [];

  console.log("partMappings : ", partMappings);

  Object.entries(partMappings).forEach(
    ([materialName, targetElements]) => {
      const baseColor = partColors[materialName];
      const gradientColor = gradientColors[materialName];
      const patternData = normalizedPattern?.[materialName.toUpperCase()];

      console.log(`Processing ${materialName}:`, {
        baseColor,
        gradientColor,
        patternData: patternData?.image ? "Pattern exists" : "No pattern"
      });

      if ((!baseColor && !patternData) || !targetElements) return;

      const matchingPaths = Array.from(
        scaleGroup.querySelectorAll("path")
      ).filter((path) => {
        let nameAttr = null;
        path.getAttributeNames().forEach((attr) => {
          if (attr.toLowerCase() === "elementname") {
            nameAttr = path.getAttribute(attr);
          }
        });
        return (
          nameAttr && targetElements.includes(nameAttr.toUpperCase())
        );
      });

      console.log(`${materialName} - matching paths:`, matchingPaths.length);

      matchingPaths.forEach((path) => {
        if (patternData?.image) {
          if (materialName === "TEE") {
            const promise = applyPatternToPath(
              baseSVG,
              matchingPaths,
              patternData,
              materialName,
              `${materialName}_${patternData.name}`
            );
            patternApplyPromises.push(promise);
          } else {
            // apply individually
            matchingPaths.forEach((path) => {
              const promise = applyPatternToPath(
                baseSVG,
                [path], // wrap in array
                patternData,
                materialName,
                `${materialName}_${patternData.name}`
              );
              patternApplyPromises.push(promise);
            });
          }
        }

        if (baseColor && gradientColor) {
          applyGradientToPath(
            baseSVG,
            path,
            baseColor,
            gradientColor,
            `grad-${materialName}`
          );
        } else if (baseColor) {
          path.setAttribute("fill", baseColor);
        }
      });
    }
  );

  // Wait for all pattern fills to complete
  await Promise.all(patternApplyPromises);

  const texture = await loadTextureFromSVG(baseSVG);
  baseColorTextureRef.current = texture;

  group.current?.traverse((child) => {
    if (!child.isMesh || !child.material) return;

    const materials = Array.isArray(child.material)
      ? child.material
      : [child.material];

    materials.forEach((mat) => {
      if (!partMappings[mat.name]) return;

      mat.map?.dispose();
      mat.map = texture;
      mat.map.flipY = false;
      mat.map.colorSpace = THREE.SRGBColorSpace;
      mat.color.set("#ffffff");
      mat.needsUpdate = true;
    });
  });
  
  console.log("SVG update completed for product:", productData?.id);
}, [productData, partMappings, group.current]);

// Then update the useEffect to use this function
useEffect(() => {
  console.log("SVG Effect Triggered");
  
  if (!svgContainerRef.current) {
    return;
  }

  const shouldRefetch =
    !svgStateRef.current || currentSvgUrlRef.current !== state.svg;

  if (shouldRefetch) {
    fetch(`${state.svg}?cacheBust=${Date.now()}`)
      .then((res) => res.text())
      .then((svgText) => {
        const parser = new DOMParser();
        const baseSVG = parser
          .parseFromString(svgText, "image/svg+xml")
          .querySelector("svg");

        if (!baseSVG) {
          console.warn("SVG not found");
          return;
        }

        svgStateRef.current = baseSVG;
        currentSvgUrlRef.current = state.svg;
        
        // Call the external function
        updateAndRenderSVG();
      });
  } else {
    // Call the external function
    updateAndRenderSVG();
  }
}, [
  state.svg,
  updateAndRenderSVG // Add this as dependency
]);
    useEffect(() => {
      console.log("svg new : ", state.svg);
      if (!svgContainerRef.current) return;

      // Check if SVG URL has changed
      const shouldRefetch =
        !svgStateRef.current || currentSvgUrlRef.current !== state.svg;

      if (shouldRefetch) {
        fetch(`${state.svg}?cacheBust=${Date.now()}`)
          .then((res) => res.text())
          .then((svgText) => {
            console.log("svgText : ", svgText);
            const parser = new DOMParser();
            const baseSVG = parser
              .parseFromString(svgText, "image/svg+xml")
              .querySelector("svg");

            console.log("baseSVG : ", baseSVG);

            if (!baseSVG) {
              console.warn("SVG not found");
              return;
            }

            svgStateRef.current = baseSVG;
            currentSvgUrlRef.current = state.svg; // Track current SVG URL
            updateAndRenderSVG();
          });
      } else {
        updateAndRenderSVG();
      }

      async function updateAndRenderSVG() {
        const baseSVG = svgStateRef.current.cloneNode(true);
        const scaleGroup = baseSVG.querySelector("#scale");
        console.log("scaleGroup : ", scaleGroup);
        if (!scaleGroup) return;

        // Use productData instead of snap
        const partColors = productData?.partColors || {};
        const gradientColors = productData?.gradientColors || {};
        const unwrappedPattern = unwrapProxy(
          productData?.selectedPattern || {}
        );
        const normalizedPattern = Object.fromEntries(
          Object.entries(unwrappedPattern).map(([key, val]) => [
            key.toUpperCase(),
            val,
          ])
        );

        const directColorParts = ["DESIGN", "LOGO", "NECK"];

        directColorParts.forEach((partName) => {
          const color = partColors?.[partName];
          if (!color) return;

          const groupObj = group.current;
          if (!groupObj) return;

          groupObj.traverse((child) => {
            if (!child.isMesh || !child.material) return;

            const materials = Array.isArray(child.material)
              ? child.material
              : [child.material];

            materials.forEach((mat) => {
              if (mat.name === partName) {
                mat.color.set(color);
                mat.needsUpdate = true;
              }
            });
          });
        });

        const patternApplyPromises = [];

        console.log("partMappings : ", partMappings);

        Object.entries(partMappings).forEach(
          ([materialName, targetElements]) => {
            const baseColor = partColors[materialName];
            const gradientColor = gradientColors[materialName];
            const patternData = normalizedPattern?.[materialName.toUpperCase()];

            console.log("baseColor : ", baseColor);

            if ((!baseColor && !patternData) || !targetElements) return;

            const matchingPaths = Array.from(
              scaleGroup.querySelectorAll("path")
            ).filter((path) => {
              let nameAttr = null;
              path.getAttributeNames().forEach((attr) => {
                if (attr.toLowerCase() === "elementname") {
                  nameAttr = path.getAttribute(attr);
                }
              });
              return (
                nameAttr && targetElements.includes(nameAttr.toUpperCase())
              );
            });

            matchingPaths.forEach((path) => {
              if (patternData?.image) {
                if (materialName === "TEE") {
                  const promise = applyPatternToPath(
                    baseSVG,
                    matchingPaths,
                    patternData,
                    materialName,
                    `${materialName}_${patternData.name}`
                  );
                  patternApplyPromises.push(promise);
                } else {
                  // apply individually
                  matchingPaths.forEach((path) => {
                    const promise = applyPatternToPath(
                      baseSVG,
                      [path], // wrap in array
                      patternData,
                      materialName,
                      `${materialName}_${patternData.name}`
                    );
                    patternApplyPromises.push(promise);
                  });
                }
              }

              if (baseColor && gradientColor) {
                applyGradientToPath(
                  baseSVG,
                  path,
                  baseColor,
                  gradientColor,
                  `grad-${materialName}`
                );
              } else if (baseColor) {
                path.setAttribute("fill", baseColor);
              }
            });
          }
        );

        // Wait for all pattern fills to complete
        await Promise.all(patternApplyPromises);

        const texture = await loadTextureFromSVG(baseSVG);
        baseColorTextureRef.current = texture;

        group.current?.traverse((child) => {
          if (!child.isMesh || !child.material) return;

          const materials = Array.isArray(child.material)
            ? child.material
            : [child.material];

          materials.forEach((mat) => {
            if (!partMappings[mat.name]) return;

            mat.map?.dispose();
            mat.map = texture;
            mat.map.flipY = false;
            mat.map.colorSpace = THREE.SRGBColorSpace;
            mat.color.set("#ffffff");
            mat.needsUpdate = true;
          });
        });
      }
    }, [
         productData?.id,
      productData?.partColors,
      productData?.gradientColors,
      productData?.selectedPattern,
      productData?.patternColors,
      state.svg,
      currentProduct
    ]);

    const logoTexture = useMemo(() => {
      if (!productData?.frontLogo) return null;
      // Create a larger canvas with logo centered and smaller
      const canvas = document.createElement("canvas");
      canvas.width = 2048;  // Increased canvas size for better quality
      canvas.height = 2048; // Increased canvas size for better quality
      const ctx = canvas.getContext("2d", { alpha: true });
      
      // Enable image smoothing for better quality
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      
      // Clear canvas with transparent background
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Create texture from the canvas
      const texture = new THREE.CanvasTexture(canvas);
      texture.colorSpace = THREE.SRGBColorSpace;
      texture.premultiplyAlpha = false; // Changed to false for better transparency
      texture.generateMipmaps = true; // Enable mipmaps for better quality
      texture.minFilter = THREE.LinearMipmapLinearFilter;
      texture.magFilter = THREE.LinearFilter;

      // Create an image to load the logo
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          // Clear canvas again before drawing
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          
          // Set logo width to 800px while preserving aspect ratio (increased for better visibility)
          const targetWidth = 800; // Fixed width of 800px
          const imgWidth = img.naturalWidth || img.width;
          const imgHeight = img.naturalHeight || img.height;
          
          // Calculate height to maintain aspect ratio
          const aspectRatio = imgHeight / imgWidth;
          const drawWidth = targetWidth;
          const drawHeight = targetWidth * aspectRatio;
          
          // Center the logo on the canvas
          const x = (canvas.width - drawWidth) / 2;
          const y = (canvas.height - drawHeight) / 2;
          
          // Draw the image centered and smaller
          ctx.drawImage(img, 0, 0, img.naturalWidth || img.width, img.naturalHeight || img.height, x, y, drawWidth, drawHeight);
          
          // Force texture update
          texture.needsUpdate = true;
        } catch (error) {
          console.error("Error drawing logo to canvas:", error);
        }
      };
      img.onerror = (error) => {
        console.error("Error loading logo image:", error);
      };
      img.src = productData.frontLogo;

      return texture;
    }, [productData?.frontLogo]);

    const logoTextureBack = useMemo(() => {
      if (!productData?.backLogo) return null;
      // Create a larger canvas with logo centered and smaller
      const canvas = document.createElement("canvas");
      canvas.width = 2048;  // Increased canvas size for better quality
      canvas.height = 2048; // Increased canvas size for better quality
      const ctx = canvas.getContext("2d", { alpha: true });
      
      // Enable image smoothing for better quality
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      
      // Clear canvas with transparent background
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Create texture from the canvas
      const texture = new THREE.CanvasTexture(canvas);
      texture.colorSpace = THREE.SRGBColorSpace;
      texture.premultiplyAlpha = false; // Changed to false for better transparency
      texture.generateMipmaps = true; // Enable mipmaps for better quality
      texture.minFilter = THREE.LinearMipmapLinearFilter;
      texture.magFilter = THREE.LinearFilter;

      // Create an image to load the logo
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          // Clear canvas again before drawing
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          
          // Set logo width to 800px while preserving aspect ratio (increased for better visibility)
          const targetWidth = 800; // Fixed width of 800px
          const imgWidth = img.naturalWidth || img.width;
          const imgHeight = img.naturalHeight || img.height;
          
          // Calculate height to maintain aspect ratio
          const aspectRatio = imgHeight / imgWidth;
          const drawWidth = targetWidth;
          const drawHeight = targetWidth * aspectRatio;
          
          // Center the logo on the canvas
          const x = (canvas.width - drawWidth) / 2;
          const y = (canvas.height - drawHeight) / 2;
          
          // Draw the image centered and smaller
          ctx.drawImage(img, 0, 0, img.naturalWidth || img.width, img.naturalHeight || img.height, x, y, drawWidth, drawHeight);
          
          // Force texture update
          texture.needsUpdate = true;
        } catch (error) {
          console.error("Error drawing logo to canvas:", error);
        }
      };
      img.onerror = (error) => {
        console.error("Error loading logo image:", error);
      };
      img.src = productData.backLogo;

      return texture;
    }, [productData?.backLogo]);

    useEffect(() => {
      if (logoTexture) {
        logoTexture.needsUpdate = true;
      }
    }, [logoTexture]);

    useEffect(() => {
      if (logoTextureBack) {
        logoTextureBack.needsUpdate = true;
      }
    }, [logoTextureBack]);

    const createCanvasTexture = () => {
      const canvas = document.createElement("canvas");
      canvas.width = 1024;
      canvas.height = 512;
      return new CanvasTexture(canvas);
    };

    const frontTextTexture = useRef(createCanvasTexture());
    const backTextTexture = useRef(createCanvasTexture());
    const frontNumberTexture = useRef(createCanvasTexture());
    const backNumberTexture = useRef(createCanvasTexture());

    // const updateTexture = (
    //   text,
    //   textureRef,
    //   partName,
    //   fontFamily,
    //   colorType = "text"
    // ) => {
    //   if (!text || !textureRef.current) return;

    //   const canvas = textureRef.current.image;
    //   const ctx = canvas.getContext("2d");

    //   if (!ctx) {
    //     console.error("Canvas context not found.");
    //     return;
    //   }

    //   ctx.clearRect(0, 0, canvas.width, canvas.height);

    //   // Use different color properties based on colorType
    //   let color;
    //   if (colorType === "text") {
    //     // For text: use textColors.front or textColors.back from current product
    //     color = partName.includes("front")
    //       ? productData?.textColors?.front || "#ffffff"
    //       : productData?.textColors?.back || "#ffffff";
    //   } else if (colorType === "number") {
    //     // For numbers: use numberColors.front or numberColors.back from current product
    //     color = partName.includes("front")
    //       ? productData?.numberColors?.front || "#ffffff"
    //       : productData?.numberColors?.back || "#ffffff";
    //   } else {
    //     // Fallback
    //     color = "#ffffff";
    //   }

    //   ctx.fillStyle = color;
    //   ctx.font = `bold 80px ${fontFamily}`;
    //   ctx.textAlign = "center";
    //   ctx.textBaseline = "middle";
    //   ctx.fillText(text, canvas.width / 2, canvas.height / 2);

    //   textureRef.current.needsUpdate = true;
    // };

    // useEffect(() => {
    //   // For front text
    //   updateTexture(
    //     productData?.frontText || "",
    //     frontTextTexture,
    //     "front",
    //     productData?.textFonts?.front || productData?.selectedFonts || "Arial",
    //     "text"
    //   );

    //   // For back text
    //   updateTexture(
    //     productData?.backText || "",
    //     backTextTexture,
    //     "back",
    //     productData?.textFonts?.back || productData?.selectedFonts || "Arial",
    //     "text"
    //   );

    //   // For front number - use number colors
    //   updateTexture(
    //     productData?.frontNumber || "",
    //     frontNumberTexture,
    //     "frontNumber",
    //     productData?.numberFonts?.front || productData?.selectedFonts || "Arial",
    //     "number"
    //   );

    //   // For back number - use number colors
    //   updateTexture(
    //     productData?.backNumber || "",
    //     backNumberTexture,
    //     "backNumber",
    //     productData?.numberFonts?.back || productData?.selectedFonts || "Arial",
    //     "number"
    //   );
    // }, [
    //   productData?.frontText,
    //   productData?.backText,
    //   productData?.frontNumber,
    //   productData?.backNumber,
    //   productData?.textColors?.front,
    //   productData?.textColors?.back,
    //   productData?.numberColors?.front,
    //   productData?.numberColors?.back,
    //   productData?.textFonts?.front,
    //   productData?.textFonts?.back,
    //   productData?.numberFonts?.front,
    //   productData?.numberFonts?.back,
    //   productData?.selectedFonts,
    // ]);

    // useEffect(() => {
    //   // For front text
    //   updateTexture(
    //     snap.frontText,
    //     frontTextTexture,
    //     "front",
    //     state.textFonts?.front || state.selectedFonts,
    //     "text" // Specify this is text
    //   );

    //   // For back text
    //   updateTexture(
    //     snap.backText,
    //     backTextTexture,
    //     "back",
    //     state.textFonts?.back || state.selectedFonts,
    //     "text" // Specify this is text
    //   );

    //   // For front number - use number colors
    //   updateTexture(
    //     snap.frontNumber,
    //     frontNumberTexture,
    //     "frontNumber",
    //     state.numberFonts?.front || state.selectedFonts,
    //     "number" // Specify this is number
    //   );

    //   // For back number - use number colors
    //   updateTexture(
    //     snap.backNumber,
    //     backNumberTexture,
    //     "backNumber",
    //     state.numberFonts?.back || state.selectedFonts,
    //     "number" // Specify this is number
    //   );
    // }, [
    //   snap.frontText,
    //   snap.backText,
    //   snap.frontNumber,
    //   snap.backNumber,
    //   // Watch for text color changes
    //   snap.textColors?.front,
    //   snap.textColors?.back,
    //   // Watch for number color changes
    //   snap.numberColors?.front,
    //   snap.numberColors?.back,
    //   state.textFonts?.front,
    //   state.textFonts?.back,
    //   state.numberFonts?.front,
    //   state.numberFonts?.back,
    //   state.selectedFonts,
    // ]);

    useEffect(() => {
      console.log("Updating textures for product:", productData?.id);
      console.log("Front text:", productData?.frontText);
      console.log("Front number:", productData?.frontNumber);

      // For front text
      updateTexture(
        productData?.frontText || "",
        frontTextTexture,
        "front",
        productData?.textFonts?.front || productData?.selectedFonts || "Arial",
        "text"
      );

      // For back text
      updateTexture(
        productData?.backText || "",
        backTextTexture,
        "back",
        productData?.textFonts?.back || productData?.selectedFonts || "Arial",
        "text"
      );

      // For front number - use number colors
      updateTexture(
        productData?.frontNumber || "",
        frontNumberTexture,
        "frontNumber",
        productData?.numberFonts?.front ||
          productData?.selectedFonts ||
          "Arial",
        "number"
      );

      // For back number - use number colors
      updateTexture(
        productData?.backNumber || "",
        backNumberTexture,
        "backNumber",
        productData?.numberFonts?.back || productData?.selectedFonts || "Arial",
        "number"
      );
    }, [
      productData?.id, // Add this to trigger when product changes
      productData?.frontText,
      productData?.backText,
      productData?.frontNumber,
      productData?.backNumber,
      productData?.textColors?.front,
      productData?.textColors?.back,
      productData?.numberColors?.front,
      productData?.numberColors?.back,
      productData?.textFonts?.front,
      productData?.textFonts?.back,
      productData?.numberFonts?.front,
      productData?.numberFonts?.back,
      productData?.selectedFonts,
    ]);

    const updateTexture = (
      text,
      textureRef,
      partName,
      fontFamily,
      colorType = "text"
    ) => {
      if (!textureRef.current) return;

      const canvas = textureRef.current.image;
      const ctx = canvas.getContext("2d");

      if (!ctx) {
        console.error("Canvas context not found.");
        return;
      }

      // Always clear the canvas
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Only draw if there's text
      if (text && text.trim() !== "") {
        // Use different color properties based on colorType
        let color;
        if (colorType === "text") {
          // For text: use textColors.front or textColors.back from current product
          color = partName.includes("front")
            ? productData?.textColors?.front || "#ffffff"
            : productData?.textColors?.back || "#ffffff";
        } else if (colorType === "number") {
          // For numbers: use numberColors.front or numberColors.back from current product
          color = partName.includes("front")
            ? productData?.numberColors?.front || "#ffffff"
            : productData?.numberColors?.back || "#ffffff";
        } else {
          // Fallback
          color = "#ffffff";
        }

        ctx.fillStyle = color;
        ctx.font = `bold 80px ${fontFamily || "Arial"}`;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(text, canvas.width / 2, canvas.height / 2);
      }

      textureRef.current.needsUpdate = true;
    };

    // Remove or update this useEffect
    // useEffect(() => {
    //   updateTexture(snap.frontText, frontTextTexture, "front");
    //   updateTexture(snap.backText, backTextTexture, "back");
    //   updateTexture(snap.frontNumber, frontNumberTexture, "frontNumber");
    //   updateTexture(snap.backNumber, backNumberTexture, "backNumber");
    // }, [state.updateTrigger]);

    // Replace it with this:
    useEffect(() => {
      // Trigger texture updates when global updateTrigger changes
      if (productData) {
        updateTexture(
          productData.frontText || "",
          frontTextTexture,
          "front",
          productData.textFonts?.front || productData.selectedFonts || "Arial",
          "text"
        );

        updateTexture(
          productData.backText || "",
          backTextTexture,
          "back",
          productData.textFonts?.back || productData.selectedFonts || "Arial",
          "text"
        );

        updateTexture(
          productData.frontNumber || "",
          frontNumberTexture,
          "frontNumber",
          productData.numberFonts?.front ||
            productData.selectedFonts ||
            "Arial",
          "number"
        );

        updateTexture(
          productData.backNumber || "",
          backNumberTexture,
          "backNumber",
          productData.numberFonts?.back || productData.selectedFonts || "Arial",
          "number"
        );
      }
    }, [state.updateTrigger]);

    // ==========================================
    // CLEAN INTERACTION STATE - FROM SCRATCH
    // ==========================================
    const [interactionMode, setInteractionMode] = useState("idle"); // idle, dragging, resizing
    const [selectedDecal, setSelectedDecal] = useState(null); // Which decal is selected
    const [isDragging, setIsDragging] = useState(false);
    const [isResizing, setIsResizing] = useState(false);
    const [activeCorner, setActiveCorner] = useState(null); // tl, tr, bl, br
    const [dragStartPos, setDragStartPos] = useState({ x: 0, y: 0 });
    const [initialDecalPos, setInitialDecalPos] = useState([0, 0, 0]);
    const [initialDecalScale, setInitialDecalScale] = useState([1, 1, 1]);
    const hasDraggedRef = useRef(false); // Track if we actually moved during drag
    const dragStartPosRef = useRef({ x: 0, y: 0 });
    const initialDecalPosRef = useRef([0, 0, 0]);
    const lastDragPositionRef = useRef([0, 0, 0]);
    const selectedDecalDragRef = useRef(null);
    const rotationIntervalRef = useRef(null); // Legacy – unused when using rAF
    const rotationRAFRef = useRef(null); // For requestAnimationFrame-based continuous rotation
    const rotationDirectionRef = useRef(null); // Track rotation direction (clockwise/anticlockwise)
    const rotationLastTimeRef = useRef(0);

    const [decalPositions, setDecalPositions] = useState({
      frontText: frontTextPosition,
      backText: backTextPosition,
      frontNumber: frontNumberPosition,
      backNumber: backNumberPosition,
      frontLogo: frontLogoPosition,
      backLogo: backLogoPosition,
    });
    const [decalScales, setDecalScales] = useState({
      frontText: frontTextScale,
      backText: backTextScale,
      frontNumber: frontNumberScale,
      backNumber: backNumberScale,
      frontLogo: frontLogoScale,
      backLogo: backLogoScale,
    });

    const [decalRotations, setDecalRotations] = useState({
      frontText: 0,
      frontNumber: 0,
      frontLogo: 0,
      backText: 0,
      backNumber: 0,
      backLogo: 0,
    });

    console.log("decalRotations:", decalRotations);

    const transformTargetsRef = useRef({});
    const [transformMode, setTransformMode] = useState("translate");
    const [, setIsTransforming] = useState(false);

    useEffect(() => {
      const modelKey = state.newKey;

      if (modelKey === "eventordereventjersey") {
        console.log("state.selectedDesignId:", glbId);
        const designId = String(glbId || "902");

        console.log("Updating positions for event order design:", designId);

        let modelConfig = modelConfig1[modelKey]?.[designId];

        if (!modelConfig) {
          console.warn(
            "No config found for design ID:",
            designId,
            "falling back to 902"
          );
          modelConfig = modelConfig1[modelKey]?.["902"];
        }

        if (!modelConfig) {
          console.error("No valid config found even for fallback 902!");
          return;
        }

        console.log("Found config for design:", designId, modelConfig);

        setDecalPositions({
          frontText: modelConfig.frontTextPosition || [0, 0, 0],
          frontNumber: modelConfig.frontNumberPosition || [0, 0, 0],
          frontLogo: modelConfig.frontLogoPosition || [0, 0, 0],
          backText: modelConfig.backTextPosition || [0, 0, 0],
          backNumber: modelConfig.backNumberPosition || [0, 0, 0],
          backLogo: modelConfig.backLogoPosition || [0, 0, 0],
        });

        setDecalScales({
          frontText: modelConfig.frontTextScale || [1, 1, 1],
          frontNumber: modelConfig.frontNumberScale || [1, 1, 1],
          frontLogo: modelConfig.frontLogoScale || [1, 1, 1],
          backText: modelConfig.backTextScale || [1, 1, 1],
          backNumber: modelConfig.backNumberScale || [1, 1, 1],
          backLogo: modelConfig.backLogoScale || [1, 1, 1],
        });

        if (modelConfig.fontSize) setFontSizetext(modelConfig.fontSize);
        if (modelConfig.fontSizeNumber)
          setFontSizeNumber(modelConfig.fontSizeNumber);

        console.log("📍 Updated decal positions for design:", designId);
      }
    }, [glbId]);

    const [tempPosition, setTempPosition] = useState([0, 0, 0]);
    const [tempScale, setTempScale] = useState([0, 0, 0]);
    const [mouseStartPos, setMouseStartPos] = useState({ x: 0, y: 0 });
    const fabricCanvasCache = useRef({});
    const textureCache = useRef({});
    const lastOverlayClickTime = useRef(0);
    const [isFrontVisible, setIsFrontVisible] = useState(true);

    const rotateIconScreenPosRef = useRef({ x: 0, y: 0 });
    const rotateClickTimeRef = useRef(0);
    const [showRotateTooltip, setShowRotateTooltip] = useState(null);

    const [resizeArrowPosition, setResizeArrowPosition] = useState({
      x: 0,
      y: 0,
    });

    useEffect(() => {
      const handleTransformHotkeys = (event) => {
        if (!selectedDecal || !selectedDecal.toLowerCase().includes("text")) {
          return;
        }

        if (event.key === "t" || event.key === "T") {
          setTransformMode("translate");
        }

        if (event.key === "s" || event.key === "S") {
          setTransformMode("scale");
        }
      };

      window.addEventListener("keydown", handleTransformHotkeys);
      return () =>
        window.removeEventListener("keydown", handleTransformHotkeys);
    }, [selectedDecal]);

    const resizeArrowPositionRef = useRef({ x: 0, y: 0 });

    const getFabricCanvas = useCallback((type) => {
      if (fabricCanvasCache.current[type]) {
        return fabricCanvasCache.current[type];
      }

      const canvas = document.createElement("canvas");
      // Use smaller canvas for numbers to prevent head cutting off
      if (type.includes("Number")) {
        canvas.width = 400;  // Smaller canvas for numbers
        canvas.height = 200; // Smaller canvas for numbers
      } else {
        canvas.width = 512;  // Reduced from 1024 - smaller canvas for tighter text bounds
        canvas.height = 256; // Reduced from 512 - smaller canvas for tighter text bounds
      }

      const fabricCanvas = new fabric.Canvas(canvas, {
        enableRetinaScaling: false,
        renderOnAddRemove: false,
        selection: false,
        preserveObjectStacking: true,

        skipTargetFind: false,
        skipOffscreen: true,
        imageSmoothingEnabled: true,

        renderOnSelectionChange: false,

        allowTouchScrolling: false,
        fireRightClick: false,
        stopContextMenu: true,
      });

      fabricCanvasCache.current[type] = {
        canvas,
        fabricCanvas,
        texture: new THREE.CanvasTexture(canvas),
      };

      return fabricCanvasCache.current[type];
    }, []);

    useEffect(() => {
      return () => {
        Object.values(textureCache.current).forEach((texture) => {
          if (texture && texture.dispose) {
            texture.dispose();
          }
        });
        textureCache.current = {};
        fabricCanvasCache.current = {};
      };
    }, []);

        useEffect(() => {
      return () => {
        stopContinuousRotation();
      };
    }, [selectedDecal]);

    useEffect(() => {
      if (!selectedDecal) return;

      const handleKeyDown = (e) => {
        if (!selectedDecal) return;
        if (
          !["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)
        )
          return;

        e.preventDefault();
        const moveAmount = 0.01;
        const currentPos = [...decalPositions[selectedDecal]];

        //console.log("currentPos : ", currentPos);
        switch (e.key) {
          case "ArrowUp":
            currentPos[1] += moveAmount;
            break;
          case "ArrowDown":
            currentPos[1] -= moveAmount;
            break;
          case "ArrowLeft":
            currentPos[0] -= moveAmount;
            break;
          case "ArrowRight":
            currentPos[0] += moveAmount;
            break;
          default:
            break;
        }

        //console.log("currentPos : ", currentPos);
        setDecalPositions((prev) => ({
          ...prev,
          [selectedDecal]: currentPos,
        }));
        setTempPosition(currentPos);
      };
      window.addEventListener("keydown", handleKeyDown);
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }, [selectedDecal, decalPositions]);

    const handleDeselect = () => {
      setSelectedDecal(null);
      setResizeMode(false);
      setResizeCorner(null);
      setInitialScale(null);
      setIsDragging(false);
      setIsResizing(false);
      setActiveCorner(null);
      // Always set to rotate-shirt mode when deselecting to enable rotation
      setInteractionMode("rotate-shirt");

      Object.keys(fabricCanvasCache.current).forEach((type) => {
        const { fabricCanvas } = fabricCanvasCache.current[type];
        fabricCanvas.discardActiveObject();
        fabricCanvas.renderAll();
      });
    };

    const [fontSizetext, setFontSizetext] = useState(() => {
      const settings = getModelSettings(menuSlug, subcategorySlug);
      return settings.fontSize || 50; // Reduced from 80 to 50
    });

    const [fontSizeNumber, setFontSizeNumber] = useState(() => {
      const settings = getModelSettings(menuSlug, subcategorySlug);
      return settings.fontSizeNumber || 60; // Reduced from 80 to 60
    });


    const getTextTexture = useCallback(
      (type, textContent, color, font, isSelected) => {
        if (!textContent || textContent.trim() === "") return null;

        console.log("textContent : ", textContent);

        try {
          const { canvas, fabricCanvas, texture } = getFabricCanvas(type);

          fabricCanvas.clear();

          // No padding: keep text tight to texture for minimal gap from t-shirt
          const text = new fabric.Text(textContent, {
            left: canvas.width / 2,
            top: canvas.height / 2,
            originX: "center",
            originY: "center",
            fontSize: (fontSizetext || 80) * 1.35,  // Reduced by 20px from previous (1.6 * 80 = 128px, now 1.35 * 80 = 108px)
            fontWeight: "bold",
            fontFamily: font || "Arial",
            fill: color || "black",
            selectable: false,
            hasControls: false,
            hasBorders: false,
            padding: 0,
            borderColor: "transparent",
            cornerSize: 0,
            transparentCorners: true,
            lockUniScaling: false,
            hoverCursor: "default",
            moveCursor: "default",
            objectCaching: false,
            borderScaleFactor: 0,
            controls: {
              tr: new fabric.Control({
                x: 0.5,
                y: -0.5,
                actionHandler: fabric.controlsUtils.rotationWithSnapping,
                cursorStyleHandler: () => "crosshair",
                // render: function (ctx, left, top, styleOverride, fabricObject) {
                //   const size = 60;
                //   ctx.save();
                //   ctx.translate(left, top);
                //   ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));

                //   ctx.beginPath();

                //   ctx.arc(0, 0, size / 2, 0, 2 * Math.PI);
                //   ctx.fillStyle = "white";
                //   ctx.fill();
                //   ctx.strokeStyle = "black";
                //   ctx.lineWidth = 3;
                //   ctx.stroke();

                //   ctx.beginPath();
                //   ctx.moveTo(size * 0.25, -size * 0.25);
                //   ctx.lineTo(size * 0.5, 0);
                //   ctx.lineTo(size * 0.25, size * 0.25);
                //   ctx.lineWidth = 7;
                //   ctx.stroke();

                //   ctx.beginPath();
                //   ctx.arc(
                //     0,
                //     0,
                //     size * 0.35,
                //     -Math.PI * 0.25,
                //     Math.PI * 1.5,
                //     false
                //   );
                //   ctx.lineWidth = 7;
                //   ctx.stroke();

                //   ctx.restore();
                // },
                actionName: "rotate",
              }),
              br: new fabric.Control({
                x: 0.5,
                y: 0.5,
                actionHandler: fabric.controlsUtils.scalingEqually,
                cursorStyleHandler: () => "nwse-resize",
                render: function (ctx, left, top, styleOverride, fabricObject) {
                  const size = 60;
                  ctx.save();
                  ctx.translate(left, top);

                  ctx.beginPath();
                  ctx.rect(-size / 2, -size / 2, size, size);
                  ctx.fillStyle = "white";
                  ctx.fill();
                  ctx.strokeStyle = "black";
                  ctx.lineWidth = 3;
                  ctx.stroke();

                  ctx.beginPath();
                  // Main line
                  ctx.moveTo(-size * 0.35, -size * 0.35);
                  ctx.lineTo(size * 0.35, size * 0.35);

                  // Arrowhead
                  ctx.moveTo(size * 0.35, size * 0.35);
                  ctx.lineTo(size * 0.2, size * 0.35);
                  ctx.lineTo(size * 0.35, size * 0.2);
                  ctx.closePath();

                  ctx.fillStyle = "black";
                  ctx.fill();
                  ctx.strokeStyle = "black";
                  ctx.lineWidth = 7;
                  ctx.stroke();

                  ctx.restore();
                },
                actionName: "scale",
              }),
            },
          });

          text.set({
            stroke: color || "black",
            strokeWidth: 1,
            strokeUniform: true,
          });

          fabricCanvas.add(text);

          if (isSelected) {
            fabricCanvas.setActiveObject(text);
            text.bringToFront();

            text.on("rotating", function (e) {
              const angle = e.target.angle;
              if (type.includes("front")) {
                frontTextRotation[2] = THREE.MathUtils.degToRad(angle);
              } else {
                backTextRotation[2] = THREE.MathUtils.degToRad(angle);
              }
            });

            text.on("scaling", function (e) {
              const scale = e.target.scaleX;
              if (type.includes("front")) {
                frontTextScale[0] = scale;
                frontTextScale[1] = scale;
              } else {
                backTextScale[0] = scale;
                backTextScale[1] = scale;
              }
            });

            // Disabled arrow creation for new resize feature
            // requestAnimationFrame(() => {
            //   const textBounds = text.getBoundingRect();
            //   calculateAndStoreArrowPosition(type, textBounds);
            // });
          }

          // Render fabric canvas and update texture
          fabricCanvas.renderAll();
          texture.needsUpdate = true;

          return texture;
        } catch (error) {
          console.error("Error creating text texture:", error);

          // Fallback canvas drawing
          const fallbackCanvas = document.createElement("canvas");
          fallbackCanvas.width = 512;  // Reduced canvas size
          fallbackCanvas.height = 256; // Reduced canvas size
          const ctx = fallbackCanvas.getContext("2d");

          ctx.fillStyle = color || "white";
          ctx.font = `108px ${font || "Arial"}`;  // Reduced by 20px (1.35 * 80 = 108px)
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText(
            textContent,
            fallbackCanvas.width / 2,
            fallbackCanvas.height / 2
          );

          return new THREE.CanvasTexture(fallbackCanvas);
        }
      },
      [getFabricCanvas, fontSizetext]
    );

    const getNumberTexture = useCallback(
      (type, textContent, color, font, isSelected) => {
        if (!textContent || textContent.trim() === "") return null;

        try {
          const { canvas, fabricCanvas, texture } = getFabricCanvas(type);

          fabricCanvas.clear();

          const text = new fabric.Text(textContent, {
            left: canvas.width / 2,
            top: canvas.height / 2,
            originX: "center",
            originY: "center",
            fontSize: (fontSizeNumber || 80) * 0.55,  // Reduced by 40px for numbers (was 84px, now 0.55 * 80 = 44px)
            fontWeight: "bold",
            fontFamily: font || "Arial",
            fill: color || "black",
            selectable: false,
            hasControls: false,
            hasBorders: false,
            borderColor: "transparent",
            cornerSize: 0,
            transparentCorners: true,
            lockUniScaling: false,
            hoverCursor: "default",
            moveCursor: "default",
            objectCaching: false,
            borderScaleFactor: 0,
            controls: {
              tr: new fabric.Control({
                x: 0.5,
                y: -0.5,
                actionHandler: fabric.controlsUtils.rotationWithSnapping,
                cursorStyleHandler: () => "crosshair",
                // render: function (ctx, left, top, styleOverride, fabricObject) {
                //   const size = 60;
                //   ctx.save();
                //   ctx.translate(left, top);
                //   ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
                //   ctx.beginPath();
                //   ctx.arc(0, 0, size / 2, 0, 2 * Math.PI);
                //   ctx.fillStyle = "white";
                //   ctx.fill();
                //   ctx.strokeStyle = "black";
                //   ctx.lineWidth = 3;
                //   ctx.stroke();

                //   ctx.beginPath();
                //   ctx.moveTo(size * 0.25, -size * 0.25);
                //   ctx.lineTo(size * 0.5, 0);
                //   ctx.lineTo(size * 0.25, size * 0.25);
                //   ctx.lineWidth = 7;
                //   ctx.stroke();

                //   ctx.beginPath();
                //   ctx.arc(
                //     0,
                //     0,
                //     size * 0.35,
                //     -Math.PI * 0.25,
                //     Math.PI * 1.5,
                //     false
                //   );
                //   ctx.lineWidth = 7;
                //   ctx.stroke();

                //   ctx.restore();
                // },
                actionName: "rotate",
              }),
              br: new fabric.Control({
                x: 0.5,
                y: 0.5,
                actionHandler: fabric.controlsUtils.scalingEqually,
                cursorStyleHandler: () => "nwse-resize",
                render: function (ctx, left, top, styleOverride, fabricObject) {
                  const size = 60;
                  ctx.save();
                  ctx.translate(left, top);

                  ctx.beginPath();
                  ctx.rect(-size / 2, -size / 2, size, size);
                  ctx.fillStyle = "white";
                  ctx.fill();
                  ctx.strokeStyle = "black";
                  ctx.lineWidth = 3;
                  ctx.stroke();

                  ctx.beginPath();

                  ctx.moveTo(-size * 0.35, -size * 0.35);
                  ctx.lineTo(size * 0.35, size * 0.35);

                  ctx.moveTo(size * 0.35, size * 0.35);
                  ctx.lineTo(size * 0.2, size * 0.35);
                  ctx.lineTo(size * 0.35, size * 0.2);
                  ctx.closePath();

                  ctx.fillStyle = "black";
                  ctx.fill();
                  ctx.strokeStyle = "black";
                  ctx.lineWidth = 7;
                  ctx.stroke();

                  ctx.restore();
                },
                actionName: "scale",
              }),
            },
          });

          // Slight stroke to harden number edges
          text.set({
            stroke: color || "black",
            strokeWidth: 1,
            strokeUniform: true,
          });

          // Add to canvas
          fabricCanvas.add(text);

          if (isSelected) {
            fabricCanvas.setActiveObject(text);
            text.bringToFront();

            // Rotation tracking
            text.on("rotating", function (e) {
              const angle = e.target.angle;
              if (type.includes("front")) {
                frontNumberRotation[2] = THREE.MathUtils.degToRad(angle);
              } else {
                backNumberRotation[2] = THREE.MathUtils.degToRad(angle);
              }
            });

            // Scaling tracking
            text.on("scaling", function (e) {
              const scale = e.target.scaleX;
              if (type.includes("front")) {
                frontNumberScale[0] = frontNumberScale[1] = scale;
              } else {
                backNumberScale[0] = backNumberScale[1] = scale;
              }
            });

            // Disabled arrow creation for new resize feature
            // requestAnimationFrame(() => {
            //   const textBounds = text.getBoundingRect();
            //   calculateAndStoreArrowPosition(type, textBounds);
            // });
          }

          fabricCanvas.renderAll();
          texture.needsUpdate = true;

          return texture;
        } catch (error) {
          console.error("Error creating number texture:", error);

          // Fallback 2D canvas version
          const fallbackCanvas = document.createElement("canvas");
          fallbackCanvas.width = 400;  // Smaller canvas for numbers
          fallbackCanvas.height = 200; // Smaller canvas for numbers
          const ctx = fallbackCanvas.getContext("2d");

          ctx.fillStyle = color || "white";
          ctx.font = `44px ${font || "Arial"}`;  // Reduced by 40px for numbers (was 84px, now 44px)
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText(
            textContent,
            fallbackCanvas.width / 2,
            fallbackCanvas.height / 2
          );

          return new THREE.CanvasTexture(fallbackCanvas);
        }
      },
      [getFabricCanvas, fontSizeNumber]
    );

    // Maintain decal aspect ratio to prevent squishing when multiple overlays overlap
    const getAspectAwareScale = useCallback((type, baseScale, texture) => {
      const scaleArray = Array.isArray(baseScale)
        ? baseScale
        : [baseScale, baseScale, baseScale];
      const base = scaleArray[0] || 1;

      // Default aspect is square
      let aspect = 1;

      // Text and number canvases use 1024x512 => height/width = 0.5
      if (type.includes("Text") || type.includes("Number")) {
        aspect = 512 / 1024;
      }

      // Logos: use the actual texture dimensions when available
      if (
        type.includes("Logo") &&
        texture &&
        texture.image &&
        texture.image.width &&
        texture.image.height
      ) {
        aspect = texture.image.height / texture.image.width;
      }

      // Keep Z as original if provided
      const z = scaleArray[2] !== undefined ? scaleArray[2] : base;
      return [base, base * aspect, z];
    }, []);

    

    const [resizeMode, setResizeMode] = useState(false);
    const [resizeStartPos, setResizeStartPos] = useState({ x: 0, y: 0 });
    const [initialScale, setInitialScale] = useState(null);
    const [resizeCorner, setResizeCorner] = useState(null);
    const [resizeBorderVisible, setResizeBorderVisible] = useState(false);
    const selectedDecalRef = useRef(null);
    const [pendingResizeEvent, setPendingResizeEvent] = useState(null);

    // NEW RESIZE FEATURE - Completely separate from existing functions
    const [newResizeActive, setNewResizeActive] = useState(false);
    const [newResizeStartPos, setNewResizeStartPos] = useState({ x: 0, y: 0 });
    const [newResizeInitialScale, setNewResizeInitialScale] = useState(null);
    const [newResizeSelectedDecal, setNewResizeSelectedDecal] = useState(null);
    const [newResizeTempScale, setNewResizeTempScale] = useState([0, 0, 0]);
    const [newResizeCorner, setNewResizeCorner] = useState(null);

     // REPLACE your detectCornerClick function with this updated version:
    const detectCornerClick = (e, decalType, camera) => {
      console.log("Corner Detection start");
      console.log(`selectedDecal: ${selectedDecal}, decalType: ${decalType}`);

      if (!selectedDecal && !decalType) {
        console.log("No selected decal or decal type");
        return false;
      }

      const position = decalPositions[decalType];
      const currentScale = decalScales[decalType];

      if (!camera || !position || !currentScale) {
        console.error("Camera, position, or scale missing");
        return false;
      }

      console.log(`Position: ${position}, Scale: ${currentScale}`);

      // Get model-specific configuration
      const modelKey = state.newKey;
      let modelConfig = modelConfig1[modelKey];

      // SPECIAL HANDLING for eventordereventjersey - it has subcategories
      if (modelKey === "eventordereventjersey" && state.selectedDesignId) {
        modelConfig =
          modelConfig1[modelKey][state.selectedDesignId] ||
          modelConfig1[modelKey];
        console.log(
          `Using eventorder category: ${state.selectedDesignId}`,
          modelConfig
        );
      }

      console.log(`Model: ${modelKey}`, modelConfig);

      // MODEL-SPECIFIC CORNER DETECTION CALCULATION
      let threshold = 50;
      let widthDivisor = 10;
      let heightDivisor = 10;

      if (modelConfig && currentScale) {
        const overallScale = modelConfig.overallScale || 1;
        const modelScale = Array.isArray(modelConfig.scale)
          ? modelConfig.scale[0]
          : modelConfig.scale || 1;
        const currentScaleX = currentScale[0] || 1;
        const currentScaleY = currentScale[1] || 1;

        console.log(
          `Model: ${modelKey}, DesignID: ${state.selectedDesignId}, Scale analysis:`,
          {
            overallScale,
            modelScale,
            currentScaleX,
            currentScaleY,
          }
        );

        if (modelKey === "menmenjersey") {
          widthDivisor = 8;
          heightDivisor = 8;
          threshold = 60;
        } else if (modelKey === "eventordereventjersey") {
          const designId = state.selectedDesignId;
          if (designId === "900" || designId === 900) {
            widthDivisor = 3;
            heightDivisor = 4;
            threshold = 70;
          } else if (designId === "901" || designId === 901) {
            widthDivisor = 2.5;
            heightDivisor = 3;
            threshold = 80;
          } else if (designId === "902" || designId === 902) {
            widthDivisor = 8;
            heightDivisor = 8;
            threshold = 60;
          } else if (designId === "903" || designId === 903) {
            widthDivisor = 2;
            heightDivisor = 2.5;
            threshold = 75;
          } else if (designId === "904" || designId === 904) {
            widthDivisor = 3;
            heightDivisor = 3.5;
            threshold = 70;
          } else {
            widthDivisor = 3;
            heightDivisor = 4;
            threshold = 70;
          }
        } else if (modelKey === "womenwomenfootballjersey") {
          widthDivisor = 6;
          heightDivisor = 6;
          threshold = 65;
        } else if (
          modelKey === "menmencricketshorts" ||
          modelKey === "menmenshorts"
        ) {
          widthDivisor = 4;
          heightDivisor = 5;
          threshold = 70;
        } else if (modelKey === "womenwomenbadmintonshorts") {
          widthDivisor = 3.5;
          heightDivisor = 4;
          threshold = 65;
        } else if (modelKey === "womenwomentrackpants") {
          widthDivisor = 4;
          heightDivisor = 5;
          threshold = 60;
        } else if (modelKey === "womenwomencyclingjersey") {
          widthDivisor = 15;
          heightDivisor = 15;
          threshold = 45;
        } else if (modelKey === "menmentanktop") {
          widthDivisor = 3;
          heightDivisor = 3.5;
          threshold = 70;
        } else if (modelKey === "menmencyclingjersey") {
          widthDivisor = 2.5;
          heightDivisor = 3;
          threshold = 80;
        } else if (modelKey === "menmentrackpants") {
          widthDivisor = 5;
          heightDivisor = 6;
          threshold = 65;
        } else if (modelKey === "menmencricketjersey") {
          widthDivisor = 8;
          heightDivisor = 8;
          threshold = 60;
        } else if (modelKey === "menmenarmsleeves") {
          widthDivisor = 2.5;
          heightDivisor = 3;
          threshold = 75;
        } else if (modelKey === "menmenbasketballshorts") {
          widthDivisor = 4.5;
          heightDivisor = 5;
          threshold = 65;
        } else if (modelKey === "womenwomenbadmintonjersey") {
          widthDivisor = 2;
          heightDivisor = 2.5;
          threshold = 75;
        } else if (modelKey === "menmensoccerjersey") {
          widthDivisor = 2;
          heightDivisor = 2.5;
          threshold = 80;
        } else if (modelKey === "womenwomenjersey") {
          widthDivisor = 3;
          heightDivisor = 3.5;
          threshold = 70;
        } else if (modelKey === "menmenbasketballjersey") {
          widthDivisor = 3;
          heightDivisor = 3.5;
          threshold = 70;
        } else if (modelKey === "kidskidsbasketballjersey") {
          widthDivisor = 3;
          heightDivisor = 3.5;
          threshold = 70;
        } else if (modelKey === "menmencitycollection") {
          widthDivisor = 2;
          heightDivisor = 2.5;
          threshold = 75;
        } else if (modelKey === "menmenxjersey") {
          widthDivisor = 2;
          heightDivisor = 2.5;
          threshold = 75;
        } else if (modelKey === "kidskidscricketshorts") {
          widthDivisor = 4.5;
          heightDivisor = 5;
          threshold = 65;
        } else if (modelKey === "kidskidsshorts") {
          widthDivisor = 4.5;
          heightDivisor = 5;
          threshold = 65;
        } else if (modelKey === "menmenfootballjersey") {
          widthDivisor = 2.5;
          heightDivisor = 3;
          threshold = 75;
        } else if (modelKey === "womenwomencricketjersey") {
          widthDivisor = 3.5;
          heightDivisor = 4;
          threshold = 65;
        } else if (modelKey === "womenwomenbadmintontanktop") {
          widthDivisor = 7;
          heightDivisor = 7;
          threshold = 55;
        } else if (modelKey === "womenwomenxjersey") {
          widthDivisor = 5;
          heightDivisor = 5;
          threshold = 60;
        } else if (modelKey === "kidskidscricketjersey") {
          widthDivisor = 3;
          heightDivisor = 4;
          threshold = 70;
        } else if (modelKey === "kidskidscyclingjersey") {
          widthDivisor = 4;
          heightDivisor = 5;
          threshold = 65;
        } else if (modelKey === "kidskidsjersey") {
          widthDivisor = 4;
          heightDivisor = 5;
          threshold = 65;
        } else if (modelKey === "kidskidstanktop") {
          widthDivisor = 3;
          heightDivisor = 3.5;
          threshold = 70;
        } else if (modelKey === "kidskidsbasictshirt") {
          widthDivisor = 4;
          heightDivisor = 4.5;
          threshold = 65;
        } else if (modelKey === "womenwomencompressionpants") {
          widthDivisor = 3.5;
          heightDivisor = 4;
          threshold = 65;
        } else {
          widthDivisor = 5;
          heightDivisor = 6;
          threshold = 60;
        }

        console.log(`Corner detection config:`, {
          widthDivisor: widthDivisor.toFixed(2),
          heightDivisor: heightDivisor.toFixed(2),
          threshold: threshold.toFixed(2),
        });
      }

      const getEventCoords = (event) => {
        if (event.touches && event.touches.length > 0) {
          return { x: event.touches[0].clientX, y: event.touches[0].clientY };
        }
        return { x: event.clientX, y: event.clientY };
      };

      const coords = getEventCoords(e);
      const clickX = coords.x;
      const clickY = coords.y;

      console.log(`Click coordinates: [${clickX}, ${clickY}]`);

      const center3D = new THREE.Vector3(...position);
      console.log("3D Center Position: ", center3D);

      let adjustedPosition = center3D.clone();

      console.log("Adjusted 3D Position: ", adjustedPosition);

      const projectedCenter = adjustedPosition.clone().project(camera);
      console.log("Projected Center: ", projectedCenter);

      // FIXED: Better validation for projected coordinates
      if (
        Math.abs(projectedCenter.x) > 3 ||
        Math.abs(projectedCenter.y) > 3 ||
        projectedCenter.z <= 0 ||
        projectedCenter.z > 1
      ) {
        console.error("❌ Projected coordinates are invalid");
        console.log(
          `Raw projected: [${projectedCenter.x}, ${projectedCenter.y}, ${projectedCenter.z}]`
        );
        return false;
      }

      const screenCenterX = (projectedCenter.x * 0.5 + 0.5) * window.innerWidth;
      const screenCenterY =
        (1 - (projectedCenter.y * 0.5 + 0.5)) * window.innerHeight;

      console.log(
        `📺 Screen center: [${screenCenterX.toFixed(
          2
        )}, ${screenCenterY.toFixed(2)}]`
      );

      let normalizedScaleX = Math.min(currentScale[0] / 50, 1);
      let normalizedScaleY = Math.min(currentScale[1] / 50, 1);

      if (modelKey === "womenwomencyclingjersey") {
        normalizedScaleX = Math.min(currentScale[0] / 80, 0.8);
        normalizedScaleY = Math.min(currentScale[1] / 80, 0.8);
      }

      const screenHalfWidth =
        (normalizedScaleX * window.innerWidth) / widthDivisor;
      const screenHalfHeight =
        (normalizedScaleY * window.innerHeight) / heightDivisor;

      console.log(
        `Screen half dimensions: W=${screenHalfWidth.toFixed(
          2
        )}, H=${screenHalfHeight.toFixed(2)}`
      );

      const maxDimension = Math.min(window.innerWidth, window.innerHeight) / 4;
      const cappedWidth = Math.min(screenHalfWidth, maxDimension);
      const cappedHeight = Math.min(screenHalfHeight, maxDimension);

      if (
        cappedWidth !== screenHalfWidth ||
        cappedHeight !== screenHalfHeight
      ) {
        console.log(
          `Dimensions capped: W=${screenHalfWidth.toFixed(
            2
          )}->${cappedWidth.toFixed(2)}, H=${screenHalfHeight.toFixed(
            2
          )}->${cappedHeight.toFixed(2)}`
        );
      }

      console.log(
        `Capped dimensions: W=${cappedWidth.toFixed(
          2
        )}, H=${cappedHeight.toFixed(2)}`
      );

      const corners = {
        tl: {
          x: screenCenterX - cappedWidth,
          y: screenCenterY - cappedHeight,
          type: "tl",
        },
        tr: {
          x: screenCenterX + cappedWidth,
          y: screenCenterY - cappedHeight,
          type: "tr",
        },
        bl: {
          x: screenCenterX - cappedWidth,
          y: screenCenterY + cappedHeight,
          type: "bl",
        },
        br: {
          x: screenCenterX + cappedWidth,
          y: screenCenterY + cappedHeight,
          type: "br",
        },
      };

      console.log(`Corners:`, corners);

      let closestCorner = null;
      let minDistance = Infinity;

      for (let key in corners) {
        const dx = clickX - corners[key].x;
        const dy = clickY - corners[key].y;
        const dist = Math.hypot(dx, dy);

        console.log(
          `📍 Corner ${key}: [${corners[key].x.toFixed(2)}, ${corners[
            key
          ].y.toFixed(2)}] distance=${dist.toFixed(2)}`
        );

        if (dist < minDistance) {
          minDistance = dist;
          closestCorner = corners[key];
        }
      }

      console.log(
        `Closest corner: ${
          closestCorner?.type
        }, distance: ${minDistance.toFixed(2)}, threshold: ${threshold}`
      );

      if (minDistance < threshold) {
        console.log("Corner detected!");
        setPendingResizeEvent(e);
        return closestCorner.type;
      }

      console.log("No corner detected");
      return false;
    };

    useEffect(() => {
      const modelKey = state.newKey;
      let modelConfig = modelConfig1[modelKey];

      if (modelKey === "eventordereventjersey" && state.selectedDesignId) {
        modelConfig = modelConfig1[modelKey][state.selectedDesignId];
        console.log(
          `Event Order Category: ${state.selectedDesignId}`,
          modelConfig
        );
      }

      console.log(`Active Model Config: ${modelKey}`, {
        overallScale: modelConfig?.overallScale,
        scale: modelConfig?.scale,
        rotation: modelConfig?.rotation,
      });
    }, [state.newKey, state.selectedDesignId]);

    const detectNewResizeCorner = (e, decalType, camera) => {
      console.log("NEW Corner Detection start");
      if (!newResizeSelectedDecal || newResizeSelectedDecal !== decalType)
        return false;

      const position = decalPositions[decalType];
      const currentScale = decalScales[decalType];
      console.log("position:", position, "currentScale:", currentScale);

      if (!camera) {
        console.error("Camera not found");
        return false;
      }

      // Get model-specific configuration
      const modelKey = state.newKey;
      const modelConfig = modelConfig1[modelKey];

      // Use a dynamic threshold based on model scale
      let threshold = 40; // Base threshold for new resize
      let widthDivisor = 8;
      let heightDivisor = 8;

      // Adjust threshold and divisors based on model's overall scale
      if (modelConfig) {
        const scaleFactor = modelConfig.overallScale || 1;
        threshold = Math.max(25, Math.min(60, threshold * (10 / scaleFactor)));

        // MODEL-SPECIFIC DIVISOR CALCULATION FOR NEW RESIZE
        if (modelKey === "menmenjersey") {
          widthDivisor = 12;
          heightDivisor = 12;
        } else if (modelKey === "eventordereventjersey") {
          const designId = state.selectedDesignId;
          if (designId === "900" || designId === 900) {
            widthDivisor = 5;
            heightDivisor = 6;
          } else if (designId === "901" || designId === 901) {
            widthDivisor = 4;
            heightDivisor = 5;
          } else if (designId === "902" || designId === 902) {
            widthDivisor = 12;
            heightDivisor = 12;
          } else if (designId === "903" || designId === 903) {
            widthDivisor = 3;
            heightDivisor = 4;
          } else if (designId === "904" || designId === 904) {
            widthDivisor = 5;
            heightDivisor = 6;
          } else {
            widthDivisor = 5;
            heightDivisor = 6;
          }
        } else if (modelKey === "womenwomenfootballjersey") {
          widthDivisor = 9;
          heightDivisor = 9;
        } else if (
          modelKey === "menmencricketshorts" ||
          modelKey === "menmenshorts"
        ) {
          widthDivisor = 6;
          heightDivisor = 7;
        } else if (modelKey === "womenwomenbadmintonshorts") {
          widthDivisor = 5;
          heightDivisor = 6;
        } else if (modelKey === "womenwomentrackpants") {
          widthDivisor = 6;
          heightDivisor = 7;
        } else if (modelKey === "womenwomencyclingjersey") {
          widthDivisor = 20;
          heightDivisor = 20;
        } else if (modelKey === "menmentanktop") {
          widthDivisor = 4;
          heightDivisor = 5;
        } else if (modelKey === "menmencyclingjersey") {
          widthDivisor = 4;
          heightDivisor = 5;
        } else if (modelKey === "menmentrackpants") {
          widthDivisor = 7;
          heightDivisor = 8;
        } else if (modelKey === "menmencricketjersey") {
          widthDivisor = 12;
          heightDivisor = 12;
        } else if (modelKey === "menmenarmsleeves") {
          widthDivisor = 4;
          heightDivisor = 5;
        } else if (modelKey === "menmenbasketballshorts") {
          widthDivisor = 6;
          heightDivisor = 7;
        } else if (modelKey === "womenwomenbadmintonjersey") {
          widthDivisor = 3;
          heightDivisor = 4;
        } else if (modelKey === "menmensoccerjersey") {
          widthDivisor = 3;
          heightDivisor = 4;
        } else if (modelKey === "womenwomenjersey") {
          widthDivisor = 5;
          heightDivisor = 6;
        } else if (modelKey === "menmenbasketballjersey") {
          widthDivisor = 5;
          heightDivisor = 6;
        } else if (modelKey === "kidskidsbasketballjersey") {
          widthDivisor = 5;
          heightDivisor = 6;
        } else if (modelKey === "menmencitycollection") {
          widthDivisor = 3;
          heightDivisor = 4;
        } else if (modelKey === "menmenxjersey") {
          widthDivisor = 3;
          heightDivisor = 4;
        } else if (modelKey === "kidskidscricketshorts") {
          widthDivisor = 6;
          heightDivisor = 7;
        } else if (modelKey === "kidskidsshorts") {
          widthDivisor = 6;
          heightDivisor = 7;
        } else if (modelKey === "menmenfootballjersey") {
          widthDivisor = 4;
          heightDivisor = 5;
        } else if (modelKey === "womenwomencricketjersey") {
          widthDivisor = 5;
          heightDivisor = 6;
        } else if (modelKey === "womenwomenbadmintontanktop") {
          widthDivisor = 10;
          heightDivisor = 10;
        } else if (modelKey === "womenwomenxjersey") {
          widthDivisor = 7;
          heightDivisor = 7;
        } else if (modelKey === "kidskidscricketjersey") {
          widthDivisor = 5;
          heightDivisor = 6;
        } else if (modelKey === "kidskidscyclingjersey") {
          widthDivisor = 6;
          heightDivisor = 7;
        } else if (modelKey === "kidskidsjersey") {
          widthDivisor = 6;
          heightDivisor = 7;
        } else if (modelKey === "kidskidstanktop") {
          widthDivisor = 5;
          heightDivisor = 6;
        } else if (modelKey === "kidskidsbasictshirt") {
          widthDivisor = 6;
          heightDivisor = 7;
        } else if (modelKey === "womenwomencompressionpants") {
          widthDivisor = 5;
          heightDivisor = 6;
        } else {
          widthDivisor = 7;
          heightDivisor = 8;
        }

        console.log(
          `Model: ${modelKey}, Overall Scale: ${scaleFactor}, Threshold: ${threshold}, Divisors: W=${widthDivisor}, H=${heightDivisor}`
        );
      }

      // Get coordinates from either mouse or touch event
      const getEventCoords = (event) => {
        if (event.touches && event.touches.length > 0) {
          return { x: event.touches[0].clientX, y: event.touches[0].clientY };
        }
        return { x: event.clientX, y: event.clientY };
      };

      const coords = getEventCoords(e);
      const clickX = coords.x;
      const clickY = coords.y;
      console.log(`Click coordinates: [${clickX}, ${clickY}]`);

      // Get the 3D position and project to screen
      const center3D = new THREE.Vector3(...position);
      console.log("3D Center Position: ", center3D);

      // FIXED: Apply position adjustment for womenwomencyclingjersey to fix extreme Y values
      let adjustedPosition = center3D.clone();

      // SPECIAL FIX for womenwomencyclingjersey - adjust problematic Y positions
      if (modelKey === "womenwomencyclingjersey") {
        console.log(`🔧 Applying cycling jersey position fix for ${decalType}`);

        // Reduce the extreme Y values that are causing projection issues
        if (
          decalType.includes("frontText") ||
          decalType.includes("frontNumber") ||
          decalType.includes("backText") ||
          decalType.includes("backNumber")
        ) {
          // Scale down the extreme Y values while maintaining relative positioning
          adjustedPosition.y = adjustedPosition.y * 0.3; // Reduce Y by 70%
          console.log(
            `🔧 Adjusted Y position: ${center3D.y} -> ${adjustedPosition.y}`
          );
        }
      }

      // Project center to screen coordinates
      const projectedCenter = adjustedPosition.clone().project(camera);

      // FIXED: More lenient validation for projected coordinates
      let projectedX = projectedCenter.x;
      let projectedY = projectedCenter.y;

      // Clamp projected coordinates to reasonable range if they're extreme
      if (Math.abs(projectedX) > 10 || Math.abs(projectedY) > 10) {
        console.log("🔄 Clamping extreme projected coordinates");
        projectedX = Math.max(-5, Math.min(5, projectedX));
        projectedY = Math.max(-5, Math.min(5, projectedY));
      }

      const screenCenterX = (projectedX * 0.5 + 0.5) * window.innerWidth;
      const screenCenterY = (1 - (projectedY * 0.5 + 0.5)) * window.innerHeight;

      console.log(
        `Screen center: [${screenCenterX.toFixed(2)}, ${screenCenterY.toFixed(
          2
        )}]`
      );

      // FIXED: Improved scale calculation with better normalization
      let normalizedScaleX = Math.min(currentScale[0] / 80, 0.7);
      let normalizedScaleY = Math.min(currentScale[1] / 80, 0.7);

      // Special adjustment for womenwomencyclingjersey to make corner area smaller
      if (modelKey === "womenwomencyclingjersey") {
        normalizedScaleX = Math.min(currentScale[0] / 120, 0.5);
        normalizedScaleY = Math.min(currentScale[1] / 120, 0.5);
      }

      const screenHalfWidth =
        (normalizedScaleX * window.innerWidth) / widthDivisor;
      const screenHalfHeight =
        (normalizedScaleY * window.innerHeight) / heightDivisor;

      console.log(
        `Screen half dimensions: W=${screenHalfWidth.toFixed(
          2
        )}, H=${screenHalfHeight.toFixed(2)}`
      );

      // Safety check: Cap dimensions to reasonable screen bounds
      const maxDimension = Math.min(window.innerWidth, window.innerHeight) / 5;
      const cappedWidth = Math.min(screenHalfWidth, maxDimension);
      const cappedHeight = Math.min(screenHalfHeight, maxDimension);

      if (
        cappedWidth !== screenHalfWidth ||
        cappedHeight !== screenHalfHeight
      ) {
        console.log(
          `Dimensions capped: W=${screenHalfWidth.toFixed(
            2
          )}->${cappedWidth.toFixed(2)}, H=${screenHalfHeight.toFixed(
            2
          )}->${cappedHeight.toFixed(2)}`
        );
      }

      // Define corners in screen space
      const corners = {
        tl: {
          x: screenCenterX - cappedWidth,
          y: screenCenterY - cappedHeight,
          type: "tl",
        },
        tr: {
          x: screenCenterX + cappedWidth,
          y: screenCenterY - cappedHeight,
          type: "tr",
        },
        bl: {
          x: screenCenterX - cappedWidth,
          y: screenCenterY + cappedHeight,
          type: "bl",
        },
        br: {
          x: screenCenterX + cappedWidth,
          y: screenCenterY + cappedHeight,
          type: "br",
        },
      };

      console.log("Corners:", corners);

      // Find closest corner
      let closestCorner = null;
      let minDistance = Infinity;

      for (let key in corners) {
        const dx = clickX - corners[key].x;
        const dy = clickY - corners[key].y;
        const dist = Math.hypot(dx, dy);

        console.log(
          `Corner ${key}: [${corners[key].x.toFixed(2)}, ${corners[
            key
          ].y.toFixed(2)}] distance=${dist.toFixed(2)}`
        );

        if (dist < minDistance) {
          minDistance = dist;
          closestCorner = corners[key];
          console.log(
            `New closest corner: ${key} with distance ${dist.toFixed(2)}`
          );
        }
      }

      console.log(
        `NEW Closest corner distance: ${minDistance.toFixed(
          2
        )}, threshold: ${threshold}`
      );

      if (minDistance < threshold) {
        console.log("✅ NEW Corner detected!");
        return closestCorner.type;
      }

      console.log("❌ NEW No corner detected");
      return false;
    };

    const handleNewResizeFunction = (e) => {
      if (
        !newResizeActive ||
        !newResizeSelectedDecal ||
        !newResizeInitialScale ||
        !newResizeCorner
      )
        return;

      const getEventCoords = (event) => {
        if (event.touches && event.touches.length > 0) {
          return { x: event.touches[0].clientX, y: event.touches[0].clientY };
        }
        return { x: event.clientX, y: event.clientY };
      };

      const modelKey = state.newKey;
      const coords = getEventCoords(e);
      let deltaX = coords.x - newResizeStartPos.x;
      let deltaY = coords.y - newResizeStartPos.y;

      if (modelKey === "womenwomenbadmintonjersey") {
        deltaX = -deltaX;
        deltaY = -deltaY;
      }

      if (
        modelKey === "menmenjersey" ||
        modelKey === "menmencricketjersey" ||
        modelKey === "womenwomenfootballjersey" ||
        modelKey === "womenwomenxjersey" ||
        modelKey === "womenwomenbadmintontanktop" ||
        (!modelKey === "eventordereventjersey" &&
          (glbId === "900" || glbId === "904"))
      ) {
        const sensitivity = newResizeSelectedDecal.includes("Logo")
          ? 0.005
          : 0.003;
        let newScale = [...newResizeInitialScale];

        requestAnimationFrame(() => {
          switch (newResizeCorner) {
            case "tl":
              newScale[0] = Math.max(
                0.05,
                Math.min(8, newResizeInitialScale[0] - deltaX * sensitivity)
              );
              newScale[1] = Math.max(
                0.05,
                Math.min(8, newResizeInitialScale[1] - deltaY * sensitivity)
              );
              break;
            case "tr":
              newScale[0] = Math.max(
                0.05,
                Math.min(8, newResizeInitialScale[0] + deltaX * sensitivity)
              );
              newScale[1] = Math.max(
                0.05,
                Math.min(8, newResizeInitialScale[1] - deltaY * sensitivity)
              );
              break;
            case "bl":
              newScale[0] = Math.max(
                0.05,
                Math.min(8, newResizeInitialScale[0] - deltaX * sensitivity)
              );
              newScale[1] = Math.max(
                0.05,
                Math.min(8, newResizeInitialScale[1] + deltaY * sensitivity)
              );
              break;
            case "br":
              newScale[0] = Math.max(
                0.05,
                Math.min(8, newResizeInitialScale[0] + deltaX * sensitivity)
              );
              newScale[1] = Math.max(
                0.05,
                Math.min(8, newResizeInitialScale[1] + deltaY * sensitivity)
              );
              break;
            default:
              break;
          }

          setNewResizeTempScale(newScale);
          setDecalScales((prev) => ({
            ...prev,
            [newResizeSelectedDecal]: newScale,
          }));

          if (newResizeSelectedDecal.includes("front")) {
            frontLogoScale[0] = newScale[0];
            frontLogoScale[1] = newScale[1];
          } else if (newResizeSelectedDecal.includes("back")) {
            backLogoScale[0] = newScale[0];
            backLogoScale[1] = newScale[1];
          }
        });
      } else {
        console.log(
          "------------------------------------------------------------------"
        );
        const sensitivity = newResizeSelectedDecal.includes("Logo")
          ? 0.005
          : 0.003;
        const diagonalDelta = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

        let scaleFactor = 1;
        switch (newResizeCorner) {
          case "tl":
            scaleFactor =
              1 +
              (deltaX < 0 && deltaY < 0 ? -diagonalDelta : diagonalDelta) *
                sensitivity;
            break;
          case "tr":
            scaleFactor =
              1 +
              (deltaX > 0 && deltaY < 0 ? -diagonalDelta : diagonalDelta) *
                sensitivity;
            break;
          case "bl":
            scaleFactor =
              1 +
              (deltaX < 0 && deltaY > 0 ? -diagonalDelta : diagonalDelta) *
                sensitivity;
            break;
          case "br":
            scaleFactor =
              1 +
              (deltaX > 0 && deltaY > 0 ? diagonalDelta : -diagonalDelta) *
                sensitivity;
            break;
        }

        const newScale = newResizeInitialScale.map((s) =>
          Math.max(5, Math.min(300, s * scaleFactor))
        );

        requestAnimationFrame(() => {
          setNewResizeTempScale(newScale);
          setDecalScales((prev) => ({
            ...prev,
            [newResizeSelectedDecal]: newScale,
          }));

          if (newResizeSelectedDecal.includes("front")) {
            frontLogoScale[0] = newScale[0];
            frontLogoScale[1] = newScale[1];
          } else if (newResizeSelectedDecal.includes("back")) {
            backLogoScale[0] = newScale[0];
            backLogoScale[1] = newScale[1];
          }
        });
      }
    };

    // NEW RESIZE END FUNCTION
    const endNewResize = () => {
      console.log("Ending NEW resize function");

      setNewResizeActive(false);
      setNewResizeSelectedDecal(null);
      setNewResizeInitialScale(null);
      setNewResizeTempScale([0, 0, 0]);
      setNewResizeCorner(null);
      setInteractionMode("rotate-shirt");
    };
    useFrame(() => {
      if (!group.current) return;

      // Update which side is visible based on rotation (only when it changes)
      const normalizedRotation =
        ((group.current.rotation.y % (Math.PI * 2)) + Math.PI * 2) %
        (Math.PI * 2);
      const isFront =
        normalizedRotation < Math.PI / 2 ||
        normalizedRotation > (3 * Math.PI) / 2;

      // Only update state if visibility changed to avoid unnecessary re-renders
      if (isFront !== isFrontVisible) {
        setIsFrontVisible(isFront);
      }

      // Don't rotate if a decal is selected or if not in rotate-shirt mode
      if (selectedDecal || interactionMode !== "rotate-shirt") return;

      const targetYRotation = snap.viewSide === "front" ? 0 : Math.PI;
      group.current.rotation.y +=
        (targetYRotation - group.current.rotation.y) * 0.1;
    });
    useEffect(() => {
      if (resizeMode && selectedDecal && pendingResizeEvent) {
        handleResizeMove(pendingResizeEvent);
        setPendingResizeEvent(null);
      }
    }, [resizeMode, selectedDecal, pendingResizeEvent]);
    useEffect(() => {
      if (resizeMode && selectedDecal && pendingResizeEvent) {
        handlePointerMove(pendingResizeEvent);
        setPendingResizeEvent(null);
      }
    }, [resizeMode, selectedDecal, pendingResizeEvent]);

    // NEW RESIZE FEATURE - Ensure full screen event capture
    useEffect(() => {
      if (interactionMode === "new-resize-mode") {
        // Add global event listeners for better event capture
        const handleGlobalPointerMove = (e) => {
          if (newResizeActive) {
            handleNewResizeFunction(e);
          }
        };

        const handleGlobalPointerUp = (e) => {
          if (newResizeActive) {
            handlePointerUp(e);
          }
        };

        document.addEventListener("pointermove", handleGlobalPointerMove);
        document.addEventListener("pointerup", handleGlobalPointerUp);
        document.addEventListener("mousemove", handleGlobalPointerMove);
        document.addEventListener("mouseup", handleGlobalPointerUp);
        document.addEventListener("touchmove", handleGlobalPointerMove);
        document.addEventListener("touchend", handleGlobalPointerUp);

        return () => {
          document.removeEventListener("pointermove", handleGlobalPointerMove);
          document.removeEventListener("pointerup", handleGlobalPointerUp);
          document.removeEventListener("mousemove", handleGlobalPointerMove);
          document.removeEventListener("mouseup", handleGlobalPointerUp);
          document.removeEventListener("touchmove", handleGlobalPointerMove);
          document.removeEventListener("touchend", handleGlobalPointerUp);
        };
      }
    }, [interactionMode, newResizeActive]);

    // ==========================================
    // START DRAGGING DECAL
    // ==========================================
    const handleDecalDragStart = (e, decalType) => {
      e.stopPropagation();

      if (rotationRAFRef.current || rotationDirectionRef.current) return;

      // Access native event for preventDefault
      const nativeEvent = e.nativeEvent || e;
      if (nativeEvent && typeof nativeEvent.preventDefault === "function") {
        nativeEvent.preventDefault();
      }

      const getCoords = (event) => {
        const evt = event.nativeEvent || event;
        if (evt.touches && evt.touches.length > 0) {
          return { x: evt.touches[0].clientX, y: evt.touches[0].clientY };
        }
        return { x: evt.clientX, y: evt.clientY };
      };

      const coords = getCoords(e);
      const currentPos = decalPositions[decalType] || [0, 0, 0];

      console.log("🚀 Drag start:", decalType, coords);

      // Capture pointer to ensure we get all subsequent events
      const target = e.target || (nativeEvent && nativeEvent.target);
      const pointerId = e.pointerId || (nativeEvent && nativeEvent.pointerId);
      if (target && pointerId !== undefined) {
        try {
          target.setPointerCapture(pointerId);
        } catch (err) {
          console.log("Pointer capture not available");
        }
      }

      setSelectedDecal(decalType);
      setIsDragging(true);
      setInteractionMode("dragging");
      setDragStartPos(coords);
      setInitialDecalPos([...currentPos]);
      hasDraggedRef.current = false;
      dragStartPosRef.current = { ...coords };
      initialDecalPosRef.current = [...currentPos];
      lastDragPositionRef.current = [...currentPos];
      selectedDecalDragRef.current = decalType;
    };

    const [isRotating, setIsRotating] = useState(false);
    const [rotationStartAngle, setRotationStartAngle] = useState(0);
    const [rotationCenter, setRotationCenter] = useState({ x: 0, y: 0 });

    // Update cursor during rotation
    useEffect(() => {
      if (isRotating) {
        document.body.style.cursor = "grabbing";
      }
      return () => {
        if (isRotating) {
          document.body.style.cursor = "auto";
        }
      };
    }, [isRotating]);

    // const handleDecalRotate = (e, decalType) => {
    //   // Stop all event propagation FIRST to prevent background click
    //   if (e?.stopPropagation) e.stopPropagation();
    //   if (e?.nativeEvent?.stopPropagation) e.nativeEvent.stopPropagation();
    //   if (e?.nativeEvent?.stopImmediatePropagation)
    //     e.nativeEvent.stopImmediatePropagation();

    //   // Prevent default behavior
    //   const nativeEvent = e.nativeEvent || e;
    //   if (nativeEvent && typeof nativeEvent.preventDefault === "function") {
    //     nativeEvent.preventDefault();
    //   }

    //   // Record timestamp to prevent background click from deselecting
    //   const now = Date.now();
    //   lastOverlayClickTime.current = now;

    //   const getCoords = (event) => {
    //     const evt = event.nativeEvent || event;
    //     if (evt.touches && evt.touches.length > 0) {
    //       return { x: evt.touches[0].clientX, y: evt.touches[0].clientY };
    //     }
    //     return { x: evt.clientX, y: evt.clientY };
    //   };

    //   const coords = getCoords(e);

    //   // Get the decal center position in screen coordinates
    //   const decalPosition = decalPositions[decalType] || [0, 0, 0];
    //   const modelKey = state.newKey;
    //   let modelConfig = modelConfig1[modelKey];

    //   if (modelKey === "eventordereventjersey" && glbId) {
    //     modelConfig = modelConfig1[modelKey][glbId] || modelConfig1[modelKey];
    //   }

    //   const center3D = new THREE.Vector3(...decalPosition);
    //   const centerScreen = center3D.clone().project(camera);
    //   const centerX = (centerScreen.x * 0.5 + 0.5) * window.innerWidth;
    //   const centerY = (-(centerScreen.y * 0.5) + 0.5) * window.innerHeight;

    //   // Calculate initial angle from center to mouse
    //   const initialAngle = Math.atan2(
    //     coords.y - centerY,
    //     coords.x - centerX
    //   );

    //   // Capture pointer
    //   const target = e.target || (nativeEvent && nativeEvent.target);
    //   const pointerId = e.pointerId || (nativeEvent && nativeEvent.pointerId);
    //   if (target && pointerId !== undefined) {
    //     try {
    //       target.setPointerCapture(pointerId);
    //     } catch (err) {
    //       console.log("Pointer capture not available");
    //     }
    //   }

    //   setSelectedDecal(decalType);
    //   setIsRotating(true);
    //   setInteractionMode("rotating");
    //   setRotationStartAngle(initialAngle);
    //   setRotationCenter({ x: centerX, y: centerY });
    //   setInitialDecalRotation(decalRotations[decalType] || 0);
    // };

    // ==========================================
    // START RESIZING DECAL (CORNER CLICKED)
    // ==========================================

    const handleDecalRotate = (e, decalType) => {
      e.stopPropagation?.();
      e.nativeEvent?.stopPropagation?.();
      e.nativeEvent?.stopImmediatePropagation?.();
      e.preventDefault?.();

      lastOverlayClickTime.current = Date.now();

      const getCoords = (event) => {
        const evt = event.nativeEvent || event;
        if (evt.touches?.length > 0) {
          return { x: evt.touches[0].clientX, y: evt.touches[0].clientY };
        }
        return { x: evt.clientX, y: evt.clientY };
      };

      const startCoords = getCoords(e);
      const decalPos = decalPositions[decalType] || [0, 0, 0];
      const center3D = new THREE.Vector3(...decalPos);
      const centerScreen = center3D.clone().project(camera);
      const centerX = (centerScreen.x * 0.5 + 0.5) * window.innerWidth;
      const centerY = (-centerScreen.y * 0.5 + 0.5) * window.innerHeight;
      const startAngle = Math.atan2(
        startCoords.y - centerY,
        startCoords.x - centerX
      );
      const startRotation = decalRotations[decalType] || 0;

      const handleMove = (moveEvent) => {
        moveEvent.preventDefault();
        moveEvent.stopPropagation();
        document.body.style.cursor = "grabbing";

        const currentCoords = getCoords(moveEvent);
        const currentAngle = Math.atan2(
          currentCoords.y - centerY,
          currentCoords.x - centerX
        );
        let angleDelta = currentAngle - startAngle;
        angleDelta = -angleDelta;
        const newRotation = startRotation + angleDelta;

        setDecalRotations((prev) => ({
          ...prev,
          [decalType]: newRotation,
        }));
      };

      const handleEnd = () => {
        document.removeEventListener("mousemove", handleMove);
        document.removeEventListener("mouseup", handleEnd);
        document.removeEventListener("touchmove", handleMove);
        document.removeEventListener("touchend", handleEnd);
        document.body.style.cursor = "auto";
        setIsRotating(false);
        setInteractionMode("idle");
      };

      setSelectedDecal(decalType);
      setIsRotating(true);
      setInteractionMode("rotating");
      document.addEventListener("mousemove", handleMove);
      document.addEventListener("mouseup", handleEnd);
      document.addEventListener("touchmove", handleMove, { passive: false });
      document.addEventListener("touchend", handleEnd);
    };
    // ==========================================
    // SMOOTH ROTATION FUNCTIONS (CLOCKWISE/ANTICLOCKWISE)
    // ==========================================
    // const rotateTextClockwise = (decalType) => {
    //   const currentRotation = decalRotations[decalType] || 0;
    //   const rotationIncrement = (5 * Math.PI) / 180; // 5 degrees in radians
    //   const newRotation = currentRotation + rotationIncrement;
    //   setDecalRotations((prev) => ({ ...prev, [decalType]: newRotation }));
    // };

    // const rotateTextAnticlockwise = (decalType) => {
    //   const currentRotation = decalRotations[decalType] || 0;
    //   const rotationIncrement = (5 * Math.PI) / 180; // 5 degrees in radians
    //   const newRotation = currentRotation - rotationIncrement;
    //   setDecalRotations((prev) => ({ ...prev, [decalType]: newRotation }));
    // };

    // Angular speed for hold-to-rotate: rad/s (~170 deg/s) – smooth and responsive
    const ROTATION_SPEED_RAD_PER_SEC = 2.8;

    const continuousRotationLoop = () => {
      const info = rotationDirectionRef.current;
      if (!info) return;
      const now = performance.now();
      let dt = (now - rotationLastTimeRef.current) / 1000;
      rotationLastTimeRef.current = now;
      if (dt > 0.1) dt = 0.1;
      const step = ROTATION_SPEED_RAD_PER_SEC * dt * (info.direction === "clockwise" ? 1 : -1);
      setDecalRotations((prev) => ({
        ...prev,
        [info.decalType]: (prev[info.decalType] || 0) + step,
      }));
      rotationRAFRef.current = requestAnimationFrame(continuousRotationLoop);
    };

    // const startContinuousRotation = (decalType, direction) => {
    //   stopContinuousRotation();
    //   rotationDirectionRef.current = { decalType, direction };
    //   rotationLastTimeRef.current = performance.now();
    //   if (direction === "clockwise") rotateTextClockwise(decalType);
    //   else rotateTextAnticlockwise(decalType);
    //   rotationRAFRef.current = requestAnimationFrame(continuousRotationLoop);
    // };

    const stopContinuousRotation = () => {
      if (rotationRAFRef.current) {
        cancelAnimationFrame(rotationRAFRef.current);
        rotationRAFRef.current = null;
      }
      if (rotationIntervalRef.current) {
        clearInterval(rotationIntervalRef.current);
        rotationIntervalRef.current = null;
      }
      rotationDirectionRef.current = null;
    };

    const handleCornerDragStart = (e, decalType, corner) => {
      e.stopPropagation();

      // Access native event for preventDefault
      const nativeEvent = e.nativeEvent || e;
      if (nativeEvent && typeof nativeEvent.preventDefault === "function") {
        nativeEvent.preventDefault();
      }

      const getCoords = (event) => {
        const evt = event.nativeEvent || event;
        if (evt.touches && evt.touches.length > 0) {
          return { x: evt.touches[0].clientX, y: evt.touches[0].clientY };
        }
        return { x: evt.clientX, y: evt.clientY };
      };

      const coords = getCoords(e);
      const currentScale = decalScales[decalType] || [1, 1, 1];

      // Capture pointer to ensure we get all subsequent events
      const target = e.target || (nativeEvent && nativeEvent.target);
      const pointerId = e.pointerId || (nativeEvent && nativeEvent.pointerId);
      if (target && pointerId !== undefined) {
        try {
          target.setPointerCapture(pointerId);
        } catch (err) {
          console.log("Pointer capture not available");
        }
      }

      setSelectedDecal(decalType);
      setIsResizing(true);
      setActiveCorner(corner);
      setInteractionMode("resizing");
      setDragStartPos(coords);
      setInitialDecalScale(
        Array.isArray(currentScale)
          ? [...currentScale]
          : [currentScale, currentScale, currentScale]
      );
      
      // Set resize cursor
      document.body.style.cursor = 'nwse-resize';
    };

    // ==========================================
    // BOUNDARY CONSTRAINT HELPER FUNCTION
    // ==========================================
    const getBoundariesForModel = useCallback(() => {
      const modelKey = state.newKey;

      // Model-specific boundaries based on actual position ranges from modelConfig1
      // Z-axis (bottom): increased by 20%, Y-axis: increased by 15% at bottom only (minY for front, maxY for back), top unchanged
      const modelBoundaries = {
        eventordereventjersey: {
          900: {
            frontText: {
              minX: -8,
              maxX: 8,
              minY: -17.25,
              maxY: -5,
              minZ: -15,
              maxZ: -4,
            },
            backText: {
              minX: -8,
              maxX: 8,
              minY: 5,
              maxY: 17.25,
              minZ: -15,
              maxZ: -4,
            },
            frontNumber: {
              minX: -8,
              maxX: 8,
              minY: -17.25,
              maxY: -5,
              minZ: -5,
              maxZ: 6,
            },
            backNumber: {
              minX: -8,
              maxX: 8,
              minY: 5,
              maxY: 17.25,
              minZ: -5,
              maxZ: 6,
            },
            frontLogo: {
              minX: -2,
              maxX: 10,
              minY: -17.25,
              maxY: -5,
              minZ: 8,
              maxZ: 21.6,
            },
            backLogo: {
              minX: -10,
              maxX: 2,
              minY: 5,
              maxY: 17.25,
              minZ: 8,
              maxZ: 21.6,
            },
          },
          902: {
            frontText: {
              minX: -80,
              maxX: 80,
              minY: 68,
              maxY: 180,
              minZ: 80,
              maxZ: 216,
            },
            backText: {
              minX: -80,
              maxX: 80,
              minY: -180,
              maxY: -68,
              minZ: 80,
              maxZ: 216,
            },
            frontNumber: {
              minX: -80,
              maxX: 80,
              minY: 68,
              maxY: 180,
              minZ: -20,
              maxZ: 96,
            },
            backNumber: {
              minX: -80,
              maxX: 80,
              minY: -180,
              maxY: -68,
              minZ: -20,
              maxZ: 96,
            },
            frontLogo: {
              minX: 20,
              maxX: 100,
              minY: 51,
              maxY: 140,
              minZ: -180,
              maxZ: -84,
            },
            backLogo: {
              minX: -100,
              maxX: -20,
              minY: -180,
              maxY: -68,
              minZ: -180,
              maxZ: -84,
            },
          },
          903: {
            frontText: {
              minX: -0.08,
              maxX: 0.08,
              minY: 0.017,
              maxY: 0.08,
              minZ: 0.05,
              maxZ: 0.18,
            },
            backText: {
              minX: -0.08,
              maxX: 0.08,
              minY: 0.02,
              maxY: 0.092,
              minZ: -0.15,
              maxZ: -0.04,
            },
            frontNumber: {
              minX: -0.08,
              maxX: 0.08,
              minY: -0.115,
              maxY: -0.02,
              minZ: 0.05,
              maxZ: 0.18,
            },
            backNumber: {
              minX: -0.08,
              maxX: 0.08,
              minY: -0.1,
              maxY: -0.017,
              minZ: -0.15,
              maxZ: -0.04,
            },
            frontLogo: {
              minX: 0.02,
              maxX: 0.08,
              minY: 0.068,
              maxY: 0.16,
              minZ: 0.05,
              maxZ: 0.18,
            },
            backLogo: {
              minX: -0.08,
              maxX: -0.02,
              minY: 0.08,
              maxY: 0.1955,
              minZ: -0.12,
              maxZ: -0.016,
            },
          },
          904: {
            frontText: {
              minX: -80,
              maxX: 80,
              minY: 42.5,
              maxY: 150,
              minZ: -1250,
              maxZ: -1010,
            },
            backText: {
              minX: -80,
              maxX: 80,
              minY: -150,
              maxY: -42.5,
              minZ: -1250,
              maxZ: -1010,
            },
            frontNumber: {
              minX: -80,
              maxX: 80,
              minY: 42.5,
              maxY: 150,
              minZ: -1450,
              maxZ: -1210,
            },
            backNumber: {
              minX: -80,
              maxX: 80,
              minY: -150,
              maxY: -42.5,
              minZ: -1450,
              maxZ: -1210,
            },
            frontLogo: {
              minX: 20,
              maxX: 100,
              minY: 34,
              maxY: 120,
              minZ: -1550,
              maxZ: -1310,
            },
            backLogo: {
              minX: 20,
              maxX: 100,
              minY: -200,
              maxY: -85,
              minZ: -1550,
              maxZ: -1310,
            },
          },
        },
        menmenjersey: {
          frontText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1725,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1725,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1725,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1725,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1725,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1725,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
        },
        menmenxjersey: {
          frontText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1725,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1725,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1725,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1725,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1725,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1725,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
        },
        menmenprotshirt: {
          frontText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1725,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1725,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1725,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1725,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1725,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1725,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
        },
        menmentanktop: {
          frontText: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 18.8,
          },
          backText: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 18.8,
          },
          frontNumber: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 18.8,
          },
          backNumber: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 18.8,
          },
          frontLogo: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 18.8,
          },
          backLogo: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 18.8,
          },
        },
        menmenarmsleeves: {
          frontText: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          backText: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          frontNumber: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          backNumber: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          frontLogo: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          backLogo: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
        },
        menmensinglet: {
          frontText: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 10.8,
          },
          backText: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 10.8,
          },
          frontNumber: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 10.8,
          },
          backNumber: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 10.8,
          },
          frontLogo: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 10.8,
          },
          backLogo: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 10.8,
          },
        },
        menmencyclingjersey: {
          frontText: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          backText: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          frontNumber: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          backNumber: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          frontLogo: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          backLogo: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
        },
        menmenwinterjersey: {
          frontText: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          backText: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          frontNumber: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          backNumber: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          frontLogo: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          backLogo: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
        },
        menmenbasketballjersey: {
          frontText: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          backText: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          frontNumber: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          backNumber: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          frontLogo: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          backLogo: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
        },
        womenwomencyclingjersey: {
          frontText: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          backText: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          frontNumber: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          backNumber: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          frontLogo: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          backLogo: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
        },
        womenwomenwinterjersey: {
          frontText: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          backText: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          frontNumber: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          backNumber: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          frontLogo: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
          backLogo: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 16.8,
          },
        },
        menmenshorts: {
          frontText: {
            minX: -10,
            maxX: 10,
            minY: -8,
            maxY: 8,
            minZ: -8,
            maxZ: 8.8,
          },
          backText: {
            minX: -10,
            maxX: 10,
            minY: 8,
            maxY: 23,
            minZ: -18,
            maxZ: -8.8,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -23,
            maxY: -8,
            minZ: -5,
            maxZ: 6,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: 8,
            maxY: 23,
            minZ: -5,
            maxZ: 6,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -23,
            maxY: -8,
            minZ: 10,
            maxZ: 24,
          },
          backLogo: {
            minX: -5,
            maxX: 5,
            minY: 8,
            maxY: 23,
            minZ: 10,
            maxZ: 24,
          },
        },
        menmencricketshorts: {
          frontText: {
            minX: -10,
            maxX: 10,
            minY: -8,
            maxY: 8,
            minZ: -8,
            maxZ: 8.8,
          },
          backText: {
            minX: -10,
            maxX: 10,
            minY: 8,
            maxY: 23,
            minZ: -18,
            maxZ: -8.8,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -23,
            maxY: -8,
            minZ: -5,
            maxZ: 6,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: 8,
            maxY: 23,
            minZ: -5,
            maxZ: 6,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -23,
            maxY: -8,
            minZ: 10,
            maxZ: 24,
          },
          backLogo: {
            minX: -5,
            maxX: 5,
            minY: 8,
            maxY: 23,
            minZ: 10,
            maxZ: 24,
          },
        },
        menmencyclingshorts: {
          frontText: {
            minX: -10,
            maxX: 10,
            minY: -8,
            maxY: 8,
            minZ: -8,
            maxZ: 8.8,
          },
          backText: {
            minX: -10,
            maxX: 10,
            minY: 8,
            maxY: 23,
            minZ: -18,
            maxZ: -8.8,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -23,
            maxY: -8,
            minZ: -5,
            maxZ: 6,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: 8,
            maxY: 23,
            minZ: -5,
            maxZ: 6,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -23,
            maxY: -8,
            minZ: 10,
            maxZ: 24,
          },
          backLogo: {
            minX: -5,
            maxX: 5,
            minY: 8,
            maxY: 23,
            minZ: 10,
            maxZ: 24,
          },
        },
        menmenrunningshorts: {
          frontText: {
            minX: -10,
            maxX: 10,
            minY: -8,
            maxY: 8,
            minZ: -8,
            maxZ: 8.8,
          },
          backText: {
            minX: -10,
            maxX: 10,
            minY: 8,
            maxY: 23,
            minZ: -18,
            maxZ: -8.8,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -23,
            maxY: -8,
            minZ: -5,
            maxZ: 6,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: 8,
            maxY: 23,
            minZ: -5,
            maxZ: 6,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -23,
            maxY: -8,
            minZ: 10,
            maxZ: 24,
          },
          backLogo: {
            minX: -5,
            maxX: 5,
            minY: 8,
            maxY: 23,
            minZ: 10,
            maxZ: 24,
          },
        },
        menmenwovenshorts: {
          frontText: {
            minX: -10,
            maxX: 10,
            minY: -8,
            maxY: 8,
            minZ: -8,
            maxZ: 8.8,
          },
          backText: {
            minX: -10,
            maxX: 10,
            minY: 8,
            maxY: 23,
            minZ: -18,
            maxZ: -8.8,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -23,
            maxY: -8,
            minZ: -5,
            maxZ: 6,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: 8,
            maxY: 23,
            minZ: -5,
            maxZ: 6,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -23,
            maxY: -8,
            minZ: 10,
            maxZ: 24,
          },
          backLogo: {
            minX: -5,
            maxX: 5,
            minY: 8,
            maxY: 23,
            minZ: 10,
            maxZ: 24,
          },
        },
        menmenknittedshorts: {
          frontText: {
            minX: -10,
            maxX: 10,
            minY: -8,
            maxY: 8,
            minZ: -8,
            maxZ: 8.8,
          },
          backText: {
            minX: -10,
            maxX: 10,
            minY: 8,
            maxY: 23,
            minZ: -18,
            maxZ: -8.8,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -23,
            maxY: -8,
            minZ: -5,
            maxZ: 6,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: 8,
            maxY: 23,
            minZ: -5,
            maxZ: 6,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -23,
            maxY: -8,
            minZ: 10,
            maxZ: 24,
          },
          backLogo: {
            minX: -5,
            maxX: 5,
            minY: 8,
            maxY: 23,
            minZ: 10,
            maxZ: 24,
          },
        },
        menmenfootballshorts: {
          frontText: {
            minX: -10,
            maxX: 10,
            minY: -8,
            maxY: 8,
            minZ: -8,
            maxZ: 8.8,
          },
          backText: {
            minX: -10,
            maxX: 10,
            minY: 8,
            maxY: 23,
            minZ: -18,
            maxZ: -8.8,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -23,
            maxY: -8,
            minZ: -5,
            maxZ: 6,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: 8,
            maxY: 23,
            minZ: -5,
            maxZ: 6,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -23,
            maxY: -8,
            minZ: 10,
            maxZ: 24,
          },
          backLogo: {
            minX: -5,
            maxX: 5,
            minY: 8,
            maxY: 23,
            minZ: 10,
            maxZ: 24,
          },
        },
        menmensoccershorts: {
          frontText: {
            minX: -10,
            maxX: 10,
            minY: -8,
            maxY: 8,
            minZ: -8,
            maxZ: 8.8,
          },
          backText: {
            minX: -10,
            maxX: 10,
            minY: 8,
            maxY: 23,
            minZ: -18,
            maxZ: -8.8,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -23,
            maxY: -8,
            minZ: -5,
            maxZ: 6,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: 8,
            maxY: 23,
            minZ: -5,
            maxZ: 6,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -23,
            maxY: -8,
            minZ: 10,
            maxZ: 24,
          },
          backLogo: {
            minX: -5,
            maxX: 5,
            minY: 8,
            maxY: 23,
            minZ: 10,
            maxZ: 24,
          },
        },
        menmenbasketballshorts: {
          frontText: {
            minX: -10,
            maxX: 10,
            minY: -8,
            maxY: 8,
            minZ: -8,
            maxZ: 8.8,
          },
          backText: {
            minX: -10,
            maxX: 10,
            minY: 8,
            maxY: 23,
            minZ: -18,
            maxZ: -8.8,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -23,
            maxY: -8,
            minZ: -5,
            maxZ: 6,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: 8,
            maxY: 23,
            minZ: -5,
            maxZ: 6,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -23,
            maxY: -8,
            minZ: 10,
            maxZ: 24,
          },
          backLogo: {
            minX: -5,
            maxX: 5,
            minY: 8,
            maxY: 23,
            minZ: 10,
            maxZ: 24,
          },
        },
        menmennftfootballshorts: {
          frontText: {
            minX: -10,
            maxX: 10,
            minY: -8,
            maxY: 8,
            minZ: -8,
            maxZ: 8.8,
          },
          backText: {
            minX: -10,
            maxX: 10,
            minY: 8,
            maxY: 23,
            minZ: -18,
            maxZ: -8.8,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -23,
            maxY: -8,
            minZ: -5,
            maxZ: 6,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: 8,
            maxY: 23,
            minZ: -5,
            maxZ: 6,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -23,
            maxY: -8,
            minZ: 10,
            maxZ: 24,
          },
          backLogo: {
            minX: -5,
            maxX: 5,
            minY: 8,
            maxY: 23,
            minZ: 10,
            maxZ: 24,
          },
        },
        menmencitycollection: {
          frontText: {
            minX: -150,
            maxX: 150,
            minY: -1500,
            maxY: 200,
            minZ: -1500,
            maxZ: -1000,
          },
          backText: {
            minX: -150,
            maxX: 150,
            minY: -1500,
            maxY: 200,
            minZ: -1500,
            maxZ: -1000,
          },
          frontNumber: {
            minX: -150,
            maxX: 150,
            minY: -1500,
            maxY: 200,
            minZ: -1500,
            maxZ: -1000,
          },
          backNumber: {
            minX: -150,
            maxX: 150,
            minY: -1500,
            maxY: 200,
            minZ: -1500,
            maxZ: -1000,
          },
          frontLogo: {
            minX: -150,
            maxX: 150,
            minY: -1500,
            maxY: 200,
            minZ: -1500,
            maxZ: -1000,
          },
          backLogo: {
            minX: -150,
            maxX: 150,
            minY: -1500,
            maxY: 200,
            minZ: -1500,
            maxZ: -1000,
          },
        },
        menmencricketjersey: {
          frontText: {
            minX: -150,
            maxX: 150,
            minY: -1500,
            maxY: 200,
            minZ: -150,
            maxZ: 200,
          },
          backText: {
            minX: -150,
            maxX: 150,
            minY: -1500,
            maxY: 200,
            minZ: -150,
            maxZ: 200,
          },
          frontNumber: {
            minX: -150,
            maxX: 150,
            minY: -1500,
            maxY: 200,
            minZ: -150,
            maxZ: 200,
          },
          backNumber: {
            minX: -150,
            maxX: 150,
            minY: -1500,
            maxY: 200,
            minZ: -150,
            maxZ: 200,
          },
          frontLogo: {
            minX: -150,
            maxX: 150,
            minY: -1500,
            maxY: 200,
            minZ: -150,
            maxZ: 200,
          },
          backLogo: {
            minX: -150,
            maxX: 150,
            minY: -1500,
            maxY: 200,
            minZ: -150,
            maxZ: 200,
          },
        },
        womenwomencitycollection: {
          frontText: {
            minX: -150,
            maxX: 150,
            minY: -1500,
            maxY: 200,
            minZ: -1500,
            maxZ: -1000,
          },
          backText: {
            minX: -150,
            maxX: 150,
            minY: -1500,
            maxY: 200,
            minZ: -1500,
            maxZ: -1000,
          },
          frontNumber: {
            minX: -150,
            maxX: 150,
            minY: -1500,
            maxY: 200,
            minZ: -1500,
            maxZ: -1000,
          },
          backNumber: {
            minX: -150,
            maxX: 150,
            minY: -1500,
            maxY: 200,
            minZ: -1500,
            maxZ: -1000,
          },
          frontLogo: {
            minX: -150,
            maxX: 150,
            minY: -1500,
            maxY: 200,
            minZ: -1500,
            maxZ: -1000,
          },
          backLogo: {
            minX: -150,
            maxX: 150,
            minY: -1500,
            maxY: 200,
            minZ: -1500,
            maxZ: -1000,
          },
        },
        menmentrackpants: {
          frontText: {
            minX: -12,
            maxX: 12,
            minY: -23,
            maxY: 20,
            minZ: 10.8,
            maxZ: 25.8,
          },
          backText: {
            minX: -12,
            maxX: 12,
            minY: -23,
            maxY: 20,
            minZ: 10.8,
            maxZ: 25.8,
          },
          frontNumber: {
            minX: -11,
            maxX: 11,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 20.8,
          },
          backNumber: {
            minX: -11,
            maxX: 11,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 20.8,
          },
          frontLogo: {
            minX: -11,
            maxX: 11,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 20.8,
          },
          backLogo: {
            minX: -11,
            maxX: 11,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 20.8,
          },
        },
        menmencompressionpants: {
          frontText: {
            minX: -12,
            maxX: 12,
            minY: -23,
            maxY: 20,
            minZ: 10.8,
            maxZ: 25.8,
          },
          backText: {
            minX: -12,
            maxX: 12,
            minY: -23,
            maxY: 20,
            minZ: 10.8,
            maxZ: 25.8,
          },
          frontNumber: {
            minX: -11,
            maxX: 11,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 20.8,
          },
          backNumber: {
            minX: -11,
            maxX: 11,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 20.8,
          },
          frontLogo: {
            minX: -11,
            maxX: 11,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 20.8,
          },
          backLogo: {
            minX: -11,
            maxX: 11,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 20.8,
          },
        },
        womenwomenbadmintonjersey: {
          frontText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
        },
        womenwomencricketjersey: {
          frontText: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 10.8,
          },
          backText: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 10.8,
          },
          frontNumber: {
            minX: -12,
            maxX: 12,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 10.8,
          },
          backNumber: {
            minX: -12,
            maxX: 12,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 10.8,
          },
          frontLogo: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 10.8,
          },
          backLogo: {
            minX: -15,
            maxX: 15,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 10.8,
          },
        },
        womenwomentrackpants: {
          frontText: {
            minX: -12,
            maxX: 12,
            minY: -23,
            maxY: 20,
            minZ: 10.8,
            maxZ: 25.8,
          },
          backText: {
            minX: -12,
            maxX: 12,
            minY: -23,
            maxY: 20,
            minZ: 10.8,
            maxZ: 25.8,
          },
          frontNumber: {
            minX: -11,
            maxX: 11,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 20.8,
          },
          backNumber: {
            minX: -11,
            maxX: 11,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 20.8,
          },
          frontLogo: {
            minX: -11,
            maxX: 11,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 20.8,
          },
          backLogo: {
            minX: -11,
            maxX: 11,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 20.8,
          },
        },
        womenwomencrickettrackpants: {
          frontText: {
            minX: -12,
            maxX: 12,
            minY: -23,
            maxY: 20,
            minZ: 10.8,
            maxZ: 25.8,
          },
          backText: {
            minX: -12,
            maxX: 12,
            minY: -23,
            maxY: 20,
            minZ: 10.8,
            maxZ: 25.8,
          },
          frontNumber: {
            minX: -11,
            maxX: 11,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 20.8,
          },
          backNumber: {
            minX: -11,
            maxX: 11,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 20.8,
          },
          frontLogo: {
            minX: -11,
            maxX: 11,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 20.8,
          },
          backLogo: {
            minX: -11,
            maxX: 11,
            minY: -23,
            maxY: 20,
            minZ: -19,
            maxZ: 20.8,
          },
        },
        womenwomenxjersey: {
          frontText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.0575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.05,
            maxY: 0.1725,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1725,
            maxY: 0.05,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.15,
            maxY: 0.0575,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontLogo: {
            minX: -0.12,
            maxX: 0.12,
            minY: -0.115,
            maxY: 0.2,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backLogo: {
            minX: -0.12,
            maxX: 0.12,
            minY: -0.1,
            maxY: 0.23,
            minZ: -0.15,
            maxZ: 0.18,
          },
        },
        womenwomenjersey: {
          frontText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.0575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.05,
            maxY: 0.1725,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1725,
            maxY: 0.05,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.15,
            maxY: 0.0575,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontLogo: {
            minX: -0.12,
            maxX: 0.12,
            minY: -0.115,
            maxY: 0.2,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backLogo: {
            minX: -0.12,
            maxX: 0.12,
            minY: -0.1,
            maxY: 0.23,
            minZ: -0.15,
            maxZ: 0.18,
          },
        },
        womenwomenprotshirt: {
          frontText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
        },
        womenwomenfootballjersey: {
          frontText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
        },
        womenwomensoccerjersey: {
          frontText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
        },
        womenwomencompressionpants: {
          frontText: {
            minX: -12,
            maxX: 12,
            minY: -23,
            maxY: 20,
            minZ: 10.8,
            maxZ: 45.8,
          },
          backText: {
            minX: -12,
            maxX: 12,
            minY: -23,
            maxY: 20,
            minZ: 10.8,
            maxZ: 45.8,
          },
          frontNumber: {
            minX: -12,
            maxX: 12,
            minY: -23,
            maxY: 20,
            minZ: 10.8,
            maxZ: 45.8,
          },
          backNumber: {
            minX: -12,
            maxX: 12,
            minY: -23,
            maxY: 20,
            minZ: 10.8,
            maxZ: 45.8,
          },
          frontLogo: {
            minX: -12,
            maxX: 12,
            minY: -23,
            maxY: 20,
            minZ: 10.8,
            maxZ: 45.8,
          },
          backLogo: {
            minX: -12,
            maxX: 12,
            minY: -23,
            maxY: 20,
            minZ: 10.8,
            maxZ: 45.8,
          },
        },
        womenwomenbadmintontanktop: {
          frontText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.0575,
            maxY: 0.11,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.0575,
            maxY: 0.11,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.0575,
            maxY: 0.11,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.0575,
            maxY: 0.11,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.0575,
            maxY: 0.11,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.0575,
            maxY: 0.11,
            minZ: -0.15,
            maxZ: 0.18,
          },
        },
        womenwomensinglet: {
          frontText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.0575,
            maxY: 0.11,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.0575,
            maxY: 0.11,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.0575,
            maxY: 0.11,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.0575,
            maxY: 0.11,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.0575,
            maxY: 0.11,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.0575,
            maxY: 0.11,
            minZ: -0.15,
            maxZ: 0.18,
          },
        },
        womenwomenarmsleeves: {
          frontText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.0575,
            maxY: 0.11,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.0575,
            maxY: 0.11,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.0575,
            maxY: 0.11,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.0575,
            maxY: 0.11,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.0575,
            maxY: 0.11,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.0575,
            maxY: 0.11,
            minZ: -0.15,
            maxZ: 0.18,
          },
        },
        womenwomenbadmintonshorts: {
          frontText: {
            minX: -10,
            maxX: 10,
            minY: -8,
            maxY: 8,
            minZ: -8,
            maxZ: 8.8,
          },
          backText: {
            minX: -10,
            maxX: 10,
            minY: 8,
            maxY: 23,
            minZ: -18,
            maxZ: -8.8,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -23,
            maxY: -8,
            minZ: -5,
            maxZ: 6,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: 8,
            maxY: 23,
            minZ: -5,
            maxZ: 6,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -23,
            maxY: -8,
            minZ: 10,
            maxZ: 24,
          },
          backLogo: {
            minX: -5,
            maxX: 5,
            minY: 8,
            maxY: 23,
            minZ: 10,
            maxZ: 24,
          },
        },
        womenwomencyclingshorts: {
          frontText: {
            minX: -10,
            maxX: 10,
            minY: -8,
            maxY: 8,
            minZ: -8,
            maxZ: 8.8,
          },
          backText: {
            minX: -10,
            maxX: 10,
            minY: 8,
            maxY: 23,
            minZ: -18,
            maxZ: -8.8,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -23,
            maxY: -8,
            minZ: -5,
            maxZ: 6,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: 8,
            maxY: 23,
            minZ: -5,
            maxZ: 6,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -23,
            maxY: -8,
            minZ: 10,
            maxZ: 24,
          },
          backLogo: {
            minX: -5,
            maxX: 5,
            minY: 8,
            maxY: 23,
            minZ: 10,
            maxZ: 24,
          },
        },
        womenwomencricketshorts: {
          frontText: {
            minX: -10,
            maxX: 10,
            minY: -8,
            maxY: 8,
            minZ: -8,
            maxZ: 8.8,
          },
          backText: {
            minX: -10,
            maxX: 10,
            minY: 8,
            maxY: 23,
            minZ: -18,
            maxZ: -8.8,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -23,
            maxY: -8,
            minZ: -5,
            maxZ: 6,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: 8,
            maxY: 23,
            minZ: -5,
            maxZ: 6,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -23,
            maxY: -8,
            minZ: 10,
            maxZ: 24,
          },
          backLogo: {
            minX: -5,
            maxX: 5,
            minY: 8,
            maxY: 23,
            minZ: 10,
            maxZ: 24,
          },
        },
        womenwomenwovenshorts: {
          frontText: {
            minX: -10,
            maxX: 10,
            minY: -8,
            maxY: 8,
            minZ: -8,
            maxZ: 8.8,
          },
          backText: {
            minX: -10,
            maxX: 10,
            minY: 8,
            maxY: 23,
            minZ: -18,
            maxZ: -8.8,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -23,
            maxY: -8,
            minZ: -5,
            maxZ: 6,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: 8,
            maxY: 23,
            minZ: -5,
            maxZ: 6,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -23,
            maxY: -8,
            minZ: 10,
            maxZ: 24,
          },
          backLogo: {
            minX: -5,
            maxX: 5,
            minY: 8,
            maxY: 23,
            minZ: 10,
            maxZ: 24,
          },
        },
        womenwomentightshorts: {
          frontText: {
            minX: -10,
            maxX: 10,
            minY: -8,
            maxY: 8,
            minZ: -8,
            maxZ: 8.8,
          },
          backText: {
            minX: -10,
            maxX: 10,
            minY: 8,
            maxY: 23,
            minZ: -18,
            maxZ: -8.8,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -23,
            maxY: -8,
            minZ: -5,
            maxZ: 6,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: 8,
            maxY: 23,
            minZ: -5,
            maxZ: 6,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -23,
            maxY: -8,
            minZ: 10,
            maxZ: 24,
          },
          backLogo: {
            minX: -5,
            maxX: 5,
            minY: 8,
            maxY: 23,
            minZ: 10,
            maxZ: 24,
          },
        },
        womenwomenfootballshorts: {
          frontText: {
            minX: -10,
            maxX: 10,
            minY: -8,
            maxY: 8,
            minZ: -8,
            maxZ: 8.8,
          },
          backText: {
            minX: -10,
            maxX: 10,
            minY: 8,
            maxY: 23,
            minZ: -18,
            maxZ: -8.8,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -23,
            maxY: -8,
            minZ: -5,
            maxZ: 6,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: 8,
            maxY: 23,
            minZ: -5,
            maxZ: 6,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -23,
            maxY: -8,
            minZ: 10,
            maxZ: 24,
          },
          backLogo: {
            minX: -5,
            maxX: 5,
            minY: 8,
            maxY: 23,
            minZ: 10,
            maxZ: 24,
          },
        },
        womenwomensoccershorts: {
          frontText: {
            minX: -10,
            maxX: 10,
            minY: -8,
            maxY: 8,
            minZ: -8,
            maxZ: 8.8,
          },
          backText: {
            minX: -10,
            maxX: 10,
            minY: 8,
            maxY: 23,
            minZ: -18,
            maxZ: -8.8,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -23,
            maxY: -8,
            minZ: -5,
            maxZ: 6,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: 8,
            maxY: 23,
            minZ: -5,
            maxZ: 6,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -23,
            maxY: -8,
            minZ: 10,
            maxZ: 24,
          },
          backLogo: {
            minX: -5,
            maxX: 5,
            minY: 8,
            maxY: 23,
            minZ: 10,
            maxZ: 24,
          },
        },
        womenwomennftfootballshorts: {
          frontText: {
            minX: -10,
            maxX: 10,
            minY: -8,
            maxY: 8,
            minZ: -8,
            maxZ: 8.8,
          },
          backText: {
            minX: -10,
            maxX: 10,
            minY: 8,
            maxY: 23,
            minZ: -18,
            maxZ: -8.8,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -23,
            maxY: -8,
            minZ: -5,
            maxZ: 6,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: 8,
            maxY: 23,
            minZ: -5,
            maxZ: 6,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -23,
            maxY: -8,
            minZ: 10,
            maxZ: 24,
          },
          backLogo: {
            minX: -5,
            maxX: 5,
            minY: 8,
            maxY: 23,
            minZ: 10,
            maxZ: 24,
          },
        },
        womenwomenbasketballshorts: {
          frontText: {
            minX: -10,
            maxX: 10,
            minY: -8,
            maxY: 8,
            minZ: -8,
            maxZ: 8.8,
          },
          backText: {
            minX: -10,
            maxX: 10,
            minY: 8,
            maxY: 23,
            minZ: -18,
            maxZ: -8.8,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -23,
            maxY: -8,
            minZ: -5,
            maxZ: 6,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: 8,
            maxY: 23,
            minZ: -5,
            maxZ: 6,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -23,
            maxY: -8,
            minZ: 10,
            maxZ: 24,
          },
          backLogo: {
            minX: -5,
            maxX: 5,
            minY: 8,
            maxY: 23,
            minZ: 10,
            maxZ: 24,
          },
        },
        womenwomenknittedshorts: {
          frontText: {
            minX: -10,
            maxX: 10,
            minY: -8,
            maxY: 8,
            minZ: -8,
            maxZ: 8.8,
          },
          backText: {
            minX: -10,
            maxX: 10,
            minY: 8,
            maxY: 23,
            minZ: -18,
            maxZ: -8.8,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -23,
            maxY: -8,
            minZ: -5,
            maxZ: 6,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: 8,
            maxY: 23,
            minZ: -5,
            maxZ: 6,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -23,
            maxY: -8,
            minZ: 10,
            maxZ: 24,
          },
          backLogo: {
            minX: -5,
            maxX: 5,
            minY: 8,
            maxY: 23,
            minZ: 10,
            maxZ: 24,
          },
        },
        kidskidsjersey: {
          frontText: {
            minX: -5,
            maxX: 5,
            minY: -8,
            maxY: 7,
            minZ: -8,
            maxZ: 8,
          },
          backText: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
          frontNumber: {
            minX: -5,
            maxX: 5,
            minY: -8,
            maxY: 7,
            minZ: -8,
            maxZ: 8,
          },
          backNumber: {
            minX: -5,
            maxX: 5,
            minY: -8,
            maxY: 7,
            minZ: -8,
            maxZ: 8,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -8,
            maxY: 7,
            minZ: -8,
            maxZ: 8,
          },
          backLogo: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
        },
        kidskidstanktop: {
          frontText: {
            minX: -19,
            maxX: 19,
            minY: -10,
            maxY: 10,
            minZ: -20,
            maxZ: 25,
          },
          backText: {
            minX: -19,
            maxX: 19,
            minY: -10,
            maxY: 10,
            minZ: -20,
            maxZ: 25,
          },
          frontNumber: {
            minX: -19,
            maxX: 19,
            minY: -10,
            maxY: 10,
            minZ: -20,
            maxZ: 25,
          },
          backNumber: {
            minX: -19,
            maxX: 19,
            minY: -10,
            maxY: 10,
            minZ: -20,
            maxZ: 25,
          },
          frontLogo: {
            minX: -19,
            maxX: 19,
            minY: -10,
            maxY: 10,
            minZ: -20,
            maxZ: 25,
          },
          backLogo: {
            minX: -19,
            maxX: 19,
            minY: -10,
            maxY: 10,
            minZ: -20,
            maxZ: 25,
          },
        },
        kidskidscyclingjersey: {
          frontText: {
            minX: -4,
            maxX: 4,
            minY: -8,
            maxY: 5,
            minZ: -8,
            maxZ: 6,
          },
          backText: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
          frontNumber: {
            minX: -4,
            maxX: 4,
            minY: -8,
            maxY: 6,
            minZ: -8,
            maxZ: 7,
          },
          backNumber: {
            minX: -4,
            maxX: 4,
            minY: -8,
            maxY: 6,
            minZ: -8,
            maxZ: 7,
          },
          frontLogo: {
            minX: -4,
            maxX: 4,
            minY: -8,
            maxY: 6,
            minZ: -8,
            maxZ: 7,
          },
          backLogo: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
        },
        kidskidswinterjersey: {
          frontText: {
            minX: -4,
            maxX: 4,
            minY: -8,
            maxY: 5,
            minZ: -8,
            maxZ: 6,
          },
          backText: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
          frontNumber: {
            minX: -4,
            maxX: 4,
            minY: -8,
            maxY: 6,
            minZ: -8,
            maxZ: 7,
          },
          backNumber: {
            minX: -4,
            maxX: 4,
            minY: -8,
            maxY: 6,
            minZ: -8,
            maxZ: 7,
          },
          frontLogo: {
            minX: -4,
            maxX: 4,
            minY: -8,
            maxY: 6,
            minZ: -8,
            maxZ: 7,
          },
          backLogo: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
        },
        kidskidscitycollection: {
          frontText: {
            minX: -4,
            maxX: 4,
            minY: -8,
            maxY: 5,
            minZ: -8,
            maxZ: 6,
          },
          backText: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
          frontNumber: {
            minX: -4,
            maxX: 4,
            minY: -8,
            maxY: 6,
            minZ: -8,
            maxZ: 7,
          },
          backNumber: {
            minX: -4,
            maxX: 4,
            minY: -8,
            maxY: 6,
            minZ: -8,
            maxZ: 7,
          },
          frontLogo: {
            minX: -4,
            maxX: 4,
            minY: -8,
            maxY: 6,
            minZ: -8,
            maxZ: 7,
          },
          backLogo: { minX: -4, maxX: 4, minY: -8, maxY: 6, minZ: -8, maxZ: 7 },
        },
        kidskidscricketjersey: {
          frontText: {
            minX: -8,
            maxX: 8,
            minY: -18,
            maxY: 18,
            minZ: -18,
            maxZ: 18,
          },
          backText: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
          frontNumber: {
            minX: -5,
            maxX: 5,
            minY: -8,
            maxY: 7,
            minZ: -8,
            maxZ: 8,
          },
          backNumber: {
            minX: -5,
            maxX: 5,
            minY: -8,
            maxY: 7,
            minZ: -8,
            maxZ: 8,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -8,
            maxY: 7,
            minZ: -8,
            maxZ: 8,
          },
          backLogo: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
        },
        kidskidstrackpants: {
          frontText: {
            minX: -8,
            maxX: 8,
            minY: -8,
            maxY: 15,
            minZ: -8,
            maxZ: 15,
          },
          backText: {
            minX: -8,
            maxX: 8,
            minY: -8,
            maxY: 15,
            minZ: -8,
            maxZ: 15,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -8,
            maxY: 15,
            minZ: -8,
            maxZ: 15,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: -8,
            maxY: 15,
            minZ: -8,
            maxZ: 15,
          },
          frontLogo: {
            minX: -8,
            maxX: 8,
            minY: -8,
            maxY: 15,
            minZ: -8,
            maxZ: 15,
          },
          backLogo: {
            minX: -8,
            maxX: 8,
            minY: -8,
            maxY: 15,
            minZ: -8,
            maxZ: 15,
          },
        },
        kidskidsxjersey: {
          frontText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
        },
        kidskidsprotshirt: {
          frontText: {
            minX: -5,
            maxX: 5,
            minY: -8,
            maxY: 7,
            minZ: -8,
            maxZ: 8,
          },
          backText: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
          frontNumber: {
            minX: -5,
            maxX: 5,
            minY: -8,
            maxY: 7,
            minZ: -8,
            maxZ: 8,
          },
          backNumber: {
            minX: -5,
            maxX: 5,
            minY: -8,
            maxY: 7,
            minZ: -8,
            maxZ: 8,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -8,
            maxY: 7,
            minZ: -8,
            maxZ: 8,
          },
          backLogo: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
        },
        kidskidscompressionpants: {
          frontText: {
            minX: -8,
            maxX: 8,
            minY: -8,
            maxY: 15,
            minZ: -8,
            maxZ: 15,
          },
          backText: {
            minX: -8,
            maxX: 8,
            minY: -8,
            maxY: 15,
            minZ: -8,
            maxZ: 15,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -8,
            maxY: 15,
            minZ: -8,
            maxZ: 15,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: -8,
            maxY: 15,
            minZ: -8,
            maxZ: 15,
          },
          frontLogo: {
            minX: -8,
            maxX: 8,
            minY: -8,
            maxY: 15,
            minZ: -8,
            maxZ: 15,
          },
          backLogo: {
            minX: -8,
            maxX: 8,
            minY: -8,
            maxY: 15,
            minZ: -8,
            maxZ: 15,
          },
        },
        kidskidssinglet: {
          frontText: {
            minX: -10,
            maxX: 10,
            minY: -23,
            maxY: 25,
            minZ: -18,
            maxZ: 25.8,
          },
          backText: {
            minX: -10,
            maxX: 10,
            minY: 8,
            maxY: 23,
            minZ: -18,
            maxZ: -8.8,
          },
          frontNumber: {
            minX: -10,
            maxX: 10,
            minY: -23,
            maxY: -8,
            minZ: -5,
            maxZ: 6,
          },
          backNumber: {
            minX: -10,
            maxX: 10,
            minY: 8,
            maxY: 23,
            minZ: -5,
            maxZ: 6,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -23,
            maxY: -8,
            minZ: 10,
            maxZ: 24,
          },
          backLogo: {
            minX: -5,
            maxX: 5,
            minY: 8,
            maxY: 23,
            minZ: 10,
            maxZ: 24,
          },
        },
        kidskidsarmsleeves: {
          frontText: {
            minX: -6,
            maxX: 6,
            minY: -23,
            maxY: 25,
            minZ: 30,
            maxZ: 45.8,
          },
          backText: {
            minX: -6,
            maxX: 6,
            minY: -23,
            maxY: 25,
            minZ: 30,
            maxZ: 45.8,
          },
          frontNumber: {
            minX: -6,
            maxX: 6,
            minY: -23,
            maxY: 25,
            minZ: 30,
            maxZ: 45.8,
          },
          backNumber: {
            minX: -6,
            maxX: 6,
            minY: -23,
            maxY: 25,
            minZ: 30,
            maxZ: 45.8,
          },
          frontLogo: {
            minX: -6,
            maxX: 6,
            minY: -23,
            maxY: 25,
            minZ: 30,
            maxZ: 45.8,
          },
          backLogo: {
            minX: -6,
            maxX: 6,
            minY: -23,
            maxY: 25,
            minZ: 30,
            maxZ: 45.8,
          },
        },
        kidskidsbasketballjersey: {
          frontText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backLogo: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
        },
        kidskidsfootballjersey: {
          frontText: {
            minX: -5,
            maxX: 5,
            minY: -8,
            maxY: 7,
            minZ: -8,
            maxZ: 8,
          },
          backText: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
          frontNumber: {
            minX: -5,
            maxX: 5,
            minY: -8,
            maxY: 7,
            minZ: -8,
            maxZ: 8,
          },
          backNumber: {
            minX: -5,
            maxX: 5,
            minY: -8,
            maxY: 7,
            minZ: -8,
            maxZ: 8,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -8,
            maxY: 7,
            minZ: -8,
            maxZ: 8,
          },
          backLogo: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
        },
        kidskidssoccerjersey: {
          frontText: {
            minX: -5,
            maxX: 5,
            minY: -8,
            maxY: 7,
            minZ: -8,
            maxZ: 8,
          },
          backText: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
          frontNumber: {
            minX: -5,
            maxX: 5,
            minY: -8,
            maxY: 7,
            minZ: -8,
            maxZ: 8,
          },
          backNumber: {
            minX: -5,
            maxX: 5,
            minY: -8,
            maxY: 7,
            minZ: -8,
            maxZ: 8,
          },
          frontLogo: {
            minX: -5,
            maxX: 5,
            minY: -8,
            maxY: 7,
            minZ: -8,
            maxZ: 8,
          },
          backLogo: { minX: -5, maxX: 5, minY: -8, maxY: 7, minZ: -8, maxZ: 8 },
        },
        kidskidsshorts: {
          frontText: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backText: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          frontLogo: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backLogo: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
        },
        kidskidscricketshorts: {
          frontText: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backText: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          frontLogo: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backLogo: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
        },
        kidskidscyclingshorts: {
          frontText: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backText: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          frontLogo: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backLogo: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
        },
        kidskidswintershorts: {
          frontText: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backText: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          frontLogo: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backLogo: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
        },
        kidskidsrunningshorts: {
          frontText: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backText: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          frontLogo: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backLogo: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
        },
        kidskidswovenshorts: {
          frontText: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backText: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          frontLogo: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backLogo: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
        },
        kidskidsknittedshorts: {
          frontText: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backText: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          frontLogo: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backLogo: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
        },
        kidskidsbasketballshorts: {
          frontText: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backText: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          frontLogo: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backLogo: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
        },
        kidskidssoccershorts: {
          frontText: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backText: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          frontLogo: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backLogo: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
        },
        kidskidsfootballshorts: {
          frontText: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backText: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          frontLogo: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backLogo: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
        },
        kidskidsnftfootballshorts: {
          frontText: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backText: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          frontNumber: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backNumber: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          frontLogo: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
          backLogo: {
            minX: -8,
            maxX: 8,
            minY: -6,
            maxY: 5.5,
            minZ: -6,
            maxZ: 5.5,
          },
        },
        default: {
          frontText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.0575,
            maxY: 0.15,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backText: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.05,
            maxY: 0.1725,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.1725,
            maxY: 0.05,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backNumber: {
            minX: -0.1,
            maxX: 0.1,
            minY: -0.15,
            maxY: 0.0575,
            minZ: -0.15,
            maxZ: 0.18,
          },
          frontLogo: {
            minX: -0.12,
            maxX: 0.12,
            minY: -0.115,
            maxY: 0.2,
            minZ: -0.15,
            maxZ: 0.18,
          },
          backLogo: {
            minX: -0.12,
            maxX: 0.12,
            minY: -0.1,
            maxY: 0.23,
            minZ: -0.15,
            maxZ: 0.18,
          },
        },
      };

      // Check if it's an event order with specific glbId
      if (
        modelKey === "eventordereventjersey" &&
        glbId &&
        modelBoundaries[modelKey][glbId]
      ) {
        return modelBoundaries[modelKey][glbId];
      }

      // Check if model has specific boundaries
      if (modelBoundaries[modelKey]) {
        return modelBoundaries[modelKey];
      }

      // Return default boundaries
      return modelBoundaries.default;
    }, [glbId]);

    const applyBoundaryConstraints = useCallback(
      (position, decalType) => {
        const boundaries = getBoundariesForModel();
        const boundary = boundaries[decalType];

        if (!boundary) {
          return position; // No boundary defined, return original position
        }

        const constrainedPosition = [...position];
        constrainedPosition[0] = Math.max(
          boundary.minX,
          Math.min(boundary.maxX, position[0])
        );
        constrainedPosition[1] = Math.max(
          boundary.minY,
          Math.min(boundary.maxY, position[1])
        );
        constrainedPosition[2] = Math.max(
          boundary.minZ,
          Math.min(boundary.maxZ, position[2])
        );

        return constrainedPosition;
      },
      [getBoundariesForModel]
    );

    // HANDLE MOUSE/TOUCH MOVE - OPTIMIZED
    // ==========================================
    const rafRef = useRef(null);

    const handleGlobalMove = useCallback(
      (e) => {
        if (interactionMode === "idle") return;

        const getCoords = (event) => {
          if (event.touches && event.touches.length > 0) {
            return { x: event.touches[0].clientX, y: event.touches[0].clientY };
          }
          return { x: event.clientX, y: event.clientY };
        };

        const coords = getCoords(e);
        const modelKey = state.newKey;

        const allowedMovementModels = [
          "menmenjersey",
          "menmenxjersey",
          "kidskidsxjersey",
          "kidskidsbasketballjersey",
          "womenwomenbadmintonjersey",
          "womenwomenprotshirt",
          "womenwomensinglet",
          "womenwomenarmsleeves",
          "womenwomenjersey",
          "womenwomensoccerjersey",
          "menmensoccerjersey",
          "menmenprotshirt",
          "menmenfootballjersey",
          "menmencricketjersey",
          "womenwomenfootballjersey",
          "womenwomenxjersey",
          "womenwomenbadmintontanktop",
        ];

        const isEventOrderSpecial =
          modelKey === "eventordereventjersey" &&
          (glbId === "900" || glbId === "904");

        const useSpecialMovement =
          allowedMovementModels.includes(modelKey) || isEventOrderSpecial;
        const useFirstResizeMethod =
          allowedMovementModels.includes(modelKey) || isEventOrderSpecial; // ⭐ FIXED: Use same condition

        if (interactionMode === "dragging" && isDragging && selectedDecal) {
          const start = dragStartPosRef.current;
          const initial = initialDecalPosRef.current;
          const deltaX = coords.x - start.x;
          const deltaY = coords.y - start.y;

          const movement = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
          if (movement > 3) hasDraggedRef.current = true;

          let newPosition;

          if (modelKey === "menmencricketjersey") {
            const normalSensitivityX = 2.4;
            const normalSensitivityZ = 2.8;
            const isBackSide = selectedDecal.includes("back");
            const finalDeltaX = isBackSide ? -deltaX : deltaX;
            const newX = initial[0] + finalDeltaX * normalSensitivityX;
            const newZ = initial[1] + deltaY * normalSensitivityZ;
            newPosition = [newX, initial[1], newZ];
          } else if (useSpecialMovement) {
            const sensitivity = 0.0015;
            const isBackSide = selectedDecal.includes("back");
            const newX = initial[0] + (isBackSide ? -deltaX : deltaX) * sensitivity;
            const newY = initial[1] - deltaY * sensitivity;
            newPosition = [newX, newY, initial[2]];
          } else if (
            modelKey === "menmencitycollection" ||
            modelKey === "womenwomencitycollection"
          ) {
            const normalSensitivityX = 1.4;
            const normalSensitivityZ = 1.8;
            const isBackSide = selectedDecal.includes("back");
            const finalDeltaX = isBackSide ? -deltaX : deltaX;
            const newX = initial[0] + finalDeltaX * normalSensitivityX;
            const newZ = initial[2] + deltaY * normalSensitivityZ;
            newPosition = [newX, initial[1], newZ];
          } else {
            const normalSensitivityX = 0.09;
            const normalSensitivityZ = 0.2;
            const isBackSide = selectedDecal.includes("back");
            const finalDeltaX = isBackSide ? -deltaX : deltaX;
            const newX = initial[0] + finalDeltaX * normalSensitivityX;
            const newZ = initial[2] - deltaY * normalSensitivityZ;
            newPosition = [newX, initial[1], newZ];
          }

          newPosition = applyBoundaryConstraints(newPosition, selectedDecal);
          lastDragPositionRef.current = newPosition;
          selectedDecalDragRef.current = selectedDecal;
          setTempPosition(newPosition);
          setDecalPositions((prev) => ({ ...prev, [selectedDecal]: newPosition }));
        }

        if (
          interactionMode === "resizing" &&
          isResizing &&
          selectedDecal &&
          activeCorner
        ) {
          requestAnimationFrame(() => {
            const deltaX = coords.x - dragStartPos.x;
            const deltaY = coords.y - dragStartPos.y;
            let adjustedDeltaX = deltaX;
            let adjustedDeltaY = deltaY;

            const sensitivity = selectedDecal.includes("Logo") ? 0.005 : 0.003;

            let newScale;

            if (modelKey === "menmencricketjersey") {
              const cricketSensitivity = selectedDecal.includes("Logo") ? 5 : 4;
              newScale = [...initialDecalScale];

              switch (activeCorner) {
                case "tl":
                  newScale[0] = Math.max(
                    100,
                    Math.min(
                      2000,
                      initialDecalScale[0] - adjustedDeltaX * cricketSensitivity
                    )
                  );
                  newScale[1] = Math.max(
                    100,
                    Math.min(
                      2000,
                      initialDecalScale[1] - adjustedDeltaY * cricketSensitivity
                    )
                  );
                  break;
                case "tr":
                  newScale[0] = Math.max(
                    100,
                    Math.min(
                      2000,
                      initialDecalScale[0] + adjustedDeltaX * cricketSensitivity
                    )
                  );
                  newScale[1] = Math.max(
                    100,
                    Math.min(
                      2000,
                      initialDecalScale[1] - adjustedDeltaY * cricketSensitivity
                    )
                  );
                  break;
                case "bl":
                  newScale[0] = Math.max(
                    100,
                    Math.min(
                      2000,
                      initialDecalScale[0] - adjustedDeltaX * cricketSensitivity
                    )
                  );
                  newScale[1] = Math.max(
                    100,
                    Math.min(
                      2000,
                      initialDecalScale[1] + adjustedDeltaY * cricketSensitivity
                    )
                  );
                  break;
                case "br":
                  newScale[0] = Math.max(
                    100,
                    Math.min(
                      2000,
                      initialDecalScale[0] + adjustedDeltaX * cricketSensitivity
                    )
                  );
                  newScale[1] = Math.max(
                    100,
                    Math.min(
                      2000,
                      initialDecalScale[1] + adjustedDeltaY * cricketSensitivity
                    )
                  );
                  break;
                default:
                  newScale = initialDecalScale;
                  break;
              }
              console.log("Cricket Jersey Resize - New Scale:", newScale);
            } else if (useFirstResizeMethod) {
              // ⭐ NOW THIS USES THE SAME MODELS LIST
              newScale = [...initialDecalScale];
              switch (activeCorner) {
                case "tl":
                  newScale[0] = Math.max(
                    0.05,
                    Math.min(
                      8,
                      initialDecalScale[0] - adjustedDeltaX * sensitivity
                    )
                  );
                  newScale[1] = Math.max(
                    0.05,
                    Math.min(
                      8,
                      initialDecalScale[1] - adjustedDeltaY * sensitivity
                    )
                  );
                  break;
                case "tr":
                  newScale[0] = Math.max(
                    0.05,
                    Math.min(
                      8,
                      initialDecalScale[0] + adjustedDeltaX * sensitivity
                    )
                  );
                  newScale[1] = Math.max(
                    0.05,
                    Math.min(
                      8,
                      initialDecalScale[1] - adjustedDeltaY * sensitivity
                    )
                  );
                  break;
                case "bl":
                  newScale[0] = Math.max(
                    0.05,
                    Math.min(
                      8,
                      initialDecalScale[0] - adjustedDeltaX * sensitivity
                    )
                  );
                  newScale[1] = Math.max(
                    0.05,
                    Math.min(
                      8,
                      initialDecalScale[1] + adjustedDeltaY * sensitivity
                    )
                  );
                  break;
                case "br":
                  newScale[0] = Math.max(
                    0.05,
                    Math.min(
                      8,
                      initialDecalScale[0] + adjustedDeltaX * sensitivity
                    )
                  );
                  newScale[1] = Math.max(
                    0.05,
                    Math.min(
                      8,
                      initialDecalScale[1] + adjustedDeltaY * sensitivity
                    )
                  );
                  break;
                default:
                  newScale = initialDecalScale;
                  break;
              }
            } else if (
              modelKey === "menmencitycollection" ||
              modelKey === "womenwomencitycollection"
            ) {
              const diagonalDelta = Math.sqrt(
                adjustedDeltaX * adjustedDeltaX +
                  adjustedDeltaY * adjustedDeltaY
              );

              // Double the sensitivity for faster scaling
              const fasterSensitivity = sensitivity * 3;

              let scaleFactor = 1;
              switch (activeCorner) {
                case "tl":
                  scaleFactor =
                    1 +
                    (adjustedDeltaX < 0 && adjustedDeltaY < 0
                      ? -diagonalDelta
                      : diagonalDelta) *
                      fasterSensitivity;
                  break;
                case "tr":
                  scaleFactor =
                    1 +
                    (adjustedDeltaX > 0 && adjustedDeltaY < 0
                      ? -diagonalDelta
                      : diagonalDelta) *
                      fasterSensitivity;
                  break;
                case "bl":
                  scaleFactor =
                    1 +
                    (adjustedDeltaX < 0 && adjustedDeltaY > 0
                      ? -diagonalDelta
                      : diagonalDelta) *
                      fasterSensitivity;
                  break;
                case "br":
                  scaleFactor =
                    1 +
                    (adjustedDeltaX > 0 && adjustedDeltaY > 0
                      ? diagonalDelta
                      : -diagonalDelta) *
                      fasterSensitivity;
                  break;
              }
              newScale = initialDecalScale.map((s) =>
                Math.max(265, Math.min(1200, s * scaleFactor))
              );
            } else {
              const diagonalDelta = Math.sqrt(
                adjustedDeltaX * adjustedDeltaX +
                  adjustedDeltaY * adjustedDeltaY
              );
              let scaleFactor = 1;
              switch (activeCorner) {
                case "tl":
                  scaleFactor =
                    1 +
                    (adjustedDeltaX < 0 && adjustedDeltaY < 0
                      ? -diagonalDelta
                      : diagonalDelta) *
                      sensitivity;
                  break;
                case "tr":
                  scaleFactor =
                    1 +
                    (adjustedDeltaX > 0 && adjustedDeltaY < 0
                      ? -diagonalDelta
                      : diagonalDelta) *
                      sensitivity;
                  break;
                case "bl":
                  scaleFactor =
                    1 +
                    (adjustedDeltaX < 0 && adjustedDeltaY > 0
                      ? -diagonalDelta
                      : diagonalDelta) *
                      sensitivity;
                  break;
                case "br":
                  scaleFactor =
                    1 +
                    (adjustedDeltaX > 0 && adjustedDeltaY > 0
                      ? diagonalDelta
                      : -diagonalDelta) *
                      sensitivity;
                  break;
              }
              newScale = initialDecalScale.map((s) =>
                Math.max(5, Math.min(300, s * scaleFactor))
              );
            }

            setTempScale(newScale);
            setDecalScales((prev) => ({
              ...prev,
              [selectedDecal]: newScale,
            }));

            if (selectedDecal.includes("front")) {
              frontLogoScale[0] = newScale[0];
              frontLogoScale[1] = newScale[1];
            } else if (selectedDecal.includes("back")) {
              backLogoScale[0] = newScale[0];
              backLogoScale[1] = newScale[1];
            }
          });
        }
      },
      [
        interactionMode,
        isDragging,
        isResizing,
        selectedDecal,
        activeCorner,
        dragStartPos,
        initialDecalPos,
        initialDecalScale,
        state.newKey,
        glbId,
      ]
    );

    // ==========================================
    // HANDLE MOUSE/TOUCH UP
    // ==========================================
    const handleGlobalUp = () => {
      if (isDragging) {
        const decal = selectedDecalDragRef.current;
        const last = lastDragPositionRef.current;
        if (decal && last && last.length === 3) {
          const pos = [...last];
          setDecalPositions((prev) => ({ ...prev, [decal]: pos }));
          setTempPosition(pos);
        }
        selectedDecalDragRef.current = null;
        setIsDragging(false);
        hasDraggedRef.current = false;
      }

      if (isResizing) {
        setIsResizing(false);
        setActiveCorner(null);
        document.body.style.cursor = "auto";
      }

      stopContinuousRotation();
      setInteractionMode("idle");
    };

    // ==========================================
    // ATTACH GLOBAL EVENT LISTENERS
    // ==========================================
    useEffect(() => {
      if (interactionMode === "dragging" || interactionMode === "resizing") {
        const handleMove = (e) => {
          e.preventDefault();
          handleGlobalMove(e);
        };

        const handleUp = (e) => {
          handleGlobalUp(e);
        };

        document.addEventListener("mousemove", handleMove);
        document.addEventListener("mouseup", handleUp);
        document.addEventListener("touchmove", handleMove, { passive: false });
        document.addEventListener("touchend", handleUp);

        return () => {
          document.removeEventListener("mousemove", handleMove);
          document.removeEventListener("mouseup", handleUp);
          document.removeEventListener("touchmove", handleMove);
          document.removeEventListener("touchend", handleUp);
        };
      }
    }, [
      interactionMode,
      isDragging,
      isResizing,
      selectedDecal,
      dragStartPos,
      initialDecalPos,
      initialDecalScale,
      activeCorner,
    ]);

    const handleResizeMove = (e) => {
      if (!resizeMode || !selectedDecal || !initialScale) return;

      // Get coordinates from either mouse or touch event
      const getEventCoords = (event) => {
        if (event.touches && event.touches.length > 0) {
          return { x: event.touches[0].clientX, y: event.touches[0].clientY };
        }
        return { x: event.clientX, y: event.clientY };
      };

      const coords = getEventCoords(e);
      const deltaX = coords.x - resizeStartPos.x;
      const deltaY = coords.y - resizeStartPos.y;

      // Calculate scale change based on diagonal movement for corner resize
      const delta =
        Math.sqrt(deltaX * deltaX + deltaY * deltaY) *
        (deltaX + deltaY > 0 ? 1 : -1);
      const scaleFactor = 1 + delta * 0.003;

      const newScale = [
        Math.max(0.1, Math.min(3, initialScale[0] * scaleFactor)),
        Math.max(0.1, Math.min(3, initialScale[1] * scaleFactor)),
        initialScale[2],
      ];

      setDecalScales((prev) => ({
        ...prev,
        [selectedDecal]: newScale,
      }));

      setTempScale(newScale);
    };

    const handleResizeUp = () => {
      if (resizeMode && selectedDecal && tempScale) {
        // Save the final scale
        setDecalScales((prev) => ({
          ...prev,
          [selectedDecal]: tempScale,
        }));
      }

      setResizeMode(false);
      setResizeCorner(null);
      setInitialScale(null);
      setTempScale([0, 0, 0]);
      setInteractionMode("rotate-shirt");
      setSelectedDecal(null);
    };

    // Mobile detection helper function
    const isMobileDevice = () => {
      return (
        window.innerWidth <= 768 ||
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      );
    };

    const handlePointerMove = (e) => {
      // Prevent default touch behavior to avoid page scrolling during drag
      if (e.type === "touchmove") {
        e.preventDefault();
      }

      // Only block pointer move when TransformControls is actively being used
      if (interactionMode === "transform-controls") {
        return;
      }

      // Better detection for active dragging
      const isMouseDown = e.buttons === 1;
      const isTouchMove =
        e.type === "touchmove" && e.touches && e.touches.length > 0;
      const isPointerMove = e.type === "pointermove" && e.pressure > 0;

      if (!isMouseDown && !isTouchMove && !isPointerMove) return;

      const getEventCoords = (event) => {
        // Touch events
        if (event.touches && event.touches.length > 0) {
          return { x: event.touches[0].clientX, y: event.touches[0].clientY };
        }
        // Pointer events (including touch on some devices)
        if (event.clientX !== undefined && event.clientY !== undefined) {
          return { x: event.clientX, y: event.clientY };
        }
        return { x: 0, y: 0 };
      };

      const coords = getEventCoords(e);

      // NEW RESIZE FEATURE - Handle new resize mode
      if (interactionMode === "new-resize-mode") {
        handleNewResizeFunction(e);
        return;
      }

      if (interactionMode === "resize-decal") {
        handleResizeMove(e);
        return;
      }

      // Handle rotation mode
      if (interactionMode === "rotating" && isRotating && selectedDecal) {
        const currentAngle = Math.atan2(
          coords.y - rotationCenter.y,
          coords.x - rotationCenter.x
        );

        // Calculate rotation delta
        const angleDelta = currentAngle - rotationStartAngle;

        // Apply rotation (adding the delta to initial rotation)
        let newRotation = initialDecalRotation + angleDelta;

        // Normalize to 0-2π range
        while (newRotation < 0) newRotation += Math.PI * 2;
        while (newRotation >= Math.PI * 2) newRotation -= Math.PI * 2;

        setDecalRotations((prev) => ({
          ...prev,
          [selectedDecal]: newRotation,
        }));
        return;
      }

      if (interactionMode === "move-decal" && selectedDecal) {
        // Get model-specific movement sensitivity
        const modelKey = state.newKey;
        let modelConfig = modelConfig1[modelKey];

        // SPECIAL HANDLING for eventordereventjersey
        if (modelKey === "eventordereventjersey" && glbId) {
          modelConfig = modelConfig1[modelKey][glbId] || modelConfig1[modelKey];
        }

        // Base sensitivity values
        let sensitivityX = selectedDecal.includes("Logo") ? 0.001 : 0.0008;
        let sensitivityY = selectedDecal.includes("Logo") ? 0.001 : 0.0008;

        // INCREASED sensitivity for touch devices (mobile)
        if (e.type === "touchmove" || e.pointerType === "touch") {
          sensitivityX *= 2.5; // Increased from 1.5 to 2.5
          sensitivityY *= 2.5;
        }

        // Additional mobile-specific boost for better responsiveness
        if (isMobileDevice()) {
          sensitivityX *= 1.5;
          sensitivityY *= 1.5;
        }

        if (modelConfig) {
          const scale = modelConfig.scale;
          const overallScale = modelConfig.overallScale || 1;
          const scaleFactor = Array.isArray(scale) ? scale[0] || 1 : scale || 1;

          let adjustedFactor = 1;

          if (
            modelKey === "menmenjersey" ||
            (modelKey === "eventordereventjersey" && glbId === "902")
          ) {
            adjustedFactor = Math.min(
              3,
              Math.max(0.5, scaleFactor / overallScale)
            );
          } else if (
            modelKey === "eventordereventjersey" &&
            (glbId === "900" || glbId === "904")
          ) {
            if (scaleFactor < 0.01) {
              adjustedFactor = Math.min(20, Math.max(5, 1 / scaleFactor));
            } else if (scaleFactor < 1) {
              adjustedFactor = Math.min(10, Math.max(2, 1 / scaleFactor));
            } else {
              adjustedFactor = Math.min(
                5,
                Math.max(0.2, scaleFactor / overallScale)
              );
            }
          } else if (modelKey === "womenwomenfootballjersey") {
            adjustedFactor = Math.min(
              3,
              Math.max(0.5, scaleFactor / overallScale)
            );
          } else if (
            modelKey === "menmenxjersey" ||
            (modelKey === "eventordereventjersey" && glbId === "903")
          ) {
            adjustedFactor = Math.min(
              3,
              Math.max(0.5, scaleFactor / overallScale)
            );
          } else if (modelKey === "womenwomenbadmintontanktop") {
            adjustedFactor = Math.min(
              4,
              Math.max(0.8, scaleFactor / overallScale)
            );
          } else if (scaleFactor < 0.01) {
            adjustedFactor = Math.min(15, Math.max(3, 1 / scaleFactor));
          } else if (scaleFactor < 0.1) {
            adjustedFactor = Math.min(10, Math.max(2, 1 / scaleFactor));
          } else {
            adjustedFactor = Math.min(
              5,
              Math.max(0.2, scaleFactor / overallScale)
            );
          }

          sensitivityX *= adjustedFactor;
          sensitivityY *= adjustedFactor;
        }

        let deltaX = (coords.x - mouseStartPos.x) * sensitivityX;
        let deltaY = -(coords.y - mouseStartPos.y) * sensitivityY;

        let maxDelta = 0.1;
        if (
          modelKey === "eventordereventjersey" &&
          (glbId === "900" || glbId === "902" || glbId === "904")
        ) {
          maxDelta = 0.5;
        } else if (
          modelKey === "menmenjersey" ||
          modelKey === "womenwomenfootballjersey" ||
          modelKey === "menmenxjersey"
        ) {
          maxDelta = 0.2;
        } else if (modelKey === "womenwomenbadmintontanktop") {
          maxDelta = 0.15;
        }

        deltaX = Math.max(-maxDelta, Math.min(maxDelta, deltaX));
        deltaY = Math.max(-maxDelta, Math.min(maxDelta, deltaY));

        const isBackSide = ["backText", "backNumber", "backLogo"].includes(
          selectedDecal
        );
        if (isBackSide) {
          deltaX *= -1;
        }

        let positionArray;
        switch (selectedDecal) {
          case "frontText":
            positionArray = frontTextPosition;
            break;
          case "backText":
            positionArray = backTextPosition;
            break;
          case "frontNumber":
            positionArray = frontNumberPosition;
            break;
          case "backNumber":
            positionArray = backNumberPosition;
            break;
          case "frontLogo":
            positionArray = frontLogoPosition;
            break;
          case "backLogo":
            positionArray = backLogoPosition;
            break;
          default:
            return;
        }

        const modelRotation = modelConfig?.rotation || [0, 0, 0];

        if (Math.abs(modelRotation[0]) > 1) {
          positionArray[0] += deltaX;
          positionArray[2] += deltaY;
        } else {
          positionArray[0] += deltaX;
          positionArray[1] += deltaY;
        }

        // Apply boundary constraints using shared helper function
        const constrainedPosition = applyBoundaryConstraints(
          [...positionArray],
          selectedDecal
        );
        positionArray[0] = constrainedPosition[0];
        positionArray[1] = constrainedPosition[1];
        positionArray[2] = constrainedPosition[2];

        setTempPosition([...positionArray]);
        setMouseStartPos(coords);
        setWasMoved(true); // Track that movement occurred
      }
    };
    const [wasMoved, setWasMoved] = useState(false);

    const handlePointerUp = () => {
      if (interactionMode === "transform-controls") {
        // Don't deselect - keep the decal selected for transform controls
        setInteractionMode("rotate-shirt");
        setIsTransforming(false);
        return;
      }

      if (interactionMode === "new-resize-mode") {
        endNewResize();
        return;
      }

      if (resizeMode && selectedDecal) {
        setResizeMode(false);
        setResizeCorner(null);
        setInitialScale(null);
        setInteractionMode("rotate-shirt");
        // Keep decal selected after resize
        return;
      }

      // Handle rotation end
      if (interactionMode === "rotating" && isRotating && selectedDecal) {
        setIsRotating(false);
        setInteractionMode("idle");
        // Keep decal selected after rotation
        return;
      }

      if (interactionMode === "move-decal" && selectedDecal) {
        setDecalPositions((prev) => ({
          ...prev,
          [selectedDecal]: tempPosition,
        }));

        setInteractionMode("rotate-shirt");
        setWasMoved(false);
        // Keep decal selected after move (don't deselect)
      }
    };

    const renderResizeArrow = () => {
      return null;
    };

    const getTransformTarget = useCallback(
      (type, position, rotation, scale) => {
        const existing = transformTargetsRef.current[type];
        const target = existing || new THREE.Object3D();

        target.position.set(position[0], position[1], position[2]);
        target.rotation.set(rotation[0], rotation[1], rotation[2]);

        const targetScale = Array.isArray(scale)
          ? scale
          : [scale || 1, scale || 1, scale || 1];

        target.scale.set(
          targetScale[0] || 1,
          targetScale[1] || 1,
          targetScale[2] || 1
        );

        transformTargetsRef.current[type] = target;
        return target;
      },
      []
    );

    const isDecalFacingCamera = useCallback(
      (e) => {
        if (!e?.point || !e?.face || !e?.object || !camera) return true;
        const normal = new THREE.Vector3();
        normal.copy(e.face.normal).transformDirection(e.object.matrixWorld);
        const toCamera = new THREE.Vector3()
          .subVectors(camera.position, e.point)
          .normalize();
        return normal.dot(toCamera) > 0.1;
      },
      [camera]
    );

    const mobileScaleFactor = isMobile ? 0.75 : 1.0;
    const mobilePositionOffset = isMobile ? [0, 0.06, 0] : [0, 0, 0];

const getResizeIconWidth = (modelKey) => {
  const widthConfigs = {
    // Men jerseys - standard size
    "menmenjersey": "70%",
    "menmenxjersey": "70%",
    "menmenprotshirt": "70%",
    "menmenfootballjersey": "70%",
    "menmensoccerjersey": "70%",

    // Men tanktops/singlets/armsleeves - slightly smaller
    "menmentanktop": "20%",
    "menmensinglet": "20%",
    "menmenarmsleeves": "15%",
    
    // Men cycling/winter/basketball jerseys - medium
    "menmencyclingjersey": "15%",
    "menmenwinterjersey": "15%",
    "menmenbasketballjersey": "15%",
    
    // Men city collection & cricket jersey - very small
    "menmencitycollection": "1%",
    "menmencricketjersey": "1%",

    // Men shorts - larger for visibility
    "menmenshorts": "35%",
    "menmenrunningshorts": "35%",
    "menmenwovenshorts": "35%",
    "menmencyclingshorts": "35%",
    "menmencricketshorts": "35%",
    "menmenknittedshorts": "35%",
    "menmenfootballshorts": "35%",
    "menmensoccershorts": "35%",
    "menmenbasketballshorts": "35%",
    "menmennftfootballshorts": "35%",

    // Men pants
    "menmentrackpants": "25%",
    "menmencompressionpants": "25%",
  
    // Women jerseys
    "womenwomenjersey": "70%",
    "womenwomenxjersey": "70%",
    "womenwomenprotshirt": "70%",
    "womenwomenfootballjersey": "70%",
    "womenwomensoccerjersey": "70%",
    "womenwomenbadmintonjersey": "70%",

    // Women shorts
    "womenwomenbadmintonshorts": "45%",
    "womenwomencyclingshorts": "45%",
    "womenwomencricketshorts": "45%",
    "womenwomenwovenshorts": "45%",
    "womenwomentightshorts": "45%",
    "womenwomenfootballshorts": "45%",
    "womenwomensoccershorts": "45%",
    "womenwomennftfootballshorts": "45%",
    "womenwomenbasketballshorts": "45%",
    "womenwomenknittedshorts": "45%",
    "womenwomenshorts": "45%",

    // Women pants
    "womenwomencrickettrackpants": "23%",
    "womenwomentrackpants": "23%",
    "womenwomencompressionpants": "13%",

    // Women special jerseys
    "womenwomencyclingjersey": "15%",
    "womenwomenwinterjersey": "15%",
    "womenwomencitycollection": "1.5%",
    "womenwomencricketjersey": "20%",
   
    // Kids jerseys - smaller
    "kidskidsjersey": "65%",
    "kidskidsprotshirt": "65%",
    "kidskidsxjersey": "65%",
    "kidskidsfootballjersey": "65%",
    "kidskidssoccerjersey": "65%",

    // Kids tanktops/singlets/armsleeves
    "kidskidstanktop": "20%",
    "kidskidssinglet": "20%",
    "kidskidsarmsleeves": "45%",
    
    // Kids special jerseys
    "kidskidscyclingjersey": "65%",
    "kidskidswinterjersey": "65%",
    "kidskidscitycollection": "65%",
    "kidskidscricketjersey": "30%",
    "kidskidsbasketballjersey": "65%",

    // Kids shorts
    "kidskidsshorts": "70%",
    "kidskidscricketshorts": "70%",
    "kidskidscyclingshorts": "70%",
    "kidskidswintershorts": "70%",
    "kidskidsrunningshorts": "70%",
    "kidskidswovenshorts": "70%",
    "kidskidsknittedshorts": "70%",
    "kidskidsbasketballshorts": "70%",
    "kidskidssoccershorts": "70%",
    "kidskidsfootballshorts": "70%",
    "kidskidsnftfootballshorts": "70%",

    // Kids pants
    "kidskidscompressionpants": "35%",
    "kidskidstrackpants": "35%",
    
    // Default
    "default": "150%"
  };

  return widthConfigs[modelKey] || widthConfigs.default;
};

    const getRotationIconSize = (modelKey, dotSize, isMobile) => {
  const sizeConfigs = {
    "menmenjersey": { min: 12, dotMult: 1.4, baseMult: 30 },
      "menmenxjersey": { min: 12, dotMult: 1.4, baseMult: 30 },
    "menmenprotshirt": { min: 12, dotMult: 1.4, baseMult: 30 },
    "menmenfootballjersey": { min: 12, dotMult: 1.4, baseMult: 30 },
    "menmensoccerjersey": { min: 12, dotMult: 1.4, baseMult: 30 },

    "menmentanktop": { min: 6, dotMult: 0.7, baseMult: 18 },
    "menmensinglet": { min: 6, dotMult: 0.7, baseMult: 18 },
    "menmenarmsleeves": { min: 6, dotMult: 0.7, baseMult: 18 },
    
    "menmencyclingjersey": { min: 6, dotMult: 0.7, baseMult: 18 },
    "menmenwinterjersey": { min: 6, dotMult: 0.7, baseMult: 18 },
    "menmenbasketballjersey": { min: 6, dotMult: 0.7, baseMult: 18 },
    "menmencitycollection": { min: 2, dotMult: 0.1, baseMult: 7 },
    "menmencricketjersey": { min: 2, dotMult: 0.1, baseMult: 7 },

    "menmenshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "menmenrunningshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "menmenwovenshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "menmencyclingshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "menmencricketshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "menmentrackpants": { min: 8, dotMult: 1.1, baseMult: 23 },
    "menmenknittedshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "menmenfootballshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "menmensoccershorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "menmenbasketballshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "menmennftfootballshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "menmencompressionpants": { min: 5, dotMult: 0.7, baseMult: 18 },
  
    "womenwomenjersey": { min: 12, dotMult: 1.3, baseMult: 28 },
    "womenwomenxjersey": { min: 12, dotMult: 1.3, baseMult: 28 },
    "womenwomenprotshirt": { min: 12, dotMult: 1.3, baseMult: 28 },

    "womenwomenbadmintonshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "womenwomencyclingshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "womenwomencricketshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "womenwomenwovenshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "womenwomentightshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "womenwomenfootballshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "womenwomensoccershorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "womenwomennftfootballshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "womenwomenbasketballshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "womenwomenknittedshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "womenwomenshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "womenwomencrickettrackpants": { min: 5, dotMult: 0.7, baseMult: 18 },
    "womenwomentrackpants": { min: 5, dotMult: 0.7, baseMult: 18 },
    "womenwomencompressionpants": { min: 5, dotMult: 0.7, baseMult: 18 },

    "womenwomencyclingjersey": { min: 6, dotMult: 0.7, baseMult: 18 },
    "womenwomenwinterjersey": { min: 6, dotMult: 0.7, baseMult: 18 },
    "womenwomencitycollection": { min: 2, dotMult: 0.1, baseMult: 7 },
    "womenwomencricketjersey": { min: 6, dotMult: 0.7, baseMult: 18 },
   
    "kidskidsjersey": { min: 10, dotMult: 1.2, baseMult: 25 },
    "kidskidsprotshirt": { min: 10, dotMult: 1.2, baseMult: 25 },
    "kidskidsxjersey": { min: 10, dotMult: 1.2, baseMult: 25 },

    "kidskidstanktop": { min: 6, dotMult: 0.7, baseMult: 18 },
    "kidskidssinglet": { min: 6, dotMult: 0.7, baseMult: 18 },
    "kidskidsarmsleeves": { min: 6, dotMult: 0.7, baseMult: 18 },
    
    "kidskidscyclingjersey": { min: 6, dotMult: 0.7, baseMult: 18 },
    "kidskidswinterjersey": { min: 6, dotMult: 0.7, baseMult: 18 },
    "kidskidscitycollection": { min: 6, dotMult: 0.7, baseMult: 18 },
    "kidskidscricketjersey": { min: 6, dotMult: 0.7, baseMult: 18 },

    "kidskidsshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "kidskidscricketshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "kidskidscyclingshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "kidskidswintershorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "kidskidsrunningshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "kidskidswovenshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "kidskidsknittedshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "kidskidsbasketballshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "kidskidssoccershorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "kidskidsfootballshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "kidskidsnftfootballshorts": { min: 8, dotMult: 1.1, baseMult: 23 },
    "kidskidscompressionpants": { min: 5, dotMult: 0.7, baseMult: 18 },
    "kidskidstrackpants": { min: 5, dotMult: 0.7, baseMult: 18 },
    
    "default": { min: 12, dotMult: 1.4, baseMult: 30 }
  };

  const config = sizeConfigs[modelKey] || sizeConfigs.default;
  
  const mobileMult = isMobile ? 1.15 : 1.0; 
  
  return Math.max(
    config.min,
    Math.round(dotSize * config.dotMult * mobileMult * config.baseMult)
  );
};

    const renderDecal = (
      type,
      defaultTexture,
      defaultPosition,
      rotation,
      defaultScale
    ) => {
      console.log(`🔍 renderDecal called for ${type}`);
      console.log(`   productData:`, productData);
      console.log(`   ${type} value:`, productData?.[type]);
      console.log(`   should display:`, !!productData?.[type]);
      const isSelected = selectedDecal === type;
      const isTextDecal = type.toLowerCase().includes("text");
      const isNumberDecal = type.toLowerCase().includes("number");

      // Check if currently dragging this specific decal
      const isCurrentlyDragging =
        isSelected && interactionMode === "dragging" && isDragging;

      // Fix: Use tempPosition when selected and dragging for smooth real-time updates
      let position =
        isCurrentlyDragging && tempPosition && tempPosition.length === 3
          ? tempPosition
          : decalPositions[type] || defaultPosition;

      // Pull text/number decals slightly toward t-shirt surface to reduce gap (fabric.js)
      const displayPosition =
        isTextDecal || isNumberDecal
          ? [position[0], position[1], position[2] - 0.0004]
          : position;

      let scale;
      // Check if currently resizing this specific decal
      const isCurrentlyResizing =
        isSelected && interactionMode === "resizing" && isResizing;

      if (
        isCurrentlyResizing &&
        tempScale &&
        tempScale.length === 3 &&
        tempScale[0] !== 0
      ) {
        // Use tempScale for real-time resize feedback for all decal types including text
        scale = tempScale;
      } else if (isTextDecal || isNumberDecal) {
        scale = decalScales[type] || defaultScale;
      } else if (
        interactionMode === "new-resize-mode" &&
        newResizeSelectedDecal === type &&
        newResizeTempScale &&
        newResizeTempScale.length === 3 &&
        newResizeTempScale[0] !== 0
      ) {
        scale = newResizeTempScale;
      } else if (
        isSelected &&
        resizeMode &&
        tempScale &&
        tempScale.length === 3 &&
        tempScale[0] !== 0
      ) {
        scale = tempScale;
      } else {
        scale = decalScales[type] || defaultScale;
      }

      let shouldDisplay = false;
      let texture = null;

      // Use productData instead of snap!
      if (type.includes("Text")) {
        const textValue = productData?.[type] || ""; // e.g., productData.frontText
        shouldDisplay = !!textValue && textValue.trim() !== "";

        if (shouldDisplay) {
          texture = getTextTexture(
            type,
            textValue,
            // Use productData.textColors instead of snap.textColors
            productData?.textColors?.[
              type.includes("front") ? "front" : "back"
            ] || "#ffffff",
            // Use productData.textFonts instead of state.textFonts
            productData?.textFonts?.[
              type.includes("front") ? "front" : "back"
            ] ||
              productData?.selectedFonts ||
              "Arial",
            isSelected
          );
        }
      } else if (type.includes("Number")) {
        const numberValue = productData?.[type] || ""; // e.g., productData.frontNumber
        shouldDisplay = !!numberValue && numberValue.trim() !== "";

        if (shouldDisplay) {
          texture = getNumberTexture(
            type,
            numberValue,
            // Use productData.numberColors instead of snap.numberColors
            productData?.numberColors?.[
              type.includes("front") ? "front" : "back"
            ] || "#ffffff",
            // Use productData.numberFonts instead of state.numberFonts
            productData?.numberFonts?.[
              type.includes("front") ? "front" : "back"
            ] ||
              productData?.selectedFonts ||
              "Arial",
            isSelected
          );
        }
      } else if (type.includes("Logo")) {
        const logoTex = type === "frontLogo" ? logoTexture : logoTextureBack;
        shouldDisplay = !!logoTex;
        texture = logoTex;
      }

      if (!shouldDisplay || !texture) return null;

      // CRITICAL FIX: Show selection UI for ALL models, not just menmenjersey
      const shouldShowDots = isSelected;

      let adjustedScale = getAspectAwareScale(type, scale, texture);

      // Get model-specific configuration
      const modelKey = state.newKey;
      const modelConfig = getModelSettings(menuSlug, subcategorySlug);

      let selectionScaleMultiplier = 1;
      let frameWidthMultiplier = 1;
      let frameHeightMultiplier = 1;
      let cornerSizeMultiplier = 1;
      let showFullBorder = false;

      if (modelKey === "menmenjersey") {
        selectionScaleMultiplier = 1;
        frameWidthMultiplier = 1;
        frameHeightMultiplier = 1;
        showFullBorder = true;
      } else if (
        modelKey === "menmentrackpants" ||
        modelKey === "womenwomentrackpants"
      ) {
        selectionScaleMultiplier = 20;
        frameWidthMultiplier = 0.8;
        frameHeightMultiplier = 0.8;
      } else if (
        modelKey === "kidskidscricketshorts" ||
        modelKey === "kidskidsshorts" ||
        modelKey === "kidskidscyclingshorts" ||
        modelKey === "kidskidswintershorts" ||
        modelKey === "kidskidsrunningshorts" ||
        modelKey === "kidskidswovenshorts" ||
        modelKey === "kidskidsknittedshorts" ||
        modelKey === "kidskidsbasketballshorts" ||
        modelKey === "kidskidssoccershorts" ||
        modelKey === "kidskidsfootballshorts" ||
        modelKey === "kidskidsnftfootballshorts"
      ) {
        selectionScaleMultiplier = 1;
        frameWidthMultiplier = 1;
        frameHeightMultiplier = 1;
        showFullBorder = true;
      } else if (modelKey.includes("shorts")) {
        selectionScaleMultiplier = 1;
        frameWidthMultiplier = 1;
        frameHeightMultiplier = 1;
        showFullBorder = true;
      } else if (
        modelKey === "menmentanktop" ||
        modelKey === "menmenarmsleeves" ||
        modelKey === "menmensinglet"
      ) {
        selectionScaleMultiplier = 1; // Fixed from 20 to 1
        frameWidthMultiplier = 1; // Fixed from 24 to 1
        frameHeightMultiplier = 1; // Fixed from 25 to 1
        showFullBorder = true;
      } else if (
        modelKey === "menmencyclingjersey" ||
        modelKey === "menmenwinterjersey" ||
        modelKey === "menmenbasketballjersey" ||
        modelKey === "womenwomencyclingjersey" ||
        modelKey === "womenwomenwinterjersey"
      ) {
        selectionScaleMultiplier = 1; // Fixed from 20 to 1
        frameWidthMultiplier = 1; // Fixed from 24 to 1
        frameHeightMultiplier = 1; // Fixed from 25 to 1
        showFullBorder = true;
      } else if (
        modelKey === "menmencitycollection" ||
        modelKey === "womenwomencitycollection"
      ) {
        selectionScaleMultiplier = 1; // Fixed from 150 to 1
        frameWidthMultiplier = 1; // Fixed from 24 to 1
        frameHeightMultiplier = 1; // Fixed from 25 to 1
        showFullBorder = true;
      } else if (modelKey === "womenwomencricketjersey") {
        selectionScaleMultiplier = 1; // Fixed from 15 to 1
        frameWidthMultiplier = 1; // Fixed from 24 to 1
        frameHeightMultiplier = 1; // Fixed from 25 to 1
        showFullBorder = true;
      } else if (
        modelKey === "kidskidsjersey" ||
        modelKey === "kidskidsprotshirt" ||
        modelKey === "kidskidsfootballjersey" ||
        modelKey === "kidskidssoccerjersey"
      ) {
        selectionScaleMultiplier = 1; // Fixed from 3 to 1
        frameWidthMultiplier = 1; // Fixed from 24 to 1
        frameHeightMultiplier = 1; // Fixed from 25 to 1
        showFullBorder = true;
      } else if (
        modelKey === "kidskidstanktop" ||
        modelKey === "kidskidssinglet"
      ) {
        selectionScaleMultiplier = 1; // Fixed from 15 to 1
        frameWidthMultiplier = 1; // Fixed from 24 to 1
        frameHeightMultiplier = 1; // Fixed from 25 to 1
        showFullBorder = true;
      } else if (
        modelKey === "kidskidscyclingjersey" ||
        modelKey === "kidskidswinterjersey" ||
        modelKey === "kidskidscitycollection"
      ) {
        selectionScaleMultiplier = 1; // Fixed from 5 to 1
        frameWidthMultiplier = 1; // Fixed from 24 to 1
        frameHeightMultiplier = 1; // Fixed from 25 to 1
        showFullBorder = true;
      } else if (modelKey === "kidskidscricketjersey") {
        selectionScaleMultiplier = 1; // Fixed from 15 to 1
        frameWidthMultiplier = 1; // Fixed from 24 to 1
        frameHeightMultiplier = 1; // Fixed from 25 to 1
        showFullBorder = true;
      } else if (modelKey === "kidskidsxjersey") {
        selectionScaleMultiplier = 1; // Fixed from 0.2 to 1
        frameWidthMultiplier = 1; // Fixed from 24 to 1
        frameHeightMultiplier = 1; // Fixed from 25 to 1
        showFullBorder = true;
      } else if (modelKey === "kidskidsarmsleeves") {
        selectionScaleMultiplier = 1; // Fixed from 5 to 1
        frameWidthMultiplier = 1; // Fixed from 24 to 1
        frameHeightMultiplier = 1; // Fixed from 25 to 1
        showFullBorder = true;
      } else if (
        modelKey === "menmencompressionpants" ||
        modelKey === "womenwomencompressionpants" ||
        modelKey === "kidskidstrackpants" ||
        modelKey === "kidskidscompressionpants"
      ) {
        selectionScaleMultiplier = 20;
        frameWidthMultiplier = 0.8;
        frameHeightMultiplier = 0.8;
        showFullBorder = true;
      } else {
        selectionScaleMultiplier = 1;
        frameWidthMultiplier = 1;
        frameHeightMultiplier = 1;
        showFullBorder = true;
      }

      let baseSelectionWidth, baseSelectionHeight;
      if (modelKey === "menmenjersey") {
        const minSelectionSize = 0.05;
        const maxSelectionSize = 1.5;

        baseSelectionWidth = Math.min(
          Math.max(adjustedScale?.[0] || 0.2, minSelectionSize),
          maxSelectionSize
        );

        baseSelectionHeight = Math.min(
          Math.max(adjustedScale?.[1] || 0.2, minSelectionSize),
          maxSelectionSize
        );
      } else {
        // For all other models - use simplified logic without clamping
        baseSelectionWidth = (adjustedScale?.[0] || 0.2) * frameWidthMultiplier;
        baseSelectionHeight =
          (adjustedScale?.[1] || 0.2) * frameHeightMultiplier;
      }

      console.log("Base Selection Width:", baseSelectionWidth);
      console.log("Base Selection Height:", baseSelectionHeight);

      // Tighter selection for text to fit closer to actual text bounds
      // Tighter selection for text to fit closer to actual text bounds
      let selectionTightness;

      if (
        modelKey === "menmenjersey" ||
        modelKey === "menmenxjersey" ||
        modelKey === "menmenprotshirt" ||
        modelKey === "menmenfootballjersey" ||
        modelKey === "menmensoccerjersey"
      ) {
        // Use original tightness for menmenjersey
        selectionTightness = type.includes("Logo")
          ? 0.92
          : type.includes("Number")
          ? 0.73
          : type.includes("Text")
          ? 0.58
          : 0.48;
      } else if (
        modelKey === "menmencyclingjersey" ||
        modelKey === "menmenwinterjersey"
      ) {
        // Use original tightness for menmenjersey
        selectionTightness = type.includes("Logo")
          ? 0.92
          : type.includes("Number")
          ? 0.5
          : type.includes("Text")
          ? 0.45
          : 0.48;
      } else if (
        modelKey === "menmencitycollection" ||
        modelKey === "menmencricketjersey"
      ) {
        // Use original tightness for menmenjersey
        selectionTightness = type.includes("Logo")
          ? 0.92
          : type.includes("Number")
          ? 0.3
          : type.includes("Text")
          ? 0.45
          : 0.48;
      } else if (
        modelKey === "menmentrackpants" ||
        modelKey === "menmenshorts" ||
        modelKey === "menmencricketshorts" ||
        modelKey === "menmencyclingshorts" ||
        modelKey === "menmenrunningshorts" ||
        modelKey === "menmenwovenshorts" ||
        modelKey === "menmenknittedshorts" ||
        modelKey === "menmenfootballshorts" ||
        modelKey === "menmensoccershorts" ||
        modelKey === "menmenbasketballshorts" ||
        modelKey === "menmennftfootballshorts"
      ) {
        // Use original tightness for menmenjersey
        selectionTightness = type.includes("Logo")
          ? 0.92
          : type.includes("Number")
          ? 0.3
          : type.includes("Text")
          ? 0.45
          : 0.48;
      } else if (modelKey === "menmenarmsleeves") {
        // Use original tightness for menmenjersey
        selectionTightness = type.includes("Logo")
          ? 0.92
          : type.includes("Number")
          ? 0.5
          : type.includes("Text")
          ? 0.45
          : 0.48;
      } else if (modelKey === "menmenbasketballjersey") {
        // Use original tightness for menmenjersey
        selectionTightness = type.includes("Logo")
          ? 0.92
          : type.includes("Number")
          ? 0.5
          : type.includes("Text")
          ? 0.45
          : 0.48;
      } else if (modelKey === "menmencompressionpants") {
        selectionTightness = type.includes("Logo")
          ? 0.92
          : type.includes("Number")
          ? 0.15
          : type.includes("Text")
          ? 0.45
          : 0.48;
      } else if (
        modelKey === "womenwomenbadmintonjersey" ||
        modelKey === "womenwomenprotshirt" ||
        modelKey === "womenwomenfootballjersey" ||
        modelKey === "womenwomensoccerjersey"
      ) {
        selectionTightness = type.includes("Logo")
          ? 0.92
          : type.includes("Number")
          ? 0.12
          : type.includes("Text")
          ? 0.45
          : 0.48;
      } else if (modelKey === "womenwomencricketjersey") {
        selectionTightness = type.includes("Logo")
          ? 0.92
          : type.includes("Number")
          ? 0.12
          : type.includes("Text")
          ? 0.45
          : 0.48;
      } else if (
        modelKey === "womenwomencyclingjersey" ||
        modelKey === "womenwomenwinterjersey"
      ) {
        selectionTightness = type.includes("Logo")
          ? 0.92
          : type.includes("Number")
          ? 0.5
          : type.includes("Text")
          ? 0.45
          : 0.48;
      } else if (
        modelKey === "womenwomenxjersey" ||
        modelKey === "womenwomenjersey"
      ) {
        selectionTightness = type.includes("Logo")
          ? 0.92
          : type.includes("Number")
          ? 0.12
          : type.includes("Text")
          ? 0.45
          : 0.48;
      } else if (
        modelKey === "womenwomenbadmintonshorts" ||
        modelKey === "womenwomencyclingshorts" ||
        modelKey === "womenwomencricketshorts" ||
        modelKey === "womenwomenwovenshorts" ||
        modelKey === "womenwomentightshorts" ||
        modelKey === "womenwomenfootballshorts" ||
        modelKey === "womenwomensoccershorts" ||
        modelKey === "womenwomennftfootballshorts" ||
        modelKey === "womenwomenbasketballshorts" ||
        modelKey === "womenwomenknittedshorts"
      ) {
        // Use original tightness for menmenjersey
        selectionTightness = type.includes("Logo")
          ? 0.92
          : type.includes("Number")
          ? 0.2
          : type.includes("Text")
          ? 0.45
          : 0.48;
      } else if (
        modelKey === "womenwomencompressionpants" ||
        modelKey === "womenwomentrackpants" ||
        modelKey === "womenwomencrickettrackpants"
      ) {
        selectionTightness = type.includes("Logo")
          ? 0.92
          : type.includes("Number")
          ? 0.2
          : type.includes("Text")
          ? 0.45
          : 0.48;
      } else if (
        modelKey === "kidskidsjersey" ||
        modelKey === "kidskidstanktop" ||
        modelKey === "kidskidsprotshirt" ||
        modelKey === "kidskidsfootballjersey" ||
        modelKey === "kidskidssoccerjersey"
      ) {
        selectionTightness = type.includes("Logo")
          ? 0.92
          : type.includes("Number")
          ? 0.15
          : type.includes("Text")
          ? 0.45
          : 0.48;
      } else if (
        modelKey === "kidskidscricketjersey" ||
        modelKey === "kidskidsxjersey" ||
        modelKey === "kidskidssinglet" ||
        modelKey === "kidskidsarmsleeves"
      ) {
        selectionTightness = type.includes("Logo")
          ? 0.92
          : type.includes("Number")
          ? 0.12
          : type.includes("Text")
          ? 0.45
          : 0.48;
      } else if (modelKey === "kidskidsbasketballjersey") {
        selectionTightness = type.includes("Logo")
          ? 0.92
          : type.includes("Number")
          ? 0.45
          : type.includes("Text")
          ? 0.45
          : 0.48;
      } else if (
        modelKey === "kidskidsshorts" ||
        modelKey === "kidskidscricketshorts" ||
        modelKey === "kidskidscyclingshorts" ||
        modelKey === "kidskidswintershorts" ||
        modelKey === "kidskidsrunningshorts" ||
        modelKey === "kidskidswovenshorts" ||
        modelKey === "kidskidsknittedshorts" ||
        modelKey === "kidskidsbasketballshorts" ||
        modelKey === "kidskidssoccershorts" ||
        modelKey === "kidskidsfootballshorts" ||
        modelKey === "kidskidsnftfootballshorts"
      ) {
        // Use original tightness for menmenjersey
        selectionTightness = type.includes("Logo")
          ? 0.92
          : type.includes("Number")
          ? 0.4
          : type.includes("Text")
          ? 0.38
          : 0.48;
      } else if (
        modelKey === "kidskidstrackpants" ||
        modelKey === "kidskidscompressionpants"
      ) {
        selectionTightness = type.includes("Logo")
          ? 0.92
          : type.includes("Number")
          ? 0.5
          : type.includes("Text")
          ? 0.45
          : 0.48;
      } else {
        selectionTightness = type.includes("Logo")
          ? 0.92
          : type.includes("Number")
          ? 0.2
          : type.includes("Text")
          ? 0.45
          : 0.48;
      }

      const frameWidth = baseSelectionWidth * selectionTightness;
      const frameHeight = baseSelectionHeight * selectionTightness;

      console.log("Frame Width:", frameWidth);
      console.log("Frame Height:", frameHeight);

      const layerOrder = type.includes("Number")
        ? 2
        : type.includes("Text")
        ? 1
        : 0;
      const polygonOffsetFactor = -1 - layerOrder;
      const additionalRotation = decalRotations[type] || 0;
      const finalRotation = [
        rotation[0],
        rotation[1],
        rotation[2] + additionalRotation,
      ];

      if (type.includes("Text")) {
        console.log(
          `📝 Rendering ${type}: baseRot=${(
            (rotation[2] * 180) /
            Math.PI
          ).toFixed(1)}°, addRot=${(
            (additionalRotation * 180) /
            Math.PI
          ).toFixed(1)}°, finalRot=${(
            (finalRotation[2] * 180) /
            Math.PI
          ).toFixed(1)}°`
        );
      }

      // Render using mesh with CanvasTexture - simplified, no decal UI
      const renderOrder = type.includes("Number")
        ? 1002
        : type.includes("Text")
        ? 1001
        : type.includes("back")
        ? 1003
        : 1000;

      // Calculate tight scale based on actual texture dimensions to keep lines close to text
      let tightScale = adjustedScale;
      if (isTextDecal || isNumberDecal) {
        // Use tighter scale - close to actual text bounds (0.98) to minimise gap from t-shirt
        tightScale = [
          adjustedScale[0] * 0.98,
          adjustedScale[1] * 0.98,
          adjustedScale[2]
        ];
      } else if (type.includes("Logo")) {
        // For logos, use adjustedScale as-is (already maintains aspect ratio from texture dimensions)
        // Don't apply any tightness multiplier to preserve aspect ratio
        tightScale = adjustedScale;
      }

      // Dot size scales with decal (text/logo) size - smaller text = smaller circles & icons
      const baseDotMultiplier = isMobile ? 0.078 : 0.058;
      const dotSize = Math.min(tightScale[0], tightScale[1]) * baseDotMultiplier;
      const dotDepth = type.includes("Logo") ? 0.05 : 0.001; // Much higher z-depth for logos to appear above
      // Bring dots very close to text by using 70% of the tightScale
      const dotOffset = 0.70; // Very close to text bounds
      const hw = (tightScale[0] / 2) * dotOffset;
      const hh = (tightScale[1] / 2) * dotOffset;
      const corners = [
        { pos: [-hw, hh, dotDepth], label: 'tl' },   // top-left
        { pos: [hw, hh, dotDepth], label: 'tr' },    // top-right
        { pos: [0, hh, dotDepth], label: 'tm' },     // top-middle
        { pos: [-hw, -hh, dotDepth], label: 'bl' },  // bottom-left
        { pos: [hw, -hh, dotDepth], label: 'br' },   // bottom-right
        { pos: [0, -hh, dotDepth], label: 'bm' }     // bottom-middle
      ];

      const useDecal = isTextDecal || isNumberDecal || type.includes("Logo");
      const textureVisual = useDecal ? (
        <Decal
          key={`${type}-decal-${(additionalRotation * 10000).toFixed(0)}`}
          position={position}
          rotation={finalRotation}
          scale={tightScale}
          map={texture}
          polygonOffsetFactor={polygonOffsetFactor}
          depthTest={true}
          {...{ "material-alphaTest": 0.1, "material-depthWrite": false }}
        />
      ) : (
        <mesh
          key={`${type}-texture-mesh-${(additionalRotation * 10000).toFixed(0)}`}
          position={displayPosition}
          rotation={finalRotation}
          scale={tightScale}
          renderOrder={renderOrder}
        >
          <planeGeometry args={[1, 1]} />
          <meshStandardMaterial
            map={texture}
            transparent={true}
            alphaTest={0.1}
            depthTest={true}
            depthWrite={false}
            polygonOffset={true}
            polygonOffsetFactor={polygonOffsetFactor}
            alphaToCoverage={true}
            side={THREE.DoubleSide}
          />
        </mesh>
      );

      return (
        <>
          {textureVisual}
          <group>
            {/* Invisible clickable/draggable area - depthTest: true; ignore when decal faces away */}
            <mesh
            position={displayPosition}
            rotation={finalRotation}
            scale={tightScale}
            renderOrder={renderOrder + 0.1}
            onPointerDown={(e) => {
              e.stopPropagation();
              if (!isDecalFacingCamera(e)) return;
              const isDot = e.object?.userData?.isDot;
              const isRotationButton = e.object?.userData?.isRotationButton;
              if ((e.object === e.target || (!isDot && !isRotationButton))) {
                handleDecalDragStart(e, type);
              }
            }}
            onClick={(e) => {
              if (!isDecalFacingCamera(e)) return;
              if (!hasDraggedRef.current && interactionMode !== "resizing") {
                e.stopPropagation();
                setSelectedDecal(type);
              }
            }}
          >
            <planeGeometry args={[1, 1]} />
            <meshBasicMaterial
              transparent
              opacity={0}
              depthTest={true}
              depthWrite={false}
              side={THREE.DoubleSide}
            />
          </mesh>

          {/* Outline connecting 4 corners + resize handles - same position/rotation as decal so it moves with text */}
          {isSelected && (
            <group position={position} rotation={finalRotation}>
              {/* Professional outline connecting the dots - key forces geometry update when text moves/resizes */}
              <line key={`outline-${type}-${position[0]}-${position[1]}-${position[2]}-${hw}-${hh}`} renderOrder={renderOrder + 99}>
                <bufferGeometry attach="geometry">
                  <bufferAttribute
                    attach="attributes-position"
                    count={5}
                    array={new Float32Array([
                      -hw, hh, dotDepth,
                      hw, hh, dotDepth,
                      hw, -hh, dotDepth,
                      -hw, -hh, dotDepth,
                      -hw, hh, dotDepth
                    ])}
                    itemSize={3}
                  />
                </bufferGeometry>
                <lineBasicMaterial
                  color="#2563EB"
                  depthTest={false}
                  depthWrite={false}
                />
              </line>
              {corners
                .filter((c) => ['tl', 'tr', 'bl', 'br'].includes(c.label))
                .map((corner, idx) => (
                  <group key={`dot-${corner.label}-${idx}`} position={corner.pos}>
                    <mesh
                      renderOrder={renderOrder + 100}
                      userData={{ isDot: true }}
                      onPointerDown={(e) => {
                        e.stopPropagation();
                        handleCornerDragStart(e, type, corner.label);
                      }}
                      onPointerOver={(e) => {
                        e.stopPropagation();
                        document.body.style.cursor = 'nwse-resize';
                      }}
                      onPointerOut={(e) => {
                        e.stopPropagation();
                        if (!isResizing) {
                          document.body.style.cursor = 'auto';
                        }
                      }}
                    >
                      <sphereGeometry args={[dotSize * 1.85, 20, 20]} />
                      <meshBasicMaterial
                        color="#2563EB"
                        transparent={false}
                        depthTest={false}
                        depthWrite={false}
                      />
                    </mesh>
                    <Html center distanceFactor={10} style={{ pointerEvents: 'none' }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        // width: `${Math.max(6, Math.round(dotSize * 1.85 * 10))}px`,
                        // height: `${Math.max(6, Math.round(dotSize * 1.85 * 10))}px`,
                        width: `${Math.max(14, Math.round(dotSize * 3.85 * 15))}px`,
                        height: `${Math.max(14, Math.round(dotSize * 3.85 * 15))}px`,
                        padding: '10%',
                        boxSizing: 'border-box',
                        userSelect: 'none',
                        pointerEvents: 'none',
                        filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.4))'
                      }}>
                        <img
                          src="/Images/resize-icon.jpeg"
                          alt="Resize"
                          style={{
                            // width: '70%',
                            width: getResizeIconWidth(modelKey),
                            objectFit: 'contain'
                          }}
                        />
                      </div>
                    </Html>
                  </group>
                ))}
            </group>
          )}
          

          {/* Rotation buttons at vertical center (for text/numbers/logos) */}
          {isSelected && (isTextDecal || isNumberDecal || type.includes("Logo")) && (
            <group position={position} rotation={finalRotation}>
             
              {/* Rotation icon above decal - larger on mobile for easier touch */}
              {(isTextDecal || isNumberDecal || type.includes("Logo")) && (
                <group position={[0, hh + dotSize * 3.2, dotDepth + (type.includes("Logo") ? 0.01 : 0.0005)]}>
                  <mesh
                    renderOrder={renderOrder + 101}
                    userData={{ isRotationButton: true, isRotationHandle: true }}
                    onPointerDown={(e) => {
                      e.stopPropagation();
                      e.nativeEvent?.stopPropagation?.();
                      e.nativeEvent?.stopImmediatePropagation?.();
                      handleDecalRotate(e, type);
                    }}
                    onPointerUp={(e) => {
                      e.stopPropagation();
                      stopContinuousRotation();
                    }}
                    onPointerLeave={(e) => {
                      e.stopPropagation();
                      stopContinuousRotation();
                    }}
                    onPointerOver={(e) => {
                      e.stopPropagation();
                      document.body.style.cursor = 'grab';
                    }}
                    onPointerOut={(e) => {
                      e.stopPropagation();
                      if (interactionMode !== "rotating") {
                        document.body.style.cursor = 'auto';
                      }
                    }}
                  >
                    <sphereGeometry args={[dotSize * (isMobile ? 2.25 : 1.95), 20, 20]} />
                    <meshBasicMaterial
                      color="#7C3AED"
                      transparent={false}
                      depthTest={false}
                      depthWrite={false}
                    />
                  </mesh>
                  <Html
                    center
                    distanceFactor={10}
                    style={{ pointerEvents: 'none' }}
                  >
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      userSelect: 'none',
                      pointerEvents: 'none',
                      fontWeight: 300,
                      filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.45))',
                      transform: 'rotate(-45deg)'
                    }}>
                      <FaArrowsRotate
                        // size={Math.max(18, Math.round(dotSize * (isMobile ? 2.25 : 1.95) * 52))}
                        // size={Math.max(12, Math.round(dotSize * (isMobile ? 1.4 : 1.1) * 30))}
                        size={getRotationIconSize(modelKey, dotSize, isMobile)}
                        color="#ffffff"
                        style={{ flexShrink: 0 }}
                      />
                    </div>
                  </Html>
                </group>
              )}
            </group>
          )}
          </group>
        </>
      );
    };

    return (
      <>
        {/* NEW RESIZE FEATURE - HTML overlay for smooth resize */}

        {interactionMode === "new-resize-mode" && (
          <Html>
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                pointerEvents: "auto",
                cursor:
                  newResizeCorner === "tl" || newResizeCorner === "br"
                    ? "nwse-resize"
                    : "nesw-resize",
                backgroundColor: "transparent",
                zIndex: 9999,
              }}
              onPointerMove={handleNewResizeFunction}
              onPointerUp={handlePointerUp}
              onMouseMove={handleNewResizeFunction}
              onMouseUp={handlePointerUp}
              onTouchMove={handleNewResizeFunction}
              onTouchEnd={handlePointerUp}
            />
          </Html>
        )}

        <Html
          style={{
            position: "absolute",
            top: "-1000px",
            left: "-800px",
            zIndex: "999999999999999999999",
          }}
        >
          <div id="svg-hidden-container" ref={svgContainerRef}></div>
        </Html>

        {interactionMode === "resize-decal" && (
          <Html>
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                pointerEvents: "auto",
                cursor: "nwse-resize",
              }}
              onPointerMove={handleResizeMove}
              onPointerUp={handleResizeUp}
              onMouseMove={handleResizeMove}
              onMouseUp={handleResizeUp}
              onTouchMove={handleResizeMove}
              onTouchEnd={handleResizeUp}
            />
          </Html>
        )}

        {interactionMode === "move-decal" && (
          <Html>
            <div
              style={{
                position: "fixed",
                top: "-188px",
                left: "-179px",
                width: "34vw",
                height: "65vh",
                pointerEvents: "auto",
                cursor: "move",
              }}
              onPointerMove={handlePointerMove}
              onPointerUp={handlePointerUp}
              onMouseMove={handlePointerMove}
              onMouseUp={handlePointerUp}
              onTouchMove={handlePointerMove}
              onTouchEnd={handlePointerUp}
            />
          </Html>
        )}

        {interactionMode === "rotating" && (
          <Html>
            <div
              style={{
                position: "fixed",
                top: "-188px",
                left: "-179px",
                width: "34vw",
                height: "65vh",
                pointerEvents: "auto",
                cursor: "grabbing",
              }}
              onPointerMove={handlePointerMove}
              onPointerUp={handlePointerUp}
              onMouseMove={handlePointerMove}
              onMouseUp={handlePointerUp}
              onTouchMove={handlePointerMove}
              onTouchEnd={handlePointerUp}
            />
          </Html>
        )}

        <OrbitControls
          enableZoom={true}
          enablePan={false}
          enabled={interactionMode === "rotate-shirt"}
          target={[0, 0, 0]}
          enableRotate
          rotateSpeed={2.0}
          minDistance={4.5}
          maxDistance={5.5}
        />

        {selectedDecal && renderResizeArrow()}

        {isLoading && (
          <Html center>
            <div style={loadingStyles}>
              <Spinner animation="border" variant="dark" />
              <p style={loadingTextStyles}>Loading...</p>
            </div>
          </Html>
        )}

        {!isLoading && (
          <group
            ref={group}
            dispose={null}
            // scale={overallScale}
            scale={overallScale * mobileScaleFactor}
            onPointerDown={() => {
              handleDeselect();
            }}
          >
            {/* <group position={position} rotation={rotation} scale={scale}> */}
            <group
              position={[
                position[0] + mobilePositionOffset[0],
                position[1] + mobilePositionOffset[1],
                position[2] + mobilePositionOffset[2],
              ]}
              // rotation={rotation}
              rotation={animatedRotation}
              scale={scale}
            >
              {parts
                .filter((part) => part.material.name !== "LOGO")
                .map((part, index) => {
                  const partName = (part.name || "").toUpperCase();
                  const matName = (part.material?.name || "").toUpperCase();
                  const isFrontPart = partName.includes("FRONT") || matName.includes("FRONT");
                  const isBackPart = partName.includes("BACK") || matName.includes("BACK");
                  const showFrontDecals = isFrontPart || (!isFrontPart && !isBackPart);
                  const showBackDecals = isBackPart || (!isFrontPart && !isBackPart);
                  return (
                    <mesh
                      key={`non-logo-${index}`}
                      geometry={part.geometry}
                      material={part.material}
                      name={part.name}
                      ref={shirtRef}
                    >
                      <>
                        {/* Front decals - only on front (or neutral) parts */}
                        {showFrontDecals && renderDecal(
                          "frontText",
                          frontTextTexture.current,
                          frontTextPosition,
                          frontTextRotation,
                          frontTextScale
                        )}
                        {showFrontDecals && renderDecal(
                          "frontNumber",
                          frontNumberTexture.current,
                          frontNumberPosition,
                          frontNumberRotation,
                          frontNumberScale
                        )}
                        {showFrontDecals && renderDecal(
                          "frontLogo",
                          logoTexture,
                          frontLogoPosition,
                          frontLogoRotation,
                          frontLogoScale
                        )}

                        {/* Back decals - only on back (or neutral) parts */}
                        {showBackDecals && renderDecal(
                          "backText",
                          backTextTexture.current,
                          backTextPosition,
                          backTextRotation,
                          backTextScale
                        )}
                        {showBackDecals && renderDecal(
                          "backNumber",
                          backNumberTexture.current,
                          backNumberPosition,
                          backNumberRotation,
                          backNumberScale
                        )}
                        {showBackDecals && renderDecal(
                          "backLogo",
                          logoTextureBack,
                          backLogoPosition,
                          backLogoRotation,
                          backLogoScale
                        )}
                      </>
                    </mesh>
                  );
                })}
            </group>

            {parts
              .filter((part) => part.material.name === "LOGO")
              .map((part, index) => {
                return (
                  <mesh
                    geometry={part.geometry}
                    material={part.material}
                    position={logoPosition}
                    rotation={logoRotation}
                    scale={logoScale}
                  />
                );
              })}
          </group>
        )}
      </>
    );
  }
);
const loadingStyles = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(197, 197, 197, 0.8)",
  padding: "5px 15px",
  borderRadius: "8px",
  gap: "20px",
};

const loadingTextStyles = {
  fontSize: "20px",
  fontWeight: "bold",
  color: "black",
  marginTop: "10px",
};

const instructionsStyle = {
  background: "rgba(0,0,0,0.7)",
  padding: "10px",
  borderRadius: "8px",
  color: "white",
};

export default ShirtModel;
